
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire839f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire839f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gCmhw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jCBFl"));

});
parcelRegister("jCBFl", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e48ec89987a65934$export$ffb0004e005737fa; }, function (v) { return $e48ec89987a65934$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e48ec89987a65934$export$34b9dba7ce09269b; }, function (v) { return $e48ec89987a65934$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e48ec89987a65934$export$25062201e9e25d76; }, function (v) { return $e48ec89987a65934$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e48ec89987a65934$export$ffb0004e005737fa;
var $e48ec89987a65934$export$34b9dba7ce09269b;
var $e48ec89987a65934$export$25062201e9e25d76;
'use strict';

var $2eaC8 = parcelRequire("2eaC8");
var $e48ec89987a65934$var$k = Symbol.for("react.element"), $e48ec89987a65934$var$l = Symbol.for("react.fragment"), $e48ec89987a65934$var$m = Object.prototype.hasOwnProperty, $e48ec89987a65934$var$n = $2eaC8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e48ec89987a65934$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e48ec89987a65934$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e48ec89987a65934$var$m.call(a, b) && !$e48ec89987a65934$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e48ec89987a65934$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e48ec89987a65934$var$n.current
    };
}
$e48ec89987a65934$export$ffb0004e005737fa = $e48ec89987a65934$var$l;
$e48ec89987a65934$export$34b9dba7ce09269b = $e48ec89987a65934$var$q;
$e48ec89987a65934$export$25062201e9e25d76 = $e48ec89987a65934$var$q;

});
parcelRegister("2eaC8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lqMcc"));

});
parcelRegister("lqMcc", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $f9a1696111dfb922$export$dca3b0875bd9a954; }, function (v) { return $f9a1696111dfb922$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f9a1696111dfb922$export$16fa2f45be04daa8; }, function (v) { return $f9a1696111dfb922$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f9a1696111dfb922$export$ffb0004e005737fa; }, function (v) { return $f9a1696111dfb922$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $f9a1696111dfb922$export$e2c29f18771995cb; }, function (v) { return $f9a1696111dfb922$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f9a1696111dfb922$export$221d75b3f55bb0bd; }, function (v) { return $f9a1696111dfb922$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f9a1696111dfb922$export$5f8d39834fd61797; }, function (v) { return $f9a1696111dfb922$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f9a1696111dfb922$export$74bf444e3cd11ea5; }, function (v) { return $f9a1696111dfb922$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f9a1696111dfb922$export$ae55be85d98224ed; }, function (v) { return $f9a1696111dfb922$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $f9a1696111dfb922$export$3ba232387fd5d6dd; }, function (v) { return $f9a1696111dfb922$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f9a1696111dfb922$export$e530037191fcd5d7; }, function (v) { return $f9a1696111dfb922$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f9a1696111dfb922$export$fd42f52fd3ae1109; }, function (v) { return $f9a1696111dfb922$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f9a1696111dfb922$export$c8a8987d4410bf2d; }, function (v) { return $f9a1696111dfb922$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f9a1696111dfb922$export$d38cd72104c1f0e9; }, function (v) { return $f9a1696111dfb922$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f9a1696111dfb922$export$7d1e3a5e95ceca43; }, function (v) { return $f9a1696111dfb922$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f9a1696111dfb922$export$257a8862b851cb5b; }, function (v) { return $f9a1696111dfb922$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f9a1696111dfb922$export$a8257692ac88316c; }, function (v) { return $f9a1696111dfb922$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f9a1696111dfb922$export$488013bae63b21da; }, function (v) { return $f9a1696111dfb922$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f9a1696111dfb922$export$7c73462e0d25e514; }, function (v) { return $f9a1696111dfb922$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $f9a1696111dfb922$export$7568632d0d33d16d; }, function (v) { return $f9a1696111dfb922$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $f9a1696111dfb922$export$88948ce120ea2619; }, function (v) { return $f9a1696111dfb922$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f9a1696111dfb922$export$35808ee640e87ca7; }, function (v) { return $f9a1696111dfb922$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f9a1696111dfb922$export$fae74005e78b1a27; }, function (v) { return $f9a1696111dfb922$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f9a1696111dfb922$export$dc8fbce3eb94dc1e; }, function (v) { return $f9a1696111dfb922$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $f9a1696111dfb922$export$6a7bc4e911dc01cf; }, function (v) { return $f9a1696111dfb922$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $f9a1696111dfb922$export$6d9c69b0de29b591; }, function (v) { return $f9a1696111dfb922$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $f9a1696111dfb922$export$f680877a34711e37; }, function (v) { return $f9a1696111dfb922$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f9a1696111dfb922$export$d5a552a76deda3c2; }, function (v) { return $f9a1696111dfb922$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $f9a1696111dfb922$export$aaabe4eda9ed9969; }, function (v) { return $f9a1696111dfb922$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f9a1696111dfb922$export$e5c5a5f917a5871c; }, function (v) { return $f9a1696111dfb922$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f9a1696111dfb922$export$1538c33de8887b59; }, function (v) { return $f9a1696111dfb922$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f9a1696111dfb922$export$13e3392192263954; }, function (v) { return $f9a1696111dfb922$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f9a1696111dfb922$export$b8f5890fc79d6aca; }, function (v) { return $f9a1696111dfb922$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f9a1696111dfb922$export$60241385465d0a34; }, function (v) { return $f9a1696111dfb922$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $f9a1696111dfb922$export$306c0aa65ff9ec16; }, function (v) { return $f9a1696111dfb922$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $f9a1696111dfb922$export$7b286972b8d8ccbf; }, function (v) { return $f9a1696111dfb922$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $f9a1696111dfb922$export$83d89fbfd8236492; }, function (v) { return $f9a1696111dfb922$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f9a1696111dfb922$export$dca3b0875bd9a954;
var $f9a1696111dfb922$export$16fa2f45be04daa8;
var $f9a1696111dfb922$export$ffb0004e005737fa;
var $f9a1696111dfb922$export$e2c29f18771995cb;
var $f9a1696111dfb922$export$221d75b3f55bb0bd;
var $f9a1696111dfb922$export$5f8d39834fd61797;
var $f9a1696111dfb922$export$74bf444e3cd11ea5;
var $f9a1696111dfb922$export$ae55be85d98224ed;
var $f9a1696111dfb922$export$3ba232387fd5d6dd;
var $f9a1696111dfb922$export$e530037191fcd5d7;
var $f9a1696111dfb922$export$fd42f52fd3ae1109;
var $f9a1696111dfb922$export$c8a8987d4410bf2d;
var $f9a1696111dfb922$export$d38cd72104c1f0e9;
var $f9a1696111dfb922$export$7d1e3a5e95ceca43;
var $f9a1696111dfb922$export$257a8862b851cb5b;
var $f9a1696111dfb922$export$a8257692ac88316c;
var $f9a1696111dfb922$export$488013bae63b21da;
var $f9a1696111dfb922$export$7c73462e0d25e514;
var $f9a1696111dfb922$export$7568632d0d33d16d;
var $f9a1696111dfb922$export$88948ce120ea2619;
var $f9a1696111dfb922$export$35808ee640e87ca7;
var $f9a1696111dfb922$export$fae74005e78b1a27;
var $f9a1696111dfb922$export$dc8fbce3eb94dc1e;
var $f9a1696111dfb922$export$6a7bc4e911dc01cf;
var $f9a1696111dfb922$export$6d9c69b0de29b591;
var $f9a1696111dfb922$export$f680877a34711e37;
var $f9a1696111dfb922$export$d5a552a76deda3c2;
var $f9a1696111dfb922$export$aaabe4eda9ed9969;
var $f9a1696111dfb922$export$e5c5a5f917a5871c;
var $f9a1696111dfb922$export$1538c33de8887b59;
var $f9a1696111dfb922$export$13e3392192263954;
var $f9a1696111dfb922$export$b8f5890fc79d6aca;
var $f9a1696111dfb922$export$60241385465d0a34;
var $f9a1696111dfb922$export$306c0aa65ff9ec16;
var $f9a1696111dfb922$export$7b286972b8d8ccbf;
var $f9a1696111dfb922$export$83d89fbfd8236492;
'use strict';
var $f9a1696111dfb922$var$l = Symbol.for("react.element"), $f9a1696111dfb922$var$n = Symbol.for("react.portal"), $f9a1696111dfb922$var$p = Symbol.for("react.fragment"), $f9a1696111dfb922$var$q = Symbol.for("react.strict_mode"), $f9a1696111dfb922$var$r = Symbol.for("react.profiler"), $f9a1696111dfb922$var$t = Symbol.for("react.provider"), $f9a1696111dfb922$var$u = Symbol.for("react.context"), $f9a1696111dfb922$var$v = Symbol.for("react.forward_ref"), $f9a1696111dfb922$var$w = Symbol.for("react.suspense"), $f9a1696111dfb922$var$x = Symbol.for("react.memo"), $f9a1696111dfb922$var$y = Symbol.for("react.lazy"), $f9a1696111dfb922$var$z = Symbol.iterator;
function $f9a1696111dfb922$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f9a1696111dfb922$var$z && a[$f9a1696111dfb922$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f9a1696111dfb922$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f9a1696111dfb922$var$C = Object.assign, $f9a1696111dfb922$var$D = {};
function $f9a1696111dfb922$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f9a1696111dfb922$var$D;
    this.updater = e || $f9a1696111dfb922$var$B;
}
$f9a1696111dfb922$var$E.prototype.isReactComponent = {};
$f9a1696111dfb922$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f9a1696111dfb922$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f9a1696111dfb922$var$F() {}
$f9a1696111dfb922$var$F.prototype = $f9a1696111dfb922$var$E.prototype;
function $f9a1696111dfb922$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f9a1696111dfb922$var$D;
    this.updater = e || $f9a1696111dfb922$var$B;
}
var $f9a1696111dfb922$var$H = $f9a1696111dfb922$var$G.prototype = new $f9a1696111dfb922$var$F;
$f9a1696111dfb922$var$H.constructor = $f9a1696111dfb922$var$G;
$f9a1696111dfb922$var$C($f9a1696111dfb922$var$H, $f9a1696111dfb922$var$E.prototype);
$f9a1696111dfb922$var$H.isPureReactComponent = !0;
var $f9a1696111dfb922$var$I = Array.isArray, $f9a1696111dfb922$var$J = Object.prototype.hasOwnProperty, $f9a1696111dfb922$var$K = {
    current: null
}, $f9a1696111dfb922$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f9a1696111dfb922$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f9a1696111dfb922$var$J.call(b, d) && !$f9a1696111dfb922$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $f9a1696111dfb922$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $f9a1696111dfb922$var$K.current
    };
}
function $f9a1696111dfb922$var$N(a, b) {
    return {
        $$typeof: $f9a1696111dfb922$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f9a1696111dfb922$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f9a1696111dfb922$var$l;
}
function $f9a1696111dfb922$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f9a1696111dfb922$var$P = /\/+/g;
function $f9a1696111dfb922$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f9a1696111dfb922$var$escape("" + a.key) : b.toString(36);
}
function $f9a1696111dfb922$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f9a1696111dfb922$var$l:
                case $f9a1696111dfb922$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $f9a1696111dfb922$var$Q(h, 0) : d, $f9a1696111dfb922$var$I(c) ? (e = "", null != a && (e = a.replace($f9a1696111dfb922$var$P, "$&/") + "/"), $f9a1696111dfb922$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($f9a1696111dfb922$var$O(c) && (c = $f9a1696111dfb922$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($f9a1696111dfb922$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($f9a1696111dfb922$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $f9a1696111dfb922$var$Q(k, g);
        h += $f9a1696111dfb922$var$R(k, b, e, f, c);
    }
    else if (f = $f9a1696111dfb922$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $f9a1696111dfb922$var$Q(k, g++), h += $f9a1696111dfb922$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $f9a1696111dfb922$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $f9a1696111dfb922$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $f9a1696111dfb922$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $f9a1696111dfb922$var$U = {
    current: null
}, $f9a1696111dfb922$var$V = {
    transition: null
}, $f9a1696111dfb922$var$W = {
    ReactCurrentDispatcher: $f9a1696111dfb922$var$U,
    ReactCurrentBatchConfig: $f9a1696111dfb922$var$V,
    ReactCurrentOwner: $f9a1696111dfb922$var$K
};
function $f9a1696111dfb922$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$f9a1696111dfb922$export$dca3b0875bd9a954 = {
    map: $f9a1696111dfb922$var$S,
    forEach: function(a, b, e) {
        $f9a1696111dfb922$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $f9a1696111dfb922$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f9a1696111dfb922$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f9a1696111dfb922$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$f9a1696111dfb922$export$16fa2f45be04daa8 = $f9a1696111dfb922$var$E;
$f9a1696111dfb922$export$ffb0004e005737fa = $f9a1696111dfb922$var$p;
$f9a1696111dfb922$export$e2c29f18771995cb = $f9a1696111dfb922$var$r;
$f9a1696111dfb922$export$221d75b3f55bb0bd = $f9a1696111dfb922$var$G;
$f9a1696111dfb922$export$5f8d39834fd61797 = $f9a1696111dfb922$var$q;
$f9a1696111dfb922$export$74bf444e3cd11ea5 = $f9a1696111dfb922$var$w;
$f9a1696111dfb922$export$ae55be85d98224ed = $f9a1696111dfb922$var$W;
$f9a1696111dfb922$export$3ba232387fd5d6dd = $f9a1696111dfb922$var$X;
$f9a1696111dfb922$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $f9a1696111dfb922$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f9a1696111dfb922$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f9a1696111dfb922$var$J.call(b, f) && !$f9a1696111dfb922$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $f9a1696111dfb922$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$f9a1696111dfb922$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $f9a1696111dfb922$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $f9a1696111dfb922$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$f9a1696111dfb922$export$c8a8987d4410bf2d = $f9a1696111dfb922$var$M;
$f9a1696111dfb922$export$d38cd72104c1f0e9 = function(a) {
    var b = $f9a1696111dfb922$var$M.bind(null, a);
    b.type = a;
    return b;
};
$f9a1696111dfb922$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f9a1696111dfb922$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f9a1696111dfb922$var$v,
        render: a
    };
};
$f9a1696111dfb922$export$a8257692ac88316c = $f9a1696111dfb922$var$O;
$f9a1696111dfb922$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f9a1696111dfb922$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f9a1696111dfb922$var$T
    };
};
$f9a1696111dfb922$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f9a1696111dfb922$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f9a1696111dfb922$export$7568632d0d33d16d = function(a) {
    var b = $f9a1696111dfb922$var$V.transition;
    $f9a1696111dfb922$var$V.transition = {};
    try {
        a();
    } finally{
        $f9a1696111dfb922$var$V.transition = b;
    }
};
$f9a1696111dfb922$export$88948ce120ea2619 = $f9a1696111dfb922$var$X;
$f9a1696111dfb922$export$35808ee640e87ca7 = function(a, b) {
    return $f9a1696111dfb922$var$U.current.useCallback(a, b);
};
$f9a1696111dfb922$export$fae74005e78b1a27 = function(a) {
    return $f9a1696111dfb922$var$U.current.useContext(a);
};
$f9a1696111dfb922$export$dc8fbce3eb94dc1e = function() {};
$f9a1696111dfb922$export$6a7bc4e911dc01cf = function(a) {
    return $f9a1696111dfb922$var$U.current.useDeferredValue(a);
};
$f9a1696111dfb922$export$6d9c69b0de29b591 = function(a, b) {
    return $f9a1696111dfb922$var$U.current.useEffect(a, b);
};
$f9a1696111dfb922$export$f680877a34711e37 = function() {
    return $f9a1696111dfb922$var$U.current.useId();
};
$f9a1696111dfb922$export$d5a552a76deda3c2 = function(a, b, e) {
    return $f9a1696111dfb922$var$U.current.useImperativeHandle(a, b, e);
};
$f9a1696111dfb922$export$aaabe4eda9ed9969 = function(a, b) {
    return $f9a1696111dfb922$var$U.current.useInsertionEffect(a, b);
};
$f9a1696111dfb922$export$e5c5a5f917a5871c = function(a, b) {
    return $f9a1696111dfb922$var$U.current.useLayoutEffect(a, b);
};
$f9a1696111dfb922$export$1538c33de8887b59 = function(a, b) {
    return $f9a1696111dfb922$var$U.current.useMemo(a, b);
};
$f9a1696111dfb922$export$13e3392192263954 = function(a, b, e) {
    return $f9a1696111dfb922$var$U.current.useReducer(a, b, e);
};
$f9a1696111dfb922$export$b8f5890fc79d6aca = function(a) {
    return $f9a1696111dfb922$var$U.current.useRef(a);
};
$f9a1696111dfb922$export$60241385465d0a34 = function(a) {
    return $f9a1696111dfb922$var$U.current.useState(a);
};
$f9a1696111dfb922$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $f9a1696111dfb922$var$U.current.useSyncExternalStore(a, b, e);
};
$f9a1696111dfb922$export$7b286972b8d8ccbf = function() {
    return $f9a1696111dfb922$var$U.current.useTransition();
};
$f9a1696111dfb922$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("52EYl", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $3abcebe705f6e3da$export$882461b6382ed46c; }, function (v) { return $3abcebe705f6e3da$export$882461b6382ed46c = v; });
var $3abcebe705f6e3da$export$882461b6382ed46c;
var $3abcebe705f6e3da$export$757ceba2d55c277e;
'use strict';

var $16XvB = parcelRequire("16XvB");
var $3abcebe705f6e3da$var$i;
$3abcebe705f6e3da$export$882461b6382ed46c = $16XvB.createRoot;
$3abcebe705f6e3da$export$757ceba2d55c277e = $16XvB.hydrateRoot;

});
parcelRegister("16XvB", function(module, exports) {
'use strict';
function $0cf4832a53f0e88d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0cf4832a53f0e88d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0cf4832a53f0e88d$var$checkDCE();

module.exports = (parcelRequire("27Qwo"));

});
parcelRegister("27Qwo", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $18c4f9e6a0e81b69$export$ae55be85d98224ed; }, function (v) { return $18c4f9e6a0e81b69$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $18c4f9e6a0e81b69$export$d39a5bbd09211389; }, function (v) { return $18c4f9e6a0e81b69$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $18c4f9e6a0e81b69$export$882461b6382ed46c; }, function (v) { return $18c4f9e6a0e81b69$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $18c4f9e6a0e81b69$export$466bfc07425424d5; }, function (v) { return $18c4f9e6a0e81b69$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $18c4f9e6a0e81b69$export$cd75ccfd720a3cd4; }, function (v) { return $18c4f9e6a0e81b69$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $18c4f9e6a0e81b69$export$fa8d919ba61d84db; }, function (v) { return $18c4f9e6a0e81b69$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $18c4f9e6a0e81b69$export$757ceba2d55c277e; }, function (v) { return $18c4f9e6a0e81b69$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $18c4f9e6a0e81b69$export$b3890eb0ae9dca99; }, function (v) { return $18c4f9e6a0e81b69$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $18c4f9e6a0e81b69$export$502457920280e6be; }, function (v) { return $18c4f9e6a0e81b69$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $18c4f9e6a0e81b69$export$c78a37762a8d58e1; }, function (v) { return $18c4f9e6a0e81b69$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $18c4f9e6a0e81b69$export$dc54d992c10e8a18; }, function (v) { return $18c4f9e6a0e81b69$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $18c4f9e6a0e81b69$export$83d89fbfd8236492; }, function (v) { return $18c4f9e6a0e81b69$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $18c4f9e6a0e81b69$export$ae55be85d98224ed;
var $18c4f9e6a0e81b69$export$d39a5bbd09211389;
var $18c4f9e6a0e81b69$export$882461b6382ed46c;
var $18c4f9e6a0e81b69$export$466bfc07425424d5;
var $18c4f9e6a0e81b69$export$cd75ccfd720a3cd4;
var $18c4f9e6a0e81b69$export$fa8d919ba61d84db;
var $18c4f9e6a0e81b69$export$757ceba2d55c277e;
var $18c4f9e6a0e81b69$export$b3890eb0ae9dca99;
var $18c4f9e6a0e81b69$export$502457920280e6be;
var $18c4f9e6a0e81b69$export$c78a37762a8d58e1;
var $18c4f9e6a0e81b69$export$dc54d992c10e8a18;
var $18c4f9e6a0e81b69$export$83d89fbfd8236492;
'use strict';

var $2eaC8 = parcelRequire("2eaC8");

var $feV1b = parcelRequire("feV1b");
function $18c4f9e6a0e81b69$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $18c4f9e6a0e81b69$var$da = new Set, $18c4f9e6a0e81b69$var$ea = {};
function $18c4f9e6a0e81b69$var$fa(a, b) {
    $18c4f9e6a0e81b69$var$ha(a, b);
    $18c4f9e6a0e81b69$var$ha(a + "Capture", b);
}
function $18c4f9e6a0e81b69$var$ha(a, b) {
    $18c4f9e6a0e81b69$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$18c4f9e6a0e81b69$var$da.add(b[a]);
}
var $18c4f9e6a0e81b69$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $18c4f9e6a0e81b69$var$ja = Object.prototype.hasOwnProperty, $18c4f9e6a0e81b69$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $18c4f9e6a0e81b69$var$la = {}, $18c4f9e6a0e81b69$var$ma = {};
function $18c4f9e6a0e81b69$var$oa(a) {
    if ($18c4f9e6a0e81b69$var$ja.call($18c4f9e6a0e81b69$var$ma, a)) return !0;
    if ($18c4f9e6a0e81b69$var$ja.call($18c4f9e6a0e81b69$var$la, a)) return !1;
    if ($18c4f9e6a0e81b69$var$ka.test(a)) return $18c4f9e6a0e81b69$var$ma[a] = !0;
    $18c4f9e6a0e81b69$var$la[a] = !0;
    return !1;
}
function $18c4f9e6a0e81b69$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $18c4f9e6a0e81b69$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $18c4f9e6a0e81b69$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $18c4f9e6a0e81b69$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $18c4f9e6a0e81b69$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $18c4f9e6a0e81b69$var$z[b] = new $18c4f9e6a0e81b69$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $18c4f9e6a0e81b69$var$ra = /[\-:]([a-z])/g;
function $18c4f9e6a0e81b69$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($18c4f9e6a0e81b69$var$ra, $18c4f9e6a0e81b69$var$sa);
    $18c4f9e6a0e81b69$var$z[b] = new $18c4f9e6a0e81b69$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($18c4f9e6a0e81b69$var$ra, $18c4f9e6a0e81b69$var$sa);
    $18c4f9e6a0e81b69$var$z[b] = new $18c4f9e6a0e81b69$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($18c4f9e6a0e81b69$var$ra, $18c4f9e6a0e81b69$var$sa);
    $18c4f9e6a0e81b69$var$z[b] = new $18c4f9e6a0e81b69$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$18c4f9e6a0e81b69$var$z.xlinkHref = new $18c4f9e6a0e81b69$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $18c4f9e6a0e81b69$var$z[a] = new $18c4f9e6a0e81b69$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $18c4f9e6a0e81b69$var$ta(a, b, c, d) {
    var e = $18c4f9e6a0e81b69$var$z.hasOwnProperty(b) ? $18c4f9e6a0e81b69$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $18c4f9e6a0e81b69$var$qa(b, c, e, d) && (c = null), d || null === e ? $18c4f9e6a0e81b69$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $18c4f9e6a0e81b69$var$ua = $2eaC8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $18c4f9e6a0e81b69$var$va = Symbol.for("react.element"), $18c4f9e6a0e81b69$var$wa = Symbol.for("react.portal"), $18c4f9e6a0e81b69$var$ya = Symbol.for("react.fragment"), $18c4f9e6a0e81b69$var$za = Symbol.for("react.strict_mode"), $18c4f9e6a0e81b69$var$Aa = Symbol.for("react.profiler"), $18c4f9e6a0e81b69$var$Ba = Symbol.for("react.provider"), $18c4f9e6a0e81b69$var$Ca = Symbol.for("react.context"), $18c4f9e6a0e81b69$var$Da = Symbol.for("react.forward_ref"), $18c4f9e6a0e81b69$var$Ea = Symbol.for("react.suspense"), $18c4f9e6a0e81b69$var$Fa = Symbol.for("react.suspense_list"), $18c4f9e6a0e81b69$var$Ga = Symbol.for("react.memo"), $18c4f9e6a0e81b69$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $18c4f9e6a0e81b69$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $18c4f9e6a0e81b69$var$Ja = Symbol.iterator;
function $18c4f9e6a0e81b69$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $18c4f9e6a0e81b69$var$Ja && a[$18c4f9e6a0e81b69$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $18c4f9e6a0e81b69$var$A = Object.assign, $18c4f9e6a0e81b69$var$La;
function $18c4f9e6a0e81b69$var$Ma(a) {
    if (void 0 === $18c4f9e6a0e81b69$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $18c4f9e6a0e81b69$var$La = b && b[1] || "";
    }
    return "\n" + $18c4f9e6a0e81b69$var$La + a;
}
var $18c4f9e6a0e81b69$var$Na = !1;
function $18c4f9e6a0e81b69$var$Oa(a, b) {
    if (!a || $18c4f9e6a0e81b69$var$Na) return "";
    $18c4f9e6a0e81b69$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $18c4f9e6a0e81b69$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $18c4f9e6a0e81b69$var$Ma(a) : "";
}
function $18c4f9e6a0e81b69$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $18c4f9e6a0e81b69$var$Ma(a.type);
        case 16:
            return $18c4f9e6a0e81b69$var$Ma("Lazy");
        case 13:
            return $18c4f9e6a0e81b69$var$Ma("Suspense");
        case 19:
            return $18c4f9e6a0e81b69$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $18c4f9e6a0e81b69$var$Oa(a.type, !1), a;
        case 11:
            return a = $18c4f9e6a0e81b69$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $18c4f9e6a0e81b69$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $18c4f9e6a0e81b69$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $18c4f9e6a0e81b69$var$ya:
            return "Fragment";
        case $18c4f9e6a0e81b69$var$wa:
            return "Portal";
        case $18c4f9e6a0e81b69$var$Aa:
            return "Profiler";
        case $18c4f9e6a0e81b69$var$za:
            return "StrictMode";
        case $18c4f9e6a0e81b69$var$Ea:
            return "Suspense";
        case $18c4f9e6a0e81b69$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $18c4f9e6a0e81b69$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $18c4f9e6a0e81b69$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $18c4f9e6a0e81b69$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $18c4f9e6a0e81b69$var$Ga:
            return b = a.displayName || null, null !== b ? b : $18c4f9e6a0e81b69$var$Qa(a.type) || "Memo";
        case $18c4f9e6a0e81b69$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $18c4f9e6a0e81b69$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $18c4f9e6a0e81b69$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $18c4f9e6a0e81b69$var$Qa(b);
        case 8:
            return b === $18c4f9e6a0e81b69$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $18c4f9e6a0e81b69$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $18c4f9e6a0e81b69$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $18c4f9e6a0e81b69$var$Ua(a) {
    var b = $18c4f9e6a0e81b69$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $18c4f9e6a0e81b69$var$Va(a) {
    a._valueTracker || (a._valueTracker = $18c4f9e6a0e81b69$var$Ua(a));
}
function $18c4f9e6a0e81b69$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $18c4f9e6a0e81b69$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $18c4f9e6a0e81b69$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $18c4f9e6a0e81b69$var$Ya(a, b) {
    var c = b.checked;
    return $18c4f9e6a0e81b69$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $18c4f9e6a0e81b69$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $18c4f9e6a0e81b69$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $18c4f9e6a0e81b69$var$ab(a, b) {
    b = b.checked;
    null != b && $18c4f9e6a0e81b69$var$ta(a, "checked", b, !1);
}
function $18c4f9e6a0e81b69$var$bb(a, b) {
    $18c4f9e6a0e81b69$var$ab(a, b);
    var c = $18c4f9e6a0e81b69$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $18c4f9e6a0e81b69$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $18c4f9e6a0e81b69$var$cb(a, b.type, $18c4f9e6a0e81b69$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $18c4f9e6a0e81b69$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $18c4f9e6a0e81b69$var$cb(a, b, c) {
    if ("number" !== b || $18c4f9e6a0e81b69$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $18c4f9e6a0e81b69$var$eb = Array.isArray;
function $18c4f9e6a0e81b69$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $18c4f9e6a0e81b69$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $18c4f9e6a0e81b69$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($18c4f9e6a0e81b69$var$p(91));
    return $18c4f9e6a0e81b69$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $18c4f9e6a0e81b69$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($18c4f9e6a0e81b69$var$p(92));
            if ($18c4f9e6a0e81b69$var$eb(c)) {
                if (1 < c.length) throw Error($18c4f9e6a0e81b69$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $18c4f9e6a0e81b69$var$Sa(c)
    };
}
function $18c4f9e6a0e81b69$var$ib(a, b) {
    var c = $18c4f9e6a0e81b69$var$Sa(b.value), d = $18c4f9e6a0e81b69$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $18c4f9e6a0e81b69$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $18c4f9e6a0e81b69$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $18c4f9e6a0e81b69$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $18c4f9e6a0e81b69$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $18c4f9e6a0e81b69$var$mb, $18c4f9e6a0e81b69$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $18c4f9e6a0e81b69$var$mb = $18c4f9e6a0e81b69$var$mb || document.createElement("div");
        $18c4f9e6a0e81b69$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $18c4f9e6a0e81b69$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $18c4f9e6a0e81b69$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $18c4f9e6a0e81b69$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $18c4f9e6a0e81b69$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($18c4f9e6a0e81b69$var$pb).forEach(function(a) {
    $18c4f9e6a0e81b69$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $18c4f9e6a0e81b69$var$pb[b] = $18c4f9e6a0e81b69$var$pb[a];
    });
});
function $18c4f9e6a0e81b69$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $18c4f9e6a0e81b69$var$pb.hasOwnProperty(a) && $18c4f9e6a0e81b69$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $18c4f9e6a0e81b69$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $18c4f9e6a0e81b69$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $18c4f9e6a0e81b69$var$tb = $18c4f9e6a0e81b69$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $18c4f9e6a0e81b69$var$ub(a, b) {
    if (b) {
        if ($18c4f9e6a0e81b69$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($18c4f9e6a0e81b69$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($18c4f9e6a0e81b69$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($18c4f9e6a0e81b69$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($18c4f9e6a0e81b69$var$p(62));
    }
}
function $18c4f9e6a0e81b69$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $18c4f9e6a0e81b69$var$wb = null;
function $18c4f9e6a0e81b69$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $18c4f9e6a0e81b69$var$yb = null, $18c4f9e6a0e81b69$var$zb = null, $18c4f9e6a0e81b69$var$Ab = null;
function $18c4f9e6a0e81b69$var$Bb(a) {
    if (a = $18c4f9e6a0e81b69$var$Cb(a)) {
        if ("function" !== typeof $18c4f9e6a0e81b69$var$yb) throw Error($18c4f9e6a0e81b69$var$p(280));
        var b = a.stateNode;
        b && (b = $18c4f9e6a0e81b69$var$Db(b), $18c4f9e6a0e81b69$var$yb(a.stateNode, a.type, b));
    }
}
function $18c4f9e6a0e81b69$var$Eb(a) {
    $18c4f9e6a0e81b69$var$zb ? $18c4f9e6a0e81b69$var$Ab ? $18c4f9e6a0e81b69$var$Ab.push(a) : $18c4f9e6a0e81b69$var$Ab = [
        a
    ] : $18c4f9e6a0e81b69$var$zb = a;
}
function $18c4f9e6a0e81b69$var$Fb() {
    if ($18c4f9e6a0e81b69$var$zb) {
        var a = $18c4f9e6a0e81b69$var$zb, b = $18c4f9e6a0e81b69$var$Ab;
        $18c4f9e6a0e81b69$var$Ab = $18c4f9e6a0e81b69$var$zb = null;
        $18c4f9e6a0e81b69$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$18c4f9e6a0e81b69$var$Bb(b[a]);
    }
}
function $18c4f9e6a0e81b69$var$Gb(a, b) {
    return a(b);
}
function $18c4f9e6a0e81b69$var$Hb() {}
var $18c4f9e6a0e81b69$var$Ib = !1;
function $18c4f9e6a0e81b69$var$Jb(a, b, c) {
    if ($18c4f9e6a0e81b69$var$Ib) return a(b, c);
    $18c4f9e6a0e81b69$var$Ib = !0;
    try {
        return $18c4f9e6a0e81b69$var$Gb(a, b, c);
    } finally{
        if ($18c4f9e6a0e81b69$var$Ib = !1, null !== $18c4f9e6a0e81b69$var$zb || null !== $18c4f9e6a0e81b69$var$Ab) $18c4f9e6a0e81b69$var$Hb(), $18c4f9e6a0e81b69$var$Fb();
    }
}
function $18c4f9e6a0e81b69$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $18c4f9e6a0e81b69$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($18c4f9e6a0e81b69$var$p(231, b, typeof c));
    return c;
}
var $18c4f9e6a0e81b69$var$Lb = !1;
if ($18c4f9e6a0e81b69$var$ia) try {
    var $18c4f9e6a0e81b69$var$Mb = {};
    Object.defineProperty($18c4f9e6a0e81b69$var$Mb, "passive", {
        get: function() {
            $18c4f9e6a0e81b69$var$Lb = !0;
        }
    });
    window.addEventListener("test", $18c4f9e6a0e81b69$var$Mb, $18c4f9e6a0e81b69$var$Mb);
    window.removeEventListener("test", $18c4f9e6a0e81b69$var$Mb, $18c4f9e6a0e81b69$var$Mb);
} catch (a) {
    $18c4f9e6a0e81b69$var$Lb = !1;
}
function $18c4f9e6a0e81b69$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $18c4f9e6a0e81b69$var$Ob = !1, $18c4f9e6a0e81b69$var$Pb = null, $18c4f9e6a0e81b69$var$Qb = !1, $18c4f9e6a0e81b69$var$Rb = null, $18c4f9e6a0e81b69$var$Sb = {
    onError: function(a) {
        $18c4f9e6a0e81b69$var$Ob = !0;
        $18c4f9e6a0e81b69$var$Pb = a;
    }
};
function $18c4f9e6a0e81b69$var$Tb(a, b, c, d, e, f, g, h, k) {
    $18c4f9e6a0e81b69$var$Ob = !1;
    $18c4f9e6a0e81b69$var$Pb = null;
    $18c4f9e6a0e81b69$var$Nb.apply($18c4f9e6a0e81b69$var$Sb, arguments);
}
function $18c4f9e6a0e81b69$var$Ub(a, b, c, d, e, f, g, h, k) {
    $18c4f9e6a0e81b69$var$Tb.apply(this, arguments);
    if ($18c4f9e6a0e81b69$var$Ob) {
        if ($18c4f9e6a0e81b69$var$Ob) {
            var l = $18c4f9e6a0e81b69$var$Pb;
            $18c4f9e6a0e81b69$var$Ob = !1;
            $18c4f9e6a0e81b69$var$Pb = null;
        } else throw Error($18c4f9e6a0e81b69$var$p(198));
        $18c4f9e6a0e81b69$var$Qb || ($18c4f9e6a0e81b69$var$Qb = !0, $18c4f9e6a0e81b69$var$Rb = l);
    }
}
function $18c4f9e6a0e81b69$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $18c4f9e6a0e81b69$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $18c4f9e6a0e81b69$var$Xb(a) {
    if ($18c4f9e6a0e81b69$var$Vb(a) !== a) throw Error($18c4f9e6a0e81b69$var$p(188));
}
function $18c4f9e6a0e81b69$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $18c4f9e6a0e81b69$var$Vb(a);
        if (null === b) throw Error($18c4f9e6a0e81b69$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $18c4f9e6a0e81b69$var$Xb(e), a;
                if (f === d) return $18c4f9e6a0e81b69$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($18c4f9e6a0e81b69$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($18c4f9e6a0e81b69$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($18c4f9e6a0e81b69$var$p(190));
    }
    if (3 !== c.tag) throw Error($18c4f9e6a0e81b69$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $18c4f9e6a0e81b69$var$Zb(a) {
    a = $18c4f9e6a0e81b69$var$Yb(a);
    return null !== a ? $18c4f9e6a0e81b69$var$$b(a) : null;
}
function $18c4f9e6a0e81b69$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $18c4f9e6a0e81b69$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $18c4f9e6a0e81b69$var$ac = $feV1b.unstable_scheduleCallback, $18c4f9e6a0e81b69$var$bc = $feV1b.unstable_cancelCallback, $18c4f9e6a0e81b69$var$cc = $feV1b.unstable_shouldYield, $18c4f9e6a0e81b69$var$dc = $feV1b.unstable_requestPaint, $18c4f9e6a0e81b69$var$B = $feV1b.unstable_now, $18c4f9e6a0e81b69$var$ec = $feV1b.unstable_getCurrentPriorityLevel, $18c4f9e6a0e81b69$var$fc = $feV1b.unstable_ImmediatePriority, $18c4f9e6a0e81b69$var$gc = $feV1b.unstable_UserBlockingPriority, $18c4f9e6a0e81b69$var$hc = $feV1b.unstable_NormalPriority, $18c4f9e6a0e81b69$var$ic = $feV1b.unstable_LowPriority, $18c4f9e6a0e81b69$var$jc = $feV1b.unstable_IdlePriority, $18c4f9e6a0e81b69$var$kc = null, $18c4f9e6a0e81b69$var$lc = null;
function $18c4f9e6a0e81b69$var$mc(a) {
    if ($18c4f9e6a0e81b69$var$lc && "function" === typeof $18c4f9e6a0e81b69$var$lc.onCommitFiberRoot) try {
        $18c4f9e6a0e81b69$var$lc.onCommitFiberRoot($18c4f9e6a0e81b69$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $18c4f9e6a0e81b69$var$oc = Math.clz32 ? Math.clz32 : $18c4f9e6a0e81b69$var$nc, $18c4f9e6a0e81b69$var$pc = Math.log, $18c4f9e6a0e81b69$var$qc = Math.LN2;
function $18c4f9e6a0e81b69$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($18c4f9e6a0e81b69$var$pc(a) / $18c4f9e6a0e81b69$var$qc | 0) | 0;
}
var $18c4f9e6a0e81b69$var$rc = 64, $18c4f9e6a0e81b69$var$sc = 4194304;
function $18c4f9e6a0e81b69$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $18c4f9e6a0e81b69$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $18c4f9e6a0e81b69$var$tc(h) : (f &= g, 0 !== f && (d = $18c4f9e6a0e81b69$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $18c4f9e6a0e81b69$var$tc(g) : 0 !== f && (d = $18c4f9e6a0e81b69$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $18c4f9e6a0e81b69$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $18c4f9e6a0e81b69$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $18c4f9e6a0e81b69$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $18c4f9e6a0e81b69$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $18c4f9e6a0e81b69$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $18c4f9e6a0e81b69$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $18c4f9e6a0e81b69$var$yc() {
    var a = $18c4f9e6a0e81b69$var$rc;
    $18c4f9e6a0e81b69$var$rc <<= 1;
    0 === ($18c4f9e6a0e81b69$var$rc & 4194240) && ($18c4f9e6a0e81b69$var$rc = 64);
    return a;
}
function $18c4f9e6a0e81b69$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $18c4f9e6a0e81b69$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $18c4f9e6a0e81b69$var$oc(b);
    a[b] = c;
}
function $18c4f9e6a0e81b69$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $18c4f9e6a0e81b69$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $18c4f9e6a0e81b69$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $18c4f9e6a0e81b69$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $18c4f9e6a0e81b69$var$C = 0;
function $18c4f9e6a0e81b69$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $18c4f9e6a0e81b69$var$Ec, $18c4f9e6a0e81b69$var$Fc, $18c4f9e6a0e81b69$var$Gc, $18c4f9e6a0e81b69$var$Hc, $18c4f9e6a0e81b69$var$Ic, $18c4f9e6a0e81b69$var$Jc = !1, $18c4f9e6a0e81b69$var$Kc = [], $18c4f9e6a0e81b69$var$Lc = null, $18c4f9e6a0e81b69$var$Mc = null, $18c4f9e6a0e81b69$var$Nc = null, $18c4f9e6a0e81b69$var$Oc = new Map, $18c4f9e6a0e81b69$var$Pc = new Map, $18c4f9e6a0e81b69$var$Qc = [], $18c4f9e6a0e81b69$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $18c4f9e6a0e81b69$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $18c4f9e6a0e81b69$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $18c4f9e6a0e81b69$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $18c4f9e6a0e81b69$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $18c4f9e6a0e81b69$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $18c4f9e6a0e81b69$var$Pc.delete(b.pointerId);
    }
}
function $18c4f9e6a0e81b69$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $18c4f9e6a0e81b69$var$Cb(b), null !== b && $18c4f9e6a0e81b69$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $18c4f9e6a0e81b69$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $18c4f9e6a0e81b69$var$Lc = $18c4f9e6a0e81b69$var$Tc($18c4f9e6a0e81b69$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $18c4f9e6a0e81b69$var$Mc = $18c4f9e6a0e81b69$var$Tc($18c4f9e6a0e81b69$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $18c4f9e6a0e81b69$var$Nc = $18c4f9e6a0e81b69$var$Tc($18c4f9e6a0e81b69$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $18c4f9e6a0e81b69$var$Oc.set(f, $18c4f9e6a0e81b69$var$Tc($18c4f9e6a0e81b69$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $18c4f9e6a0e81b69$var$Pc.set(f, $18c4f9e6a0e81b69$var$Tc($18c4f9e6a0e81b69$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $18c4f9e6a0e81b69$var$Vc(a) {
    var b = $18c4f9e6a0e81b69$var$Wc(a.target);
    if (null !== b) {
        var c = $18c4f9e6a0e81b69$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $18c4f9e6a0e81b69$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $18c4f9e6a0e81b69$var$Ic(a.priority, function() {
                        $18c4f9e6a0e81b69$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $18c4f9e6a0e81b69$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $18c4f9e6a0e81b69$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $18c4f9e6a0e81b69$var$wb = d;
            c.target.dispatchEvent(d);
            $18c4f9e6a0e81b69$var$wb = null;
        } else return b = $18c4f9e6a0e81b69$var$Cb(c), null !== b && $18c4f9e6a0e81b69$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $18c4f9e6a0e81b69$var$Zc(a, b, c) {
    $18c4f9e6a0e81b69$var$Xc(a) && c.delete(b);
}
function $18c4f9e6a0e81b69$var$$c() {
    $18c4f9e6a0e81b69$var$Jc = !1;
    null !== $18c4f9e6a0e81b69$var$Lc && $18c4f9e6a0e81b69$var$Xc($18c4f9e6a0e81b69$var$Lc) && ($18c4f9e6a0e81b69$var$Lc = null);
    null !== $18c4f9e6a0e81b69$var$Mc && $18c4f9e6a0e81b69$var$Xc($18c4f9e6a0e81b69$var$Mc) && ($18c4f9e6a0e81b69$var$Mc = null);
    null !== $18c4f9e6a0e81b69$var$Nc && $18c4f9e6a0e81b69$var$Xc($18c4f9e6a0e81b69$var$Nc) && ($18c4f9e6a0e81b69$var$Nc = null);
    $18c4f9e6a0e81b69$var$Oc.forEach($18c4f9e6a0e81b69$var$Zc);
    $18c4f9e6a0e81b69$var$Pc.forEach($18c4f9e6a0e81b69$var$Zc);
}
function $18c4f9e6a0e81b69$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $18c4f9e6a0e81b69$var$Jc || ($18c4f9e6a0e81b69$var$Jc = !0, $feV1b.unstable_scheduleCallback($feV1b.unstable_NormalPriority, $18c4f9e6a0e81b69$var$$c)));
}
function $18c4f9e6a0e81b69$var$bd(a) {
    function b(b) {
        return $18c4f9e6a0e81b69$var$ad(b, a);
    }
    if (0 < $18c4f9e6a0e81b69$var$Kc.length) {
        $18c4f9e6a0e81b69$var$ad($18c4f9e6a0e81b69$var$Kc[0], a);
        for(var c = 1; c < $18c4f9e6a0e81b69$var$Kc.length; c++){
            var d = $18c4f9e6a0e81b69$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $18c4f9e6a0e81b69$var$Lc && $18c4f9e6a0e81b69$var$ad($18c4f9e6a0e81b69$var$Lc, a);
    null !== $18c4f9e6a0e81b69$var$Mc && $18c4f9e6a0e81b69$var$ad($18c4f9e6a0e81b69$var$Mc, a);
    null !== $18c4f9e6a0e81b69$var$Nc && $18c4f9e6a0e81b69$var$ad($18c4f9e6a0e81b69$var$Nc, a);
    $18c4f9e6a0e81b69$var$Oc.forEach(b);
    $18c4f9e6a0e81b69$var$Pc.forEach(b);
    for(c = 0; c < $18c4f9e6a0e81b69$var$Qc.length; c++)d = $18c4f9e6a0e81b69$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $18c4f9e6a0e81b69$var$Qc.length && (c = $18c4f9e6a0e81b69$var$Qc[0], null === c.blockedOn);)$18c4f9e6a0e81b69$var$Vc(c), null === c.blockedOn && $18c4f9e6a0e81b69$var$Qc.shift();
}
var $18c4f9e6a0e81b69$var$cd = $18c4f9e6a0e81b69$var$ua.ReactCurrentBatchConfig, $18c4f9e6a0e81b69$var$dd = !0;
function $18c4f9e6a0e81b69$var$ed(a, b, c, d) {
    var e = $18c4f9e6a0e81b69$var$C, f = $18c4f9e6a0e81b69$var$cd.transition;
    $18c4f9e6a0e81b69$var$cd.transition = null;
    try {
        $18c4f9e6a0e81b69$var$C = 1, $18c4f9e6a0e81b69$var$fd(a, b, c, d);
    } finally{
        $18c4f9e6a0e81b69$var$C = e, $18c4f9e6a0e81b69$var$cd.transition = f;
    }
}
function $18c4f9e6a0e81b69$var$gd(a, b, c, d) {
    var e = $18c4f9e6a0e81b69$var$C, f = $18c4f9e6a0e81b69$var$cd.transition;
    $18c4f9e6a0e81b69$var$cd.transition = null;
    try {
        $18c4f9e6a0e81b69$var$C = 4, $18c4f9e6a0e81b69$var$fd(a, b, c, d);
    } finally{
        $18c4f9e6a0e81b69$var$C = e, $18c4f9e6a0e81b69$var$cd.transition = f;
    }
}
function $18c4f9e6a0e81b69$var$fd(a, b, c, d) {
    if ($18c4f9e6a0e81b69$var$dd) {
        var e = $18c4f9e6a0e81b69$var$Yc(a, b, c, d);
        if (null === e) $18c4f9e6a0e81b69$var$hd(a, b, d, $18c4f9e6a0e81b69$var$id, c), $18c4f9e6a0e81b69$var$Sc(a, d);
        else if ($18c4f9e6a0e81b69$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($18c4f9e6a0e81b69$var$Sc(a, d), b & 4 && -1 < $18c4f9e6a0e81b69$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $18c4f9e6a0e81b69$var$Cb(e);
                null !== f && $18c4f9e6a0e81b69$var$Ec(f);
                f = $18c4f9e6a0e81b69$var$Yc(a, b, c, d);
                null === f && $18c4f9e6a0e81b69$var$hd(a, b, d, $18c4f9e6a0e81b69$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $18c4f9e6a0e81b69$var$hd(a, b, d, null, c);
    }
}
var $18c4f9e6a0e81b69$var$id = null;
function $18c4f9e6a0e81b69$var$Yc(a, b, c, d) {
    $18c4f9e6a0e81b69$var$id = null;
    a = $18c4f9e6a0e81b69$var$xb(d);
    a = $18c4f9e6a0e81b69$var$Wc(a);
    if (null !== a) {
        if (b = $18c4f9e6a0e81b69$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $18c4f9e6a0e81b69$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $18c4f9e6a0e81b69$var$id = a;
    return null;
}
function $18c4f9e6a0e81b69$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($18c4f9e6a0e81b69$var$ec()){
                case $18c4f9e6a0e81b69$var$fc:
                    return 1;
                case $18c4f9e6a0e81b69$var$gc:
                    return 4;
                case $18c4f9e6a0e81b69$var$hc:
                case $18c4f9e6a0e81b69$var$ic:
                    return 16;
                case $18c4f9e6a0e81b69$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $18c4f9e6a0e81b69$var$kd = null, $18c4f9e6a0e81b69$var$ld = null, $18c4f9e6a0e81b69$var$md = null;
function $18c4f9e6a0e81b69$var$nd() {
    if ($18c4f9e6a0e81b69$var$md) return $18c4f9e6a0e81b69$var$md;
    var a, b = $18c4f9e6a0e81b69$var$ld, c = b.length, d, e = "value" in $18c4f9e6a0e81b69$var$kd ? $18c4f9e6a0e81b69$var$kd.value : $18c4f9e6a0e81b69$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $18c4f9e6a0e81b69$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $18c4f9e6a0e81b69$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $18c4f9e6a0e81b69$var$pd() {
    return !0;
}
function $18c4f9e6a0e81b69$var$qd() {
    return !1;
}
function $18c4f9e6a0e81b69$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $18c4f9e6a0e81b69$var$pd : $18c4f9e6a0e81b69$var$qd;
        this.isPropagationStopped = $18c4f9e6a0e81b69$var$qd;
        return this;
    }
    $18c4f9e6a0e81b69$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $18c4f9e6a0e81b69$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $18c4f9e6a0e81b69$var$pd);
        },
        persist: function() {},
        isPersistent: $18c4f9e6a0e81b69$var$pd
    });
    return b;
}
var $18c4f9e6a0e81b69$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $18c4f9e6a0e81b69$var$td = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$sd), $18c4f9e6a0e81b69$var$ud = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$sd, {
    view: 0,
    detail: 0
}), $18c4f9e6a0e81b69$var$vd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$ud), $18c4f9e6a0e81b69$var$wd, $18c4f9e6a0e81b69$var$xd, $18c4f9e6a0e81b69$var$yd, $18c4f9e6a0e81b69$var$Ad = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $18c4f9e6a0e81b69$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $18c4f9e6a0e81b69$var$yd && ($18c4f9e6a0e81b69$var$yd && "mousemove" === a.type ? ($18c4f9e6a0e81b69$var$wd = a.screenX - $18c4f9e6a0e81b69$var$yd.screenX, $18c4f9e6a0e81b69$var$xd = a.screenY - $18c4f9e6a0e81b69$var$yd.screenY) : $18c4f9e6a0e81b69$var$xd = $18c4f9e6a0e81b69$var$wd = 0, $18c4f9e6a0e81b69$var$yd = a);
        return $18c4f9e6a0e81b69$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $18c4f9e6a0e81b69$var$xd;
    }
}), $18c4f9e6a0e81b69$var$Bd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Ad), $18c4f9e6a0e81b69$var$Cd = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$Ad, {
    dataTransfer: 0
}), $18c4f9e6a0e81b69$var$Dd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Cd), $18c4f9e6a0e81b69$var$Ed = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$ud, {
    relatedTarget: 0
}), $18c4f9e6a0e81b69$var$Fd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Ed), $18c4f9e6a0e81b69$var$Gd = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $18c4f9e6a0e81b69$var$Hd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Gd), $18c4f9e6a0e81b69$var$Id = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $18c4f9e6a0e81b69$var$Jd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Id), $18c4f9e6a0e81b69$var$Kd = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$sd, {
    data: 0
}), $18c4f9e6a0e81b69$var$Ld = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Kd), $18c4f9e6a0e81b69$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $18c4f9e6a0e81b69$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $18c4f9e6a0e81b69$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $18c4f9e6a0e81b69$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $18c4f9e6a0e81b69$var$Od[a]) ? !!b[a] : !1;
}
function $18c4f9e6a0e81b69$var$zd() {
    return $18c4f9e6a0e81b69$var$Pd;
}
var $18c4f9e6a0e81b69$var$Qd = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $18c4f9e6a0e81b69$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $18c4f9e6a0e81b69$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $18c4f9e6a0e81b69$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $18c4f9e6a0e81b69$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $18c4f9e6a0e81b69$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $18c4f9e6a0e81b69$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $18c4f9e6a0e81b69$var$Rd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Qd), $18c4f9e6a0e81b69$var$Sd = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $18c4f9e6a0e81b69$var$Td = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Sd), $18c4f9e6a0e81b69$var$Ud = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $18c4f9e6a0e81b69$var$zd
}), $18c4f9e6a0e81b69$var$Vd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Ud), $18c4f9e6a0e81b69$var$Wd = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $18c4f9e6a0e81b69$var$Xd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Wd), $18c4f9e6a0e81b69$var$Yd = $18c4f9e6a0e81b69$var$A({}, $18c4f9e6a0e81b69$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $18c4f9e6a0e81b69$var$Zd = $18c4f9e6a0e81b69$var$rd($18c4f9e6a0e81b69$var$Yd), $18c4f9e6a0e81b69$var$$d = [
    9,
    13,
    27,
    32
], $18c4f9e6a0e81b69$var$ae = $18c4f9e6a0e81b69$var$ia && "CompositionEvent" in window, $18c4f9e6a0e81b69$var$be = null;
$18c4f9e6a0e81b69$var$ia && "documentMode" in document && ($18c4f9e6a0e81b69$var$be = document.documentMode);
var $18c4f9e6a0e81b69$var$ce = $18c4f9e6a0e81b69$var$ia && "TextEvent" in window && !$18c4f9e6a0e81b69$var$be, $18c4f9e6a0e81b69$var$de = $18c4f9e6a0e81b69$var$ia && (!$18c4f9e6a0e81b69$var$ae || $18c4f9e6a0e81b69$var$be && 8 < $18c4f9e6a0e81b69$var$be && 11 >= $18c4f9e6a0e81b69$var$be), $18c4f9e6a0e81b69$var$ee = String.fromCharCode(32), $18c4f9e6a0e81b69$var$fe = !1;
function $18c4f9e6a0e81b69$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $18c4f9e6a0e81b69$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $18c4f9e6a0e81b69$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $18c4f9e6a0e81b69$var$ie = !1;
function $18c4f9e6a0e81b69$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $18c4f9e6a0e81b69$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $18c4f9e6a0e81b69$var$fe = !0;
            return $18c4f9e6a0e81b69$var$ee;
        case "textInput":
            return a = b.data, a === $18c4f9e6a0e81b69$var$ee && $18c4f9e6a0e81b69$var$fe ? null : a;
        default:
            return null;
    }
}
function $18c4f9e6a0e81b69$var$ke(a, b) {
    if ($18c4f9e6a0e81b69$var$ie) return "compositionend" === a || !$18c4f9e6a0e81b69$var$ae && $18c4f9e6a0e81b69$var$ge(a, b) ? (a = $18c4f9e6a0e81b69$var$nd(), $18c4f9e6a0e81b69$var$md = $18c4f9e6a0e81b69$var$ld = $18c4f9e6a0e81b69$var$kd = null, $18c4f9e6a0e81b69$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $18c4f9e6a0e81b69$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $18c4f9e6a0e81b69$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $18c4f9e6a0e81b69$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$18c4f9e6a0e81b69$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $18c4f9e6a0e81b69$var$ne(a, b, c, d) {
    $18c4f9e6a0e81b69$var$Eb(d);
    b = $18c4f9e6a0e81b69$var$oe(b, "onChange");
    0 < b.length && (c = new $18c4f9e6a0e81b69$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $18c4f9e6a0e81b69$var$pe = null, $18c4f9e6a0e81b69$var$qe = null;
function $18c4f9e6a0e81b69$var$re(a) {
    $18c4f9e6a0e81b69$var$se(a, 0);
}
function $18c4f9e6a0e81b69$var$te(a) {
    var b = $18c4f9e6a0e81b69$var$ue(a);
    if ($18c4f9e6a0e81b69$var$Wa(b)) return a;
}
function $18c4f9e6a0e81b69$var$ve(a, b) {
    if ("change" === a) return b;
}
var $18c4f9e6a0e81b69$var$we = !1;
if ($18c4f9e6a0e81b69$var$ia) {
    var $18c4f9e6a0e81b69$var$xe;
    if ($18c4f9e6a0e81b69$var$ia) {
        var $18c4f9e6a0e81b69$var$ye = "oninput" in document;
        if (!$18c4f9e6a0e81b69$var$ye) {
            var $18c4f9e6a0e81b69$var$ze = document.createElement("div");
            $18c4f9e6a0e81b69$var$ze.setAttribute("oninput", "return;");
            $18c4f9e6a0e81b69$var$ye = "function" === typeof $18c4f9e6a0e81b69$var$ze.oninput;
        }
        $18c4f9e6a0e81b69$var$xe = $18c4f9e6a0e81b69$var$ye;
    } else $18c4f9e6a0e81b69$var$xe = !1;
    $18c4f9e6a0e81b69$var$we = $18c4f9e6a0e81b69$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $18c4f9e6a0e81b69$var$Ae() {
    $18c4f9e6a0e81b69$var$pe && ($18c4f9e6a0e81b69$var$pe.detachEvent("onpropertychange", $18c4f9e6a0e81b69$var$Be), $18c4f9e6a0e81b69$var$qe = $18c4f9e6a0e81b69$var$pe = null);
}
function $18c4f9e6a0e81b69$var$Be(a) {
    if ("value" === a.propertyName && $18c4f9e6a0e81b69$var$te($18c4f9e6a0e81b69$var$qe)) {
        var b = [];
        $18c4f9e6a0e81b69$var$ne(b, $18c4f9e6a0e81b69$var$qe, a, $18c4f9e6a0e81b69$var$xb(a));
        $18c4f9e6a0e81b69$var$Jb($18c4f9e6a0e81b69$var$re, b);
    }
}
function $18c4f9e6a0e81b69$var$Ce(a, b, c) {
    "focusin" === a ? ($18c4f9e6a0e81b69$var$Ae(), $18c4f9e6a0e81b69$var$pe = b, $18c4f9e6a0e81b69$var$qe = c, $18c4f9e6a0e81b69$var$pe.attachEvent("onpropertychange", $18c4f9e6a0e81b69$var$Be)) : "focusout" === a && $18c4f9e6a0e81b69$var$Ae();
}
function $18c4f9e6a0e81b69$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $18c4f9e6a0e81b69$var$te($18c4f9e6a0e81b69$var$qe);
}
function $18c4f9e6a0e81b69$var$Ee(a, b) {
    if ("click" === a) return $18c4f9e6a0e81b69$var$te(b);
}
function $18c4f9e6a0e81b69$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $18c4f9e6a0e81b69$var$te(b);
}
function $18c4f9e6a0e81b69$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $18c4f9e6a0e81b69$var$He = "function" === typeof Object.is ? Object.is : $18c4f9e6a0e81b69$var$Ge;
function $18c4f9e6a0e81b69$var$Ie(a, b) {
    if ($18c4f9e6a0e81b69$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$18c4f9e6a0e81b69$var$ja.call(b, e) || !$18c4f9e6a0e81b69$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $18c4f9e6a0e81b69$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $18c4f9e6a0e81b69$var$Ke(a, b) {
    var c = $18c4f9e6a0e81b69$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $18c4f9e6a0e81b69$var$Je(c);
    }
}
function $18c4f9e6a0e81b69$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $18c4f9e6a0e81b69$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $18c4f9e6a0e81b69$var$Me() {
    for(var a = window, b = $18c4f9e6a0e81b69$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $18c4f9e6a0e81b69$var$Xa(a.document);
    }
    return b;
}
function $18c4f9e6a0e81b69$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $18c4f9e6a0e81b69$var$Oe(a) {
    var b = $18c4f9e6a0e81b69$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $18c4f9e6a0e81b69$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $18c4f9e6a0e81b69$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $18c4f9e6a0e81b69$var$Ke(c, f);
                var g = $18c4f9e6a0e81b69$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $18c4f9e6a0e81b69$var$Pe = $18c4f9e6a0e81b69$var$ia && "documentMode" in document && 11 >= document.documentMode, $18c4f9e6a0e81b69$var$Qe = null, $18c4f9e6a0e81b69$var$Re = null, $18c4f9e6a0e81b69$var$Se = null, $18c4f9e6a0e81b69$var$Te = !1;
function $18c4f9e6a0e81b69$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $18c4f9e6a0e81b69$var$Te || null == $18c4f9e6a0e81b69$var$Qe || $18c4f9e6a0e81b69$var$Qe !== $18c4f9e6a0e81b69$var$Xa(d) || (d = $18c4f9e6a0e81b69$var$Qe, "selectionStart" in d && $18c4f9e6a0e81b69$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $18c4f9e6a0e81b69$var$Se && $18c4f9e6a0e81b69$var$Ie($18c4f9e6a0e81b69$var$Se, d) || ($18c4f9e6a0e81b69$var$Se = d, d = $18c4f9e6a0e81b69$var$oe($18c4f9e6a0e81b69$var$Re, "onSelect"), 0 < d.length && (b = new $18c4f9e6a0e81b69$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $18c4f9e6a0e81b69$var$Qe)));
}
function $18c4f9e6a0e81b69$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $18c4f9e6a0e81b69$var$We = {
    animationend: $18c4f9e6a0e81b69$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $18c4f9e6a0e81b69$var$Ve("Animation", "AnimationIteration"),
    animationstart: $18c4f9e6a0e81b69$var$Ve("Animation", "AnimationStart"),
    transitionend: $18c4f9e6a0e81b69$var$Ve("Transition", "TransitionEnd")
}, $18c4f9e6a0e81b69$var$Xe = {}, $18c4f9e6a0e81b69$var$Ye = {};
$18c4f9e6a0e81b69$var$ia && ($18c4f9e6a0e81b69$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $18c4f9e6a0e81b69$var$We.animationend.animation, delete $18c4f9e6a0e81b69$var$We.animationiteration.animation, delete $18c4f9e6a0e81b69$var$We.animationstart.animation), "TransitionEvent" in window || delete $18c4f9e6a0e81b69$var$We.transitionend.transition);
function $18c4f9e6a0e81b69$var$Ze(a) {
    if ($18c4f9e6a0e81b69$var$Xe[a]) return $18c4f9e6a0e81b69$var$Xe[a];
    if (!$18c4f9e6a0e81b69$var$We[a]) return a;
    var b = $18c4f9e6a0e81b69$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $18c4f9e6a0e81b69$var$Ye) return $18c4f9e6a0e81b69$var$Xe[a] = b[c];
    return a;
}
var $18c4f9e6a0e81b69$var$$e = $18c4f9e6a0e81b69$var$Ze("animationend"), $18c4f9e6a0e81b69$var$af = $18c4f9e6a0e81b69$var$Ze("animationiteration"), $18c4f9e6a0e81b69$var$bf = $18c4f9e6a0e81b69$var$Ze("animationstart"), $18c4f9e6a0e81b69$var$cf = $18c4f9e6a0e81b69$var$Ze("transitionend"), $18c4f9e6a0e81b69$var$df = new Map, $18c4f9e6a0e81b69$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $18c4f9e6a0e81b69$var$ff(a, b) {
    $18c4f9e6a0e81b69$var$df.set(a, b);
    $18c4f9e6a0e81b69$var$fa(b, [
        a
    ]);
}
for(var $18c4f9e6a0e81b69$var$gf = 0; $18c4f9e6a0e81b69$var$gf < $18c4f9e6a0e81b69$var$ef.length; $18c4f9e6a0e81b69$var$gf++){
    var $18c4f9e6a0e81b69$var$hf = $18c4f9e6a0e81b69$var$ef[$18c4f9e6a0e81b69$var$gf], $18c4f9e6a0e81b69$var$jf = $18c4f9e6a0e81b69$var$hf.toLowerCase(), $18c4f9e6a0e81b69$var$kf = $18c4f9e6a0e81b69$var$hf[0].toUpperCase() + $18c4f9e6a0e81b69$var$hf.slice(1);
    $18c4f9e6a0e81b69$var$ff($18c4f9e6a0e81b69$var$jf, "on" + $18c4f9e6a0e81b69$var$kf);
}
$18c4f9e6a0e81b69$var$ff($18c4f9e6a0e81b69$var$$e, "onAnimationEnd");
$18c4f9e6a0e81b69$var$ff($18c4f9e6a0e81b69$var$af, "onAnimationIteration");
$18c4f9e6a0e81b69$var$ff($18c4f9e6a0e81b69$var$bf, "onAnimationStart");
$18c4f9e6a0e81b69$var$ff("dblclick", "onDoubleClick");
$18c4f9e6a0e81b69$var$ff("focusin", "onFocus");
$18c4f9e6a0e81b69$var$ff("focusout", "onBlur");
$18c4f9e6a0e81b69$var$ff($18c4f9e6a0e81b69$var$cf, "onTransitionEnd");
$18c4f9e6a0e81b69$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$18c4f9e6a0e81b69$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$18c4f9e6a0e81b69$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$18c4f9e6a0e81b69$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$18c4f9e6a0e81b69$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$18c4f9e6a0e81b69$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$18c4f9e6a0e81b69$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$18c4f9e6a0e81b69$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$18c4f9e6a0e81b69$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$18c4f9e6a0e81b69$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $18c4f9e6a0e81b69$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $18c4f9e6a0e81b69$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($18c4f9e6a0e81b69$var$lf));
function $18c4f9e6a0e81b69$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $18c4f9e6a0e81b69$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $18c4f9e6a0e81b69$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $18c4f9e6a0e81b69$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $18c4f9e6a0e81b69$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($18c4f9e6a0e81b69$var$Qb) throw a = $18c4f9e6a0e81b69$var$Rb, $18c4f9e6a0e81b69$var$Qb = !1, $18c4f9e6a0e81b69$var$Rb = null, a;
}
function $18c4f9e6a0e81b69$var$D(a, b) {
    var c = b[$18c4f9e6a0e81b69$var$of];
    void 0 === c && (c = b[$18c4f9e6a0e81b69$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($18c4f9e6a0e81b69$var$pf(b, a, 2, !1), c.add(d));
}
function $18c4f9e6a0e81b69$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $18c4f9e6a0e81b69$var$pf(c, a, d, b);
}
var $18c4f9e6a0e81b69$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $18c4f9e6a0e81b69$var$sf(a) {
    if (!a[$18c4f9e6a0e81b69$var$rf]) {
        a[$18c4f9e6a0e81b69$var$rf] = !0;
        $18c4f9e6a0e81b69$var$da.forEach(function(b) {
            "selectionchange" !== b && ($18c4f9e6a0e81b69$var$mf.has(b) || $18c4f9e6a0e81b69$var$qf(b, !1, a), $18c4f9e6a0e81b69$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$18c4f9e6a0e81b69$var$rf] || (b[$18c4f9e6a0e81b69$var$rf] = !0, $18c4f9e6a0e81b69$var$qf("selectionchange", !1, b));
    }
}
function $18c4f9e6a0e81b69$var$pf(a, b, c, d) {
    switch($18c4f9e6a0e81b69$var$jd(b)){
        case 1:
            var e = $18c4f9e6a0e81b69$var$ed;
            break;
        case 4:
            e = $18c4f9e6a0e81b69$var$gd;
            break;
        default:
            e = $18c4f9e6a0e81b69$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$18c4f9e6a0e81b69$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $18c4f9e6a0e81b69$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $18c4f9e6a0e81b69$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $18c4f9e6a0e81b69$var$Jb(function() {
        var d = f, e = $18c4f9e6a0e81b69$var$xb(c), g = [];
        a: {
            var h = $18c4f9e6a0e81b69$var$df.get(a);
            if (void 0 !== h) {
                var k = $18c4f9e6a0e81b69$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $18c4f9e6a0e81b69$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $18c4f9e6a0e81b69$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $18c4f9e6a0e81b69$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $18c4f9e6a0e81b69$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $18c4f9e6a0e81b69$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $18c4f9e6a0e81b69$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $18c4f9e6a0e81b69$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $18c4f9e6a0e81b69$var$Vd;
                        break;
                    case $18c4f9e6a0e81b69$var$$e:
                    case $18c4f9e6a0e81b69$var$af:
                    case $18c4f9e6a0e81b69$var$bf:
                        k = $18c4f9e6a0e81b69$var$Hd;
                        break;
                    case $18c4f9e6a0e81b69$var$cf:
                        k = $18c4f9e6a0e81b69$var$Xd;
                        break;
                    case "scroll":
                        k = $18c4f9e6a0e81b69$var$vd;
                        break;
                    case "wheel":
                        k = $18c4f9e6a0e81b69$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $18c4f9e6a0e81b69$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $18c4f9e6a0e81b69$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $18c4f9e6a0e81b69$var$Kb(w, x), null != F && t.push($18c4f9e6a0e81b69$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $18c4f9e6a0e81b69$var$wb && (n = c.relatedTarget || c.fromElement) && ($18c4f9e6a0e81b69$var$Wc(n) || n[$18c4f9e6a0e81b69$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $18c4f9e6a0e81b69$var$Wc(n) : null, null !== n && (J = $18c4f9e6a0e81b69$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $18c4f9e6a0e81b69$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $18c4f9e6a0e81b69$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $18c4f9e6a0e81b69$var$ue(k);
                        u = null == n ? h : $18c4f9e6a0e81b69$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $18c4f9e6a0e81b69$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $18c4f9e6a0e81b69$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $18c4f9e6a0e81b69$var$vf(F))u++;
                            for(; 0 < w - u;)t = $18c4f9e6a0e81b69$var$vf(t), w--;
                            for(; 0 < u - w;)x = $18c4f9e6a0e81b69$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $18c4f9e6a0e81b69$var$vf(t);
                                x = $18c4f9e6a0e81b69$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $18c4f9e6a0e81b69$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $18c4f9e6a0e81b69$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $18c4f9e6a0e81b69$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $18c4f9e6a0e81b69$var$ve;
                else if ($18c4f9e6a0e81b69$var$me(h)) {
                    if ($18c4f9e6a0e81b69$var$we) na = $18c4f9e6a0e81b69$var$Fe;
                    else {
                        na = $18c4f9e6a0e81b69$var$De;
                        var xa = $18c4f9e6a0e81b69$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $18c4f9e6a0e81b69$var$Ee);
                if (na && (na = na(a, d))) {
                    $18c4f9e6a0e81b69$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $18c4f9e6a0e81b69$var$cb(h, "number", h.value);
            }
            xa = d ? $18c4f9e6a0e81b69$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($18c4f9e6a0e81b69$var$me(xa) || "true" === xa.contentEditable) $18c4f9e6a0e81b69$var$Qe = xa, $18c4f9e6a0e81b69$var$Re = d, $18c4f9e6a0e81b69$var$Se = null;
                    break;
                case "focusout":
                    $18c4f9e6a0e81b69$var$Se = $18c4f9e6a0e81b69$var$Re = $18c4f9e6a0e81b69$var$Qe = null;
                    break;
                case "mousedown":
                    $18c4f9e6a0e81b69$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $18c4f9e6a0e81b69$var$Te = !1;
                    $18c4f9e6a0e81b69$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($18c4f9e6a0e81b69$var$Pe) break;
                case "keydown":
                case "keyup":
                    $18c4f9e6a0e81b69$var$Ue(g, c, e);
            }
            var $a;
            if ($18c4f9e6a0e81b69$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $18c4f9e6a0e81b69$var$ie ? $18c4f9e6a0e81b69$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($18c4f9e6a0e81b69$var$de && "ko" !== c.locale && ($18c4f9e6a0e81b69$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $18c4f9e6a0e81b69$var$ie && ($a = $18c4f9e6a0e81b69$var$nd()) : ($18c4f9e6a0e81b69$var$kd = e, $18c4f9e6a0e81b69$var$ld = "value" in $18c4f9e6a0e81b69$var$kd ? $18c4f9e6a0e81b69$var$kd.value : $18c4f9e6a0e81b69$var$kd.textContent, $18c4f9e6a0e81b69$var$ie = !0)), xa = $18c4f9e6a0e81b69$var$oe(d, ba), 0 < xa.length && (ba = new $18c4f9e6a0e81b69$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $18c4f9e6a0e81b69$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $18c4f9e6a0e81b69$var$ce ? $18c4f9e6a0e81b69$var$je(a, c) : $18c4f9e6a0e81b69$var$ke(a, c)) d = $18c4f9e6a0e81b69$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $18c4f9e6a0e81b69$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $18c4f9e6a0e81b69$var$se(g, b);
    });
}
function $18c4f9e6a0e81b69$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $18c4f9e6a0e81b69$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $18c4f9e6a0e81b69$var$Kb(a, c), null != f && d.unshift($18c4f9e6a0e81b69$var$tf(a, f, e)), f = $18c4f9e6a0e81b69$var$Kb(a, b), null != f && d.push($18c4f9e6a0e81b69$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $18c4f9e6a0e81b69$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $18c4f9e6a0e81b69$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $18c4f9e6a0e81b69$var$Kb(c, f), null != k && g.unshift($18c4f9e6a0e81b69$var$tf(c, k, h))) : e || (k = $18c4f9e6a0e81b69$var$Kb(c, f), null != k && g.push($18c4f9e6a0e81b69$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $18c4f9e6a0e81b69$var$xf = /\r\n?/g, $18c4f9e6a0e81b69$var$yf = /\u0000|\uFFFD/g;
function $18c4f9e6a0e81b69$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($18c4f9e6a0e81b69$var$xf, "\n").replace($18c4f9e6a0e81b69$var$yf, "");
}
function $18c4f9e6a0e81b69$var$Af(a, b, c) {
    b = $18c4f9e6a0e81b69$var$zf(b);
    if ($18c4f9e6a0e81b69$var$zf(a) !== b && c) throw Error($18c4f9e6a0e81b69$var$p(425));
}
function $18c4f9e6a0e81b69$var$Bf() {}
var $18c4f9e6a0e81b69$var$Cf = null, $18c4f9e6a0e81b69$var$Df = null;
function $18c4f9e6a0e81b69$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $18c4f9e6a0e81b69$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $18c4f9e6a0e81b69$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $18c4f9e6a0e81b69$var$Hf = "function" === typeof Promise ? Promise : void 0, $18c4f9e6a0e81b69$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $18c4f9e6a0e81b69$var$Hf ? function(a) {
    return $18c4f9e6a0e81b69$var$Hf.resolve(null).then(a).catch($18c4f9e6a0e81b69$var$If);
} : $18c4f9e6a0e81b69$var$Ff;
function $18c4f9e6a0e81b69$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $18c4f9e6a0e81b69$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $18c4f9e6a0e81b69$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $18c4f9e6a0e81b69$var$bd(b);
}
function $18c4f9e6a0e81b69$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $18c4f9e6a0e81b69$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $18c4f9e6a0e81b69$var$Nf = Math.random().toString(36).slice(2), $18c4f9e6a0e81b69$var$Of = "__reactFiber$" + $18c4f9e6a0e81b69$var$Nf, $18c4f9e6a0e81b69$var$Pf = "__reactProps$" + $18c4f9e6a0e81b69$var$Nf, $18c4f9e6a0e81b69$var$uf = "__reactContainer$" + $18c4f9e6a0e81b69$var$Nf, $18c4f9e6a0e81b69$var$of = "__reactEvents$" + $18c4f9e6a0e81b69$var$Nf, $18c4f9e6a0e81b69$var$Qf = "__reactListeners$" + $18c4f9e6a0e81b69$var$Nf, $18c4f9e6a0e81b69$var$Rf = "__reactHandles$" + $18c4f9e6a0e81b69$var$Nf;
function $18c4f9e6a0e81b69$var$Wc(a) {
    var b = a[$18c4f9e6a0e81b69$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$18c4f9e6a0e81b69$var$uf] || c[$18c4f9e6a0e81b69$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $18c4f9e6a0e81b69$var$Mf(a); null !== a;){
                if (c = a[$18c4f9e6a0e81b69$var$Of]) return c;
                a = $18c4f9e6a0e81b69$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $18c4f9e6a0e81b69$var$Cb(a) {
    a = a[$18c4f9e6a0e81b69$var$Of] || a[$18c4f9e6a0e81b69$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $18c4f9e6a0e81b69$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($18c4f9e6a0e81b69$var$p(33));
}
function $18c4f9e6a0e81b69$var$Db(a) {
    return a[$18c4f9e6a0e81b69$var$Pf] || null;
}
var $18c4f9e6a0e81b69$var$Sf = [], $18c4f9e6a0e81b69$var$Tf = -1;
function $18c4f9e6a0e81b69$var$Uf(a) {
    return {
        current: a
    };
}
function $18c4f9e6a0e81b69$var$E(a) {
    0 > $18c4f9e6a0e81b69$var$Tf || (a.current = $18c4f9e6a0e81b69$var$Sf[$18c4f9e6a0e81b69$var$Tf], $18c4f9e6a0e81b69$var$Sf[$18c4f9e6a0e81b69$var$Tf] = null, $18c4f9e6a0e81b69$var$Tf--);
}
function $18c4f9e6a0e81b69$var$G(a, b) {
    $18c4f9e6a0e81b69$var$Tf++;
    $18c4f9e6a0e81b69$var$Sf[$18c4f9e6a0e81b69$var$Tf] = a.current;
    a.current = b;
}
var $18c4f9e6a0e81b69$var$Vf = {}, $18c4f9e6a0e81b69$var$H = $18c4f9e6a0e81b69$var$Uf($18c4f9e6a0e81b69$var$Vf), $18c4f9e6a0e81b69$var$Wf = $18c4f9e6a0e81b69$var$Uf(!1), $18c4f9e6a0e81b69$var$Xf = $18c4f9e6a0e81b69$var$Vf;
function $18c4f9e6a0e81b69$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $18c4f9e6a0e81b69$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $18c4f9e6a0e81b69$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $18c4f9e6a0e81b69$var$$f() {
    $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$Wf);
    $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$H);
}
function $18c4f9e6a0e81b69$var$ag(a, b, c) {
    if ($18c4f9e6a0e81b69$var$H.current !== $18c4f9e6a0e81b69$var$Vf) throw Error($18c4f9e6a0e81b69$var$p(168));
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$H, b);
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$Wf, c);
}
function $18c4f9e6a0e81b69$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($18c4f9e6a0e81b69$var$p(108, $18c4f9e6a0e81b69$var$Ra(a) || "Unknown", e));
    return $18c4f9e6a0e81b69$var$A({}, c, d);
}
function $18c4f9e6a0e81b69$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $18c4f9e6a0e81b69$var$Vf;
    $18c4f9e6a0e81b69$var$Xf = $18c4f9e6a0e81b69$var$H.current;
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$H, a);
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$Wf, $18c4f9e6a0e81b69$var$Wf.current);
    return !0;
}
function $18c4f9e6a0e81b69$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($18c4f9e6a0e81b69$var$p(169));
    c ? (a = $18c4f9e6a0e81b69$var$bg(a, b, $18c4f9e6a0e81b69$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$Wf), $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$H), $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$H, a)) : $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$Wf);
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$Wf, c);
}
var $18c4f9e6a0e81b69$var$eg = null, $18c4f9e6a0e81b69$var$fg = !1, $18c4f9e6a0e81b69$var$gg = !1;
function $18c4f9e6a0e81b69$var$hg(a) {
    null === $18c4f9e6a0e81b69$var$eg ? $18c4f9e6a0e81b69$var$eg = [
        a
    ] : $18c4f9e6a0e81b69$var$eg.push(a);
}
function $18c4f9e6a0e81b69$var$ig(a) {
    $18c4f9e6a0e81b69$var$fg = !0;
    $18c4f9e6a0e81b69$var$hg(a);
}
function $18c4f9e6a0e81b69$var$jg() {
    if (!$18c4f9e6a0e81b69$var$gg && null !== $18c4f9e6a0e81b69$var$eg) {
        $18c4f9e6a0e81b69$var$gg = !0;
        var a = 0, b = $18c4f9e6a0e81b69$var$C;
        try {
            var c = $18c4f9e6a0e81b69$var$eg;
            for($18c4f9e6a0e81b69$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $18c4f9e6a0e81b69$var$eg = null;
            $18c4f9e6a0e81b69$var$fg = !1;
        } catch (e) {
            throw null !== $18c4f9e6a0e81b69$var$eg && ($18c4f9e6a0e81b69$var$eg = $18c4f9e6a0e81b69$var$eg.slice(a + 1)), $18c4f9e6a0e81b69$var$ac($18c4f9e6a0e81b69$var$fc, $18c4f9e6a0e81b69$var$jg), e;
        } finally{
            $18c4f9e6a0e81b69$var$C = b, $18c4f9e6a0e81b69$var$gg = !1;
        }
    }
    return null;
}
var $18c4f9e6a0e81b69$var$kg = [], $18c4f9e6a0e81b69$var$lg = 0, $18c4f9e6a0e81b69$var$mg = null, $18c4f9e6a0e81b69$var$ng = 0, $18c4f9e6a0e81b69$var$og = [], $18c4f9e6a0e81b69$var$pg = 0, $18c4f9e6a0e81b69$var$qg = null, $18c4f9e6a0e81b69$var$rg = 1, $18c4f9e6a0e81b69$var$sg = "";
function $18c4f9e6a0e81b69$var$tg(a, b) {
    $18c4f9e6a0e81b69$var$kg[$18c4f9e6a0e81b69$var$lg++] = $18c4f9e6a0e81b69$var$ng;
    $18c4f9e6a0e81b69$var$kg[$18c4f9e6a0e81b69$var$lg++] = $18c4f9e6a0e81b69$var$mg;
    $18c4f9e6a0e81b69$var$mg = a;
    $18c4f9e6a0e81b69$var$ng = b;
}
function $18c4f9e6a0e81b69$var$ug(a, b, c) {
    $18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg++] = $18c4f9e6a0e81b69$var$rg;
    $18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg++] = $18c4f9e6a0e81b69$var$sg;
    $18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg++] = $18c4f9e6a0e81b69$var$qg;
    $18c4f9e6a0e81b69$var$qg = a;
    var d = $18c4f9e6a0e81b69$var$rg;
    a = $18c4f9e6a0e81b69$var$sg;
    var e = 32 - $18c4f9e6a0e81b69$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $18c4f9e6a0e81b69$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $18c4f9e6a0e81b69$var$rg = 1 << 32 - $18c4f9e6a0e81b69$var$oc(b) + e | c << e | d;
        $18c4f9e6a0e81b69$var$sg = f + a;
    } else $18c4f9e6a0e81b69$var$rg = 1 << f | c << e | d, $18c4f9e6a0e81b69$var$sg = a;
}
function $18c4f9e6a0e81b69$var$vg(a) {
    null !== a.return && ($18c4f9e6a0e81b69$var$tg(a, 1), $18c4f9e6a0e81b69$var$ug(a, 1, 0));
}
function $18c4f9e6a0e81b69$var$wg(a) {
    for(; a === $18c4f9e6a0e81b69$var$mg;)$18c4f9e6a0e81b69$var$mg = $18c4f9e6a0e81b69$var$kg[--$18c4f9e6a0e81b69$var$lg], $18c4f9e6a0e81b69$var$kg[$18c4f9e6a0e81b69$var$lg] = null, $18c4f9e6a0e81b69$var$ng = $18c4f9e6a0e81b69$var$kg[--$18c4f9e6a0e81b69$var$lg], $18c4f9e6a0e81b69$var$kg[$18c4f9e6a0e81b69$var$lg] = null;
    for(; a === $18c4f9e6a0e81b69$var$qg;)$18c4f9e6a0e81b69$var$qg = $18c4f9e6a0e81b69$var$og[--$18c4f9e6a0e81b69$var$pg], $18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg] = null, $18c4f9e6a0e81b69$var$sg = $18c4f9e6a0e81b69$var$og[--$18c4f9e6a0e81b69$var$pg], $18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg] = null, $18c4f9e6a0e81b69$var$rg = $18c4f9e6a0e81b69$var$og[--$18c4f9e6a0e81b69$var$pg], $18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg] = null;
}
var $18c4f9e6a0e81b69$var$xg = null, $18c4f9e6a0e81b69$var$yg = null, $18c4f9e6a0e81b69$var$I = !1, $18c4f9e6a0e81b69$var$zg = null;
function $18c4f9e6a0e81b69$var$Ag(a, b) {
    var c = $18c4f9e6a0e81b69$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $18c4f9e6a0e81b69$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $18c4f9e6a0e81b69$var$xg = a, $18c4f9e6a0e81b69$var$yg = $18c4f9e6a0e81b69$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $18c4f9e6a0e81b69$var$xg = a, $18c4f9e6a0e81b69$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $18c4f9e6a0e81b69$var$qg ? {
                id: $18c4f9e6a0e81b69$var$rg,
                overflow: $18c4f9e6a0e81b69$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $18c4f9e6a0e81b69$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $18c4f9e6a0e81b69$var$xg = a, $18c4f9e6a0e81b69$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $18c4f9e6a0e81b69$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $18c4f9e6a0e81b69$var$Eg(a) {
    if ($18c4f9e6a0e81b69$var$I) {
        var b = $18c4f9e6a0e81b69$var$yg;
        if (b) {
            var c = b;
            if (!$18c4f9e6a0e81b69$var$Cg(a, b)) {
                if ($18c4f9e6a0e81b69$var$Dg(a)) throw Error($18c4f9e6a0e81b69$var$p(418));
                b = $18c4f9e6a0e81b69$var$Lf(c.nextSibling);
                var d = $18c4f9e6a0e81b69$var$xg;
                b && $18c4f9e6a0e81b69$var$Cg(a, b) ? $18c4f9e6a0e81b69$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $18c4f9e6a0e81b69$var$I = !1, $18c4f9e6a0e81b69$var$xg = a);
            }
        } else {
            if ($18c4f9e6a0e81b69$var$Dg(a)) throw Error($18c4f9e6a0e81b69$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $18c4f9e6a0e81b69$var$I = !1;
            $18c4f9e6a0e81b69$var$xg = a;
        }
    }
}
function $18c4f9e6a0e81b69$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $18c4f9e6a0e81b69$var$xg = a;
}
function $18c4f9e6a0e81b69$var$Gg(a) {
    if (a !== $18c4f9e6a0e81b69$var$xg) return !1;
    if (!$18c4f9e6a0e81b69$var$I) return $18c4f9e6a0e81b69$var$Fg(a), $18c4f9e6a0e81b69$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$18c4f9e6a0e81b69$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $18c4f9e6a0e81b69$var$yg)) {
        if ($18c4f9e6a0e81b69$var$Dg(a)) throw $18c4f9e6a0e81b69$var$Hg(), Error($18c4f9e6a0e81b69$var$p(418));
        for(; b;)$18c4f9e6a0e81b69$var$Ag(a, b), b = $18c4f9e6a0e81b69$var$Lf(b.nextSibling);
    }
    $18c4f9e6a0e81b69$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($18c4f9e6a0e81b69$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $18c4f9e6a0e81b69$var$yg = $18c4f9e6a0e81b69$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $18c4f9e6a0e81b69$var$yg = null;
        }
    } else $18c4f9e6a0e81b69$var$yg = $18c4f9e6a0e81b69$var$xg ? $18c4f9e6a0e81b69$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $18c4f9e6a0e81b69$var$Hg() {
    for(var a = $18c4f9e6a0e81b69$var$yg; a;)a = $18c4f9e6a0e81b69$var$Lf(a.nextSibling);
}
function $18c4f9e6a0e81b69$var$Ig() {
    $18c4f9e6a0e81b69$var$yg = $18c4f9e6a0e81b69$var$xg = null;
    $18c4f9e6a0e81b69$var$I = !1;
}
function $18c4f9e6a0e81b69$var$Jg(a) {
    null === $18c4f9e6a0e81b69$var$zg ? $18c4f9e6a0e81b69$var$zg = [
        a
    ] : $18c4f9e6a0e81b69$var$zg.push(a);
}
var $18c4f9e6a0e81b69$var$Kg = $18c4f9e6a0e81b69$var$ua.ReactCurrentBatchConfig;
function $18c4f9e6a0e81b69$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($18c4f9e6a0e81b69$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($18c4f9e6a0e81b69$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($18c4f9e6a0e81b69$var$p(284));
        if (!c._owner) throw Error($18c4f9e6a0e81b69$var$p(290, a));
    }
    return a;
}
function $18c4f9e6a0e81b69$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($18c4f9e6a0e81b69$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $18c4f9e6a0e81b69$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $18c4f9e6a0e81b69$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $18c4f9e6a0e81b69$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $18c4f9e6a0e81b69$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $18c4f9e6a0e81b69$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $18c4f9e6a0e81b69$var$Ha && $18c4f9e6a0e81b69$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $18c4f9e6a0e81b69$var$Lg(a, b, c), d.return = a, d;
        d = $18c4f9e6a0e81b69$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $18c4f9e6a0e81b69$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $18c4f9e6a0e81b69$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $18c4f9e6a0e81b69$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $18c4f9e6a0e81b69$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $18c4f9e6a0e81b69$var$va:
                    return c = $18c4f9e6a0e81b69$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $18c4f9e6a0e81b69$var$Lg(a, null, b), c.return = a, c;
                case $18c4f9e6a0e81b69$var$wa:
                    return b = $18c4f9e6a0e81b69$var$Sg(b, a.mode, c), b.return = a, b;
                case $18c4f9e6a0e81b69$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($18c4f9e6a0e81b69$var$eb(b) || $18c4f9e6a0e81b69$var$Ka(b)) return b = $18c4f9e6a0e81b69$var$Tg(b, a.mode, c, null), b.return = a, b;
            $18c4f9e6a0e81b69$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $18c4f9e6a0e81b69$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $18c4f9e6a0e81b69$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $18c4f9e6a0e81b69$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($18c4f9e6a0e81b69$var$eb(c) || $18c4f9e6a0e81b69$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $18c4f9e6a0e81b69$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $18c4f9e6a0e81b69$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $18c4f9e6a0e81b69$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $18c4f9e6a0e81b69$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($18c4f9e6a0e81b69$var$eb(d) || $18c4f9e6a0e81b69$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $18c4f9e6a0e81b69$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $18c4f9e6a0e81b69$var$I && $18c4f9e6a0e81b69$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $18c4f9e6a0e81b69$var$I && $18c4f9e6a0e81b69$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $18c4f9e6a0e81b69$var$I && $18c4f9e6a0e81b69$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $18c4f9e6a0e81b69$var$Ka(h);
        if ("function" !== typeof l) throw Error($18c4f9e6a0e81b69$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($18c4f9e6a0e81b69$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $18c4f9e6a0e81b69$var$I && $18c4f9e6a0e81b69$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $18c4f9e6a0e81b69$var$I && $18c4f9e6a0e81b69$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $18c4f9e6a0e81b69$var$I && $18c4f9e6a0e81b69$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $18c4f9e6a0e81b69$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $18c4f9e6a0e81b69$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $18c4f9e6a0e81b69$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $18c4f9e6a0e81b69$var$Ha && $18c4f9e6a0e81b69$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $18c4f9e6a0e81b69$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $18c4f9e6a0e81b69$var$ya ? (d = $18c4f9e6a0e81b69$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $18c4f9e6a0e81b69$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $18c4f9e6a0e81b69$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $18c4f9e6a0e81b69$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $18c4f9e6a0e81b69$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $18c4f9e6a0e81b69$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($18c4f9e6a0e81b69$var$eb(f)) return n(a, d, f, h);
            if ($18c4f9e6a0e81b69$var$Ka(f)) return t(a, d, f, h);
            $18c4f9e6a0e81b69$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $18c4f9e6a0e81b69$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $18c4f9e6a0e81b69$var$Ug = $18c4f9e6a0e81b69$var$Og(!0), $18c4f9e6a0e81b69$var$Vg = $18c4f9e6a0e81b69$var$Og(!1), $18c4f9e6a0e81b69$var$Wg = $18c4f9e6a0e81b69$var$Uf(null), $18c4f9e6a0e81b69$var$Xg = null, $18c4f9e6a0e81b69$var$Yg = null, $18c4f9e6a0e81b69$var$Zg = null;
function $18c4f9e6a0e81b69$var$$g() {
    $18c4f9e6a0e81b69$var$Zg = $18c4f9e6a0e81b69$var$Yg = $18c4f9e6a0e81b69$var$Xg = null;
}
function $18c4f9e6a0e81b69$var$ah(a) {
    var b = $18c4f9e6a0e81b69$var$Wg.current;
    $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$Wg);
    a._currentValue = b;
}
function $18c4f9e6a0e81b69$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $18c4f9e6a0e81b69$var$ch(a, b) {
    $18c4f9e6a0e81b69$var$Xg = a;
    $18c4f9e6a0e81b69$var$Zg = $18c4f9e6a0e81b69$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($18c4f9e6a0e81b69$var$dh = !0), a.firstContext = null);
}
function $18c4f9e6a0e81b69$var$eh(a) {
    var b = a._currentValue;
    if ($18c4f9e6a0e81b69$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $18c4f9e6a0e81b69$var$Yg) {
            if (null === $18c4f9e6a0e81b69$var$Xg) throw Error($18c4f9e6a0e81b69$var$p(308));
            $18c4f9e6a0e81b69$var$Yg = a;
            $18c4f9e6a0e81b69$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $18c4f9e6a0e81b69$var$Yg = $18c4f9e6a0e81b69$var$Yg.next = a;
    }
    return b;
}
var $18c4f9e6a0e81b69$var$fh = null;
function $18c4f9e6a0e81b69$var$gh(a) {
    null === $18c4f9e6a0e81b69$var$fh ? $18c4f9e6a0e81b69$var$fh = [
        a
    ] : $18c4f9e6a0e81b69$var$fh.push(a);
}
function $18c4f9e6a0e81b69$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $18c4f9e6a0e81b69$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $18c4f9e6a0e81b69$var$ih(a, d);
}
function $18c4f9e6a0e81b69$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $18c4f9e6a0e81b69$var$jh = !1;
function $18c4f9e6a0e81b69$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $18c4f9e6a0e81b69$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $18c4f9e6a0e81b69$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $18c4f9e6a0e81b69$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($18c4f9e6a0e81b69$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $18c4f9e6a0e81b69$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $18c4f9e6a0e81b69$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $18c4f9e6a0e81b69$var$ih(a, c);
}
function $18c4f9e6a0e81b69$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $18c4f9e6a0e81b69$var$Cc(a, c);
    }
}
function $18c4f9e6a0e81b69$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $18c4f9e6a0e81b69$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $18c4f9e6a0e81b69$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $18c4f9e6a0e81b69$var$A({}, q, r);
                            break a;
                        case 2:
                            $18c4f9e6a0e81b69$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $18c4f9e6a0e81b69$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $18c4f9e6a0e81b69$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($18c4f9e6a0e81b69$var$p(191, e));
            e.call(d);
        }
    }
}
var $18c4f9e6a0e81b69$var$th = {}, $18c4f9e6a0e81b69$var$uh = $18c4f9e6a0e81b69$var$Uf($18c4f9e6a0e81b69$var$th), $18c4f9e6a0e81b69$var$vh = $18c4f9e6a0e81b69$var$Uf($18c4f9e6a0e81b69$var$th), $18c4f9e6a0e81b69$var$wh = $18c4f9e6a0e81b69$var$Uf($18c4f9e6a0e81b69$var$th);
function $18c4f9e6a0e81b69$var$xh(a) {
    if (a === $18c4f9e6a0e81b69$var$th) throw Error($18c4f9e6a0e81b69$var$p(174));
    return a;
}
function $18c4f9e6a0e81b69$var$yh(a, b) {
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$wh, b);
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$vh, a);
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$uh, $18c4f9e6a0e81b69$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $18c4f9e6a0e81b69$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $18c4f9e6a0e81b69$var$lb(b, a);
    }
    $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$uh);
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$uh, b);
}
function $18c4f9e6a0e81b69$var$zh() {
    $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$uh);
    $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$vh);
    $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$wh);
}
function $18c4f9e6a0e81b69$var$Ah(a) {
    $18c4f9e6a0e81b69$var$xh($18c4f9e6a0e81b69$var$wh.current);
    var b = $18c4f9e6a0e81b69$var$xh($18c4f9e6a0e81b69$var$uh.current);
    var c = $18c4f9e6a0e81b69$var$lb(b, a.type);
    b !== c && ($18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$vh, a), $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$uh, c));
}
function $18c4f9e6a0e81b69$var$Bh(a) {
    $18c4f9e6a0e81b69$var$vh.current === a && ($18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$uh), $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$vh));
}
var $18c4f9e6a0e81b69$var$L = $18c4f9e6a0e81b69$var$Uf(0);
function $18c4f9e6a0e81b69$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $18c4f9e6a0e81b69$var$Dh = [];
function $18c4f9e6a0e81b69$var$Eh() {
    for(var a = 0; a < $18c4f9e6a0e81b69$var$Dh.length; a++)$18c4f9e6a0e81b69$var$Dh[a]._workInProgressVersionPrimary = null;
    $18c4f9e6a0e81b69$var$Dh.length = 0;
}
var $18c4f9e6a0e81b69$var$Fh = $18c4f9e6a0e81b69$var$ua.ReactCurrentDispatcher, $18c4f9e6a0e81b69$var$Gh = $18c4f9e6a0e81b69$var$ua.ReactCurrentBatchConfig, $18c4f9e6a0e81b69$var$Hh = 0, $18c4f9e6a0e81b69$var$M = null, $18c4f9e6a0e81b69$var$N = null, $18c4f9e6a0e81b69$var$O = null, $18c4f9e6a0e81b69$var$Ih = !1, $18c4f9e6a0e81b69$var$Jh = !1, $18c4f9e6a0e81b69$var$Kh = 0, $18c4f9e6a0e81b69$var$Lh = 0;
function $18c4f9e6a0e81b69$var$P() {
    throw Error($18c4f9e6a0e81b69$var$p(321));
}
function $18c4f9e6a0e81b69$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$18c4f9e6a0e81b69$var$He(a[c], b[c])) return !1;
    return !0;
}
function $18c4f9e6a0e81b69$var$Nh(a, b, c, d, e, f) {
    $18c4f9e6a0e81b69$var$Hh = f;
    $18c4f9e6a0e81b69$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $18c4f9e6a0e81b69$var$Fh.current = null === a || null === a.memoizedState ? $18c4f9e6a0e81b69$var$Oh : $18c4f9e6a0e81b69$var$Ph;
    a = c(d, e);
    if ($18c4f9e6a0e81b69$var$Jh) {
        f = 0;
        do {
            $18c4f9e6a0e81b69$var$Jh = !1;
            $18c4f9e6a0e81b69$var$Kh = 0;
            if (25 <= f) throw Error($18c4f9e6a0e81b69$var$p(301));
            f += 1;
            $18c4f9e6a0e81b69$var$O = $18c4f9e6a0e81b69$var$N = null;
            b.updateQueue = null;
            $18c4f9e6a0e81b69$var$Fh.current = $18c4f9e6a0e81b69$var$Qh;
            a = c(d, e);
        }while ($18c4f9e6a0e81b69$var$Jh);
    }
    $18c4f9e6a0e81b69$var$Fh.current = $18c4f9e6a0e81b69$var$Rh;
    b = null !== $18c4f9e6a0e81b69$var$N && null !== $18c4f9e6a0e81b69$var$N.next;
    $18c4f9e6a0e81b69$var$Hh = 0;
    $18c4f9e6a0e81b69$var$O = $18c4f9e6a0e81b69$var$N = $18c4f9e6a0e81b69$var$M = null;
    $18c4f9e6a0e81b69$var$Ih = !1;
    if (b) throw Error($18c4f9e6a0e81b69$var$p(300));
    return a;
}
function $18c4f9e6a0e81b69$var$Sh() {
    var a = 0 !== $18c4f9e6a0e81b69$var$Kh;
    $18c4f9e6a0e81b69$var$Kh = 0;
    return a;
}
function $18c4f9e6a0e81b69$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $18c4f9e6a0e81b69$var$O ? $18c4f9e6a0e81b69$var$M.memoizedState = $18c4f9e6a0e81b69$var$O = a : $18c4f9e6a0e81b69$var$O = $18c4f9e6a0e81b69$var$O.next = a;
    return $18c4f9e6a0e81b69$var$O;
}
function $18c4f9e6a0e81b69$var$Uh() {
    if (null === $18c4f9e6a0e81b69$var$N) {
        var a = $18c4f9e6a0e81b69$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $18c4f9e6a0e81b69$var$N.next;
    var b = null === $18c4f9e6a0e81b69$var$O ? $18c4f9e6a0e81b69$var$M.memoizedState : $18c4f9e6a0e81b69$var$O.next;
    if (null !== b) $18c4f9e6a0e81b69$var$O = b, $18c4f9e6a0e81b69$var$N = a;
    else {
        if (null === a) throw Error($18c4f9e6a0e81b69$var$p(310));
        $18c4f9e6a0e81b69$var$N = a;
        a = {
            memoizedState: $18c4f9e6a0e81b69$var$N.memoizedState,
            baseState: $18c4f9e6a0e81b69$var$N.baseState,
            baseQueue: $18c4f9e6a0e81b69$var$N.baseQueue,
            queue: $18c4f9e6a0e81b69$var$N.queue,
            next: null
        };
        null === $18c4f9e6a0e81b69$var$O ? $18c4f9e6a0e81b69$var$M.memoizedState = $18c4f9e6a0e81b69$var$O = a : $18c4f9e6a0e81b69$var$O = $18c4f9e6a0e81b69$var$O.next = a;
    }
    return $18c4f9e6a0e81b69$var$O;
}
function $18c4f9e6a0e81b69$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $18c4f9e6a0e81b69$var$Wh(a) {
    var b = $18c4f9e6a0e81b69$var$Uh(), c = b.queue;
    if (null === c) throw Error($18c4f9e6a0e81b69$var$p(311));
    c.lastRenderedReducer = a;
    var d = $18c4f9e6a0e81b69$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($18c4f9e6a0e81b69$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $18c4f9e6a0e81b69$var$M.lanes |= m;
                $18c4f9e6a0e81b69$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $18c4f9e6a0e81b69$var$He(d, b.memoizedState) || ($18c4f9e6a0e81b69$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $18c4f9e6a0e81b69$var$M.lanes |= f, $18c4f9e6a0e81b69$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $18c4f9e6a0e81b69$var$Xh(a) {
    var b = $18c4f9e6a0e81b69$var$Uh(), c = b.queue;
    if (null === c) throw Error($18c4f9e6a0e81b69$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $18c4f9e6a0e81b69$var$He(f, b.memoizedState) || ($18c4f9e6a0e81b69$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $18c4f9e6a0e81b69$var$Yh() {}
function $18c4f9e6a0e81b69$var$Zh(a, b) {
    var c = $18c4f9e6a0e81b69$var$M, d = $18c4f9e6a0e81b69$var$Uh(), e = b(), f = !$18c4f9e6a0e81b69$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $18c4f9e6a0e81b69$var$dh = !0);
    d = d.queue;
    $18c4f9e6a0e81b69$var$$h($18c4f9e6a0e81b69$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $18c4f9e6a0e81b69$var$O && $18c4f9e6a0e81b69$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $18c4f9e6a0e81b69$var$bi(9, $18c4f9e6a0e81b69$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $18c4f9e6a0e81b69$var$Q) throw Error($18c4f9e6a0e81b69$var$p(349));
        0 !== ($18c4f9e6a0e81b69$var$Hh & 30) || $18c4f9e6a0e81b69$var$di(c, b, e);
    }
    return e;
}
function $18c4f9e6a0e81b69$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $18c4f9e6a0e81b69$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $18c4f9e6a0e81b69$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $18c4f9e6a0e81b69$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $18c4f9e6a0e81b69$var$ei(b) && $18c4f9e6a0e81b69$var$fi(a);
}
function $18c4f9e6a0e81b69$var$ai(a, b, c) {
    return c(function() {
        $18c4f9e6a0e81b69$var$ei(b) && $18c4f9e6a0e81b69$var$fi(a);
    });
}
function $18c4f9e6a0e81b69$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$18c4f9e6a0e81b69$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $18c4f9e6a0e81b69$var$fi(a) {
    var b = $18c4f9e6a0e81b69$var$ih(a, 1);
    null !== b && $18c4f9e6a0e81b69$var$gi(b, a, 1, -1);
}
function $18c4f9e6a0e81b69$var$hi(a) {
    var b = $18c4f9e6a0e81b69$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $18c4f9e6a0e81b69$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $18c4f9e6a0e81b69$var$ii.bind(null, $18c4f9e6a0e81b69$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $18c4f9e6a0e81b69$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $18c4f9e6a0e81b69$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $18c4f9e6a0e81b69$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $18c4f9e6a0e81b69$var$ji() {
    return $18c4f9e6a0e81b69$var$Uh().memoizedState;
}
function $18c4f9e6a0e81b69$var$ki(a, b, c, d) {
    var e = $18c4f9e6a0e81b69$var$Th();
    $18c4f9e6a0e81b69$var$M.flags |= a;
    e.memoizedState = $18c4f9e6a0e81b69$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $18c4f9e6a0e81b69$var$li(a, b, c, d) {
    var e = $18c4f9e6a0e81b69$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $18c4f9e6a0e81b69$var$N) {
        var g = $18c4f9e6a0e81b69$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $18c4f9e6a0e81b69$var$Mh(d, g.deps)) {
            e.memoizedState = $18c4f9e6a0e81b69$var$bi(b, c, f, d);
            return;
        }
    }
    $18c4f9e6a0e81b69$var$M.flags |= a;
    e.memoizedState = $18c4f9e6a0e81b69$var$bi(1 | b, c, f, d);
}
function $18c4f9e6a0e81b69$var$mi(a, b) {
    return $18c4f9e6a0e81b69$var$ki(8390656, 8, a, b);
}
function $18c4f9e6a0e81b69$var$$h(a, b) {
    return $18c4f9e6a0e81b69$var$li(2048, 8, a, b);
}
function $18c4f9e6a0e81b69$var$ni(a, b) {
    return $18c4f9e6a0e81b69$var$li(4, 2, a, b);
}
function $18c4f9e6a0e81b69$var$oi(a, b) {
    return $18c4f9e6a0e81b69$var$li(4, 4, a, b);
}
function $18c4f9e6a0e81b69$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $18c4f9e6a0e81b69$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $18c4f9e6a0e81b69$var$li(4, 4, $18c4f9e6a0e81b69$var$pi.bind(null, b, a), c);
}
function $18c4f9e6a0e81b69$var$ri() {}
function $18c4f9e6a0e81b69$var$si(a, b) {
    var c = $18c4f9e6a0e81b69$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $18c4f9e6a0e81b69$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $18c4f9e6a0e81b69$var$ti(a, b) {
    var c = $18c4f9e6a0e81b69$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $18c4f9e6a0e81b69$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $18c4f9e6a0e81b69$var$ui(a, b, c) {
    if (0 === ($18c4f9e6a0e81b69$var$Hh & 21)) return a.baseState && (a.baseState = !1, $18c4f9e6a0e81b69$var$dh = !0), a.memoizedState = c;
    $18c4f9e6a0e81b69$var$He(c, b) || (c = $18c4f9e6a0e81b69$var$yc(), $18c4f9e6a0e81b69$var$M.lanes |= c, $18c4f9e6a0e81b69$var$rh |= c, a.baseState = !0);
    return b;
}
function $18c4f9e6a0e81b69$var$vi(a, b) {
    var c = $18c4f9e6a0e81b69$var$C;
    $18c4f9e6a0e81b69$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $18c4f9e6a0e81b69$var$Gh.transition;
    $18c4f9e6a0e81b69$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $18c4f9e6a0e81b69$var$C = c, $18c4f9e6a0e81b69$var$Gh.transition = d;
    }
}
function $18c4f9e6a0e81b69$var$wi() {
    return $18c4f9e6a0e81b69$var$Uh().memoizedState;
}
function $18c4f9e6a0e81b69$var$xi(a, b, c) {
    var d = $18c4f9e6a0e81b69$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($18c4f9e6a0e81b69$var$zi(a)) $18c4f9e6a0e81b69$var$Ai(b, c);
    else if (c = $18c4f9e6a0e81b69$var$hh(a, b, c, d), null !== c) {
        var e = $18c4f9e6a0e81b69$var$R();
        $18c4f9e6a0e81b69$var$gi(c, a, d, e);
        $18c4f9e6a0e81b69$var$Bi(c, b, d);
    }
}
function $18c4f9e6a0e81b69$var$ii(a, b, c) {
    var d = $18c4f9e6a0e81b69$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($18c4f9e6a0e81b69$var$zi(a)) $18c4f9e6a0e81b69$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($18c4f9e6a0e81b69$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $18c4f9e6a0e81b69$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $18c4f9e6a0e81b69$var$hh(a, b, e, d);
        null !== c && (e = $18c4f9e6a0e81b69$var$R(), $18c4f9e6a0e81b69$var$gi(c, a, d, e), $18c4f9e6a0e81b69$var$Bi(c, b, d));
    }
}
function $18c4f9e6a0e81b69$var$zi(a) {
    var b = a.alternate;
    return a === $18c4f9e6a0e81b69$var$M || null !== b && b === $18c4f9e6a0e81b69$var$M;
}
function $18c4f9e6a0e81b69$var$Ai(a, b) {
    $18c4f9e6a0e81b69$var$Jh = $18c4f9e6a0e81b69$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $18c4f9e6a0e81b69$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $18c4f9e6a0e81b69$var$Cc(a, c);
    }
}
var $18c4f9e6a0e81b69$var$Rh = {
    readContext: $18c4f9e6a0e81b69$var$eh,
    useCallback: $18c4f9e6a0e81b69$var$P,
    useContext: $18c4f9e6a0e81b69$var$P,
    useEffect: $18c4f9e6a0e81b69$var$P,
    useImperativeHandle: $18c4f9e6a0e81b69$var$P,
    useInsertionEffect: $18c4f9e6a0e81b69$var$P,
    useLayoutEffect: $18c4f9e6a0e81b69$var$P,
    useMemo: $18c4f9e6a0e81b69$var$P,
    useReducer: $18c4f9e6a0e81b69$var$P,
    useRef: $18c4f9e6a0e81b69$var$P,
    useState: $18c4f9e6a0e81b69$var$P,
    useDebugValue: $18c4f9e6a0e81b69$var$P,
    useDeferredValue: $18c4f9e6a0e81b69$var$P,
    useTransition: $18c4f9e6a0e81b69$var$P,
    useMutableSource: $18c4f9e6a0e81b69$var$P,
    useSyncExternalStore: $18c4f9e6a0e81b69$var$P,
    useId: $18c4f9e6a0e81b69$var$P,
    unstable_isNewReconciler: !1
}, $18c4f9e6a0e81b69$var$Oh = {
    readContext: $18c4f9e6a0e81b69$var$eh,
    useCallback: function(a, b) {
        $18c4f9e6a0e81b69$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $18c4f9e6a0e81b69$var$eh,
    useEffect: $18c4f9e6a0e81b69$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $18c4f9e6a0e81b69$var$ki(4194308, 4, $18c4f9e6a0e81b69$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $18c4f9e6a0e81b69$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $18c4f9e6a0e81b69$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $18c4f9e6a0e81b69$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $18c4f9e6a0e81b69$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $18c4f9e6a0e81b69$var$xi.bind(null, $18c4f9e6a0e81b69$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $18c4f9e6a0e81b69$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $18c4f9e6a0e81b69$var$hi,
    useDebugValue: $18c4f9e6a0e81b69$var$ri,
    useDeferredValue: function(a) {
        return $18c4f9e6a0e81b69$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $18c4f9e6a0e81b69$var$hi(!1), b = a[0];
        a = $18c4f9e6a0e81b69$var$vi.bind(null, a[1]);
        $18c4f9e6a0e81b69$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $18c4f9e6a0e81b69$var$M, e = $18c4f9e6a0e81b69$var$Th();
        if ($18c4f9e6a0e81b69$var$I) {
            if (void 0 === c) throw Error($18c4f9e6a0e81b69$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $18c4f9e6a0e81b69$var$Q) throw Error($18c4f9e6a0e81b69$var$p(349));
            0 !== ($18c4f9e6a0e81b69$var$Hh & 30) || $18c4f9e6a0e81b69$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $18c4f9e6a0e81b69$var$mi($18c4f9e6a0e81b69$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $18c4f9e6a0e81b69$var$bi(9, $18c4f9e6a0e81b69$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $18c4f9e6a0e81b69$var$Th(), b = $18c4f9e6a0e81b69$var$Q.identifierPrefix;
        if ($18c4f9e6a0e81b69$var$I) {
            var c = $18c4f9e6a0e81b69$var$sg;
            var d = $18c4f9e6a0e81b69$var$rg;
            c = (d & ~(1 << 32 - $18c4f9e6a0e81b69$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $18c4f9e6a0e81b69$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $18c4f9e6a0e81b69$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $18c4f9e6a0e81b69$var$Ph = {
    readContext: $18c4f9e6a0e81b69$var$eh,
    useCallback: $18c4f9e6a0e81b69$var$si,
    useContext: $18c4f9e6a0e81b69$var$eh,
    useEffect: $18c4f9e6a0e81b69$var$$h,
    useImperativeHandle: $18c4f9e6a0e81b69$var$qi,
    useInsertionEffect: $18c4f9e6a0e81b69$var$ni,
    useLayoutEffect: $18c4f9e6a0e81b69$var$oi,
    useMemo: $18c4f9e6a0e81b69$var$ti,
    useReducer: $18c4f9e6a0e81b69$var$Wh,
    useRef: $18c4f9e6a0e81b69$var$ji,
    useState: function() {
        return $18c4f9e6a0e81b69$var$Wh($18c4f9e6a0e81b69$var$Vh);
    },
    useDebugValue: $18c4f9e6a0e81b69$var$ri,
    useDeferredValue: function(a) {
        var b = $18c4f9e6a0e81b69$var$Uh();
        return $18c4f9e6a0e81b69$var$ui(b, $18c4f9e6a0e81b69$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $18c4f9e6a0e81b69$var$Wh($18c4f9e6a0e81b69$var$Vh)[0], b = $18c4f9e6a0e81b69$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $18c4f9e6a0e81b69$var$Yh,
    useSyncExternalStore: $18c4f9e6a0e81b69$var$Zh,
    useId: $18c4f9e6a0e81b69$var$wi,
    unstable_isNewReconciler: !1
}, $18c4f9e6a0e81b69$var$Qh = {
    readContext: $18c4f9e6a0e81b69$var$eh,
    useCallback: $18c4f9e6a0e81b69$var$si,
    useContext: $18c4f9e6a0e81b69$var$eh,
    useEffect: $18c4f9e6a0e81b69$var$$h,
    useImperativeHandle: $18c4f9e6a0e81b69$var$qi,
    useInsertionEffect: $18c4f9e6a0e81b69$var$ni,
    useLayoutEffect: $18c4f9e6a0e81b69$var$oi,
    useMemo: $18c4f9e6a0e81b69$var$ti,
    useReducer: $18c4f9e6a0e81b69$var$Xh,
    useRef: $18c4f9e6a0e81b69$var$ji,
    useState: function() {
        return $18c4f9e6a0e81b69$var$Xh($18c4f9e6a0e81b69$var$Vh);
    },
    useDebugValue: $18c4f9e6a0e81b69$var$ri,
    useDeferredValue: function(a) {
        var b = $18c4f9e6a0e81b69$var$Uh();
        return null === $18c4f9e6a0e81b69$var$N ? b.memoizedState = a : $18c4f9e6a0e81b69$var$ui(b, $18c4f9e6a0e81b69$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $18c4f9e6a0e81b69$var$Xh($18c4f9e6a0e81b69$var$Vh)[0], b = $18c4f9e6a0e81b69$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $18c4f9e6a0e81b69$var$Yh,
    useSyncExternalStore: $18c4f9e6a0e81b69$var$Zh,
    useId: $18c4f9e6a0e81b69$var$wi,
    unstable_isNewReconciler: !1
};
function $18c4f9e6a0e81b69$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $18c4f9e6a0e81b69$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $18c4f9e6a0e81b69$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $18c4f9e6a0e81b69$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $18c4f9e6a0e81b69$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $18c4f9e6a0e81b69$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $18c4f9e6a0e81b69$var$R(), e = $18c4f9e6a0e81b69$var$yi(a), f = $18c4f9e6a0e81b69$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $18c4f9e6a0e81b69$var$nh(a, f, e);
        null !== b && ($18c4f9e6a0e81b69$var$gi(b, a, e, d), $18c4f9e6a0e81b69$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $18c4f9e6a0e81b69$var$R(), e = $18c4f9e6a0e81b69$var$yi(a), f = $18c4f9e6a0e81b69$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $18c4f9e6a0e81b69$var$nh(a, f, e);
        null !== b && ($18c4f9e6a0e81b69$var$gi(b, a, e, d), $18c4f9e6a0e81b69$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $18c4f9e6a0e81b69$var$R(), d = $18c4f9e6a0e81b69$var$yi(a), e = $18c4f9e6a0e81b69$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $18c4f9e6a0e81b69$var$nh(a, e, d);
        null !== b && ($18c4f9e6a0e81b69$var$gi(b, a, d, c), $18c4f9e6a0e81b69$var$oh(b, a, d));
    }
};
function $18c4f9e6a0e81b69$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$18c4f9e6a0e81b69$var$Ie(c, d) || !$18c4f9e6a0e81b69$var$Ie(e, f) : !0;
}
function $18c4f9e6a0e81b69$var$Gi(a, b, c) {
    var d = !1, e = $18c4f9e6a0e81b69$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $18c4f9e6a0e81b69$var$eh(f) : (e = $18c4f9e6a0e81b69$var$Zf(b) ? $18c4f9e6a0e81b69$var$Xf : $18c4f9e6a0e81b69$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $18c4f9e6a0e81b69$var$Yf(a, e) : $18c4f9e6a0e81b69$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $18c4f9e6a0e81b69$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $18c4f9e6a0e81b69$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $18c4f9e6a0e81b69$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $18c4f9e6a0e81b69$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $18c4f9e6a0e81b69$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $18c4f9e6a0e81b69$var$eh(f) : (f = $18c4f9e6a0e81b69$var$Zf(b) ? $18c4f9e6a0e81b69$var$Xf : $18c4f9e6a0e81b69$var$H.current, e.context = $18c4f9e6a0e81b69$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($18c4f9e6a0e81b69$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $18c4f9e6a0e81b69$var$Ei.enqueueReplaceState(e, e.state, null), $18c4f9e6a0e81b69$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $18c4f9e6a0e81b69$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $18c4f9e6a0e81b69$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $18c4f9e6a0e81b69$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $18c4f9e6a0e81b69$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $18c4f9e6a0e81b69$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $18c4f9e6a0e81b69$var$Ni(a, b, c) {
    c = $18c4f9e6a0e81b69$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $18c4f9e6a0e81b69$var$Oi || ($18c4f9e6a0e81b69$var$Oi = !0, $18c4f9e6a0e81b69$var$Pi = d);
        $18c4f9e6a0e81b69$var$Li(a, b);
    };
    return c;
}
function $18c4f9e6a0e81b69$var$Qi(a, b, c) {
    c = $18c4f9e6a0e81b69$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $18c4f9e6a0e81b69$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $18c4f9e6a0e81b69$var$Li(a, b);
        "function" !== typeof d && (null === $18c4f9e6a0e81b69$var$Ri ? $18c4f9e6a0e81b69$var$Ri = new Set([
            this
        ]) : $18c4f9e6a0e81b69$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $18c4f9e6a0e81b69$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $18c4f9e6a0e81b69$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $18c4f9e6a0e81b69$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $18c4f9e6a0e81b69$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $18c4f9e6a0e81b69$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $18c4f9e6a0e81b69$var$mh(-1, 1), b.tag = 2, $18c4f9e6a0e81b69$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $18c4f9e6a0e81b69$var$Wi = $18c4f9e6a0e81b69$var$ua.ReactCurrentOwner, $18c4f9e6a0e81b69$var$dh = !1;
function $18c4f9e6a0e81b69$var$Xi(a, b, c, d) {
    b.child = null === a ? $18c4f9e6a0e81b69$var$Vg(b, null, c, d) : $18c4f9e6a0e81b69$var$Ug(b, a.child, c, d);
}
function $18c4f9e6a0e81b69$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $18c4f9e6a0e81b69$var$ch(b, e);
    d = $18c4f9e6a0e81b69$var$Nh(a, b, c, d, f, e);
    c = $18c4f9e6a0e81b69$var$Sh();
    if (null !== a && !$18c4f9e6a0e81b69$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $18c4f9e6a0e81b69$var$Zi(a, b, e);
    $18c4f9e6a0e81b69$var$I && c && $18c4f9e6a0e81b69$var$vg(b);
    b.flags |= 1;
    $18c4f9e6a0e81b69$var$Xi(a, b, d, e);
    return b.child;
}
function $18c4f9e6a0e81b69$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$18c4f9e6a0e81b69$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $18c4f9e6a0e81b69$var$bj(a, b, f, d, e);
        a = $18c4f9e6a0e81b69$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $18c4f9e6a0e81b69$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $18c4f9e6a0e81b69$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $18c4f9e6a0e81b69$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $18c4f9e6a0e81b69$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($18c4f9e6a0e81b69$var$Ie(f, d) && a.ref === b.ref) {
            if ($18c4f9e6a0e81b69$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($18c4f9e6a0e81b69$var$dh = !0);
            else return b.lanes = a.lanes, $18c4f9e6a0e81b69$var$Zi(a, b, e);
        }
    }
    return $18c4f9e6a0e81b69$var$cj(a, b, c, d, e);
}
function $18c4f9e6a0e81b69$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$ej, $18c4f9e6a0e81b69$var$fj), $18c4f9e6a0e81b69$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$ej, $18c4f9e6a0e81b69$var$fj), $18c4f9e6a0e81b69$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$ej, $18c4f9e6a0e81b69$var$fj);
            $18c4f9e6a0e81b69$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$ej, $18c4f9e6a0e81b69$var$fj), $18c4f9e6a0e81b69$var$fj |= d;
    $18c4f9e6a0e81b69$var$Xi(a, b, e, c);
    return b.child;
}
function $18c4f9e6a0e81b69$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $18c4f9e6a0e81b69$var$cj(a, b, c, d, e) {
    var f = $18c4f9e6a0e81b69$var$Zf(c) ? $18c4f9e6a0e81b69$var$Xf : $18c4f9e6a0e81b69$var$H.current;
    f = $18c4f9e6a0e81b69$var$Yf(b, f);
    $18c4f9e6a0e81b69$var$ch(b, e);
    c = $18c4f9e6a0e81b69$var$Nh(a, b, c, d, f, e);
    d = $18c4f9e6a0e81b69$var$Sh();
    if (null !== a && !$18c4f9e6a0e81b69$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $18c4f9e6a0e81b69$var$Zi(a, b, e);
    $18c4f9e6a0e81b69$var$I && d && $18c4f9e6a0e81b69$var$vg(b);
    b.flags |= 1;
    $18c4f9e6a0e81b69$var$Xi(a, b, c, e);
    return b.child;
}
function $18c4f9e6a0e81b69$var$hj(a, b, c, d, e) {
    if ($18c4f9e6a0e81b69$var$Zf(c)) {
        var f = !0;
        $18c4f9e6a0e81b69$var$cg(b);
    } else f = !1;
    $18c4f9e6a0e81b69$var$ch(b, e);
    if (null === b.stateNode) $18c4f9e6a0e81b69$var$ij(a, b), $18c4f9e6a0e81b69$var$Gi(b, c, d), $18c4f9e6a0e81b69$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $18c4f9e6a0e81b69$var$eh(l) : (l = $18c4f9e6a0e81b69$var$Zf(c) ? $18c4f9e6a0e81b69$var$Xf : $18c4f9e6a0e81b69$var$H.current, l = $18c4f9e6a0e81b69$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $18c4f9e6a0e81b69$var$Hi(b, g, d, l);
        $18c4f9e6a0e81b69$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $18c4f9e6a0e81b69$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $18c4f9e6a0e81b69$var$Wf.current || $18c4f9e6a0e81b69$var$jh ? ("function" === typeof m && ($18c4f9e6a0e81b69$var$Di(b, c, m, d), k = b.memoizedState), (h = $18c4f9e6a0e81b69$var$jh || $18c4f9e6a0e81b69$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $18c4f9e6a0e81b69$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $18c4f9e6a0e81b69$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $18c4f9e6a0e81b69$var$eh(k) : (k = $18c4f9e6a0e81b69$var$Zf(c) ? $18c4f9e6a0e81b69$var$Xf : $18c4f9e6a0e81b69$var$H.current, k = $18c4f9e6a0e81b69$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $18c4f9e6a0e81b69$var$Hi(b, g, d, k);
        $18c4f9e6a0e81b69$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $18c4f9e6a0e81b69$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $18c4f9e6a0e81b69$var$Wf.current || $18c4f9e6a0e81b69$var$jh ? ("function" === typeof y && ($18c4f9e6a0e81b69$var$Di(b, c, y, d), n = b.memoizedState), (l = $18c4f9e6a0e81b69$var$jh || $18c4f9e6a0e81b69$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $18c4f9e6a0e81b69$var$jj(a, b, c, d, f, e);
}
function $18c4f9e6a0e81b69$var$jj(a, b, c, d, e, f) {
    $18c4f9e6a0e81b69$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $18c4f9e6a0e81b69$var$dg(b, c, !1), $18c4f9e6a0e81b69$var$Zi(a, b, f);
    d = b.stateNode;
    $18c4f9e6a0e81b69$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $18c4f9e6a0e81b69$var$Ug(b, a.child, null, f), b.child = $18c4f9e6a0e81b69$var$Ug(b, null, h, f)) : $18c4f9e6a0e81b69$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $18c4f9e6a0e81b69$var$dg(b, c, !0);
    return b.child;
}
function $18c4f9e6a0e81b69$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $18c4f9e6a0e81b69$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $18c4f9e6a0e81b69$var$ag(a, b.context, !1);
    $18c4f9e6a0e81b69$var$yh(a, b.containerInfo);
}
function $18c4f9e6a0e81b69$var$lj(a, b, c, d, e) {
    $18c4f9e6a0e81b69$var$Ig();
    $18c4f9e6a0e81b69$var$Jg(e);
    b.flags |= 256;
    $18c4f9e6a0e81b69$var$Xi(a, b, c, d);
    return b.child;
}
var $18c4f9e6a0e81b69$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $18c4f9e6a0e81b69$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $18c4f9e6a0e81b69$var$oj(a, b, c) {
    var d = b.pendingProps, e = $18c4f9e6a0e81b69$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$L, e & 1);
    if (null === a) {
        $18c4f9e6a0e81b69$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $18c4f9e6a0e81b69$var$pj(g, d, 0, null), a = $18c4f9e6a0e81b69$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $18c4f9e6a0e81b69$var$nj(c), b.memoizedState = $18c4f9e6a0e81b69$var$mj, a) : $18c4f9e6a0e81b69$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $18c4f9e6a0e81b69$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $18c4f9e6a0e81b69$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $18c4f9e6a0e81b69$var$Pg(h, f) : (f = $18c4f9e6a0e81b69$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $18c4f9e6a0e81b69$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $18c4f9e6a0e81b69$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $18c4f9e6a0e81b69$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $18c4f9e6a0e81b69$var$qj(a, b) {
    b = $18c4f9e6a0e81b69$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $18c4f9e6a0e81b69$var$sj(a, b, c, d) {
    null !== d && $18c4f9e6a0e81b69$var$Jg(d);
    $18c4f9e6a0e81b69$var$Ug(b, a.child, null, c);
    a = $18c4f9e6a0e81b69$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $18c4f9e6a0e81b69$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $18c4f9e6a0e81b69$var$Ki(Error($18c4f9e6a0e81b69$var$p(422))), $18c4f9e6a0e81b69$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $18c4f9e6a0e81b69$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $18c4f9e6a0e81b69$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $18c4f9e6a0e81b69$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $18c4f9e6a0e81b69$var$nj(g);
        b.memoizedState = $18c4f9e6a0e81b69$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $18c4f9e6a0e81b69$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($18c4f9e6a0e81b69$var$p(419));
        d = $18c4f9e6a0e81b69$var$Ki(f, d, void 0);
        return $18c4f9e6a0e81b69$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($18c4f9e6a0e81b69$var$dh || h) {
        d = $18c4f9e6a0e81b69$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $18c4f9e6a0e81b69$var$ih(a, e), $18c4f9e6a0e81b69$var$gi(d, a, e, -1));
        }
        $18c4f9e6a0e81b69$var$tj();
        d = $18c4f9e6a0e81b69$var$Ki(Error($18c4f9e6a0e81b69$var$p(421)));
        return $18c4f9e6a0e81b69$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $18c4f9e6a0e81b69$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $18c4f9e6a0e81b69$var$yg = $18c4f9e6a0e81b69$var$Lf(e.nextSibling);
    $18c4f9e6a0e81b69$var$xg = b;
    $18c4f9e6a0e81b69$var$I = !0;
    $18c4f9e6a0e81b69$var$zg = null;
    null !== a && ($18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg++] = $18c4f9e6a0e81b69$var$rg, $18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg++] = $18c4f9e6a0e81b69$var$sg, $18c4f9e6a0e81b69$var$og[$18c4f9e6a0e81b69$var$pg++] = $18c4f9e6a0e81b69$var$qg, $18c4f9e6a0e81b69$var$rg = a.id, $18c4f9e6a0e81b69$var$sg = a.overflow, $18c4f9e6a0e81b69$var$qg = b);
    b = $18c4f9e6a0e81b69$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $18c4f9e6a0e81b69$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $18c4f9e6a0e81b69$var$bh(a.return, b, c);
}
function $18c4f9e6a0e81b69$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $18c4f9e6a0e81b69$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $18c4f9e6a0e81b69$var$Xi(a, b, d.children, c);
    d = $18c4f9e6a0e81b69$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $18c4f9e6a0e81b69$var$vj(a, c, b);
            else if (19 === a.tag) $18c4f9e6a0e81b69$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $18c4f9e6a0e81b69$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $18c4f9e6a0e81b69$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $18c4f9e6a0e81b69$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $18c4f9e6a0e81b69$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $18c4f9e6a0e81b69$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $18c4f9e6a0e81b69$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $18c4f9e6a0e81b69$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $18c4f9e6a0e81b69$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($18c4f9e6a0e81b69$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $18c4f9e6a0e81b69$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $18c4f9e6a0e81b69$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $18c4f9e6a0e81b69$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $18c4f9e6a0e81b69$var$kj(b);
            $18c4f9e6a0e81b69$var$Ig();
            break;
        case 5:
            $18c4f9e6a0e81b69$var$Ah(b);
            break;
        case 1:
            $18c4f9e6a0e81b69$var$Zf(b.type) && $18c4f9e6a0e81b69$var$cg(b);
            break;
        case 4:
            $18c4f9e6a0e81b69$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$L, $18c4f9e6a0e81b69$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $18c4f9e6a0e81b69$var$oj(a, b, c);
                $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$L, $18c4f9e6a0e81b69$var$L.current & 1);
                a = $18c4f9e6a0e81b69$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$L, $18c4f9e6a0e81b69$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $18c4f9e6a0e81b69$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$L, $18c4f9e6a0e81b69$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $18c4f9e6a0e81b69$var$dj(a, b, c);
    }
    return $18c4f9e6a0e81b69$var$Zi(a, b, c);
}
var $18c4f9e6a0e81b69$var$zj, $18c4f9e6a0e81b69$var$Aj, $18c4f9e6a0e81b69$var$Bj, $18c4f9e6a0e81b69$var$Cj;
$18c4f9e6a0e81b69$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$18c4f9e6a0e81b69$var$Aj = function() {};
$18c4f9e6a0e81b69$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $18c4f9e6a0e81b69$var$xh($18c4f9e6a0e81b69$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $18c4f9e6a0e81b69$var$Ya(a, e);
                d = $18c4f9e6a0e81b69$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $18c4f9e6a0e81b69$var$A({}, e, {
                    value: void 0
                });
                d = $18c4f9e6a0e81b69$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $18c4f9e6a0e81b69$var$gb(a, e);
                d = $18c4f9e6a0e81b69$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $18c4f9e6a0e81b69$var$Bf);
        }
        $18c4f9e6a0e81b69$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($18c4f9e6a0e81b69$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($18c4f9e6a0e81b69$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $18c4f9e6a0e81b69$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$18c4f9e6a0e81b69$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $18c4f9e6a0e81b69$var$Dj(a, b) {
    if (!$18c4f9e6a0e81b69$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $18c4f9e6a0e81b69$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $18c4f9e6a0e81b69$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $18c4f9e6a0e81b69$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $18c4f9e6a0e81b69$var$S(b), null;
        case 1:
            return $18c4f9e6a0e81b69$var$Zf(b.type) && $18c4f9e6a0e81b69$var$$f(), $18c4f9e6a0e81b69$var$S(b), null;
        case 3:
            d = b.stateNode;
            $18c4f9e6a0e81b69$var$zh();
            $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$Wf);
            $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$H);
            $18c4f9e6a0e81b69$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $18c4f9e6a0e81b69$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $18c4f9e6a0e81b69$var$zg && ($18c4f9e6a0e81b69$var$Fj($18c4f9e6a0e81b69$var$zg), $18c4f9e6a0e81b69$var$zg = null));
            $18c4f9e6a0e81b69$var$Aj(a, b);
            $18c4f9e6a0e81b69$var$S(b);
            return null;
        case 5:
            $18c4f9e6a0e81b69$var$Bh(b);
            var e = $18c4f9e6a0e81b69$var$xh($18c4f9e6a0e81b69$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $18c4f9e6a0e81b69$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($18c4f9e6a0e81b69$var$p(166));
                    $18c4f9e6a0e81b69$var$S(b);
                    return null;
                }
                a = $18c4f9e6a0e81b69$var$xh($18c4f9e6a0e81b69$var$uh.current);
                if ($18c4f9e6a0e81b69$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$18c4f9e6a0e81b69$var$Of] = b;
                    d[$18c4f9e6a0e81b69$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $18c4f9e6a0e81b69$var$D("cancel", d);
                            $18c4f9e6a0e81b69$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $18c4f9e6a0e81b69$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $18c4f9e6a0e81b69$var$lf.length; e++)$18c4f9e6a0e81b69$var$D($18c4f9e6a0e81b69$var$lf[e], d);
                            break;
                        case "source":
                            $18c4f9e6a0e81b69$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $18c4f9e6a0e81b69$var$D("error", d);
                            $18c4f9e6a0e81b69$var$D("load", d);
                            break;
                        case "details":
                            $18c4f9e6a0e81b69$var$D("toggle", d);
                            break;
                        case "input":
                            $18c4f9e6a0e81b69$var$Za(d, f);
                            $18c4f9e6a0e81b69$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $18c4f9e6a0e81b69$var$D("invalid", d);
                            break;
                        case "textarea":
                            $18c4f9e6a0e81b69$var$hb(d, f), $18c4f9e6a0e81b69$var$D("invalid", d);
                    }
                    $18c4f9e6a0e81b69$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $18c4f9e6a0e81b69$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $18c4f9e6a0e81b69$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $18c4f9e6a0e81b69$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $18c4f9e6a0e81b69$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $18c4f9e6a0e81b69$var$Va(d);
                            $18c4f9e6a0e81b69$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $18c4f9e6a0e81b69$var$Va(d);
                            $18c4f9e6a0e81b69$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $18c4f9e6a0e81b69$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $18c4f9e6a0e81b69$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$18c4f9e6a0e81b69$var$Of] = b;
                    a[$18c4f9e6a0e81b69$var$Pf] = d;
                    $18c4f9e6a0e81b69$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $18c4f9e6a0e81b69$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $18c4f9e6a0e81b69$var$D("cancel", a);
                                $18c4f9e6a0e81b69$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $18c4f9e6a0e81b69$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $18c4f9e6a0e81b69$var$lf.length; e++)$18c4f9e6a0e81b69$var$D($18c4f9e6a0e81b69$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $18c4f9e6a0e81b69$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $18c4f9e6a0e81b69$var$D("error", a);
                                $18c4f9e6a0e81b69$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $18c4f9e6a0e81b69$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $18c4f9e6a0e81b69$var$Za(a, d);
                                e = $18c4f9e6a0e81b69$var$Ya(a, d);
                                $18c4f9e6a0e81b69$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $18c4f9e6a0e81b69$var$A({}, d, {
                                    value: void 0
                                });
                                $18c4f9e6a0e81b69$var$D("invalid", a);
                                break;
                            case "textarea":
                                $18c4f9e6a0e81b69$var$hb(a, d);
                                e = $18c4f9e6a0e81b69$var$gb(a, d);
                                $18c4f9e6a0e81b69$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $18c4f9e6a0e81b69$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $18c4f9e6a0e81b69$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $18c4f9e6a0e81b69$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $18c4f9e6a0e81b69$var$ob(a, k) : "number" === typeof k && $18c4f9e6a0e81b69$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($18c4f9e6a0e81b69$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $18c4f9e6a0e81b69$var$D("scroll", a) : null != k && $18c4f9e6a0e81b69$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $18c4f9e6a0e81b69$var$Va(a);
                                $18c4f9e6a0e81b69$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $18c4f9e6a0e81b69$var$Va(a);
                                $18c4f9e6a0e81b69$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $18c4f9e6a0e81b69$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $18c4f9e6a0e81b69$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $18c4f9e6a0e81b69$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $18c4f9e6a0e81b69$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $18c4f9e6a0e81b69$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $18c4f9e6a0e81b69$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($18c4f9e6a0e81b69$var$p(166));
                c = $18c4f9e6a0e81b69$var$xh($18c4f9e6a0e81b69$var$wh.current);
                $18c4f9e6a0e81b69$var$xh($18c4f9e6a0e81b69$var$uh.current);
                if ($18c4f9e6a0e81b69$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$18c4f9e6a0e81b69$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $18c4f9e6a0e81b69$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $18c4f9e6a0e81b69$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $18c4f9e6a0e81b69$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$18c4f9e6a0e81b69$var$Of] = b, b.stateNode = d;
            }
            $18c4f9e6a0e81b69$var$S(b);
            return null;
        case 13:
            $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($18c4f9e6a0e81b69$var$I && null !== $18c4f9e6a0e81b69$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $18c4f9e6a0e81b69$var$Hg(), $18c4f9e6a0e81b69$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $18c4f9e6a0e81b69$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($18c4f9e6a0e81b69$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($18c4f9e6a0e81b69$var$p(317));
                        f[$18c4f9e6a0e81b69$var$Of] = b;
                    } else $18c4f9e6a0e81b69$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $18c4f9e6a0e81b69$var$S(b);
                    f = !1;
                } else null !== $18c4f9e6a0e81b69$var$zg && ($18c4f9e6a0e81b69$var$Fj($18c4f9e6a0e81b69$var$zg), $18c4f9e6a0e81b69$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($18c4f9e6a0e81b69$var$L.current & 1) ? 0 === $18c4f9e6a0e81b69$var$T && ($18c4f9e6a0e81b69$var$T = 3) : $18c4f9e6a0e81b69$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $18c4f9e6a0e81b69$var$S(b);
            return null;
        case 4:
            return $18c4f9e6a0e81b69$var$zh(), $18c4f9e6a0e81b69$var$Aj(a, b), null === a && $18c4f9e6a0e81b69$var$sf(b.stateNode.containerInfo), $18c4f9e6a0e81b69$var$S(b), null;
        case 10:
            return $18c4f9e6a0e81b69$var$ah(b.type._context), $18c4f9e6a0e81b69$var$S(b), null;
        case 17:
            return $18c4f9e6a0e81b69$var$Zf(b.type) && $18c4f9e6a0e81b69$var$$f(), $18c4f9e6a0e81b69$var$S(b), null;
        case 19:
            $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$L);
            f = b.memoizedState;
            if (null === f) return $18c4f9e6a0e81b69$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $18c4f9e6a0e81b69$var$Dj(f, !1);
                else {
                    if (0 !== $18c4f9e6a0e81b69$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $18c4f9e6a0e81b69$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $18c4f9e6a0e81b69$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$L, $18c4f9e6a0e81b69$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $18c4f9e6a0e81b69$var$B() > $18c4f9e6a0e81b69$var$Gj && (b.flags |= 128, d = !0, $18c4f9e6a0e81b69$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $18c4f9e6a0e81b69$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $18c4f9e6a0e81b69$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$18c4f9e6a0e81b69$var$I) return $18c4f9e6a0e81b69$var$S(b), null;
                    } else 2 * $18c4f9e6a0e81b69$var$B() - f.renderingStartTime > $18c4f9e6a0e81b69$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $18c4f9e6a0e81b69$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $18c4f9e6a0e81b69$var$B(), b.sibling = null, c = $18c4f9e6a0e81b69$var$L.current, $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$L, d ? c & 1 | 2 : c & 1), b;
            $18c4f9e6a0e81b69$var$S(b);
            return null;
        case 22:
        case 23:
            return $18c4f9e6a0e81b69$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($18c4f9e6a0e81b69$var$fj & 1073741824) && ($18c4f9e6a0e81b69$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $18c4f9e6a0e81b69$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($18c4f9e6a0e81b69$var$p(156, b.tag));
}
function $18c4f9e6a0e81b69$var$Ij(a, b) {
    $18c4f9e6a0e81b69$var$wg(b);
    switch(b.tag){
        case 1:
            return $18c4f9e6a0e81b69$var$Zf(b.type) && $18c4f9e6a0e81b69$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $18c4f9e6a0e81b69$var$zh(), $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$Wf), $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$H), $18c4f9e6a0e81b69$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $18c4f9e6a0e81b69$var$Bh(b), null;
        case 13:
            $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($18c4f9e6a0e81b69$var$p(340));
                $18c4f9e6a0e81b69$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$L), null;
        case 4:
            return $18c4f9e6a0e81b69$var$zh(), null;
        case 10:
            return $18c4f9e6a0e81b69$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $18c4f9e6a0e81b69$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $18c4f9e6a0e81b69$var$Jj = !1, $18c4f9e6a0e81b69$var$U = !1, $18c4f9e6a0e81b69$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $18c4f9e6a0e81b69$var$V = null;
function $18c4f9e6a0e81b69$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $18c4f9e6a0e81b69$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $18c4f9e6a0e81b69$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $18c4f9e6a0e81b69$var$W(a, b, d);
    }
}
var $18c4f9e6a0e81b69$var$Nj = !1;
function $18c4f9e6a0e81b69$var$Oj(a, b) {
    $18c4f9e6a0e81b69$var$Cf = $18c4f9e6a0e81b69$var$dd;
    a = $18c4f9e6a0e81b69$var$Me();
    if ($18c4f9e6a0e81b69$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $18c4f9e6a0e81b69$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $18c4f9e6a0e81b69$var$dd = !1;
    for($18c4f9e6a0e81b69$var$V = b; null !== $18c4f9e6a0e81b69$var$V;)if (b = $18c4f9e6a0e81b69$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $18c4f9e6a0e81b69$var$V = a;
    else for(; null !== $18c4f9e6a0e81b69$var$V;){
        b = $18c4f9e6a0e81b69$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $18c4f9e6a0e81b69$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($18c4f9e6a0e81b69$var$p(163));
            }
        } catch (F) {
            $18c4f9e6a0e81b69$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $18c4f9e6a0e81b69$var$V = a;
            break;
        }
        $18c4f9e6a0e81b69$var$V = b.return;
    }
    n = $18c4f9e6a0e81b69$var$Nj;
    $18c4f9e6a0e81b69$var$Nj = !1;
    return n;
}
function $18c4f9e6a0e81b69$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $18c4f9e6a0e81b69$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $18c4f9e6a0e81b69$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $18c4f9e6a0e81b69$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $18c4f9e6a0e81b69$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $18c4f9e6a0e81b69$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$18c4f9e6a0e81b69$var$Of], delete b[$18c4f9e6a0e81b69$var$Pf], delete b[$18c4f9e6a0e81b69$var$of], delete b[$18c4f9e6a0e81b69$var$Qf], delete b[$18c4f9e6a0e81b69$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $18c4f9e6a0e81b69$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $18c4f9e6a0e81b69$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $18c4f9e6a0e81b69$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $18c4f9e6a0e81b69$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $18c4f9e6a0e81b69$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($18c4f9e6a0e81b69$var$Vj(a, b, c), a = a.sibling; null !== a;)$18c4f9e6a0e81b69$var$Vj(a, b, c), a = a.sibling;
}
function $18c4f9e6a0e81b69$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($18c4f9e6a0e81b69$var$Wj(a, b, c), a = a.sibling; null !== a;)$18c4f9e6a0e81b69$var$Wj(a, b, c), a = a.sibling;
}
var $18c4f9e6a0e81b69$var$X = null, $18c4f9e6a0e81b69$var$Xj = !1;
function $18c4f9e6a0e81b69$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$18c4f9e6a0e81b69$var$Zj(a, b, c), c = c.sibling;
}
function $18c4f9e6a0e81b69$var$Zj(a, b, c) {
    if ($18c4f9e6a0e81b69$var$lc && "function" === typeof $18c4f9e6a0e81b69$var$lc.onCommitFiberUnmount) try {
        $18c4f9e6a0e81b69$var$lc.onCommitFiberUnmount($18c4f9e6a0e81b69$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $18c4f9e6a0e81b69$var$U || $18c4f9e6a0e81b69$var$Lj(c, b);
        case 6:
            var d = $18c4f9e6a0e81b69$var$X, e = $18c4f9e6a0e81b69$var$Xj;
            $18c4f9e6a0e81b69$var$X = null;
            $18c4f9e6a0e81b69$var$Yj(a, b, c);
            $18c4f9e6a0e81b69$var$X = d;
            $18c4f9e6a0e81b69$var$Xj = e;
            null !== $18c4f9e6a0e81b69$var$X && ($18c4f9e6a0e81b69$var$Xj ? (a = $18c4f9e6a0e81b69$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $18c4f9e6a0e81b69$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $18c4f9e6a0e81b69$var$X && ($18c4f9e6a0e81b69$var$Xj ? (a = $18c4f9e6a0e81b69$var$X, c = c.stateNode, 8 === a.nodeType ? $18c4f9e6a0e81b69$var$Kf(a.parentNode, c) : 1 === a.nodeType && $18c4f9e6a0e81b69$var$Kf(a, c), $18c4f9e6a0e81b69$var$bd(a)) : $18c4f9e6a0e81b69$var$Kf($18c4f9e6a0e81b69$var$X, c.stateNode));
            break;
        case 4:
            d = $18c4f9e6a0e81b69$var$X;
            e = $18c4f9e6a0e81b69$var$Xj;
            $18c4f9e6a0e81b69$var$X = c.stateNode.containerInfo;
            $18c4f9e6a0e81b69$var$Xj = !0;
            $18c4f9e6a0e81b69$var$Yj(a, b, c);
            $18c4f9e6a0e81b69$var$X = d;
            $18c4f9e6a0e81b69$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$18c4f9e6a0e81b69$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $18c4f9e6a0e81b69$var$Mj(c, b, g) : 0 !== (f & 4) && $18c4f9e6a0e81b69$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $18c4f9e6a0e81b69$var$Yj(a, b, c);
            break;
        case 1:
            if (!$18c4f9e6a0e81b69$var$U && ($18c4f9e6a0e81b69$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $18c4f9e6a0e81b69$var$W(c, b, h);
            }
            $18c4f9e6a0e81b69$var$Yj(a, b, c);
            break;
        case 21:
            $18c4f9e6a0e81b69$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($18c4f9e6a0e81b69$var$U = (d = $18c4f9e6a0e81b69$var$U) || null !== c.memoizedState, $18c4f9e6a0e81b69$var$Yj(a, b, c), $18c4f9e6a0e81b69$var$U = d) : $18c4f9e6a0e81b69$var$Yj(a, b, c);
            break;
        default:
            $18c4f9e6a0e81b69$var$Yj(a, b, c);
    }
}
function $18c4f9e6a0e81b69$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $18c4f9e6a0e81b69$var$Kj);
        b.forEach(function(b) {
            var d = $18c4f9e6a0e81b69$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $18c4f9e6a0e81b69$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $18c4f9e6a0e81b69$var$X = h.stateNode;
                        $18c4f9e6a0e81b69$var$Xj = !1;
                        break a;
                    case 3:
                        $18c4f9e6a0e81b69$var$X = h.stateNode.containerInfo;
                        $18c4f9e6a0e81b69$var$Xj = !0;
                        break a;
                    case 4:
                        $18c4f9e6a0e81b69$var$X = h.stateNode.containerInfo;
                        $18c4f9e6a0e81b69$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $18c4f9e6a0e81b69$var$X) throw Error($18c4f9e6a0e81b69$var$p(160));
            $18c4f9e6a0e81b69$var$Zj(f, g, e);
            $18c4f9e6a0e81b69$var$X = null;
            $18c4f9e6a0e81b69$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $18c4f9e6a0e81b69$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$18c4f9e6a0e81b69$var$dk(b, a), b = b.sibling;
}
function $18c4f9e6a0e81b69$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            if (d & 4) {
                try {
                    $18c4f9e6a0e81b69$var$Pj(3, a, a.return), $18c4f9e6a0e81b69$var$Qj(3, a);
                } catch (t) {
                    $18c4f9e6a0e81b69$var$W(a, a.return, t);
                }
                try {
                    $18c4f9e6a0e81b69$var$Pj(5, a, a.return);
                } catch (t) {
                    $18c4f9e6a0e81b69$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            d & 512 && null !== c && $18c4f9e6a0e81b69$var$Lj(c, c.return);
            break;
        case 5:
            $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            d & 512 && null !== c && $18c4f9e6a0e81b69$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $18c4f9e6a0e81b69$var$ob(e, "");
                } catch (t) {
                    $18c4f9e6a0e81b69$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $18c4f9e6a0e81b69$var$ab(e, f);
                    $18c4f9e6a0e81b69$var$vb(h, g);
                    var l = $18c4f9e6a0e81b69$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $18c4f9e6a0e81b69$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $18c4f9e6a0e81b69$var$nb(e, q) : "children" === m ? $18c4f9e6a0e81b69$var$ob(e, q) : $18c4f9e6a0e81b69$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $18c4f9e6a0e81b69$var$bb(e, f);
                            break;
                        case "textarea":
                            $18c4f9e6a0e81b69$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $18c4f9e6a0e81b69$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $18c4f9e6a0e81b69$var$fb(e, !!f.multiple, f.defaultValue, !0) : $18c4f9e6a0e81b69$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$18c4f9e6a0e81b69$var$Pf] = f;
                } catch (t) {
                    $18c4f9e6a0e81b69$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($18c4f9e6a0e81b69$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $18c4f9e6a0e81b69$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $18c4f9e6a0e81b69$var$bd(b.containerInfo);
            } catch (t) {
                $18c4f9e6a0e81b69$var$W(a, a.return, t);
            }
            break;
        case 4:
            $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            break;
        case 13:
            $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($18c4f9e6a0e81b69$var$fk = $18c4f9e6a0e81b69$var$B()));
            d & 4 && $18c4f9e6a0e81b69$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($18c4f9e6a0e81b69$var$U = (l = $18c4f9e6a0e81b69$var$U) || m, $18c4f9e6a0e81b69$var$ck(b, a), $18c4f9e6a0e81b69$var$U = l) : $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($18c4f9e6a0e81b69$var$V = a, m = a.child; null !== m;){
                    for(q = $18c4f9e6a0e81b69$var$V = m; null !== $18c4f9e6a0e81b69$var$V;){
                        r = $18c4f9e6a0e81b69$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $18c4f9e6a0e81b69$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $18c4f9e6a0e81b69$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $18c4f9e6a0e81b69$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $18c4f9e6a0e81b69$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $18c4f9e6a0e81b69$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $18c4f9e6a0e81b69$var$V = y) : $18c4f9e6a0e81b69$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $18c4f9e6a0e81b69$var$rb("display", g));
                            } catch (t) {
                                $18c4f9e6a0e81b69$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $18c4f9e6a0e81b69$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $18c4f9e6a0e81b69$var$ck(b, a);
            $18c4f9e6a0e81b69$var$ek(a);
            d & 4 && $18c4f9e6a0e81b69$var$ak(a);
            break;
        case 21:
            break;
        default:
            $18c4f9e6a0e81b69$var$ck(b, a), $18c4f9e6a0e81b69$var$ek(a);
    }
}
function $18c4f9e6a0e81b69$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($18c4f9e6a0e81b69$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($18c4f9e6a0e81b69$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($18c4f9e6a0e81b69$var$ob(e, ""), d.flags &= -33);
                    var f = $18c4f9e6a0e81b69$var$Uj(a);
                    $18c4f9e6a0e81b69$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $18c4f9e6a0e81b69$var$Uj(a);
                    $18c4f9e6a0e81b69$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($18c4f9e6a0e81b69$var$p(161));
            }
        } catch (k) {
            $18c4f9e6a0e81b69$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $18c4f9e6a0e81b69$var$hk(a, b, c) {
    $18c4f9e6a0e81b69$var$V = a;
    $18c4f9e6a0e81b69$var$ik(a, b, c);
}
function $18c4f9e6a0e81b69$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $18c4f9e6a0e81b69$var$V;){
        var e = $18c4f9e6a0e81b69$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $18c4f9e6a0e81b69$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $18c4f9e6a0e81b69$var$U;
                h = $18c4f9e6a0e81b69$var$Jj;
                var l = $18c4f9e6a0e81b69$var$U;
                $18c4f9e6a0e81b69$var$Jj = g;
                if (($18c4f9e6a0e81b69$var$U = k) && !l) for($18c4f9e6a0e81b69$var$V = e; null !== $18c4f9e6a0e81b69$var$V;)g = $18c4f9e6a0e81b69$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $18c4f9e6a0e81b69$var$jk(e) : null !== k ? (k.return = g, $18c4f9e6a0e81b69$var$V = k) : $18c4f9e6a0e81b69$var$jk(e);
                for(; null !== f;)$18c4f9e6a0e81b69$var$V = f, $18c4f9e6a0e81b69$var$ik(f, b, c), f = f.sibling;
                $18c4f9e6a0e81b69$var$V = e;
                $18c4f9e6a0e81b69$var$Jj = h;
                $18c4f9e6a0e81b69$var$U = l;
            }
            $18c4f9e6a0e81b69$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $18c4f9e6a0e81b69$var$V = f) : $18c4f9e6a0e81b69$var$kk(a, b, c);
    }
}
function $18c4f9e6a0e81b69$var$kk(a) {
    for(; null !== $18c4f9e6a0e81b69$var$V;){
        var b = $18c4f9e6a0e81b69$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $18c4f9e6a0e81b69$var$U || $18c4f9e6a0e81b69$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$18c4f9e6a0e81b69$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $18c4f9e6a0e81b69$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $18c4f9e6a0e81b69$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $18c4f9e6a0e81b69$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $18c4f9e6a0e81b69$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($18c4f9e6a0e81b69$var$p(163));
                }
                $18c4f9e6a0e81b69$var$U || b.flags & 512 && $18c4f9e6a0e81b69$var$Rj(b);
            } catch (r) {
                $18c4f9e6a0e81b69$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $18c4f9e6a0e81b69$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $18c4f9e6a0e81b69$var$V = c;
            break;
        }
        $18c4f9e6a0e81b69$var$V = b.return;
    }
}
function $18c4f9e6a0e81b69$var$gk(a) {
    for(; null !== $18c4f9e6a0e81b69$var$V;){
        var b = $18c4f9e6a0e81b69$var$V;
        if (b === a) {
            $18c4f9e6a0e81b69$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $18c4f9e6a0e81b69$var$V = c;
            break;
        }
        $18c4f9e6a0e81b69$var$V = b.return;
    }
}
function $18c4f9e6a0e81b69$var$jk(a) {
    for(; null !== $18c4f9e6a0e81b69$var$V;){
        var b = $18c4f9e6a0e81b69$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $18c4f9e6a0e81b69$var$Qj(4, b);
                    } catch (k) {
                        $18c4f9e6a0e81b69$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $18c4f9e6a0e81b69$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $18c4f9e6a0e81b69$var$Rj(b);
                    } catch (k) {
                        $18c4f9e6a0e81b69$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $18c4f9e6a0e81b69$var$Rj(b);
                    } catch (k) {
                        $18c4f9e6a0e81b69$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $18c4f9e6a0e81b69$var$W(b, b.return, k);
        }
        if (b === a) {
            $18c4f9e6a0e81b69$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $18c4f9e6a0e81b69$var$V = h;
            break;
        }
        $18c4f9e6a0e81b69$var$V = b.return;
    }
}
var $18c4f9e6a0e81b69$var$lk = Math.ceil, $18c4f9e6a0e81b69$var$mk = $18c4f9e6a0e81b69$var$ua.ReactCurrentDispatcher, $18c4f9e6a0e81b69$var$nk = $18c4f9e6a0e81b69$var$ua.ReactCurrentOwner, $18c4f9e6a0e81b69$var$ok = $18c4f9e6a0e81b69$var$ua.ReactCurrentBatchConfig, $18c4f9e6a0e81b69$var$K = 0, $18c4f9e6a0e81b69$var$Q = null, $18c4f9e6a0e81b69$var$Y = null, $18c4f9e6a0e81b69$var$Z = 0, $18c4f9e6a0e81b69$var$fj = 0, $18c4f9e6a0e81b69$var$ej = $18c4f9e6a0e81b69$var$Uf(0), $18c4f9e6a0e81b69$var$T = 0, $18c4f9e6a0e81b69$var$pk = null, $18c4f9e6a0e81b69$var$rh = 0, $18c4f9e6a0e81b69$var$qk = 0, $18c4f9e6a0e81b69$var$rk = 0, $18c4f9e6a0e81b69$var$sk = null, $18c4f9e6a0e81b69$var$tk = null, $18c4f9e6a0e81b69$var$fk = 0, $18c4f9e6a0e81b69$var$Gj = Infinity, $18c4f9e6a0e81b69$var$uk = null, $18c4f9e6a0e81b69$var$Oi = !1, $18c4f9e6a0e81b69$var$Pi = null, $18c4f9e6a0e81b69$var$Ri = null, $18c4f9e6a0e81b69$var$vk = !1, $18c4f9e6a0e81b69$var$wk = null, $18c4f9e6a0e81b69$var$xk = 0, $18c4f9e6a0e81b69$var$yk = 0, $18c4f9e6a0e81b69$var$zk = null, $18c4f9e6a0e81b69$var$Ak = -1, $18c4f9e6a0e81b69$var$Bk = 0;
function $18c4f9e6a0e81b69$var$R() {
    return 0 !== ($18c4f9e6a0e81b69$var$K & 6) ? $18c4f9e6a0e81b69$var$B() : -1 !== $18c4f9e6a0e81b69$var$Ak ? $18c4f9e6a0e81b69$var$Ak : $18c4f9e6a0e81b69$var$Ak = $18c4f9e6a0e81b69$var$B();
}
function $18c4f9e6a0e81b69$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($18c4f9e6a0e81b69$var$K & 2) && 0 !== $18c4f9e6a0e81b69$var$Z) return $18c4f9e6a0e81b69$var$Z & -$18c4f9e6a0e81b69$var$Z;
    if (null !== $18c4f9e6a0e81b69$var$Kg.transition) return 0 === $18c4f9e6a0e81b69$var$Bk && ($18c4f9e6a0e81b69$var$Bk = $18c4f9e6a0e81b69$var$yc()), $18c4f9e6a0e81b69$var$Bk;
    a = $18c4f9e6a0e81b69$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $18c4f9e6a0e81b69$var$jd(a.type);
    return a;
}
function $18c4f9e6a0e81b69$var$gi(a, b, c, d) {
    if (50 < $18c4f9e6a0e81b69$var$yk) throw $18c4f9e6a0e81b69$var$yk = 0, $18c4f9e6a0e81b69$var$zk = null, Error($18c4f9e6a0e81b69$var$p(185));
    $18c4f9e6a0e81b69$var$Ac(a, c, d);
    if (0 === ($18c4f9e6a0e81b69$var$K & 2) || a !== $18c4f9e6a0e81b69$var$Q) a === $18c4f9e6a0e81b69$var$Q && (0 === ($18c4f9e6a0e81b69$var$K & 2) && ($18c4f9e6a0e81b69$var$qk |= c), 4 === $18c4f9e6a0e81b69$var$T && $18c4f9e6a0e81b69$var$Ck(a, $18c4f9e6a0e81b69$var$Z)), $18c4f9e6a0e81b69$var$Dk(a, d), 1 === c && 0 === $18c4f9e6a0e81b69$var$K && 0 === (b.mode & 1) && ($18c4f9e6a0e81b69$var$Gj = $18c4f9e6a0e81b69$var$B() + 500, $18c4f9e6a0e81b69$var$fg && $18c4f9e6a0e81b69$var$jg());
}
function $18c4f9e6a0e81b69$var$Dk(a, b) {
    var c = a.callbackNode;
    $18c4f9e6a0e81b69$var$wc(a, b);
    var d = $18c4f9e6a0e81b69$var$uc(a, a === $18c4f9e6a0e81b69$var$Q ? $18c4f9e6a0e81b69$var$Z : 0);
    if (0 === d) null !== c && $18c4f9e6a0e81b69$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $18c4f9e6a0e81b69$var$bc(c);
        if (1 === b) 0 === a.tag ? $18c4f9e6a0e81b69$var$ig($18c4f9e6a0e81b69$var$Ek.bind(null, a)) : $18c4f9e6a0e81b69$var$hg($18c4f9e6a0e81b69$var$Ek.bind(null, a)), $18c4f9e6a0e81b69$var$Jf(function() {
            0 === ($18c4f9e6a0e81b69$var$K & 6) && $18c4f9e6a0e81b69$var$jg();
        }), c = null;
        else {
            switch($18c4f9e6a0e81b69$var$Dc(d)){
                case 1:
                    c = $18c4f9e6a0e81b69$var$fc;
                    break;
                case 4:
                    c = $18c4f9e6a0e81b69$var$gc;
                    break;
                case 16:
                    c = $18c4f9e6a0e81b69$var$hc;
                    break;
                case 536870912:
                    c = $18c4f9e6a0e81b69$var$jc;
                    break;
                default:
                    c = $18c4f9e6a0e81b69$var$hc;
            }
            c = $18c4f9e6a0e81b69$var$Fk(c, $18c4f9e6a0e81b69$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $18c4f9e6a0e81b69$var$Gk(a, b) {
    $18c4f9e6a0e81b69$var$Ak = -1;
    $18c4f9e6a0e81b69$var$Bk = 0;
    if (0 !== ($18c4f9e6a0e81b69$var$K & 6)) throw Error($18c4f9e6a0e81b69$var$p(327));
    var c = a.callbackNode;
    if ($18c4f9e6a0e81b69$var$Hk() && a.callbackNode !== c) return null;
    var d = $18c4f9e6a0e81b69$var$uc(a, a === $18c4f9e6a0e81b69$var$Q ? $18c4f9e6a0e81b69$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $18c4f9e6a0e81b69$var$Ik(a, d);
    else {
        b = d;
        var e = $18c4f9e6a0e81b69$var$K;
        $18c4f9e6a0e81b69$var$K |= 2;
        var f = $18c4f9e6a0e81b69$var$Jk();
        if ($18c4f9e6a0e81b69$var$Q !== a || $18c4f9e6a0e81b69$var$Z !== b) $18c4f9e6a0e81b69$var$uk = null, $18c4f9e6a0e81b69$var$Gj = $18c4f9e6a0e81b69$var$B() + 500, $18c4f9e6a0e81b69$var$Kk(a, b);
        for(;;)try {
            $18c4f9e6a0e81b69$var$Lk();
            break;
        } catch (h) {
            $18c4f9e6a0e81b69$var$Mk(a, h);
        }
        $18c4f9e6a0e81b69$var$$g();
        $18c4f9e6a0e81b69$var$mk.current = f;
        $18c4f9e6a0e81b69$var$K = e;
        null !== $18c4f9e6a0e81b69$var$Y ? b = 0 : ($18c4f9e6a0e81b69$var$Q = null, $18c4f9e6a0e81b69$var$Z = 0, b = $18c4f9e6a0e81b69$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $18c4f9e6a0e81b69$var$xc(a), 0 !== e && (d = e, b = $18c4f9e6a0e81b69$var$Nk(a, e)));
        if (1 === b) throw c = $18c4f9e6a0e81b69$var$pk, $18c4f9e6a0e81b69$var$Kk(a, 0), $18c4f9e6a0e81b69$var$Ck(a, d), $18c4f9e6a0e81b69$var$Dk(a, $18c4f9e6a0e81b69$var$B()), c;
        if (6 === b) $18c4f9e6a0e81b69$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$18c4f9e6a0e81b69$var$Ok(e) && (b = $18c4f9e6a0e81b69$var$Ik(a, d), 2 === b && (f = $18c4f9e6a0e81b69$var$xc(a), 0 !== f && (d = f, b = $18c4f9e6a0e81b69$var$Nk(a, f))), 1 === b)) throw c = $18c4f9e6a0e81b69$var$pk, $18c4f9e6a0e81b69$var$Kk(a, 0), $18c4f9e6a0e81b69$var$Ck(a, d), $18c4f9e6a0e81b69$var$Dk(a, $18c4f9e6a0e81b69$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($18c4f9e6a0e81b69$var$p(345));
                case 2:
                    $18c4f9e6a0e81b69$var$Pk(a, $18c4f9e6a0e81b69$var$tk, $18c4f9e6a0e81b69$var$uk);
                    break;
                case 3:
                    $18c4f9e6a0e81b69$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $18c4f9e6a0e81b69$var$fk + 500 - $18c4f9e6a0e81b69$var$B(), 10 < b)) {
                        if (0 !== $18c4f9e6a0e81b69$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $18c4f9e6a0e81b69$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $18c4f9e6a0e81b69$var$Ff($18c4f9e6a0e81b69$var$Pk.bind(null, a, $18c4f9e6a0e81b69$var$tk, $18c4f9e6a0e81b69$var$uk), b);
                        break;
                    }
                    $18c4f9e6a0e81b69$var$Pk(a, $18c4f9e6a0e81b69$var$tk, $18c4f9e6a0e81b69$var$uk);
                    break;
                case 4:
                    $18c4f9e6a0e81b69$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $18c4f9e6a0e81b69$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $18c4f9e6a0e81b69$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $18c4f9e6a0e81b69$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $18c4f9e6a0e81b69$var$Ff($18c4f9e6a0e81b69$var$Pk.bind(null, a, $18c4f9e6a0e81b69$var$tk, $18c4f9e6a0e81b69$var$uk), d);
                        break;
                    }
                    $18c4f9e6a0e81b69$var$Pk(a, $18c4f9e6a0e81b69$var$tk, $18c4f9e6a0e81b69$var$uk);
                    break;
                case 5:
                    $18c4f9e6a0e81b69$var$Pk(a, $18c4f9e6a0e81b69$var$tk, $18c4f9e6a0e81b69$var$uk);
                    break;
                default:
                    throw Error($18c4f9e6a0e81b69$var$p(329));
            }
        }
    }
    $18c4f9e6a0e81b69$var$Dk(a, $18c4f9e6a0e81b69$var$B());
    return a.callbackNode === c ? $18c4f9e6a0e81b69$var$Gk.bind(null, a) : null;
}
function $18c4f9e6a0e81b69$var$Nk(a, b) {
    var c = $18c4f9e6a0e81b69$var$sk;
    a.current.memoizedState.isDehydrated && ($18c4f9e6a0e81b69$var$Kk(a, b).flags |= 256);
    a = $18c4f9e6a0e81b69$var$Ik(a, b);
    2 !== a && (b = $18c4f9e6a0e81b69$var$tk, $18c4f9e6a0e81b69$var$tk = c, null !== b && $18c4f9e6a0e81b69$var$Fj(b));
    return a;
}
function $18c4f9e6a0e81b69$var$Fj(a) {
    null === $18c4f9e6a0e81b69$var$tk ? $18c4f9e6a0e81b69$var$tk = a : $18c4f9e6a0e81b69$var$tk.push.apply($18c4f9e6a0e81b69$var$tk, a);
}
function $18c4f9e6a0e81b69$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$18c4f9e6a0e81b69$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $18c4f9e6a0e81b69$var$Ck(a, b) {
    b &= ~$18c4f9e6a0e81b69$var$rk;
    b &= ~$18c4f9e6a0e81b69$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $18c4f9e6a0e81b69$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $18c4f9e6a0e81b69$var$Ek(a) {
    if (0 !== ($18c4f9e6a0e81b69$var$K & 6)) throw Error($18c4f9e6a0e81b69$var$p(327));
    $18c4f9e6a0e81b69$var$Hk();
    var b = $18c4f9e6a0e81b69$var$uc(a, 0);
    if (0 === (b & 1)) return $18c4f9e6a0e81b69$var$Dk(a, $18c4f9e6a0e81b69$var$B()), null;
    var c = $18c4f9e6a0e81b69$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $18c4f9e6a0e81b69$var$xc(a);
        0 !== d && (b = d, c = $18c4f9e6a0e81b69$var$Nk(a, d));
    }
    if (1 === c) throw c = $18c4f9e6a0e81b69$var$pk, $18c4f9e6a0e81b69$var$Kk(a, 0), $18c4f9e6a0e81b69$var$Ck(a, b), $18c4f9e6a0e81b69$var$Dk(a, $18c4f9e6a0e81b69$var$B()), c;
    if (6 === c) throw Error($18c4f9e6a0e81b69$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $18c4f9e6a0e81b69$var$Pk(a, $18c4f9e6a0e81b69$var$tk, $18c4f9e6a0e81b69$var$uk);
    $18c4f9e6a0e81b69$var$Dk(a, $18c4f9e6a0e81b69$var$B());
    return null;
}
function $18c4f9e6a0e81b69$var$Qk(a, b) {
    var c = $18c4f9e6a0e81b69$var$K;
    $18c4f9e6a0e81b69$var$K |= 1;
    try {
        return a(b);
    } finally{
        $18c4f9e6a0e81b69$var$K = c, 0 === $18c4f9e6a0e81b69$var$K && ($18c4f9e6a0e81b69$var$Gj = $18c4f9e6a0e81b69$var$B() + 500, $18c4f9e6a0e81b69$var$fg && $18c4f9e6a0e81b69$var$jg());
    }
}
function $18c4f9e6a0e81b69$var$Rk(a) {
    null !== $18c4f9e6a0e81b69$var$wk && 0 === $18c4f9e6a0e81b69$var$wk.tag && 0 === ($18c4f9e6a0e81b69$var$K & 6) && $18c4f9e6a0e81b69$var$Hk();
    var b = $18c4f9e6a0e81b69$var$K;
    $18c4f9e6a0e81b69$var$K |= 1;
    var c = $18c4f9e6a0e81b69$var$ok.transition, d = $18c4f9e6a0e81b69$var$C;
    try {
        if ($18c4f9e6a0e81b69$var$ok.transition = null, $18c4f9e6a0e81b69$var$C = 1, a) return a();
    } finally{
        $18c4f9e6a0e81b69$var$C = d, $18c4f9e6a0e81b69$var$ok.transition = c, $18c4f9e6a0e81b69$var$K = b, 0 === ($18c4f9e6a0e81b69$var$K & 6) && $18c4f9e6a0e81b69$var$jg();
    }
}
function $18c4f9e6a0e81b69$var$Hj() {
    $18c4f9e6a0e81b69$var$fj = $18c4f9e6a0e81b69$var$ej.current;
    $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$ej);
}
function $18c4f9e6a0e81b69$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $18c4f9e6a0e81b69$var$Gf(c));
    if (null !== $18c4f9e6a0e81b69$var$Y) for(c = $18c4f9e6a0e81b69$var$Y.return; null !== c;){
        var d = c;
        $18c4f9e6a0e81b69$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $18c4f9e6a0e81b69$var$$f();
                break;
            case 3:
                $18c4f9e6a0e81b69$var$zh();
                $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$Wf);
                $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$H);
                $18c4f9e6a0e81b69$var$Eh();
                break;
            case 5:
                $18c4f9e6a0e81b69$var$Bh(d);
                break;
            case 4:
                $18c4f9e6a0e81b69$var$zh();
                break;
            case 13:
                $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$L);
                break;
            case 19:
                $18c4f9e6a0e81b69$var$E($18c4f9e6a0e81b69$var$L);
                break;
            case 10:
                $18c4f9e6a0e81b69$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $18c4f9e6a0e81b69$var$Hj();
        }
        c = c.return;
    }
    $18c4f9e6a0e81b69$var$Q = a;
    $18c4f9e6a0e81b69$var$Y = a = $18c4f9e6a0e81b69$var$Pg(a.current, null);
    $18c4f9e6a0e81b69$var$Z = $18c4f9e6a0e81b69$var$fj = b;
    $18c4f9e6a0e81b69$var$T = 0;
    $18c4f9e6a0e81b69$var$pk = null;
    $18c4f9e6a0e81b69$var$rk = $18c4f9e6a0e81b69$var$qk = $18c4f9e6a0e81b69$var$rh = 0;
    $18c4f9e6a0e81b69$var$tk = $18c4f9e6a0e81b69$var$sk = null;
    if (null !== $18c4f9e6a0e81b69$var$fh) {
        for(b = 0; b < $18c4f9e6a0e81b69$var$fh.length; b++)if (c = $18c4f9e6a0e81b69$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $18c4f9e6a0e81b69$var$fh = null;
    }
    return a;
}
function $18c4f9e6a0e81b69$var$Mk(a, b) {
    do {
        var c = $18c4f9e6a0e81b69$var$Y;
        try {
            $18c4f9e6a0e81b69$var$$g();
            $18c4f9e6a0e81b69$var$Fh.current = $18c4f9e6a0e81b69$var$Rh;
            if ($18c4f9e6a0e81b69$var$Ih) {
                for(var d = $18c4f9e6a0e81b69$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $18c4f9e6a0e81b69$var$Ih = !1;
            }
            $18c4f9e6a0e81b69$var$Hh = 0;
            $18c4f9e6a0e81b69$var$O = $18c4f9e6a0e81b69$var$N = $18c4f9e6a0e81b69$var$M = null;
            $18c4f9e6a0e81b69$var$Jh = !1;
            $18c4f9e6a0e81b69$var$Kh = 0;
            $18c4f9e6a0e81b69$var$nk.current = null;
            if (null === c || null === c.return) {
                $18c4f9e6a0e81b69$var$T = 1;
                $18c4f9e6a0e81b69$var$pk = b;
                $18c4f9e6a0e81b69$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $18c4f9e6a0e81b69$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $18c4f9e6a0e81b69$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $18c4f9e6a0e81b69$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $18c4f9e6a0e81b69$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $18c4f9e6a0e81b69$var$Si(f, l, b);
                            $18c4f9e6a0e81b69$var$tj();
                            break a;
                        }
                        k = Error($18c4f9e6a0e81b69$var$p(426));
                    }
                } else if ($18c4f9e6a0e81b69$var$I && h.mode & 1) {
                    var J = $18c4f9e6a0e81b69$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $18c4f9e6a0e81b69$var$Vi(J, g, h, f, b);
                        $18c4f9e6a0e81b69$var$Jg($18c4f9e6a0e81b69$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $18c4f9e6a0e81b69$var$Ji(k, h);
                4 !== $18c4f9e6a0e81b69$var$T && ($18c4f9e6a0e81b69$var$T = 2);
                null === $18c4f9e6a0e81b69$var$sk ? $18c4f9e6a0e81b69$var$sk = [
                    f
                ] : $18c4f9e6a0e81b69$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $18c4f9e6a0e81b69$var$Ni(f, k, b);
                            $18c4f9e6a0e81b69$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $18c4f9e6a0e81b69$var$Ri || !$18c4f9e6a0e81b69$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $18c4f9e6a0e81b69$var$Qi(f, h, b);
                                $18c4f9e6a0e81b69$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $18c4f9e6a0e81b69$var$Sk(c);
        } catch (na) {
            b = na;
            $18c4f9e6a0e81b69$var$Y === c && null !== c && ($18c4f9e6a0e81b69$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $18c4f9e6a0e81b69$var$Jk() {
    var a = $18c4f9e6a0e81b69$var$mk.current;
    $18c4f9e6a0e81b69$var$mk.current = $18c4f9e6a0e81b69$var$Rh;
    return null === a ? $18c4f9e6a0e81b69$var$Rh : a;
}
function $18c4f9e6a0e81b69$var$tj() {
    if (0 === $18c4f9e6a0e81b69$var$T || 3 === $18c4f9e6a0e81b69$var$T || 2 === $18c4f9e6a0e81b69$var$T) $18c4f9e6a0e81b69$var$T = 4;
    null === $18c4f9e6a0e81b69$var$Q || 0 === ($18c4f9e6a0e81b69$var$rh & 268435455) && 0 === ($18c4f9e6a0e81b69$var$qk & 268435455) || $18c4f9e6a0e81b69$var$Ck($18c4f9e6a0e81b69$var$Q, $18c4f9e6a0e81b69$var$Z);
}
function $18c4f9e6a0e81b69$var$Ik(a, b) {
    var c = $18c4f9e6a0e81b69$var$K;
    $18c4f9e6a0e81b69$var$K |= 2;
    var d = $18c4f9e6a0e81b69$var$Jk();
    if ($18c4f9e6a0e81b69$var$Q !== a || $18c4f9e6a0e81b69$var$Z !== b) $18c4f9e6a0e81b69$var$uk = null, $18c4f9e6a0e81b69$var$Kk(a, b);
    for(;;)try {
        $18c4f9e6a0e81b69$var$Tk();
        break;
    } catch (e) {
        $18c4f9e6a0e81b69$var$Mk(a, e);
    }
    $18c4f9e6a0e81b69$var$$g();
    $18c4f9e6a0e81b69$var$K = c;
    $18c4f9e6a0e81b69$var$mk.current = d;
    if (null !== $18c4f9e6a0e81b69$var$Y) throw Error($18c4f9e6a0e81b69$var$p(261));
    $18c4f9e6a0e81b69$var$Q = null;
    $18c4f9e6a0e81b69$var$Z = 0;
    return $18c4f9e6a0e81b69$var$T;
}
function $18c4f9e6a0e81b69$var$Tk() {
    for(; null !== $18c4f9e6a0e81b69$var$Y;)$18c4f9e6a0e81b69$var$Uk($18c4f9e6a0e81b69$var$Y);
}
function $18c4f9e6a0e81b69$var$Lk() {
    for(; null !== $18c4f9e6a0e81b69$var$Y && !$18c4f9e6a0e81b69$var$cc();)$18c4f9e6a0e81b69$var$Uk($18c4f9e6a0e81b69$var$Y);
}
function $18c4f9e6a0e81b69$var$Uk(a) {
    var b = $18c4f9e6a0e81b69$var$Vk(a.alternate, a, $18c4f9e6a0e81b69$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $18c4f9e6a0e81b69$var$Sk(a) : $18c4f9e6a0e81b69$var$Y = b;
    $18c4f9e6a0e81b69$var$nk.current = null;
}
function $18c4f9e6a0e81b69$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $18c4f9e6a0e81b69$var$Ej(c, b, $18c4f9e6a0e81b69$var$fj), null !== c) {
                $18c4f9e6a0e81b69$var$Y = c;
                return;
            }
        } else {
            c = $18c4f9e6a0e81b69$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $18c4f9e6a0e81b69$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $18c4f9e6a0e81b69$var$T = 6;
                $18c4f9e6a0e81b69$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $18c4f9e6a0e81b69$var$Y = b;
            return;
        }
        $18c4f9e6a0e81b69$var$Y = b = a;
    }while (null !== b);
    0 === $18c4f9e6a0e81b69$var$T && ($18c4f9e6a0e81b69$var$T = 5);
}
function $18c4f9e6a0e81b69$var$Pk(a, b, c) {
    var d = $18c4f9e6a0e81b69$var$C, e = $18c4f9e6a0e81b69$var$ok.transition;
    try {
        $18c4f9e6a0e81b69$var$ok.transition = null, $18c4f9e6a0e81b69$var$C = 1, $18c4f9e6a0e81b69$var$Wk(a, b, c, d);
    } finally{
        $18c4f9e6a0e81b69$var$ok.transition = e, $18c4f9e6a0e81b69$var$C = d;
    }
    return null;
}
function $18c4f9e6a0e81b69$var$Wk(a, b, c, d) {
    do $18c4f9e6a0e81b69$var$Hk();
    while (null !== $18c4f9e6a0e81b69$var$wk);
    if (0 !== ($18c4f9e6a0e81b69$var$K & 6)) throw Error($18c4f9e6a0e81b69$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($18c4f9e6a0e81b69$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $18c4f9e6a0e81b69$var$Bc(a, f);
    a === $18c4f9e6a0e81b69$var$Q && ($18c4f9e6a0e81b69$var$Y = $18c4f9e6a0e81b69$var$Q = null, $18c4f9e6a0e81b69$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $18c4f9e6a0e81b69$var$vk || ($18c4f9e6a0e81b69$var$vk = !0, $18c4f9e6a0e81b69$var$Fk($18c4f9e6a0e81b69$var$hc, function() {
        $18c4f9e6a0e81b69$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $18c4f9e6a0e81b69$var$ok.transition;
        $18c4f9e6a0e81b69$var$ok.transition = null;
        var g = $18c4f9e6a0e81b69$var$C;
        $18c4f9e6a0e81b69$var$C = 1;
        var h = $18c4f9e6a0e81b69$var$K;
        $18c4f9e6a0e81b69$var$K |= 4;
        $18c4f9e6a0e81b69$var$nk.current = null;
        $18c4f9e6a0e81b69$var$Oj(a, c);
        $18c4f9e6a0e81b69$var$dk(c, a);
        $18c4f9e6a0e81b69$var$Oe($18c4f9e6a0e81b69$var$Df);
        $18c4f9e6a0e81b69$var$dd = !!$18c4f9e6a0e81b69$var$Cf;
        $18c4f9e6a0e81b69$var$Df = $18c4f9e6a0e81b69$var$Cf = null;
        a.current = c;
        $18c4f9e6a0e81b69$var$hk(c, a, e);
        $18c4f9e6a0e81b69$var$dc();
        $18c4f9e6a0e81b69$var$K = h;
        $18c4f9e6a0e81b69$var$C = g;
        $18c4f9e6a0e81b69$var$ok.transition = f;
    } else a.current = c;
    $18c4f9e6a0e81b69$var$vk && ($18c4f9e6a0e81b69$var$vk = !1, $18c4f9e6a0e81b69$var$wk = a, $18c4f9e6a0e81b69$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($18c4f9e6a0e81b69$var$Ri = null);
    $18c4f9e6a0e81b69$var$mc(c.stateNode, d);
    $18c4f9e6a0e81b69$var$Dk(a, $18c4f9e6a0e81b69$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($18c4f9e6a0e81b69$var$Oi) throw $18c4f9e6a0e81b69$var$Oi = !1, a = $18c4f9e6a0e81b69$var$Pi, $18c4f9e6a0e81b69$var$Pi = null, a;
    0 !== ($18c4f9e6a0e81b69$var$xk & 1) && 0 !== a.tag && $18c4f9e6a0e81b69$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $18c4f9e6a0e81b69$var$zk ? $18c4f9e6a0e81b69$var$yk++ : ($18c4f9e6a0e81b69$var$yk = 0, $18c4f9e6a0e81b69$var$zk = a) : $18c4f9e6a0e81b69$var$yk = 0;
    $18c4f9e6a0e81b69$var$jg();
    return null;
}
function $18c4f9e6a0e81b69$var$Hk() {
    if (null !== $18c4f9e6a0e81b69$var$wk) {
        var a = $18c4f9e6a0e81b69$var$Dc($18c4f9e6a0e81b69$var$xk), b = $18c4f9e6a0e81b69$var$ok.transition, c = $18c4f9e6a0e81b69$var$C;
        try {
            $18c4f9e6a0e81b69$var$ok.transition = null;
            $18c4f9e6a0e81b69$var$C = 16 > a ? 16 : a;
            if (null === $18c4f9e6a0e81b69$var$wk) var d = !1;
            else {
                a = $18c4f9e6a0e81b69$var$wk;
                $18c4f9e6a0e81b69$var$wk = null;
                $18c4f9e6a0e81b69$var$xk = 0;
                if (0 !== ($18c4f9e6a0e81b69$var$K & 6)) throw Error($18c4f9e6a0e81b69$var$p(331));
                var e = $18c4f9e6a0e81b69$var$K;
                $18c4f9e6a0e81b69$var$K |= 4;
                for($18c4f9e6a0e81b69$var$V = a.current; null !== $18c4f9e6a0e81b69$var$V;){
                    var f = $18c4f9e6a0e81b69$var$V, g = f.child;
                    if (0 !== ($18c4f9e6a0e81b69$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($18c4f9e6a0e81b69$var$V = l; null !== $18c4f9e6a0e81b69$var$V;){
                                    var m = $18c4f9e6a0e81b69$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $18c4f9e6a0e81b69$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $18c4f9e6a0e81b69$var$V = q;
                                    else for(; null !== $18c4f9e6a0e81b69$var$V;){
                                        m = $18c4f9e6a0e81b69$var$V;
                                        var r = m.sibling, y = m.return;
                                        $18c4f9e6a0e81b69$var$Sj(m);
                                        if (m === l) {
                                            $18c4f9e6a0e81b69$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $18c4f9e6a0e81b69$var$V = r;
                                            break;
                                        }
                                        $18c4f9e6a0e81b69$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $18c4f9e6a0e81b69$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $18c4f9e6a0e81b69$var$V = g;
                    else b: for(; null !== $18c4f9e6a0e81b69$var$V;){
                        f = $18c4f9e6a0e81b69$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $18c4f9e6a0e81b69$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $18c4f9e6a0e81b69$var$V = x;
                            break b;
                        }
                        $18c4f9e6a0e81b69$var$V = f.return;
                    }
                }
                var w = a.current;
                for($18c4f9e6a0e81b69$var$V = w; null !== $18c4f9e6a0e81b69$var$V;){
                    g = $18c4f9e6a0e81b69$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $18c4f9e6a0e81b69$var$V = u;
                    else b: for(g = w; null !== $18c4f9e6a0e81b69$var$V;){
                        h = $18c4f9e6a0e81b69$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $18c4f9e6a0e81b69$var$Qj(9, h);
                            }
                        } catch (na) {
                            $18c4f9e6a0e81b69$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $18c4f9e6a0e81b69$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $18c4f9e6a0e81b69$var$V = F;
                            break b;
                        }
                        $18c4f9e6a0e81b69$var$V = h.return;
                    }
                }
                $18c4f9e6a0e81b69$var$K = e;
                $18c4f9e6a0e81b69$var$jg();
                if ($18c4f9e6a0e81b69$var$lc && "function" === typeof $18c4f9e6a0e81b69$var$lc.onPostCommitFiberRoot) try {
                    $18c4f9e6a0e81b69$var$lc.onPostCommitFiberRoot($18c4f9e6a0e81b69$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $18c4f9e6a0e81b69$var$C = c, $18c4f9e6a0e81b69$var$ok.transition = b;
        }
    }
    return !1;
}
function $18c4f9e6a0e81b69$var$Xk(a, b, c) {
    b = $18c4f9e6a0e81b69$var$Ji(c, b);
    b = $18c4f9e6a0e81b69$var$Ni(a, b, 1);
    a = $18c4f9e6a0e81b69$var$nh(a, b, 1);
    b = $18c4f9e6a0e81b69$var$R();
    null !== a && ($18c4f9e6a0e81b69$var$Ac(a, 1, b), $18c4f9e6a0e81b69$var$Dk(a, b));
}
function $18c4f9e6a0e81b69$var$W(a, b, c) {
    if (3 === a.tag) $18c4f9e6a0e81b69$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $18c4f9e6a0e81b69$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $18c4f9e6a0e81b69$var$Ri || !$18c4f9e6a0e81b69$var$Ri.has(d))) {
                a = $18c4f9e6a0e81b69$var$Ji(c, a);
                a = $18c4f9e6a0e81b69$var$Qi(b, a, 1);
                b = $18c4f9e6a0e81b69$var$nh(b, a, 1);
                a = $18c4f9e6a0e81b69$var$R();
                null !== b && ($18c4f9e6a0e81b69$var$Ac(b, 1, a), $18c4f9e6a0e81b69$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $18c4f9e6a0e81b69$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $18c4f9e6a0e81b69$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $18c4f9e6a0e81b69$var$Q === a && ($18c4f9e6a0e81b69$var$Z & c) === c && (4 === $18c4f9e6a0e81b69$var$T || 3 === $18c4f9e6a0e81b69$var$T && ($18c4f9e6a0e81b69$var$Z & 130023424) === $18c4f9e6a0e81b69$var$Z && 500 > $18c4f9e6a0e81b69$var$B() - $18c4f9e6a0e81b69$var$fk ? $18c4f9e6a0e81b69$var$Kk(a, 0) : $18c4f9e6a0e81b69$var$rk |= c);
    $18c4f9e6a0e81b69$var$Dk(a, b);
}
function $18c4f9e6a0e81b69$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $18c4f9e6a0e81b69$var$sc, $18c4f9e6a0e81b69$var$sc <<= 1, 0 === ($18c4f9e6a0e81b69$var$sc & 130023424) && ($18c4f9e6a0e81b69$var$sc = 4194304)));
    var c = $18c4f9e6a0e81b69$var$R();
    a = $18c4f9e6a0e81b69$var$ih(a, b);
    null !== a && ($18c4f9e6a0e81b69$var$Ac(a, b, c), $18c4f9e6a0e81b69$var$Dk(a, c));
}
function $18c4f9e6a0e81b69$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $18c4f9e6a0e81b69$var$Yk(a, c);
}
function $18c4f9e6a0e81b69$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($18c4f9e6a0e81b69$var$p(314));
    }
    null !== d && d.delete(b);
    $18c4f9e6a0e81b69$var$Yk(a, c);
}
var $18c4f9e6a0e81b69$var$Vk;
$18c4f9e6a0e81b69$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $18c4f9e6a0e81b69$var$Wf.current) $18c4f9e6a0e81b69$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $18c4f9e6a0e81b69$var$dh = !1, $18c4f9e6a0e81b69$var$yj(a, b, c);
            $18c4f9e6a0e81b69$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $18c4f9e6a0e81b69$var$dh = !1, $18c4f9e6a0e81b69$var$I && 0 !== (b.flags & 1048576) && $18c4f9e6a0e81b69$var$ug(b, $18c4f9e6a0e81b69$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $18c4f9e6a0e81b69$var$ij(a, b);
            a = b.pendingProps;
            var e = $18c4f9e6a0e81b69$var$Yf(b, $18c4f9e6a0e81b69$var$H.current);
            $18c4f9e6a0e81b69$var$ch(b, c);
            e = $18c4f9e6a0e81b69$var$Nh(null, b, d, a, e, c);
            var f = $18c4f9e6a0e81b69$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $18c4f9e6a0e81b69$var$Zf(d) ? (f = !0, $18c4f9e6a0e81b69$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $18c4f9e6a0e81b69$var$kh(b), e.updater = $18c4f9e6a0e81b69$var$Ei, b.stateNode = e, e._reactInternals = b, $18c4f9e6a0e81b69$var$Ii(b, d, a, c), b = $18c4f9e6a0e81b69$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $18c4f9e6a0e81b69$var$I && f && $18c4f9e6a0e81b69$var$vg(b), $18c4f9e6a0e81b69$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $18c4f9e6a0e81b69$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $18c4f9e6a0e81b69$var$Zk(d);
                a = $18c4f9e6a0e81b69$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $18c4f9e6a0e81b69$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $18c4f9e6a0e81b69$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $18c4f9e6a0e81b69$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $18c4f9e6a0e81b69$var$$i(null, b, d, $18c4f9e6a0e81b69$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($18c4f9e6a0e81b69$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $18c4f9e6a0e81b69$var$Ci(d, e), $18c4f9e6a0e81b69$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $18c4f9e6a0e81b69$var$Ci(d, e), $18c4f9e6a0e81b69$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $18c4f9e6a0e81b69$var$kj(b);
                if (null === a) throw Error($18c4f9e6a0e81b69$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $18c4f9e6a0e81b69$var$lh(a, b);
                $18c4f9e6a0e81b69$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $18c4f9e6a0e81b69$var$Ji(Error($18c4f9e6a0e81b69$var$p(423)), b);
                        b = $18c4f9e6a0e81b69$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $18c4f9e6a0e81b69$var$Ji(Error($18c4f9e6a0e81b69$var$p(424)), b);
                        b = $18c4f9e6a0e81b69$var$lj(a, b, d, c, e);
                        break a;
                    } else for($18c4f9e6a0e81b69$var$yg = $18c4f9e6a0e81b69$var$Lf(b.stateNode.containerInfo.firstChild), $18c4f9e6a0e81b69$var$xg = b, $18c4f9e6a0e81b69$var$I = !0, $18c4f9e6a0e81b69$var$zg = null, c = $18c4f9e6a0e81b69$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $18c4f9e6a0e81b69$var$Ig();
                    if (d === e) {
                        b = $18c4f9e6a0e81b69$var$Zi(a, b, c);
                        break a;
                    }
                    $18c4f9e6a0e81b69$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $18c4f9e6a0e81b69$var$Ah(b), null === a && $18c4f9e6a0e81b69$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $18c4f9e6a0e81b69$var$Ef(d, e) ? g = null : null !== f && $18c4f9e6a0e81b69$var$Ef(d, f) && (b.flags |= 32), $18c4f9e6a0e81b69$var$gj(a, b), $18c4f9e6a0e81b69$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $18c4f9e6a0e81b69$var$Eg(b), null;
        case 13:
            return $18c4f9e6a0e81b69$var$oj(a, b, c);
        case 4:
            return $18c4f9e6a0e81b69$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $18c4f9e6a0e81b69$var$Ug(b, null, d, c) : $18c4f9e6a0e81b69$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $18c4f9e6a0e81b69$var$Ci(d, e), $18c4f9e6a0e81b69$var$Yi(a, b, d, e, c);
        case 7:
            return $18c4f9e6a0e81b69$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $18c4f9e6a0e81b69$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $18c4f9e6a0e81b69$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $18c4f9e6a0e81b69$var$G($18c4f9e6a0e81b69$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($18c4f9e6a0e81b69$var$He(f.value, g)) {
                        if (f.children === e.children && !$18c4f9e6a0e81b69$var$Wf.current) {
                            b = $18c4f9e6a0e81b69$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $18c4f9e6a0e81b69$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $18c4f9e6a0e81b69$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($18c4f9e6a0e81b69$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $18c4f9e6a0e81b69$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $18c4f9e6a0e81b69$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $18c4f9e6a0e81b69$var$ch(b, c), e = $18c4f9e6a0e81b69$var$eh(e), d = d(e), b.flags |= 1, $18c4f9e6a0e81b69$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $18c4f9e6a0e81b69$var$Ci(d, b.pendingProps), e = $18c4f9e6a0e81b69$var$Ci(d.type, e), $18c4f9e6a0e81b69$var$$i(a, b, d, e, c);
        case 15:
            return $18c4f9e6a0e81b69$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $18c4f9e6a0e81b69$var$Ci(d, e), $18c4f9e6a0e81b69$var$ij(a, b), b.tag = 1, $18c4f9e6a0e81b69$var$Zf(d) ? (a = !0, $18c4f9e6a0e81b69$var$cg(b)) : a = !1, $18c4f9e6a0e81b69$var$ch(b, c), $18c4f9e6a0e81b69$var$Gi(b, d, e), $18c4f9e6a0e81b69$var$Ii(b, d, e, c), $18c4f9e6a0e81b69$var$jj(null, b, d, !0, a, c);
        case 19:
            return $18c4f9e6a0e81b69$var$xj(a, b, c);
        case 22:
            return $18c4f9e6a0e81b69$var$dj(a, b, c);
    }
    throw Error($18c4f9e6a0e81b69$var$p(156, b.tag));
};
function $18c4f9e6a0e81b69$var$Fk(a, b) {
    return $18c4f9e6a0e81b69$var$ac(a, b);
}
function $18c4f9e6a0e81b69$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $18c4f9e6a0e81b69$var$Bg(a, b, c, d) {
    return new $18c4f9e6a0e81b69$var$$k(a, b, c, d);
}
function $18c4f9e6a0e81b69$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $18c4f9e6a0e81b69$var$Zk(a) {
    if ("function" === typeof a) return $18c4f9e6a0e81b69$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $18c4f9e6a0e81b69$var$Da) return 11;
        if (a === $18c4f9e6a0e81b69$var$Ga) return 14;
    }
    return 2;
}
function $18c4f9e6a0e81b69$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $18c4f9e6a0e81b69$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $18c4f9e6a0e81b69$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $18c4f9e6a0e81b69$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $18c4f9e6a0e81b69$var$ya:
            return $18c4f9e6a0e81b69$var$Tg(c.children, e, f, b);
        case $18c4f9e6a0e81b69$var$za:
            g = 8;
            e |= 8;
            break;
        case $18c4f9e6a0e81b69$var$Aa:
            return a = $18c4f9e6a0e81b69$var$Bg(12, c, b, e | 2), a.elementType = $18c4f9e6a0e81b69$var$Aa, a.lanes = f, a;
        case $18c4f9e6a0e81b69$var$Ea:
            return a = $18c4f9e6a0e81b69$var$Bg(13, c, b, e), a.elementType = $18c4f9e6a0e81b69$var$Ea, a.lanes = f, a;
        case $18c4f9e6a0e81b69$var$Fa:
            return a = $18c4f9e6a0e81b69$var$Bg(19, c, b, e), a.elementType = $18c4f9e6a0e81b69$var$Fa, a.lanes = f, a;
        case $18c4f9e6a0e81b69$var$Ia:
            return $18c4f9e6a0e81b69$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $18c4f9e6a0e81b69$var$Ba:
                    g = 10;
                    break a;
                case $18c4f9e6a0e81b69$var$Ca:
                    g = 9;
                    break a;
                case $18c4f9e6a0e81b69$var$Da:
                    g = 11;
                    break a;
                case $18c4f9e6a0e81b69$var$Ga:
                    g = 14;
                    break a;
                case $18c4f9e6a0e81b69$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($18c4f9e6a0e81b69$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $18c4f9e6a0e81b69$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $18c4f9e6a0e81b69$var$Tg(a, b, c, d) {
    a = $18c4f9e6a0e81b69$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $18c4f9e6a0e81b69$var$pj(a, b, c, d) {
    a = $18c4f9e6a0e81b69$var$Bg(22, a, d, b);
    a.elementType = $18c4f9e6a0e81b69$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $18c4f9e6a0e81b69$var$Qg(a, b, c) {
    a = $18c4f9e6a0e81b69$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $18c4f9e6a0e81b69$var$Sg(a, b, c) {
    b = $18c4f9e6a0e81b69$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $18c4f9e6a0e81b69$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $18c4f9e6a0e81b69$var$zc(0);
    this.expirationTimes = $18c4f9e6a0e81b69$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $18c4f9e6a0e81b69$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $18c4f9e6a0e81b69$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $18c4f9e6a0e81b69$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $18c4f9e6a0e81b69$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $18c4f9e6a0e81b69$var$kh(f);
    return a;
}
function $18c4f9e6a0e81b69$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $18c4f9e6a0e81b69$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $18c4f9e6a0e81b69$var$dl(a) {
    if (!a) return $18c4f9e6a0e81b69$var$Vf;
    a = a._reactInternals;
    a: {
        if ($18c4f9e6a0e81b69$var$Vb(a) !== a || 1 !== a.tag) throw Error($18c4f9e6a0e81b69$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($18c4f9e6a0e81b69$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($18c4f9e6a0e81b69$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($18c4f9e6a0e81b69$var$Zf(c)) return $18c4f9e6a0e81b69$var$bg(a, c, b);
    }
    return b;
}
function $18c4f9e6a0e81b69$var$el(a, b, c, d, e, f, g, h, k) {
    a = $18c4f9e6a0e81b69$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $18c4f9e6a0e81b69$var$dl(null);
    c = a.current;
    d = $18c4f9e6a0e81b69$var$R();
    e = $18c4f9e6a0e81b69$var$yi(c);
    f = $18c4f9e6a0e81b69$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $18c4f9e6a0e81b69$var$nh(c, f, e);
    a.current.lanes = e;
    $18c4f9e6a0e81b69$var$Ac(a, e, d);
    $18c4f9e6a0e81b69$var$Dk(a, d);
    return a;
}
function $18c4f9e6a0e81b69$var$fl(a, b, c, d) {
    var e = b.current, f = $18c4f9e6a0e81b69$var$R(), g = $18c4f9e6a0e81b69$var$yi(e);
    c = $18c4f9e6a0e81b69$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $18c4f9e6a0e81b69$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $18c4f9e6a0e81b69$var$nh(e, b, g);
    null !== a && ($18c4f9e6a0e81b69$var$gi(a, e, g, f), $18c4f9e6a0e81b69$var$oh(a, e, g));
    return g;
}
function $18c4f9e6a0e81b69$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $18c4f9e6a0e81b69$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $18c4f9e6a0e81b69$var$il(a, b) {
    $18c4f9e6a0e81b69$var$hl(a, b);
    (a = a.alternate) && $18c4f9e6a0e81b69$var$hl(a, b);
}
function $18c4f9e6a0e81b69$var$jl() {
    return null;
}
var $18c4f9e6a0e81b69$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $18c4f9e6a0e81b69$var$ll(a) {
    this._internalRoot = a;
}
$18c4f9e6a0e81b69$var$ml.prototype.render = $18c4f9e6a0e81b69$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($18c4f9e6a0e81b69$var$p(409));
    $18c4f9e6a0e81b69$var$fl(a, b, null, null);
};
$18c4f9e6a0e81b69$var$ml.prototype.unmount = $18c4f9e6a0e81b69$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $18c4f9e6a0e81b69$var$Rk(function() {
            $18c4f9e6a0e81b69$var$fl(null, a, null, null);
        });
        b[$18c4f9e6a0e81b69$var$uf] = null;
    }
};
function $18c4f9e6a0e81b69$var$ml(a) {
    this._internalRoot = a;
}
$18c4f9e6a0e81b69$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $18c4f9e6a0e81b69$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $18c4f9e6a0e81b69$var$Qc.length && 0 !== b && b < $18c4f9e6a0e81b69$var$Qc[c].priority; c++);
        $18c4f9e6a0e81b69$var$Qc.splice(c, 0, a);
        0 === c && $18c4f9e6a0e81b69$var$Vc(a);
    }
};
function $18c4f9e6a0e81b69$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $18c4f9e6a0e81b69$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $18c4f9e6a0e81b69$var$pl() {}
function $18c4f9e6a0e81b69$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $18c4f9e6a0e81b69$var$gl(g);
                f.call(a);
            };
        }
        var g = $18c4f9e6a0e81b69$var$el(b, d, a, 0, null, !1, !1, "", $18c4f9e6a0e81b69$var$pl);
        a._reactRootContainer = g;
        a[$18c4f9e6a0e81b69$var$uf] = g.current;
        $18c4f9e6a0e81b69$var$sf(8 === a.nodeType ? a.parentNode : a);
        $18c4f9e6a0e81b69$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $18c4f9e6a0e81b69$var$gl(k);
            h.call(a);
        };
    }
    var k = $18c4f9e6a0e81b69$var$bl(a, 0, !1, null, null, !1, !1, "", $18c4f9e6a0e81b69$var$pl);
    a._reactRootContainer = k;
    a[$18c4f9e6a0e81b69$var$uf] = k.current;
    $18c4f9e6a0e81b69$var$sf(8 === a.nodeType ? a.parentNode : a);
    $18c4f9e6a0e81b69$var$Rk(function() {
        $18c4f9e6a0e81b69$var$fl(b, k, c, d);
    });
    return k;
}
function $18c4f9e6a0e81b69$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $18c4f9e6a0e81b69$var$gl(g);
                h.call(a);
            };
        }
        $18c4f9e6a0e81b69$var$fl(b, g, a, e);
    } else g = $18c4f9e6a0e81b69$var$ql(c, b, a, e, d);
    return $18c4f9e6a0e81b69$var$gl(g);
}
$18c4f9e6a0e81b69$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $18c4f9e6a0e81b69$var$tc(b.pendingLanes);
                0 !== c && ($18c4f9e6a0e81b69$var$Cc(b, c | 1), $18c4f9e6a0e81b69$var$Dk(b, $18c4f9e6a0e81b69$var$B()), 0 === ($18c4f9e6a0e81b69$var$K & 6) && ($18c4f9e6a0e81b69$var$Gj = $18c4f9e6a0e81b69$var$B() + 500, $18c4f9e6a0e81b69$var$jg()));
            }
            break;
        case 13:
            $18c4f9e6a0e81b69$var$Rk(function() {
                var b = $18c4f9e6a0e81b69$var$ih(a, 1);
                if (null !== b) {
                    var c = $18c4f9e6a0e81b69$var$R();
                    $18c4f9e6a0e81b69$var$gi(b, a, 1, c);
                }
            }), $18c4f9e6a0e81b69$var$il(a, 1);
    }
};
$18c4f9e6a0e81b69$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $18c4f9e6a0e81b69$var$ih(a, 134217728);
        if (null !== b) {
            var c = $18c4f9e6a0e81b69$var$R();
            $18c4f9e6a0e81b69$var$gi(b, a, 134217728, c);
        }
        $18c4f9e6a0e81b69$var$il(a, 134217728);
    }
};
$18c4f9e6a0e81b69$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $18c4f9e6a0e81b69$var$yi(a), c = $18c4f9e6a0e81b69$var$ih(a, b);
        if (null !== c) {
            var d = $18c4f9e6a0e81b69$var$R();
            $18c4f9e6a0e81b69$var$gi(c, a, b, d);
        }
        $18c4f9e6a0e81b69$var$il(a, b);
    }
};
$18c4f9e6a0e81b69$var$Hc = function() {
    return $18c4f9e6a0e81b69$var$C;
};
$18c4f9e6a0e81b69$var$Ic = function(a, b) {
    var c = $18c4f9e6a0e81b69$var$C;
    try {
        return $18c4f9e6a0e81b69$var$C = a, b();
    } finally{
        $18c4f9e6a0e81b69$var$C = c;
    }
};
$18c4f9e6a0e81b69$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $18c4f9e6a0e81b69$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $18c4f9e6a0e81b69$var$Db(d);
                        if (!e) throw Error($18c4f9e6a0e81b69$var$p(90));
                        $18c4f9e6a0e81b69$var$Wa(d);
                        $18c4f9e6a0e81b69$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $18c4f9e6a0e81b69$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $18c4f9e6a0e81b69$var$fb(a, !!c.multiple, b, !1);
    }
};
$18c4f9e6a0e81b69$var$Gb = $18c4f9e6a0e81b69$var$Qk;
$18c4f9e6a0e81b69$var$Hb = $18c4f9e6a0e81b69$var$Rk;
var $18c4f9e6a0e81b69$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $18c4f9e6a0e81b69$var$Cb,
        $18c4f9e6a0e81b69$var$ue,
        $18c4f9e6a0e81b69$var$Db,
        $18c4f9e6a0e81b69$var$Eb,
        $18c4f9e6a0e81b69$var$Fb,
        $18c4f9e6a0e81b69$var$Qk
    ]
}, $18c4f9e6a0e81b69$var$tl = {
    findFiberByHostInstance: $18c4f9e6a0e81b69$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $18c4f9e6a0e81b69$var$ul = {
    bundleType: $18c4f9e6a0e81b69$var$tl.bundleType,
    version: $18c4f9e6a0e81b69$var$tl.version,
    rendererPackageName: $18c4f9e6a0e81b69$var$tl.rendererPackageName,
    rendererConfig: $18c4f9e6a0e81b69$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $18c4f9e6a0e81b69$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $18c4f9e6a0e81b69$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $18c4f9e6a0e81b69$var$tl.findFiberByHostInstance || $18c4f9e6a0e81b69$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $18c4f9e6a0e81b69$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$18c4f9e6a0e81b69$var$vl.isDisabled && $18c4f9e6a0e81b69$var$vl.supportsFiber) try {
        $18c4f9e6a0e81b69$var$kc = $18c4f9e6a0e81b69$var$vl.inject($18c4f9e6a0e81b69$var$ul), $18c4f9e6a0e81b69$var$lc = $18c4f9e6a0e81b69$var$vl;
    } catch (a) {}
}
$18c4f9e6a0e81b69$export$ae55be85d98224ed = $18c4f9e6a0e81b69$var$sl;
$18c4f9e6a0e81b69$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$18c4f9e6a0e81b69$var$nl(b)) throw Error($18c4f9e6a0e81b69$var$p(200));
    return $18c4f9e6a0e81b69$var$cl(a, b, null, c);
};
$18c4f9e6a0e81b69$export$882461b6382ed46c = function(a, b) {
    if (!$18c4f9e6a0e81b69$var$nl(a)) throw Error($18c4f9e6a0e81b69$var$p(299));
    var c = !1, d = "", e = $18c4f9e6a0e81b69$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $18c4f9e6a0e81b69$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$18c4f9e6a0e81b69$var$uf] = b.current;
    $18c4f9e6a0e81b69$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $18c4f9e6a0e81b69$var$ll(b);
};
$18c4f9e6a0e81b69$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($18c4f9e6a0e81b69$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($18c4f9e6a0e81b69$var$p(268, a));
    }
    a = $18c4f9e6a0e81b69$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$18c4f9e6a0e81b69$export$cd75ccfd720a3cd4 = function(a) {
    return $18c4f9e6a0e81b69$var$Rk(a);
};
$18c4f9e6a0e81b69$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$18c4f9e6a0e81b69$var$ol(b)) throw Error($18c4f9e6a0e81b69$var$p(200));
    return $18c4f9e6a0e81b69$var$rl(null, a, b, !0, c);
};
$18c4f9e6a0e81b69$export$757ceba2d55c277e = function(a, b, c) {
    if (!$18c4f9e6a0e81b69$var$nl(a)) throw Error($18c4f9e6a0e81b69$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $18c4f9e6a0e81b69$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $18c4f9e6a0e81b69$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$18c4f9e6a0e81b69$var$uf] = b.current;
    $18c4f9e6a0e81b69$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $18c4f9e6a0e81b69$var$ml(b);
};
$18c4f9e6a0e81b69$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$18c4f9e6a0e81b69$var$ol(b)) throw Error($18c4f9e6a0e81b69$var$p(200));
    return $18c4f9e6a0e81b69$var$rl(null, a, b, !1, c);
};
$18c4f9e6a0e81b69$export$502457920280e6be = function(a) {
    if (!$18c4f9e6a0e81b69$var$ol(a)) throw Error($18c4f9e6a0e81b69$var$p(40));
    return a._reactRootContainer ? ($18c4f9e6a0e81b69$var$Rk(function() {
        $18c4f9e6a0e81b69$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$18c4f9e6a0e81b69$var$uf] = null;
        });
    }), !0) : !1;
};
$18c4f9e6a0e81b69$export$c78a37762a8d58e1 = $18c4f9e6a0e81b69$var$Qk;
$18c4f9e6a0e81b69$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$18c4f9e6a0e81b69$var$ol(c)) throw Error($18c4f9e6a0e81b69$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($18c4f9e6a0e81b69$var$p(38));
    return $18c4f9e6a0e81b69$var$rl(a, b, c, !1, d);
};
$18c4f9e6a0e81b69$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("feV1b", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i9o7b"));

});
parcelRegister("i9o7b", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d36bc5f6b70006d6$export$c4744153514ff05d; }, function (v) { return $d36bc5f6b70006d6$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d36bc5f6b70006d6$export$3e506c1ccc9cc1a7; }, function (v) { return $d36bc5f6b70006d6$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d36bc5f6b70006d6$export$e26fe2ed2fa76875; }, function (v) { return $d36bc5f6b70006d6$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d36bc5f6b70006d6$export$502329bbf4b505b1; }, function (v) { return $d36bc5f6b70006d6$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d36bc5f6b70006d6$export$6e3807111c4874c4; }, function (v) { return $d36bc5f6b70006d6$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d36bc5f6b70006d6$export$c27134553091fb3a; }, function (v) { return $d36bc5f6b70006d6$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d36bc5f6b70006d6$export$33ee1acdc04fd2a2; }, function (v) { return $d36bc5f6b70006d6$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d36bc5f6b70006d6$export$b00a404bbd5edef2; }, function (v) { return $d36bc5f6b70006d6$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d36bc5f6b70006d6$export$8352ce38b91d0c62; }, function (v) { return $d36bc5f6b70006d6$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d36bc5f6b70006d6$export$d66a1c1c77bd778b; }, function (v) { return $d36bc5f6b70006d6$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d36bc5f6b70006d6$export$d3dfb8e4810cb555; }, function (v) { return $d36bc5f6b70006d6$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d36bc5f6b70006d6$export$839f9183b0465a69; }, function (v) { return $d36bc5f6b70006d6$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d36bc5f6b70006d6$export$72fdf0e06517287b; }, function (v) { return $d36bc5f6b70006d6$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d36bc5f6b70006d6$export$4b844e58a3e414b4; }, function (v) { return $d36bc5f6b70006d6$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d36bc5f6b70006d6$export$816d2913ae6b83b1; }, function (v) { return $d36bc5f6b70006d6$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d36bc5f6b70006d6$export$61bcfe829111a1d0; }, function (v) { return $d36bc5f6b70006d6$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d36bc5f6b70006d6$export$7ee8c9beb337bc3f; }, function (v) { return $d36bc5f6b70006d6$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d36bc5f6b70006d6$export$b5836b71941fa3ed; }, function (v) { return $d36bc5f6b70006d6$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d36bc5f6b70006d6$export$cf845f2c119da08a; }, function (v) { return $d36bc5f6b70006d6$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d36bc5f6b70006d6$export$c4744153514ff05d;
var $d36bc5f6b70006d6$export$3e506c1ccc9cc1a7;
var $d36bc5f6b70006d6$export$e26fe2ed2fa76875;
var $d36bc5f6b70006d6$export$502329bbf4b505b1;
var $d36bc5f6b70006d6$export$6e3807111c4874c4;
var $d36bc5f6b70006d6$export$c27134553091fb3a;
var $d36bc5f6b70006d6$export$33ee1acdc04fd2a2;
var $d36bc5f6b70006d6$export$b00a404bbd5edef2;
var $d36bc5f6b70006d6$export$8352ce38b91d0c62;
var $d36bc5f6b70006d6$export$d66a1c1c77bd778b;
var $d36bc5f6b70006d6$export$d3dfb8e4810cb555;
var $d36bc5f6b70006d6$export$839f9183b0465a69;
var $d36bc5f6b70006d6$export$72fdf0e06517287b;
var $d36bc5f6b70006d6$export$4b844e58a3e414b4;
var $d36bc5f6b70006d6$export$816d2913ae6b83b1;
var $d36bc5f6b70006d6$export$61bcfe829111a1d0;
var $d36bc5f6b70006d6$export$7ee8c9beb337bc3f;
var $d36bc5f6b70006d6$export$b5836b71941fa3ed;
var $d36bc5f6b70006d6$export$cf845f2c119da08a;
'use strict';
function $d36bc5f6b70006d6$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $d36bc5f6b70006d6$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d36bc5f6b70006d6$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $d36bc5f6b70006d6$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $d36bc5f6b70006d6$var$g(C, c)) n < e && 0 > $d36bc5f6b70006d6$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $d36bc5f6b70006d6$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $d36bc5f6b70006d6$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d36bc5f6b70006d6$var$l = performance;
    $d36bc5f6b70006d6$export$c4744153514ff05d = function() {
        return $d36bc5f6b70006d6$var$l.now();
    };
} else {
    var $d36bc5f6b70006d6$var$p = Date, $d36bc5f6b70006d6$var$q = $d36bc5f6b70006d6$var$p.now();
    $d36bc5f6b70006d6$export$c4744153514ff05d = function() {
        return $d36bc5f6b70006d6$var$p.now() - $d36bc5f6b70006d6$var$q;
    };
}
var $d36bc5f6b70006d6$var$r = [], $d36bc5f6b70006d6$var$t = [], $d36bc5f6b70006d6$var$u = 1, $d36bc5f6b70006d6$var$v = null, $d36bc5f6b70006d6$var$y = 3, $d36bc5f6b70006d6$var$z = !1, $d36bc5f6b70006d6$var$A = !1, $d36bc5f6b70006d6$var$B = !1, $d36bc5f6b70006d6$var$D = "function" === typeof setTimeout ? setTimeout : null, $d36bc5f6b70006d6$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $d36bc5f6b70006d6$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $d36bc5f6b70006d6$var$G(a) {
    for(var b = $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$t); null !== b;){
        if (null === b.callback) $d36bc5f6b70006d6$var$k($d36bc5f6b70006d6$var$t);
        else if (b.startTime <= a) $d36bc5f6b70006d6$var$k($d36bc5f6b70006d6$var$t), b.sortIndex = b.expirationTime, $d36bc5f6b70006d6$var$f($d36bc5f6b70006d6$var$r, b);
        else break;
        b = $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$t);
    }
}
function $d36bc5f6b70006d6$var$H(a) {
    $d36bc5f6b70006d6$var$B = !1;
    $d36bc5f6b70006d6$var$G(a);
    if (!$d36bc5f6b70006d6$var$A) {
        if (null !== $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$r)) $d36bc5f6b70006d6$var$A = !0, $d36bc5f6b70006d6$var$I($d36bc5f6b70006d6$var$J);
        else {
            var b = $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$t);
            null !== b && $d36bc5f6b70006d6$var$K($d36bc5f6b70006d6$var$H, b.startTime - a);
        }
    }
}
function $d36bc5f6b70006d6$var$J(a, b) {
    $d36bc5f6b70006d6$var$A = !1;
    $d36bc5f6b70006d6$var$B && ($d36bc5f6b70006d6$var$B = !1, $d36bc5f6b70006d6$var$E($d36bc5f6b70006d6$var$L), $d36bc5f6b70006d6$var$L = -1);
    $d36bc5f6b70006d6$var$z = !0;
    var c = $d36bc5f6b70006d6$var$y;
    try {
        $d36bc5f6b70006d6$var$G(b);
        for($d36bc5f6b70006d6$var$v = $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$r); null !== $d36bc5f6b70006d6$var$v && (!($d36bc5f6b70006d6$var$v.expirationTime > b) || a && !$d36bc5f6b70006d6$var$M());){
            var d = $d36bc5f6b70006d6$var$v.callback;
            if ("function" === typeof d) {
                $d36bc5f6b70006d6$var$v.callback = null;
                $d36bc5f6b70006d6$var$y = $d36bc5f6b70006d6$var$v.priorityLevel;
                var e = d($d36bc5f6b70006d6$var$v.expirationTime <= b);
                b = $d36bc5f6b70006d6$export$c4744153514ff05d();
                "function" === typeof e ? $d36bc5f6b70006d6$var$v.callback = e : $d36bc5f6b70006d6$var$v === $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$r) && $d36bc5f6b70006d6$var$k($d36bc5f6b70006d6$var$r);
                $d36bc5f6b70006d6$var$G(b);
            } else $d36bc5f6b70006d6$var$k($d36bc5f6b70006d6$var$r);
            $d36bc5f6b70006d6$var$v = $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$r);
        }
        if (null !== $d36bc5f6b70006d6$var$v) var w = !0;
        else {
            var m = $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$t);
            null !== m && $d36bc5f6b70006d6$var$K($d36bc5f6b70006d6$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $d36bc5f6b70006d6$var$v = null, $d36bc5f6b70006d6$var$y = c, $d36bc5f6b70006d6$var$z = !1;
    }
}
var $d36bc5f6b70006d6$var$N = !1, $d36bc5f6b70006d6$var$O = null, $d36bc5f6b70006d6$var$L = -1, $d36bc5f6b70006d6$var$P = 5, $d36bc5f6b70006d6$var$Q = -1;
function $d36bc5f6b70006d6$var$M() {
    return $d36bc5f6b70006d6$export$c4744153514ff05d() - $d36bc5f6b70006d6$var$Q < $d36bc5f6b70006d6$var$P ? !1 : !0;
}
function $d36bc5f6b70006d6$var$R() {
    if (null !== $d36bc5f6b70006d6$var$O) {
        var a = $d36bc5f6b70006d6$export$c4744153514ff05d();
        $d36bc5f6b70006d6$var$Q = a;
        var b = !0;
        try {
            b = $d36bc5f6b70006d6$var$O(!0, a);
        } finally{
            b ? $d36bc5f6b70006d6$var$S() : ($d36bc5f6b70006d6$var$N = !1, $d36bc5f6b70006d6$var$O = null);
        }
    } else $d36bc5f6b70006d6$var$N = !1;
}
var $d36bc5f6b70006d6$var$S;
if ("function" === typeof $d36bc5f6b70006d6$var$F) $d36bc5f6b70006d6$var$S = function() {
    $d36bc5f6b70006d6$var$F($d36bc5f6b70006d6$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d36bc5f6b70006d6$var$T = new MessageChannel, $d36bc5f6b70006d6$var$U = $d36bc5f6b70006d6$var$T.port2;
    $d36bc5f6b70006d6$var$T.port1.onmessage = $d36bc5f6b70006d6$var$R;
    $d36bc5f6b70006d6$var$S = function() {
        $d36bc5f6b70006d6$var$U.postMessage(null);
    };
} else $d36bc5f6b70006d6$var$S = function() {
    $d36bc5f6b70006d6$var$D($d36bc5f6b70006d6$var$R, 0);
};
function $d36bc5f6b70006d6$var$I(a) {
    $d36bc5f6b70006d6$var$O = a;
    $d36bc5f6b70006d6$var$N || ($d36bc5f6b70006d6$var$N = !0, $d36bc5f6b70006d6$var$S());
}
function $d36bc5f6b70006d6$var$K(a, b) {
    $d36bc5f6b70006d6$var$L = $d36bc5f6b70006d6$var$D(function() {
        a($d36bc5f6b70006d6$export$c4744153514ff05d());
    }, b);
}
$d36bc5f6b70006d6$export$3e506c1ccc9cc1a7 = 5;
$d36bc5f6b70006d6$export$e26fe2ed2fa76875 = 1;
$d36bc5f6b70006d6$export$502329bbf4b505b1 = 4;
$d36bc5f6b70006d6$export$6e3807111c4874c4 = 3;
$d36bc5f6b70006d6$export$c27134553091fb3a = null;
$d36bc5f6b70006d6$export$33ee1acdc04fd2a2 = 2;
$d36bc5f6b70006d6$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d36bc5f6b70006d6$export$8352ce38b91d0c62 = function() {
    $d36bc5f6b70006d6$var$A || $d36bc5f6b70006d6$var$z || ($d36bc5f6b70006d6$var$A = !0, $d36bc5f6b70006d6$var$I($d36bc5f6b70006d6$var$J));
};
$d36bc5f6b70006d6$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d36bc5f6b70006d6$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$d36bc5f6b70006d6$export$d3dfb8e4810cb555 = function() {
    return $d36bc5f6b70006d6$var$y;
};
$d36bc5f6b70006d6$export$839f9183b0465a69 = function() {
    return $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$r);
};
$d36bc5f6b70006d6$export$72fdf0e06517287b = function(a) {
    switch($d36bc5f6b70006d6$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d36bc5f6b70006d6$var$y;
    }
    var c = $d36bc5f6b70006d6$var$y;
    $d36bc5f6b70006d6$var$y = b;
    try {
        return a();
    } finally{
        $d36bc5f6b70006d6$var$y = c;
    }
};
$d36bc5f6b70006d6$export$4b844e58a3e414b4 = function() {};
$d36bc5f6b70006d6$export$816d2913ae6b83b1 = function() {};
$d36bc5f6b70006d6$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d36bc5f6b70006d6$var$y;
    $d36bc5f6b70006d6$var$y = a;
    try {
        return b();
    } finally{
        $d36bc5f6b70006d6$var$y = c;
    }
};
$d36bc5f6b70006d6$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d36bc5f6b70006d6$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d36bc5f6b70006d6$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d36bc5f6b70006d6$var$f($d36bc5f6b70006d6$var$t, a), null === $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$r) && a === $d36bc5f6b70006d6$var$h($d36bc5f6b70006d6$var$t) && ($d36bc5f6b70006d6$var$B ? ($d36bc5f6b70006d6$var$E($d36bc5f6b70006d6$var$L), $d36bc5f6b70006d6$var$L = -1) : $d36bc5f6b70006d6$var$B = !0, $d36bc5f6b70006d6$var$K($d36bc5f6b70006d6$var$H, c - d))) : (a.sortIndex = e, $d36bc5f6b70006d6$var$f($d36bc5f6b70006d6$var$r, a), $d36bc5f6b70006d6$var$A || $d36bc5f6b70006d6$var$z || ($d36bc5f6b70006d6$var$A = !0, $d36bc5f6b70006d6$var$I($d36bc5f6b70006d6$var$J)));
    return a;
};
$d36bc5f6b70006d6$export$b5836b71941fa3ed = $d36bc5f6b70006d6$var$M;
$d36bc5f6b70006d6$export$cf845f2c119da08a = function(a) {
    var b = $d36bc5f6b70006d6$var$y;
    return function() {
        var c = $d36bc5f6b70006d6$var$y;
        $d36bc5f6b70006d6$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d36bc5f6b70006d6$var$y = c;
        }
    };
};

});





parcelRegister("1wrgB", function(module, exports) {

$parcel$export(module.exports, "AppProvider", function () { return $1f964efb45e2468a$export$c7dacf3845253dcf; });
$parcel$export(module.exports, "useApp", function () { return $1f964efb45e2468a$export$fca13ab91e1a6240; });

var $gCmhw = parcelRequire("gCmhw");

var $2eaC8 = parcelRequire("2eaC8");

var $16XvB = parcelRequire("16XvB");

var $gMErx = parcelRequire("gMErx");

var $hYmNv = parcelRequire("hYmNv");

var $12MXM = parcelRequire("12MXM");

var $3rEkS = parcelRequire("3rEkS");

var $eGYci = parcelRequire("eGYci");

var $i2uG6 = parcelRequire("i2uG6");

var $1BuUO = parcelRequire("1BuUO");

var $lGggQ = parcelRequire("lGggQ");

var $7hk6Y = parcelRequire("7hk6Y");

var $hVlFU = parcelRequire("hVlFU");

var $ke30W = parcelRequire("ke30W");

var $4aj47 = parcelRequire("4aj47");

var $k7Lgv = parcelRequire("k7Lgv");

var $eHxTy = parcelRequire("eHxTy");

var $hUL2G = parcelRequire("hUL2G");

var $411pF = parcelRequire("411pF");

var $bRDgQ = parcelRequire("bRDgQ");

var $gL9Nf = parcelRequire("gL9Nf");

var $cfBdF = parcelRequire("cfBdF");
const $1f964efb45e2468a$var$HOME_CITY_KEY = 'taki_home_city';
const $1f964efb45e2468a$var$readHomeCity = ()=>{
    try {
        const raw = localStorage.getItem($1f964efb45e2468a$var$HOME_CITY_KEY);
        if (!raw) return null;
        const v = JSON.parse(raw);
        return v && v.cityId ? v : null;
    } catch  {
        return null;
    }
};
const $1f964efb45e2468a$var$DATA_VERSION = '4.0'; // Persistence upgrade
/**
 * v13.22 — دمج صفحتين من الواجهة مع الحفاظ على الترتيب وبلا تكرار.
 * `primary` له الأولوية عند تكرار المعرّف (الصفحة الأحدث من القاعدة تغلب
 * النسخة القديمة في الذاكرة)، والترتيب النهائي `created_at` تنازلياً — نفس
 * ترتيب الاستعلام تماماً فلا «تقفز» البطاقات أمام المستخدم.
 */ const $1f964efb45e2468a$var$mergeDealPages = (primary, secondary)=>{
    const byId = new Map();
    for (const d of secondary)byId.set(d.id, d);
    for (const d of primary){
        const old = byId.get(d.id);
        // نحافظ على الحقول المُرطَّبة محلياً (تصويت المصداقية) كما في مسار البث
        byId.set(d.id, old ? {
            ...old,
            ...d,
            authReal: d.authReal ?? old.authReal,
            authFake: d.authFake ?? old.authFake,
            myAuthVote: old.myAuthVote === true || old.myAuthVote === false ? old.myAuthVote : d.myAuthVote,
            // v13.24 — لا نمحو تقييمات مُرطَّبة بمصفوفة فارغة. المسارات السريعة
            // (browse) لا تجلب صفوف التقييمات لأن البطاقة تكتفي بالمتوسط المثبَّت،
            // فلولا هذا الحارس لأفقدت صفحةَ المتجر وتفاصيلَ العرض مراجعاتها.
            ratings: Array.isArray(d.ratings) && d.ratings.length ? d.ratings : old.ratings && old.ratings.length ? old.ratings : d.ratings || []
        } : d);
    }
    return Array.from(byId.values()).sort((a, b)=>(Number(b.createdAt) || 0) - (Number(a.createdAt) || 0) || (a.id < b.id ? 1 : a.id > b.id ? -1 : 0));
};
const $1f964efb45e2468a$var$AppContext = /*#__PURE__*/ (0, $2eaC8.createContext)(undefined);
























const $1f964efb45e2468a$export$c7dacf3845253dcf = ({ children: children })=>{
    /**
     * v14.63 — تُقرأ من الجهاز أولاً ثم يصحّحها تفضيل الخادم عند الترطيب.
     * قبلها كانت تبدأ عربية دائماً، فمن اختار الإنجليزية يرى وميضاً عربياً في
     * كل فتح — و`ErrorBoundary` (مكوّن صنف لا يصل إلى السياق) يقرأ وسم اللغة
     * من المستند، فكان يعرض جدارَ خطأٍ عربياً لمستخدمٍ إنجليزي.
     * الخادم يبقى المرجع: `preferred_lang` يدهس هذه القيمة متى وصل.
     */ const [language, setLanguageState] = (0, $2eaC8.useState)(()=>{
        try {
            return localStorage.getItem('taki_lang') === 'en' ? 'en' : 'ar';
        } catch  {
            return 'ar';
        }
    });
    // Hydrate the public deal feed synchronously from the last snapshot so
    // the home screen paints real content on the FIRST frame — before the
    // ~300-500 ms (Tokyo ↔ KSA) network round-trip even starts. The live
    // fetch in initData still runs and overwrites this; the snapshot is a
    // render cache, never the source of truth.
    const [deals, setDeals] = (0, $2eaC8.useState)(()=>(0, $bRDgQ.readSnapshot)('deals') || []);
    // v14.26 — عدد غير المقروء **من الجدول كلّه**. عدّ النافذة المحلّية يكذب:
    // النافذة أحدث ١٠٠ صفّ، وحسابٌ قِيس عليه ٧٤٧ إشعاراً.
    const [notifUnread, setNotifUnread] = (0, $2eaC8.useState)(0);
    // v13.22 — نافذة الواجهة المُحمّلة + مؤشّر الصفحة التالية (keyset).
    // `deals` لم تعد «كل العروض» بل ما حُمّل من الواجهة؛ الصفحات المتخصّصة
    // (لوحة التاجر / صفحة المتجر) تستعلم عن متجرها مباشرة فتبقى مكتملة.
    const dealsCursorRef = (0, $2eaC8.useRef)(null);
    const loadingMoreRef = (0, $2eaC8.useRef)(false);
    const [hasMoreDeals, setHasMoreDeals] = (0, $2eaC8.useState)(false);
    const [loadingMoreDeals, setLoadingMoreDeals] = (0, $2eaC8.useState)(false);
    const dealsRef = (0, $2eaC8.useRef)(deals);
    (0, $2eaC8.useEffect)(()=>{
        dealsRef.current = deals;
    }, [
        deals
    ]);
    // Tracks deals the seller (or any local action) just wrote, so the
    // realtime echo can't clobber the optimistic status with a stale
    // packet — the recurring "pause flips back to active" bug. Each entry
    // is a per-deal timestamp; entries older than the guard window are
    // ignored.
    const recentLocalDealWritesRef = (0, $2eaC8.useRef)(new Map());
    const LOCAL_WRITE_GUARD_MS = 5000;
    const markLocalDealWrite = (0, $2eaC8.useCallback)((dealId)=>{
        recentLocalDealWritesRef.current.set(dealId, Date.now());
    }, []);
    const isRecentLocalDealWrite = (0, $2eaC8.useCallback)((dealId)=>{
        const ts = recentLocalDealWritesRef.current.get(dealId);
        if (!ts) return false;
        if (Date.now() - ts > LOCAL_WRITE_GUARD_MS) {
            recentLocalDealWritesRef.current.delete(dealId);
            return false;
        }
        return true;
    }, []);
    const [user, setUser] = (0, $2eaC8.useState)(()=>{
        try {
            return (0, $1BuUO.authService).getUser();
        } catch (e) {
            return null;
        }
    });
    // Admin "act as user" — v11.16 real session swap. The admin's tokens
    // are saved to localStorage before swapping; the Supabase session is
    // replaced with the target's via verifyOtp (edge function admin-impersonate
    // returns the hashed_token). After the swap every Supabase call from
    // this browser is authorized as the target — they can post, delete,
    // message, edit DB rows just as the target would. `impersonating` holds
    // the admin's identity for the exit banner.
    const [impersonating, setImpersonating] = (0, $2eaC8.useState)(()=>{
        try {
            // Clear leftover v11.15 keys (deprecated by v11.16 real-swap).
            localStorage.removeItem('TAKI_IMPERSONATE_TARGET');
            localStorage.removeItem('TAKI_IMPERSONATE_ADMIN');
            const raw = localStorage.getItem('TAKI_IMPERSONATION_SESSION');
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            return {
                adminId: parsed.adminId,
                adminName: parsed.adminName,
                targetId: parsed.targetId,
                startedAt: parsed.startedAt
            };
        } catch  {
            return null;
        }
    });
    // v11.17: drives the banner exit-button spinner + double-tap guard.
    const [stoppingImp, setStoppingImp] = (0, $2eaC8.useState)(false);
    const stoppingImpRef = (0, $2eaC8.useRef)(false);
    // v14.14 — مرجع حيّ للمستخدم: المؤقّتات ذات `[]` تحبس القيمة الأولى في
    // إغلاقها، فمن سجّل دخوله بعد الإقلاع يبقى «زائراً» في نظرها إلى الأبد.
    const userRef = (0, $2eaC8.useRef)(null);
    // True once the initial Supabase session check has resolved (success OR
    // failure). Distinguishes "still hydrating" from "definitively a guest".
    // Without this, AuthRedirector kicks logged-in admins off /admin on
    // refresh because user is briefly null while the session loads.
    const [isAuthReady, setIsAuthReady] = (0, $2eaC8.useState)(false);
    // Tracks the user id we last fully hydrated on an explicit sign-in.
    // Supabase JS can re-fire SIGNED_IN on tab focus / token reload; without
    // this guard a single focus would re-pull every list (the refetch storm
    // behind "الموقع ثقيل"). Cleared on sign-out so a re-login re-hydrates.
    const lastSignInHydratedIdRef = (0, $2eaC8.useRef)(null);
    (0, $2eaC8.useEffect)(()=>{
        userRef.current = user;
    }, [
        user
    ]);
    // v14.63 — الزائر يحفظ محلياً، فتظهر مفضلته من أول رسم بلا وميض.
    const [favorites, setFavorites] = (0, $2eaC8.useState)(()=>(0, $gL9Nf.guestFavorites).read());
    // يبدأ بنفس القيمة الأولى للحالة (مفضلة الزائر) لا بمصفوفة فارغة.
    const favoritesRef = (0, $2eaC8.useRef)(favorites);
    (0, $2eaC8.useEffect)(()=>{
        favoritesRef.current = favorites;
    }, [
        favorites
    ]);
    /**
     * v14.63 — ترطيب المفضلة **بمسارٍ واحد** لكل طرق الدخول الثلاث (استعادة
     * جلسة · حدث تسجيل دخول · إعادة مزامنة). ما حفظه الزائر قبل التسجيل يُدمج
     * في حسابه ثم يُمسح محلياً — وإلا ضاع في اللحظة التي يسجّل فيها.
     * 🪤 كان الدمج مكتوباً في مسارٍ واحد من الثلاثة، فالدخول من المسارين
     * الآخرين يمسح ما حفظه الزائر بلا أثر.
     */ const hydrateFavorites = (0, $2eaC8.useCallback)(async (uid)=>{
        const pending = (0, $gL9Nf.guestFavorites).read();
        if (pending.length) {
            await (0, $i2uG6.userRepository).mergeFavorites(pending);
            (0, $gL9Nf.guestFavorites).clear();
        }
        const f = await (0, $i2uG6.userRepository).getFavorites();
        setFavorites(f);
        favoritesRef.current = f;
        (0, $bRDgQ.writeSnapshot)('fav_' + uid, f);
    }, []);
    const [followedMerchants, setFollowedMerchants] = (0, $2eaC8.useState)([]);
    const [blockedMerchants, setBlockedMerchants] = (0, $2eaC8.useState)([]);
    const [notifications, setNotifications] = (0, $2eaC8.useState)([]);
    const [bookings, setBookings] = (0, $2eaC8.useState)([]);
    const [lastBookingEvent, setLastBookingEvent] = (0, $2eaC8.useState)(null);
    const [branches, setBranches] = (0, $2eaC8.useState)([]);
    // Status progression rank for reconciliation — higher = more advanced.
    // This prevents confirmed 'completed' or 'cancelled' states from being reverted
    // by stale or out-of-order Realtime updates (e.g. from a previous acknowledgement broadcast).
    const STATUS_RANK = {
        pending: 0,
        acknowledged: 1,
        completed: 2,
        cancelled: 2
    };
    // v12.76 — طابور مثل نوافذ التأكيد: الخانة الواحدة كانت تُسقط وعد نافذة
    // مفتوحة إذا طُلبت ثانية فيعلق منتظرها للأبد.
    const [promptQueue, setPromptQueue] = (0, $2eaC8.useState)([]);
    const promptConfig = promptQueue[0] || null;
    const closePrompt = (0, $2eaC8.useCallback)(()=>setPromptQueue((q)=>q.slice(1)), []);
    const customPrompt = (0, $2eaC8.useCallback)((message)=>{
        return new Promise((resolve)=>{
            setPromptQueue((q)=>[
                    ...q,
                    {
                        message: message,
                        resolve: resolve
                    }
                ]);
        });
    }, []);
    const reconcileStatus = (0, $2eaC8.useCallback)((localStatus, remoteStatus)=>{
        return (STATUS_RANK[localStatus] || 0) >= (STATUS_RANK[remoteStatus] || 0) ? localStatus : remoteStatus;
    }, []);
    // Custom Dialog State — v12.76: طابور FIFO بدل خانة واحدة. الخانة الواحدة
    // كانت تعني أن أي نافذة ثانية تظهر والأولى مفتوحة «تستبدلها» فلا يُستدعى
    // وعد الأولى أبداً — والكود المنتظر (await customConfirm/Alert) يعلق إلى
    // الأبد (جذر «النقرات تعلق»). الآن تُعرض النوافذ واحدة تلو الأخرى.
    const [dialogQueue, setDialogQueue] = (0, $2eaC8.useState)([]);
    const dialogConfig = dialogQueue[0] || null;
    const closeDialog = (0, $2eaC8.useCallback)(()=>setDialogQueue((q)=>q.slice(1)), []);
    // Post-purchase rating box: opens automatically for the BUYER the moment
    // their booking is marked completed (seller scanned the QR). Distinct
    // from the (removed) booking spam box — this is a one-time "rate the
    // store" prompt the owner explicitly asked for.
    const [ratingPrompt, setRatingPrompt] = (0, $2eaC8.useState)(null);
    // Two-step post-purchase flow (v11.97): 'auth' asks «is this offer real?»
    // first, then either 'rate' (rate / edit the store rating) or 'done'
    // (already rated → show the previous rating with EDIT + DELETE options —
    // editable since v12.30 so a merchant product-swap can't freeze old votes).
    const [ratingStep, setRatingStep] = (0, $2eaC8.useState)('auth');
    // Carries id + dealId so the «done» step can edit or delete the previous rating.
    const [prevReview, setPrevReview] = (0, $2eaC8.useState)(null);
    const [authVoting, setAuthVoting] = (0, $2eaC8.useState)(false);
    const promptedRatingRef = (0, $2eaC8.useRef)(new Set());
    /**
     * v14.06 — الحجوزات التي رفض المشتري تقييمها («لاحقاً»). تُحفَظ في الجهاز لا
     * في الذاكرة وحدها: من ضغط «لاحقاً» لا يجوز أن تُلاحقه النافذة عند كل فتح
     * للتطبيق. ومدة الحفظ ١٤ يوماً — أطول من نافذة الدالة (٧ أيام) فالرفض نهائيّ
     * عملياً، ويبقى بابُ التقييم مفتوحاً من صفحة العرض متى شاء.
     */ const RATE_DISMISS_KEY = 'taki_rate_dismissed_v1';
    const rateDismissedRef = (0, $2eaC8.useRef)({});
    const rateCheckingRef = (0, $2eaC8.useRef)(false);
    // مراجع (لا حالة) حتى لا يُعاد بناء دالة القياس مع كل تغيّر — فتُستدعى من
    // اشتراكات تُسجّل مرة واحدة، ولو أُعيد بناؤها لاحتجنا إعادة الاشتراك كلّه.
    const userIdRef = (0, $2eaC8.useRef)(undefined);
    const languageRef = (0, $2eaC8.useRef)('ar');
    const ratingPromptRef = (0, $2eaC8.useRef)(null);
    const ingestDealsRef = (0, $2eaC8.useRef)(()=>{});
    const checkRatingRef = (0, $2eaC8.useRef)(()=>{});
    const [ratingStars, setRatingStars] = (0, $2eaC8.useState)(5);
    const [ratingComment, setRatingComment] = (0, $2eaC8.useState)('');
    const [ratingSubmitting, setRatingSubmitting] = (0, $2eaC8.useState)(false);
    // Non-blocking realtime banner (booking/message). One slot — the newest
    // replaces the previous; the <InAppBanner> component auto-dismisses it.
    const [inAppBanner, setInAppBanner] = (0, $2eaC8.useState)(null);
    const dismissInAppBanner = (0, $2eaC8.useCallback)(()=>setInAppBanner(null), []);
    const customAlert = (0, $2eaC8.useCallback)((message)=>{
        return new Promise((resolve)=>{
            setDialogQueue((q)=>[
                    ...q,
                    {
                        type: 'alert',
                        message: message,
                        resolve: ()=>resolve(undefined)
                    }
                ]);
        });
    }, []);
    const customConfirm = (0, $2eaC8.useCallback)((message)=>{
        return new Promise((resolve)=>{
            setDialogQueue((q)=>[
                    ...q,
                    {
                        type: 'confirm',
                        message: message,
                        resolve: resolve
                    }
                ]);
        });
    }, []);
    // Refs that always point at the latest dialog callbacks. Used by code paths
    // (e.g. the auth listener) that capture stale closures otherwise.
    (0, $2eaC8.useEffect)(()=>{
        ratingPromptRef.current = ratingPrompt;
    }, [
        ratingPrompt
    ]);
    (0, $2eaC8.useEffect)(()=>{
        userIdRef.current = user?.id;
    }, [
        user?.id
    ]);
    (0, $2eaC8.useEffect)(()=>{
        languageRef.current = language;
    }, [
        language
    ]);
    // v14.63 — وسم لغة الصفحة واتجاهها: **مصدر واحد**. قبلها كان `document.dir`
    // يُكتب في ثلاثة مواضع متفرّقة (تبديل يدوي + مساري ترطيب)، و`<html lang>`
    // **لا يُكتب أبداً** — فيبقى النظام يظنّ الصفحة عربية مهما اختار المستخدم:
    // قارئ الشاشة ينطق الإنجليزية بمحرّك عربي، والمتصفّح يعرض ترجمةً في غير
    // محلّها، ومحرّكات البحث تُصنّف الصفحة لغةً خاطئة. الأثر الآن يعمل عند أول
    // رسم وعند كل تبديل وبعد أي ترطيب من تفضيل الخادم — لا يمكن أن يُنسى أحدها.
    // 🪤 `useLayoutEffect` لا `useEffect`: الأخير يعمل **بعد** رسم المتصفّح،
    // فكان التبديل يرسم إطاراً واحداً بالاتجاه القديم — وهذا ارتدادٌ عن الكتابة
    // المتزامنة التي كانت داخل `setLanguage`. الآن يُضبط قبل أول رسم.
    (0, $2eaC8.useLayoutEffect)(()=>{
        try {
            const el = document.documentElement;
            el.lang = language;
            el.dir = language === 'ar' ? 'rtl' : 'ltr';
            localStorage.setItem('taki_lang', language); // لأول رسمٍ في الزيارة القادمة
        } catch  {}
    }, [
        language
    ]);
    const customAlertRef = (0, $2eaC8.useRef)(customAlert);
    const customConfirmRef = (0, $2eaC8.useRef)(customConfirm);
    (0, $2eaC8.useEffect)(()=>{
        customAlertRef.current = customAlert;
    }, [
        customAlert
    ]);
    (0, $2eaC8.useEffect)(()=>{
        customConfirmRef.current = customConfirm;
    }, [
        customConfirm
    ]);
    // If we already have a cached deal feed, don't gate the UI behind the
    // full-screen loader — show the cached content instantly and let the
    // background fetch swap it in. Only a true cold start (no snapshot)
    // shows the spinner.
    const [loading, setLoading] = (0, $2eaC8.useState)(()=>!((0, $bRDgQ.readSnapshot)('deals') || []).length);
    const [topLocation, setTopLocationState] = (0, $2eaC8.useState)({
        region: '',
        city: '',
        mall: ''
    });
    const [homeCity, setHomeCityState] = (0, $2eaC8.useState)(()=>$1f964efb45e2468a$var$readHomeCity());
    const setHomeCity = (0, $2eaC8.useCallback)((c)=>{
        setHomeCityState(c);
        try {
            if (c && c.cityId) localStorage.setItem($1f964efb45e2468a$var$HOME_CITY_KEY, JSON.stringify(c));
            else localStorage.removeItem($1f964efb45e2468a$var$HOME_CITY_KEY);
        } catch  {}
    }, []);
    const [notifKeywords, setNotifKeywords] = (0, $2eaC8.useState)([]);
    const [smartAlerts, setSmartAlerts] = (0, $2eaC8.useState)([]);
    const [storeProfiles, setStoreProfiles] = (0, $2eaC8.useState)(()=>(0, $bRDgQ.readSnapshot)('sellers') || {});
    /**
     * v13.80 — جلب ملفات المتاجر **عند الحاجة** بدل تنزيل الدليل كله.
     *
     * دليل المتاجر صار مسقوفاً بألف متجر عند الفتح (`SELLER_DIRECTORY_CAP`).
     * هذه الدالة تسدّ الفارق: أي متجر يظهر عرضه على الشاشة أو تُفتح صفحته ولا
     * نملك ملفه — يُطلب بمعرّفه وحده. الطلبات تُجمَّع في دفعة واحدة كل ٢٥٠
     * مللي، ولا يُطلب معرّف مرتين (`inFlight`)، فلا عاصفة طلبات مهما تعدّدت
     * البطاقات الظاهرة.
     */ const storeProfilesRef = (0, $2eaC8.useRef)(storeProfiles);
    (0, $2eaC8.useEffect)(()=>{
        storeProfilesRef.current = storeProfiles;
    }, [
        storeProfiles
    ]);
    const pendingStoreIdsRef = (0, $2eaC8.useRef)(new Set());
    const inFlightStoreIdsRef = (0, $2eaC8.useRef)(new Set());
    const storeFetchTimerRef = (0, $2eaC8.useRef)(null);
    const flushStoreProfileFetch = (0, $2eaC8.useCallback)(async ()=>{
        storeFetchTimerRef.current = null;
        const ids = Array.from(pendingStoreIdsRef.current);
        pendingStoreIdsRef.current.clear();
        if (ids.length === 0) return;
        ids.forEach((id)=>inFlightStoreIdsRef.current.add(id));
        try {
            const rows = await (0, $i2uG6.userRepository).getSellersByIds(ids);
            if (rows.length > 0) setStoreProfiles((prev)=>{
                const merged = {
                    ...prev
                };
                rows.forEach((r)=>{
                    merged[r.id] = r;
                });
                return merged;
            });
        } catch (e) {
            (0, $4aj47.logger).warn('ensureStoreProfiles failed:', e);
        } finally{
            // نُبقي المعرّف في «قيد الطلب» حتى لو عاد فارغاً (متجر محذوف أو
            // محجوب) فلا ندخل في حلقة طلبٍ أبدية على معرّف لا صفّ له.
            ids.forEach((id)=>inFlightStoreIdsRef.current.add(id));
        }
    }, []);
    const ensureStoreProfiles = (0, $2eaC8.useCallback)((ids)=>{
        let added = false;
        for (const raw of ids){
            const id = (raw || '').trim();
            if (!id) continue;
            if (storeProfilesRef.current[id]) continue;
            if (inFlightStoreIdsRef.current.has(id)) continue;
            if (pendingStoreIdsRef.current.has(id)) continue;
            pendingStoreIdsRef.current.add(id);
            added = true;
        }
        if (!added || storeFetchTimerRef.current) return;
        storeFetchTimerRef.current = setTimeout(()=>{
            flushStoreProfileFetch();
        }, 250);
    }, [
        flushStoreProfileFetch
    ]);
    // كل عرض في النافذة يحتاج اسم متجره وشعاره — فمتى تغيّرت النافذة (فتح،
    // صفحة تالية، عروض متجر مُدخَلة) نسدّ الناقص فوراً. v13.80
    (0, $2eaC8.useEffect)(()=>{
        if (deals.length === 0) return;
        ensureStoreProfiles(deals.map((d)=>d.storeId));
    }, [
        deals,
        ensureStoreProfiles
    ]);
    (0, $2eaC8.useEffect)(()=>()=>{
            if (storeFetchTimerRef.current) clearTimeout(storeFetchTimerRef.current);
        }, []);
    // v11.23 — active sponsors (راعٍ رسمي), keyed by storeId. Loaded once on
    // mount and refreshed via realtime so an admin grant/revoke reflects live.
    const [sponsors, setSponsors] = (0, $2eaC8.useState)({});
    (0, $2eaC8.useEffect)(()=>{
        let alive = true;
        const load = async ()=>{
            const list = await (0, $ke30W.sponsorRepository).getActive();
            if (!alive) return;
            const map = {};
            for (const s of list)map[s.storeId] = s;
            setSponsors(map);
        };
        load();
        let channel;
        (async ()=>{
            const { supabase: supabase } = await Promise.resolve((parcelRequire("hUL2G")));
            if (!alive) return;
            channel = supabase.channel('sponsors-live').on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: 'sponsors'
            }, ()=>{
                load();
            }).subscribe();
        })();
        return ()=>{
            alive = false;
            if (channel) Promise.resolve((parcelRequire("hUL2G"))).then(({ supabase: supabase })=>supabase.removeChannel(channel));
        };
    }, []);
    // Platform-wide feature flags read from `platform_settings`. Defaults are
    // conservative (off) so the UI never accidentally exposes a section before
    // the admin opts in. Realtime listener below keeps every client in sync
    // the instant the admin flips a toggle.
    const [platformSettings, setPlatformSettings] = (0, $2eaC8.useState)(()=>{
        // v12.44 — «هوية المواسم»: apply the cached season skin during the very
        // first render (before paint) so returning visitors never see the base
        // identity flash in before the themed colors arrive from the server.
        let cachedSeason = '';
        try {
            cachedSeason = localStorage.getItem('TAKI_SEASON') || '';
            if (cachedSeason) document.documentElement.setAttribute('data-season', cachedSeason);
        } catch  {}
        return (0, $12MXM.defaultPlatformSettings)(cachedSeason);
    });
    // v12.48 — تمنع SeasonalGate من redirect مبكر قبل وصول نوافذ الحملة
    const [platformSettingsReady, setPlatformSettingsReady] = (0, $2eaC8.useState)(false);
    // v12.51 — «مرونة» تبديل الثيم (طلب ناصر): صنف مؤقت على <html> يفعّل
    // transition لونياً ناعماً (~0.35s) لكل العناصر أثناء تبديل داكن/فاتح أو
    // تبدّل الموسم، ثم يُزال فلا يبقى أي أثر على أداء التمرير (مهم لآيفون X).
    const themeAnimTimer = (0, $2eaC8.useRef)(0);
    const animateThemeSwap = (0, $2eaC8.useCallback)(()=>{
        try {
            const el = document.documentElement;
            el.classList.add('theme-anim');
            window.clearTimeout(themeAnimTimer.current);
            themeAnimTimer.current = window.setTimeout(()=>el.classList.remove('theme-anim'), 650);
        } catch  {}
    }, []);
    // Load platform settings + subscribe to realtime updates so admin toggles
    // propagate to every open tab without requiring a refresh.
    (0, $2eaC8.useEffect)(()=>{
        let cancelled = false;
        const apply = (key, value)=>{
            if (cancelled) return;
            const patch = (0, $12MXM.applyPlatformSetting)(key, value);
            if (!patch) return;
            // أثر الموسم على DOM يبقى هنا: تبديلُه realtime ينساب بنعومة.
            if (key === 'seasonal_theme') {
                animateThemeSwap();
                (0, $12MXM.applySeasonSkin)(value);
            }
            setPlatformSettings(patch);
        };
        (async ()=>{
            try {
                const { data: data } = await (0, $hUL2G.supabase).from('platform_settings').select('key, value').in('key', (0, $12MXM.PLATFORM_SETTING_KEYS));
                (data || []).forEach((r)=>apply(r.key, r.value));
            } catch (e) {
                console.warn('Platform settings fetch failed:', e);
            }
            if (!cancelled) setPlatformSettingsReady(true);
        })();
        const channel = (0, $hUL2G.supabase).channel('platform-settings-sync').on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'platform_settings'
        }, (payload)=>{
            const row = payload.new || payload.old;
            if (row?.key) apply(row.key, payload.new?.value ?? row.value);
        }).subscribe();
        return ()=>{
            cancelled = true;
            try {
                (0, $hUL2G.supabase).removeChannel(channel);
            } catch  {}
        };
    }, []);
    const [darkMode, setDarkMode] = (0, $2eaC8.useState)(()=>{
        try {
            const stored = localStorage.getItem('TAKI_DARK_MODE');
            if (stored === '1') return true;
            if (stored === '0') return false;
            // first-time visitor: respect OS preference
            if (typeof window !== 'undefined' && window.matchMedia) return window.matchMedia('(prefers-color-scheme: dark)').matches;
        } catch  {}
        return false;
    });
    // Admin "view as" — lets an admin preview the app as a buyer or
    // seller without changing their actual role. Only meaningful when
    // user.userType === 'admin'; ignored otherwise.
    const [viewAs, setViewAsState] = (0, $2eaC8.useState)(()=>{
        const stored = localStorage.getItem('TAKI_VIEW_AS');
        return stored === 'buyer' || stored === 'seller' ? stored : null;
    });
    const setViewAs = (0, $2eaC8.useCallback)((role)=>{
        setViewAsState(role);
        if (role) localStorage.setItem('TAKI_VIEW_AS', role);
        else localStorage.removeItem('TAKI_VIEW_AS');
    }, []);
    // Apply dark mode class to document + persist preference
    (0, $2eaC8.useEffect)(()=>{
        if (darkMode) {
            document.documentElement.classList.add('dark-mode');
            document.documentElement.classList.remove('light-mode');
        } else {
            document.documentElement.classList.remove('dark-mode');
            document.documentElement.classList.add('light-mode');
        }
        try {
            localStorage.setItem('TAKI_DARK_MODE', darkMode ? '1' : '0');
        } catch  {}
    }, [
        darkMode
    ]);
    // v14.13 — لا يُطلب إذن الإشعارات عند الفتح بعد اليوم. 🪤 كان يُطلب لحظة
    // الإقلاع مقابل لا شيء يراه المستخدم، وأغلب الناس يرفضون، والرفض على الويب
    // شبه نهائي (لا يُعاد السؤال أبداً) — فكنّا نحرق الطلبة الوحيدة على لا شيء.
    // الطلب انتقل إلى زرّ صريح بعد أول حجز ناجح («تفعيل الإشعارات» في حجوزاتي
    // وفي الحساب). وهنا نكتفي بتحديث اشتراكٍ قائم لمن فعّلها فعلاً، كي يبقى
    // صفّه حيّاً ولا يكنسه تنظيف التسعين يوماً.
    (0, $2eaC8.useEffect)(()=>{
        (0, $k7Lgv.pushService).refreshIfEnabled().catch(()=>{});
    }, []);
    const toggleDarkMode = (0, $2eaC8.useCallback)(()=>{
        // v12.54 — «مرونة ٤K» (طلب ناصر): على الأجهزة الداعمة (iOS 18+/Chrome)
        // نلفّ التبديل في View Transition = تلاشٍ متقاطع لكامل الشاشة، كل
        // البكسلات (حتى التدرجات والصور) تتحول معاً بلا أي قفزة. الأجهزة
        // الأقدم تبقى على الانتقال اللوني المؤقت theme-anim (v12.51).
        const doc = document;
        if (typeof doc.startViewTransition === 'function') {
            doc.startViewTransition(()=>{
                (0, $16XvB.flushSync)(()=>setDarkMode((prev)=>!prev));
            });
            return;
        }
        animateThemeSwap();
        setDarkMode((prev)=>!prev);
    }, [
        animateThemeSwap
    ]);
    // Periodic expiry check — every 30s. When a deal crosses its expiry,
    // we flip the local status AND push the change to Supabase so every
    // other device sees the same expiry without waiting for their own
    // timer to fire.
    // v14.14 — المزامنة **لصاحب العرض وحده**. كان كل زائر (ومنهم الزائر
    // المجهول) يحاول الكتابة لكل عرض منتهٍ على شاشته كل ٣٠ ثانية، وترفضه RLS
    // دائماً: طلب شبكة ضائع + سطر `permission denied for table deals` أحمر في
    // سجلّ كل زائر — وسجلٌّ مليء بأخطاء متوقَّعة يُخفي الخطأ الحقيقي حين يقع.
    (0, $2eaC8.useEffect)(()=>{
        const interval = setInterval(()=>{
            setDeals((prevDeals)=>{
                const now = Date.now();
                const expiringIds = [];
                const updatedDeals = prevDeals.map((deal)=>{
                    if (deal.status === 'expired') return deal;
                    const lifespanMs = (deal.expiresInMinutes || 120) * 60000;
                    if (now > deal.createdAt + lifespanMs) {
                        expiringIds.push(deal.id);
                        return {
                            ...deal,
                            status: 'expired'
                        };
                    }
                    return deal;
                });
                if (expiringIds.length === 0) return prevDeals;
                // Best-effort server sync — only the seller's RLS allows the
                // write, so other clients silently fail and rely on realtime
                // when the seller's client makes the same flip.
                expiringIds.forEach((id)=>{
                    const deal = updatedDeals.find((d)=>d.id === id);
                    // صاحب العرض وحده تسمح له RLS بالكتابة — فلا نطلب ما نعلم رفضه.
                    if (deal && userRef.current?.id && deal.storeId === userRef.current.id) (0, $eGYci.dealRepository).save(deal).catch(()=>{});
                });
                return updatedDeals;
            });
        }, 30000);
        return ()=>clearInterval(interval);
    }, []);
    // Freshness poll — while the app is in the FOREGROUND, re-pull deals every
    // 30s so a deal published/updated from the bot (or another device) shows up
    // even if its realtime packet was dropped. The deals websocket is dropped
    // silently on iOS Safari far more often than the notifications/bookings
    // ones, and the heartbeat can't tell (any realtime event keeps it "alive").
    // Deals-only = one small query, and it's PAUSED entirely while backgrounded
    // so it costs nothing in the user's pocket. v12.06
    (0, $2eaC8.useEffect)(()=>{
        let cancelled = false;
        const poll = ()=>{
            if (document.visibilityState !== 'visible') return;
            if (typeof navigator !== 'undefined' && navigator.onLine === false) return;
            // v13.22 — الاستطلاع الدوري يجدّد **الصفحة الأولى** ويدمجها فوق
            // المُحمّل (كان يُعيد تنزيل الكتالوج كله كل ٣٠ ثانية لكل جهاز).
            (0, $eGYci.dealRepository).getFeedPage().then(({ deals: firstPage })=>{
                if (cancelled || !firstPage?.length) return;
                setDeals((prev)=>{
                    const merged = $1f964efb45e2468a$var$mergeDealPages(firstPage, prev);
                    (0, $bRDgQ.writeSnapshot)('deals', merged.slice(0, (0, $eGYci.DEALS_PAGE_SIZE) * 2));
                    return merged;
                });
            }).catch(()=>{});
        };
        const interval = setInterval(poll, 30000);
        return ()=>{
            cancelled = true;
            clearInterval(interval);
        };
    }, []);
    // Note: REAL-TIME DEAL MATCHING ENGINE moved lower to avoid initialization errors.
    (0, $2eaC8.useEffect)(()=>{
        let isInitializing = false;
        // SAFETY: even if every Supabase call hangs (cold start, dropped
        // packet, RLS misconfig), auth must NEVER block the UI for more than
        // 2.5s. After that we treat the visitor as a guest and let them in.
        const safetyTimer = setTimeout(()=>{
            setIsAuthReady(true);
            setLoading(false);
        }, 2500);
        const initData = async ()=>{
            if (isInitializing) return;
            isInitializing = true;
            try {
                (0, $4aj47.logger).info("\uD83D\uDE80 Initializing App Context (Direct Remote Only)...");
                (0, $4aj47.logger).info("\uD83D\uDCE1 Fetching state from remote...");
                setLoading(true);
                // FAST PATH — auth check on its own. As soon as it resolves
                // (success or failure), we flip isAuthReady so protected routes
                // can render without waiting for deals/sellers/notifications.
                (0, $i2uG6.userRepository).getCurrentUser().then(async (currentUser)=>{
                    if (currentUser) {
                        // v11.16: real session swap means Supabase already
                        // reports the target as the current user (when
                        // impersonating). Sanity-check that the stored
                        // impersonation metadata still matches the live
                        // session — if it drifted (admin manually restored
                        // session elsewhere), clear the stale localStorage.
                        try {
                            const raw = localStorage.getItem('TAKI_IMPERSONATION_SESSION');
                            if (raw) {
                                const parsed = JSON.parse(raw);
                                if (parsed.targetId && parsed.targetId !== currentUser.id) {
                                    localStorage.removeItem('TAKI_IMPERSONATION_SESSION');
                                    setImpersonating(null);
                                }
                            }
                        } catch  {}
                        (0, $4aj47.logger).info(`\u{1F464} Session found: ${currentUser.name}`);
                        setUser(currentUser);
                        // v14.82 — اختيارُ الحساب في القياس يسود على هذا
                        // الجهاز، فمن أوقفه من جوّاله يجده موقوفاً على
                        // حاسبه. قراءةٌ فقط — لا يُكتب من هنا شيء، وإلا
                        // دهس جهازٌ لم يُضبط قطّ اختيارَ جهازٍ ضُبط عمداً.
                        (0, $411pF.syncAnalyticsConsentFromAccount)();
                        // initData is now the single owner of cold-load
                        // hydration. The profile is already in hand, so
                        // populate the follow/keyword/smart-alert/language
                        // slices here with ZERO extra network calls. The
                        // auth listener used to re-do all of this on
                        // INITIAL_SESSION (every page open) — that duplicate
                        // pass is now skipped (see onAuthStateChange).
                        setFollowedMerchants(currentUser.followedMerchants || []);
                        setBlockedMerchants(currentUser.blockedMerchants || []);
                        setNotifKeywords(currentUser.notifKeywords || []);
                        setSmartAlerts(currentUser.smartAlerts || []);
                        const cuLang = currentUser.preferredLang;
                        if (cuLang === 'ar' || cuLang === 'en') setLanguageState(cuLang);
                        // Mark this id as hydrated so a SIGNED_IN that
                        // Supabase re-fires on focus doesn't re-pull.
                        lastSignInHydratedIdRef.current = currentUser.id;
                        const uid = currentUser.id;
                        // Instant paint of the user's own lists from the
                        // last snapshot (keyed by uid so a shared device
                        // never shows the previous account). The live
                        // fetch below overwrites these.
                        const snapFav = (0, $bRDgQ.readSnapshot)('fav_' + uid);
                        if (snapFav) setFavorites(snapFav);
                        const snapNotif = (0, $bRDgQ.readSnapshot)('notif_' + uid);
                        if (snapNotif) setNotifications(snapNotif);
                        const snapBk = (0, $bRDgQ.readSnapshot)('bk_' + uid);
                        if (snapBk) setBookings(snapBk);
                        // Background hydration of user-specific data — does
                        // not gate isAuthReady; pages render immediately.
                        Promise.allSettled([
                            // v14.63 — ما حفظه الزائر قبل التسجيل يُدمج في حسابه
                            // ثم يُمسح محلياً، فلا يضيع ولا يتكرّر.
                            hydrateFavorites(uid),
                            (0, $lGggQ.notificationRepository).browsePage(null, 100).then((p)=>{
                                setNotifications(p.rows);
                                setNotifUnread(p.unreadTotal);
                                (0, $bRDgQ.writeSnapshot)('notif_' + uid, p.rows);
                            }),
                            Promise.resolve((parcelRequire("7hk6Y"))).then(({ bookingRepository: bookingRepository })=>// Pass the deals we already have so getByUser
                                // does NOT re-fetch the entire deals + ratings
                                // tables (a duplicate Tokyo round-trip on the
                                // critical path).
                                bookingRepository.getByUser(uid, dealsRef.current).then((b)=>{
                                    setBookings(b);
                                    (0, $bRDgQ.writeSnapshot)('bk_' + uid, b);
                                })),
                            // Sellers/admins use branches for the "📍 لوكيشن سابق"
                            // chip picker. Buyers don't need them — skip the
                            // round-trip for them.
                            currentUser.userType === 'seller' || currentUser.userType === 'admin' ? (0, $hVlFU.branchRepository).listByMerchant(uid).then(setBranches) : Promise.resolve()
                        ]).catch(()=>{});
                        // v14.06 — تقييم فات صاحبه (بلاغ ناصر): نقيس المعلّق من
                        // القاعدة بعد جهوز الجلسة. التأخير الصغير ليقرأ التقييم
                        // السابق من العروض المحمَّلة فيعرض «تعديل» لا «جديد».
                        setTimeout(()=>checkRatingRef.current(), 2500);
                    }
                }).catch((err)=>console.warn('Auth check failed:', err)).finally(()=>{
                    clearTimeout(safetyTimer);
                    setIsAuthReady(true);
                });
                // PARALLEL — global data fetch. Doesn't block auth gate.
                Promise.allSettled([
                    // v13.22 — أول صفحة فقط بدل الكتالوج كله (الترقيم بالمفتاح)
                    (0, $eGYci.dealRepository).getFeedPage().then(({ deals: firstPage, nextCursor: nextCursor, hasMore: hasMore })=>{
                        if (firstPage) {
                            setDeals(firstPage);
                            dealsCursorRef.current = nextCursor;
                            setHasMoreDeals(hasMore);
                            (0, $bRDgQ.writeSnapshot)('deals', firstPage);
                        }
                    }),
                    (0, $i2uG6.userRepository).getAllSellers().then((sellers)=>{
                        if (sellers) {
                            const profiles = {};
                            sellers.forEach((s)=>{
                                profiles[s.id] = s;
                            });
                            setStoreProfiles(profiles);
                            (0, $bRDgQ.writeSnapshot)('sellers', profiles);
                        }
                    })
                ]).finally(()=>{
                    setLoading(false);
                });
            } catch (error) {
                console.error("\u274C Failed to initialize app data:", error);
                clearTimeout(safetyTimer);
                setLoading(false);
                setIsAuthReady(true);
            } finally{
                isInitializing = false;
            }
        };
        initData();
        // SECURITY: Removed window.appContextSetters debug backdoor
        // Supabase Real-Time Auth Listener
        const authListenerPromise = Promise.resolve((parcelRequire("hUL2G"))).then(({ supabase: supabase })=>{
            try {
                const { data: data } = supabase.auth.onAuthStateChange(async (event, session)=>{
                    try {
                        // Explicit sign-out branch — without this, logging out
                        // left `user` populated until a full reload, so the UI
                        // showed the previous account on a guest session.
                        if (event === 'SIGNED_OUT' || !session?.user && event !== 'INITIAL_SESSION') {
                            // v11.16: drop impersonation state too. Note this
                            // ALSO fires when the admin gracefully stops
                            // impersonating — but `stopImpersonating` already
                            // restored admin's session BEFORE this listener
                            // would fire SIGNED_OUT, so this branch only runs
                            // for an actual sign-out / token expiry.
                            try {
                                localStorage.removeItem('TAKI_IMPERSONATION_SESSION');
                            } catch  {}
                            setImpersonating(null);
                            setUser(null);
                            (0, $1BuUO.authService).setUser(null);
                            setBookings([]);
                            setNotifications([]);
                            setFavorites([]);
                            setFollowedMerchants([]);
                            setBranches([]);
                            setIsAuthReady(true);
                            // Re-login (even same account) must re-hydrate.
                            lastSignInHydratedIdRef.current = null;
                            // Wipe every cached snapshot so a shared device
                            // never paints the previous account's lists.
                            (0, $bRDgQ.clearSnapshots)();
                            return;
                        }
                        if (session?.user) {
                            const spUser = session.user;
                            const meta = spUser.user_metadata || {};
                            // Optimistic profile from the JWT — this is enough to
                            // unlock the UI immediately. We rebuild from the real
                            // DB row in the background and merge once it lands, so
                            // a slow `users` query (RLS, cold start, dropped
                            // packet) never leaves the login button hanging.
                            const optimisticProfile = {
                                id: spUser.id,
                                name: meta.name || "\u0645\u0633\u062A\u062E\u062F\u0645",
                                phone: meta.phone || spUser.phone || '',
                                email: meta.email || spUser.email || '',
                                userType: meta.user_type || 'buyer',
                                shop: meta.shop || '',
                                contactPhone: meta.contact_phone || meta.phone || spUser.phone || '',
                                address: meta.address || '',
                                savings: 0,
                                bookingsCount: 0,
                                notifKeywords: [],
                                smartAlerts: [],
                                preferredLang: 'ar',
                                followedMerchants: [],
                                blockedMerchants: []
                            };
                            setUser((prev)=>{
                                if (prev && prev.id !== optimisticProfile.id) {
                                    setBookings([]);
                                    setNotifications([]);
                                    setFavorites([]);
                                    setBranches([]);
                                }
                                return prev && prev.id === optimisticProfile.id ? prev : optimisticProfile;
                            });
                            // Mirror to authService memory and unlock the UI
                            // even on the very first event — without this, a
                            // refreshed protected route could still bounce a
                            // signed-in user to '/' before the canonical row
                            // arrives.
                            (0, $1BuUO.authService).setUser(optimisticProfile);
                            setIsAuthReady(true);
                            clearTimeout(safetyTimer);
                            // ── Heavy hydration gate ───────────────────────
                            // The lightweight optimistic profile above already
                            // unlocks the UI correctly. The expensive part
                            // (canonical findById + soft-delete recovery RPC +
                            // re-pull of bookings/notifications/favorites/
                            // followed/branches) must run ONLY on an explicit
                            // sign-in, and only once per signed-in id:
                            //  • INITIAL_SESSION  → initData() already owns the
                            //    full cold-load hydration (no duplicate).
                            //  • TOKEN_REFRESHED  → fires every ~50 min & on
                            //    some focus events — must never refetch.
                            //  • USER_UPDATED     → fires on every
                            //    supabase.auth.updateUser (e.g. the favorites
                            //    metadata mirror) — must never refetch.
                            // This single gate removes the bulk of the
                            // "الموقع ثقيل" duplicate-request storm. Realtime +
                            // the focus/visibility re-sync keep data live.
                            if (event !== 'SIGNED_IN' || lastSignInHydratedIdRef.current === spUser.id) return;
                            lastSignInHydratedIdRef.current = spUser.id;
                            // Fetch the canonical profile in the background — never
                            // block the auth callback on it.
                            const { userRepository: ur } = await Promise.resolve((parcelRequire("i2uG6")));
                            const existingProfile = await ur.findById(spUser.id).catch(()=>null);
                            const profile = existingProfile || optimisticProfile;
                            if (existingProfile) {
                                setUser(existingProfile);
                                setFollowedMerchants(existingProfile.followedMerchants || []);
                                setBlockedMerchants(existingProfile.blockedMerchants || []);
                            }
                            // 30-day soft-delete recovery: if the user signs in while
                            // their account is in the grace window, prompt them to
                            // restore it. (migration v9.17 / soft_delete_my_account)
                            try {
                                const { data: status } = await supabase.rpc('get_my_account_status');
                                const row = Array.isArray(status) ? status[0] : status;
                                if (row?.deleted_at) {
                                    const daysLeft = Number(row.days_left) || 0;
                                    const wantsRestore = await customConfirmRef.current(`\u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{633}\u{627}\u{628} \u{645}\u{62D}\u{630}\u{648}\u{641} \u{648}\u{633}\u{64A}\u{64F}\u{645}\u{62D}\u{649} \u{646}\u{647}\u{627}\u{626}\u{64A}\u{627}\u{64B} \u{62E}\u{644}\u{627}\u{644} ${daysLeft} \u{64A}\u{648}\u{645}. \u{647}\u{644} \u{62A}\u{631}\u{64A}\u{62F} \u{627}\u{633}\u{62A}\u{631}\u{62C}\u{627}\u{639}\u{647} \u{627}\u{644}\u{622}\u{646}\u{61F}`);
                                    if (wantsRestore) {
                                        const { data: restored, error: restoreErr } = await supabase.rpc('restore_my_account');
                                        if (!restoreErr && restored) await customAlertRef.current("\u2705 \u062A\u0645 \u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u062D\u0633\u0627\u0628\u0643 \u0628\u0646\u062C\u0627\u062D");
                                        else await customAlertRef.current("\u274C \u062A\u0639\u0630\u0651\u0631 \u0627\u0633\u062A\u0631\u062C\u0627\u0639 \u0627\u0644\u062D\u0633\u0627\u0628 \u2014 \u0627\u0646\u062A\u0647\u062A \u0641\u062A\u0631\u0629 \u0627\u0644\u0633\u0645\u0627\u062D");
                                    } else {
                                        // User declined — sign them back out so the deletion stands.
                                        try {
                                            await supabase.auth.signOut();
                                        } catch  {}
                                        setUser(null);
                                        return;
                                    }
                                }
                            } catch  {}
                            // Background hydration — never await. Each call updates state
                            // independently as it resolves, so the UI renders the new user
                            // immediately and progressively fills in.
                            Promise.resolve((parcelRequire("7hk6Y"))).then(({ bookingRepository: br })=>br.getByUser(spUser.id, dealsRef.current).then((b)=>{
                                    setBookings(b);
                                    (0, $bRDgQ.writeSnapshot)('bk_' + spUser.id, b);
                                }).catch(()=>{}));
                            Promise.resolve((parcelRequire("lGggQ"))).then(({ notificationRepository: nr })=>nr.browsePage(null, 100).then((p)=>{
                                    setNotifications(p.rows);
                                    setNotifUnread(p.unreadTotal);
                                    (0, $bRDgQ.writeSnapshot)('notif_' + spUser.id, p.rows);
                                }).catch(()=>{}));
                            hydrateFavorites(spUser.id).catch(()=>{});
                            (0, $i2uG6.userRepository).getFollowedMerchants().then(setFollowedMerchants).catch(()=>{});
                            // Branches feed the "📍 لوكيشن سابق" chip picker;
                            // only sellers/admins need them.
                            if (profile.userType === 'seller' || profile.userType === 'admin') (0, $hVlFU.branchRepository).listByMerchant(spUser.id).then(setBranches).catch(()=>{});
                            else setBranches([]);
                            setNotifKeywords(profile.notifKeywords || []);
                            setSmartAlerts(profile.smartAlerts || []);
                            // Hydrate language from server preference
                            const pref = profile.preferredLang;
                            if (pref === 'ar' || pref === 'en') setLanguageState(pref);
                            // Targeted cleanup — keep global-sync alive so
                            // public deal/store updates still flow even when
                            // no one is signed in.
                            const channels = supabase.getChannels();
                            channels.filter((c)=>typeof c?.topic === 'string' && c.topic.startsWith('realtime:user-sync-')).forEach((c)=>supabase.removeChannel(c));
                        }
                    } catch (authError) {
                        console.error("\u274C Auth state change error:", authError);
                    }
                });
                return data;
            } catch (listenerError) {
                console.error("\u274C Failed to setup auth listener:", listenerError);
                return null;
            }
        });
        return ()=>{
            clearTimeout(safetyTimer);
            authListenerPromise.then((l)=>l?.subscription?.unsubscribe?.());
        };
    }, []);
    // ⚡️ STABILIZATION: Safety Timeout to prevent permanent "Loading" hang
    (0, $2eaC8.useEffect)(()=>{
        if (loading) {
            const timer = setTimeout(()=>{
                if (loading) {
                    console.warn("\u26A0\uFE0F App initialization taking too long. Forcing loading state to false.");
                    setLoading(false);
                }
            }, 8000);
            return ()=>clearTimeout(timer);
        }
    }, [
        loading
    ]);
    // Removing all storageService effect calls to comply with "No Local Storage" request
    const setTopLocation = (0, $2eaC8.useCallback)((loc)=>{
        setTopLocationState(loc);
    }, []);
    // Sound helper — throttled so local addNotification + realtime INSERT
    // don't double-ping for the same event.
    const lastSoundAtRef = (0, $2eaC8.useRef)(0);
    const playNotificationSound = (0, $2eaC8.useCallback)(()=>{
        const now = Date.now();
        if (now - lastSoundAtRef.current < 1500) return;
        lastSoundAtRef.current = now;
        try {
            const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');
            audio.volume = 0.5;
            audio.play().catch(()=>{}); // Browser might block auto-play
        } catch (e) {}
    }, []);
    // De-dupe للعرض المرئي: addNotification يعرض التنبيه محلياً ثم يحفظ الصف
    // بنفس الـid، والبث اللحظي يعيد نفس الصف بعد ~ثانية فكان يُعرض مرة ثانية
    // (لقطة ناصر: إشعاران متطابقان). الصوت كان محمياً بمؤقّت — العرض لم يكن.
    const shownAlertIdsRef = (0, $2eaC8.useRef)(new Map());
    const alertNotShownBefore = (0, $2eaC8.useCallback)((key)=>{
        if (!key) return true;
        const now = Date.now();
        const m = shownAlertIdsRef.current;
        m.forEach((t, k)=>{
            if (now - t > 300000) m.delete(k);
        }); // تنظيف كل ٥ دقائق
        if (m.has(key)) return false;
        m.set(key, now);
        return true;
    }, []);
    // Notification display helper — dedupeKey = معرّف الإشعار (نفسه محلياً وفي صدى البث)
    const showRealTimeAlert = (0, $2eaC8.useCallback)((title, body, dedupeKey)=>{
        if (!alertNotShownBefore(dedupeKey)) return;
        if ('Notification' in window && Notification.permission === 'granted') {
            const isAr = language === 'ar';
            new Notification(isAr ? title.ar : title.en, {
                body: isAr ? body.ar : body.en,
                icon: '/logo192.png'
            });
        }
        playNotificationSound();
    }, [
        language,
        playNotificationSound,
        alertNotShownBefore
    ]);
    const addNotification = (0, $2eaC8.useCallback)(async (userId, title, body, type = 'system', metadata)=>{
        const newNotif = {
            id: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 10)}`,
            userId: userId,
            title: title,
            body: body,
            type: type,
            metadata: metadata,
            isRead: false,
            createdAt: Date.now()
        };
        // Only mirror into local state if the local user is the recipient —
        // otherwise the sender's notif list would accumulate the receiver's
        // alerts (e.g. a buyer would see "New Booking!" notifs that belong to
        // the seller). The recipient's own client picks it up either via
        // their initial fetch or the realtime listener.
        if (user && user.id === userId) setNotifications((prev)=>{
            const updated = [
                newNotif,
                ...prev
            ];
            return updated;
        });
        // Background remote sync — fire-and-forget, the realtime listener on
        // the recipient's side picks it up and pushes a native browser alert.
        (0, $lGggQ.notificationRepository).save(newNotif).catch((err)=>console.warn('Notification remote sync deferred:', err?.message || err));
        // Native alert + sound only when the recipient is the local user.
        // نمرر id الإشعار — صدى البث اللحظي يحمل نفسه فلا يُعرض مرتين (v12.19).
        if (user && user.id === userId) showRealTimeAlert(title, body, newNotif.id);
    }, [
        user,
        showRealTimeAlert
    ]);
    const toggleFollowMerchant = (0, $2eaC8.useCallback)(async (merchantId)=>{
        const newFollows = followedMerchants.includes(merchantId) ? followedMerchants.filter((f)=>f !== merchantId) : [
            ...followedMerchants,
            merchantId
        ];
        // 1. Update State (Optimistic)
        setFollowedMerchants(newFollows);
        if (user) {
            // 2. Update cached user profile in memory
            const updatedUser = {
                ...user,
                followedMerchants: newFollows
            };
            setUser(updatedUser);
            (0, $1BuUO.authService).setUser(updatedUser);
            // 3. Update Supabase (Final Truth)
            // Trigger tr_follow_notification (migration v8.6) will handle the notification instantly
            await (0, $i2uG6.userRepository).saveProfile(updatedUser);
        }
    }, [
        followedMerchants,
        user
    ]);
    // Buyer blocks a merchant: their deals must vanish from Home/Nearby
    // and never trigger a smart-alert notification. The notification side
    // is enforced server-side (handle_deal_smart_notifications /
    // handle_smart_alerts_backfill skip blocked_merchants); the client
    // filters the lists. Blocking a followed store also drops the follow
    // (following a blocked store is contradictory).
    const toggleBlockMerchant = (0, $2eaC8.useCallback)(async (merchantId)=>{
        const isBlocked = blockedMerchants.includes(merchantId);
        const newBlocked = isBlocked ? blockedMerchants.filter((b)=>b !== merchantId) : [
            ...blockedMerchants,
            merchantId
        ];
        const newFollows = !isBlocked && followedMerchants.includes(merchantId) ? followedMerchants.filter((f)=>f !== merchantId) : followedMerchants;
        setBlockedMerchants(newBlocked);
        if (newFollows !== followedMerchants) setFollowedMerchants(newFollows);
        if (user) {
            const updatedUser = {
                ...user,
                blockedMerchants: newBlocked,
                followedMerchants: newFollows
            };
            setUser(updatedUser);
            (0, $1BuUO.authService).setUser(updatedUser);
            await (0, $i2uG6.userRepository).saveProfile(updatedUser);
        }
    }, [
        blockedMerchants,
        followedMerchants,
        user
    ]);
    /**
     * v14.63 — «المفضلة» صارت خاصّية حقيقية. ثلاثة فروق جوهرية عن القديم:
     *  ١) **نداءٌ واحد لكل نقرة** بدل قراءة-مفارقة-كتابة (أربع جولات شبكة)،
     *     فلا تضيع إحدى نقرتين سريعتين بسباق «آخر كاتبٍ يفوز».
     *  ٢) **تراجعٌ عند الفشل**: لا يبقى القلب ممتلئاً وقد رفضت القاعدة الحفظ.
     *  ٣) 🔴 **لا متابعة تلقائية للتاجر**: كان حفظ عرضٍ واحد يشترك المشتري
     *     صامتاً في كل إشعارات ذلك المتجر — بلا إفصاح ولا زرّ. الحفظ للعرض،
     *     والمتابعة لها زرّها المستقلّ.
     *  والزائر (غير المسجَّل) يحفظ في جهازه، وتُدمج مفضلته في حسابه عند الدخول.
     */ const toggleFavorite = (0, $2eaC8.useCallback)(async (id)=>{
        const prev = favoritesRef.current;
        const isAdding = !prev.includes(id);
        const next = isAdding ? [
            ...prev,
            id
        ] : prev.filter((f)=>f !== id);
        setFavorites(next);
        favoritesRef.current = next; // فوراً: نقرتان متتاليتان لا تتصادمان
        const uid = userRef.current?.id;
        if (!uid) {
            (0, $gL9Nf.guestFavorites).write(next);
            return;
        } // زائر: جهازه فقط
        (0, $bRDgQ.writeSnapshot)('fav_' + uid, next);
        const ok = isAdding ? await (0, $i2uG6.userRepository).addFavorite(id) : await (0, $i2uG6.userRepository).removeFavorite(id);
        if (!ok) {
            // 🪤 التراجع يُطبَّق على **هذا المعرّف وحده** لا بإعادة اللقطة
            // القديمة كاملة: نقرةٌ ثانية ناجحة أثناء انتظار الأولى كانت
            // ستُمحى معها. (كشفته المراجعة الخصمية قبل النشر.)
            const now = favoritesRef.current;
            const reverted = isAdding ? now.filter((f)=>f !== id) : now.includes(id) ? now : [
                ...now,
                id
            ];
            setFavorites(reverted);
            favoritesRef.current = reverted;
            (0, $bRDgQ.writeSnapshot)('fav_' + uid, reverted);
        }
    }, []);
    const updateStoreProfile = (0, $2eaC8.useCallback)((storeId, profile)=>{
        // Optimistic local update — UI reacts immediately.
        setStoreProfiles((prev)=>({
                ...prev,
                [storeId]: {
                    ...prev[storeId],
                    ...profile
                }
            }));
        // Persist to DB. Only the seller themselves can write their own row
        // (RLS), so skip the network call for stores owned by someone else.
        if (!user || user.id !== storeId) return;
        const merged = {
            ...user,
            contactPhone: profile.contactPhone ?? profile.phone ?? user.contactPhone,
            phone: profile.phone ?? user.phone,
            email: profile.email ?? user.email,
            avatar_url: profile.avatar_url ?? profile.avatar ?? user.avatar_url,
            bio: profile.bio ?? user.bio,
            address: profile.address ?? user.address,
            workingHours: profile.workingHours ?? user.workingHours
        };
        setUser(merged);
        (0, $1BuUO.authService).setUser(merged);
        (0, $i2uG6.userRepository).saveProfile(merged).catch((err)=>{
            console.error('Failed to persist store profile to DB:', err);
        });
    }, [
        user
    ]);
    const updateProfile = (0, $2eaC8.useCallback)(async (data)=>{
        if (!user) return;
        const updated = {
            ...user,
            ...data
        };
        setUser(updated);
        await (0, $i2uG6.userRepository).saveProfile(updated);
    }, [
        user
    ]);
    const checkMarketingAlerts = (0, $2eaC8.useCallback)(async (lat, lng)=>{
        if (!user) return;
        // Skip admin users entirely — pep-talks for sellers should not fire
        // for an admin even when their JWT user_metadata still says 'seller'
        // (legacy from registration). This was the root cause of "زد مبيعاتك"
        // showing on every refresh for admins.
        if (user.userType === 'admin') return;
        // Throttle: once per 24h. DB column `users.last_promo_check_at` is
        // the authoritative source — no local cache (would split-brain across
        // devices and let the same user see the same promo twice).
        const now = Date.now();
        const dayMs = 86400000;
        // ATOMIC 24h gate — a single conditional UPDATE *claims* the window.
        // The old read-then-stamp had a race: two near-simultaneous callers (the
        // sign-in timer racing the location watcher, or web + PWA on two devices)
        // both read the stale timestamp, both passed, and BOTH created the promo
        // → it arrived twice on every channel. Now Postgres serialises the row
        // UPDATE: the first commits the fresh timestamp, the second's WHERE no
        // longer matches and it gets 0 rows back → it bails. v11.77 (Task 6)
        try {
            const { supabase: supabase } = await Promise.resolve((parcelRequire("hUL2G")));
            const cutoffIso = new Date(now - dayMs).toISOString();
            const { data: claimed, error: error } = await supabase.from('users').update({
                last_promo_check_at: new Date(now).toISOString()
            }).eq('id', user.id).or(`last_promo_check_at.is.null,last_promo_check_at.lt.${cutoffIso}`).select('id');
            if (error) return; // on error, never risk a duplicate
            if (!claimed || claimed.length === 0) return; // window already claimed → skip
        } catch  {
            return;
        }
        try {
            // Fetch active campaigns from Supabase for this user type
            const { promoRepository: promoRepository } = await (parcelRequire("jCjMw"));
            const city = topLocation.city || undefined;
            const campaigns = await promoRepository.getActiveCampaigns(user.userType, city);
            if (campaigns.length > 0) for (const campaign of campaigns){
                const hasSeen = await promoRepository.hasSeenCampaign(campaign.id, user.id);
                if (!hasSeen) {
                    addNotification(user.id, {
                        ar: campaign.titleAr,
                        en: campaign.titleEn
                    }, {
                        ar: campaign.bodyAr,
                        en: campaign.bodyEn
                    }, 'marketing', {
                        campaignId: campaign.id,
                        imageUrl: campaign.imageUrl,
                        actionUrl: campaign.actionUrl,
                        actionLabelAr: campaign.actionLabelAr,
                        actionLabelEn: campaign.actionLabelEn
                    });
                    promoRepository.markAsSeen(campaign.id, user.id);
                    return; // Show one campaign at a time to avoid flooding
                }
            }
        } catch (e) {
            console.warn('Promo campaign fetch failed, falling back to local alerts:', e);
        }
        // ── Fallback: proximity-based alerts if no Supabase campaigns ──
        if (user.userType === 'buyer' && lat && lng) {
            const hasNearby = deals.some((d)=>{
                // v12.65 — المول المعروف يتقدم على GPS جهاز التاجر لحظة الإنشاء
                const dLoc = (0, $gMErx.getLocation)(d.locationId);
                const dLat = dLoc?.lat || d.mapLocation?.lat || 0;
                const dLng = dLoc?.lng || d.mapLocation?.lng || 0;
                return d.status === 'active' && (0, $3rEkS.getDistance)(lat, lng, dLat, dLng) <= 5;
            });
            if (hasNearby) addNotification(user.id, {
                ar: "\uD83D\uDCCD \u0639\u0631\u0648\u0636 \u0645\u0630\u0647\u0644\u0629 \u062D\u0648\u0644\u0643 \u0627\u0644\u0622\u0646!",
                en: "\uD83D\uDCCD Amazing deals near you!"
            }, {
                ar: "\u0647\u0646\u0627\u0643 \u0639\u0631\u0648\u0636 \u062D\u0635\u0631\u064A\u0629 \u0642\u0631\u064A\u0628\u0629 \u0645\u0646\u0643 \u062C\u062F\u0627\u064B\u060C \u0627\u0643\u062A\u0634\u0641\u0647\u0627 \u0627\u0644\u0622\u0646 \u0648\u0648\u0641\u0631 \u0623\u0643\u062B\u0631! \uD83D\uDECD\uFE0F",
                en: "There are exclusive deals very close to you, explore them now and save more! \uD83D\uDECD\uFE0F"
            }, 'marketing');
        } else if (user.userType === 'seller') addNotification(user.id, {
            ar: "\uD83D\uDCC8 \u0632\u062F \u0645\u0628\u064A\u0639\u0627\u062A\u0643 \u0627\u0644\u0622\u0646!",
            en: "\uD83D\uDCC8 Boost your sales now!"
        }, {
            ar: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u064A\u0628\u062D\u062B\u0648\u0646 \u0639\u0646 \u0639\u0631\u0648\u0636 \u062C\u062F\u064A\u062F\u0629 \u0641\u064A \u0645\u0646\u0637\u0642\u062A\u0643! \u0623\u0636\u0641 \u0639\u0631\u0636\u0627\u064B \u0627\u0644\u0622\u0646 \u0644\u062C\u0630\u0628\u0647\u0645. \uD83C\uDFEC",
            en: "Customers are looking for new deals in your area! Post a deal now to attract them. \uD83C\uDFEC"
        }, 'marketing');
    }, [
        user,
        deals,
        addNotification,
        topLocation
    ]);
    // Fire promotional alerts shortly after the user signs in, regardless
    // of whether they ever visit the Nearby page. Uses the 6-hour throttle
    // already inside checkMarketingAlerts so the user is not spammed.
    (0, $2eaC8.useEffect)(()=>{
        if (!user) return;
        const t = setTimeout(()=>{
            checkMarketingAlerts();
        }, 4000);
        return ()=>clearTimeout(t);
    }, [
        user?.id,
        checkMarketingAlerts
    ]);
    // ═══════════════════════════════════════════════════════════════════
    //  Live location (shoppers) — world-class, second-by-second tracking.
    //  If geolocation is already permitted we track silently on every app
    //  open (no nagging). Otherwise the UI shows an "enable" prompt. While
    //  the app is open we follow the user as they walk/drive and persist
    //  their position to `users.lat/lng` (throttled) so the platform can
    //  push "deals near you" by proximity — even when they're not looking.
    // ═══════════════════════════════════════════════════════════════════
    const liveUserRef = (0, $2eaC8.useRef)(null);
    (0, $2eaC8.useEffect)(()=>{
        liveUserRef.current = user;
    }, [
        user
    ]);
    const checkAlertsRef = (0, $2eaC8.useRef)(checkMarketingAlerts);
    (0, $2eaC8.useEffect)(()=>{
        checkAlertsRef.current = checkMarketingAlerts;
    }, [
        checkMarketingAlerts
    ]);
    const liveWatchRef = (0, $2eaC8.useRef)(null);
    const lastLiveRef = (0, $2eaC8.useRef)(null);
    const lastSaveRef = (0, $2eaC8.useRef)(null);
    const liveAlertedRef = (0, $2eaC8.useRef)(false);
    // v13.79 — نبدأ **عارفين**: آخر موقع معروف يُستعاد من ذاكرة الجهاز فوراً،
    // فلا تظهر دعوة «فعّل موقعك» في كل فتح، ولا تُحسب المسافات من الصفر بينما
    // ننتظر تثبيت GPS جديداً (قد لا يصل داخل المباني). المتتبّع الحيّ يصحّحه
    // خلال ثوانٍ. هذا هو سلوك تطبيقات التوصيل الذي طلبه ناصر.
    const rememberedFix = (0, $2eaC8.useMemo)(()=>(0, $hYmNv.readRememberedFix)(), []);
    const [liveLocation, setLiveLocation] = (0, $2eaC8.useState)(rememberedFix ? {
        lat: rememberedFix.lat,
        lng: rememberedFix.lng
    } : null);
    const [locationIsFresh, setLocationIsFresh] = (0, $2eaC8.useState)(rememberedFix ? (0, $hYmNv.isFreshFix)(rememberedFix.at) : false);
    const [locationPermission, setLocationPermission] = (0, $2eaC8.useState)('unknown');
    // Once a shopper turns live location ON we remember it here. iOS Safari has
    // NO usable Permissions API for geolocation, so on every relaunch the state
    // fell back to 'prompt' and the «فعّل موقعك» banner nagged again — even
    // though the OS still trusts the site. This flag lets us resume tracking
    // silently on open (and hide the banner) until an actual denial clears it.
    // v12.08
    const LIVE_LOC_KEY = 'taki_live_loc_on';
    // Persist the live fix to the account — throttled so a moving car doesn't
    // hammer the DB: first fix saves immediately, then only after a real move
    // (≥75 m) AND ≥60 s, or a 5-min heartbeat. Sellers are skipped (not shoppers).
    const persistLiveLocation = (0, $2eaC8.useCallback)(async (lat, lng)=>{
        const u = liveUserRef.current;
        // v13.11 (طلب ناصر): لا نكتب الموقع الحي إلا لحساب مشترٍ صِرف. التاجر —
        // وكذلك المتجر المملوك لأدمن — له موقع ثابت على الخريطة يحفظه من لوحته؛
        // لو كتبنا فوق users.lat/lng بموقع الجهاز الحي لضاع دبوس المتجر المحفوظ
        // (كان يظهر «معلومات الموقع غير متوفرة» ويطلب التفعيل كل مرة).
        if (!u?.id || u.userType !== 'buyer') return;
        const last = lastSaveRef.current;
        if (last) {
            const movedM = (0, $3rEkS.getDistance)(last.lat, last.lng, lat, lng) * 1000;
            const elapsed = Date.now() - last.at;
            if (!(movedM >= 75 && elapsed >= 60000 || elapsed >= 300000)) return;
        }
        lastSaveRef.current = {
            lat: lat,
            lng: lng,
            at: Date.now()
        };
        try {
            await (0, $hUL2G.supabase).from('users').update({
                lat: lat,
                lng: lng
            }).eq('id', u.id);
        } catch  {}
    }, []);
    const startLiveWatch = (0, $2eaC8.useCallback)(()=>{
        if (liveWatchRef.current != null) return;
        if (!('geolocation' in navigator) || !navigator.geolocation.watchPosition) return;
        liveWatchRef.current = navigator.geolocation.watchPosition((pos)=>{
            const lat = pos.coords.latitude, lng = pos.coords.longitude;
            const prev = lastLiveRef.current;
            const moved = prev ? (0, $3rEkS.getDistance)(prev.lat, prev.lng, lat, lng) * 1000 : Infinity;
            if (!prev || moved >= 8) {
                lastLiveRef.current = {
                    lat: lat,
                    lng: lng
                };
                setLiveLocation({
                    lat: lat,
                    lng: lng
                });
            }
            setLocationPermission('granted');
            setLocationIsFresh(true);
            // ذاكرة الجهاز: يكفي هذا ليفتح التطبيق في المرة القادمة عارفاً
            // أين المستخدم بلا سؤال ولا انتظار. v13.79
            (0, $hYmNv.rememberFix)(lat, lng);
            persistLiveLocation(lat, lng);
            if (!liveAlertedRef.current) {
                liveAlertedRef.current = true;
                checkAlertsRef.current?.(lat, lng);
            }
        }, (err)=>{
            // A real permission DENIAL (code 1) must surface so the CTA
            // comes back and the persisted "on" flag is cleared. Other
            // codes (position unavailable / timeout) are transient — keep
            // the last known fix and keep tracking. v12.08
            if (err && err.code === 1) {
                setLocationPermission('denied');
                setLocationIsFresh(false);
                // سحب الإذن قرار صريح من المستخدم — ننسى الموقع المحفوظ
                // احتراماً له، لا نكتفي بإيقاف التتبّع. v13.79
                setLiveLocation(null);
                lastLiveRef.current = null;
                (0, $hYmNv.forgetFix)();
                try {
                    localStorage.removeItem(LIVE_LOC_KEY);
                } catch  {}
                stopLiveWatch();
            }
        }, {
            enableHighAccuracy: true,
            maximumAge: 1000,
            timeout: 15000
        });
    }, [
        persistLiveLocation
    ]);
    const stopLiveWatch = (0, $2eaC8.useCallback)(()=>{
        if (liveWatchRef.current != null) {
            navigator.geolocation.clearWatch(liveWatchRef.current);
            liveWatchRef.current = null;
        }
    }, []);
    // Explicit "enable my location" — fires the browser prompt on a user gesture
    // (Safari-safe), then starts continuous tracking. Returns whether it worked.
    const requestLiveLocation = (0, $2eaC8.useCallback)(async ()=>{
        try {
            // getCurrentPositionSafe يتكفّل بمصغّر تيليجرام أيضاً (v13.79)، فلا
            // نرفض مبكراً لمجرد غياب navigator.geolocation داخل تيليجرام.
            const { lat: lat, lng: lng } = await (0, $3rEkS.getCurrentPositionSafe)();
            lastLiveRef.current = {
                lat: lat,
                lng: lng
            };
            setLiveLocation({
                lat: lat,
                lng: lng
            });
            setLocationPermission('granted');
            setLocationIsFresh(true);
            (0, $hYmNv.rememberFix)(lat, lng);
            try {
                localStorage.setItem(LIVE_LOC_KEY, '1');
            } catch  {}
            await persistLiveLocation(lat, lng);
            startLiveWatch();
            return {
                lat: lat,
                lng: lng
            };
        } catch  {
            setLocationPermission('denied');
            setLocationIsFresh(false);
            try {
                localStorage.removeItem(LIVE_LOC_KEY);
            } catch  {}
            return null;
        }
    }, [
        persistLiveLocation,
        startLiveWatch
    ]);
    // On app open: a shopper who already granted location is tracked silently
    // (no re-ask). Otherwise we surface the permission state so the UI prompts.
    (0, $2eaC8.useEffect)(()=>{
        // v13.11 — التتبّع التلقائي والبانر للمشتري فقط. التاجر/المالك لا يُلاحَق
        // بطلب التفعيل، ولا يُكتب فوق موقع متجره الثابت (طلب ناصر).
        // v13.79 — والزائر بلا حساب مشترٍ أيضاً: هو يتصفّح العروض ويحتاج
        // المسافات مثله مثل المسجّل، وكان استثناؤه يعني إعادة السؤال في كل
        // صفحة. الكتابة إلى `users.lat/lng` تبقى للمشتري وحده (persistLiveLocation).
        const isShopper = !user || user.userType === 'buyer';
        if (!isShopper) {
            stopLiveWatch();
            liveAlertedRef.current = false;
            lastSaveRef.current = null;
            return;
        }
        if (!('geolocation' in navigator)) {
            setLocationPermission('unsupported');
            return;
        }
        let cancelled = false;
        let perm = null;
        // If the shopper already turned live location ON in a previous session,
        // resume tracking SILENTLY and treat it as granted so the banner stays
        // hidden. watchPosition itself re-validates: if the OS actually revoked
        // access, its error callback (code 1) flips us back to 'denied' and
        // clears the flag. This is the path that makes iOS "remember" it. v12.08
        let savedOn = false;
        try {
            savedOn = localStorage.getItem(LIVE_LOC_KEY) === '1';
        } catch  {}
        if (savedOn) {
            setLocationPermission('granted');
            startLiveWatch();
        }
        (async ()=>{
            try {
                if (navigator.permissions?.query) {
                    perm = await navigator.permissions.query({
                        name: 'geolocation'
                    });
                    if (cancelled) return;
                    // Don't let a stale 'prompt' from the Permissions API override
                    // a live "on" flag — only downgrade on a real denial.
                    if (perm.state === 'denied') {
                        setLocationPermission('denied');
                        try {
                            localStorage.removeItem(LIVE_LOC_KEY);
                        } catch  {}
                        stopLiveWatch();
                    } else if (perm.state === 'granted') {
                        setLocationPermission('granted');
                        startLiveWatch();
                    } else if (!savedOn) setLocationPermission('prompt');
                    perm.onchange = ()=>{
                        if (perm.state === 'denied') {
                            try {
                                localStorage.removeItem(LIVE_LOC_KEY);
                            } catch  {}
                            setLocationPermission('denied');
                            stopLiveWatch();
                        } else if (perm.state === 'granted') {
                            setLocationPermission('granted');
                            startLiveWatch();
                        } else setLocationPermission(savedOn ? 'granted' : 'prompt');
                    };
                } else if (!savedOn) setLocationPermission('prompt'); // older Safari has no Permissions API — CTA requests
            } catch  {
                if (!savedOn) setLocationPermission('prompt');
            }
        })();
        return ()=>{
            cancelled = true;
            if (perm) perm.onchange = null;
        };
    }, [
        user?.id,
        user?.userType,
        startLiveWatch,
        stopLiveWatch
    ]);
    // v13.79 — من نعرف موقعه لا نسأله عن مدينته. متى ما توفّر تثبيت (حيّ أو
    // مستعاد من ذاكرة الجهاز) ولم تُحدَّد مدينة بعد، نستنتج أقرب مدينة ونحفظها
    // — فتختفي بوابة «وين مدينتك؟» بعد أول مرة وإلى الأبد، ويبقى للمستخدم
    // تغييرها يدوياً من الفلاتر متى شاء.
    (0, $2eaC8.useEffect)(()=>{
        if (homeCity?.cityId || !liveLocation) return;
        const near = (0, $gMErx.findNearestCity)(liveLocation.lat, liveLocation.lng);
        if (near) setHomeCity({
            regionId: near.regionId,
            cityId: near.id
        });
    }, [
        liveLocation?.lat,
        liveLocation?.lng,
        homeCity?.cityId,
        setHomeCity
    ]);
    // v12.50 — «جمهور المدن»: سجّل «فتح تطبيق» (جلسة) مرة كل ٣٠ دقيقة كحد
    // أقصى، بآخر إحداثيات معروفة إن وُجدت. القاعدة تكبح المكرر أيضاً
    // (track_app_open)، وهذا يغذي لوحة الأدمن: كم شخصاً دخل يومياً ومن أين
    // ومن أي قناة (ويب/تيليجرام/واتساب). أنون بلا حساب يُحصى بلا هوية.
    (0, $2eaC8.useEffect)(()=>{
        const OPEN_KEY = 'TAKI_APPOPEN_AT';
        const timer = setTimeout(()=>{
            try {
                // v14.82 — بوّابة الموافقة: «فتح التطبيق» قياسٌ سلوكي أيضاً.
                if (!(0, $411pF.analyticsAllowed)()) return;
                const uid = user?.id || 'anon';
                let last = null;
                try {
                    last = JSON.parse(localStorage.getItem(OPEN_KEY) || 'null');
                } catch  {}
                if (last && last.uid === uid && Date.now() - last.at < 1800000) return;
                // آخر موقع معروف يكفي لإحصاء «من أي مدينة فُتح التطبيق» حتى قبل
                // وصول أول تثبيت حيّ في هذه الجلسة. v13.79
                const coords = lastLiveRef.current || rememberedFix;
                Promise.resolve((parcelRequire("6xdoN"))).then(({ isTelegramMiniApp: isTelegramMiniApp })=>{
                    const src = isTelegramMiniApp() ? 'telegram' : 'web';
                    (0, $hUL2G.supabase).rpc('track_app_open', {
                        p_source: src,
                        p_lat: coords?.lat ?? null,
                        p_lng: coords?.lng ?? null
                    }).then(()=>{
                        try {
                            localStorage.setItem(OPEN_KEY, JSON.stringify({
                                at: Date.now(),
                                uid: uid
                            }));
                        } catch  {}
                    }, ()=>{});
                }).catch(()=>{});
            } catch  {}
        }, 5000); // مهلة قصيرة حتى تصل أول إحداثيات المتتبع الحي إن كان مفعّلاً
        return ()=>clearTimeout(timer);
    }, [
        user?.id
    ]);
    const markNotifRead = (0, $2eaC8.useCallback)((id)=>{
        setNotifications((prev)=>{
            // لا نُنقص العدّاد إلا إن كان الصفّ غير مقروء فعلاً — الضغط مرّتين
            // على نفس الإشعار كان سيُنقصه مرّتين فيُظهر رقماً أقلّ من الحقيقة.
            if (prev.some((n)=>n.id === id && !n.isRead)) setNotifUnread((c)=>Math.max(0, c - 1));
            return prev.map((n)=>n.id === id ? {
                    ...n,
                    isRead: true
                } : n);
        });
        // Sync read status to Supabase
        (0, $lGggQ.notificationRepository).markAsRead(id);
    }, []);
    // "قراءة الكل" — mark every unread notification of the signed-in user as read at
    // once (optimistic locally, then one bulk UPDATE). Used by the buyer (Profile +
    // /notifications) and the seller (dashboard) notification lists.
    const markAllNotifsRead = (0, $2eaC8.useCallback)(()=>{
        const uid = user?.id;
        if (!uid) return;
        setNotifications((prev)=>prev.map((n)=>n.userId === uid && !n.isRead ? {
                    ...n,
                    isRead: true
                } : n));
        setNotifUnread(0); // التحديث الجملي على الخادم يشمل ما خرج عن النافذة
        (0, $lGggQ.notificationRepository).markAllAsRead(uid);
    }, [
        user
    ]);
    const logout = (0, $2eaC8.useCallback)(async ()=>{
        // Clear all per-user state instantly so the UI doesn't flash the
        // outgoing account's data while authService.logout() round-trips. The
        // SIGNED_OUT listener also clears, but doing it here closes the gap
        // between click and Supabase responding.
        try {
            localStorage.removeItem('TAKI_IMPERSONATION_SESSION');
        } catch  {}
        setImpersonating(null);
        setUser(null);
        setFavorites([]);
        setFollowedMerchants([]);
        setNotifications([]);
        setBookings([]);
        setSmartAlerts([]);
        (0, $bRDgQ.clearSnapshots)();
        // Drop the device's push subscription so the previous account
        // doesn't keep receiving alerts on this hardware.
        (0, $k7Lgv.pushService).unsubscribe().catch(()=>{});
        // Don't await — the UI is already in the logged-out state. Awaiting
        // signOut just delays the next interaction (e.g. typing in the login
        // form) without changing the outcome.
        (0, $1BuUO.authService).logout().catch((e)=>console.warn('Signout deferred:', e));
    }, []);
    // ============================================================
    // Admin "act as user" — v11.16 real session swap
    // ============================================================
    // start: backs up admin's tokens, calls the admin-impersonate edge
    // function (service-role) to get a magiclink hashed_token, then calls
    // verifyOtp to actually swap the Supabase session to the target. After
    // the swap, every Supabase call is authorized as the target — the
    // admin can post, delete, message, edit DB rows exactly as the target
    // would. The page reloads so all userId-dependent hooks re-bind.
    const startImpersonating = (0, $2eaC8.useCallback)(async (targetUserId)=>{
        if (!user || user.userType !== 'admin') {
            await customAlert("\u26A0\uFE0F \u0647\u0630\u0647 \u0627\u0644\u062E\u0627\u0635\u064A\u0629 \u0645\u064F\u062A\u0627\u062D\u0629 \u0644\u0644\u0645\u062F\u064A\u0631 \u0641\u064E\u0642\u064E\u0637");
            return;
        }
        if (impersonating) {
            await customAlert("\u26A0\uFE0F \u0623\u0646\u062A \u0628\u0650\u0627\u0644\u0641\u0650\u0639\u0644 \u062A\u064E\u062A\u064E\u0635\u0641\u064E\u0651\u062D \u062D\u0633\u0627\u0628 \u0622\u062E\u0631 \u2014 \u0627\u0631\u062C\u0639 \u0644\u0644\u0645\u062F\u064A\u0631 \u0623\u0648\u0651\u0644\u0627\u064B");
            return;
        }
        if (targetUserId === user.id) {
            await customAlert("\u26A0\uFE0F \u0644\u0627 \u064A\u064F\u0645\u0643\u0646\u0643 \u0627\u0644\u062A\u064E\u0651\u0635\u0641\u064F\u0651\u062D \u0643\u064E\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u062F\u064A\u0631 \u0646\u064E\u0641\u0633\u0647");
            return;
        }
        // 1. Capture admin's current tokens BEFORE the swap — these are
        //    what we'll use to restore the admin session on exit.
        const { data: sessData, error: sessErr } = await (0, $hUL2G.supabase).auth.getSession();
        if (sessErr || !sessData?.session?.access_token || !sessData?.session?.refresh_token) {
            await customAlert("\u26A0\uFE0F \u062A\u064E\u0639\u0630\u064E\u0651\u0631 \u0642\u0650\u0631\u0627\u0621\u0629 \u062C\u064E\u0644\u0633\u0629 \u0627\u0644\u0645\u062F\u064A\u0631 \u2014 \u062D\u0627\u0648\u0644 \u062A\u064E\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u062C\u062F\u064A\u062F");
            return;
        }
        const adminTokens = {
            access_token: sessData.session.access_token,
            refresh_token: sessData.session.refresh_token
        };
        // 2. Ask the edge function for a magiclink token for the target.
        const { data: efData, error: efErr } = await (0, $hUL2G.supabase).functions.invoke('admin-impersonate', {
            body: {
                targetUserId: targetUserId
            }
        });
        if (efErr || !efData?.hashed_token) {
            const msg = efData?.error || efErr?.message || "\u062E\u064E\u0637\u0623 \u063A\u064E\u064A\u0631 \u0645\u064E\u0639\u0631\u0648\u0641";
            await customAlert("\u26A0\uFE0F " + msg);
            return;
        }
        // 3. Swap the Supabase session. verifyOtp consumes the hashed_token
        //    and returns a real session for the target. After this, every
        //    Supabase call from this browser is authorized as the target.
        const { error: verifyErr } = await (0, $hUL2G.supabase).auth.verifyOtp({
            type: 'magiclink',
            token_hash: efData.hashed_token
        });
        if (verifyErr) {
            // Restore admin session if the swap clobbered something.
            try {
                await (0, $hUL2G.supabase).auth.setSession(adminTokens);
            } catch  {}
            await customAlert("\u26A0\uFE0F \u0641\u064E\u0634\u0644 \u062A\u064E\u0628\u062F\u064A\u0644 \u0627\u0644\u062C\u064E\u0644\u0633\u0629: " + verifyErr.message);
            return;
        }
        // 4. Persist the admin's tokens + target metadata so stopImpersonating
        //    can restore the original admin session on exit, and so the
        //    reloaded page can show the banner. We write AFTER the successful
        //    swap to avoid leaving stale state on a failed attempt.
        try {
            localStorage.setItem('TAKI_IMPERSONATION_SESSION', JSON.stringify({
                adminAccessToken: adminTokens.access_token,
                adminRefreshToken: adminTokens.refresh_token,
                adminId: user.id,
                adminName: user.name || "\u0645\u062F\u064A\u0631",
                targetId: targetUserId,
                targetName: efData.target?.name || "\u0645\u064F\u0633\u062A\u064E\u062E\u062F\u0650\u0645",
                targetUserType: efData.target?.userType || 'buyer',
                startedAt: new Date().toISOString()
            }));
        } catch  {
            // localStorage blocked — without it stopImpersonating can't restore.
            // Try to restore admin session right away and bail.
            try {
                await (0, $hUL2G.supabase).auth.setSession(adminTokens);
            } catch  {}
            await customAlert("\u26A0\uFE0F \u0627\u0644\u0645\u062A\u0635\u0641\u0650\u0651\u062D \u064A\u064E\u0645\u0646\u0639 \u0627\u0644\u062D\u0641\u0638 \u0627\u0644\u0645\u062D\u0644\u064A \u2014 \u0644\u0627 \u064A\u064F\u0645\u0643\u0646 \u0628\u064E\u062F\u0621 \u0627\u0644\u062C\u064E\u0644\u0633\u0629");
            return;
        }
        // 5. Full navigation — every userId-dependent hook rebuilds for the
        //    target. Sellers land on their dashboard, buyers on home.
        const dest = efData.target?.userType === 'seller' ? '/seller' : '/';
        window.location.assign(dest);
    }, [
        user,
        impersonating,
        customAlert
    ]);
    // stop: restores admin's saved tokens via setSession, logs the stop
    // action, and reloads to /admin. v11.17 hardening:
    //   - Audit log is fire-and-forget (RLS denies it while we're on the
    //     target's session anyway — the start row is the security record;
    //     awaiting the failed INSERT was hanging the exit on slow links).
    //   - setSession is wrapped in a 6 s race so a flaky network never
    //     traps the admin inside the impersonation.
    //   - The function ALWAYS reaches a navigation step (success ⇒ /admin,
    //     failure ⇒ /register after sign-out) so the click never feels dead.
    //   - `stoppingImp` state gates double-tap and drives the banner spinner.
    const stopImpersonating = (0, $2eaC8.useCallback)(async ()=>{
        if (stoppingImpRef.current) return;
        stoppingImpRef.current = true;
        setStoppingImp(true);
        const raw = (()=>{
            try {
                return localStorage.getItem('TAKI_IMPERSONATION_SESSION');
            } catch  {
                return null;
            }
        })();
        if (!raw) {
            window.location.assign('/admin');
            return;
        }
        let backup;
        try {
            backup = JSON.parse(raw);
        } catch  {
            try {
                localStorage.removeItem('TAKI_IMPERSONATION_SESSION');
            } catch  {}
            window.location.assign('/admin');
            return;
        }
        // Fire-and-forget audit log. RLS will deny this (we're on target's
        // session, is_admin() returns false), so we don't even bother
        // surfacing the error — the start row is the audit record that
        // matters and was inserted server-side via service_role.
        try {
            (0, $hUL2G.supabase).from('admin_impersonation_log').insert({
                admin_id: backup.adminId,
                target_id: backup.targetId,
                action: 'stop'
            }).then(()=>{}, ()=>{});
        } catch  {}
        const restorePromise = (0, $hUL2G.supabase).auth.setSession({
            access_token: backup.adminAccessToken,
            refresh_token: backup.adminRefreshToken
        });
        const timeoutPromise = new Promise((resolve)=>setTimeout(()=>resolve({
                    error: {
                        message: 'timeout'
                    }
                }), 8000));
        let restored = false;
        try {
            const result = await Promise.race([
                restorePromise,
                timeoutPromise
            ]);
            if (!result?.error) restored = true;
        } catch  {}
        // ALWAYS clean up local state and navigate, even on failure.
        try {
            localStorage.removeItem('TAKI_IMPERSONATION_SESSION');
        } catch  {}
        setImpersonating(null);
        if (restored) window.location.assign('/admin');
        else {
            try {
                await (0, $hUL2G.supabase).auth.signOut();
            } catch  {}
            try {
                await customAlertRef.current("\u26A0\uFE0F \u0627\u0646\u062A\u064E\u0647\u062A \u0635\u064E\u0644\u0627\u062D\u064A\u0629 \u062C\u064E\u0644\u0633\u0629 \u0627\u0644\u0645\u062F\u064A\u0631 \u2014 \u0633\u064E\u062C\u0650\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u064E\u0631\u064E\u0651\u0629 \u0623\u064F\u062E\u0631\u0649 \u0644\u0644\u0639\u064E\u0648\u062F\u0629");
            } catch  {}
            window.location.assign('/register');
        }
    }, []);
    const deleteAccount = (0, $2eaC8.useCallback)(async ()=>{
        // 30-day soft delete with grace period (migration v9.17). The user's
        // row is marked `deleted_at`/`purge_after`; their deals are paused.
        // A subsequent login within 30 days offers recovery.
        try {
            const { supabase: supabase } = await Promise.resolve((parcelRequire("hUL2G")));
            const { error: error } = await supabase.rpc('soft_delete_my_account');
            if (error) throw error;
        } catch (e) {
            // v14.21 — المسار الاحتياطي لم يعد يمسح شيئاً: `delete_user_account`
            // صارت تُعطّل وتجدول التجهيل بعد ٣٠ يوماً مثل المسار الأوّل تماماً.
            // 🔴 كانت تمسح صفّ المصادقة، والحذف يتسلسل إلى الطلبات والفواتير.
            console.error('Soft delete RPC failed, using the deactivation fallback:', e);
            await (0, $1BuUO.authService).deleteAccount();
        }
        // Sign out locally so the next visit forces a fresh login (which is
        // the trigger for the recovery prompt).
        try {
            await (0, $1BuUO.authService).logout();
        } catch  {}
        (0, $bRDgQ.clearSnapshots)();
        setUser(null);
        setFavorites([]);
        setFollowedMerchants([]);
        setNotifications([]);
        setBookings([]);
    }, []);
    const addDeal = (0, $2eaC8.useCallback)(async (deal)=>{
        (0, $4aj47.logger).log("\uD83D\uDED2 Adding deal:", deal.itemName, 'by user:', user?.id);
        const dealWithTime = {
            ...deal,
            status: deal.status || 'active',
            createdAt: deal.createdAt || Date.now(),
            ratings: deal.ratings || []
        };
        // (Removed v10.57) Earlier versions called userRepository.saveProfile(user)
        // here to "ensure FK target exists" before the deal insert. In practice
        // the user row is already created by the handle_new_user trigger at
        // signup, so this pre-write was redundant — and on a stalled auth-token
        // lock it ate half the timeout budget, leaving the spinner stuck.
        // Skipped. If the FK truly is missing (very rare), the deal upsert
        // surfaces a clear "store_id violates foreign key constraint" error
        // for the user to act on.
        // DB-first save — no "saved locally" lie. The UI only reflects
        //    the deal AFTER the database has accepted it. If the DB rejects
        //    (location cap, validation, RLS) the user sees a specific error
        //    and nothing appears in their list. If a transient auth-lock
        //    fires we retry once silently.
        const trySave = async ()=>{
            await (0, $eGYci.dealRepository).save(dealWithTime);
        };
        try {
            await trySave();
        } catch (error) {
            const msg = error?.message || '';
            const isTransientLock = /lock.*auth-token|stole it|NavigatorLock/i.test(msg);
            // v14.95 — سببُ الرفض بعبارةٍ فيها **الخطوة التالية**: حدّ المواقع (نفس النصّ
            // حرفاً بحرف)، و«المتجر غير موثّق» (P0024) الذي كان يصل جملةً عمياء.
            const known = (0, $cfBdF.publishErrorMessage)(`${error?.code || ''} ${msg}`, language === 'ar');
            if (known) {
                customAlert(known);
                return;
            }
            if (isTransientLock) try {
                await new Promise((r)=>setTimeout(r, 500));
                await trySave();
            } catch (retryErr) {
                console.error("\u274C Deal save retry failed:", retryErr);
                customAlert(language === 'ar' ? "\u26A0\uFE0F \u062A\u0639\u0630\u0651\u0631 \u062D\u0641\u0638 \u0627\u0644\u0639\u0631\u0636 \u0641\u064A \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F \u0642\u0644\u064A\u0644." : "\u26A0\uFE0F Could not save deal to database. Try again shortly.");
                return;
            }
            else {
                console.error("\u274C Failed to save deal to database:", error);
                customAlert(language === 'ar' ? `\u{26A0}\u{FE0F} \u{62A}\u{639}\u{630}\u{651}\u{631} \u{62D}\u{641}\u{638} \u{627}\u{644}\u{639}\u{631}\u{636} \u{641}\u{64A} \u{642}\u{627}\u{639}\u{62F}\u{629} \u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A}.${msg ? `\n${msg}` : ''}` : `\u{26A0}\u{FE0F} Could not save deal to database.${msg ? `\n${msg}` : ''}`);
                return;
            }
        }
        // 3. DB save succeeded — mirror to local state now. Functional update
        //    + dedup-by-id so a rapid double-click or a realtime INSERT race
        //    can't produce two rows for the same deal.
        setDeals((prev)=>{
            const filtered = prev.filter((d)=>d.id !== dealWithTime.id);
            return [
                dealWithTime,
                ...filtered
            ];
        });
        (0, $4aj47.logger).log("\u2705 Deal saved to database");
    // Follower / Smart Alert notifications are fanned out 100% server-side
    // by tr_deal_smart_notifications. The server fires on INSERT — no
    // client work needed.
    }, [
        user,
        language,
        customAlert
    ]);
    const updateDeal = (0, $2eaC8.useCallback)(async (deal)=>{
        // DB-first: never show an "optimistic" version of a deal that the
        // database might reject. The UI only updates AFTER the DB confirms.
        try {
            await (0, $eGYci.dealRepository).save(deal);
        } catch (error) {
            const msg = error?.message || '';
            const isTransientLock = /lock.*auth-token|stole it|NavigatorLock/i.test(msg);
            const isLocationCap = /LOCATION_LIMIT_EXCEEDED/i.test(msg);
            // v12.32 — انتهاء الاشتراك سبب واضح بالعربي بدل نص الخطأ الخام
            // (كان الاستئناف «ينجح» ظاهرياً — أساس طلب ناصر ١٥).
            const isSubRequired = /SUBSCRIPTION_REQUIRED/i.test(msg);
            // حد الباقة من نص الخطأ نفسه («Plan allows N distinct locations») —
            // فتأتي الرسالة بعدد باقة التاجر الفعلي، وبصياغة ناصر لباقة الموقع
            // الواحد: استخدم نفس موقع منتجاتك النشطة أو أوقف/احذف الأول. v12.32
            const capMatch = msg.match(/allows\s+(\d+)\s+distinct/i);
            const capN = capMatch ? Number(capMatch[1]) : 0;
            // v13.16 — «needs M»: عدد المواقع التي يغطيها هذا العرض فعلاً (الأساسي
            // + فروع «انشر في عدة مواقع»). يجعل رسالة تخفيض الباقة مفهومة: عرضك
            // منشور على ٣ فروع وباقتك صارت موقعاً واحداً.
            const needMatch = msg.match(/needs\s+(\d+)/i);
            const needN = needMatch ? Number(needMatch[1]) : 0;
            const capMsgAr = needN > 1 && capN > 0 && needN > capN ? `\u{26A0}\u{FE0F} \u{647}\u{630}\u{627} \u{627}\u{644}\u{639}\u{631}\u{636} \u{645}\u{646}\u{634}\u{648}\u{631} \u{641}\u{64A} ${needN} \u{645}\u{648}\u{627}\u{642}\u{639}\u{60C} \u{648}\u{628}\u{627}\u{642}\u{62A}\u{643} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}\u{629} \u{62A}\u{633}\u{645}\u{62D} \u{628}\u{640}${capN === 1 ? "\u0645\u0648\u0642\u0639 \u0648\u0627\u062D\u062F \u0641\u0642\u0637" : `${capN} \u{645}\u{648}\u{627}\u{642}\u{639}`}.

\u{627}\u{641}\u{62A}\u{62D} \xab\u{62A}\u{639}\u{62F}\u{64A}\u{644}\xbb \u{639}\u{644}\u{649} \u{627}\u{644}\u{639}\u{631}\u{636} \u{648}\u{623}\u{632}\u{644} \u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639} \u{627}\u{644}\u{632}\u{627}\u{626}\u{62F}\u{629} \u{645}\u{646} \u{642}\u{633}\u{645} \xab\u{627}\u{646}\u{634}\u{631} \u{646}\u{641}\u{633} \u{627}\u{644}\u{639}\u{631}\u{636} \u{641}\u{64A} \u{639}\u{62F}\u{629} \u{645}\u{648}\u{627}\u{642}\u{639}\xbb \u{62D}\u{62A}\u{649} \u{64A}\u{635}\u{628}\u{62D} \u{627}\u{644}\u{639}\u{62F}\u{62F} ${capN === 1 ? "\u0645\u0648\u0642\u0639\u0627\u064B \u0648\u0627\u062D\u062F\u0627\u064B" : `${capN} \u{623}\u{648} \u{623}\u{642}\u{644}`}\u{60C} \u{62B}\u{645} \u{627}\u{62D}\u{641}\u{638}. \u{648}\u{644}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639} \u{631}\u{642}\u{650}\u{651} \u{628}\u{627}\u{642}\u{62A}\u{643} \u{645}\u{646} \xab\u{627}\u{644}\u{627}\u{634}\u{62A}\u{631}\u{627}\u{643}\xbb.` : capN === 1 ? "\u26A0\uFE0F \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0628\u0645\u0648\u0642\u0639 \u0648\u0627\u062D\u062F \u0641\u0642\u0637.\n\n\u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0641\u064A \u0645\u0648\u0642\u0639 \u0645\u062E\u062A\u0644\u0641 \u0639\u0646 \u0645\u0646\u062A\u062C\u0627\u062A\u0643 \u0627\u0644\u0646\u0634\u0637\u0629 \u2014 \u0627\u0633\u062A\u062E\u062F\u0645 \u0646\u0641\u0633 \u0645\u0648\u0642\u0639 \u0627\u0644\u0645\u0646\u062A\u062C \u0627\u0644\u0623\u0648\u0644\u060C \u0623\u0648 \u0623\u0648\u0642\u0641/\u0627\u062D\u0630\u0641 \u0645\u0646\u062A\u062C\u0627\u062A \u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u062D\u0627\u0644\u064A \u0623\u0648\u0644\u0627\u064B \u0644\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0648\u0642\u0639 \u0622\u062E\u0631. \u0648\u0644\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0648\u0627\u0642\u0639 \u0631\u0642\u0650\u0651 \u0628\u0627\u0642\u062A\u0643 \u0645\u0646 \xab\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\xbb." : `\u{26A0}\u{FE0F} \u{648}\u{635}\u{644}\u{62A} \u{644}\u{62D}\u{62F} \u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639} \u{627}\u{644}\u{645}\u{633}\u{645}\u{648}\u{62D} \u{641}\u{64A} \u{628}\u{627}\u{642}\u{62A}\u{643}${capN > 1 ? ` (${capN} \u{645}\u{648}\u{627}\u{642}\u{639})` : ''}.

\u{627}\u{62E}\u{62A}\u{631} \u{645}\u{648}\u{642}\u{639}\u{627}\u{64B} \u{645}\u{646} \u{645}\u{648}\u{627}\u{642}\u{639}\u{643} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}\u{629}\u{60C} \u{623}\u{648} \u{623}\u{648}\u{642}\u{641}/\u{627}\u{62D}\u{630}\u{641} \u{643}\u{644} \u{645}\u{646}\u{62A}\u{62C}\u{627}\u{62A} \u{623}\u{62D}\u{62F} \u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639} \u{644}\u{62A}\u{641}\u{631}\u{64A}\u{63A} \u{62E}\u{627}\u{646}\u{629} \u{642}\u{628}\u{644} \u{62A}\u{641}\u{639}\u{64A}\u{644} \u{639}\u{631}\u{636} \u{641}\u{64A} \u{645}\u{648}\u{642}\u{639} \u{62C}\u{62F}\u{64A}\u{62F}. \u{648}\u{644}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639} \u{631}\u{642}\u{650}\u{651} \u{628}\u{627}\u{642}\u{62A}\u{643} \u{645}\u{646} \xab\u{627}\u{644}\u{627}\u{634}\u{62A}\u{631}\u{627}\u{643}\xbb.`;
            console.error('Failed to update deal in database:', error);
            // v13.19 (تصحيح طلب ناصر): انتهاء الاشتراك وحده يعرض خيار فتح صفحة
            // الاشتراك. أما **حد المواقع** فلا يقترح الترقية هنا إطلاقاً —
            // مسار التاجر المتفق عليه: رسالة واحدة ثم صفحة التعديل، والترقية
            // تُعرض هناك عند ضغط فرع إضافي. (كان يعرض تأكيداً يقفز للباقات
            // فتتوالى ثلاث رسائل على التاجر.)
            if (isSubRequired) {
                const goUpgrade = await customConfirm(language === 'ar' ? "\uD83D\uDD12 \u0627\u0634\u062A\u0631\u0627\u0643\u0643 \u0645\u0646\u062A\u0647\u064A \u2014 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0646\u0634\u0631 \u0623\u0648 \u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0623\u064A \u0639\u0631\u0636 \u0642\u0628\u0644 \u062A\u062C\u062F\u064A\u062F\u0647.\n\n\u2022 \xab\u0645\u0648\u0627\u0641\u0642\xbb = \u0641\u062A\u062D \u0635\u0641\u062D\u0629 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u0622\u0646.\n\u2022 \xab\u0625\u0644\u063A\u0627\u0621\xbb = \u0644\u0627\u062D\u0642\u0627\u064B." : "\uD83D\uDD12 Your subscription has expired.\n\n\u2022 OK = open Subscription.\n\u2022 Cancel = later.");
                if (goUpgrade) window.location.assign('/subscription');
                return false;
            }
            customAlert(language === 'ar' ? isLocationCap ? capMsgAr : isTransientLock ? "\u26A0\uFE0F \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629 \u062A\u0623\u062E\u0631\u062A \u2014 \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F \u062B\u0648\u0627\u0646\u064D." : `\u{26A0}\u{FE0F} \u{62A}\u{639}\u{630}\u{651}\u{631} \u{62D}\u{641}\u{638} \u{627}\u{644}\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{641}\u{64A} \u{642}\u{627}\u{639}\u{62F}\u{629} \u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A}.${msg ? `\n(${msg})` : ''}` : isLocationCap ? "\u26A0\uFE0F You have reached your package location limit. Remove extra branches from the deal and save." : isTransientLock ? "\u26A0\uFE0F Sync delayed \u2014 try again in a few seconds." : `\u{26A0}\u{FE0F} Could not save change to database.${msg ? `\n(${msg})` : ''}`);
            return false;
        }
        // Re-read the row from DB and apply it to local state. This is the
        // canonical version — any trigger-derived field (region/city
        // backfill, timestamps, etc.) is reflected.
        try {
            const fresh = await (0, $eGYci.dealRepository).getById(deal.id);
            if (fresh) setDeals((prev)=>prev.map((d)=>d.id === fresh.id ? fresh : d));
            else // Row vanished between save and re-read — extremely rare.
            // Fall back to the version we just wrote.
            setDeals((prev)=>prev.map((d)=>d.id === deal.id ? deal : d));
        } catch  {
            // Read-back failed but write succeeded. Use the version we wrote.
            setDeals((prev)=>prev.map((d)=>d.id === deal.id ? deal : d));
        }
        return true;
    }, [
        customAlert,
        language
    ]);
    const deleteDeal = (0, $2eaC8.useCallback)(async (id)=>{
        // Optimistic local removal — stash the deal for potential restoration
        let removedDeal;
        setDeals((prev)=>{
            removedDeal = prev.find((d)=>d.id === id);
            return prev.filter((d)=>d.id !== id);
        });
        try {
            await (0, $eGYci.dealRepository).remove(id);
        } catch (error) {
            console.error('Failed to delete deal from database:', error);
            // Restore the deal locally since server failed
            if (removedDeal) setDeals((prev)=>[
                    removedDeal,
                    ...prev
                ]);
            customAlert(language === 'ar' ? `\u{26A0}\u{FE0F} \u{641}\u{634}\u{644} \u{62D}\u{630}\u{641} \u{627}\u{644}\u{639}\u{631}\u{636} \u{645}\u{646} \u{627}\u{644}\u{633}\u{64A}\u{631}\u{641}\u{631}: ${error?.message || "\u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641"}` : `\u{26A0}\u{FE0F} Failed to delete deal from server: ${error?.message || 'Unknown error'}`);
        }
    }, [
        customAlert,
        language
    ]);
    // v10.67 — returns a boolean so the caller (DealDetails.handleReview)
    // can distinguish "saved" from "silently dropped" and show the right
    // toast. Previously this returned void and any RLS/network failure
    // looked identical to success — the form closed, no error was raised,
    // and the buyer wondered why their review never appeared.
    const addRating = (0, $2eaC8.useCallback)(async (dealId, ratingData)=>{
        const dealToUpdate = deals.find((d)=>d.id === dealId);
        if (!dealToUpdate || !user) return false;
        const { ratingRepository: ratingRepository } = await (parcelRequire("bZlZ8"));
        const created = await ratingRepository.create({
            dealId: dealId,
            userId: user.id,
            userName: user.name || "\u0645\u0633\u062A\u062E\u062F\u0645",
            score: ratingData.score,
            comment: ratingData.comment
        });
        // DB blocked a second rating of this store (anti-inflation backstop). v11.97b
        if (created === 'duplicate') return 'duplicate';
        // v13.15 — حدّ الطلبات: تقييمات كثيرة خلال ساعة
        if (created === 'rate_limited') return 'rate_limited';
        if (!created) return false;
        const local = {
            id: created.id,
            userId: created.userId,
            userName: created.userName,
            score: created.score,
            comment: created.comment,
            // بتوقيت الجهاز المحلي — toISOString (UTC) كان يرجع التقييم يوماً
            // للوراء بين منتصف الليل و٣ فجراً بتوقيت السعودية
            date: (()=>{
                const d = new Date(created.createdAt);
                return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            })(),
            reply: created.reply || undefined,
            repliedBy: created.repliedBy || undefined,
            repliedAt: created.repliedAt || undefined,
            likedBy: created.likedBy,
            likeCount: created.likeCount
        };
        setDeals((prev)=>prev.map((d)=>d.id === dealId ? {
                    ...d,
                    ratings: [
                        ...d.ratings || [],
                        local
                    ]
                } : d));
        // The merchant + admin notification is created server-side by the
        // SECURITY DEFINER trigger `tr_rating_notification` on rating
        // INSERT (sets meta_data.audience='seller'). A client-side insert
        // is impossible here anyway: the notifications RLS policy
        // `notifs_insert_self` only allows writing rows for one's own auth
        // uid, so the buyer can never notify the merchant from the client
        // — that silent RLS rejection is exactly why this never arrived.
        return true;
    }, [
        deals,
        user
    ]);
    // v12.30 — edit an existing rating (stars + comment). The `update_rating`
    // RPC enforces owner-or-admin server-side; here we just sync local state.
    const updateRating = (0, $2eaC8.useCallback)(async (dealId, ratingId, ratingData)=>{
        const { ratingRepository: ratingRepository } = await (parcelRequire("bZlZ8"));
        const ok = await ratingRepository.update(ratingId, ratingData.score, ratingData.comment);
        if (!ok) return false;
        setDeals((prev)=>prev.map((d)=>d.id === dealId ? {
                    ...d,
                    ratings: (d.ratings || []).map((r)=>r.id === ratingId ? {
                            ...r,
                            score: ratingData.score,
                            comment: ratingData.comment
                        } : r)
                } : d));
        return true;
    }, []);
    // Buyer authenticity vote («عرض حقيقي / شكلي») — ONE per deal, and since
    // v12.30 it is EDITABLE: re-voting flips the previous vote (the DB upserts).
    // Rationale (Nasser): a merchant could swap the whole product in the same
    // slot and keep an old favourable vote frozen — the buyer must be able to
    // change their mind after a re-purchase.
    const recordAuthVote = (0, $2eaC8.useCallback)(async (dealId, isReal)=>{
        if (!user) return false;
        const current = dealsRef.current.find((d)=>d.id === dealId);
        // Same vote again → nothing to change (skip the round-trip).
        if (current && current.myAuthVote === isReal) return true;
        const { authenticityRepository: authenticityRepository } = await (parcelRequire("gTQhM"));
        const ok = await authenticityRepository.vote(dealId, isReal);
        if (!ok) return false;
        setDeals((prev)=>prev.map((d)=>{
                if (d.id !== dealId) return d;
                if (d.myAuthVote === isReal) return d;
                // Move the counter: remove the old vote (if any), add the new one.
                let real = d.authReal || 0;
                let fake = d.authFake || 0;
                if (d.myAuthVote === true) real = Math.max(0, real - 1);
                if (d.myAuthVote === false) fake = Math.max(0, fake - 1);
                if (isReal) real += 1;
                else fake += 1;
                return {
                    ...d,
                    authReal: real,
                    authFake: fake,
                    myAuthVote: isReal
                };
            }));
        return true;
    }, [
        user
    ]);
    /**
     * v14.06 — 🔴 إصلاح «التقييم لم يظهر عند اكتمال الشراء» (بلاغ ناصر).
     *
     * كان الظهور معلَّقاً على حدث ريل‑تايم واحد لحظة إتمام التاجر للطلب، وفيه
     * عطلان مستقلان قُيسا في الكود:
     *  ١) الحجز يُعلَّم «معالَجاً» **قبل** التحقّق من تحميل العرض، فإن لم يكن
     *     العرض داخل نافذة العروض المحمَّلة (وهو الشائع لحساب جديد) لم تُفتح
     *     النافذة أبداً ولم يُعَد النظر فيها.
     *  ٢) الحدث نفسه قد لا يصل إطلاقاً: الجوال في الجيب لحظة الاستلام، أو
     *     التطبيق مغلق — وإعادة الاشتراك لا تُعيد بثّ ما فات.
     *
     * الحلّ: **الحالة تُقاس لا تُنتظر.** الدالة `pending_rating_prompts` على جدة
     * تُرجع كل حجز مكتمل خلال ٧ أيام لم يُقيَّم متجره أو لم يُصوَّت على مصداقية
     * عرضه، فنفتح أوّلها عند كل جهوز جلسة وكل تحديث كامل. ولا نعتمد على تحميل
     * العرض: اسم المتجر ومعرّفاته تأتي من الدالة، والعرض يُجلَب عند الحاجة.
     */ const checkPendingRatingPrompts = (0, $2eaC8.useCallback)(async ()=>{
        if (rateCheckingRef.current) return;
        const uid = userIdRef.current;
        if (!uid) return;
        // نافذة مفتوحة أصلاً؟ لا نُكدّس نافذتين فوق بعضهما.
        if (ratingPromptRef.current) return;
        rateCheckingRef.current = true;
        try {
            if (!Object.keys(rateDismissedRef.current).length) try {
                const raw = localStorage.getItem(RATE_DISMISS_KEY);
                const parsed = raw ? JSON.parse(raw) : {};
                const cutoff = Date.now() - 1209600000;
                rateDismissedRef.current = Object.fromEntries(Object.entries(parsed).filter(([, ts])=>Number(ts) > cutoff));
            } catch  {
                rateDismissedRef.current = {};
            }
            const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('pending_rating_prompts');
            if (error) {
                (0, $4aj47.logger).warn('pending_rating_prompts:', error.message);
                return;
            }
            const rows = Array.isArray(data) ? data : [];
            const next = rows.find((r)=>r && r.barcode && !rateDismissedRef.current[r.barcode] && !promptedRatingRef.current.has(r.barcode));
            if (!next) return;
            // العرض غير محمَّل؟ اجلبه وأدخِله في النافذة — خطوة التصويت
            // («حقيقي/شكلي») تحتاج صفّ العرض لتعرض التصويت السابق وتحدّثه.
            let deal = dealsRef.current.find((x)=>x.id === next.deal_id);
            if (!deal) try {
                const fetched = await (0, $eGYci.dealRepository).getById(next.deal_id);
                if (fetched) {
                    ingestDealsRef.current([
                        fetched
                    ]);
                    deal = fetched;
                }
            } catch  {}
            // تقييم سابق لهذا المتجر (لتعديله لا تكراره) — من العرض المحمَّل إن وُجد.
            let myStoreReview = null;
            let myReviewDealId = '';
            for (const x of dealsRef.current){
                if (x.storeId !== next.store_id) continue;
                const r = (x.ratings || []).find((rr)=>rr.userId === uid);
                if (r) {
                    myStoreReview = r;
                    myReviewDealId = x.id;
                    break;
                }
            }
            setRatingStars(myStoreReview ? myStoreReview.score : 5);
            setRatingComment('');
            setPrevReview(myStoreReview ? {
                id: myStoreReview.id,
                dealId: myReviewDealId,
                score: myStoreReview.score,
                comment: myStoreReview.comment || ''
            } : null);
            // الخطوة الأولى = ما ينقص فعلاً: لم يصوّت ⇒ «حقيقي/شكلي»، صوّت ولم
            // يقيّم ⇒ النجوم مباشرة. (الدالة لا تُرجع من أتمّ الاثنين.)
            setRatingStep(next.has_vote ? 'rate' : 'auth');
            setRatingPrompt({
                barcode: next.barcode,
                dealId: next.deal_id,
                storeId: next.store_id,
                storeName: next.shop_name || deal?.shopName || (languageRef.current === 'ar' ? "\u0627\u0644\u0645\u062A\u062C\u0631" : 'the store')
            });
        } catch (e) {
            (0, $4aj47.logger).warn('checkPendingRatingPrompts failed:', e);
        } finally{
            rateCheckingRef.current = false;
        }
    }, []);
    /** «لاحقاً»/إغلاق: يُسجَّل الرفض في الجهاز فلا تُلاحقه النافذة كل فتح. */ const dismissRatingPrompt = (0, $2eaC8.useCallback)(()=>{
        const bc = ratingPromptRef.current?.barcode;
        if (bc) {
            promptedRatingRef.current.add(bc);
            rateDismissedRef.current[bc] = Date.now();
            try {
                localStorage.setItem(RATE_DISMISS_KEY, JSON.stringify(rateDismissedRef.current));
            } catch  {}
        }
        setRatingPrompt(null);
    }, []);
    const addReply = (0, $2eaC8.useCallback)(async (dealId, ratingId, reply)=>{
        const { ratingRepository: ratingRepository } = await (parcelRequire("bZlZ8"));
        // Optimistic — the reply lands in the UI before the server round-trip.
        const trimmed = reply.trim();
        let buyerId;
        setDeals((prev)=>prev.map((d)=>{
                if (d.id !== dealId) return d;
                return {
                    ...d,
                    ratings: d.ratings?.map((r)=>{
                        if (r.id !== ratingId) return r;
                        buyerId = r.userId;
                        return {
                            ...r,
                            reply: trimmed || undefined,
                            repliedBy: user?.id,
                            repliedAt: new Date().toISOString()
                        };
                    })
                };
            }));
        const ok = await ratingRepository.setReply(ratingId, trimmed);
        if (!ok) {
            // Rollback by removing the optimistic reply on failure
            setDeals((prev)=>prev.map((d)=>{
                    if (d.id !== dealId) return d;
                    return {
                        ...d,
                        ratings: d.ratings?.map((r)=>r.id === ratingId ? {
                                ...r,
                                reply: undefined,
                                repliedBy: undefined,
                                repliedAt: undefined
                            } : r)
                    };
                }));
            console.warn('Reply persistence failed; rolled back optimistic update');
            return;
        }
        if (buyerId && trimmed) {
            const itemName = deals.find((d)=>d.id === dealId)?.itemName || '';
            addNotification(buyerId, {
                ar: "\uD83D\uDCAC \u0631\u062F \u062C\u062F\u064A\u062F \u0639\u0644\u0649 \u062A\u0639\u0644\u064A\u0642\u0643",
                en: "\uD83D\uDCAC New reply to your review"
            }, {
                ar: `\u{642}\u{627}\u{645} \u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{645}\u{62D}\u{644} \u{628}\u{627}\u{644}\u{631}\u{62F} \u{639}\u{644}\u{649} \u{62A}\u{642}\u{64A}\u{64A}\u{645}\u{643} \u{644}\u{645}\u{646}\u{62A}\u{62C} ${itemName}`,
                en: `The shop owner replied to your review of ${itemName}`
            }, 'system', {
                dealId: dealId,
                ratingId: ratingId
            });
        }
    }, [
        deals,
        user,
        addNotification
    ]);
    const toggleRatingLike = (0, $2eaC8.useCallback)(async (dealId, ratingId)=>{
        if (!user) return;
        const { ratingRepository: ratingRepository } = await (parcelRequire("bZlZ8"));
        const me = user.id;
        // Optimistic flip
        let prevState = null;
        setDeals((prev)=>prev.map((d)=>{
                if (d.id !== dealId) return d;
                return {
                    ...d,
                    ratings: d.ratings?.map((r)=>{
                        if (r.id !== ratingId) return r;
                        const likedBy = r.likedBy || [];
                        const wasLiked = likedBy.includes(me);
                        prevState = {
                            liked: wasLiked,
                            count: r.likeCount ?? 0
                        };
                        return {
                            ...r,
                            likedBy: wasLiked ? likedBy.filter((x)=>x !== me) : [
                                ...likedBy,
                                me
                            ],
                            likeCount: Math.max(0, (r.likeCount ?? 0) + (wasLiked ? -1 : 1))
                        };
                    })
                };
            }));
        const result = await ratingRepository.toggleLike(ratingId);
        if (!result) // Rollback
        {
            if (prevState) setDeals((prev)=>prev.map((d)=>{
                    if (d.id !== dealId) return d;
                    return {
                        ...d,
                        ratings: d.ratings?.map((r)=>{
                            if (r.id !== ratingId) return r;
                            const likedBy = r.likedBy || [];
                            const restored = prevState.liked ? likedBy.includes(me) ? likedBy : [
                                ...likedBy,
                                me
                            ] : likedBy.filter((x)=>x !== me);
                            return {
                                ...r,
                                likedBy: restored,
                                likeCount: prevState.count
                            };
                        })
                    };
                }));
        }
    }, [
        user
    ]);
    const removeRating = (0, $2eaC8.useCallback)(async (dealId, ratingId)=>{
        const { ratingRepository: ratingRepository } = await (parcelRequire("bZlZ8"));
        let snapshot = [];
        setDeals((prev)=>prev.map((d)=>{
                if (d.id !== dealId) return d;
                snapshot = d.ratings || [];
                return {
                    ...d,
                    ratings: (d.ratings || []).filter((r)=>r.id !== ratingId)
                };
            }));
        const ok = await ratingRepository.remove(ratingId);
        if (!ok) {
            const restore = snapshot;
            setDeals((prev)=>prev.map((d)=>d.id === dealId ? {
                        ...d,
                        ratings: restore
                    } : d));
        }
    }, []);
    const addNotifKeyword = (0, $2eaC8.useCallback)((kw)=>{
        if (!notifKeywords.includes(kw)) {
            const updated = [
                ...notifKeywords,
                kw
            ];
            setNotifKeywords(updated);
            // Server is source of truth — no localStorage needed
            if (user) (0, $i2uG6.userRepository).saveProfile({
                ...user,
                notifKeywords: updated
            });
        }
    }, [
        notifKeywords,
        user
    ]);
    const removeNotifKeyword = (0, $2eaC8.useCallback)((kw)=>{
        const updated = notifKeywords.filter((k)=>k !== kw);
        setNotifKeywords(updated);
        // Server is source of truth — no localStorage needed
        if (user) (0, $i2uG6.userRepository).saveProfile({
            ...user,
            notifKeywords: updated
        });
    }, [
        notifKeywords,
        user
    ]);
    // v10.66 — these were previously fire-and-forget. On iOS Safari the
    // Supabase JS SDK's auth-refresh inTabLock can hang for tens of seconds
    // after a backgrounded tab returns, causing saveProfile() to reject
    // silently. The UI showed the rule "added" while the DB held nothing,
    // and the seller would later wonder why no notification ever arrived.
    // Now we await the round-trip, revert local state on failure, and let
    // the caller (Profile.handleAdd) show a clear toast either way.
    const addSmartAlert = (0, $2eaC8.useCallback)(async (rule)=>{
        if (!user) return false;
        const previous = smartAlerts;
        const updated = [
            ...smartAlerts,
            rule
        ];
        setSmartAlerts(updated);
        try {
            await (0, $i2uG6.userRepository).saveProfile({
                ...user,
                smartAlerts: updated
            });
            return true;
        } catch (err) {
            (0, $4aj47.logger).error('Failed to save smart alert:', err);
            setSmartAlerts(previous);
            return false;
        }
    }, [
        smartAlerts,
        user
    ]);
    const removeSmartAlert = (0, $2eaC8.useCallback)(async (idx)=>{
        if (!user) return false;
        const previous = smartAlerts;
        const updated = smartAlerts.filter((_, i)=>i !== idx);
        setSmartAlerts(updated);
        try {
            await (0, $i2uG6.userRepository).saveProfile({
                ...user,
                smartAlerts: updated
            });
            return true;
        } catch (err) {
            (0, $4aj47.logger).error('Failed to remove smart alert:', err);
            setSmartAlerts(previous);
            return false;
        }
    }, [
        smartAlerts,
        user
    ]);
    // Booking logic - uses generateBarcode from helpers
    const bookDeal = (0, $2eaC8.useCallback)((deal, quantity = 1, userId = 'anon', prepTime, notes, selectedOptions, locationId, paymentMethod, fulfillment, deliveryAddress)=>{
        const barcode = (0, $3rEkS.generateBarcode)();
        // v14.10 — المهلة صارت من مسؤولية الخادم وحده: مشغّل `tr_ad_set_booking_hold`
        // يدهس ما نرسله هنا ويكتب المهلة الصحيحة بحسب نوع الطلب (استلام ساعتان ·
        // توصيل ستّ ساعات · تُضبط من صفّ `platform_settings.booking_holds` وحده).
        // ما نحسبه هنا قيمةٌ تفاؤلية تُعرض ثوانيَ حتى يصل الصفّ الحقيقي عبر
        // Realtime، فلا يرى المشتري بطاقةً بلا عدّاد.
        // v12.07 (يبقى قائماً) — لا تُقصّ المهلة أبداً إلى نهاية العرض.
        const now = Date.now();
        const optimisticHoldMs = (fulfillment === 'delivery' ? 6 : 2) * 3600000;
        const expiryTime = now + optimisticHoldMs;
        const booking = {
            deal: deal,
            barcode: barcode,
            backupCode: barcode,
            expiryTime: expiryTime,
            bookedAt: now,
            bookedQuantity: quantity,
            userId: userId,
            userName: user?.name || user?.shop || '',
            userPhone: user?.phone || user?.contactPhone || '',
            prepTime: prepTime,
            notes: notes,
            selectedOptions: // v12.53 — اختيارات المنتج المهيكلة (النص القارئ داخل notes أصلاً)
            selectedOptions,
            // v12.91 — الفرع المختار عند العرض متعدد المواقع (null = موقع واحد)
            locationId: locationId || null,
            // v13.11 — نية الدفع وقت الحجز (طلب ناصر): يخفي زر «ادفع الآن» عن COD
            paymentMethod: paymentMethod || undefined,
            // v14.06 — طريقة الاستلام وعنوانه. الرسوم **لا تُرسل**: حارس القاعدة
            // يحسبها من نطاق التاجر ويكتبها، ثم يعود الصفّ بها في أول مزامنة.
            fulfillment: fulfillment === 'delivery' ? 'delivery' : 'pickup',
            deliveryAddress: fulfillment === 'delivery' ? deliveryAddress || null : null,
            status: 'pending'
        };
        setBookings((prev)=>{
            const updated = [
                booking,
                ...prev
            ];
            return updated;
        });
        // v13.14 — الخصم الحقيقي للمخزون يتم ذرّياً في القاعدة (تريغر
        // tr_booking_stock_reserve يقفل صف العرض ويرفض عند النفاد، ثم
        // trg_adjust_deal_quantity يخصم). هنا خصم محلي تفاؤلي فقط ليتحدث
        // العداد فوراً أمام المشتري — وRealtime يجلب الرقم الحقيقي خلال أقل
        // من ثانية. (كتابة العميل السابقة updateDealStock بقيمة مطلقة أُزيلت —
        // كانت تفسد المخزون تحت التزامن العالي.)
        const hadStockCap = deal.quantity !== 'unlimited' && typeof deal.quantity === 'number' && typeof deal.initialQuantity === 'number' && deal.initialQuantity > 0;
        if (hadStockCap) setDeals((prev)=>prev.map((d)=>d.id === deal.id && typeof d.quantity === 'number' ? {
                    ...d,
                    quantity: Math.max(0, d.quantity - quantity)
                } : d));
        // Persist to remote — the server-side trigger
        // `tr_booking_notification` (migration v8.7) emits both the
        // "New Booking Request" alert to the seller (with prep_time/notes
        // baked in) and the "Booking Confirmed" alert to the buyer. We
        // deliberately do NOT addNotification(...) here to avoid duplicates.
        // v12.76 — الفشل لم يعد صامتاً: كان «أطلق وانسَ» فإذا رفض الحارس
        // (سباق حدود/مخزون) أو انقطعت الشبكة يبقى الطلب ظاهراً محلياً ثم
        // «يختفي» عند أول مزامنة والكمية منخصمة بلا حجز — الآن نتراجع
        // محلياً ونعيد الكمية ونخبر المشتري ليعيد المحاولة.
        // v13.29 — نهاية القِمع: حجز اكتمل فعلاً. يُسجَّل **بعد** نجاح الحفظ فقط،
        // فلا يُحتسب حجزٌ تراجعنا عنه (مخزون نفد/شبكة انقطعت) — وإلا لأظهرت
        // لوحة التاجر تحويلاً لم يحدث.
        // v14.28 — كان هذا «أطلق وانسَ»: الشاشة تقول «✅ تم تأكيد الحجز» وتنتقل
        // إلى «حجوزاتي»، ثم يصل ردّ الخادم بالرفض (نفد المخزون، تجاوز الحدّ،
        // حارس التوصيل) فيظهر تنبيه ثانٍ **في صفحة أخرى** ويختفي الطلب.
        // المشتري يقرأ نجاحاً ثم فشلاً لنفس الفعل.
        // الآن: `settled` وعدٌ لا يُحسم إلا بعد ردّ الخادم، والنداء ينتظره قبل
        // أن يُعلن شيئاً. ورسائل الرفض المصقولة تُمرَّر إليه ليعرضها في مكانها.
        let settle;
        const settled = new Promise((res)=>{
            settle = res;
        });
        const reject = (m)=>settle({
                ok: false,
                error: m
            });
        (0, $7hk6Y.bookingRepository).save(booking).then(()=>{
            settle({
                ok: true
            });
            // v14.80 — تُوسَم الجلسة «حجزت» فيصير التحويل قابلاً للقياس:
            // «كم زائراً من انستقرام حجز فعلاً» لا «كم زائراً جاء».
            Promise.resolve((parcelRequire("iw1Ih"))).then(({ markVisitBooked: markVisitBooked })=>markVisitBooked()).catch(()=>{});
            (parcelRequire("lJZYA")).then(({ trackEvent: trackEvent })=>trackEvent('booking_completed', deal.storeId, deal.id, {
                    metadata: {
                        qty: quantity
                    }
                })).catch(()=>{});
        }).catch((e)=>{
            const msg = e?.message || '';
            console.warn("Booking remote save FAILED \u2014 rolling back:", msg);
            setBookings((prev)=>prev.filter((b)=>b.barcode !== barcode));
            // v13.14 — استرجاع محلي فقط: الحفظ فشل = التريغر لم يخصم في القاعدة
            // أصلاً، فلا نكتب فيها شيئاً (الكتابة السابقة كانت تفسد المخزون).
            if (hadStockCap) setDeals((prev)=>prev.map((d)=>d.id === deal.id && typeof d.quantity === 'number' ? {
                        ...d,
                        quantity: d.quantity + quantity
                    } : d));
            // v13.14 — رسالة رفض المخزون الذري تصل هنا الآن (نفدت الكمية —
            // سبقك مشترون آخرون) وتُعرض كما هي بالعربية من القاعدة.
            // v13.15 — وكذلك رسائل حدّ الطلبات (⏳ محاولات كثيرة…) تُعرض كما هي.
            // v13.31 — كشفه اختبار التزاحم: نفاد كمية «النوع» يرفعه
            // tr_validate_booking_options برمز آلي `VARIANT_STOCK:الاسم:المتبقي`
            // (وطلبُ خيارٍ إلزامي بـ`NEEDS_OPTIONS`) — وكانا يسقطان في فرع
            // «تحقق من اتصالك» فيرى المشتري رمزاً إنجليزياً بدل السبب الحقيقي.
            const variantOut = msg.match(/VARIANT_STOCK:([^:]*):(\d+)/);
            const stockMsg = variantOut ? language === 'ar' ? `\u{646}\u{641}\u{62F}\u{62A} \u{643}\u{645}\u{64A}\u{629} \xab${variantOut[1]}\xbb \u{2014} \u{633}\u{628}\u{642}\u{643} \u{645}\u{634}\u{62A}\u{631}\u{648}\u{646} \u{622}\u{62E}\u{631}\u{648}\u{646} \u{625}\u{644}\u{64A}\u{647}\u{627} (\u{627}\u{644}\u{645}\u{62A}\u{627}\u{62D} \u{627}\u{644}\u{622}\u{646}: ${variantOut[2]})` : `"${variantOut[1]}" is sold out \u{2014} others booked it first (available now: ${variantOut[2]})` : msg;
            if (/NEEDS_OPTIONS/.test(msg)) {
                reject(language === 'ar' ? "\u26A0\uFE0F \u0627\u062E\u062A\u0631 \u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0645\u0646\u062A\u062C \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u0623\u0648\u0644\u0627\u064B \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629." : "\u26A0\uFE0F Please choose the required product options first, then try again.");
                return;
            }
            const isStockReject = !!variantOut || /نفدت|سبقك/.test(msg);
            if (isStockReject) {
                reject(`\u{26D4} ${stockMsg}`);
                return;
            }
            // v13.31 — كشفه اختبار التزاحم: حدود الحجز يرفعها
            // taki_enforce_booking_rules برموز آلية، وكانت تصل للمشتري كما هي
            // («TAKI_REBOOK_LIMIT:2») داخل رسالة «تحقق من اتصالك» المضلِّلة.
            const limitCode = msg.match(/TAKI_(MAX_QTY|REBOOK_LIMIT|REBOOK_WAIT):(\d+)/);
            if (limitCode) {
                const n = limitCode[2];
                const ar = limitCode[1] === 'MAX_QTY' ? `\u{26D4} \u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} ${n} \u{642}\u{637}\u{639}\u{629} \u{641}\u{64A} \u{627}\u{644}\u{637}\u{644}\u{628} \u{627}\u{644}\u{648}\u{627}\u{62D}\u{62F} \u{644}\u{647}\u{630}\u{627} \u{627}\u{644}\u{639}\u{631}\u{636} \u{2014} \u{642}\u{644}\u{651}\u{644} \u{627}\u{644}\u{643}\u{645}\u{64A}\u{629} \u{648}\u{623}\u{639}\u{62F} \u{627}\u{644}\u{645}\u{62D}\u{627}\u{648}\u{644}\u{629}.` : limitCode[1] === 'REBOOK_LIMIT' ? `\u{26D4} \u{648}\u{635}\u{644}\u{62A} \u{644}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{645}\u{633}\u{645}\u{648}\u{62D} (${n}) \u{645}\u{646} \u{627}\u{644}\u{62D}\u{62C}\u{648}\u{632}\u{627}\u{62A} \u{639}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{639}\u{631}\u{636}.` : `\u{23F3} \u{644}\u{627} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{625}\u{639}\u{627}\u{62F}\u{629} \u{627}\u{644}\u{62D}\u{62C}\u{632} \u{639}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{639}\u{631}\u{636} \u{625}\u{644}\u{627} \u{628}\u{639}\u{62F} ${n} \u{62F}\u{642}\u{64A}\u{642}\u{629}.`;
                const en = limitCode[1] === 'MAX_QTY' ? `\u{26D4} Max ${n} per order for this deal \u{2014} lower the quantity and try again.` : limitCode[1] === 'REBOOK_LIMIT' ? `\u{26D4} You reached the limit (${n}) of bookings on this deal.` : `\u{23F3} You can rebook this deal in ${n} minute(s).`;
                reject(language === 'ar' ? ar : en);
                return;
            }
            // v14.06 — رفض حارس التوصيل (SQLSTATE P0013). الرموز آلية، والمشتري
            // يجب أن يقرأ السبب لا الرمز — وإلا ظنّ أن الشبكة هي العلّة.
            const dlvMin = msg.match(/TAKI_DELIVERY_MIN_ORDER:([0-9.]+)/);
            if (dlvMin) {
                reject(language === 'ar' ? `\u{26D4} \u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{62F}\u{646}\u{649} \u{644}\u{637}\u{644}\u{628} \u{627}\u{644}\u{62A}\u{648}\u{635}\u{64A}\u{644} \u{645}\u{646} \u{647}\u{630}\u{627} \u{627}\u{644}\u{645}\u{62A}\u{62C}\u{631} ${dlvMin[1]} \u{631}.\u{633} \u{2014} \u{623}\u{636}\u{650}\u{641} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{623}\u{648} \u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{644}\u{627}\u{645} \u{645}\u{646} \u{627}\u{644}\u{645}\u{62A}\u{62C}\u{631}.` : `\u{26D4} This store's delivery minimum is ${dlvMin[1]} SAR \u{2014} add more or choose pickup.`);
                return;
            }
            if (/TAKI_DELIVERY_OUT_OF_ZONE/.test(msg)) {
                reject(language === 'ar' ? "\u26D4 \u0639\u0646\u0648\u0627\u0646\u0643 \u062E\u0627\u0631\u062C \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0648\u0635\u064A\u0644 \u0627\u0644\u0630\u064A \u062D\u062F\u0651\u062F\u0647 \u0647\u0630\u0627 \u0627\u0644\u0645\u062A\u062C\u0631 \u2014 \u0627\u062E\u062A\u0631 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0645\u0646 \u0627\u0644\u0645\u062A\u062C\u0631 \u0623\u0648 \u062D\u062F\u0651\u062B \u0639\u0646\u0648\u0627\u0646\u0643." : "\u26D4 Your address is outside this store's delivery area \u2014 choose pickup or update your address.");
                return;
            }
            if (/TAKI_DELIVERY_NO_ADDRESS/.test(msg)) {
                reject(language === 'ar' ? "\uD83D\uDCCD \u0644\u0627 \u064A\u0648\u062C\u062F \u0639\u0646\u0648\u0627\u0646 \u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0648\u0638 \u2014 \u0623\u0636\u0650\u0641\u0647 \u0645\u0646 \xab\u062D\u0633\u0627\u0628\u064A \u2190 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u2190 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062A\u0648\u0635\u064A\u0644\xbb \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629." : "\uD83D\uDCCD No saved delivery address \u2014 add it in \u201CMy account \u2192 Settings \u2192 Delivery address\u201D, then retry.");
                return;
            }
            if (/TAKI_DELIVERY_CARD_ONLY/.test(msg)) {
                reject(language === 'ar' ? "\uD83D\uDCB3 \u0627\u0644\u062A\u0648\u0635\u064A\u0644 \u0644\u062F\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062A\u062C\u0631 \u0628\u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0641\u0642\u0637 \u2014 \u0627\u062E\u062A\u0631 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629." : "\uD83D\uDCB3 Delivery at this store is card-only \u2014 choose online payment and retry.");
                return;
            }
            if (/TAKI_DELIVERY_OFF/.test(msg)) {
                reject(language === 'ar' ? "\uD83D\uDEAB \u0623\u0648\u0642\u0641 \u0647\u0630\u0627 \u0627\u0644\u0645\u062A\u062C\u0631 \u062E\u062F\u0645\u0629 \u0627\u0644\u062A\u0648\u0635\u064A\u0644 \u2014 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0645\u0646 \u0627\u0644\u0645\u062A\u062C\u0631 \u0645\u062A\u0627\u062D." : "\uD83D\uDEAB This store turned delivery off \u2014 pickup is available.");
                return;
            }
            if (/DEAL_NOT_ACTIVE/.test(msg)) {
                reject(language === 'ar' ? "\u26D4 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u0644\u0645 \u064A\u0639\u062F \u0645\u062A\u0627\u062D\u0627\u064B \u2014 \u0623\u0648\u0642\u0641\u0647 \u0627\u0644\u062A\u0627\u062C\u0631 \u0623\u0648 \u0627\u0646\u062A\u0647\u0649. \u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0644\u062A\u0631\u0649 \u0627\u0644\u0639\u0631\u0648\u0636 \u0627\u0644\u0633\u0627\u0631\u064A\u0629." : "\u26D4 This deal is no longer available \u2014 the merchant paused it or it ended. Refresh to see live deals.");
                return;
            }
            // v14.32 — رفضُ الحارس بسبب الإيقاف أو تعليق الحجز كان يسقط في فرع
            // «تحقق من اتصالك»، فيقرأ الموقوف أن المشكلة في الإنترنت ويعيد
            // المحاولة مراراً ويتّصل بالدعم شاكياً من «عطل في الموقع». القاعدة
            // ترفع نصّاً عربياً واضحاً بالفعل — فلنُوصله كما هو.
            if (/حسابك موقوف|تم تعليق الحجز|حسابك معلّق/.test(msg)) {
                reject(`\u{26D4} ${msg}`);
                return;
            }
            if (/P0018|لا يمكنك نشر عروض/.test(msg)) {
                reject(`\u{26D4} ${msg}`);
                return;
            }
            const isRateReject = /محاولات|الحد الأقصى لعدد/.test(msg);
            reject(language === 'ar' ? isRateReject ? msg : `\u{26A0}\u{FE0F} \u{644}\u{645} \u{64A}\u{643}\u{62A}\u{645}\u{644} \u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62D}\u{62C}\u{632} \u{2014} \u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{627}\u{62A}\u{635}\u{627}\u{644}\u{643} \u{648}\u{62D}\u{627}\u{648}\u{644} \u{645}\u{631}\u{629} \u{623}\u{62E}\u{631}\u{649}.${msg ? `\n(${msg})` : ''}` : isRateReject ? msg : `\u{26A0}\u{FE0F} Booking was not saved \u{2014} check your connection and try again.${msg ? `\n(${msg})` : ''}`);
        });
        // كل مسار في `catch` أعلاه ينتهي بـ`reject(...)`، وفرع النجاح بـ`settle({ok:true})`.
        // فالوعد محسومٌ دائماً ولا يبقى الزرّ «جارٍ…» معلّقاً.
        return Object.assign(booking, {
            settled: settled
        });
    }, [
        user,
        language
    ]);
    // In-flight tracker: prevents double-tap from a barcode scanner firing
    // two simultaneous status transitions for the same booking. Each entry
    // is cleared as soon as the RPC settles (success or failure).
    const bookingsInFlightRef = (0, $2eaC8.useRef)(new Set());
    const cancelBooking = (0, $2eaC8.useCallback)(async (barcode)=>{
        const target = bookings.find((b)=>b.barcode === barcode);
        if (!target || target.status === 'cancelled' || target.status === 'completed') return false;
        if (bookingsInFlightRef.current.has(barcode)) return false;
        bookingsInFlightRef.current.add(barcode);
        const previousStatus = target.status;
        // Optimistic update — feels instant.
        setBookings((prev)=>prev.map((b)=>b.barcode === barcode ? {
                    ...b,
                    status: 'cancelled'
                } : b));
        try {
            await (0, $7hk6Y.bookingRepository).updateStatus(barcode, 'cancelled');
            // v13.14 — استرجاع الكمية يتم ذرّياً في القاعدة (trg_adjust_deal_quantity
            // على status→cancelled). كتابة العميل السابقة (updateQuantity بقيمة مطلقة
            // من قراءة قديمة) كانت تُضخّم المخزون تحت التزامن (استرجاع مزدوج) —
            // أُزيلت. هنا تحديث محلي تفاؤلي فقط، وRealtime يجلب الرقم الحقيقي فوراً.
            if (target.deal && target.deal.quantity !== 'unlimited') {
                const currentDeal = dealsRef.current.find((d)=>d.id === target.deal.id);
                if (currentDeal && currentDeal.quantity !== 'unlimited') {
                    const restored = currentDeal.quantity + (target.bookedQuantity || 1);
                    setDeals((prev)=>prev.map((d)=>d.id === currentDeal.id ? {
                                ...d,
                                quantity: restored
                            } : d));
                }
            }
        } catch (e) {
            // RPC rejected the transition (already completed, RLS, etc.).
            // Roll the local row back so the UI matches the DB instead of
            // showing a status that doesn't exist server-side.
            setBookings((prev)=>prev.map((b)=>b.barcode === barcode ? {
                        ...b,
                        status: previousStatus
                    } : b));
            customAlert(language === 'ar' ? `\u{26A0}\u{FE0F} \u{641}\u{634}\u{644} \u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{62D}\u{62C}\u{632}: ${e?.message || "\u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641"}` : `\u{26A0}\u{FE0F} Cancel failed: ${e?.message || 'Unknown error'}`);
            return false;
        } finally{
            bookingsInFlightRef.current.delete(barcode);
        }
        return true;
    }, [
        bookings,
        language,
        customAlert
    ]);
    const completeBooking = (0, $2eaC8.useCallback)(async (barcode)=>{
        const target = bookings.find((b)=>b.barcode === barcode);
        if (!target || target.status === 'completed' || target.status === 'cancelled') return false;
        if (bookingsInFlightRef.current.has(barcode)) return false;
        bookingsInFlightRef.current.add(barcode);
        const previousStatus = target.status;
        setBookings((prev)=>prev.map((b)=>b.barcode === barcode ? {
                    ...b,
                    status: 'completed'
                } : b));
        try {
            await (0, $7hk6Y.bookingRepository).updateStatus(barcode, 'completed');
        // Success — server trigger emits buyer + seller + admin notifs.
        } catch (e) {
            // The "completion silently reverts" bug lived here: previously
            // we left the optimistic 'completed' in place even on failure,
            // and on the next realtime sync the row reverted to acknowledged
            // because DB never accepted the change. Roll back + tell the
            // user so they can retry.
            setBookings((prev)=>prev.map((b)=>b.barcode === barcode ? {
                        ...b,
                        status: previousStatus
                    } : b));
            customAlert(language === 'ar' ? `\u{26A0}\u{FE0F} \u{641}\u{634}\u{644} \u{62A}\u{623}\u{643}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{633}\u{644}\u{64A}\u{645}: ${e?.message || "\u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641"}. \u{62D}\u{627}\u{648}\u{644} \u{645}\u{631}\u{629} \u{623}\u{62E}\u{631}\u{649}.` : `\u{26A0}\u{FE0F} Completion failed: ${e?.message || 'Unknown error'}. Please retry.`);
            return false;
        } finally{
            bookingsInFlightRef.current.delete(barcode);
        }
        return true;
    }, [
        bookings,
        language,
        customAlert
    ]);
    const acknowledgeBooking = (0, $2eaC8.useCallback)(async (barcode, merchantNote)=>{
        const target = bookings.find((b)=>b.barcode === barcode);
        if (!target || target.status !== 'pending') return false;
        if (bookingsInFlightRef.current.has(barcode)) return false;
        bookingsInFlightRef.current.add(barcode);
        const previousStatus = target.status;
        const previousNote = target.merchantNote;
        setBookings((prev)=>prev.map((b)=>b.barcode === barcode ? {
                    ...b,
                    status: 'acknowledged',
                    merchantNote: merchantNote || b.merchantNote
                } : b));
        try {
            await (0, $7hk6Y.bookingRepository).updateStatus(barcode, 'acknowledged', merchantNote);
        } catch (e) {
            setBookings((prev)=>prev.map((b)=>b.barcode === barcode ? {
                        ...b,
                        status: previousStatus,
                        merchantNote: previousNote
                    } : b));
            customAlert(language === 'ar' ? `\u{26A0}\u{FE0F} \u{641}\u{634}\u{644} \u{62A}\u{623}\u{643}\u{64A}\u{62F} \u{627}\u{633}\u{62A}\u{644}\u{627}\u{645} \u{627}\u{644}\u{637}\u{644}\u{628}: ${e?.message || "\u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641"}. \u{62D}\u{627}\u{648}\u{644} \u{645}\u{631}\u{629} \u{623}\u{62E}\u{631}\u{649}.` : `\u{26A0}\u{FE0F} Acknowledge failed: ${e?.message || 'Unknown error'}. Please retry.`);
            return false;
        } finally{
            bookingsInFlightRef.current.delete(barcode);
        }
        return true;
    }, [
        bookings,
        language,
        customAlert
    ]);
    // Public refresh — for pages that mount after a booking event and want to
    // guarantee parity with the server even if a realtime packet was missed.
    const refreshBookings = (0, $2eaC8.useCallback)(async ()=>{
        if (!user?.id) return;
        try {
            const fresh = await (0, $7hk6Y.bookingRepository).getByUser(user.id, dealsRef.current);
            (0, $bRDgQ.writeSnapshot)('bk_' + user.id, fresh);
            setBookings((prev)=>{
                // Preserve any messages we already fetched per booking — the
                // bookings select doesn't include them.
                const byBarcode = {};
                prev.forEach((b)=>{
                    byBarcode[b.barcode] = b;
                });
                return fresh.map((b)=>({
                        ...b,
                        messages: byBarcode[b.barcode]?.messages
                    }));
            });
        } catch (e) {
            console.warn('refreshBookings failed:', e);
        }
    }, [
        user?.id
    ]);
    // ── Booking messages thread (buyer ↔ seller, 3+3 cap) ──
    const fetchBookingMessages = (0, $2eaC8.useCallback)(async (barcode)=>{
        try {
            const messages = await (0, $7hk6Y.bookingRepository).getMessages(barcode);
            setBookings((prev)=>prev.map((b)=>b.barcode === barcode ? {
                        ...b,
                        messages: messages
                    } : b));
        } catch (e) {
            console.warn('fetchBookingMessages failed:', e?.message || e);
        }
    }, []);
    const sendBookingMessage = (0, $2eaC8.useCallback)(async (barcode, body, attachmentPath)=>{
        const text = (body || '').trim();
        // v14.27 — صورةٌ بلا نصّ رسالةٌ كاملة. الخادم يضع 📎 نصّاً لأن الجدول
        // يمنع الفراغ، فلا نمنعها هنا بشرطٍ أقدم من الميزة.
        if (!text && !attachmentPath) return;
        try {
            const inserted = await (0, $7hk6Y.bookingRepository).sendMessage(barcode, text, attachmentPath);
            setBookings((prev)=>prev.map((b)=>{
                    if (b.barcode !== barcode) return b;
                    const existing = b.messages || [];
                    if (existing.find((m)=>m.id === inserted.id)) return b;
                    return {
                        ...b,
                        messages: [
                            ...existing,
                            inserted
                        ]
                    };
                }));
        } catch (e) {
            customAlert(language === 'ar' ? `\u{26A0}\u{FE0F} ${e?.message || "\u062A\u0639\u0630\u0651\u0631 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629"}` : `\u{26A0}\u{FE0F} ${e?.message || 'Could not send message'}`);
            throw e;
        }
    }, [
        customAlert,
        language
    ]);
    const markBookingMessagesRead = (0, $2eaC8.useCallback)(async (barcode)=>{
        try {
            await (0, $7hk6Y.bookingRepository).markMessagesRead(barcode);
            // Optimistic local update so the unread-dot disappears immediately
            setBookings((prev)=>prev.map((b)=>{
                    if (b.barcode !== barcode || !b.messages) return b;
                    const now = Date.now();
                    const myRole = b.userId === user?.id ? 'buyer' : b.deal?.storeId === user?.id ? 'seller' : null;
                    if (!myRole) return b;
                    return {
                        ...b,
                        messages: b.messages.map((m)=>m.senderRole !== myRole && !m.readAt ? {
                                ...m,
                                readAt: now
                            } : m)
                    };
                }));
        } catch (e) {
            console.warn('markBookingMessagesRead failed:', e?.message || e);
        }
    }, [
        user?.id
    ]);
    // Same idea for deals — Home calls this on mount / focus so a freshly
    // posted deal appears even if the global realtime packet was dropped.
    //
    // v13.22 — يُحدّث **الصفحة الأولى فقط** ويدمجها فوق ما حُمّل، فلا يفقد
    // المستخدم الصفحات التي مرّرها ولا نُعيد تنزيل الكتالوج كله.
    const refreshDeals = (0, $2eaC8.useCallback)(async ()=>{
        try {
            const { deals: firstPage, nextCursor: nextCursor, hasMore: hasMore } = await (0, $eGYci.dealRepository).getFeedPage();
            setDeals((prev)=>{
                const merged = $1f964efb45e2468a$var$mergeDealPages(firstPage, prev);
                (0, $bRDgQ.writeSnapshot)('deals', merged.slice(0, (0, $eGYci.DEALS_PAGE_SIZE) * 2));
                return merged;
            });
            // لم نكن قد مرّرنا بعد؟ إذاً مؤشّر الصفحة الأولى هو الصحيح.
            if (!dealsCursorRef.current) {
                dealsCursorRef.current = nextCursor;
                setHasMoreDeals(hasMore);
            }
        } catch (e) {
            console.warn('refreshDeals failed:', e);
        }
    }, []);
    /**
     * v13.22 — إدخال عروض مجلوبة باستعلام موجّه (عروض متجر بعينه) إلى النافذة.
     *
     * بعد الترقيم لم تعد `deals` تحوي الكتالوج كله، فصفحات المتجر التي تُرشّح
     * المصفوفة (`deals.filter(d => d.storeId === …)`) كانت سترى المُحمّل فقط.
     * بدل إعادة كتابة كل مواضع الترشيح، تجلب تلك الصفحات عروض متجرها وتُدخلها
     * هنا — فتبقى الشيفرة القائمة صحيحة تماماً والنتيجة مكتملة دائماً.
     */ // v13.29 — أبلغ ناقل القياس بهوية المتجر الحالي حتى لا تُحتسب مشاهدات
    // التاجر ونقراته على منتجاته هو (كان أكبر مصدر تضخّم في الأرقام).
    (0, $2eaC8.useEffect)(()=>{
        (parcelRequire("lJZYA")).then(({ setAnalyticsIdentity: setAnalyticsIdentity })=>setAnalyticsIdentity(user?.userType === 'seller' || user?.userType === 'admin' ? user?.id || null : null)).catch(()=>{});
    }, [
        user?.id,
        user?.userType
    ]);
    const ingestDeals = (0, $2eaC8.useCallback)((incoming)=>{
        if (!incoming?.length) return;
        setDeals((prev)=>$1f964efb45e2468a$var$mergeDealPages(incoming, prev));
    }, []);
    /**
     * v13.22 — تحميل الصفحة التالية (التمرير اللانهائي).
     * محميّ من الاستدعاء المتزامن بمرجع (ref) فلا تُحمَّل الصفحة مرتين لو
     * أطلق المراقب الحدث سريعاً مرتين.
     */ const loadMoreDeals = (0, $2eaC8.useCallback)(async ()=>{
        if (loadingMoreRef.current || !dealsCursorRef.current) return;
        loadingMoreRef.current = true;
        setLoadingMoreDeals(true);
        try {
            const { deals: page, nextCursor: nextCursor, hasMore: hasMore } = await (0, $eGYci.dealRepository).getFeedPage({
                cursor: dealsCursorRef.current
            });
            if (page.length) setDeals((prev)=>$1f964efb45e2468a$var$mergeDealPages(prev, page));
            dealsCursorRef.current = nextCursor;
            setHasMoreDeals(hasMore);
        } catch (e) {
            console.warn('loadMoreDeals failed:', e);
        } finally{
            loadingMoreRef.current = false;
            setLoadingMoreDeals(false);
        }
    }, []);
    // v14.06 — دالة قياس التقييمات المعلّقة تحتاج إدخال عرضٍ غير محمَّل. تُربَط
    // هنا **بعد** تعريف `ingestDeals`: ربطها قبله يرمي TDZ في أول رسم (وهو الفخّ
    // الموثَّق في هذا الملف: `useCallback` يستدعي `const` سهمياً معرّفاً بعده).
    (0, $2eaC8.useEffect)(()=>{
        ingestDealsRef.current = ingestDeals;
    }, [
        ingestDeals
    ]);
    (0, $2eaC8.useEffect)(()=>{
        checkRatingRef.current = ()=>{
            checkPendingRatingPrompts();
        };
    }, [
        checkPendingRatingPrompts
    ]);
    const setLanguage = (0, $2eaC8.useCallback)((lang)=>{
        setLanguageState(lang);
        // Persist preference on the server when signed in. Local
        // storage is no longer the source of truth — see migration v8.13.
        if (user) {
            const updated = {
                ...user,
                preferredLang: lang
            };
            setUser(updated);
            (0, $1BuUO.authService).setUser(updated);
            (0, $i2uG6.userRepository).saveProfile(updated).catch(()=>{});
        }
    }, [
        user
    ]);
    // Stable refs for the realtime handlers. The central realtime effect
    // below must NOT re-subscribe every time these callbacks change identity.
    // `addNotification`/`showRealTimeAlert` are rebuilt whenever the `user`
    // object is replaced — and that happens 3-4× during a single login
    // (null → getCurrentUser → optimistic JWT profile → canonical DB row →
    // language hydrate). Each re-subscribe tore down and rebuilt every
    // Supabase channel mid-handshake, so notification/booking INSERTs were
    // dropped until the user manually refreshed (the "لازم أحدّث 3 مرات"
    // bug). Routing handlers through refs lets the effect depend on
    // `user?.id` alone and keep channels stable for the whole session.
    const showRealTimeAlertRef = (0, $2eaC8.useRef)(showRealTimeAlert);
    const addNotificationRef = (0, $2eaC8.useRef)(addNotification);
    const reconcileStatusRef = (0, $2eaC8.useRef)(reconcileStatus);
    const refreshDealsRef = (0, $2eaC8.useRef)(refreshDeals);
    (0, $2eaC8.useEffect)(()=>{
        refreshDealsRef.current = refreshDeals;
    }, [
        refreshDeals
    ]);
    // v13.80 — آخر حدث ريل‑تايم على `bookings` يخصّ هذا المستخدم، بعدّاد
    // تسلسلي حتى يميّز المستهلك حدثين متطابقين متتاليين (نفس الصفّ، نفس الحالة).
    const bookingEventSeqRef = (0, $2eaC8.useRef)(0);
    (0, $2eaC8.useEffect)(()=>{
        showRealTimeAlertRef.current = showRealTimeAlert;
    }, [
        showRealTimeAlert
    ]);
    (0, $2eaC8.useEffect)(()=>{
        addNotificationRef.current = addNotification;
    }, [
        addNotification
    ]);
    (0, $2eaC8.useEffect)(()=>{
        reconcileStatusRef.current = reconcileStatus;
    }, [
        reconcileStatus
    ]);
    // 🌍 CENTRAL REALTIME SYNC (Handles visibility, online/offline, etc.)
    (0, $2eaC8.useEffect)(()=>{
        const disconnect = (0, $eHxTy.realtimeService).connect({
            userId: user?.id || null,
            onNotificationInsert: (payload)=>{
                const n = payload.new;
                const mapped = {
                    id: n.id,
                    userId: n.user_id,
                    title: {
                        ar: n.title_ar,
                        en: n.title_en
                    },
                    body: {
                        ar: n.body_ar,
                        en: n.body_en
                    },
                    type: n.type,
                    isRead: !!n.is_read,
                    createdAt: new Date(n.created_at).getTime(),
                    metadata: n.meta_data
                };
                setNotifications((prev)=>{
                    if (prev.find((p)=>p.id === mapped.id)) return prev;
                    return [
                        mapped,
                        ...prev
                    ];
                });
                if (user?.id === n.user_id) {
                    // OS notification (if permitted) + the non-blocking in-app
                    // top banner. The banner is what guarantees the BUYER sees
                    // a "new message" heads-up too — previously they got
                    // nothing visible because only the seller had the (now
                    // removed) center box and the OS path is permission-gated.
                    showRealTimeAlertRef.current(mapped.title, mapped.body, mapped.id);
                    setInAppBanner({
                        id: mapped.id,
                        title: mapped.title,
                        body: mapped.body,
                        metadata: mapped.metadata
                    });
                }
            },
            onNotificationUpdate: (payload)=>{
                if (payload.eventType === 'DELETE') setNotifications((prev)=>prev.filter((n)=>n.id !== payload.old.id));
                else if (payload.eventType === 'UPDATE' && payload.new) setNotifications((prev)=>prev.map((n)=>n.id === payload.new.id ? {
                            ...n,
                            isRead: !!payload.new.is_read
                        } : n));
            },
            onBookingMessage: (payload)=>{
                // Live thread updates. INSERT = new message → append.
                // UPDATE = read-receipt (only field that changes is read_at).
                if (payload.eventType === 'INSERT' && payload.new) {
                    const row = payload.new;
                    const mapped = {
                        id: row.id,
                        barcode: row.barcode,
                        senderId: row.sender_id,
                        senderRole: row.sender_role,
                        body: row.body,
                        createdAt: new Date(row.created_at).getTime(),
                        readAt: row.read_at ? new Date(row.read_at).getTime() : null
                    };
                    setBookings((prev)=>prev.map((b)=>{
                            if (b.barcode !== mapped.barcode) return b;
                            const existing = b.messages || [];
                            if (existing.find((m)=>m.id === mapped.id)) return b;
                            return {
                                ...b,
                                messages: [
                                    ...existing,
                                    mapped
                                ]
                            };
                        }));
                } else if (payload.eventType === 'UPDATE' && payload.new) {
                    const row = payload.new;
                    setBookings((prev)=>prev.map((b)=>{
                            if (b.barcode !== row.barcode || !b.messages) return b;
                            return {
                                ...b,
                                messages: b.messages.map((m)=>m.id === row.id ? {
                                        ...m,
                                        readAt: row.read_at ? new Date(row.read_at).getTime() : null
                                    } : m)
                            };
                        }));
                }
            },
            onBookingChange: (payload)=>{
                // v13.80 — بثّ الحدث الخام للقوائم المُرقَّمة (`useBookingBrowse`).
                //
                // بلاغ ناصر: «الطلب اكتمل ووصلني الإشعار، والبطاقة ما زالت كما
                // هي ولم تنتقل للسجل». السبب: قائمتا «الجارية» و«السابقة» في
                // لوحة التاجر وصفحة الحجوزات تأتيان من الخادم صفحةً صفحة
                // (v13.28)، بينما الريل‑تايم كان يحدّث **مصفوفة السياق** وحدها.
                // فأي إتمام/إلغاء يقع من جهاز آخر أو من البوت أو من الطرف
                // الثاني كان لا يحرّك الصفّ حتى تحديث الصفحة يدوياً. (v13.71
                // عالجت الأفعال المحلية فقط بإعادة تحميل بعد الفعل نفسه.)
                const evRow = payload.new || payload.old;
                if (evRow?.barcode) {
                    const touchesMe = payload.eventType === 'DELETE' || evRow.user_id === user?.id || evRow.store_id === user?.id;
                    if (touchesMe) {
                        bookingEventSeqRef.current += 1;
                        setLastBookingEvent({
                            type: payload.eventType,
                            row: evRow,
                            seq: bookingEventSeqRef.current
                        });
                    }
                }
                if (payload.eventType === 'INSERT') {
                    const n = payload.new;
                    const isMine = n.user_id === user?.id || n.store_id === user?.id;
                    if (!isMine) return;
                    const mapped = {
                        barcode: n.barcode,
                        backupCode: n.backup_code,
                        deal: dealsRef.current.find((d)=>d.id === n.deal_id) || {
                            id: n.deal_id,
                            storeId: n.store_id,
                            itemName: "\u062A\u062E\u0641\u064A\u0636"
                        },
                        userId: n.user_id,
                        userName: n.user_name || undefined,
                        userPhone: n.user_phone || undefined,
                        bookedQuantity: n.booked_quantity,
                        prepTime: n.prep_time,
                        notes: n.notes,
                        status: n.status,
                        bookedAt: n.booked_at,
                        expiryTime: n.expiry_time
                    };
                    setBookings((prev)=>{
                        if (prev.find((b)=>b.barcode === mapped.barcode)) return prev;
                        return [
                            mapped,
                            ...prev
                        ];
                    });
                } else if (payload.eventType === 'UPDATE' && payload.new) {
                    const updated = payload.new;
                    setBookings((prev)=>{
                        const known = prev.find((b)=>b.barcode === updated.barcode);
                        if (known) return prev.map((b)=>b.barcode === updated.barcode ? {
                                ...b,
                                status: reconcileStatusRef.current(b.status, updated.status),
                                notes: updated.notes || b.notes
                            } : b);
                        return prev;
                    });
                    // اكتمل شراءُ هذا المشتري ⇒ نافذة «حقيقي/شكلي» ثم تقييم المتجر.
                    //
                    // v14.06 — كان هنا منطقٌ كامل يبني النافذة من العروض المحمَّلة،
                    // ويُعلِّم الحجز «معالَجاً» **قبل** التحقّق من وجود العرض — فمن
                    // كان عرضه خارج النافذة المحمَّلة (الحساب الجديد غالباً) لم تظهر
                    // له النافذة أبداً. صار المسار واحداً: نُنادي دالة القياس التي
                    // تسأل القاعدة «ما الذي ينقص فعلاً؟» — فتعمل هنا وعند كل فتح
                    // للتطبيق سواءً وصل الحدث أم فات.
                    if (updated.status === 'completed' && updated.user_id && updated.user_id === user?.id && !promptedRatingRef.current.has(updated.barcode)) checkRatingRef.current();
                } else if (payload.eventType === 'DELETE') setBookings((prev)=>prev.filter((b)=>b.barcode !== payload.old.barcode));
            },
            onDealChange: (payload)=>{
                Promise.resolve((parcelRequire("eGYci"))).then(({ dealRepository: dr })=>{
                    if (payload.eventType === 'INSERT' || payload.eventType === 'UPDATE') {
                        const mapped = dr.mapRowToDeal(payload.new);
                        if (mapped.status === 'deleted') {
                            setDeals((prev)=>prev.filter((d)=>d.id !== mapped.id));
                            return;
                        }
                        // DEAL MATCHING ENGINE: Notify the buyer if favorited deal price dropped or restocked
                        if (payload.eventType === 'UPDATE' && user?.id && mapped.storeId !== user.id) {
                            const before = payload.old;
                            const updated = payload.new;
                            if (favoritesRef.current.includes(mapped.id)) {
                                const priceDropped = before?.discounted_price != null && updated.discounted_price != null && updated.discounted_price < before.discounted_price;
                                const restocked = before?.quantity === 0 && updated.quantity && updated.quantity > 0;
                                if (priceDropped) addNotificationRef.current(user.id, {
                                    ar: "\uD83D\uDCB8 \u0627\u0646\u062E\u0641\u0636 \u0633\u0639\u0631 \u0645\u0646\u062A\u062C \u0641\u064A \u0645\u0641\u0636\u0644\u062A\u0643!",
                                    en: "\uD83D\uDCB8 Price drop on a favorite!"
                                }, {
                                    ar: `${updated.item_name}: ${updated.discounted_price} \u{631}.\u{633} (\u{643}\u{627}\u{646} ${before.discounted_price} \u{631}.\u{633})`,
                                    en: `${updated.item_name}: ${updated.discounted_price} SAR (was ${before.discounted_price} SAR)`
                                }, 'deal', {
                                    dealId: updated.id
                                });
                                else if (restocked) addNotificationRef.current(user.id, {
                                    ar: "\uD83D\uDCE6 \u0645\u0646\u062A\u062C\u0643 \u0627\u0644\u0645\u0641\u0636\u0644 \u0639\u0627\u062F \u0644\u0644\u062A\u0648\u0641\u0631!",
                                    en: "\uD83D\uDCE6 Favorite restocked!"
                                }, {
                                    ar: `${updated.item_name} \u{641}\u{64A} ${updated.shop_name} \u{623}\u{635}\u{628}\u{62D} \u{645}\u{62A}\u{627}\u{62D}\u{627}\u{64B} \u{645}\u{62C}\u{62F}\u{62F}\u{627}\u{64B}.`,
                                    en: `${updated.item_name} at ${updated.shop_name} is available again.`
                                }, 'deal', {
                                    dealId: updated.id
                                });
                            }
                        }
                        setDeals((prev)=>{
                            const exists = prev.find((d)=>d.id === mapped.id);
                            // mapRowToDeal returns authReal/authFake=0 and
                            // myAuthVote=null (the realtime row doesn't carry the
                            // per-user vote — those are hydrated separately in
                            // getAll). Merging naively wiped the buyer's own
                            // authenticity vote on every deal tick, so the
                            // post-purchase modal re-asked and a re-vote could
                            // flip real↔fake. Preserve the hydrated values. v12.10
                            if (exists) return prev.map((d)=>d.id === mapped.id ? {
                                    ...d,
                                    ...mapped,
                                    authReal: d.authReal ?? mapped.authReal,
                                    authFake: d.authFake ?? mapped.authFake,
                                    myAuthVote: d.myAuthVote === true || d.myAuthVote === false ? d.myAuthVote : mapped.myAuthVote
                                } : d);
                            return [
                                mapped,
                                ...prev
                            ];
                        });
                    } else if (payload.eventType === 'DELETE') setDeals((prev)=>prev.filter((d)=>d.id !== payload.old.id));
                });
            },
            // A rating written anywhere (bot/app/another device) → re-pull deals so
            // its ratings (and the store average) surface within seconds, not on the
            // next manual reload. Ratings are infrequent, so a refetch is cheap.
            // v13.21 — SCALE-CRITICAL: this used to call `dealRepository.getAll()`
            // on EVERY rating change anywhere on the platform — re-downloading
            // the entire deals table + every rating to EVERY connected client.
            // One review by one buyer cost N clients a full catalogue download.
            // Now we apply the delta from the payload to the one affected deal.
            onRatingChange: (payload)=>{
                const row = payload?.new ?? payload?.old;
                const dealId = row?.deal_id;
                if (!dealId) return;
                const removed = payload?.eventType === 'DELETE' || !!payload?.new?.deleted_at;
                const mapped = payload?.new ? {
                    id: payload.new.id,
                    userId: payload.new.user_id,
                    userName: payload.new.user_name,
                    score: Number(payload.new.score) || 0,
                    comment: payload.new.comment ?? '',
                    // بتوقيت الجهاز — toISOString (UTC) يرجع اليوم للوراء قبل ٣ فجراً
                    date: payload.new.created_at ? (()=>{
                        const d = new Date(payload.new.created_at);
                        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                    })() : '',
                    reply: payload.new.reply ?? undefined,
                    repliedBy: payload.new.replied_by ?? undefined,
                    repliedAt: payload.new.replied_at ?? undefined,
                    likedBy: Array.isArray(payload.new.liked_by) ? payload.new.liked_by : [],
                    likeCount: Number(payload.new.like_count) || 0
                } : null;
                setDeals((prev)=>prev.map((d)=>{
                        if (d.id !== dealId) return d;
                        const list = Array.isArray(d.ratings) ? d.ratings : [];
                        const without = list.filter((r)=>r.id !== row.id);
                        return {
                            ...d,
                            ratings: removed || !mapped ? without : [
                                mapped,
                                ...without
                            ]
                        };
                    }));
            },
            onUserChange: (payload)=>{
                const newUser = payload.new;
                const oldUser = payload.old;
                // v13.21 — SCALE-CRITICAL: was `getAllSellers()` (a full
                // download of every merchant row, with select('*')) on EVERY
                // merchant row change, for every connected client. Now the
                // changed merchant is merged in place — O(1) instead of O(N).
                // Gate is «not a buyer» (never `=== 'seller'`): Nasser's own
                // store is admin-owned and a seller-only check drops it.
                const roleOf = newUser?.user_type ?? oldUser?.user_type;
                if (roleOf && roleOf !== 'buyer') {
                    const sid = newUser?.id ?? oldUser?.id;
                    if (sid) setStoreProfiles((prev)=>{
                        const next = {
                            ...prev
                        };
                        if (payload.eventType === 'DELETE' || newUser?.deleted_at) delete next[sid];
                        else if (newUser) next[sid] = {
                            ...prev[sid],
                            ...(0, $i2uG6.mapUserRowToProfile)(newUser)
                        };
                        return next;
                    });
                }
                // Update current user if it's me
                if (user?.id && newUser?.id === user.id && payload.eventType === 'UPDATE') {
                    const newFollowed = Array.isArray(newUser.followed_merchants) ? newUser.followed_merchants : undefined;
                    if (newFollowed) setFollowedMerchants(newFollowed);
                    const newBlocked = Array.isArray(newUser.blocked_merchants) ? newUser.blocked_merchants : undefined;
                    if (newBlocked) setBlockedMerchants(newBlocked);
                    setUser((prev)=>({
                            ...prev,
                            name: newUser.name,
                            phone: newUser.phone,
                            shop: newUser.shop,
                            bio: newUser.bio,
                            avatar_url: newUser.avatar_url,
                            contactPhone: newUser.contact_phone,
                            followedMerchants: newFollowed || prev.followedMerchants,
                            blockedMerchants: newBlocked || prev.blockedMerchants,
                            // v14.06 — عنوان التوصيل يُحدَّث من أي جهاز آخر أيضاً
                            // (غيّره على الجوال فيسري على المتصفح بلا إعادة تحميل).
                            deliveryAddress: newUser.delivery_address && typeof newUser.delivery_address === 'object' ? newUser.delivery_address : newUser.delivery_address === null ? null : prev.deliveryAddress
                        }));
                }
            },
            onFavoriteChange: (payload)=>{
                if (payload.eventType === 'INSERT') setFavorites((prev)=>prev.includes(payload.new.deal_id) ? prev : [
                        ...prev,
                        payload.new.deal_id
                    ]);
                else if (payload.eventType === 'DELETE') setFavorites((prev)=>prev.filter((id)=>id !== payload.old.deal_id));
            },
            onRefreshAll: async ()=>{
                (0, $4aj47.logger).info("\uD83D\uDD04 Full Refresh Triggered");
                // v14.06 — تقييمٌ فات صاحبه: كل عودة للواجهة تُعيد القياس، فلا
                // يضيع تقييمٌ لأن الجوال كان في الجيب لحظة الاستلام.
                checkRatingRef.current();
                const ruid = user?.id;
                await Promise.allSettled([
                    // v13.80 — الصفحة الأولى لا الكتالوج كله. كان التحديث الكامل
                    // (عودة من الخلفية، اتصال يعود، سحب للتحديث) ينزّل **كل**
                    // عروض المنصّة رغم أن الفتح نفسه صار مُرقّماً منذ v13.22 —
                    // تناقض كان سيصير قاتلاً مع مليون عرض. `refreshDeals` تجلب
                    // الصفحة الأولى وتدمجها مع المُحمَّل فلا يضيع تمرير المستخدم.
                    refreshDealsRef.current(),
                    // Preserve previously-fetched per-booking chat messages — the
                    // bookings select doesn't include them, so a naive setBookings(fresh)
                    // would wipe `messages` on every focus/visibility refresh and force
                    // every open BookingThread to re-fetch from scratch.
                    ruid ? Promise.resolve((parcelRequire("7hk6Y"))).then(({ bookingRepository: br })=>br.getByUser(ruid, dealsRef.current).then((fresh)=>{
                            (0, $bRDgQ.writeSnapshot)('bk_' + ruid, fresh);
                            setBookings((prev)=>{
                                const byBarcode = {};
                                prev.forEach((b)=>{
                                    byBarcode[b.barcode] = b;
                                });
                                return fresh.map((b)=>({
                                        ...b,
                                        messages: byBarcode[b.barcode]?.messages
                                    }));
                            });
                        })) : Promise.resolve(),
                    ruid ? Promise.resolve((parcelRequire("lGggQ"))).then(({ notificationRepository: nr })=>nr.browsePage(null, 100).then((p)=>{
                            setNotifications(p.rows);
                            setNotifUnread(p.unreadTotal);
                            (0, $bRDgQ.writeSnapshot)('notif_' + ruid, p.rows);
                        })) : Promise.resolve(),
                    ruid ? hydrateFavorites(ruid) : Promise.resolve(),
                    // v13.80 — دمج لا استبدال: الاستبدال كان يمسح ملفات المتاجر
                    // التي جُلبت بالمعرّف (متجر خارج الصفحة المسقوفة) فتفقد
                    // بطاقاته اسمه وشعاره حتى تُجلب من جديد.
                    Promise.resolve((parcelRequire("i2uG6"))).then(({ userRepository: ur })=>ur.getAllSellers().then((sellers)=>{
                            setStoreProfiles((prev)=>{
                                const merged = {
                                    ...prev
                                };
                                sellers.forEach((s)=>{
                                    merged[s.id] = s;
                                });
                                (0, $bRDgQ.writeSnapshot)('sellers', merged);
                                return merged;
                            });
                        }))
                ]);
            }
        });
        return ()=>disconnect();
    // Depend ONLY on the user id. The handlers above read the latest
    // showRealTimeAlert/addNotification/reconcileStatus via refs, so the
    // realtime channels are created once per signed-in user and stay
    // subscribed for the whole session instead of being torn down and
    // rebuilt every time an unrelated callback changes identity.
    }, [
        user?.id
    ]);
    // Effective user-type for rendering. Admins can flip into buyer/seller
    // preview mode via setViewAs; non-admins always see their real role.
    const effectiveUserType = user?.userType === 'admin' && viewAs ? viewAs : user?.userType || 'buyer';
    // v11.19 — admin permission derivations. Single source of truth; both
    // the dashboard tab filtering and individual action buttons consult
    // `hasPermission`. Super admin always wins; non-admins always lose.
    const isSuperAdmin = user?.userType === 'admin' && user?.isSuperAdmin === true;
    const adminPermissions = user?.userType === 'admin' && Array.isArray(user?.adminPermissions) ? user.adminPermissions : [];
    const hasPermission = (0, $2eaC8.useCallback)((perm)=>{
        if (!user || user.userType !== 'admin') return false;
        if (user.isSuperAdmin === true) return true;
        return Array.isArray(user.adminPermissions) && user.adminPermissions.includes(perm);
    }, [
        user
    ]);
    const incrementDealView = async (dealId)=>{
        try {
            const { error: error } = await (0, $hUL2G.supabase).rpc('increment_deal_view', {
                target_deal_id: dealId
            });
            if (error) throw error;
            setDeals((prev)=>prev.map((d)=>d.id === dealId ? {
                        ...d,
                        views: (d.views || 0) + 1
                    } : d));
        } catch (err) {
            (0, $4aj47.logger).error('View inc error:', err);
        }
    };
    const incrementDealClick = async (dealId)=>{
        try {
            const { error: error } = await (0, $hUL2G.supabase).rpc('increment_deal_click', {
                target_deal_id: dealId
            });
            if (error) throw error;
            setDeals((prev)=>prev.map((d)=>d.id === dealId ? {
                        ...d,
                        clicks: (d.clicks || 0) + 1
                    } : d));
        } catch (err) {
            (0, $4aj47.logger).error('Click inc error:', err);
        }
    };
    const saveBranch = (0, $2eaC8.useCallback)(async (input)=>{
        if (!user?.id) return null;
        try {
            const saved = await (0, $hVlFU.branchRepository).upsert({
                ...input,
                merchantId: user.id
            });
            if (saved) setBranches((prev)=>{
                const idx = prev.findIndex((b)=>b.id === saved.id);
                if (idx >= 0) {
                    const next = [
                        ...prev
                    ];
                    next[idx] = saved;
                    return next;
                }
                return [
                    ...prev,
                    saved
                ];
            });
            return saved;
        } catch (err) {
            (0, $4aj47.logger).error('saveBranch error:', err);
            throw err;
        }
    }, [
        user?.id
    ]);
    /**
     * v14.75c — تحرير بطاقة الموقع (الاسم/العنوان) **بتحديثٍ خالص**.
     *
     * 🔴 لماذا لا `saveBranch`: تلك `upsert` = `INSERT … ON CONFLICT DO UPDATE`،
     *    فتُطلق مسار **BEFORE INSERT** في حارس السقف، والإعفاء «المفتاح لم
     *    يتغيّر» محبوسٌ داخل فرع `TG_OP='UPDATE'` وحده — فكانت إعادةُ تسمية
     *    فرعٍ لمتجرٍ بلغ سقفه مستحيلة. قِيس على جدة: `UPDATE` نجح على نفس
     *    الصفّ الذي ردّ فيه `upsert` بـ`LOCATION_LIMIT_EXCEEDED`.
     */ const updateBranchCard = (0, $2eaC8.useCallback)(async (id, patch)=>{
        const res = await (0, $hVlFU.branchRepository).setCard(id, patch);
        if (res.ok) setBranches((prev)=>prev.map((b)=>b.id === id ? {
                    ...b,
                    ...patch.nameAr !== undefined ? {
                        nameAr: patch.nameAr.trim().slice(0, 80)
                    } : {},
                    ...patch.address !== undefined ? {
                        address: String(patch.address ?? '').trim().slice(0, 200) || null
                    } : {}
                } : b));
        return res;
    }, []);
    const removeBranch = (0, $2eaC8.useCallback)(async (id)=>{
        const prevList = branches;
        // Optimistic — drop locally first so the chip vanishes instantly.
        setBranches((prev)=>prev.filter((b)=>b.id !== id));
        try {
            await (0, $hVlFU.branchRepository).remove(id);
        } catch (err) {
            // Roll back on failure so the seller sees the chip again and
            // knows the delete didn't actually land.
            (0, $4aj47.logger).error('removeBranch error:', err);
            setBranches(prevList);
            throw err;
        }
    }, [
        branches
    ]);
    // Memoize the context value to prevent unnecessary re-renders
    // ===== Malls/markets hydrated from the DB (admin-managed) =====
    // The bots already read public.locations live; here we pull the same curated
    // list into the app and mutate the bundled LOCATIONS array in place, then bump
    // geoVersion so the whole tree re-reads it. So edits in «إدارة المولات» reflect
    // on the website too — one source of truth. Falls back to the bundled list if
    // the fetch is empty/fails. (v12.01)
    const [geoVersion, setGeoVersion] = (0, $2eaC8.useState)(0);
    const reloadGeo = (0, $2eaC8.useCallback)(async ()=>{
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('locations').select('id,name,name_en,type,city_id,lat,lng');
            if (error || !data || data.length === 0) return;
            const mapped = data.map((r)=>({
                    id: String(r.id),
                    name: r.name,
                    nameEn: r.name_en || undefined,
                    type: r.type === 'market' ? 'market' : 'mall',
                    cityId: r.city_id,
                    lat: Number(r.lat),
                    lng: Number(r.lng)
                }));
            (0, $gMErx.replaceLocations)(mapped);
            setGeoVersion((v)=>v + 1);
        } catch  {}
    }, []);
    (0, $2eaC8.useEffect)(()=>{
        reloadGeo();
    }, [
        reloadGeo
    ]);
    const contextValue = (0, $2eaC8.useMemo)(()=>({
            language: language,
            setLanguage: setLanguage,
            geoVersion: geoVersion,
            reloadGeo: reloadGeo,
            deals: deals,
            loading: loading,
            isAuthReady: isAuthReady,
            addDeal: addDeal,
            updateDeal: updateDeal,
            deleteDeal: deleteDeal,
            user: user,
            logout: logout,
            deleteAccount: deleteAccount,
            favorites: favorites,
            toggleFavorite: toggleFavorite,
            followedMerchants: followedMerchants,
            toggleFollowMerchant: toggleFollowMerchant,
            blockedMerchants: blockedMerchants,
            toggleBlockMerchant: toggleBlockMerchant,
            notifications: notifications,
            notifUnread: notifUnread,
            addNotification: addNotification,
            markNotifRead: markNotifRead,
            markAllNotifsRead: markAllNotifsRead,
            bookings: bookings,
            bookDeal: bookDeal,
            cancelBooking: cancelBooking,
            completeBooking: completeBooking,
            acknowledgeBooking: acknowledgeBooking,
            sendBookingMessage: sendBookingMessage,
            fetchBookingMessages: fetchBookingMessages,
            markBookingMessagesRead: markBookingMessagesRead,
            refreshBookings: refreshBookings,
            lastBookingEvent: lastBookingEvent,
            refreshDeals: refreshDeals,
            loadMoreDeals: loadMoreDeals,
            hasMoreDeals: hasMoreDeals,
            loadingMoreDeals: loadingMoreDeals,
            ingestDeals: ingestDeals,
            addRating: addRating,
            updateRating: updateRating,
            addReply: addReply,
            toggleRatingLike: toggleRatingLike,
            removeRating: removeRating,
            topLocation: topLocation,
            setTopLocation: setTopLocation,
            homeCity: homeCity,
            setHomeCity: setHomeCity,
            notifKeywords: notifKeywords,
            addNotifKeyword: addNotifKeyword,
            removeNotifKeyword: removeNotifKeyword,
            smartAlerts: smartAlerts,
            addSmartAlert: addSmartAlert,
            removeSmartAlert: removeSmartAlert,
            storeProfiles: storeProfiles,
            sponsors: sponsors,
            updateStoreProfile: updateStoreProfile,
            ensureStoreProfiles: ensureStoreProfiles,
            updateProfile: updateProfile,
            checkMarketingAlerts: checkMarketingAlerts,
            liveLocation: liveLocation,
            locationPermission: locationPermission,
            locationIsFresh: locationIsFresh,
            requestLiveLocation: requestLiveLocation,
            darkMode: darkMode,
            toggleDarkMode: toggleDarkMode,
            customAlert: customAlert,
            customConfirm: customConfirm,
            customPrompt: customPrompt,
            inAppBanner: inAppBanner,
            dismissInAppBanner: dismissInAppBanner,
            viewAs: viewAs,
            setViewAs: setViewAs,
            effectiveUserType: effectiveUserType,
            impersonating: impersonating,
            startImpersonating: startImpersonating,
            stopImpersonating: stopImpersonating,
            isSuperAdmin: isSuperAdmin,
            adminPermissions: adminPermissions,
            hasPermission: hasPermission,
            incrementDealView: incrementDealView,
            incrementDealClick: incrementDealClick,
            platformSettings: platformSettings,
            platformSettingsReady: platformSettingsReady,
            branches: branches,
            saveBranch: saveBranch,
            updateBranchCard: updateBranchCard,
            removeBranch: removeBranch
        }), [
        language,
        setLanguage,
        geoVersion,
        reloadGeo,
        deals,
        loading,
        isAuthReady,
        addDeal,
        updateDeal,
        deleteDeal,
        user,
        logout,
        deleteAccount,
        favorites,
        toggleFavorite,
        followedMerchants,
        toggleFollowMerchant,
        blockedMerchants,
        toggleBlockMerchant,
        notifications,
        notifUnread,
        addNotification,
        markNotifRead,
        markAllNotifsRead,
        bookings,
        bookDeal,
        cancelBooking,
        completeBooking,
        acknowledgeBooking,
        sendBookingMessage,
        fetchBookingMessages,
        markBookingMessagesRead,
        refreshBookings,
        lastBookingEvent,
        refreshDeals,
        loadMoreDeals,
        hasMoreDeals,
        loadingMoreDeals,
        ingestDeals,
        addRating,
        updateRating,
        addReply,
        toggleRatingLike,
        removeRating,
        topLocation,
        setTopLocation,
        homeCity,
        setHomeCity,
        notifKeywords,
        addNotifKeyword,
        removeNotifKeyword,
        smartAlerts,
        addSmartAlert,
        removeSmartAlert,
        storeProfiles,
        sponsors,
        updateStoreProfile,
        ensureStoreProfiles,
        updateProfile,
        checkMarketingAlerts,
        liveLocation,
        locationPermission,
        locationIsFresh,
        requestLiveLocation,
        darkMode,
        toggleDarkMode,
        customAlert,
        customConfirm,
        customPrompt,
        inAppBanner,
        dismissInAppBanner,
        viewAs,
        setViewAs,
        effectiveUserType,
        impersonating,
        startImpersonating,
        stopImpersonating,
        isSuperAdmin,
        adminPermissions,
        hasPermission,
        incrementDealView,
        incrementDealClick,
        platformSettings,
        platformSettingsReady,
        branches,
        saveBranch,
        updateBranchCard,
        removeBranch
    ]);
    return /*#__PURE__*/ (0, $gCmhw.jsxs)($1f964efb45e2468a$var$AppContext.Provider, {
        value: contextValue,
        children: [
            children,
            impersonating && user && /*#__PURE__*/ (0, $gCmhw.jsx)("style", {
                children: `@keyframes taki-spin{to{transform:rotate(360deg)}}`
            }),
            impersonating && user && /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                style: {
                    position: 'fixed',
                    top: 'env(safe-area-inset-top, 0)',
                    insetInlineStart: 0,
                    insetInlineEnd: 0,
                    zIndex: 99999,
                    background: 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
                    color: 'white',
                    padding: '10px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 10,
                    boxShadow: '0 6px 18px rgba(185, 28, 28, 0.55)',
                    fontFamily: 'inherit'
                },
                dir: language === 'ar' ? 'rtl' : 'ltr',
                children: [
                    /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                        style: {
                            fontWeight: 900,
                            fontSize: '0.85rem',
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $gCmhw.jsx)("span", {
                                style: {
                                    fontSize: '1rem'
                                },
                                children: "\uD83D\uDD13"
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsxs)("span", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: [
                                    "\u062C\u064E\u0644\u0633\u0629 \u0643\u0627\u0645\u0644\u0629 \u0643\u064E\u0640 ",
                                    /*#__PURE__*/ (0, $gCmhw.jsx)("strong", {
                                        children: user?.name || "\u2014"
                                    }),
                                    " (",
                                    user?.userType === 'seller' ? "\u062A\u0627\u062C\u0631" : "\u0645\u064F\u0634\u062A\u0631\u064A",
                                    ") \u2014 \u0643\u0644 \u062A\u064E\u0639\u062F\u064A\u0644 \u064A\u064E\u062A\u0645 \u0628\u0650\u0627\u0633\u0645\u0647"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                        onClick: stopImpersonating,
                        disabled: stoppingImp,
                        style: {
                            background: 'white',
                            color: '#b91c1c',
                            border: 'none',
                            borderRadius: 999,
                            padding: '6px 14px',
                            fontWeight: 900,
                            fontSize: '0.78rem',
                            cursor: stoppingImp ? 'wait' : 'pointer',
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                            fontFamily: 'inherit',
                            opacity: stoppingImp ? 0.7 : 1,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6
                        },
                        children: stoppingImp ? /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $gCmhw.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gCmhw.jsx)("span", {
                                    style: {
                                        display: 'inline-block',
                                        width: 12,
                                        height: 12,
                                        borderRadius: '50%',
                                        border: '2px solid rgba(185,28,28,0.3)',
                                        borderTopColor: '#b91c1c',
                                        animation: 'taki-spin 0.7s linear infinite'
                                    }
                                }),
                                "\u062C\u0627\u0631\u064A \u0627\u0644\u0631\u064F\u0651\u062C\u0648\u0639..."
                            ]
                        }) : /*#__PURE__*/ (0, $gCmhw.jsx)((0, $gCmhw.Fragment), {
                            children: "\uD83D\uDD19 \u0631\u062C\u0648\u0639 \u0644\u0644\u0645\u062F\u064A\u0631"
                        })
                    })
                ]
            }),
            user?.userType === 'admin' && viewAs && /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                onClick: ()=>{
                    setViewAs(null);
                    window.location.assign('/admin');
                },
                style: {
                    position: 'fixed',
                    bottom: 90,
                    insetInlineStart: 16,
                    zIndex: 9999,
                    padding: '10px 14px',
                    borderRadius: 999,
                    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                    color: 'white',
                    fontWeight: 900,
                    fontSize: '0.85rem',
                    border: 'none',
                    cursor: 'pointer',
                    boxShadow: '0 6px 18px rgba(245,158,11,0.45)'
                },
                children: language === 'ar' ? `\u{1F441}\u{FE0F} \u{645}\u{639}\u{627}\u{64A}\u{646}\u{629} \u{643}\u{640}${viewAs === 'buyer' ? "\u0645\u0634\u062A\u0631\u064D" : "\u062A\u0627\u062C\u0631"} \u{2014} \u{631}\u{62C}\u{648}\u{639}` : `\u{1F441}\u{FE0F} Previewing as ${viewAs} \u{2014} exit`
            }),
            ratingPrompt && /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                style: {
                    position: 'fixed',
                    inset: 0,
                    zIndex: 99990,
                    background: 'rgba(0,0,0,0.55)',
                    backdropFilter: 'blur(6px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 18
                },
                children: /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                    className: "animate-fade-in",
                    style: {
                        background: 'var(--card-bg)',
                        color: 'var(--text-primary)',
                        borderRadius: 24,
                        width: '100%',
                        maxWidth: 400,
                        boxShadow: '0 24px 60px rgba(0,0,0,0.4)',
                        overflow: 'hidden'
                    },
                    children: [
                        /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                            style: {
                                // Authenticity header is BLUE (matches the real/fake blue/yellow
                                // scheme); green/red are reserved for shop open/closed. v11.98
                                background: ratingStep === 'auth' ? 'linear-gradient(135deg, #1d4ed8, #1e40af)' : 'linear-gradient(135deg, #0f172a, #334155)',
                                color: '#fff',
                                padding: '22px 20px 18px',
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                                    style: {
                                        fontSize: '2.2rem',
                                        marginBottom: 4
                                    },
                                    children: ratingStep === 'auth' ? "\uD83D\uDEE1\uFE0F" : ratingStep === 'done' ? "\uD83D\uDE4F" : "\u2B50"
                                }),
                                /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                                    style: {
                                        fontSize: '1.12rem',
                                        fontWeight: 900
                                    },
                                    children: ratingStep === 'auth' ? language === 'ar' ? "\u0647\u0644 \u0647\u0630\u0627 \u0627\u0644\u0639\u0631\u0636 \u062D\u0642\u064A\u0642\u064A \u0623\u0645 \u0634\u0643\u0644\u064A\u061F" : 'Is this offer real or cosmetic?' : ratingStep === 'done' ? language === 'ar' ? "\u0634\u0643\u0631\u0627\u064B \u0644\u0643 \uD83D\uDE4F" : "Thank you \uD83D\uDE4F" : prevReview ? language === 'ar' ? "\u062A\u0639\u062F\u064A\u0644 \u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0645\u062A\u062C\u0631" : 'Edit your store rating' : language === 'ar' ? "\u0646\u0631\u062C\u0648 \u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0645\u062A\u062C\u0631" : 'Please rate the store'
                                }),
                                /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                                    style: {
                                        fontSize: '0.83rem',
                                        fontWeight: 600,
                                        opacity: 0.9,
                                        marginTop: 5,
                                        lineHeight: 1.6
                                    },
                                    children: ratingStep === 'auth' ? language === 'ar' ? `\u{633}\u{627}\u{639}\u{62F} \u{628}\u{642}\u{64A}\u{629} \u{627}\u{644}\u{645}\u{634}\u{62A}\u{631}\u{64A}\u{646} \u{2014} \u{647}\u{644} \u{643}\u{627}\u{646} \u{639}\u{631}\u{636} \xab${ratingPrompt.storeName}\xbb \u{645}\u{637}\u{627}\u{628}\u{642}\u{627}\u{64B} \u{644}\u{644}\u{648}\u{627}\u{642}\u{639}\u{61F}` : `Help other buyers \u{2014} was the offer at \u{201C}${ratingPrompt.storeName}\u{201D} as described?` : ratingStep === 'done' ? language === 'ar' ? `\u{644}\u{642}\u{62F} \u{642}\u{64A}\u{651}\u{645}\u{62A} \xab${ratingPrompt.storeName}\xbb \u{633}\u{627}\u{628}\u{642}\u{627}\u{64B} \u{2014} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{62A}\u{639}\u{62F}\u{64A}\u{644} \u{62A}\u{642}\u{64A}\u{64A}\u{645}\u{643} \u{623}\u{648} \u{62D}\u{630}\u{641}\u{647}.` : `You already rated \u{201C}${ratingPrompt.storeName}\u{201D} \u{2014} you can edit or delete your rating.` : language === 'ar' ? `\u{62A}\u{642}\u{64A}\u{64A}\u{645}\u{643} \u{64A}\u{647}\u{645}\u{651}\u{646}\u{627} \u{1F64F} \u{2014} \u{643}\u{64A}\u{641} \u{643}\u{627}\u{646}\u{62A} \u{62A}\u{62C}\u{631}\u{628}\u{62A}\u{643} \u{645}\u{639} \xab${ratingPrompt.storeName}\xbb\u{61F}` : `Your feedback matters \u{1F64F} \u{2014} how was your experience with \u{201C}${ratingPrompt.storeName}\u{201D}?`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                            style: {
                                padding: 20
                            },
                            children: [
                                ratingStep === 'auth' && (()=>{
                                    const myVote = deals.find((d)=>d.id === ratingPrompt.dealId)?.myAuthVote;
                                    const hasVote = myVote === true || myVote === false;
                                    const proceed = ()=>setRatingStep(prevReview ? 'done' : 'rate');
                                    return /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                                                style: {
                                                    fontSize: '0.8rem',
                                                    fontWeight: 600,
                                                    color: 'var(--text-secondary)',
                                                    lineHeight: 1.7,
                                                    background: 'var(--gray-100)',
                                                    borderRadius: 12,
                                                    padding: '10px 12px',
                                                    textAlign: language === 'ar' ? 'right' : 'left'
                                                },
                                                children: language === 'ar' ? /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $gCmhw.Fragment), {
                                                    children: [
                                                        "\uD83D\uDD35 ",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("b", {
                                                            children: "\u0639\u0631\u0636 \u062D\u0642\u064A\u0642\u064A"
                                                        }),
                                                        ": \u062E\u0635\u0645 \u0641\u0639\u0644\u064A \u0639\u0644\u0649 \u0627\u0644\u0633\u0639\u0631.",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("br", {}),
                                                        "\uD83D\uDFE1 ",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("b", {
                                                            children: "\u0639\u0631\u0636 \u0634\u0643\u0644\u064A"
                                                        }),
                                                        ": \u0627\u0644\u062A\u062E\u0641\u064A\u0636 \u063A\u064A\u0631 \u0641\u0639\u0644\u064A (\u0646\u0641\u0633 \u0627\u0644\u0633\u0639\u0631\u060C \u0623\u0648 \u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0623\u0635\u0644\u064A \u0645\u0631\u0641\u0648\u0639).",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("span", {
                                                            style: {
                                                                opacity: 0.8
                                                            },
                                                            children: "\u0647\u0630\u0627 \u062A\u0642\u064A\u064A\u0645 \u0644\u0645\u0635\u062F\u0627\u0642\u064A\u0629 \u0627\u0644\u0639\u0631\u0636 \u0641\u0642\u0637 \u2014 \u0648\u0644\u064A\u0633 \u0627\u062A\u0647\u0627\u0645\u0627\u064B \u0644\u0644\u0645\u062A\u062C\u0631 \u0628\u0627\u0644\u0646\u0635\u0628."
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $gCmhw.Fragment), {
                                                    children: [
                                                        "\uD83D\uDD35 ",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("b", {
                                                            children: "Real offer"
                                                        }),
                                                        ": a genuine price cut.",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("br", {}),
                                                        "\uD83D\uDFE1 ",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("b", {
                                                            children: "Cosmetic offer"
                                                        }),
                                                        ": no real cut (same price, or an inflated original price).",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("span", {
                                                            style: {
                                                                opacity: 0.8
                                                            },
                                                            children: "This rates the offer's credibility only \u2014 it is not a fraud accusation."
                                                        })
                                                    ]
                                                })
                                            }),
                                            hasVote && /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                                                style: {
                                                    fontSize: '0.82rem',
                                                    fontWeight: 800,
                                                    color: 'var(--text-primary)',
                                                    lineHeight: 1.7,
                                                    background: myVote ? 'rgba(29,78,216,0.10)' : 'rgba(234,179,8,0.14)',
                                                    border: `1.5px solid ${myVote ? 'rgba(29,78,216,0.35)' : 'rgba(202,138,4,0.4)'}`,
                                                    borderRadius: 12,
                                                    padding: '10px 12px',
                                                    textAlign: 'center'
                                                },
                                                children: language === 'ar' ? /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $gCmhw.Fragment), {
                                                    children: [
                                                        "\u062A\u0635\u0648\u064A\u062A\u0643 \u0627\u0644\u0633\u0627\u0628\u0642: ",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("b", {
                                                            children: myVote ? "\uD83D\uDD35 \u0639\u0631\u0636 \u062D\u0642\u064A\u0642\u064A" : "\uD83D\uDFE1 \u0639\u0631\u0636 \u0634\u0643\u0644\u064A"
                                                        }),
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("span", {
                                                            style: {
                                                                fontWeight: 600,
                                                                color: 'var(--text-secondary)'
                                                            },
                                                            children: "\u064A\u0645\u0643\u0646\u0643 \u062A\u063A\u064A\u064A\u0631\u0647 \u0627\u0644\u0622\u0646 \u0623\u0648 \u0627\u0644\u0625\u0628\u0642\u0627\u0621 \u0639\u0644\u064A\u0647."
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $gCmhw.Fragment), {
                                                    children: [
                                                        "Your previous vote: ",
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("b", {
                                                            children: myVote ? "\uD83D\uDD35 Real offer" : "\uD83D\uDFE1 Cosmetic offer"
                                                        }),
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $gCmhw.jsx)("span", {
                                                            style: {
                                                                fontWeight: 600,
                                                                color: 'var(--text-secondary)'
                                                            },
                                                            children: "You can change it now or keep it."
                                                        })
                                                    ]
                                                })
                                            }),
                                            [
                                                true,
                                                false
                                            ].map((isReal)=>/*#__PURE__*/ (0, $gCmhw.jsxs)("button", {
                                                    disabled: authVoting,
                                                    onClick: async ()=>{
                                                        if (authVoting) return;
                                                        setAuthVoting(true);
                                                        const ok = await recordAuthVote(ratingPrompt.dealId, isReal);
                                                        setAuthVoting(false);
                                                        if (!ok) {
                                                            customAlert(language === 'ar' ? "\u274C \u062A\u0639\u0630\u0651\u0631 \u062A\u0633\u062C\u064A\u0644 \u062A\u0635\u0648\u064A\u062A\u0643\u060C \u062D\u0627\u0648\u0644 \u0644\u0627\u062D\u0642\u0627\u064B" : "\u274C Could not record your vote, try later");
                                                            return;
                                                        }
                                                        if (hasVote && myVote !== isReal) customAlert(language === 'ar' ? "\u2705 \u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u062A\u0635\u0648\u064A\u062A\u0643 \u0628\u0646\u062C\u0627\u062D" : "\u2705 Your vote was changed");
                                                        proceed();
                                                    },
                                                    style: {
                                                        width: '100%',
                                                        padding: 16,
                                                        borderRadius: 16,
                                                        // BLUE = real, YELLOW = fake (green/red reserved for
                                                        // shop open/closed). Yellow needs dark text. v11.98
                                                        border: myVote === isReal ? '2.5px solid #10b981' : 'none',
                                                        background: isReal ? 'linear-gradient(135deg, #1d4ed8, #2563eb)' : 'linear-gradient(135deg, #facc15, #eab308)',
                                                        color: isReal ? '#fff' : '#713f12',
                                                        fontWeight: 900,
                                                        fontSize: '1rem',
                                                        cursor: authVoting ? 'default' : 'pointer',
                                                        opacity: authVoting ? 0.7 : 1
                                                    },
                                                    children: [
                                                        isReal ? language === 'ar' ? "\uD83D\uDD35 \u0639\u0631\u0636 \u062D\u0642\u064A\u0642\u064A" : "\uD83D\uDD35 Real offer" : language === 'ar' ? "\uD83D\uDFE1 \u0639\u0631\u0636 \u0634\u0643\u0644\u064A" : "\uD83D\uDFE1 Cosmetic offer",
                                                        myVote === isReal ? language === 'ar' ? " \u2713 (\u062A\u0635\u0648\u064A\u062A\u0643 \u0627\u0644\u062D\u0627\u0644\u064A)" : " \u2713 (current)" : ''
                                                    ]
                                                }, String(isReal))),
                                            hasVote && /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                                onClick: proceed,
                                                style: {
                                                    width: '100%',
                                                    padding: 13,
                                                    borderRadius: 14,
                                                    border: '1.5px solid var(--border-color)',
                                                    background: 'var(--body-bg)',
                                                    color: 'var(--text-primary)',
                                                    fontWeight: 800,
                                                    fontSize: '0.9rem',
                                                    cursor: 'pointer'
                                                },
                                                children: language === 'ar' ? "\u21A9\uFE0F \u0645\u062A\u0627\u0628\u0639\u0629 \u0628\u062F\u0648\u0646 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062A\u0635\u0648\u064A\u062A" : "\u21A9\uFE0F Continue without changing"
                                            }),
                                            /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                                onClick: dismissRatingPrompt,
                                                style: {
                                                    width: '100%',
                                                    padding: 10,
                                                    marginTop: 2,
                                                    background: 'none',
                                                    border: 'none',
                                                    color: 'var(--text-secondary)',
                                                    fontWeight: 700,
                                                    fontSize: '0.8rem',
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline'
                                                },
                                                children: language === 'ar' ? "\u0644\u0627\u062D\u0642\u0627\u064B" : 'Later'
                                            })
                                        ]
                                    });
                                })(),
                                ratingStep === 'rate' && /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $gCmhw.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                justifyContent: 'center',
                                                gap: 8,
                                                marginBottom: 16
                                            },
                                            children: [
                                                1,
                                                2,
                                                3,
                                                4,
                                                5
                                            ].map((star)=>/*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                                    type: "button",
                                                    "aria-label": `${star}`,
                                                    onClick: ()=>setRatingStars(star),
                                                    style: {
                                                        fontSize: '2rem',
                                                        background: 'none',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        padding: 2,
                                                        filter: star <= ratingStars ? 'none' : 'grayscale(1)',
                                                        opacity: star <= ratingStars ? 1 : 0.35,
                                                        transition: 'opacity 0.15s ease'
                                                    },
                                                    children: "\u2B50"
                                                }, star))
                                        }),
                                        /*#__PURE__*/ (0, $gCmhw.jsx)("textarea", {
                                            value: ratingComment,
                                            onChange: (e)=>setRatingComment(e.target.value),
                                            placeholder: language === 'ar' ? "\u0627\u0643\u062A\u0628 \u062A\u0639\u0644\u064A\u0642\u0643 \u0639\u0646 \u0627\u0644\u0645\u062A\u062C\u0631 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)..." : "Write your comment about the store (optional)\u2026",
                                            style: {
                                                width: '100%',
                                                padding: 14,
                                                borderRadius: 14,
                                                minHeight: 84,
                                                border: '1.5px solid var(--border-color)',
                                                background: 'var(--body-bg)',
                                                color: 'var(--text-primary)',
                                                fontSize: '0.9rem',
                                                outline: 'none',
                                                resize: 'none',
                                                marginBottom: 16,
                                                fontFamily: 'inherit'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                            onClick: async ()=>{
                                                if (ratingSubmitting) return;
                                                setRatingSubmitting(true);
                                                // v12.30 — editing an existing rating UPDATES it in
                                                // place; only a first-time rating INSERTs.
                                                const isEdit = !!(prevReview && prevReview.id && prevReview.dealId);
                                                const ok = isEdit ? await updateRating(prevReview.dealId, prevReview.id, {
                                                    score: ratingStars,
                                                    comment: ratingComment.trim()
                                                }) : await addRating(ratingPrompt.dealId, {
                                                    score: ratingStars,
                                                    comment: ratingComment.trim()
                                                });
                                                setRatingSubmitting(false);
                                                setRatingPrompt(null);
                                                if (ok === 'duplicate') customAlert(language === 'ar' ? "\u0644\u0642\u062F \u0642\u064A\u0651\u0645\u062A \u0647\u0630\u0627 \u0627\u0644\u0645\u062A\u062C\u0631 \u0633\u0627\u0628\u0642\u0627\u064B \u2014 \u0627\u0641\u062A\u062D \u0635\u0641\u062D\u0629 \u0627\u0644\u0639\u0631\u0636 \u0644\u062A\u0639\u062F\u064A\u0644 \u062A\u0642\u064A\u064A\u0645\u0643." : "You already rated this store \u2014 open the deal page to edit your rating.");
                                                else if (!ok) customAlert(language === 'ar' ? "\u274C \u062A\u0639\u0630\u0651\u0631 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062A\u0642\u064A\u064A\u0645\u060C \u062D\u0627\u0648\u0644 \u0644\u0627\u062D\u0642\u0627\u064B" : "\u274C Could not submit your rating, try later");
                                                else if (isEdit) customAlert(language === 'ar' ? "\u2705 \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u062A\u0642\u064A\u064A\u0645\u0643 \u0628\u0646\u062C\u0627\u062D" : "\u2705 Your rating was updated");
                                            },
                                            disabled: ratingSubmitting,
                                            style: {
                                                width: '100%',
                                                padding: 15,
                                                borderRadius: 16,
                                                border: 'none',
                                                background: 'var(--primary)',
                                                color: '#fff',
                                                fontWeight: 900,
                                                fontSize: '0.98rem',
                                                cursor: ratingSubmitting ? 'default' : 'pointer'
                                            },
                                            children: ratingSubmitting ? language === 'ar' ? "\u23F3 \u062C\u0627\u0631\u064A \u0627\u0644\u0625\u0631\u0633\u0627\u0644..." : "\u23F3 Submitting\u2026" : prevReview ? language === 'ar' ? "\u062D\u0641\u0638 \u0627\u0644\u062A\u0639\u062F\u064A\u0644 \u2705" : "Save changes \u2705" : language === 'ar' ? "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062A\u0642\u064A\u064A\u0645 \u2705" : "Submit rating \u2705"
                                        }),
                                        /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                            onClick: dismissRatingPrompt,
                                            style: {
                                                width: '100%',
                                                padding: 10,
                                                marginTop: 10,
                                                background: 'none',
                                                border: 'none',
                                                color: 'var(--text-secondary)',
                                                fontWeight: 700,
                                                fontSize: '0.8rem',
                                                cursor: 'pointer',
                                                textDecoration: 'underline'
                                            },
                                            children: language === 'ar' ? "\u0644\u0627\u062D\u0642\u0627\u064B" : 'Later'
                                        })
                                    ]
                                }),
                                ratingStep === 'done' && /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $gCmhw.Fragment), {
                                    children: [
                                        prevReview && /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                                            style: {
                                                textAlign: 'center',
                                                marginBottom: 14
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                                                    style: {
                                                        color: '#f59e0b',
                                                        fontSize: '1.6rem',
                                                        letterSpacing: 2
                                                    },
                                                    children: [
                                                        "\u2605".repeat(prevReview.score),
                                                        "\u2606".repeat(5 - prevReview.score)
                                                    ]
                                                }),
                                                prevReview.comment && /*#__PURE__*/ (0, $gCmhw.jsxs)("p", {
                                                    style: {
                                                        marginTop: 8,
                                                        fontSize: '0.88rem',
                                                        color: 'var(--text-primary)',
                                                        lineHeight: 1.6
                                                    },
                                                    children: [
                                                        "\u201C",
                                                        prevReview.comment,
                                                        "\u201D"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $gCmhw.jsx)("p", {
                                            style: {
                                                fontSize: '0.8rem',
                                                color: 'var(--text-secondary)',
                                                lineHeight: 1.7,
                                                marginBottom: 14,
                                                textAlign: 'center'
                                            },
                                            children: language === 'ar' ? "\u064A\u064F\u0633\u0645\u062D \u0628\u062A\u0642\u064A\u064A\u0645 \u0648\u0627\u062D\u062F \u0644\u0643\u0644 \u0645\u062A\u062C\u0631 \u2014 \u0648\u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644\u0647 \u0623\u0648 \u062D\u0630\u0641\u0647 \u0641\u064A \u0623\u064A \u0648\u0642\u062A \u0625\u0630\u0627 \u062A\u063A\u064A\u0651\u0631\u062A \u062A\u062C\u0631\u0628\u062A\u0643." : "One rating per store \u2014 and you can edit or delete it anytime if your experience changed."
                                        }),
                                        /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                gap: 10,
                                                marginBottom: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                                    onClick: ()=>{
                                                        setRatingStars(prevReview?.score || 5);
                                                        setRatingComment(prevReview?.comment || '');
                                                        setRatingStep('rate');
                                                    },
                                                    style: {
                                                        flex: 1,
                                                        padding: 13,
                                                        borderRadius: 14,
                                                        border: 'none',
                                                        background: 'linear-gradient(135deg, #0f172a, #334155)',
                                                        color: '#fff',
                                                        fontWeight: 900,
                                                        fontSize: '0.88rem',
                                                        cursor: 'pointer'
                                                    },
                                                    children: language === 'ar' ? "\u270F\uFE0F \u062A\u0639\u062F\u064A\u0644 \u062A\u0642\u064A\u064A\u0645\u064A" : "\u270F\uFE0F Edit my rating"
                                                }),
                                                /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                                    onClick: async ()=>{
                                                        if (!prevReview?.id || !prevReview.dealId) return;
                                                        const yes = await customConfirm(language === 'ar' ? "\u062D\u0630\u0641 \u062A\u0642\u064A\u064A\u0645\u0643 \u0627\u0644\u0633\u0627\u0628\u0642 \u0646\u0647\u0627\u0626\u064A\u0627\u064B\u061F \u064A\u0645\u0643\u0646\u0643 \u0643\u062A\u0627\u0628\u0629 \u062A\u0642\u064A\u064A\u0645 \u062C\u062F\u064A\u062F \u0628\u0639\u062F \u0627\u0644\u062D\u0630\u0641." : 'Delete your previous rating permanently? You can write a new one after.');
                                                        if (!yes) return;
                                                        await removeRating(prevReview.dealId, prevReview.id);
                                                        setPrevReview(null);
                                                        setRatingStars(5);
                                                        setRatingComment('');
                                                        setRatingStep('rate');
                                                        customAlert(language === 'ar' ? "\uD83D\uDDD1 \u062A\u0645 \u062D\u0630\u0641 \u062A\u0642\u064A\u064A\u0645\u0643 \u2014 \u064A\u0645\u0643\u0646\u0643 \u0643\u062A\u0627\u0628\u0629 \u062A\u0642\u064A\u064A\u0645 \u062C\u062F\u064A\u062F \u0627\u0644\u0622\u0646." : "\uD83D\uDDD1 Rating deleted \u2014 you can write a new one now.");
                                                    },
                                                    style: {
                                                        flex: 1,
                                                        padding: 13,
                                                        borderRadius: 14,
                                                        border: '1.5px solid rgba(239,68,68,0.4)',
                                                        background: 'rgba(239,68,68,0.08)',
                                                        color: '#ef4444',
                                                        fontWeight: 900,
                                                        fontSize: '0.88rem',
                                                        cursor: 'pointer'
                                                    },
                                                    children: language === 'ar' ? "\uD83D\uDDD1 \u062D\u0630\u0641 \u062A\u0642\u064A\u064A\u0645\u064A" : "\uD83D\uDDD1 Delete my rating"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                            onClick: ()=>toggleFollowMerchant(ratingPrompt.storeId),
                                            style: {
                                                width: '100%',
                                                padding: 14,
                                                borderRadius: 16,
                                                border: 'none',
                                                background: followedMerchants.includes(ratingPrompt.storeId) ? 'linear-gradient(135deg, #16a34a, #22c55e)' : 'var(--primary)',
                                                color: '#fff',
                                                fontWeight: 900,
                                                fontSize: '0.95rem',
                                                cursor: 'pointer'
                                            },
                                            children: followedMerchants.includes(ratingPrompt.storeId) ? language === 'ar' ? "\u2705 \u062A\u062A\u0627\u0628\u0639 \u0647\u0630\u0627 \u0627\u0644\u0645\u062A\u062C\u0631" : "\u2705 Following this store" : language === 'ar' ? "\u2795 \u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u062A\u062C\u0631" : "\u2795 Follow store"
                                        }),
                                        /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                            onClick: dismissRatingPrompt,
                                            style: {
                                                width: '100%',
                                                padding: 10,
                                                marginTop: 10,
                                                background: 'none',
                                                border: 'none',
                                                color: 'var(--text-secondary)',
                                                fontWeight: 700,
                                                fontSize: '0.85rem',
                                                cursor: 'pointer'
                                            },
                                            children: language === 'ar' ? "\u0625\u063A\u0644\u0627\u0642" : 'Close'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            dialogConfig && /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 99999,
                    padding: 20
                },
                children: /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                    className: "animate-fade-in",
                    style: {
                        background: 'var(--card-bg, white)',
                        color: 'var(--text-primary, #0f172a)',
                        padding: 24,
                        borderRadius: 24,
                        width: '100%',
                        maxWidth: 400,
                        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                        textAlign: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                            style: {
                                fontSize: '1.1rem',
                                fontWeight: 800,
                                marginBottom: 24,
                                lineHeight: 1.6,
                                whiteSpace: 'pre-line'
                            },
                            children: dialogConfig.message
                        }),
                        /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: 12,
                                justifyContent: 'center'
                            },
                            children: [
                                dialogConfig.type === 'confirm' && /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                    onClick: ()=>{
                                        dialogConfig.resolve(false);
                                        closeDialog();
                                    },
                                    style: {
                                        flex: 1,
                                        padding: '12px',
                                        borderRadius: 14,
                                        border: 'none',
                                        background: 'var(--gray-100)',
                                        color: 'var(--gray-500, #64748b)',
                                        fontWeight: 800,
                                        fontSize: '1rem',
                                        cursor: 'pointer'
                                    },
                                    children: language === 'ar' ? "\u0625\u0644\u063A\u0627\u0621" : 'Cancel'
                                }),
                                /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                    onClick: ()=>{
                                        dialogConfig.resolve(true);
                                        closeDialog();
                                    },
                                    style: {
                                        flex: 1,
                                        padding: '12px',
                                        borderRadius: 14,
                                        border: 'none',
                                        background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                                        color: 'white',
                                        fontWeight: 800,
                                        fontSize: '1rem',
                                        cursor: 'pointer'
                                    },
                                    children: language === 'ar' ? "\u0645\u0648\u0627\u0641\u0642" : 'OK'
                                })
                            ]
                        })
                    ]
                })
            }),
            promptConfig && /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 10000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 20
                },
                children: /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                    style: {
                        backgroundColor: 'var(--card-bg)',
                        borderRadius: 24,
                        padding: 24,
                        width: '100%',
                        maxWidth: 400,
                        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                        textAlign: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                            style: {
                                fontSize: '1.1rem',
                                fontWeight: 900,
                                marginBottom: 20,
                                color: 'var(--text-primary)',
                                whiteSpace: 'pre-line'
                            },
                            children: promptConfig.message
                        }),
                        /*#__PURE__*/ (0, $gCmhw.jsx)("textarea", {
                            id: "custom-prompt-input",
                            autoFocus: true,
                            style: {
                                width: '100%',
                                minHeight: 100,
                                padding: 12,
                                borderRadius: 12,
                                border: '1.5px solid var(--border-color)',
                                background: 'var(--body-bg)',
                                color: 'var(--text-primary)',
                                fontSize: '1rem',
                                marginBottom: 20,
                                outline: 'none'
                            }
                        }),
                        /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                    onClick: ()=>{
                                        const val = document.getElementById('custom-prompt-input').value;
                                        promptConfig.resolve(val);
                                        closePrompt();
                                    },
                                    style: {
                                        flex: 1,
                                        padding: '14px',
                                        borderRadius: 12,
                                        backgroundColor: 'var(--primary)',
                                        color: 'white',
                                        border: 'none',
                                        fontWeight: 900,
                                        fontSize: '0.95rem'
                                    },
                                    children: language === 'ar' ? "\u0625\u0631\u0633\u0627\u0644" : 'Send'
                                }),
                                /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                                    onClick: ()=>{
                                        promptConfig.resolve(null);
                                        closePrompt();
                                    },
                                    style: {
                                        flex: 1,
                                        padding: '14px',
                                        borderRadius: 12,
                                        backgroundColor: 'var(--gray-200)',
                                        color: 'var(--text-secondary)',
                                        border: 'none',
                                        fontWeight: 800,
                                        fontSize: '0.95rem'
                                    },
                                    children: language === 'ar' ? "\u0625\u0644\u063A\u0627\u0621" : 'Cancel'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $1f964efb45e2468a$export$fca13ab91e1a6240 = ()=>{
    const context = (0, $2eaC8.useContext)($1f964efb45e2468a$var$AppContext);
    if (!context) throw new Error('useApp must be used within AppProvider');
    return context;
};

});
parcelRegister("gMErx", function(module, exports) {

$parcel$export(module.exports, "CATEGORIES", function () { return $9ec848631800ed29$export$a513ea61a7bee91c; });
$parcel$export(module.exports, "GENDERS", function () { return $9ec848631800ed29$export$8e2993016c604bf0; });
$parcel$export(module.exports, "findNearestCity", function () { return $9ec848631800ed29$export$a3e368fe59f79872; });
$parcel$export(module.exports, "CITIES", function () { return $9ec848631800ed29$export$f03f7c19d8f50e16; });
$parcel$export(module.exports, "LOCATIONS", function () { return $9ec848631800ed29$export$9396c9157495b4d; });
$parcel$export(module.exports, "findNearestLocation", function () { return $9ec848631800ed29$export$28ddc432f7315b6a; });
$parcel$export(module.exports, "REGIONS", function () { return $9ec848631800ed29$export$36b79d2b85570e14; });
$parcel$export(module.exports, "USER_LOCATION", function () { return $9ec848631800ed29$export$33e59afb97a56e0a; });
$parcel$export(module.exports, "getLocation", function () { return $9ec848631800ed29$export$e7fd20fad3cf4b5f; });
$parcel$export(module.exports, "getCity", function () { return $9ec848631800ed29$export$a7423564503d66c; });
$parcel$export(module.exports, "getRegion", function () { return $9ec848631800ed29$export$d4a625cede2da71b; });
$parcel$export(module.exports, "replaceLocations", function () { return $9ec848631800ed29$export$bee660cf687be4d1; });
$parcel$export(module.exports, "geoName", function () { return $9ec848631800ed29$export$67ff3b7b3f2ff4f9; });
$parcel$export(module.exports, "getStore", function () { return $9ec848631800ed29$export$6fec604aa7293d0c; });
const $9ec848631800ed29$export$a513ea61a7bee91c = [
    {
        id: 'all',
        ar: "\u0627\u0644\u0643\u0644",
        en: 'All',
        emoji: "\uD83D\uDD25"
    },
    {
        id: 'Fashion_Women',
        ar: "\u0641\u0633\u0627\u062A\u064A\u0646 \u0648\u0646\u0633\u0627\u0621",
        en: 'Women & Dresses',
        emoji: "\uD83D\uDC57"
    },
    {
        id: 'Fashion_Men',
        ar: "\u0645\u0644\u0627\u0628\u0633 \u0631\u062C\u0627\u0644\u064A\u0629",
        en: 'Men Fashion',
        emoji: "\uD83D\uDC54"
    },
    {
        id: 'Kids_Infants',
        ar: "\u0631\u0636\u0639 \u0648\u0645\u0644\u0627\u0628\u0633 \u062D\u0645\u0644",
        en: 'Infants & Maternity',
        emoji: "\uD83D\uDC76"
    },
    {
        id: 'Kids_Girls',
        ar: "\u0645\u0644\u0627\u0628\u0633 \u0623\u0637\u0641\u0627\u0644",
        en: 'Kids',
        emoji: "\uD83D\uDC67"
    },
    {
        id: 'Electronics',
        ar: "\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0627\u062A",
        en: 'Electronics',
        emoji: "\uD83D\uDCF1"
    },
    {
        id: 'Food',
        ar: "\u0645\u0637\u0627\u0639\u0645",
        en: 'Food',
        emoji: "\uD83C\uDF54"
    },
    {
        id: 'Beauty',
        ar: "\u0639\u0637\u0648\u0631 \u0648\u062A\u062C\u0645\u064A\u0644",
        en: 'Beauty',
        emoji: "\uD83D\uDC84"
    },
    {
        id: 'Glasses',
        ar: "\u0646\u0638\u0627\u0631\u0627\u062A",
        en: 'Eyewear',
        emoji: "\uD83D\uDC53"
    },
    {
        id: 'MensSalon',
        ar: "\u0635\u0627\u0644\u0648\u0646 \u0631\u062C\u0627\u0644\u064A",
        en: 'Barbershop',
        emoji: "\uD83D\uDC88"
    },
    {
        id: 'WomensSalon',
        ar: "\u0635\u0627\u0644\u0648\u0646 \u0646\u0633\u0627\u0626\u064A",
        en: "Women's Salon",
        emoji: "\uD83D\uDC87\u200D\u2640\uFE0F"
    },
    {
        id: 'Sports',
        ar: "\u0631\u064A\u0627\u0636\u0629",
        en: 'Sports',
        emoji: "\u26BD"
    },
    {
        id: 'Supermarket',
        ar: "\u0633\u0648\u0628\u0631\u0645\u0627\u0631\u0643\u062A",
        en: 'Supermarket',
        emoji: "\uD83D\uDED2"
    },
    {
        id: 'Butcher',
        ar: "\u0645\u0644\u062D\u0645\u0629",
        en: 'Butcher',
        emoji: "\uD83E\uDD69"
    },
    {
        id: 'Sanitary',
        ar: "\u0623\u062F\u0648\u0627\u062A \u0635\u062D\u064A\u0629",
        en: 'Sanitary',
        emoji: "\uD83D\uDEBF"
    },
    {
        id: 'Cafe',
        ar: "\u0645\u0642\u0627\u0647\u064A",
        en: 'Cafes',
        emoji: "\u2615"
    },
    {
        id: 'Home',
        ar: "\u0645\u0646\u0632\u0644 \u0648\u062F\u064A\u0643\u0648\u0631",
        en: 'Home',
        emoji: "\uD83C\uDFE0"
    },
    {
        id: 'Hotels',
        ar: "\u0641\u0646\u0627\u062F\u0642",
        en: 'Hotels',
        emoji: "\uD83C\uDFE8"
    },
    {
        id: 'CarRentals',
        ar: "\u062A\u0623\u062C\u064A\u0631 \u0633\u064A\u0627\u0631\u0627\u062A",
        en: 'Car Rentals',
        emoji: "\uD83D\uDE97"
    },
    {
        id: 'Laundry',
        ar: "\u0645\u063A\u0633\u0644\u0629 \u0645\u0644\u0627\u0628\u0633",
        en: 'Laundromats',
        emoji: "\uD83E\uDDFA"
    },
    {
        id: 'MensTailor',
        ar: "\u062E\u064A\u0627\u0637\u0629 \u0631\u062C\u0627\u0644\u064A\u0629",
        en: "Men's Tailor",
        emoji: "\uD83E\uDDF5"
    },
    {
        id: 'WomensTailor',
        ar: "\u0645\u0634\u063A\u0644 \u0646\u0633\u0627\u0626\u064A",
        en: "Women's Tailor",
        emoji: "\uD83E\uDEA1"
    },
    {
        id: 'CarWash',
        ar: "\u0645\u063A\u0633\u0644\u0629 \u0633\u064A\u0627\u0631\u0627\u062A",
        en: 'Car Wash',
        emoji: "\uD83E\uDDFD"
    },
    {
        id: 'CarWorkshop',
        ar: "\u0645\u0633\u062A\u0644\u0632\u0645\u0627\u062A \u0648\u0648\u0631\u0634 \u0627\u0644\u0633\u064A\u0627\u0631\u0627\u062A",
        en: 'Car Parts & Workshops',
        emoji: "\uD83D\uDD27"
    },
    {
        id: 'Amusements',
        ar: "\u0645\u0644\u0627\u0647\u064A \u0623\u0644\u0639\u0627\u0628",
        en: 'Amusements',
        emoji: "\uD83C\uDFA1"
    },
    {
        id: 'Gym',
        ar: "\u0646\u0627\u062F\u064A \u0631\u064A\u0627\u0636\u064A",
        en: 'Gym',
        emoji: "\uD83C\uDFCB\uFE0F"
    },
    {
        id: 'Library',
        ar: "\u0645\u0643\u062A\u0628\u0629",
        en: 'Library',
        emoji: "\uD83D\uDCDA"
    },
    {
        id: 'Nursery',
        ar: "\u0645\u0634\u0627\u062A\u0644 \u0632\u0631\u0627\u0639\u064A\u0629",
        en: 'Nurseries',
        emoji: "\uD83C\uDF31"
    },
    {
        id: 'Pharmacy',
        ar: "\u0635\u064A\u062F\u0644\u064A\u0629",
        en: 'Pharmacy',
        emoji: "\uD83D\uDC8A"
    },
    {
        id: 'Clinics',
        ar: "\u0639\u064A\u0627\u062F\u0627\u062A",
        en: 'Clinics',
        emoji: "\uD83E\uDE7A"
    },
    {
        id: 'Online',
        ar: "\u0623\u0648\u0646\u0644\u0627\u064A\u0646",
        en: 'Online',
        emoji: "\uD83C\uDF10"
    },
    {
        id: 'Other',
        ar: "\u0623\u062E\u0631\u0649",
        en: 'Other',
        emoji: "\u2728"
    }
];
const $9ec848631800ed29$export$8e2993016c604bf0 = [
    {
        id: 'all',
        ar: "\u0627\u0644\u0643\u0644",
        en: 'All',
        emoji: "\uD83D\uDC65"
    },
    {
        id: 'men',
        ar: "\u0631\u062C\u0627\u0644",
        en: 'Men',
        emoji: "\uD83D\uDC68"
    },
    {
        id: 'women',
        ar: "\u0646\u0633\u0627\u0621",
        en: 'Women',
        emoji: "\uD83D\uDC69"
    },
    {
        id: 'kids',
        ar: "\u0623\u0637\u0641\u0627\u0644",
        en: 'Kids',
        emoji: "\uD83D\uDC76"
    },
    {
        id: 'other',
        ar: "\u0623\u062E\u0631\u0649",
        en: 'Other',
        emoji: "\u2728"
    }
];
const $9ec848631800ed29$export$65ed38a8a8f60c04 = (lat1, lon1, lat2, lon2)=>{
    const p = 0.017453292519943295; // Math.PI / 180
    const c = Math.cos;
    const a = 0.5 - c((lat2 - lat1) * p) / 2 + c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p)) / 2;
    return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
};
const $9ec848631800ed29$export$a3e368fe59f79872 = (lat, lng)=>{
    let nearest = undefined;
    let minDistance = Infinity;
    $9ec848631800ed29$export$f03f7c19d8f50e16.forEach((city)=>{
        // We look for a location in this city to get a coordinate baseline
        // Since CITIES don't have coords directly, we find a representative location
        const loc = $9ec848631800ed29$export$9396c9157495b4d.find((l)=>l.cityId === city.id);
        if (loc) {
            const dist = $9ec848631800ed29$export$65ed38a8a8f60c04(lat, lng, loc.lat, loc.lng);
            if (dist < minDistance) {
                minDistance = dist;
                nearest = city;
            }
        }
    });
    return nearest;
};
const $9ec848631800ed29$export$28ddc432f7315b6a = (lat, lng)=>{
    let nearest = undefined;
    let minDistance = Infinity;
    $9ec848631800ed29$export$9396c9157495b4d.forEach((loc)=>{
        const dist = $9ec848631800ed29$export$65ed38a8a8f60c04(lat, lng, loc.lat, loc.lng);
        if (dist < minDistance) {
            minDistance = dist;
            nearest = loc;
        }
    });
    // If closer than 500m, consider it inside that location
    return minDistance < 0.5 ? nearest : undefined;
};
const $9ec848631800ed29$export$36b79d2b85570e14 = [
    {
        id: 'riyadh',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0631\u064A\u0627\u0636",
        nameEn: "Riyadh Region",
        lat: 24.7136,
        lng: 46.6753
    },
    {
        id: 'makkah',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0645\u0643\u0629 \u0627\u0644\u0645\u0643\u0631\u0645\u0629",
        nameEn: "Makkah Region",
        lat: 21.3891,
        lng: 39.8579
    },
    {
        id: 'madinah',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0627\u0644\u0645\u0646\u0648\u0631\u0629",
        nameEn: "Madinah Region",
        lat: 24.4672,
        lng: 39.6061
    },
    {
        id: 'qassim',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0642\u0635\u064A\u0645",
        nameEn: "Qassim Region",
        lat: 26.3260,
        lng: 43.9750
    },
    {
        id: 'eastern',
        name: "\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0634\u0631\u0642\u064A\u0629",
        nameEn: "Eastern Province",
        lat: 26.4207,
        lng: 50.0888
    },
    {
        id: 'asir',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0639\u0633\u064A\u0631",
        nameEn: "Asir Region",
        lat: 18.2171,
        lng: 42.5053
    },
    {
        id: 'tabuk',
        name: "\u0645\u0646\u0637\u0642\u0629 \u062A\u0628\u0648\u0643",
        nameEn: "Tabuk Region",
        lat: 28.3833,
        lng: 36.5667
    },
    {
        id: 'hail',
        name: "\u0645\u0646\u0637\u0642\u0629 \u062D\u0627\u0626\u0644",
        nameEn: "Hail Region",
        lat: 27.5167,
        lng: 41.6833
    },
    {
        id: 'northern',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u062D\u062F\u0648\u062F \u0627\u0644\u0634\u0645\u0627\u0644\u064A\u0629",
        nameEn: "Northern Borders Region",
        lat: 30.9667,
        lng: 41.0167
    },
    {
        id: 'jazan',
        name: "\u0645\u0646\u0637\u0642\u0629 \u062C\u0627\u0632\u0627\u0646",
        nameEn: "Jazan Region",
        lat: 16.8892,
        lng: 42.5511
    },
    {
        id: 'najran',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0646\u062C\u0631\u0627\u0646",
        nameEn: "Najran Region",
        lat: 17.4917,
        lng: 44.1322
    },
    {
        id: 'baha',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0628\u0627\u062D\u0629",
        nameEn: "Al Bahah Region",
        lat: 20.0125,
        lng: 41.4653
    },
    {
        id: 'jouf',
        name: "\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u062C\u0648\u0641",
        nameEn: "Al Jawf Region",
        lat: 29.9667,
        lng: 40.2000
    }
];
const $9ec848631800ed29$export$f03f7c19d8f50e16 = [
    {
        id: 'bukayriah',
        name: "\u0627\u0644\u0628\u0643\u064A\u0631\u064A\u0629",
        nameEn: "Bukayriah",
        regionId: 'qassim',
        lat: 26.1437,
        lng: 43.6593
    },
    {
        id: 'badaiah',
        name: "\u0627\u0644\u0628\u062F\u0627\u0626\u0639",
        nameEn: "Badaya",
        regionId: 'qassim',
        lat: 25.9750,
        lng: 43.6833
    },
    {
        id: 'muznib',
        name: "\u0627\u0644\u0645\u0630\u0646\u0628",
        nameEn: "Mithnab",
        regionId: 'qassim',
        lat: 25.8667,
        lng: 44.2167
    },
    {
        id: 'riyadh_city',
        name: "\u0627\u0644\u0631\u064A\u0627\u0636",
        nameEn: "Riyadh",
        regionId: 'riyadh',
        lat: 24.7136,
        lng: 46.6753
    },
    {
        id: 'kharj',
        name: "\u0627\u0644\u062E\u0631\u062C",
        nameEn: "Al Kharj",
        regionId: 'riyadh',
        lat: 24.1500,
        lng: 47.3000
    },
    {
        id: 'majmaah',
        name: "\u0627\u0644\u0645\u062C\u0645\u0639\u0629",
        nameEn: "Al Majmaah",
        regionId: 'riyadh',
        lat: 25.9000,
        lng: 45.3333
    },
    {
        id: 'dawadmi',
        name: "\u0627\u0644\u062F\u0648\u0627\u062F\u0645\u064A",
        nameEn: "Dawadmi",
        regionId: 'riyadh',
        lat: 24.5075,
        lng: 44.3919
    },
    {
        id: 'wadi_ad_dawasir',
        name: "\u0648\u0627\u062F\u064A \u0627\u0644\u062F\u0648\u0627\u0633\u0631",
        nameEn: "Wadi ad-Dawasir",
        regionId: 'riyadh',
        lat: 20.4500,
        lng: 44.7500
    },
    {
        id: 'quwayiyah',
        name: "\u0627\u0644\u0642\u0648\u064A\u0639\u064A\u0629",
        nameEn: "Quwayiyah",
        regionId: 'riyadh',
        lat: 24.0500,
        lng: 45.2667
    },
    {
        id: 'zulfi',
        name: "\u0627\u0644\u0632\u0644\u0641\u064A",
        nameEn: "Az Zulfi",
        regionId: 'riyadh',
        lat: 26.3000,
        lng: 44.8167
    },
    {
        id: 'shakra',
        name: "\u0634\u0642\u0631\u0627\u0621",
        nameEn: "Shaqra",
        regionId: 'riyadh',
        lat: 25.2422,
        lng: 45.2494
    },
    {
        id: 'diriyah',
        name: "\u0627\u0644\u062F\u0631\u0639\u064A\u0629",
        nameEn: "Diriyah",
        regionId: 'riyadh',
        lat: 24.7500,
        lng: 46.5333
    },
    // مكة المكرمة
    {
        id: 'makkah_city',
        name: "\u0645\u0643\u0629 \u0627\u0644\u0645\u0643\u0631\u0645\u0629",
        nameEn: "Makkah",
        regionId: 'makkah',
        lat: 21.3891,
        lng: 39.8579
    },
    {
        id: 'jeddah',
        name: "\u062C\u062F\u0629",
        nameEn: "Jeddah",
        regionId: 'makkah',
        lat: 21.4858,
        lng: 39.1867
    },
    {
        id: 'taif',
        name: "\u0627\u0644\u0637\u0627\u0626\u0641",
        nameEn: "Taif",
        regionId: 'makkah',
        lat: 21.2833,
        lng: 40.4167
    },
    {
        id: 'qunfudhah',
        name: "\u0627\u0644\u0642\u0646\u0641\u0630\u0629",
        nameEn: "Al Qunfudhah",
        regionId: 'makkah',
        lat: 19.1264,
        lng: 41.0789
    },
    {
        id: 'rabigh',
        name: "\u0631\u0627\u0628\u063A",
        nameEn: "Rabigh",
        regionId: 'makkah',
        lat: 22.8000,
        lng: 39.0333
    },
    {
        id: 'laith',
        name: "\u0627\u0644\u0644\u064A\u062B",
        nameEn: "Al Lith",
        regionId: 'makkah',
        lat: 20.1500,
        lng: 40.2667
    },
    {
        id: 'bahrah',
        name: "\u0628\u062D\u0631\u0629",
        nameEn: "Bahrah",
        regionId: 'makkah',
        lat: 21.4167,
        lng: 39.4667
    },
    {
        id: 'khulays',
        name: "\u062E\u0644\u064A\u0635",
        nameEn: "Khulays",
        regionId: 'makkah',
        lat: 22.1833,
        lng: 39.3167
    },
    {
        id: 'ranyah',
        name: "\u0631\u0646\u064A\u0629",
        nameEn: "Ranyah",
        regionId: 'makkah',
        lat: 21.2500,
        lng: 42.8500
    },
    {
        id: 'turubah',
        name: "\u062A\u0631\u0628\u0629",
        nameEn: "Turabah",
        regionId: 'makkah',
        lat: 21.2167,
        lng: 41.6333
    },
    // المدينة المنورة
    {
        id: 'madinah_city',
        name: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0627\u0644\u0645\u0646\u0648\u0631\u0629",
        nameEn: "Madinah",
        regionId: 'madinah',
        lat: 24.4672,
        lng: 39.6061
    },
    {
        id: 'yanbu',
        name: "\u064A\u0646\u0628\u0639",
        nameEn: "Yanbu",
        regionId: 'madinah',
        lat: 24.0891,
        lng: 38.0637
    },
    {
        id: 'ula',
        name: "\u0627\u0644\u0639\u0644\u0627",
        nameEn: "AlUla",
        regionId: 'madinah',
        lat: 26.6167,
        lng: 37.9167
    },
    {
        id: 'mahad_adh_dhahab',
        name: "\u0645\u0647\u062F \u0627\u0644\u0630\u0647\u0628",
        nameEn: "Mahd adh Dhahab",
        regionId: 'madinah',
        lat: 23.4833,
        lng: 40.8667
    },
    {
        id: 'badr',
        name: "\u0628\u062F\u0631",
        nameEn: "Badr",
        regionId: 'madinah',
        lat: 23.7833,
        lng: 38.8333
    },
    {
        id: 'khaybar',
        name: "\u062E\u064A\u0628\u0631",
        nameEn: "Khaybar",
        regionId: 'madinah',
        lat: 25.6833,
        lng: 39.2833
    },
    {
        id: 'hinakiyah',
        name: "\u0627\u0644\u062D\u0646\u0627\u0643\u064A\u0629",
        nameEn: "Al Hinakiyah",
        regionId: 'madinah',
        lat: 24.8500,
        lng: 40.5000
    },
    // القصيم
    {
        id: 'buraidah',
        name: "\u0628\u0631\u064A\u062F\u0629",
        nameEn: "Buraidah",
        regionId: 'qassim',
        lat: 26.3260,
        lng: 43.9750
    },
    {
        id: 'unaizah',
        name: "\u0639\u0646\u064A\u0632\u0629",
        nameEn: "Unaizah",
        regionId: 'qassim',
        lat: 26.0842,
        lng: 43.9936
    },
    {
        id: 'rass',
        name: "\u0627\u0644\u0631\u0633",
        nameEn: "Ar Rass",
        regionId: 'qassim',
        lat: 25.8692,
        lng: 43.4975
    },
    {
        id: 'mithnab',
        name: "\u0627\u0644\u0645\u0630\u0646\u0628",
        nameEn: "Al Midhnab",
        regionId: 'qassim',
        lat: 25.8667,
        lng: 44.2167
    },
    {
        id: 'bukayriyah_q',
        name: "\u0627\u0644\u0628\u0643\u064A\u0631\u064A\u0629",
        nameEn: "Al Bukayriyah",
        regionId: 'qassim',
        lat: 26.1500,
        lng: 43.6667
    },
    {
        id: 'badaya',
        name: "\u0627\u0644\u0628\u062F\u0627\u0626\u0639",
        nameEn: "Al Badaya",
        regionId: 'qassim',
        lat: 25.9667,
        lng: 43.6833
    },
    {
        id: 'riyadh_al_khabra',
        name: "\u0631\u064A\u0627\u0636 \u0627\u0644\u062E\u0628\u0631\u0627\u0621",
        nameEn: "Riyadh Al Khabra",
        regionId: 'qassim',
        lat: 26.0667,
        lng: 43.5833
    },
    // المنطقة الشرقية
    {
        id: 'dammam',
        name: "\u0627\u0644\u062F\u0645\u0627\u0645",
        nameEn: "Dammam",
        regionId: 'eastern',
        lat: 26.4207,
        lng: 50.0888
    },
    {
        id: 'khobar',
        name: "\u0627\u0644\u062E\u0628\u0631",
        nameEn: "Khobar",
        regionId: 'eastern',
        lat: 26.2172,
        lng: 50.1971
    },
    {
        id: 'dhahran',
        name: "\u0627\u0644\u0638\u0647\u0631\u0627\u0646",
        nameEn: "Dhahran",
        regionId: 'eastern',
        lat: 26.2361,
        lng: 50.1211
    },
    {
        id: 'jubail',
        name: "\u0627\u0644\u062C\u0628\u064A\u0644",
        nameEn: "Jubail",
        regionId: 'eastern',
        lat: 27.0117,
        lng: 49.6583
    },
    {
        id: 'hafuf',
        name: "\u0627\u0644\u0647\u0641\u0648\u0641 (\u0627\u0644\u0623\u062D\u0633\u0627\u0621)",
        nameEn: "Hofuf (Al-Ahsa)",
        regionId: 'eastern',
        lat: 25.3787,
        lng: 49.5863
    },
    {
        id: 'qatif',
        name: "\u0627\u0644\u0642\u0637\u064A\u0641",
        nameEn: "Qatif",
        regionId: 'eastern',
        lat: 26.5167,
        lng: 50.0000
    },
    {
        id: 'hafar_al_batin',
        name: "\u062D\u0641\u0631 \u0627\u0644\u0628\u0627\u0637\u0646",
        nameEn: "Hafar Al-Batin",
        regionId: 'eastern',
        lat: 28.4333,
        lng: 45.9667
    },
    {
        id: 'khafji',
        name: "\u0627\u0644\u062E\u0641\u062C\u064A",
        nameEn: "Khafji",
        regionId: 'eastern',
        lat: 28.4342,
        lng: 48.4908
    },
    {
        id: 'ras_tanura',
        name: "\u0631\u0623\u0633 \u062A\u0646\u0648\u0631\u0629",
        nameEn: "Ras Tanura",
        regionId: 'eastern',
        lat: 26.6500,
        lng: 50.1167
    },
    {
        id: 'nairyah',
        name: "\u0627\u0644\u0646\u0639\u064A\u0631\u064A\u0629",
        nameEn: "Nairyah",
        regionId: 'eastern',
        lat: 27.5000,
        lng: 48.4833
    },
    // منطقة عسير
    {
        id: 'abha',
        name: "\u0623\u0628\u0647\u0627",
        nameEn: "Abha",
        regionId: 'asir',
        lat: 18.2171,
        lng: 42.5053
    },
    {
        id: 'khamis_mushait',
        name: "\u062E\u0645\u064A\u0633 \u0645\u0634\u064A\u0637",
        nameEn: "Khamis Mushait",
        regionId: 'asir',
        lat: 18.3000,
        lng: 42.7333
    },
    {
        id: 'bishah',
        name: "\u0628\u064A\u0634\u0629",
        nameEn: "Bishah",
        regionId: 'asir',
        lat: 19.9833,
        lng: 42.6167
    },
    {
        id: 'namas',
        name: "\u0627\u0644\u0646\u0645\u0627\u0635",
        nameEn: "An-Namas",
        regionId: 'asir',
        lat: 19.1167,
        lng: 42.1167
    },
    {
        id: 'mahail_asir',
        name: "\u0645\u062D\u0627\u064A\u0644 \u0639\u0633\u064A\u0631",
        nameEn: "Mahayil Asir",
        regionId: 'asir',
        lat: 18.5500,
        lng: 41.9167
    },
    {
        id: 'bariq',
        name: "\u0628\u0627\u0631\u0642",
        nameEn: "Bariq",
        regionId: 'asir',
        lat: 18.9167,
        lng: 41.9333
    },
    {
        id: 'ahad_rufaydah',
        name: "\u0623\u062D\u062F \u0631\u0641\u064A\u062F\u0629",
        nameEn: "Ahad Rafidah",
        regionId: 'asir',
        lat: 18.1500,
        lng: 42.8500
    },
    // منطقة تبوك
    {
        id: 'tabuk_city',
        name: "\u062A\u0628\u0648\u0643",
        nameEn: "Tabuk",
        regionId: 'tabuk',
        lat: 28.3833,
        lng: 36.5667
    },
    {
        id: 'wajh',
        name: "\u0627\u0644\u0648\u062C\u0647",
        nameEn: "Al-Wajh",
        regionId: 'tabuk',
        lat: 26.2333,
        lng: 36.4667
    },
    {
        id: 'duba',
        name: "\u0636\u0628\u0627\u0621",
        nameEn: "Duba",
        regionId: 'tabuk',
        lat: 27.3500,
        lng: 35.6833
    },
    {
        id: 'tiyama',
        name: "\u062A\u064A\u0645\u0627\u0621",
        nameEn: "Tayma",
        regionId: 'tabuk',
        lat: 27.6333,
        lng: 38.5500
    },
    {
        id: 'umluj',
        name: "\u0623\u0645\u0644\u062C",
        nameEn: "Umluj",
        regionId: 'tabuk',
        lat: 25.0333,
        lng: 37.2667
    },
    {
        id: 'haql',
        name: "\u062D\u0642\u0644",
        nameEn: "Haql",
        regionId: 'tabuk',
        lat: 29.2833,
        lng: 34.9333
    },
    // منطقة حائل
    {
        id: 'hail_city',
        name: "\u062D\u0627\u0626\u0644",
        nameEn: "Hail",
        regionId: 'hail',
        lat: 27.5167,
        lng: 41.6833
    },
    {
        id: 'baqaa',
        name: "\u0628\u0642\u0639\u0627\u0621",
        nameEn: "Baqaa",
        regionId: 'hail',
        lat: 27.9333,
        lng: 42.3333
    },
    {
        id: 'shnan',
        name: "\u0627\u0644\u0634\u0646\u0627\u0646",
        nameEn: "Ash-Shanan",
        regionId: 'hail',
        lat: 27.1667,
        lng: 42.4333
    },
    {
        id: 'ghazalah',
        name: "\u0627\u0644\u063A\u0632\u0627\u0644\u0629",
        nameEn: "Al-Ghazalah",
        regionId: 'hail',
        lat: 26.4333,
        lng: 41.2333
    },
    // منطقة الحدود الشمالية
    {
        id: 'arar',
        name: "\u0639\u0631\u0639\u0631",
        nameEn: "Arar",
        regionId: 'northern',
        lat: 30.9667,
        lng: 41.0167
    },
    {
        id: 'rafha',
        name: "\u0631\u0641\u062D\u0627\u0621",
        nameEn: "Rafha",
        regionId: 'northern',
        lat: 29.6167,
        lng: 43.5000
    },
    {
        id: 'turayf',
        name: "\u0637\u0631\u064A\u0641",
        nameEn: "Turaif",
        regionId: 'northern',
        lat: 31.6833,
        lng: 38.6500
    },
    {
        id: 'uwayqilah',
        name: "\u0627\u0644\u0639\u0648\u064A\u0642\u064A\u0644\u0629",
        nameEn: "Al-Uwayqilah",
        regionId: 'northern',
        lat: 30.3167,
        lng: 42.1833
    },
    // منطقة جازان
    {
        id: 'jazan_city',
        name: "\u062C\u0627\u0632\u0627\u0646",
        nameEn: "Jazan",
        regionId: 'jazan',
        lat: 16.8892,
        lng: 42.5511
    },
    {
        id: 'sabya',
        name: "\u0635\u0628\u064A\u0627",
        nameEn: "Sabya",
        regionId: 'jazan',
        lat: 17.1500,
        lng: 42.6167
    },
    {
        id: 'abu_arish',
        name: "\u0623\u0628\u0648 \u0639\u0631\u064A\u0634",
        nameEn: "Abu Arish",
        regionId: 'jazan',
        lat: 16.9667,
        lng: 42.8333
    },
    {
        id: 'samitah',
        name: "\u0635\u0627\u0645\u0637\u0629",
        nameEn: "Samtah",
        regionId: 'jazan',
        lat: 16.5833,
        lng: 42.9333
    },
    {
        id: 'adrabi',
        name: "\u0627\u0644\u062F\u0631\u0628",
        nameEn: "Ad-Darb",
        regionId: 'jazan',
        lat: 17.7167,
        lng: 42.2500
    },
    {
        id: 'biysh',
        name: "\u0628\u064A\u0634",
        nameEn: "Baish",
        regionId: 'jazan',
        lat: 17.3833,
        lng: 42.5333
    },
    // منطقة نجران
    {
        id: 'najran_city',
        name: "\u0646\u062C\u0631\u0627\u0646",
        nameEn: "Najran",
        regionId: 'najran',
        lat: 17.4917,
        lng: 44.1322
    },
    {
        id: 'sharurah',
        name: "\u0634\u0631\u0648\u0631\u0629",
        nameEn: "Sharurah",
        regionId: 'najran',
        lat: 17.4833,
        lng: 47.1167
    },
    {
        id: 'hubuna',
        name: "\u062D\u0628\u0648\u0646\u0627",
        nameEn: "Habuna",
        regionId: 'najran',
        lat: 17.8500,
        lng: 44.3667
    },
    // منطقة الباحة
    {
        id: 'baha_city',
        name: "\u0627\u0644\u0628\u0627\u062D\u0629",
        nameEn: "Al-Bahah",
        regionId: 'baha',
        lat: 20.0125,
        lng: 41.4653
    },
    {
        id: 'baljurashi',
        name: "\u0628\u0644\u062C\u0631\u0634\u064A",
        nameEn: "Baljurashi",
        regionId: 'baha',
        lat: 19.8500,
        lng: 41.5667
    },
    {
        id: 'mandaq',
        name: "\u0627\u0644\u0645\u0646\u062F\u0642",
        nameEn: "Al-Mandaq",
        regionId: 'baha',
        lat: 20.1500,
        lng: 41.2833
    },
    {
        id: 'mikhwah',
        name: "\u0627\u0644\u0645\u062E\u0648\u0627\u0629",
        nameEn: "Al-Makhwah",
        regionId: 'baha',
        lat: 19.7833,
        lng: 41.4333
    },
    // منطقة الجوف
    {
        id: 'sakaka',
        name: "\u0633\u0643\u0627\u0643\u0627",
        nameEn: "Sakaka",
        regionId: 'jouf',
        lat: 29.9667,
        lng: 40.2000
    },
    {
        id: 'qurayyat',
        name: "\u0627\u0644\u0642\u0631\u064A\u0627\u062A",
        nameEn: "Qurayyat",
        regionId: 'jouf',
        lat: 31.3333,
        lng: 37.3333
    },
    {
        id: 'dumat_jandal',
        name: "\u062F\u0648\u0645\u0629 \u0627\u0644\u062C\u0646\u062F\u0644",
        nameEn: "Dumat Al-Jandal",
        regionId: 'jouf',
        lat: 29.8167,
        lng: 39.8667
    },
    {
        id: 'tabarjal',
        name: "\u0637\u0628\u0631\u062C\u0644",
        nameEn: "Tabarjal",
        regionId: 'jouf',
        lat: 30.5000,
        lng: 38.3500
    }
];
const $9ec848631800ed29$export$9396c9157495b4d = [
    // ========== الرياض ==========
    {
        id: 'nakheel_riyadh',
        name: "\u0627\u0644\u0646\u062E\u064A\u0644 \u0645\u0648\u0644",
        nameEn: "Nakheel Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7669,
        lng: 46.6806
    },
    {
        id: 'riyadh_park',
        name: "\u0627\u0644\u0631\u064A\u0627\u0636 \u0628\u0627\u0631\u0643",
        nameEn: "Riyadh Park",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7578,
        lng: 46.6300
    },
    {
        id: 'riyadh_gallery',
        name: "\u0627\u0644\u0631\u064A\u0627\u0636 \u062C\u0627\u0644\u064A\u0631\u064A",
        nameEn: "Riyadh Gallery",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.6907,
        lng: 46.6653
    },
    {
        id: 'panorama_riyadh',
        name: "\u0628\u0627\u0646\u0648\u0631\u0627\u0645\u0627 \u0645\u0648\u0644",
        nameEn: "Panorama Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7003,
        lng: 46.6842
    },
    {
        id: 'hayat_mall',
        name: "\u062D\u064A\u0627\u0629 \u0645\u0648\u0644",
        nameEn: "Hayat Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7631,
        lng: 46.7384
    },
    {
        id: 'granada_riyadh',
        name: "\u063A\u0631\u0646\u0627\u0637\u0629 \u0645\u0648\u0644",
        nameEn: "Granada Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7724,
        lng: 46.7262
    },
    {
        id: 'kingdom_mall',
        name: "\u0645\u0631\u0643\u0632 \u0627\u0644\u0645\u0645\u0644\u0643\u0629",
        nameEn: "Kingdom Centre",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7118,
        lng: 46.6744
    },
    {
        id: 'avenues_riyadh',
        name: "\u0630\u0627 \u0623\u0641\u0646\u064A\u0648\u0632",
        nameEn: "The Avenues",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7683,
        lng: 46.6933
    },
    {
        id: 'via_riyadh',
        name: "\u0641\u064A\u0627\u0621 \u0627\u0644\u0631\u064A\u0627\u0636",
        nameEn: "Via Riyadh",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7350,
        lng: 46.6570
    },
    {
        id: 'othaim_riyadh',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644",
        nameEn: "Othaim Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7389,
        lng: 46.7529
    },
    {
        id: 'tala_mall',
        name: "\u062A\u0627\u0644\u0627 \u0645\u0648\u0644",
        nameEn: "Tala Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7522,
        lng: 46.6855
    },
    {
        id: 'cena_mall',
        name: "\u0633\u0646\u062A\u0631\u064A\u0627 \u0645\u0648\u0644",
        nameEn: "Centria Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.6946,
        lng: 46.6814
    },
    {
        id: 'qasr_mall',
        name: "\u0627\u0644\u0642\u0635\u0631 \u0645\u0648\u0644",
        nameEn: "Al Qasr Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.5971,
        lng: 46.6811
    },
    {
        id: 'hamra_mall',
        name: "\u0627\u0644\u062D\u0645\u0631\u0627\u0621 \u0645\u0648\u0644",
        nameEn: "Al Hamra Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7766,
        lng: 46.7588
    },
    {
        id: 'marina_mall',
        name: "\u0645\u0627\u0631\u064A\u0646\u0627 \u0645\u0648\u0644",
        nameEn: "Marina Mall",
        type: 'mall',
        cityId: 'riyadh_city',
        lat: 24.7430,
        lng: 46.6666
    },
    {
        id: 'taibah_souq',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0637\u064A\u0628\u0629",
        nameEn: "Taibah Souq",
        type: 'market',
        cityId: 'riyadh_city',
        lat: 24.7400,
        lng: 46.6800
    },
    {
        id: 'batha_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0628\u0637\u062D\u0627\u0621",
        nameEn: "Al Batha Souq",
        type: 'market',
        cityId: 'riyadh_city',
        lat: 24.6360,
        lng: 46.7170
    },
    {
        id: 'dira_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062F\u064A\u0631\u0629",
        nameEn: "Al Dirah Souq",
        type: 'market',
        cityId: 'riyadh_city',
        lat: 24.6352,
        lng: 46.7113
    },
    {
        id: 'ovais_souq',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0627\u0644\u0639\u0648\u064A\u0633",
        nameEn: "Al Owais Souq",
        type: 'market',
        cityId: 'riyadh_city',
        lat: 24.7450,
        lng: 46.6850
    },
    {
        id: 'kharj_mall',
        name: "\u0627\u0644\u062E\u0631\u062C \u0645\u0648\u0644",
        nameEn: "Al Kharj Mall",
        type: 'mall',
        cityId: 'kharj',
        lat: 24.1537,
        lng: 47.3340
    },
    {
        id: 'jawhara_mall',
        name: "\u0627\u0644\u062C\u0648\u0647\u0631\u0629 \u0645\u0648\u0644",
        nameEn: "Al Jawharah Mall",
        type: 'mall',
        cityId: 'kharj',
        lat: 24.1480,
        lng: 47.3120
    },
    // ========== مكة المكرمة وجدة ==========
    {
        id: 'red_sea_mall',
        name: "\u0631\u062F \u0633\u064A \u0645\u0648\u0644",
        nameEn: "Red Sea Mall",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.6274,
        lng: 39.1185
    },
    {
        id: 'mall_of_arabia',
        name: "\u0645\u0648\u0644 \u0627\u0644\u0639\u0631\u0628",
        nameEn: "Mall of Arabia",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.5834,
        lng: 39.1461
    },
    {
        id: 'aziz_mall',
        name: "\u0627\u0644\u0639\u0632\u064A\u0632 \u0645\u0648\u0644",
        nameEn: "Al Aziz Mall",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.5422,
        lng: 39.1757
    },
    {
        id: 'stars_avenue',
        name: "\u0633\u062A\u0627\u0631\u0632 \u0623\u0641\u0646\u064A\u0648",
        nameEn: "Stars Avenue",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.5894,
        lng: 39.1540
    },
    {
        id: 'heraa_mall',
        name: "\u0647\u064A\u0641\u0627\u0621 \u0645\u0648\u0644",
        nameEn: "Haifa Mall",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.5580,
        lng: 39.1735
    },
    {
        id: 'andalus_jeddah',
        name: "\u0627\u0644\u0623\u0646\u062F\u0644\u0633 \u0645\u0648\u0644",
        nameEn: "Andalus Mall",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.5736,
        lng: 39.1513
    },
    {
        id: 'salam_mall_jeddah',
        name: "\u0627\u0644\u0633\u0644\u0627\u0645 \u0645\u0648\u0644",
        nameEn: "Al Salam Mall",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.5033,
        lng: 39.2311
    },
    {
        id: 'roshen_mall',
        name: "\u0631\u0648\u0634\u0627\u0646 \u0645\u0648\u0644",
        nameEn: "Roshan Mall",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.6455,
        lng: 39.1080
    },
    {
        id: 'balad_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0628\u0644\u062F",
        nameEn: "Al Balad Souq",
        type: 'market',
        cityId: 'jeddah',
        lat: 21.4844,
        lng: 39.1862
    },
    {
        id: 'shatea_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0634\u0627\u0637\u0626",
        nameEn: "Al Shati Souq",
        type: 'market',
        cityId: 'jeddah',
        lat: 21.5600,
        lng: 39.1400
    },
    {
        id: 'bawadi_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0628\u0648\u0627\u062F\u064A",
        nameEn: "Al Bawadi Souq",
        type: 'market',
        cityId: 'jeddah',
        lat: 21.5977,
        lng: 39.1788
    },
    {
        id: 'abraj_bait',
        name: "\u0623\u0628\u0631\u0627\u062C \u0627\u0644\u0628\u064A\u062A",
        nameEn: "Abraj Al Bait",
        type: 'mall',
        cityId: 'makkah_city',
        lat: 21.4189,
        lng: 39.8263
    },
    {
        id: 'makkah_mall',
        name: "\u0645\u0643\u0629 \u0645\u0648\u0644",
        nameEn: "Makkah Mall",
        type: 'mall',
        cityId: 'makkah_city',
        lat: 21.3948,
        lng: 39.8339
    },
    {
        id: 'aziziyah_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0639\u0632\u064A\u0632\u064A\u0629",
        nameEn: "Al Aziziyah Souq",
        type: 'market',
        cityId: 'makkah_city',
        lat: 21.3950,
        lng: 39.8450
    },
    {
        id: 'diyafa_mall',
        name: "\u0645\u0648\u0644 \u0627\u0644\u0636\u064A\u0627\u0641\u0629",
        nameEn: "Al Diyafa Mall",
        type: 'mall',
        cityId: 'makkah_city',
        lat: 21.4333,
        lng: 39.8000
    },
    {
        id: 'hijaz_mall',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062D\u062C\u0627\u0632",
        nameEn: "Al Hijaz Souq",
        type: 'mall',
        cityId: 'makkah_city',
        lat: 21.4350,
        lng: 39.7900
    },
    {
        id: 'taif_heart',
        name: "\u0642\u0644\u0628 \u0627\u0644\u0637\u0627\u0626\u0641",
        nameEn: "Heart of Taif",
        type: 'mall',
        cityId: 'taif',
        lat: 21.2727,
        lng: 40.4163
    },
    {
        id: 'jouri_mall',
        name: "\u062C\u0648\u0631\u064A \u0645\u0648\u0644",
        nameEn: "Jouri Mall",
        type: 'mall',
        cityId: 'taif',
        lat: 21.2634,
        lng: 40.3829
    },
    // ========== المدينة المنورة ==========
    {
        id: 'noor_mall',
        name: "\u0627\u0644\u0646\u0648\u0631 \u0645\u0648\u0644",
        nameEn: "Al Noor Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.4671,
        lng: 39.6024
    },
    {
        id: 'rashid_mall_madinah',
        name: "\u0627\u0644\u0631\u0627\u0634\u062F \u0645\u064A\u063A\u0627 \u0645\u0648\u0644",
        nameEn: "Al Rashid Mega Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.4685,
        lng: 39.6146
    },
    {
        id: 'al_alyat_mall',
        name: "\u0627\u0644\u0639\u0627\u0644\u064A\u0629 \u0645\u0648\u0644",
        nameEn: "Al Aliyah Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.4444,
        lng: 39.6111
    },
    {
        id: 'manar_mall',
        name: "\u0627\u0644\u0645\u0646\u0627\u0631 \u0645\u0648\u0644",
        nameEn: "Al Manar Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.4820,
        lng: 39.5777
    },
    {
        id: 'quba_souq',
        name: "\u0633\u0648\u0642 \u0642\u0628\u0627\u0621",
        nameEn: "Quba Souq",
        type: 'market',
        cityId: 'madinah_city',
        lat: 24.4523,
        lng: 39.6199
    },
    {
        id: 'yanbu_mall',
        name: "\u064A\u0646\u0628\u0639 \u0645\u0648\u0644",
        nameEn: "Yanbu Mall",
        type: 'mall',
        cityId: 'yanbu',
        lat: 24.0895,
        lng: 38.0618
    },
    {
        id: 'dana_mall',
        name: "\u0627\u0644\u062F\u0627\u0646\u0629 \u0645\u0648\u0644",
        nameEn: "Al Dana Mall",
        type: 'mall',
        cityId: 'yanbu',
        lat: 24.1000,
        lng: 38.0500
    },
    // ========== القصيم ==========
    {
        id: 'othaim_buraidah',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644 \u0628\u0631\u064A\u062F\u0629",
        nameEn: "Othaim Mall Buraydah",
        type: 'mall',
        cityId: 'buraidah',
        lat: 26.3266,
        lng: 43.9750
    },
    {
        id: 'nakheel_buraidah',
        name: "\u0627\u0644\u0646\u062E\u064A\u0644 \u0628\u0644\u0627\u0632\u0627",
        nameEn: "Nakheel Plaza",
        type: 'mall',
        cityId: 'buraidah',
        lat: 26.3350,
        lng: 43.9680
    },
    {
        id: 'buraidah_souq',
        name: "\u0633\u0648\u0642 \u0628\u0631\u064A\u062F\u0629 \u0627\u0644\u0645\u0631\u0643\u0632\u064A",
        nameEn: "Buraydah Central Souq",
        type: 'market',
        cityId: 'buraidah',
        lat: 26.3280,
        lng: 43.9730
    },
    {
        id: 'unaizah_mall',
        name: "\u0639\u0646\u064A\u0632\u0629 \u0645\u0648\u0644",
        nameEn: "Unaizah Mall",
        type: 'mall',
        cityId: 'unaizah',
        lat: 26.0842,
        lng: 43.9936
    },
    {
        id: 'rass_mall',
        name: "\u0627\u0644\u0631\u0633 \u0645\u0648\u0644",
        nameEn: "Ar Rass Mall",
        type: 'mall',
        cityId: 'rass',
        lat: 25.8692,
        lng: 43.4975
    },
    // ========== المنطقة الشرقية ==========
    {
        id: 'nakheel_dammam',
        name: "\u0627\u0644\u0646\u062E\u064A\u0644 \u0645\u0648\u0644 \u0627\u0644\u062F\u0645\u0627\u0645",
        nameEn: "Nakheel Mall Dammam",
        type: 'mall',
        cityId: 'dammam',
        lat: 26.4193,
        lng: 50.0888
    },
    {
        id: 'othaim_dammam',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644 \u0627\u0644\u062F\u0645\u0627\u0645",
        nameEn: "Othaim Mall Dammam",
        type: 'mall',
        cityId: 'dammam',
        lat: 26.4350,
        lng: 50.0704
    },
    {
        id: 'rashid_mega_mall',
        name: "\u0627\u0644\u0631\u0627\u0634\u062F \u0645\u064A\u063A\u0627 \u0645\u0648\u0644",
        nameEn: "Rashid Mega Mall",
        type: 'mall',
        cityId: 'khobar',
        lat: 26.2812,
        lng: 50.1900
    },
    {
        id: 'dhahran_mall',
        name: "\u0627\u0644\u0638\u0647\u0631\u0627\u0646 \u0645\u0648\u0644",
        nameEn: "Dhahran Mall",
        type: 'mall',
        cityId: 'dhahran',
        lat: 26.2975,
        lng: 50.1413
    },
    {
        id: 'fanateer_mall',
        name: "\u0627\u0644\u0641\u0646\u0627\u062A\u064A\u0631 \u0645\u0648\u0644",
        nameEn: "Fanateer Mall",
        type: 'mall',
        cityId: 'jubail',
        lat: 27.0046,
        lng: 49.6601
    },
    {
        id: 'jubail_mall',
        name: "\u0627\u0644\u062C\u0628\u064A\u0644 \u0645\u0648\u0644",
        nameEn: "Jubail Mall",
        type: 'mall',
        cityId: 'jubail',
        lat: 27.0100,
        lng: 49.6700
    },
    {
        id: 'ahsa_mall',
        name: "\u0627\u0644\u0623\u062D\u0633\u0627\u0621 \u0645\u0648\u0644",
        nameEn: "Al Ahsa Mall",
        type: 'mall',
        cityId: 'hafuf',
        lat: 25.3768,
        lng: 49.5851
    },
    {
        id: 'qaisariyyah_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0642\u064A\u0635\u0631\u064A\u0629",
        nameEn: "Qaisariyah Souq",
        type: 'market',
        cityId: 'hafuf',
        lat: 25.3790,
        lng: 49.5870
    },
    {
        id: 'darin_mall',
        name: "\u062F\u0627\u0631\u064A\u0646 \u0645\u0648\u0644",
        nameEn: "Darin Mall",
        type: 'mall',
        cityId: 'dammam',
        lat: 26.4100,
        lng: 50.0650
    },
    {
        id: 'mall_dhahran',
        name: "\u0623\u0645\u0648\u0627\u062C \u0645\u0648\u0644",
        nameEn: "Amwaj Mall",
        type: 'mall',
        cityId: 'dhahran',
        lat: 26.3111,
        lng: 50.1555
    },
    {
        id: 'venezia_mall',
        name: "\u0641\u064A\u0646\u064A\u0633\u064A\u0627 \u0645\u0648\u0644",
        nameEn: "Venezia Mall",
        type: 'mall',
        cityId: 'khobar',
        lat: 26.2810,
        lng: 50.1970
    },
    // ========== عسير ==========
    {
        id: 'abha_mall',
        name: "\u0623\u0628\u0647\u0627 \u0645\u0648\u0644",
        nameEn: "Abha Mall",
        type: 'mall',
        cityId: 'abha',
        lat: 18.2295,
        lng: 42.5020
    },
    {
        id: 'asir_mall',
        name: "\u0639\u0633\u064A\u0631 \u0645\u0648\u0644",
        nameEn: "Asir Mall",
        type: 'mall',
        cityId: 'abha',
        lat: 18.2320,
        lng: 42.5200
    },
    {
        id: 'rashid_mall_abha',
        name: "\u0627\u0644\u0631\u0627\u0634\u062F \u0645\u0648\u0644 \u0623\u0628\u0647\u0627",
        nameEn: "Rashid Mall Abha",
        type: 'mall',
        cityId: 'abha',
        lat: 18.2435,
        lng: 42.5401
    },
    {
        id: 'khamis_mall',
        name: "\u0627\u0644\u062E\u0645\u064A\u0633 \u0623\u0641\u0646\u064A\u0648",
        nameEn: "Khamis Avenue",
        type: 'mall',
        cityId: 'khamis_mushait',
        lat: 18.3002,
        lng: 42.7341
    },
    {
        id: 'mushait_mall',
        name: "\u0645\u0648\u062C\u0627\u0646 \u0628\u0627\u0631\u0643",
        nameEn: "Mojan Park",
        type: 'mall',
        cityId: 'khamis_mushait',
        lat: 18.3100,
        lng: 42.7500
    },
    {
        id: 'souq_thulathi',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        nameEn: "Tuesday Souq",
        type: 'market',
        cityId: 'abha',
        lat: 18.2260,
        lng: 42.5000
    },
    // ========== المناطق الأخرى (أسواق شعبية ومولات) ==========
    {
        id: 'tabuk_park',
        name: "\u062A\u0628\u0648\u0643 \u0628\u0627\u0631\u0643",
        nameEn: "Tabuk Park",
        type: 'mall',
        cityId: 'tabuk_city',
        lat: 28.3834,
        lng: 36.5844
    },
    {
        id: 'tabuk_souq',
        name: "\u0633\u0648\u0642 \u062A\u0628\u0648\u0643 \u0627\u0644\u0634\u0639\u0628\u064A",
        nameEn: "Tabuk Popular Souq",
        type: 'market',
        cityId: 'tabuk_city',
        lat: 28.3800,
        lng: 36.5800
    },
    {
        id: 'hail_mall',
        name: "\u062D\u0627\u0626\u0644 \u0645\u0648\u0644",
        nameEn: "Hail Mall",
        type: 'mall',
        cityId: 'hail_city',
        lat: 27.5114,
        lng: 41.6904
    },
    {
        id: 'barzan_souq',
        name: "\u0633\u0648\u0642 \u0628\u0631\u0632\u0627\u0646",
        nameEn: "Barzan Souq",
        type: 'market',
        cityId: 'hail_city',
        lat: 27.5250,
        lng: 41.6950
    },
    {
        id: 'salma_mall',
        name: "\u0633\u0644\u0645\u0649 \u0645\u0648\u0644",
        nameEn: "Salma Mall",
        type: 'mall',
        cityId: 'hail_city',
        lat: 27.5200,
        lng: 41.7000
    },
    {
        id: 'arar_mall',
        name: "\u0639\u0631\u0639\u0631 \u0645\u0648\u0644",
        nameEn: "Arar Mall",
        type: 'mall',
        cityId: 'arar',
        lat: 30.9753,
        lng: 41.0200
    },
    {
        id: 'jazan_mall',
        name: "\u0643\u0627\u062F\u064A \u0645\u0648\u0644",
        nameEn: "Kadi Mall",
        type: 'mall',
        cityId: 'jazan_city',
        lat: 16.8900,
        lng: 42.5500
    },
    {
        id: 'jazan_souq',
        name: "\u0633\u0648\u0642 \u062C\u0627\u0632\u0627\u0646 \u0627\u0644\u062F\u0627\u062E\u0644\u064A (\u0627\u0644\u0628\u0644\u062F)",
        nameEn: "Jazan Inner Souq (Al Balad)",
        type: 'market',
        cityId: 'jazan_city',
        lat: 16.8850,
        lng: 42.5550
    },
    {
        id: 'rashid_mall_jazan',
        name: "\u0627\u0644\u0631\u0627\u0634\u062F \u0645\u0648\u0644 \u062C\u0627\u0632\u0627\u0646",
        nameEn: "Rashid Mall Jazan",
        type: 'mall',
        cityId: 'jazan_city',
        lat: 16.8800,
        lng: 42.5600
    },
    {
        id: 'najran_mall',
        name: "\u0646\u062C\u0631\u0627\u0646 \u0645\u0648\u0644",
        nameEn: "Najran Mall",
        type: 'mall',
        cityId: 'najran_city',
        lat: 17.4922,
        lng: 44.1314
    },
    {
        id: 'najran_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062C\u0646\u0627\u0628\u064A \u0627\u0644\u0634\u0639\u0628\u064A",
        nameEn: "Al Janabi Popular Souq",
        type: 'market',
        cityId: 'najran_city',
        lat: 17.5000,
        lng: 44.1400
    },
    {
        id: 'baha_mall',
        name: "\u0627\u0644\u0628\u0627\u062D\u0629 \u0645\u0648\u0644",
        nameEn: "Al Baha Mall",
        type: 'mall',
        cityId: 'baha_city',
        lat: 20.0125,
        lng: 41.4653
    },
    {
        id: 'baha_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0645\u064A\u0633 \u0628\u0627\u0644\u0628\u0627\u062D\u0629",
        nameEn: "Al Khamis Souq in Al Baha",
        type: 'market',
        cityId: 'baha_city',
        lat: 20.0150,
        lng: 41.4600
    },
    {
        id: 'mikhwah_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0645\u062E\u0648\u0627\u0629 \u0627\u0644\u0634\u0639\u0628\u064A",
        nameEn: "Al Makhwah Popular Souq",
        type: 'market',
        cityId: 'mikhwah',
        lat: 19.8227,
        lng: 41.4385
    },
    {
        id: 'jouf_mall',
        name: "\u0627\u0644\u062C\u0648\u0641 \u0628\u0644\u0627\u0632\u0627",
        nameEn: "Al Jouf Plaza",
        type: 'mall',
        cityId: 'sakaka',
        lat: 29.9697,
        lng: 40.2064
    },
    {
        id: 'jouf_souq',
        name: "\u0633\u0648\u0642 \u0633\u0643\u0627\u0643\u0627 \u0627\u0644\u0634\u0639\u0628\u064A",
        nameEn: "Sakaka Popular Souq",
        type: 'market',
        cityId: 'sakaka',
        lat: 29.9750,
        lng: 40.2100
    },
    {
        id: 'qurayyat_mall',
        name: "\u0627\u0644\u0642\u0631\u064A\u0627\u062A \u0645\u0648\u0644",
        nameEn: "Qurayyat Mall",
        type: 'mall',
        cityId: 'qurayyat',
        lat: 31.3317,
        lng: 37.3414
    },
    {
        id: 'tariq_souq',
        name: "\u0633\u0648\u0642 \u0637\u0627\u0631\u0642",
        nameEn: "Tariq Souq",
        type: 'market',
        cityId: 'khobar',
        lat: 26.2800,
        lng: 50.2100
    },
    {
        id: 'suwaileh_souq',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0627\u0644\u0633\u0648\u064A\u0644\u0645",
        nameEn: "Al Suwailem Markets",
        type: 'market',
        cityId: 'riyadh_city',
        lat: 24.6300,
        lng: 46.7120
    },
    {
        id: 'ahsa_souq',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0633\u0648\u064A\u0642 \u0628\u0627\u0644\u0627\u062D\u0633\u0627\u0621",
        nameEn: "Al Suwaiq Souq in Al Ahsa",
        type: 'market',
        cityId: 'hafuf',
        lat: 25.3780,
        lng: 49.5880
    },
    // ===== توسعة المولات والأسواق v11.98 — مصدر موثّق + تحقّق مسافة من مركز المدينة =====
    // ++ abha
    {
        id: 'haraj_abha',
        name: "\u062D\u0631\u0627\u062C \u0623\u0628\u0647\u0627",
        nameEn: "Haraj Abha",
        type: 'market',
        cityId: 'abha',
        lat: 18.24865,
        lng: 42.52805
    },
    {
        id: 'lavanda_park',
        name: "\u0644\u0627\u0641\u0646\u062F\u0627 \u0628\u0627\u0631\u0643",
        nameEn: "Lavanda Park",
        type: 'mall',
        cityId: 'abha',
        lat: 18.24006,
        lng: 42.60378
    },
    // ++ abu_arish
    {
        id: 'forsatak_shopping',
        name: "\u0641\u0631\u0635\u062A\u0643 \u0644\u0644\u062A\u0633\u0648\u0642",
        nameEn: "Forsatak Shopping Mall",
        type: 'mall',
        cityId: 'abu_arish',
        lat: 16.96142,
        lng: 42.82163
    },
    {
        id: 'the_region',
        name: "\u0630\u064A \u0631\u064A\u062C\u0646 \u0645\u0648\u0644",
        nameEn: "The Region Mall",
        type: 'mall',
        cityId: 'abu_arish',
        lat: 16.96051,
        lng: 42.82166
    },
    // ++ arar
    {
        id: 'arar_vegetable',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631 \u0628\u0639\u0631\u0639\u0631",
        nameEn: "Arar Vegetable Market",
        type: 'market',
        cityId: 'arar',
        lat: 30.97687,
        lng: 41.01281
    },
    {
        id: 'valley',
        name: "\u0641\u0627\u0644\u064A \u0645\u0648\u0644",
        nameEn: "Valley Mall",
        type: 'mall',
        cityId: 'arar',
        lat: 30.96629,
        lng: 41.02432
    },
    // ++ badr
    {
        id: 'abdullah_al_othaim_markets',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0639\u0628\u062F\u0627\u0644\u0644\u0647 \u0627\u0644\u0639\u062B\u064A\u0645",
        nameEn: "Abdullah Al Othaim Markets",
        type: 'market',
        cityId: 'badr',
        lat: 23.78007,
        lng: 38.79702
    },
    // ++ baha_city
    {
        id: 'ghoneim_mall',
        name: "\u0627\u0644\u063A\u0646\u064A\u0645 \u0645\u0648\u0644",
        nameEn: "Al Ghoneim Mall",
        type: 'mall',
        cityId: 'baha_city',
        lat: 20.00719,
        lng: 41.45171
    },
    // ++ baljurashi
    {
        id: 'baljurashi_mall',
        name: "\u0628\u0644\u062C\u0631\u0634\u064A \u0645\u0648\u0644",
        nameEn: "Baljurashi Mall",
        type: 'mall',
        cityId: 'baljurashi',
        lat: 19.88378,
        lng: 41.56766
    },
    // ++ baqaa
    {
        id: 'vegetable_market_baqaa',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631 (\u0628\u0642\u0639\u0627\u0621)",
        nameEn: "Vegetable Market (Baqaa)",
        type: 'market',
        cityId: 'baqaa',
        lat: 27.9027,
        lng: 42.3944
    },
    // ++ bariq
    {
        id: 'souq_al_ajamah',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0639\u062C\u0645\u0629",
        nameEn: "Souq Al Ajamah",
        type: 'market',
        cityId: 'bariq',
        lat: 19.01128,
        lng: 41.87948
    },
    {
        id: 'souq_al_rubu',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0631\u0628\u0648\u0639",
        nameEn: "Souq Al Rubu",
        type: 'market',
        cityId: 'bariq',
        lat: 18.9285,
        lng: 41.91195
    },
    // ++ bukayriah
    {
        id: 'al_bukayriyah',
        name: "\u0645\u0648\u0644 \u0627\u0644\u0628\u0643\u064A\u0631\u064A\u0629",
        nameEn: "Al Bukayriyah Mall",
        type: 'mall',
        cityId: 'bukayriah',
        lat: 26.14386,
        lng: 43.65071
    },
    {
        id: 'monday_popular',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0627\u062B\u0646\u064A\u0646 \u0627\u0644\u0634\u0639\u0628\u064A",
        nameEn: "Monday Popular Market",
        type: 'market',
        cityId: 'bukayriah',
        lat: 26.12278,
        lng: 43.67721
    },
    // ++ bukayriyah_q
    {
        id: 'al_bukayriyah_bukayriyah_q',
        name: "\u0645\u0648\u0644 \u0627\u0644\u0628\u0643\u064A\u0631\u064A\u0629",
        nameEn: "Al Bukayriyah Mall",
        type: 'mall',
        cityId: 'bukayriyah_q',
        lat: 26.14386,
        lng: 43.65071
    },
    {
        id: 'monday_popular_bukayriyah_q',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0627\u062B\u0646\u064A\u0646 \u0627\u0644\u0634\u0639\u0628\u064A",
        nameEn: "Monday Popular Market",
        type: 'market',
        cityId: 'bukayriyah_q',
        lat: 26.12278,
        lng: 43.67721
    },
    // ++ buraidah
    {
        id: 'al_faiziah',
        name: "\u0645\u0648\u0644 \u0627\u0644\u0641\u0627\u064A\u0632\u064A\u0629",
        nameEn: "Al Faiziah Mall",
        type: 'mall',
        cityId: 'buraidah',
        lat: 26.38628,
        lng: 43.96259
    },
    {
        id: 'al_rashid',
        name: "\u0627\u0644\u0631\u0627\u0634\u062F \u0645\u0648\u0644",
        nameEn: "Al Rashid Mall",
        type: 'mall',
        cityId: 'buraidah',
        lat: 26.36763,
        lng: 43.94281
    },
    {
        id: 'alhasson',
        name: "\u0627\u0644\u062D\u0633\u0648\u0646 \u0633\u0646\u062A\u0631",
        nameEn: "Alhasson Center",
        type: 'mall',
        cityId: 'buraidah',
        lat: 26.36686,
        lng: 43.94225
    },
    {
        id: 'aljedaie',
        name: "\u0627\u0644\u062C\u062F\u064A\u0639\u064A \u0645\u0648\u0644",
        nameEn: "Aljedaie Mall",
        type: 'mall',
        cityId: 'buraidah',
        lat: 26.3741,
        lng: 43.93634
    },
    {
        id: 'birds',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0637\u064A\u0648\u0631",
        nameEn: "Birds Market",
        type: 'market',
        cityId: 'buraidah',
        lat: 26.35468,
        lng: 44.0461
    },
    {
        id: 'central_dates',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062A\u0645\u0648\u0631 \u0627\u0644\u0645\u0631\u0643\u0632\u064A",
        nameEn: "Central Dates Market",
        type: 'market',
        cityId: 'buraidah',
        lat: 26.3135,
        lng: 43.98242
    },
    {
        id: 'vegetable_and_fruit',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u0643\u0647",
        nameEn: "Vegetable and Fruit Market",
        type: 'market',
        cityId: 'buraidah',
        lat: 26.3123,
        lng: 43.97844
    },
    // ++ dammam
    {
        id: 'dammam_fish',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0633\u0645\u0643 \u0628\u0627\u0644\u062F\u0645\u0627\u0645",
        nameEn: "Dammam Fish Market",
        type: 'market',
        cityId: 'dammam',
        lat: 26.44576,
        lng: 50.06573
    },
    {
        id: 'marina_mall_dammam',
        name: "\u0645\u0627\u0631\u064A\u0646\u0627 \u0645\u0648\u0644 \u0627\u0644\u062F\u0645\u0627\u0645",
        nameEn: "Marina Mall Dammam",
        type: 'mall',
        cityId: 'dammam',
        lat: 26.45508,
        lng: 50.10569
    },
    // ++ dawadmi
    {
        id: 'othaim',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0639\u062B\u064A\u0645",
        nameEn: "Othaim Market",
        type: 'market',
        cityId: 'dawadmi',
        lat: 24.516,
        lng: 44.4103
    },
    // ++ diriyah
    {
        id: 'al_makan',
        name: "\u0627\u0644\u0645\u0643\u0627\u0646 \u0645\u0648\u0644",
        nameEn: "Al Makan Mall",
        type: 'mall',
        cityId: 'diriyah',
        lat: 24.79055,
        lng: 46.61177
    },
    {
        id: 'lumiere',
        name: "\u0644\u0648\u0645\u064A\u064A\u0631 \u0645\u0648\u0644",
        nameEn: "Lumiere Mall",
        type: 'mall',
        cityId: 'diriyah',
        lat: 24.75987,
        lng: 46.60362
    },
    {
        id: 'riyadh_park_diriyah',
        name: "\u0627\u0644\u0631\u064A\u0627\u0636 \u0628\u0627\u0631\u0643",
        nameEn: "Riyadh Park",
        type: 'mall',
        cityId: 'diriyah',
        lat: 24.75677,
        lng: 46.62987
    },
    {
        id: 'u_walk',
        name: "\u064A\u0648 \u0648\u0648\u0643",
        nameEn: "U Walk",
        type: 'mall',
        cityId: 'diriyah',
        lat: 24.73804,
        lng: 46.62882
    },
    // ++ dumat_jandal
    {
        id: 'arena_al_jouf',
        name: "\u0645\u0648\u0644 \u0623\u0631\u064A\u0646\u0627 \u0627\u0644\u062C\u0648\u0641",
        nameEn: "Arena Al Jouf Mall",
        type: 'mall',
        cityId: 'dumat_jandal',
        lat: 29.79867,
        lng: 39.8535
    },
    // ++ hafar_al_batin
    {
        id: 'al_othaim_mall_hafar_al_batin',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644 \u062D\u0641\u0631 \u0627\u0644\u0628\u0627\u0637\u0646",
        nameEn: "Al Othaim Mall Hafar Al Batin",
        type: 'mall',
        cityId: 'hafar_al_batin',
        lat: 28.3186,
        lng: 45.95045
    },
    {
        id: 'hala',
        name: "\u0647\u0644\u0627 \u0645\u0648\u0644",
        nameEn: "Hala Mall",
        type: 'mall',
        cityId: 'hafar_al_batin',
        lat: 28.41218,
        lng: 45.99798
    },
    {
        id: 'sarh_al_muslim',
        name: "\u0635\u0631\u062D \u0627\u0644\u0645\u0633\u0644\u0645 \u0645\u0648\u0644",
        nameEn: "Sarh Al Muslim Mall",
        type: 'mall',
        cityId: 'hafar_al_batin',
        lat: 28.40919,
        lng: 45.97097
    },
    // ++ hafuf
    {
        id: 'al_haraj_souq_mubarraz',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062D\u0631\u0627\u062C \u0628\u0627\u0644\u0645\u0628\u0631\u0632",
        nameEn: "Al Haraj Souq Mubarraz",
        type: 'market',
        cityId: 'hafuf',
        lat: 25.39579,
        lng: 49.5936
    },
    {
        id: 'al_othaim_mall_mubarraz',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644 \u0627\u0644\u0645\u0628\u0631\u0632",
        nameEn: "Al Othaim Mall Mubarraz",
        type: 'mall',
        cityId: 'hafuf',
        lat: 25.40022,
        lng: 49.57793
    },
    {
        id: 'al_soni_electronics',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0633\u0648\u0646\u064A \u0644\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0627\u062A",
        nameEn: "Al Soni Electronics Souq",
        type: 'market',
        cityId: 'hafuf',
        lat: 25.38062,
        lng: 49.58997
    },
    {
        id: 'nakheel_plaza_hofuf',
        name: "\u0627\u0644\u0646\u062E\u064A\u0644 \u0628\u0644\u0627\u0632\u0627",
        nameEn: "Nakheel Plaza Hofuf",
        type: 'mall',
        cityId: 'hafuf',
        lat: 25.35966,
        lng: 49.54755
    },
    // ++ hail_city
    {
        id: 'centrepoint_hail',
        name: "\u0633\u0646\u062A\u0631 \u0628\u0648\u064A\u0646\u062A \u062D\u0627\u0626\u0644",
        nameEn: "Centrepoint Hail",
        type: 'mall',
        cityId: 'hail_city',
        lat: 27.50929,
        lng: 41.69929
    },
    {
        id: 'garden_mall_mango_garden',
        name: "\u0627\u0644\u062D\u062F\u064A\u0642\u0629 \u0645\u0648\u0644 (\u0645\u0627\u0646\u062C\u0648 \u062C\u0627\u0631\u062F\u0646 \u0645\u0648\u0644)",
        nameEn: "Garden Mall (MANGO Garden Mall)",
        type: 'mall',
        cityId: 'hail_city',
        lat: 27.55437,
        lng: 41.68155
    },
    {
        id: 'grand',
        name: "\u062C\u0631\u0627\u0646\u062F \u0645\u0648\u0644",
        nameEn: "Grand Mall",
        type: 'mall',
        cityId: 'hail_city',
        lat: 27.47394,
        lng: 41.67696
    },
    {
        id: 'hail_square',
        name: "\u0645\u062C\u0645\u0639 \u062D\u0627\u0626\u0644 \u0633\u0643\u0648\u064A\u0631",
        nameEn: "Hail Square",
        type: 'mall',
        cityId: 'hail_city',
        lat: 27.4999,
        lng: 41.67051
    },
    {
        id: 'othaim_mall_hail',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644 \u062D\u0627\u0626\u0644",
        nameEn: "Othaim Mall Hail",
        type: 'mall',
        cityId: 'hail_city',
        lat: 27.47404,
        lng: 41.67665
    },
    // ++ haql
    {
        id: 'othaim_markets',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0627\u0644\u0639\u062B\u064A\u0645",
        nameEn: "Othaim Markets",
        type: 'market',
        cityId: 'haql',
        lat: 29.28114,
        lng: 34.93833
    },
    // ++ jazan_city
    {
        id: 'vegetable_and_fruit_jazan_city',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u0643\u0647",
        nameEn: "Vegetable and Fruit Market",
        type: 'market',
        cityId: 'jazan_city',
        lat: 16.90174,
        lng: 42.54598
    },
    // ++ jeddah
    {
        id: 'hera',
        name: "\u062D\u0631\u0627\u0621 \u0645\u0648\u0644",
        nameEn: "Hera Mall",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.61092,
        lng: 39.13918
    },
    {
        id: 'jeddah_park',
        name: "\u062C\u062F\u0629 \u0628\u0627\u0631\u0643",
        nameEn: "Jeddah Park",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.55622,
        lng: 39.18497
    },
    {
        id: 'le_prestige',
        name: "\u0644\u0648 \u0628\u0631\u064A\u0633\u062A\u064A\u062C \u0645\u0648\u0644",
        nameEn: "Le Prestige Mall",
        type: 'mall',
        cityId: 'jeddah',
        lat: 21.56564,
        lng: 39.12501
    },
    {
        id: 'souq_al_alawi_al_balad',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0639\u0644\u0648\u064A (\u0627\u0644\u0628\u0644\u062F)",
        nameEn: "Souq Al Alawi (Al Balad)",
        type: 'market',
        cityId: 'jeddah',
        lat: 21.48421,
        lng: 39.1875
    },
    // ++ khafji
    {
        id: 'al_othaim_mall_khafji',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644 \u0627\u0644\u062E\u0641\u062C\u064A",
        nameEn: "Al Othaim Mall Khafji",
        type: 'mall',
        cityId: 'khafji',
        lat: 28.42172,
        lng: 48.48063
    },
    // ++ khamis_mushait
    {
        id: 'asdaf',
        name: "\u0623\u0635\u062F\u0627\u0641 \u0645\u0648\u0644",
        nameEn: "Asdaf Mall",
        type: 'mall',
        cityId: 'khamis_mushait',
        lat: 18.306,
        lng: 42.73223
    },
    // ++ kharj
    {
        id: 'al_wahah',
        name: "\u0627\u0644\u0648\u0627\u062D\u0629 \u0645\u0648\u0644",
        nameEn: "Al Wahah Mall",
        type: 'mall',
        cityId: 'kharj',
        lat: 24.12969,
        lng: 47.26459
    },
    {
        id: 'al_warood',
        name: "\u0627\u0644\u0648\u0631\u0648\u062F \u0628\u0644\u0627\u0632\u0627",
        nameEn: "Al Warood Plaza",
        type: 'mall',
        cityId: 'kharj',
        lat: 24.15889,
        lng: 47.29999
    },
    {
        id: 'jaw',
        name: "\u062C\u0648 \u0645\u0648\u0644",
        nameEn: "Jaw Mall",
        type: 'mall',
        cityId: 'kharj',
        lat: 24.16612,
        lng: 47.33396
    },
    // ++ khaybar
    {
        id: 'al_muthallath_shopping',
        name: "\u0645\u0631\u0643\u0632 \u0627\u0644\u0645\u062B\u0644\u062B \u0644\u0644\u062A\u0633\u0648\u064A\u0642",
        nameEn: "Al Muthallath Shopping Center",
        type: 'market',
        cityId: 'khaybar',
        lat: 25.69404,
        lng: 39.29546
    },
    {
        id: 'al_takamul_shopping',
        name: "\u0627\u0644\u062A\u0643\u0627\u0645\u0644 \u0644\u0644\u062A\u0633\u0648\u0642",
        nameEn: "Al Takamul Shopping Center",
        type: 'market',
        cityId: 'khaybar',
        lat: 25.69192,
        lng: 39.29413
    },
    // ++ laith
    {
        id: 'souq_mugaybil',
        name: "\u0633\u0648\u0642 \u0645\u0642\u064A\u0628\u0644",
        nameEn: "Souq Mugaybil",
        type: 'market',
        cityId: 'laith',
        lat: 20.14874,
        lng: 40.27905
    },
    // ++ madinah_city
    {
        id: 'al_jabri',
        name: "\u0645\u062C\u0645\u0639 \u0627\u0644\u062C\u0627\u0628\u0631\u064A",
        nameEn: "Al Jabri Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.45801,
        lng: 39.61439
    },
    {
        id: 'al_jazira_shopping',
        name: "\u0645\u062C\u0645\u0639 \u0627\u0644\u062C\u0632\u064A\u0631\u0629 \u0644\u0644\u062A\u0633\u0648\u0642",
        nameEn: "Al Jazira Shopping Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.46393,
        lng: 39.61504
    },
    {
        id: 'al_madinah',
        name: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0633\u0646\u062A\u0631",
        nameEn: "Al Madinah Center",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.45744,
        lng: 39.59598
    },
    {
        id: 'al_madinah_international',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0627\u0644\u062F\u0648\u0644\u064A",
        nameEn: "Al Madinah International Souq",
        type: 'market',
        cityId: 'madinah_city',
        lat: 24.48355,
        lng: 39.59765
    },
    {
        id: 'al_qarat',
        name: "\u0645\u062C\u0645\u0639 \u0627\u0644\u0642\u0627\u0631\u0627\u062A",
        nameEn: "Al Qarat Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.49415,
        lng: 39.60089
    },
    {
        id: 'al_rashed',
        name: "\u0627\u0644\u0631\u0627\u0634\u062F \u0645\u0648\u0644",
        nameEn: "Al Rashed Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.48731,
        lng: 39.64953
    },
    {
        id: 'centre_point',
        name: "\u0633\u0646\u062A\u0631 \u0628\u0648\u064A\u0646\u062A",
        nameEn: "Centre Point",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.46382,
        lng: 39.61196
    },
    {
        id: 'hassan',
        name: "\u062D\u0633\u0646 \u0645\u0648\u0644",
        nameEn: "Hassan Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.49799,
        lng: 39.6185
    },
    {
        id: 'j_walk',
        name: "\u062C\u064A \u0648\u0648\u0643",
        nameEn: "J Walk",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.45791,
        lng: 39.54429
    },
    {
        id: 'mazaia',
        name: "\u0645\u0632\u0627\u064A\u0627 \u0645\u0648\u0644",
        nameEn: "Mazaia Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.48476,
        lng: 39.61045
    },
    {
        id: 'namia',
        name: "\u0645\u0631\u0643\u0632 \u0646\u0627\u0645\u064A\u0629",
        nameEn: "Namia Center",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.47195,
        lng: 39.61277
    },
    {
        id: 'new_bilal',
        name: "\u0633\u0648\u0642 \u0628\u0644\u0627\u0644 \u0627\u0644\u062C\u062F\u064A\u062F",
        nameEn: "New Bilal Market",
        type: 'market',
        cityId: 'madinah_city',
        lat: 24.46187,
        lng: 39.61181
    },
    {
        id: 'new_dates',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062A\u0645\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F",
        nameEn: "New Dates Market",
        type: 'market',
        cityId: 'madinah_city',
        lat: 24.41674,
        lng: 39.61705
    },
    {
        id: 'qurban',
        name: "\u0642\u0631\u0628\u0627\u0646 \u0645\u0648\u0644",
        nameEn: "Qurban Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.45376,
        lng: 39.61994
    },
    {
        id: 'rotana',
        name: "\u0631\u0648\u062A\u0627\u0646\u0627 \u0645\u0648\u0644",
        nameEn: "Rotana Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.45845,
        lng: 39.6664
    },
    {
        id: 'space',
        name: "\u0633\u0628\u064A\u0633 \u0645\u0648\u0644",
        nameEn: "Space Mall",
        type: 'mall',
        cityId: 'madinah_city',
        lat: 24.48584,
        lng: 39.58935
    },
    // ++ mahad_adh_dhahab
    {
        id: 'abdullah_al_othaim_markets_mahad_adh_dhahab',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0639\u0628\u062F\u0627\u0644\u0644\u0647 \u0627\u0644\u0639\u062B\u064A\u0645",
        nameEn: "Abdullah Al Othaim Markets",
        type: 'market',
        cityId: 'mahad_adh_dhahab',
        lat: 23.50642,
        lng: 40.88548
    },
    // ++ mahail_asir
    {
        id: 'oasis_al_waha',
        name: "\u0627\u0644\u0648\u0627\u062D\u0629 \u0645\u0648\u0644",
        nameEn: "Oasis (Al Waha) Mall",
        type: 'mall',
        cityId: 'mahail_asir',
        lat: 18.55198,
        lng: 42.04006
    },
    // ++ majmaah
    {
        id: 'majmaah',
        name: "\u0645\u0648\u0644 \u0627\u0644\u0645\u062C\u0645\u0639\u0629",
        nameEn: "Majmaah Mall",
        type: 'mall',
        cityId: 'majmaah',
        lat: 25.90935,
        lng: 45.34319
    },
    {
        id: 'othaim_majmaah',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644",
        nameEn: "Othaim Mall",
        type: 'mall',
        cityId: 'majmaah',
        lat: 25.90262,
        lng: 45.35489
    },
    // ++ makkah_city
    {
        id: 'souq_al_arab',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0639\u0631\u0628",
        nameEn: "Souq Al Arab",
        type: 'market',
        cityId: 'makkah_city',
        lat: 21.44615,
        lng: 39.85599
    },
    {
        id: 'souq_al_khalil',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0644\u064A\u0644",
        nameEn: "Souq Al Khalil",
        type: 'market',
        cityId: 'makkah_city',
        lat: 21.42122,
        lng: 39.82186
    },
    {
        id: 'souq_al_tamr_dates',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062A\u0645\u0648\u0631",
        nameEn: "Souq Al Tamr (Dates Market)",
        type: 'market',
        cityId: 'makkah_city',
        lat: 21.37039,
        lng: 39.80595
    },
    // ++ muznib
    {
        id: 'al_muznib_old_heritage',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0645\u0630\u0646\u0628 \u0627\u0644\u0642\u062F\u064A\u0645 \u0627\u0644\u062A\u0631\u0627\u062B\u064A",
        nameEn: "Al Muznib Old Heritage Market",
        type: 'market',
        cityId: 'muznib',
        lat: 25.86836,
        lng: 44.22761
    },
    // ++ nairyah
    {
        id: 'nairyah_popular',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0646\u0639\u064A\u0631\u064A\u0629 \u0627\u0644\u0634\u0639\u0628\u064A",
        nameEn: "Nairyah Popular Souq",
        type: 'market',
        cityId: 'nairyah',
        lat: 27.465,
        lng: 48.4806
    },
    // ++ najran_city
    {
        id: 'al_azzam',
        name: "\u0627\u0644\u0639\u0632\u0651\u0627\u0645 \u0645\u0648\u0644",
        nameEn: "Al-Azzam Mall",
        type: 'mall',
        cityId: 'najran_city',
        lat: 17.53926,
        lng: 44.21432
    },
    {
        id: 'al_faisaliah_market_for_vegetables_fruit',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0641\u064A\u0635\u0644\u064A\u0629 \u0644\u0644\u062E\u0636\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u0643\u0647 \u0648\u0627\u0644\u0644\u062D\u0648\u0645",
        nameEn: "Al-Faisaliah Market for Vegetables, Fruits and Meat",
        type: 'market',
        cityId: 'najran_city',
        lat: 17.52588,
        lng: 44.20105
    },
    {
        id: 'najran_royal',
        name: "\u0646\u062C\u0631\u0627\u0646 \u0631\u0648\u064A\u0627\u0644 \u0645\u0648\u0644",
        nameEn: "Najran Royal Mall",
        type: 'mall',
        cityId: 'najran_city',
        lat: 17.55017,
        lng: 44.25779
    },
    {
        id: 'suq_al_haraj_wa_al_aghnam_popular_livest',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062D\u0631\u0627\u062C \u0648\u0627\u0644\u0623\u063A\u0646\u0627\u0645 (\u0633\u0648\u0642 \u0627\u0644\u062C\u0646\u0627\u0628\u064A \u0627\u0644\u0634\u0639\u0628\u064A)",
        nameEn: "Suq Al-Haraj wa Al-Aghnam (popular livestock market)",
        type: 'market',
        cityId: 'najran_city',
        lat: 17.49389,
        lng: 44.15213
    },
    // ++ namas
    {
        id: 'al_namas',
        name: "\u0627\u0644\u0646\u0645\u0627\u0635 \u0645\u0648\u0644",
        nameEn: "Al Namas Mall",
        type: 'mall',
        cityId: 'namas',
        lat: 19.11868,
        lng: 42.13088
    },
    // ++ qatif
    {
        id: 'city_mall_qatif',
        name: "\u0645\u062C\u0645\u0639 \u0633\u064A\u062A\u064A \u0645\u0648\u0644 \u0628\u0627\u0644\u0642\u0637\u064A\u0641",
        nameEn: "City Mall Qatif",
        type: 'mall',
        cityId: 'qatif',
        lat: 26.55785,
        lng: 50.0377
    },
    {
        id: 'qatif',
        name: "\u0645\u062C\u0645\u0639 \u0627\u0644\u0642\u0637\u064A\u0641 \u0628\u0644\u0627\u0632\u0627",
        nameEn: "Qatif Plaza",
        type: 'mall',
        cityId: 'qatif',
        lat: 26.5509,
        lng: 50.01545
    },
    {
        id: 'qatif_central_fish',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0633\u0645\u0643 \u0627\u0644\u0645\u0631\u0643\u0632\u064A \u0628\u0627\u0644\u0642\u0637\u064A\u0641",
        nameEn: "Qatif Central Fish Market",
        type: 'market',
        cityId: 'qatif',
        lat: 26.55533,
        lng: 50.00797
    },
    {
        id: 'qatif_thursday',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0645\u064A\u0633 \u0628\u0627\u0644\u0642\u0637\u064A\u0641",
        nameEn: "Qatif Thursday Souq",
        type: 'market',
        cityId: 'qatif',
        lat: 26.55686,
        lng: 49.99917
    },
    // ++ qurayyat
    {
        id: 'al_wisam_discount',
        name: "\u0645\u0631\u0643\u0632 \u0627\u0644\u0648\u0633\u0627\u0645 \u0644\u0644\u062A\u062E\u0641\u064A\u0636\u0627\u062A",
        nameEn: "Al Wisam Discount Center",
        type: 'mall',
        cityId: 'qurayyat',
        lat: 31.31927,
        lng: 37.35733
    },
    // ++ rabigh
    {
        id: 'rabigh',
        name: "\u0631\u0627\u0628\u063A \u0645\u0648\u0644",
        nameEn: "Rabigh Mall",
        type: 'mall',
        cityId: 'rabigh',
        lat: 22.78871,
        lng: 39.03258
    },
    {
        id: 'rabigh_livestock',
        name: "\u0633\u0648\u0642 \u0631\u0627\u0628\u063A \u0644\u0644\u0645\u0648\u0627\u0634\u064A",
        nameEn: "Rabigh Livestock Market",
        type: 'market',
        cityId: 'rabigh',
        lat: 22.77047,
        lng: 39.05598
    },
    // ++ rafha
    {
        id: 'rafha_shopping',
        name: "\u0645\u0631\u0643\u0632 \u062A\u0633\u0648\u0642 \u0631\u0641\u062D\u0627\u0621",
        nameEn: "Rafha Shopping Center",
        type: 'market',
        cityId: 'rafha',
        lat: 29.6177,
        lng: 43.5263
    },
    // ++ rass
    {
        id: 'al_deira',
        name: "\u0627\u0644\u062F\u064A\u0631\u0629 \u0645\u0648\u0644",
        nameEn: "Al Deira Mall",
        type: 'mall',
        cityId: 'rass',
        lat: 25.86894,
        lng: 43.50871
    },
    {
        id: 'al_othaim_mall_al_rass',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644 \u0627\u0644\u0631\u0633",
        nameEn: "Al Othaim Mall Al Rass",
        type: 'mall',
        cityId: 'rass',
        lat: 25.8976,
        lng: 43.4719
    },
    {
        id: 'al_rass_vegetable_and_fruit',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u0643\u0647 \u0628\u0627\u0644\u0631\u0633",
        nameEn: "Al Rass Vegetable and Fruit Market",
        type: 'market',
        cityId: 'rass',
        lat: 25.87303,
        lng: 43.50978
    },
    {
        id: 'city',
        name: "\u0633\u064A\u062A\u064A \u0633\u0646\u062A\u0631",
        nameEn: "City Center",
        type: 'mall',
        cityId: 'rass',
        lat: 25.86832,
        lng: 43.50466
    },
    {
        id: 'sahara',
        name: "\u0635\u062D\u0627\u0631\u0649 \u0645\u0648\u0644",
        nameEn: "Sahara Mall",
        type: 'mall',
        cityId: 'rass',
        lat: 25.86681,
        lng: 43.50653
    },
    // ++ riyadh_al_khabra
    {
        id: 'riyadh_al_khabra_local_dates',
        name: "\u0633\u0648\u0642 \u0631\u064A\u0627\u0636 \u0627\u0644\u062E\u0628\u0631\u0627\u0621 \u0644\u0644\u062A\u0645\u0648\u0631 \u0627\u0644\u0645\u062D\u0644\u064A\u0629",
        nameEn: "Riyadh Al Khabra Local Dates Market",
        type: 'market',
        cityId: 'riyadh_al_khabra',
        lat: 26.05628,
        lng: 43.56225
    },
    // ++ sabya
    {
        id: 'al_qahtani_commercial_complex',
        name: "\u0645\u062C\u0645\u0639 \u0627\u0644\u0642\u062D\u0637\u0627\u0646\u064A \u0627\u0644\u062A\u062C\u0627\u0631\u064A",
        nameEn: "Al Qahtani Commercial Complex",
        type: 'market',
        cityId: 'sabya',
        lat: 17.10284,
        lng: 42.65453
    },
    {
        id: 'al_salwa_commercial_complex',
        name: "\u0645\u062C\u0645\u0639 \u0627\u0644\u0633\u0644\u0648\u0649 \u0627\u0644\u062A\u062C\u0627\u0631\u064A",
        nameEn: "Al Salwa Commercial Complex",
        type: 'market',
        cityId: 'sabya',
        lat: 17.08745,
        lng: 42.64619
    },
    {
        id: 'tuesday',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        nameEn: "Tuesday Market",
        type: 'market',
        cityId: 'sabya',
        lat: 17.21531,
        lng: 42.6438
    },
    // ++ sakaka
    {
        id: 'al_hassoun',
        name: "\u0645\u0648\u0644 \u0627\u0644\u062D\u0633\u0648\u0646",
        nameEn: "Al Hassoun Mall",
        type: 'mall',
        cityId: 'sakaka',
        lat: 29.95443,
        lng: 40.19022
    },
    {
        id: 'ala_kefak',
        name: "\u0639\u0644\u0649 \u0643\u064A\u0641\u0643",
        nameEn: "Ala Kefak Mall",
        type: 'mall',
        cityId: 'sakaka',
        lat: 29.97625,
        lng: 40.21262
    },
    {
        id: 'downtown',
        name: "\u0633\u0648\u0642 \u062F\u0627\u0648\u0646 \u062A\u0627\u0648\u0646",
        nameEn: "Downtown Market",
        type: 'market',
        cityId: 'sakaka',
        lat: 29.95638,
        lng: 40.20963
    },
    {
        id: 'jouf_square',
        name: "\u0633\u0643\u0648\u064A\u0631 \u0627\u0644\u062C\u0648\u0641",
        nameEn: "Jouf Square",
        type: 'mall',
        cityId: 'sakaka',
        lat: 29.97628,
        lng: 40.21388
    },
    {
        id: 'samina',
        name: "\u0633\u0648\u0642 \u0633\u0645\u064A\u0646\u0627",
        nameEn: "Samina Market",
        type: 'market',
        cityId: 'sakaka',
        lat: 29.95852,
        lng: 40.19388
    },
    // ++ samitah
    {
        id: 'al_burhan',
        name: "\u0627\u0644\u0628\u0631\u0647\u0627\u0646 \u0645\u0648\u0644",
        nameEn: "Al Burhan Mall",
        type: 'mall',
        cityId: 'samitah',
        lat: 16.60476,
        lng: 42.93732
    },
    // ++ shakra
    {
        id: 'al_andalus_commercial',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0623\u0646\u062F\u0644\u0633 \u0627\u0644\u062A\u062C\u0627\u0631\u064A",
        nameEn: "Al Andalus Commercial Market",
        type: 'market',
        cityId: 'shakra',
        lat: 25.24348,
        lng: 45.25844
    },
    {
        id: 'shaqra_commercial',
        name: "\u0633\u0648\u0642 \u0634\u0642\u0631\u0627\u0621 \u0627\u0644\u062A\u062C\u0627\u0631\u064A",
        nameEn: "Shaqra Commercial Souq",
        type: 'mall',
        cityId: 'shakra',
        lat: 25.25182,
        lng: 45.25584
    },
    {
        id: 'vegetable_and_meat',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631 \u0648\u0627\u0644\u0644\u062D\u0648\u0645",
        nameEn: "Vegetable and Meat Market",
        type: 'market',
        cityId: 'shakra',
        lat: 25.24551,
        lng: 45.2601
    },
    // ++ tabuk_city
    {
        id: 'al_hokair',
        name: "\u0627\u0644\u062D\u0643\u064A\u0631 \u0645\u0648\u0644",
        nameEn: "Al Hokair Mall",
        type: 'mall',
        cityId: 'tabuk_city',
        lat: 28.39513,
        lng: 36.54863
    },
    {
        id: 'al_raqi',
        name: "\u0627\u0644\u0631\u0627\u0642\u064A \u0645\u0648\u0644",
        nameEn: "Al Raqi Mall",
        type: 'mall',
        cityId: 'tabuk_city',
        lat: 28.36265,
        lng: 36.56715
    },
    {
        id: 'al_sannabel',
        name: "\u0627\u0644\u0633\u0646\u0627\u0628\u0644 \u0645\u0648\u0644",
        nameEn: "Al Sannabel Mall",
        type: 'mall',
        cityId: 'tabuk_city',
        lat: 28.38679,
        lng: 36.56383
    },
    {
        id: 'central_marketplace',
        name: "\u0627\u0644\u0633\u0648\u0642 \u0627\u0644\u0645\u0631\u0643\u0632\u064A (\u0633\u0648\u0642 \u0634\u0639\u0628\u064A)",
        nameEn: "Central Marketplace",
        type: 'market',
        cityId: 'tabuk_city',
        lat: 28.40525,
        lng: 36.53974
    },
    {
        id: 'park_mall_tabuk_park',
        name: "\u0628\u0627\u0631\u0643 \u0645\u0648\u0644",
        nameEn: "Park Mall (Tabuk Park)",
        type: 'mall',
        cityId: 'tabuk_city',
        lat: 28.42928,
        lng: 36.57293
    },
    {
        id: 'vegetable_market_souk_khodra',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631",
        nameEn: "Vegetable Market (Souk Khodra)",
        type: 'market',
        cityId: 'tabuk_city',
        lat: 28.40407,
        lng: 36.53963
    },
    // ++ taif
    {
        id: 'central_fish',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0633\u0645\u0643 \u0627\u0644\u0645\u0631\u0643\u0632\u064A",
        nameEn: "Central Fish Market",
        type: 'market',
        cityId: 'taif',
        lat: 21.27214,
        lng: 40.4063
    },
    {
        id: 'souq_al_anqari',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0639\u0646\u0642\u0631\u064A",
        nameEn: "Souq Al Anqari",
        type: 'market',
        cityId: 'taif',
        lat: 21.27306,
        lng: 40.43041
    },
    {
        id: 'souq_al_obeikan',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0639\u0628\u064A\u0643\u0627\u0646",
        nameEn: "Souq Al Obeikan",
        type: 'market',
        cityId: 'taif',
        lat: 21.27395,
        lng: 40.42407
    },
    {
        id: 'taif_international',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0637\u0627\u0626\u0641 \u0627\u0644\u062F\u0648\u0644\u064A",
        nameEn: "Taif International Mall",
        type: 'mall',
        cityId: 'taif',
        lat: 21.27248,
        lng: 40.43202
    },
    {
        id: 'tera',
        name: "\u062A\u064A\u0631\u0627 \u0645\u0648\u0644",
        nameEn: "Tera Mall",
        type: 'mall',
        cityId: 'taif',
        lat: 21.27955,
        lng: 40.44451
    },
    // ++ turayf
    {
        id: 'othaim_markets_turaif',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0627\u0644\u0639\u062B\u064A\u0645 \u0637\u0631\u064A\u0641",
        nameEn: "Othaim Markets Turaif",
        type: 'market',
        cityId: 'turayf',
        lat: 31.67789,
        lng: 38.67636
    },
    // ++ ula
    {
        id: 'vegetable_market_alula',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631",
        nameEn: "Vegetable Market (AlUla)",
        type: 'market',
        cityId: 'ula',
        lat: 26.60796,
        lng: 37.92485
    },
    // ++ umluj
    {
        id: 'al_olayan',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0639\u0644\u064A\u0627\u0646",
        nameEn: "Al Olayan Market",
        type: 'market',
        cityId: 'umluj',
        lat: 25.03464,
        lng: 37.26026
    },
    // ++ unaizah
    {
        id: 'al_othaim_mall_unaizah',
        name: "\u0627\u0644\u0639\u062B\u064A\u0645 \u0645\u0648\u0644 \u0639\u0646\u064A\u0632\u0629",
        nameEn: "Al Othaim Mall Unaizah",
        type: 'mall',
        cityId: 'unaizah',
        lat: 26.10741,
        lng: 43.9946
    },
    {
        id: 'onaizah_dates',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062A\u0645\u0648\u0631 \u0628\u0639\u0646\u064A\u0632\u0629",
        nameEn: "Onaizah Dates Market",
        type: 'market',
        cityId: 'unaizah',
        lat: 26.11218,
        lng: 44.02987
    },
    {
        id: 'onaizah_friday',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062C\u0645\u0639\u0629 \u0628\u0639\u0646\u064A\u0632\u0629",
        nameEn: "Onaizah Friday Market",
        type: 'market',
        cityId: 'unaizah',
        lat: 26.11258,
        lng: 44.02515
    },
    // ++ uwayqilah
    {
        id: 'abdullah_al_othaim_markets_uwayqilah',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0639\u0628\u062F\u0627\u0644\u0644\u0647 \u0627\u0644\u0639\u062B\u064A\u0645 \u0627\u0644\u0639\u0648\u064A\u0642\u064A\u0644\u0629",
        nameEn: "Abdullah Al-Othaim Markets Uwayqilah",
        type: 'market',
        cityId: 'uwayqilah',
        lat: 30.3504,
        lng: 42.2441
    },
    // ++ wadi_ad_dawasir
    {
        id: 'al_liddam_general',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0644\u062F\u0627\u0645 \u0627\u0644\u0639\u0627\u0645",
        nameEn: "Al Liddam General Souq",
        type: 'market',
        cityId: 'wadi_ad_dawasir',
        lat: 20.46834,
        lng: 44.79115
    },
    {
        id: 'dates',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062A\u0645\u0648\u0631",
        nameEn: "Dates Souq",
        type: 'market',
        cityId: 'wadi_ad_dawasir',
        lat: 20.46767,
        lng: 44.7904
    },
    {
        id: 'popular',
        name: "\u0627\u0644\u0633\u0648\u0642 \u0627\u0644\u0634\u0639\u0628\u064A",
        nameEn: "Popular Souq",
        type: 'market',
        cityId: 'wadi_ad_dawasir',
        lat: 20.4678,
        lng: 44.79102
    },
    {
        id: 'sahara_central_markets',
        name: "\u0623\u0633\u0648\u0627\u0642 \u0627\u0644\u0635\u062D\u0627\u0631\u0649 \u0627\u0644\u0645\u0631\u0643\u0632\u064A\u0629",
        nameEn: "Sahara Central Markets",
        type: 'market',
        cityId: 'wadi_ad_dawasir',
        lat: 20.46119,
        lng: 44.78082
    },
    {
        id: 'vegetable_and_fruit_wadi_ad_dawasir',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631 \u0648\u0627\u0644\u0641\u0648\u0627\u0643\u0647",
        nameEn: "Vegetable and Fruit Market",
        type: 'market',
        cityId: 'wadi_ad_dawasir',
        lat: 20.46936,
        lng: 44.78333
    },
    // ++ yanbu
    {
        id: 'al_jawhara',
        name: "\u0627\u0644\u062C\u0648\u0647\u0631\u0629 \u0645\u0648\u0644",
        nameEn: "Al Jawhara Mall",
        type: 'mall',
        cityId: 'yanbu',
        lat: 24.01506,
        lng: 38.19835
    },
    {
        id: 'al_nakheel',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0646\u062E\u064A\u0644",
        nameEn: "Al Nakheel Market",
        type: 'market',
        cityId: 'yanbu',
        lat: 24.01428,
        lng: 38.19323
    },
    {
        id: 'al_rabiah',
        name: "\u0627\u0644\u0631\u0627\u0628\u064A\u0629 \u0645\u0648\u0644",
        nameEn: "Al Rabiah Mall",
        type: 'mall',
        cityId: 'yanbu',
        lat: 24.10258,
        lng: 38.03175
    },
    {
        id: 'dana',
        name: "\u062F\u0627\u0646\u0627 \u0645\u0648\u0644",
        nameEn: "Dana Mall",
        type: 'mall',
        cityId: 'yanbu',
        lat: 24.03318,
        lng: 38.19359
    },
    {
        id: 'fish',
        name: "\u0633\u0648\u0642 \u0627\u0644\u0633\u0645\u0643",
        nameEn: "Fish Market",
        type: 'market',
        cityId: 'yanbu',
        lat: 24.07426,
        lng: 38.05381
    },
    {
        id: 'miro',
        name: "\u0645\u064A\u0631\u0648 \u0645\u0648\u0644",
        nameEn: "Miro Mall",
        type: 'mall',
        cityId: 'yanbu',
        lat: 24.02461,
        lng: 38.22315
    },
    {
        id: 'royal_plaza_shopping',
        name: "\u0645\u0631\u0643\u0632 \u062A\u0633\u0648\u0642 \u0631\u0648\u064A\u0627\u0644 \u0628\u0644\u0627\u0632\u0627",
        nameEn: "Royal Plaza Shopping Center",
        type: 'mall',
        cityId: 'yanbu',
        lat: 24.08543,
        lng: 38.05612
    },
    // ++ zulfi
    {
        id: 'central',
        name: "\u0627\u0644\u0633\u0648\u0642 \u0627\u0644\u0645\u0631\u0643\u0632\u064A",
        nameEn: "Central Market",
        type: 'market',
        cityId: 'zulfi',
        lat: 26.29625,
        lng: 44.80762
    },
    {
        id: 'city_zulfi',
        name: "\u0633\u062A\u064A \u0645\u0648\u0644",
        nameEn: "City Mall",
        type: 'mall',
        cityId: 'zulfi',
        lat: 26.29335,
        lng: 44.80743
    },
    {
        id: 'vegetable_and_dates',
        name: "\u0633\u0648\u0642 \u0627\u0644\u062E\u0636\u0627\u0631 \u0648\u0627\u0644\u062A\u0645\u0648\u0631",
        nameEn: "Vegetable and Dates Market",
        type: 'market',
        cityId: 'zulfi',
        lat: 26.29472,
        lng: 44.8086
    }
];
const $9ec848631800ed29$export$b8de75f2fd4fbd02 = [
    {
        id: 'm1',
        name: "\u0645\u062D\u0644 \u0627\u0644\u0623\u0646\u0627\u0642\u0629",
        rating: 4.8,
        lat: 24.7669,
        lng: 46.6806,
        address: "\u0627\u0644\u0646\u062E\u064A\u0644 \u0645\u0648\u0644\u060C \u0627\u0644\u0631\u064A\u0627\u0636"
    },
    {
        id: 'store_2',
        name: "\u0639\u0637\u0648\u0631 \u0628\u0627\u0631\u064A\u0633",
        rating: 4.5,
        lat: 24.7578,
        lng: 46.6300,
        address: "\u0627\u0644\u0631\u064A\u0627\u0636 \u0628\u0627\u0631\u0643\u060C \u0627\u0644\u0631\u064A\u0627\u0636"
    },
    {
        id: 'store_3',
        name: "\u0623\u0632\u064A\u0627\u0621 \u0627\u0644\u0634\u0631\u0642",
        rating: 4.7,
        lat: 24.6907,
        lng: 46.6653,
        address: "\u0627\u0644\u0631\u064A\u0627\u0636 \u062C\u0627\u0644\u064A\u0631\u064A\u060C \u0627\u0644\u0631\u064A\u0627\u0636"
    },
    {
        id: 'store_4',
        name: "\u062A\u0642\u0646\u064A\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644",
        rating: 4.9,
        lat: 24.7003,
        lng: 46.6842,
        address: "\u0628\u0627\u0646\u0648\u0631\u0627\u0645\u0627 \u0645\u0648\u0644\u060C \u0627\u0644\u0631\u064A\u0627\u0636"
    },
    {
        id: 'store_5',
        name: "\u0645\u0637\u0639\u0645 \u0627\u0644\u0628\u064A\u062A \u0627\u0644\u0633\u0639\u0648\u062F\u064A",
        rating: 4.6,
        lat: 21.6274,
        lng: 39.1185,
        address: "\u0631\u062F \u0633\u064A \u0645\u0648\u0644\u060C \u062C\u062F\u0629"
    },
    {
        id: 'store_6',
        name: "\u0631\u064A\u0627\u0636\u0629 \u0627\u0644\u0623\u0628\u0637\u0627\u0644",
        rating: 4.4,
        lat: 21.5834,
        lng: 39.1461,
        address: "\u0645\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u060C \u062C\u062F\u0629"
    },
    {
        id: 'store_7',
        name: "\u0643\u0648\u0641\u064A \u062A\u0627\u064A\u0645",
        rating: 4.8,
        lat: 26.4193,
        lng: 50.0888,
        address: "\u0627\u0644\u0646\u062E\u064A\u0644 \u0645\u0648\u0644\u060C \u0627\u0644\u062F\u0645\u0627\u0645"
    },
    {
        id: 'store_8',
        name: "\u0623\u062B\u0627\u062B \u0627\u0644\u0645\u0646\u0632\u0644 \u0627\u0644\u0639\u0635\u0631\u064A",
        rating: 4.3,
        lat: 26.2812,
        lng: 50.1900,
        address: "\u0627\u0644\u0631\u0627\u0634\u062F \u0645\u064A\u063A\u0627 \u0645\u0648\u0644\u060C \u0627\u0644\u062E\u0628\u0631"
    },
    {
        id: 'store_9',
        name: "\u0633\u0648\u0628\u0631\u0645\u0627\u0631\u0643\u062A \u0627\u0644\u062E\u064A\u0631",
        rating: 4.5,
        lat: 24.4671,
        lng: 39.6024,
        address: "\u0627\u0644\u0646\u0648\u0631 \u0645\u0648\u0644\u060C \u0627\u0644\u0645\u062F\u064A\u0646\u0629"
    },
    {
        id: 'store_10',
        name: "\u0645\u0644\u0627\u0628\u0633 \u0627\u0644\u0635\u063A\u0627\u0631",
        rating: 4.7,
        lat: 18.2295,
        lng: 42.5020,
        address: "\u0623\u0628\u0647\u0627 \u0645\u0648\u0644\u060C \u0623\u0628\u0647\u0627"
    }
];
const $9ec848631800ed29$export$33e59afb97a56e0a = {
    lat: 24.7136,
    lng: 46.6753
};
const $9ec848631800ed29$export$e7fd20fad3cf4b5f = (id)=>$9ec848631800ed29$export$9396c9157495b4d.find((l)=>l.id === id);
const $9ec848631800ed29$export$a7423564503d66c = (id)=>$9ec848631800ed29$export$f03f7c19d8f50e16.find((c)=>c.id === id);
const $9ec848631800ed29$export$d4a625cede2da71b = (id)=>$9ec848631800ed29$export$36b79d2b85570e14.find((r)=>r.id === id);
const $9ec848631800ed29$export$bee660cf687be4d1 = (next)=>{
    if (!Array.isArray(next) || next.length === 0) return;
    $9ec848631800ed29$export$9396c9157495b4d.length = 0;
    $9ec848631800ed29$export$9396c9157495b4d.push(...next);
};
const $9ec848631800ed29$export$67ff3b7b3f2ff4f9 = (item, language)=>language === 'en' && item?.nameEn ? item.nameEn : item?.name || '';
const $9ec848631800ed29$export$6fec604aa7293d0c = (id)=>$9ec848631800ed29$export$b8de75f2fd4fbd02.find((s)=>s.id === id);

});

parcelRegister("hYmNv", function(module, exports) {

$parcel$export(module.exports, "readRememberedFix", function () { return $a9bce6c0c2067139$export$e78922ec4b403d7e; });
$parcel$export(module.exports, "rememberFix", function () { return $a9bce6c0c2067139$export$78d659f19444738c; });
$parcel$export(module.exports, "forgetFix", function () { return $a9bce6c0c2067139$export$42b1fbb5d606ef97; });
$parcel$export(module.exports, "isFreshFix", function () { return $a9bce6c0c2067139$export$d229e70607dcbc74; });
/**
 * ذاكرة الموقع (v13.79) — «اسأل مرة واحدة، ثم اعرف».
 *
 * بلاغ ناصر: «في كل مرة أطلب يطلبني أفعّل الموقع… أريده مثل تطبيقات التوصيل».
 * السبب لم يكن الصلاحية نفسها — المتصفح يتذكّرها — بل أن التطبيق كان **ينسى
 * الإحداثيات** عند كل فتح: `liveLocation` يبدأ `null` في كل جلسة، فكل صفحة
 * تعتمد عليه (تفاصيل العرض، حولي، المسافات) تعرض دعوة «فعّل موقعك» في أول
 * ثوانٍ — أو دائماً إن كان داخل مبنى ولم يصل تثبيت GPS.
 *
 * الحلّ هو ما تفعله تطبيقات التوصيل بالضبط: **آخر موقع معروف يُحفظ محلياً**
 * ويُستعاد فوراً عند الفتح، فيبدأ التطبيق عارفاً أين المستخدم بلا سؤال ولا
 * انتظار، ثم يصحّحه المتتبّع الحيّ خلال ثوانٍ حين يصل تثبيت جديد.
 *
 * خصوصية: البيانات محليّة على الجهاز فقط (`localStorage`)، ولا تُرسل من هنا
 * إلى أي خادم — الكتابة إلى `users.lat/lng` تبقى في `AppContext` وللمشتري فقط.
 * ومسح بيانات المتصفح أو رفض الصلاحية يمسحها (`forgetFix`).
 */ const $a9bce6c0c2067139$var$FIX_KEY = 'taki_last_fix';
/** بعد شهر يصير الموقع المحفوظ تخميناً لا معلومة — نتجاهله ونسأل من جديد. */ const $a9bce6c0c2067139$var$MAX_AGE_MS = 2592000000;
const $a9bce6c0c2067139$export$9636dbb17ecc1782 = 600000;
const $a9bce6c0c2067139$var$isCoord = (lat, lng)=>typeof lat === 'number' && typeof lng === 'number' && Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(lat === 0 && lng === 0); // (0,0) في المحيط = قراءة فاسدة لا موقع
const $a9bce6c0c2067139$export$e78922ec4b403d7e = ()=>{
    try {
        const raw = localStorage.getItem($a9bce6c0c2067139$var$FIX_KEY);
        if (!raw) return null;
        const f = JSON.parse(raw);
        if (!f || !$a9bce6c0c2067139$var$isCoord(f.lat, f.lng)) return null;
        const at = typeof f.at === 'number' && Number.isFinite(f.at) ? f.at : 0;
        if (at && Date.now() - at > $a9bce6c0c2067139$var$MAX_AGE_MS) return null;
        return {
            lat: f.lat,
            lng: f.lng,
            at: at
        };
    } catch  {
        return null; // وضع خاص / حصة ممتلئة — نكمل بلا ذاكرة
    }
};
const $a9bce6c0c2067139$export$78d659f19444738c = (lat, lng)=>{
    if (!$a9bce6c0c2067139$var$isCoord(lat, lng)) return;
    try {
        localStorage.setItem($a9bce6c0c2067139$var$FIX_KEY, JSON.stringify({
            lat: lat,
            lng: lng,
            at: Date.now()
        }));
    } catch  {}
};
const $a9bce6c0c2067139$export$42b1fbb5d606ef97 = ()=>{
    try {
        localStorage.removeItem($a9bce6c0c2067139$var$FIX_KEY);
    } catch  {}
};
const $a9bce6c0c2067139$export$d229e70607dcbc74 = (at)=>!!at && Date.now() - at <= $a9bce6c0c2067139$export$9636dbb17ecc1782;

});

parcelRegister("12MXM", function(module, exports) {

$parcel$export(module.exports, "PLATFORM_SETTING_KEYS", function () { return $1fa8bd30317e87d8$export$76e74c7dec0945e1; });
$parcel$export(module.exports, "defaultPlatformSettings", function () { return $1fa8bd30317e87d8$export$bddf8a20fa4ed56b; });
$parcel$export(module.exports, "applyPlatformSetting", function () { return $1fa8bd30317e87d8$export$9db371ef8f7b57ee; });
$parcel$export(module.exports, "applySeasonSkin", function () { return $1fa8bd30317e87d8$export$cb2f99e845cc03a6; });
/**
 * platformSettings — إعدادات المنصّة: نوعُها وافتراضاتُها وقارئُها (v14.92)
 * ═══════════════════════════════════════════════════════════════════════════
 * كانت هذه كلها داخل `AppContext.tsx` — والسقّافة (`check-file-size.js`) تمنع
 * نموّه سطراً واحداً عمداً: ملفٌّ لا يُقرأ في جلسةٍ واحدة يصير التعديل فيه
 * تخميناً. فحين احتاج إعدادُ مهلة الشكاوى مكاناً، كان الصواب **تقليصه** لا
 * رفع سقفه.
 *
 * وهنا مصدرٌ واحد لثلاثة أشياء كانت متفرّقة ومعرّضة للانحراف:
 *   • النوع (كان مكتوباً مرّتين: في واجهة السياق وفي `useState`)،
 *   • الافتراضات،
 *   • **وقائمة المفاتيح المجلوبة** — 🪤 وقد انحرفت فعلاً: `complaints_sla_hours`
 *     كان له فرعُ تطبيقٍ ولم يكن في قائمة الجلب الأوّل، فما كان يصل إلا إن
 *     غيّره المدير أثناء فتح الصفحة. الآن القائمة تُشتقّ من نفس الجدول.
 */ 
var $inbzl = parcelRequire("inbzl");

var $3rEkS = parcelRequire("3rEkS");
const $1fa8bd30317e87d8$export$76e74c7dec0945e1 = [
    'oauth_google_enabled',
    'oauth_apple_enabled',
    'telegram_bot_enabled',
    'whatsapp_bot_enabled',
    'whatsapp_bot_number',
    'seasonal_theme',
    'season_campaign',
    'sponsor_layout',
    'banner_autoplay_seconds',
    'booking_holds',
    'merchant_vat',
    'complaints_sla_hours',
    'chat_limits',
    'verification',
    'refund_window',
    'stock_link_enabled'
];
/**
 * رقمٌ ضمن مجال، وإلا الافتراضي. القيمة قد تصل نصّاً من jsonb.
 * 🪤 `exclusiveLo` ليست زينة: مهلة الحجز كانت `n > 0` لا `n >= 0`، وصفرُ ساعةٍ
 *    مهلةٌ منتهية قبل أن تبدأ.
 * 🪤 وتُقرأ بـ`parseFloat` لا `Number()`: `Number(null)` صفرٌ صالح — فنسبة
 *    ضريبةٍ `null` كانت ستصير **٠٪** بدل الافتراضي ١٥٪ (خطأٌ يصمت).
 */ const $1fa8bd30317e87d8$var$num = (x, d, lo, hi, exclusiveLo = false)=>{
    const n = typeof x === 'number' ? x : parseFloat(String(x ?? ''));
    if (!Number.isFinite(n) || n > hi) return d;
    return (exclusiveLo ? n > lo : n >= lo) ? n : d;
};
const $1fa8bd30317e87d8$export$bddf8a20fa4ed56b = (seasonalTheme = '')=>({
        oauthGoogleEnabled: false,
        oauthAppleEnabled: false,
        telegramBotEnabled: true,
        whatsappBotEnabled: false,
        whatsappBotNumber: '',
        seasonalTheme: seasonalTheme,
        seasonCampaign: null,
        sponsorLayout: (0, $3rEkS.DEFAULT_SPONSOR_LAYOUT),
        bannerSeconds: 2,
        bookingHolds: {
            pickupHours: 2,
            deliveryHours: 6,
            selfCloseMinutes: 10
        },
        merchantVatRate: 15,
        complaintsSlaHours: 24,
        chatLimits: {
            perBooking: 0,
            perHour: 120
        },
        verification: {
            mode: 'off',
            slaHours: 24,
            vacation: false,
            showBadge: false
        },
        refundWindow: {
            hours: 2,
            merchantButton: true
        },
        // 🔴 مطفأ افتراضياً: فشلٌ مغلق — غيابُ الصفّ يعني مخفيّاً لا ظاهراً.
        stockLinkEnabled: false
    });
const $1fa8bd30317e87d8$export$9db371ef8f7b57ee = (key, value)=>{
    switch(key){
        case 'oauth_google_enabled':
            return (prev)=>({
                    ...prev,
                    oauthGoogleEnabled: value === true
                });
        case 'oauth_apple_enabled':
            return (prev)=>({
                    ...prev,
                    oauthAppleEnabled: value === true
                });
        case 'telegram_bot_enabled':
            return (prev)=>({
                    ...prev,
                    telegramBotEnabled: value === true
                });
        case 'whatsapp_bot_enabled':
            return (prev)=>({
                    ...prev,
                    whatsappBotEnabled: value === true
                });
        case 'whatsapp_bot_number':
            // رقم واتساب الرسمي (أرقام فقط، مثل "9665…"). يبني رابط wa.me،
            // وفراغُه يُخفي الزرّ بدل أن يفتح رابطاً معطوباً (درس v14.77).
            return (prev)=>({
                    ...prev,
                    whatsappBotNumber: typeof value === 'string' ? value.replace(/\D/g, '') : ''
                });
        case 'seasonal_theme':
            // v12.44 — «هوية المواسم»: يختار المالك موسماً فتتبدّل كل الصفحات
            // المفتوحة لحظياً. الجلد نفسه CSS خالص مفتاحه <html data-season>.
            return (prev)=>({
                    ...prev,
                    seasonalTheme: typeof value === 'string' ? value : ''
                });
        case 'season_campaign':
            // v12.48 — «حملة الموسم»: نوافذ التجار/العامة لصفحة عروض الموسم.
            return (prev)=>({
                    ...prev,
                    seasonCampaign: (0, $inbzl.parseSeasonCampaign)(value)
                });
        case 'sponsor_layout':
            // v12.50 — «تحكم ترتيب الرعاة»: نمط ظهور الإعلانات في القوائم.
            return (prev)=>({
                    ...prev,
                    sponsorLayout: (0, $3rEkS.parseSponsorLayout)(value)
                });
        case 'booking_holds':
            // v14.10 — مهلة الحجز: استلام · توصيل. الرقم الوحيد في المنصّة كلها،
            // تقرؤه الواجهة والقاعدة والبوتان من هنا، ويسري تغييره بلا نشر.
            return (prev)=>({
                    ...prev,
                    bookingHolds: {
                        pickupHours: $1fa8bd30317e87d8$var$num((value || {}).pickup_hours, 2, 0, 8760, true),
                        deliveryHours: $1fa8bd30317e87d8$var$num((value || {}).delivery_hours, 6, 0, 8760, true),
                        // v15.42 — صفرٌ مقبولٌ هنا (يُعطّل المهلة عمداً)، فـ`exclusiveLo`
                        // مُطفأة — عكسَ الساعات حيث صفرٌ مهلةٌ منتهيةٌ قبل أن تبدأ.
                        selfCloseMinutes: $1fa8bd30317e87d8$var$num((value || {}).self_close_minutes, 10, 0, 1440)
                    }
                });
        case 'merchant_vat':
            // v14.17 — نسبة ضريبة طلبات التجار. للعرض فقط (حاسبة التاجر)؛
            // الفاتورة نفسها تحمل نسبتها مجمّدة من لحظة البيع.
            return (prev)=>({
                    ...prev,
                    merchantVatRate: $1fa8bd30317e87d8$var$num((value || {}).rate, 15, 0, 100)
                });
        case 'complaints_sla_hours':
            // v14.92 — كم ساعةً نَعِد بالردّ خلالها على الشكوى.
            return (prev)=>({
                    ...prev,
                    complaintsSlaHours: $1fa8bd30317e87d8$var$num(value, 24, 1, 720)
                });
        case 'chat_limits':
            // v14.93 — حدود المحادثة. 0 في per_booking = بلا حدّ، فلا يُقصّ
            // بـGREATEST إلى 1؛ والقاعدة هي الحَكَم دائماً وهذا للعرض فقط.
            return (prev)=>({
                    ...prev,
                    chatLimits: {
                        perBooking: $1fa8bd30317e87d8$var$num((value || {}).per_booking, 0, 0, 1000),
                        perHour: $1fa8bd30317e87d8$var$num((value || {}).per_hour, 120, 1, 10000)
                    }
                });
        case 'verification':
            {
                // v14.95 — وضعٌ غير معروف يُقرأ `off`: الافتراضُ الآمن ألّا نمنع أحداً.
                const v = value || {};
                const mode = [
                    'off',
                    'advisory',
                    'required'
                ].includes(v.mode) ? v.mode : 'off';
                return (prev)=>({
                        ...prev,
                        verification: {
                            mode: mode,
                            slaHours: $1fa8bd30317e87d8$var$num(v.sla_hours, 24, 1, 720),
                            vacation: v.vacation === true,
                            showBadge: v.show_badge === true
                        }
                    });
            }
        case 'refund_window':
            {
                // v14.97 — نافذة الاسترداد المضمون + مفتاح زرّ التاجر. يطابق
                // `taki_refund_policy()` على القاعدة قصّاً وافتراضاً (٠‑٧٢٠ ساعة).
                // 🪤 والصفر مسموحٌ عمداً (`exclusiveLo=false`): «لا نافذة معلنة»
                //    حالةٌ صالحة تُخفي جملة الضمان، لا قيمةٌ فاسدة تُقصّ إلى ساعتين.
                const v = value || {};
                return (prev)=>({
                        ...prev,
                        refundWindow: {
                            hours: $1fa8bd30317e87d8$var$num(v.hours, 2, 0, 720),
                            merchantButton: typeof v.merchant_button === 'boolean' ? v.merchant_button : true
                        }
                    });
            }
        case 'stock_link_enabled':
            // v15.25 — إظهارُ بطاقة ربط المخزون للتجّار، بيد ناصر.
            // 🪤 `=== true` لا `!== false`: البوتُ «يفشل مفتوحاً» لأنه خدمةٌ
            //    قائمة، وهذه ميزةٌ **لم تُؤكَّد بعد** فتفشل **مغلقة**.
            return (prev)=>({
                    ...prev,
                    stockLinkEnabled: value === true
                });
        case 'banner_autoplay_seconds':
            // v12.71 — سرعة تنقّل بانر الرئيسية بيد المدير (الافتراضي ثانيتان).
            return (prev)=>({
                    ...prev,
                    bannerSeconds: $1fa8bd30317e87d8$var$num(value, 2, 1, 120)
                });
        default:
            return null;
    }
};
const $1fa8bd30317e87d8$export$cb2f99e845cc03a6 = (value)=>{
    const seasonId = typeof value === 'string' ? value : '';
    try {
        if (seasonId) {
            document.documentElement.setAttribute('data-season', seasonId);
            localStorage.setItem('TAKI_SEASON', seasonId);
        } else {
            document.documentElement.removeAttribute('data-season');
            localStorage.removeItem('TAKI_SEASON');
        }
    } catch  {}
};

});
parcelRegister("inbzl", function(module, exports) {

$parcel$export(module.exports, "SEASONS", function () { return $821d50b4afd56845$export$dea41471f21a81e5; });
$parcel$export(module.exports, "getSeasonById", function () { return $821d50b4afd56845$export$5cdd50c7729dc328; });
$parcel$export(module.exports, "parseSeasonCampaign", function () { return $821d50b4afd56845$export$47cdeb3c81d2adc7; });
$parcel$export(module.exports, "seasonHeroTexts", function () { return $821d50b4afd56845$export$efdbf0a37e0dd0d2; });
$parcel$export(module.exports, "campaignSellerOpen", function () { return $821d50b4afd56845$export$fc9598f3bf4ffa2b; });
$parcel$export(module.exports, "campaignPublicLive", function () { return $821d50b4afd56845$export$6a526fa1cc46c0bb; });
// v12.44 — «هوية المواسم»: تعريف المواسم السعودية. الـCSS في styles.css يقرأ
// data-season على <html> ويبدّل هوية الألوان كاملة (فاتح + داكن)، وتصل لكل
// الأجهزة عبر realtime على platform_settings.seasonal_theme.
// v12.57 — توحيد (طلب ناصر): لم يعد التفعيل يدوياً — القاعدة تشتق
// seasonal_theme تلقائياً من النافذة العامة لحملة الموسم (season_campaign):
// trigger عند حفظ/إنهاء الحملة + كرون taki-season-theme-sync كل ١٥ دقيقة
// (تفعيل/إطفاء منتصف الليل). البوتان يتبعان نفس المفتاح عبر bot_active_season.
// v12.45 — فصل «العيد» عن «رمضان» بهوية مستقلة + إعدادات «عمق الموسم» (fx):
// عناصر متحركة تملأ الشاشة كلها (فوانيس تهبط في رمضان، شموس في الصيف،
// بالونات تصعد في العيد…) عبر SeasonFX.tsx — نفس المعرّفات تُستخدم نصياً
// في البوتين (server/lib/season.js) فأبقِ القائمتين متطابقتي المعرّفات.
const $821d50b4afd56845$export$dea41471f21a81e5 = [
    {
        id: 'ramadan',
        emoji: "\uD83C\uDFEE",
        ar: "\u0631\u0645\u0636\u0627\u0646",
        en: 'Ramadan',
        taglineAr: "\u0647\u0644\u0651 \u0627\u0644\u0634\u0647\u0631\u2026 \u0639\u0631\u0648\u0636 \u0627\u0644\u0633\u062D\u0648\u0631 \u0648\u0627\u0644\u0645\u0644\u0627\u0628\u0633 \u0648\u0645\u0633\u062A\u0644\u0632\u0645\u0627\u062A \u0631\u0645\u0636\u0627\u0646 \u0641\u064A \u0645\u0643\u0627\u0646 \u0648\u0627\u062D\u062F.",
        taglineEn: "Ramadan is here \u2014 suhoor, fashion and essentials deals in one place.",
        hintAr: "\u0634\u0647\u0631 \u0631\u0645\u0636\u0627\u0646 (\u064A\u062A\u0642\u062F\u0651\u0645 ~\u0661\u0661 \u064A\u0648\u0645\u0627\u064B \u0643\u0644 \u0633\u0646\u0629)",
        swatch: 'linear-gradient(130deg, #4c1d95, #7c3aed 55%, #c026d3)',
        fx: {
            mode: 'fall',
            items: [
                "\uD83C\uDFEE",
                "\uD83C\uDF19",
                "\uD83C\uDFEE",
                "\u2728",
                "\uD83C\uDFEE"
            ]
        }
    },
    {
        id: 'eid',
        emoji: "\uD83C\uDF89",
        ar: "\u0627\u0644\u0639\u064A\u062F",
        en: 'Eid',
        taglineAr: "\u0639\u064A\u062F\u0643\u0645 \u0645\u0628\u0627\u0631\u0643\u2026 \u0627\u0644\u0639\u064A\u062F\u064A\u0627\u062A \u0648\u0627\u0644\u0647\u062F\u0627\u064A\u0627 \u0648\u0639\u0631\u0648\u0636 \u0627\u0644\u0639\u064A\u062F \u0648\u0635\u0644\u062A.",
        taglineEn: "Eid Mubarak \u2014 gifts, Eidiyah and celebration deals have arrived.",
        hintAr: "\u0639\u064A\u062F \u0627\u0644\u0641\u0637\u0631 \u0648\u0639\u064A\u062F \u0627\u0644\u0623\u0636\u062D\u0649 \u2014 \u0641\u0639\u0651\u0644\u0647 \u0644\u064A\u0644\u0629 \u0627\u0644\u0639\u064A\u062F",
        swatch: 'linear-gradient(130deg, #701a75, #c026d3 55%, #f59e0b)',
        fx: {
            mode: 'rise',
            items: [
                "\uD83C\uDF88",
                "\uD83C\uDF81",
                "\uD83C\uDF88",
                "\u2728",
                "\uD83C\uDF89"
            ]
        }
    },
    {
        id: 'founding',
        emoji: "\uD83D\uDC0E",
        ar: "\u064A\u0648\u0645 \u0627\u0644\u062A\u0623\u0633\u064A\u0633",
        en: 'Founding Day',
        taglineAr: "\u064A\u0648\u0645 \u0628\u062F\u064A\u0646\u0627\u2026 \u062E\u0635\u0648\u0645\u0627\u062A \u0628\u0631\u0648\u062D \u0627\u0644\u062A\u0631\u0627\u062B \u0628\u0645\u0646\u0627\u0633\u0628\u0629 \u0662\u0662 \u0641\u0628\u0631\u0627\u064A\u0631.",
        taglineEn: "Founding Day \u2014 heritage-inspired deals for February 22.",
        hintAr: "\u0662\u0662 \u0641\u0628\u0631\u0627\u064A\u0631",
        swatch: 'linear-gradient(130deg, #713f12, #b45309 55%, #d4a24e)',
        fx: {
            mode: 'fall',
            items: [
                "\uD83C\uDF34",
                "\uD83D\uDC2A",
                "\u2728",
                "\uD83C\uDF34"
            ]
        }
    },
    {
        id: 'national',
        emoji: "\uD83C\uDDF8\uD83C\uDDE6",
        ar: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
        en: 'National Day',
        taglineAr: "\u0639\u0632\u0651\u0647\u0627 \u0641\u064A \u0639\u0644\u0627\u0647\u0627\u2026 \u062E\u0635\u0648\u0645\u0627\u062A \u0648\u0637\u0646\u064A\u0629 \u0636\u062E\u0645\u0629 \u0645\u0646 \u0645\u062A\u0627\u062C\u0631 \u0645\u062F\u064A\u0646\u062A\u0643.",
        taglineEn: "National Day \u2014 massive green-day discounts from your city\u2019s stores.",
        hintAr: "\u0662\u0663 \u0633\u0628\u062A\u0645\u0628\u0631",
        swatch: 'linear-gradient(130deg, #064e2b, #0e8544 60%, #25b06b)',
        // v12.47 — طلب ناصر: بدون علم في العناصر النازلة؛ القلب الأخضر يهيمن.
        fx: {
            mode: 'fall',
            items: [
                "\uD83D\uDC9A",
                "\u2728",
                "\uD83D\uDC9A"
            ]
        }
    },
    {
        id: 'school',
        emoji: "\uD83C\uDF92",
        ar: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0644\u0644\u0645\u062F\u0627\u0631\u0633",
        en: 'Back to School',
        taglineAr: "\u0642\u0631\u0637\u0627\u0633\u064A\u0629 \u0648\u0645\u0644\u0627\u0628\u0633 \u0648\u0623\u062D\u0630\u064A\u0629\u2026 \u062C\u0647\u0651\u0632 \u0623\u0637\u0641\u0627\u0644\u0643 \u0628\u0623\u0642\u0644 \u0627\u0644\u0623\u0633\u0639\u0627\u0631.",
        taglineEn: "Stationery, clothes and shoes \u2014 get the kids ready for less.",
        hintAr: "\u0645\u0646\u062A\u0635\u0641 \u0623\u063A\u0633\u0637\u0633 \u2013 \u0623\u0648\u0644 \u0633\u0628\u062A\u0645\u0628\u0631",
        swatch: 'linear-gradient(130deg, #1e3a8a, #3b82f6 60%, #60a5fa)',
        fx: {
            mode: 'fall',
            items: [
                "\uD83D\uDCDA",
                "\u270F\uFE0F",
                "\uD83C\uDF92",
                "\uD83D\uDCD0"
            ]
        }
    },
    {
        id: 'white_friday',
        emoji: "\uD83D\uDECD\uFE0F",
        ar: "\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u0628\u064A\u0636\u0627\u0621",
        en: 'White Friday',
        taglineAr: "\u0630\u0631\u0648\u0629 \u0627\u0644\u062A\u062E\u0641\u064A\u0636\u0627\u062A\u2026 \u062E\u0635\u0648\u0645\u0627\u062A \u062A\u062A\u062C\u0627\u0648\u0632 \u0665\u0660\u066A \u0644\u0641\u062A\u0631\u0629 \u0645\u062D\u062F\u0648\u062F\u0629.",
        taglineEn: "Peak sale season \u2014 50%+ discounts for a limited time.",
        hintAr: "\u0646\u0647\u0627\u064A\u0629 \u0646\u0648\u0641\u0645\u0628\u0631",
        swatch: 'linear-gradient(130deg, #0b0f1a, #331122 50%, #b91c1c)',
        fx: {
            mode: 'fall',
            items: [
                "\uD83C\uDFF7\uFE0F",
                "\uD83D\uDCA5",
                "\uD83D\uDECD\uFE0F",
                "\uD83C\uDFF7\uFE0F"
            ]
        }
    },
    {
        id: 'summer',
        emoji: "\u2600\uFE0F",
        ar: "\u0625\u062C\u0627\u0632\u0629 \u0627\u0644\u0635\u064A\u0641",
        en: 'Summer Break',
        taglineAr: "\u0635\u064A\u0651\u0641 \u0648\u0627\u0631\u062A\u0627\u062D\u2026 \u0639\u0631\u0648\u0636 \u0627\u0644\u0645\u0633\u0627\u0621 \u0648\u0627\u0644\u0645\u0648\u0644\u0627\u062A \u0637\u0648\u0644 \u0627\u0644\u0625\u062C\u0627\u0632\u0629.",
        taglineEn: "Summer break \u2014 evening mall deals all season long.",
        hintAr: "\u064A\u0648\u0646\u064A\u0648 \u2013 \u0623\u063A\u0633\u0637\u0633",
        swatch: 'linear-gradient(130deg, #0d9488, #06b6d4 60%, #fb923c)',
        fx: {
            mode: 'fall',
            items: [
                "\u2600\uFE0F",
                "\u2600\uFE0F",
                "\uD83C\uDF49",
                "\u2600\uFE0F",
                "\uD83D\uDD76\uFE0F"
            ]
        }
    }
];
const $821d50b4afd56845$export$5cdd50c7729dc328 = (id)=>$821d50b4afd56845$export$dea41471f21a81e5.find((s)=>s.id === id);
const $821d50b4afd56845$export$47cdeb3c81d2adc7 = (value)=>{
    if (!value || typeof value !== 'object' || typeof value.season_id !== 'string' || !$821d50b4afd56845$export$5cdd50c7729dc328(value.season_id)) return null;
    return {
        seasonId: value.season_id,
        eventDate: typeof value.event_date === 'string' ? value.event_date : undefined,
        sellerFrom: typeof value.seller_from === 'string' ? value.seller_from : undefined,
        sellerTo: typeof value.seller_to === 'string' ? value.seller_to : undefined,
        publicFrom: typeof value.public_from === 'string' ? value.public_from : undefined,
        publicTo: typeof value.public_to === 'string' ? value.public_to : undefined,
        heroTitleAr: typeof value.hero_title_ar === 'string' ? value.hero_title_ar : undefined,
        heroTitleEn: typeof value.hero_title_en === 'string' ? value.hero_title_en : undefined,
        heroTaglineAr: typeof value.hero_tagline_ar === 'string' ? value.hero_tagline_ar : undefined,
        heroTaglineEn: typeof value.hero_tagline_en === 'string' ? value.hero_tagline_en : undefined
    };
};
const $821d50b4afd56845$export$efdbf0a37e0dd0d2 = (season, campaign, isRTL)=>{
    const pick = (custom, fallback)=>{
        const t = (custom || '').trim();
        return t ? t : fallback;
    };
    const c = campaign && campaign.seasonId === season.id ? campaign : null;
    return isRTL ? {
        title: pick(c?.heroTitleAr, `\u{639}\u{631}\u{648}\u{636} ${season.ar} \u{627}\u{644}\u{62D}\u{635}\u{631}\u{64A}\u{629}`),
        tagline: pick(c?.heroTaglineAr, season.taglineAr)
    } : {
        title: pick(c?.heroTitleEn, `Exclusive ${season.en} Deals`),
        tagline: pick(c?.heroTaglineEn, season.taglineEn)
    };
};
/** تاريخ اليوم المحلي بصيغة YYYY-MM-DD (جمهور المنصة سعودي — توقيت الجهاز كافٍ). */ const $821d50b4afd56845$var$todayStr = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const $821d50b4afd56845$var$inWindow = (from, to)=>{
    if (!from || !to) return false;
    const t = $821d50b4afd56845$var$todayStr();
    return t >= from && t <= to;
};
const $821d50b4afd56845$export$fc9598f3bf4ffa2b = (c)=>!!c && $821d50b4afd56845$var$inWindow(c.sellerFrom, c.sellerTo);
const $821d50b4afd56845$export$6a526fa1cc46c0bb = (c)=>!!c && $821d50b4afd56845$var$inWindow(c.publicFrom, c.publicTo);

});

parcelRegister("3rEkS", function(module, exports) {

$parcel$export(module.exports, "resolveDealLocation", function () { return $6a2912aaef5c381d$export$3e069540d64e8aa5; });
$parcel$export(module.exports, "sponsorLabelText", function () { return $6a2912aaef5c381d$export$ee312f7a6d1a296a; });
$parcel$export(module.exports, "isSponsorActive", function () { return $6a2912aaef5c381d$export$d26b58674e1f9783; });
$parcel$export(module.exports, "getDistance", function () { return $6a2912aaef5c381d$export$79376507b09a66f; });
$parcel$export(module.exports, "DEFAULT_SPONSOR_LAYOUT", function () { return $6a2912aaef5c381d$export$6daa114dde7497ac; });
$parcel$export(module.exports, "parseSponsorLayout", function () { return $6a2912aaef5c381d$export$be8c9d9fed952ca2; });
$parcel$export(module.exports, "interleaveSponsored", function () { return $6a2912aaef5c381d$export$10ed76fb0e969593; });
$parcel$export(module.exports, "isDealComingSoon", function () { return $6a2912aaef5c381d$export$6a044a50fcf6b0d9; });
$parcel$export(module.exports, "dealLifespanStart", function () { return $6a2912aaef5c381d$export$b097b63584dfdb93; });
$parcel$export(module.exports, "isDealExpiredByTime", function () { return $6a2912aaef5c381d$export$8283d38a0fd4115f; });
$parcel$export(module.exports, "formatComingSoonRemaining", function () { return $6a2912aaef5c381d$export$4684c03c0d2beb4d; });
$parcel$export(module.exports, "normalizeArabicNumerals", function () { return $6a2912aaef5c381d$export$1ac84f2112a171b3; });
$parcel$export(module.exports, "generateBarcode", function () { return $6a2912aaef5c381d$export$7c72b4396e7afeca; });
$parcel$export(module.exports, "toHijri", function () { return $6a2912aaef5c381d$export$3e60c2e9978852f8; });
$parcel$export(module.exports, "createT", function () { return $6a2912aaef5c381d$export$1262b0a17ac4eb62; });
$parcel$export(module.exports, "openExternalUrl", function () { return $6a2912aaef5c381d$export$29ac8f00d0f8fe39; });
$parcel$export(module.exports, "TimeoutError", function () { return $6a2912aaef5c381d$export$66d311bf29d5c89c; });
$parcel$export(module.exports, "withTimeout", function () { return $6a2912aaef5c381d$export$e86e19342bc4850e; });
$parcel$export(module.exports, "sanitizeDecimalInput", function () { return $6a2912aaef5c381d$export$8800cad23ea9b245; });
$parcel$export(module.exports, "GeoError", function () { return $6a2912aaef5c381d$export$f598978d1d605ce; });
$parcel$export(module.exports, "getCurrentPositionSafe", function () { return $6a2912aaef5c381d$export$177da7260a4d8a11; });
$parcel$export(module.exports, "geoErrorMessage", function () { return $6a2912aaef5c381d$export$4802f9d3ceb148cf; });
$parcel$export(module.exports, "getAuthenticityBadge", function () { return $6a2912aaef5c381d$export$d472bd3ebc4adae2; });
$parcel$export(module.exports, "storeAvatar", function () { return $6a2912aaef5c381d$export$7e9b1700caac08ed; });
$parcel$export(module.exports, "waLink", function () { return (parcelRequire("jP2yR")).waLink; });
/**
 * TAKI Shared Utility Functions
 * Centralized helpers to eliminate code duplication across the app.
 */ 
var $gMErx = parcelRequire("gMErx");

var $jwDxG = parcelRequire("jwDxG");

var $jP2yR = parcelRequire("jP2yR");
const $6a2912aaef5c381d$export$3e069540d64e8aa5 = (deal)=>{
    if (deal.region || deal.city) return {
        regionId: deal.region,
        cityId: deal.city
    };
    const loc = (0, $gMErx.LOCATIONS).find((l)=>l.id === deal.locationId);
    if (loc) {
        const city = (0, $gMErx.CITIES).find((c)=>c.id === loc.cityId);
        return {
            regionId: city?.regionId,
            cityId: loc.cityId
        };
    }
    if (deal.mapLocation) {
        const nearest = (0, $gMErx.findNearestCity)(deal.mapLocation.lat, deal.mapLocation.lng);
        if (nearest) return {
            regionId: nearest.regionId,
            cityId: nearest.id
        };
    }
    return {};
};
const $6a2912aaef5c381d$export$90fbbb860a45770a = (deal)=>{
    if (deal.locations && deal.locations.length > 1) return deal.locations.map((l)=>{
        if (l.region || l.city) return {
            regionId: l.region,
            cityId: l.city,
            locationId: l.locationId
        };
        const loc = l.locationId ? (0, $gMErx.LOCATIONS).find((x)=>x.id === l.locationId) : undefined;
        if (loc) {
            const city = (0, $gMErx.CITIES).find((c)=>c.id === loc.cityId);
            return {
                regionId: city?.regionId,
                cityId: loc.cityId,
                locationId: l.locationId
            };
        }
        if (l.lat != null && l.lng != null) {
            const near = (0, $gMErx.findNearestCity)(l.lat, l.lng);
            if (near) return {
                regionId: near.regionId,
                cityId: near.id,
                locationId: l.locationId
            };
        }
        return {
            locationId: l.locationId
        };
    });
    const primary = $6a2912aaef5c381d$export$3e069540d64e8aa5(deal);
    return [
        {
            regionId: primary.regionId,
            cityId: primary.cityId,
            locationId: deal.locationId
        }
    ];
};
const $6a2912aaef5c381d$export$4e4ff4c880cc1071 = (deal, filter)=>{
    if (!filter.mall && !filter.city && !filter.region) return true;
    return $6a2912aaef5c381d$export$90fbbb860a45770a(deal).some(({ regionId: regionId, cityId: cityId, locationId: locationId })=>{
        if (filter.mall && locationId !== filter.mall) return false;
        if (filter.city && cityId !== filter.city) return false;
        if (filter.region && regionId !== filter.region) return false;
        return true;
    });
};
const $6a2912aaef5c381d$export$a893890a2afbf2 = 5; // one sponsor ad after every 5 normal deals
const $6a2912aaef5c381d$export$ee312f7a6d1a296a = (label, isRTL)=>{
    const l = label || 'ad';
    // 'none' = gold frame only; 'star' = gold frame + a corner ⭐ badge
    // (rendered separately in DealCard) — neither shows a full text ribbon.
    if (l === 'none' || l === 'star') return '';
    if (l === 'sponsor') return isRTL ? "\u0631\u0627\u0639\u064D \u0631\u0633\u0645\u064A" : 'Official Sponsor';
    return isRTL ? "\u0625\u0639\u0644\u0627\u0646" : 'Ad';
};
const $6a2912aaef5c381d$export$d26b58674e1f9783 = (s)=>{
    if (!s || !s.isActive) return false;
    const now = Date.now();
    if (s.startsAt && new Date(s.startsAt).getTime() > now) return false;
    if (s.expiresAt && new Date(s.expiresAt).getTime() <= now) return false;
    return true;
};
const $6a2912aaef5c381d$export$a95ce00ee4e129dd = (deal, s)=>{
    if (s.targetCategory && deal.category !== s.targetCategory && deal.category !== 'all') return false;
    if (s.targetCity || s.targetRegion) {
        const { regionId: regionId, cityId: cityId } = $6a2912aaef5c381d$export$3e069540d64e8aa5(deal);
        if (s.targetCity && cityId !== s.targetCity) return false;
        if (s.targetRegion && regionId !== s.targetRegion) return false;
    }
    if (s.targetLat != null && s.targetLng != null && s.targetRadiusKm != null && s.targetRadiusKm > 0) {
        const lat = deal.mapLocation?.lat;
        const lng = deal.mapLocation?.lng;
        if (typeof lat !== 'number' || typeof lng !== 'number') return false;
        if ($6a2912aaef5c381d$export$79376507b09a66f(s.targetLat, s.targetLng, lat, lng) > s.targetRadiusKm) return false;
    }
    return true;
};
const $6a2912aaef5c381d$export$6daa114dde7497ac = {
    everyN: $6a2912aaef5c381d$export$a893890a2afbf2,
    lead: true,
    tierOrder: [
        'sponsor',
        'ad',
        'star',
        'none'
    ],
    rotation: 'round_robin',
    storeOrder: []
};
const $6a2912aaef5c381d$export$be8c9d9fed952ca2 = (v)=>{
    const d = $6a2912aaef5c381d$export$6daa114dde7497ac;
    if (!v || typeof v !== 'object') return d;
    const rawTiers = Array.isArray(v.tier_order) ? v.tier_order.filter((t)=>[
            'sponsor',
            'ad',
            'star',
            'none'
        ].includes(t)) : [];
    const tierOrder = [
        ...rawTiers,
        ...d.tierOrder.filter((t)=>!rawTiers.includes(t))
    ];
    const n = Number(v.every_n);
    return {
        everyN: Number.isFinite(n) ? Math.min(20, Math.max(1, Math.round(n))) : d.everyN,
        lead: v.lead !== false,
        tierOrder: tierOrder,
        rotation: v.rotation === 'sequential' ? 'sequential' : 'round_robin',
        storeOrder: Array.isArray(v.store_order) ? v.store_order.filter((s)=>typeof s === 'string') : []
    };
};
const $6a2912aaef5c381d$export$10ed76fb0e969593 = (ranked, sponsorMap, layout = $6a2912aaef5c381d$export$6daa114dde7497ac)=>{
    const everyN = Math.min(20, Math.max(1, layout.everyN || $6a2912aaef5c381d$export$a893890a2afbf2));
    // ترتيب الطبقة من tierOrder — الفهرس الأصغر = أسبق ظهوراً.
    const labelRank = (label)=>{
        const i = layout.tierOrder.indexOf(label || 'ad');
        return i === -1 ? layout.tierOrder.length : i;
    };
    // ترتيب المتاجر داخل الطبقة: اليدوي أولاً (storeOrder)، ثم priority تنازلياً.
    const storeCmp = (a, b)=>{
        const ia = layout.storeOrder.indexOf(a);
        const ib = layout.storeOrder.indexOf(b);
        if (ia !== -1 || ib !== -1) {
            if (ia === -1) return 1;
            if (ib === -1) return -1;
            return ia - ib;
        }
        const pa = sponsorMap[a]?.priority ?? 0;
        const pb = sponsorMap[b]?.priority ?? 0;
        if (pb !== pa) return pb - pa;
        return a < b ? -1 : a > b ? 1 : 0;
    };
    // Partition: ad-eligible deals (active sponsor + on-target) vs the rest.
    const normal = [];
    const adsByStore = new Map();
    for (const d of ranked){
        const s = sponsorMap[d.storeId];
        if (s && $6a2912aaef5c381d$export$d26b58674e1f9783(s) && $6a2912aaef5c381d$export$a95ce00ee4e129dd(d, s)) {
            if (!adsByStore.has(d.storeId)) adsByStore.set(d.storeId, []);
            adsByStore.get(d.storeId).push(d);
        } else normal.push(d);
    }
    if (adsByStore.size === 0) return normal.map((deal)=>({
            deal: deal,
            sponsored: false
        }));
    // Build the ad SEQUENCE with tier precedence taken from layout.tierOrder:
    //   1. Tiers emit in the owner's chosen order — the whole first tier drains
    //      before the next tier appears.
    //   2. WITHIN a tier, stores follow storeOrder (manual) then priority; the
    //      rotation mode decides round-robin (S1,S2,S3,S1…) vs sequential
    //      (all of S1, then all of S2 …).
    const byTier = new Map(); // rank → storeIds
    for (const id of adsByStore.keys()){
        const rank = labelRank(sponsorMap[id]?.labelType);
        if (!byTier.has(rank)) byTier.set(rank, []);
        byTier.get(rank).push(id);
    }
    const tiers = Array.from(byTier.keys()).sort((a, b)=>a - b); // فهرس أصغر = أسبق
    const adQueue = [];
    for (const rank of tiers){
        const stores = byTier.get(rank).sort(storeCmp);
        if (layout.rotation === 'sequential') // متجر يستنفد كل منتجاته ثم الذي يليه.
        for (const id of stores){
            const q = adsByStore.get(id) || [];
            for (const deal of q)adQueue.push({
                deal: deal,
                sponsored: true,
                sponsorLabel: sponsorMap[id]?.labelType || 'ad'
            });
        }
        else {
            // Round-robin across this tier's stores until all their queues drain.
            let any = true;
            while(any){
                any = false;
                for (const id of stores){
                    const q = adsByStore.get(id);
                    if (q && q.length > 0) {
                        adQueue.push({
                            deal: q.shift(),
                            sponsored: true,
                            sponsorLabel: sponsorMap[id]?.labelType || 'ad'
                        });
                        any = true;
                    }
                }
            }
        }
    }
    const out = [];
    let ni = 0; // normal index
    let ai = 0; // ad-queue index
    const remainingAds = ()=>ai < adQueue.length;
    const nextAd = ()=>ai < adQueue.length ? adQueue[ai++] : null;
    // With lead=true the FIRST sponsored card opens the page (before any normal
    // deal); lead=false starts with normal deals and the first ad waits for the
    // first everyN chunk. Then one sponsored card after every `everyN` normals.
    if (layout.lead) {
        const lead = nextAd();
        if (lead) out.push(lead);
    }
    while(ni < normal.length || remainingAds()){
        for(let i = 0; i < everyN && ni < normal.length; i++)out.push({
            deal: normal[ni++],
            sponsored: false
        });
        if (remainingAds()) {
            const ad = nextAd();
            if (ad) out.push(ad);
        }
    }
    return out;
};
const $6a2912aaef5c381d$export$241a3ec3d77a5f37 = 604800000; // 7 days
const $6a2912aaef5c381d$export$41b9aa7e1adc802e = 14400000; // 4 hours
const $6a2912aaef5c381d$export$6a044a50fcf6b0d9 = (deal)=>{
    return typeof deal.startsAt === 'number' && deal.startsAt > Date.now();
};
const $6a2912aaef5c381d$export$a836211cde525677 = (deal)=>{
    if (typeof deal.startsAt !== 'number') return false;
    const now = Date.now();
    return deal.startsAt > now && deal.startsAt <= now + $6a2912aaef5c381d$export$241a3ec3d77a5f37;
};
const $6a2912aaef5c381d$export$8b944a0ed827123e = (deal)=>{
    if (typeof deal.startsAt !== 'number') return false;
    const diff = deal.startsAt - Date.now();
    return diff > 0 && diff <= $6a2912aaef5c381d$export$41b9aa7e1adc802e;
};
const $6a2912aaef5c381d$export$b097b63584dfdb93 = (deal)=>{
    return typeof deal.startsAt === 'number' ? Math.max(deal.startsAt, deal.createdAt || 0) : deal.createdAt || 0;
};
const $6a2912aaef5c381d$export$6902da3cbbaf2496 = (deal)=>{
    return $6a2912aaef5c381d$export$b097b63584dfdb93(deal) + (deal.expiresInMinutes || 0) * 60000;
};
const $6a2912aaef5c381d$export$8283d38a0fd4115f = (deal)=>{
    const mins = deal.expiresInMinutes || 120;
    return Date.now() > $6a2912aaef5c381d$export$b097b63584dfdb93(deal) + mins * 60000;
};
const $6a2912aaef5c381d$export$4684c03c0d2beb4d = (startsAt, isRTL)=>{
    const diff = startsAt - Date.now();
    if (diff <= 0) return {
        text: isRTL ? "\u0645\u062A\u0627\u062D \u0627\u0644\u0622\u0646" : 'Live now',
        urgent: false,
        ready: true
    };
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor(diff / 3600000 % 24);
    const mins = Math.floor(diff / 60000 % 60);
    const secs = Math.floor(diff / 1000 % 60);
    const urgent = diff <= $6a2912aaef5c381d$export$41b9aa7e1adc802e;
    if (days > 0) return {
        text: isRTL ? `${days}\u{64A} ${hours}\u{633}` : `${days}d ${hours}h`,
        urgent: false,
        ready: false
    };
    if (hours > 0) return {
        text: isRTL ? `${hours}\u{633} ${mins}\u{62F}` : `${hours}h ${mins}m`,
        urgent: urgent,
        ready: false
    };
    if (mins > 0) return {
        text: isRTL ? `${mins}\u{62F} ${secs.toString().padStart(2, '0')}\u{62B}` : `${mins}m ${secs}s`,
        urgent: true,
        ready: false
    };
    return {
        text: isRTL ? `${secs}\u{62B}` : `${secs}s`,
        urgent: true,
        ready: false
    };
};
const $6a2912aaef5c381d$export$1ac84f2112a171b3 = (input)=>{
    const arabicNumerals = [
        "\u0660",
        "\u0661",
        "\u0662",
        "\u0663",
        "\u0664",
        "\u0665",
        "\u0666",
        "\u0667",
        "\u0668",
        "\u0669"
    ];
    let result = input;
    arabicNumerals.forEach((an, i)=>{
        result = result.replace(new RegExp(an, 'g'), i.toString());
    });
    return result;
};
const $6a2912aaef5c381d$export$79376507b09a66f = (lat1, lon1, lat2, lon2)=>{
    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
const $6a2912aaef5c381d$export$b689e093b86bce3f = (deal, home)=>{
    if (!home || !home.cityId) return 0;
    const hc = (0, $gMErx.CITIES).find((c)=>c.id === home.cityId);
    // v12.91 — أقرب فرع يحسم الترتيب لعرض متعدد المواقع (أدنى tier).
    const tierOf = ({ regionId: regionId, cityId: cityId })=>{
        if (!cityId && !regionId) return 6;
        if (cityId && cityId === home.cityId) return 0;
        if (regionId && home.regionId && regionId === home.regionId) return 1;
        const dc = cityId ? (0, $gMErx.CITIES).find((c)=>c.id === cityId) : undefined;
        if (hc && dc) {
            const km = $6a2912aaef5c381d$export$79376507b09a66f(hc.lat, hc.lng, dc.lat, dc.lng);
            if (km < 150) return 2;
            if (km < 400) return 3;
            return 4;
        }
        return 5;
    };
    return Math.min(...$6a2912aaef5c381d$export$90fbbb860a45770a(deal).map(tierOf));
};
const $6a2912aaef5c381d$export$ba5fa3602b2d0381 = 10;
const $6a2912aaef5c381d$export$7c72b4396e7afeca = (length = $6a2912aaef5c381d$export$ba5fa3602b2d0381)=>{
    const firstDigits = '123456789';
    const digits = '0123456789';
    const randomValues = new Uint32Array(length);
    crypto.getRandomValues(randomValues);
    let barcode = firstDigits.charAt(randomValues[0] % firstDigits.length);
    for(let i = 1; i < length; i++)barcode += digits.charAt(randomValues[i] % digits.length);
    return barcode;
};
const $6a2912aaef5c381d$export$3e60c2e9978852f8 = (dateStr)=>{
    if (!dateStr) return '';
    try {
        const date = new Date(dateStr);
        const formatter = new Intl.DateTimeFormat('ar-SA-u-ca-islamic-uma', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
        return formatter.format(date);
    } catch (e) {
        return '';
    }
};
const $6a2912aaef5c381d$export$1262b0a17ac4eb62 = (isRTL)=>(ar, en)=>isRTL ? ar : en;
const $6a2912aaef5c381d$export$29ac8f00d0f8fe39 = (url)=>{
    try {
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch  {
        window.location.href = url;
    }
};
class $6a2912aaef5c381d$export$66d311bf29d5c89c extends Error {
    constructor(ms){
        super(`Operation exceeded ${ms}ms timeout`);
        this.name = 'TimeoutError';
    }
}
const $6a2912aaef5c381d$export$e86e19342bc4850e = (promise, ms)=>{
    return new Promise((resolve, reject)=>{
        const timer = setTimeout(()=>reject(new $6a2912aaef5c381d$export$66d311bf29d5c89c(ms)), ms);
        promise.then((v)=>{
            clearTimeout(timer);
            resolve(v);
        }, (e)=>{
            clearTimeout(timer);
            reject(e);
        });
    });
};
const $6a2912aaef5c381d$export$8800cad23ea9b245 = (raw)=>{
    let v = raw.replace(/[^\d.]/g, '');
    // Collapse multiple dots to one (keep the first).
    const firstDot = v.indexOf('.');
    if (firstDot !== -1) v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
    // Cap fractional digits at 2 (halalas), but only after at least one
    // decimal digit is typed so "16." stays "16." while typing.
    const m = v.match(/^(\d*)\.(\d*)$/);
    if (m && m[2].length > 2) v = `${m[1]}.${m[2].slice(0, 2)}`;
    return v;
};
class $6a2912aaef5c381d$export$f598978d1d605ce extends Error {
    kind;
    constructor(kind){
        super(kind);
        this.kind = kind;
        this.name = 'GeoError';
    }
}
const $6a2912aaef5c381d$var$mapGeoPositionError = (err)=>{
    if (err.code === 1) return new $6a2912aaef5c381d$export$f598978d1d605ce('denied');
    if (err.code === 3) return new $6a2912aaef5c381d$export$f598978d1d605ce('timeout');
    return new $6a2912aaef5c381d$export$f598978d1d605ce('unavailable');
};
// One attempt that ALWAYS settles: a hard JS timer fires even if Safari never
// calls back. maximumAge lets the low-accuracy pass return a recent cached fix
// fast (desktop Safari).
const $6a2912aaef5c381d$var$geoPositionOnce = (enableHighAccuracy, timeoutMs)=>new Promise((resolve, reject)=>{
        let settled = false;
        const finish = (fn)=>{
            if (settled) return;
            settled = true;
            clearTimeout(guard);
            fn();
        };
        const guard = setTimeout(()=>finish(()=>reject(new $6a2912aaef5c381d$export$f598978d1d605ce('timeout'))), timeoutMs + 2000);
        try {
            navigator.geolocation.getCurrentPosition((pos)=>finish(()=>resolve({
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                        accuracy: pos.coords.accuracy
                    })), (err)=>finish(()=>reject($6a2912aaef5c381d$var$mapGeoPositionError(err))), {
                enableHighAccuracy: enableHighAccuracy,
                timeout: timeoutMs,
                maximumAge: enableHighAccuracy ? 0 : 120000
            });
        } catch  {
            finish(()=>reject(new $6a2912aaef5c381d$export$f598978d1d605ce('unavailable')));
        }
    });
const $6a2912aaef5c381d$export$177da7260a4d8a11 = async (opts)=>{
    const highMs = opts?.highMs ?? 8000;
    const lowMs = opts?.lowMs ?? 8000;
    const viaTelegram = async (fallbackErr)=>{
        const tg = await (0, $jwDxG.getTelegramLocation)(Math.max(highMs, 8000));
        if (tg) return tg;
        throw fallbackErr;
    };
    if (typeof navigator === 'undefined' || !navigator.geolocation || !navigator.geolocation.getCurrentPosition) return viaTelegram(new $6a2912aaef5c381d$export$f598978d1d605ce('unsupported'));
    try {
        return await $6a2912aaef5c381d$var$geoPositionOnce(true, highMs);
    } catch (e) {
        const kind = e instanceof $6a2912aaef5c381d$export$f598978d1d605ce ? e.kind : 'unavailable';
        if (kind === 'denied' || kind === 'unsupported') return viaTelegram(e);
        try {
            return await $6a2912aaef5c381d$var$geoPositionOnce(false, lowMs);
        } catch (e2) {
            return viaTelegram(e2);
        }
    }
};
const $6a2912aaef5c381d$export$4802f9d3ceb148cf = (e, isRTL)=>{
    const kind = e instanceof $6a2912aaef5c381d$export$f598978d1d605ce ? e.kind : 'unavailable';
    if (kind === 'denied') return isRTL ? "\u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0645\u0648\u0642\u0639 \u0645\u0631\u0641\u0648\u0636\u0629. \u0641\u0639\u0651\u0644\u0647\u0627 \u0645\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u062A\u0635\u0641\u062D/\u0627\u0644\u062C\u0647\u0627\u0632 \u062B\u0645 \u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u2014 \u0623\u0648 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0642\u0639\u0643 \u064A\u062F\u0648\u064A\u0627\u064B." : "Location permission is denied. Enable it in your browser/device settings and retry \u2014 or tap the map to set your location manually.";
    if (kind === 'unsupported') return isRTL ? "\u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0644\u0627 \u064A\u062F\u0639\u0645 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u0648\u0642\u0639 \u2014 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0642\u0639\u0643 \u064A\u062F\u0648\u064A\u0627\u064B." : "This browser does not support geolocation \u2014 tap the map to set your location manually.";
    if (kind === 'timeout') return isRTL ? "\u0627\u0646\u062A\u0647\u062A \u0645\u0647\u0644\u0629 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u0648\u0642\u0639. \u062A\u0623\u0643\u062F \u0645\u0646 \u062A\u0641\u0639\u064A\u0644 \u062E\u062F\u0645\u0629 \u0627\u0644\u0645\u0648\u0642\u0639\u060C \u0623\u0648 \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0642\u0639\u0643 \u064A\u062F\u0648\u064A\u0627\u064B." : 'Location request timed out. Make sure location services are on, or tap the map to set it manually.';
    return isRTL ? "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u0648\u0642\u0639. \u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0642\u0639\u0643 \u064A\u062F\u0648\u064A\u0627\u064B." : 'Could not get your location. Tap the map to set it manually.';
};
const $6a2912aaef5c381d$export$d472bd3ebc4adae2 = (real = 0, fake = 0, isRTL = true)=>{
    const r = Math.max(0, real || 0);
    const f = Math.max(0, fake || 0);
    const total = r + f;
    if (total <= 0) return {
        show: false,
        real: true,
        pct: 0,
        total: 0,
        label: '',
        color: '',
        bg: ''
    };
    const realPct = Math.round(r / total * 100);
    const isReal = r >= f; // ties resolve to "real"
    const pct = isReal ? realPct : 100 - realPct;
    const label = isReal ? `${isRTL ? "\uD83D\uDD35 \u0639\u0631\u0636 \u062D\u0642\u064A\u0642\u064A" : "\uD83D\uDD35 Real offer"} ${pct}%` : `${isRTL ? "\uD83D\uDFE1 \u0639\u0631\u0636 \u0634\u0643\u0644\u064A" : "\uD83D\uDFE1 Cosmetic offer"} ${pct}%`;
    // BLUE (real) / YELLOW (fake) — NOT green/red, which are reserved for shop
    // open/closed status (owner's rule, v11.98). Yellow needs DARK text for AA
    // contrast; blue keeps white. Solid pill → readable on light + dark cards.
    return {
        show: true,
        real: isReal,
        pct: pct,
        total: total,
        label: label,
        color: isReal ? '#ffffff' : '#713f12',
        bg: isReal ? '#1d4ed8' : '#facc15'
    };
};
const $6a2912aaef5c381d$export$7e9b1700caac08ed = (profile)=>String(profile?.avatar_url || profile?.avatar || '');

});
parcelRegister("jwDxG", function(module, exports) {

$parcel$export(module.exports, "getTelegramLocation", function () { return $d47215856dfe8ff2$export$6cebd3013841c81c; });
/**
 * موقع المستخدم داخل تيليجرام (v13.79).
 *
 * سؤال ناصر: «هل التطبيق والبوتات يختلف الوضع؟» — نعم، ولهذا الملف.
 *
 * حين يُفتح تاكي **داخل تيليجرام** (Mini App) فهو يعمل في متصفّح تيليجرام
 * المدمج، لا في سفاري/كروم. صلاحية الموقع هناك ليست صلاحية الموقع التي منحها
 * المستخدم للموقع في متصفّحه: `navigator.geolocation` كثيراً ما يُرفض فوراً
 * لأن تيليجرام نفسه هو من يملك إذن الموقع من النظام. لذلك يوفّر تيليجرام
 * واجهة خاصة `WebApp.LocationManager` (Bot API 8.0) — وهي الطريق الوحيد
 * لمعرفة موقع المستخدم داخل المصغّر.
 *
 * هذا الملف جسر رفيع لتلك الواجهة: بلا اعتماديات، ولا يرمي أبداً، ويُرجع
 * `null` خارج تيليجرام أو حين لا يمنح المستخدم الإذن — فيكمل النداء الأصلي
 * مساره الطبيعي في المتصفّح العادي.
 */ const $d47215856dfe8ff2$var$manager = ()=>{
    try {
        const lm = window?.Telegram?.WebApp?.LocationManager;
        return lm && typeof lm.getLocation === 'function' ? lm : null;
    } catch  {
        return null;
    }
};
const $d47215856dfe8ff2$export$656619f0f5a192c5 = ()=>!!$d47215856dfe8ff2$var$manager();
/**
 * جهّز `LocationManager`. تيليجرام يوجب `init` قبل أي قراءة، والاستدعاء
 * المتكرر آمن. نضع مهلة صلبة لأن ردّ النداء قد لا يأتي في نسخ عميل قديمة.
 */ const $d47215856dfe8ff2$var$initManager = (lm, timeoutMs)=>new Promise((resolve)=>{
        if (lm.isInited) {
            resolve();
            return;
        }
        let done = false;
        const finish = ()=>{
            if (!done) {
                done = true;
                clearTimeout(guard);
                resolve();
            }
        };
        const guard = setTimeout(finish, timeoutMs);
        try {
            lm.init?.(finish);
        } catch  {
            finish();
        }
    });
const $d47215856dfe8ff2$export$6cebd3013841c81c = async (timeoutMs = 10000)=>{
    const lm = $d47215856dfe8ff2$var$manager();
    if (!lm) return null;
    try {
        await $d47215856dfe8ff2$var$initManager(lm, Math.min(timeoutMs, 4000));
        if (lm.isLocationAvailable === false) return null;
        return await new Promise((resolve)=>{
            let done = false;
            const finish = (v)=>{
                if (!done) {
                    done = true;
                    clearTimeout(guard);
                    resolve(v);
                }
            };
            const guard = setTimeout(()=>finish(null), timeoutMs);
            try {
                lm.getLocation((loc)=>{
                    if (!loc || !Number.isFinite(loc.latitude) || !Number.isFinite(loc.longitude)) {
                        finish(null);
                        return;
                    }
                    finish({
                        lat: loc.latitude,
                        lng: loc.longitude,
                        accuracy: Number.isFinite(loc.horizontal_accuracy) ? loc.horizontal_accuracy : 0
                    });
                });
            } catch  {
                finish(null);
            }
        });
    } catch  {
        return null;
    }
};
const $d47215856dfe8ff2$export$79fddbef494cfa7 = ()=>{
    const lm = $d47215856dfe8ff2$var$manager();
    if (!lm || typeof lm.openSettings !== 'function') return false;
    try {
        lm.openSettings();
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("jP2yR", function(module, exports) {
/**
 * phone.js — اشتقاق رابط واتساب من رقم جوال: **نسخةٌ واحدة** (v14.77)
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 لماذا وُحِّد: النمط كان منسوخاً في الشاشات بصيغةٍ واحدة تصحّ لحالةٍ واحدة:
 *       `https://wa.me/966${phone.replace(/^0/, '')}`
 *    فهي تعمل مع `05…` فقط، وتُخرج رابطاً معطوباً لكل ما عداها:
 *      • `+9665…`  ⇐ `wa.me/966+9665…`
 *      • `00966…`  ⇐ `wa.me/96600966…`
 *      • `٠٥٥…`    ⇐ يخرج بالأرقام العربية كما هو
 *      • `9665…`   ⇐ `wa.me/9669665…`
 *
 * 🪤 والرابط المعطوب **لا يُخطئ ولا يُسجَّل**: واتساب يفتح ويقول «الرقم غير
 *    صالح»، فيستنتج صاحبُ اللوحة أن العميل ليس على واتساب — والخطأ في الرابط.
 *    ولذلك تُرجع الدالّة فراغاً حين لا تستطيع اشتقاق رقمٍ سليم، ويُخفي المكوّن
 *    الزرَّ عندها: لا زرّ خيرٌ من زرٍّ يقود إلى خطأ.
 *
 * ℹ️ السعودية: `9665XXXXXXXX` (مفتاح ٩٦٦ + ٥ + ثماني خانات). وما جاء بمفتاح
 *    دولةٍ أخرى يُمرَّر كما هو — إخفاء وسيلة تواصلٍ صالحة أسوأ من تمريرها.
 */ const $e6e4c456c1782c16$var$AR_DIGITS = "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669";
const $e6e4c456c1782c16$var$FA_DIGITS = "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9";
/** أرقام عربية/فارسية ⇐ لاتينية. (لوحة المفاتيح العربية تُخرجها كثيراً.) */ function $e6e4c456c1782c16$var$toLatinDigits(s) {
    let out = '';
    for (const ch of String(s == null ? '' : s)){
        const a = $e6e4c456c1782c16$var$AR_DIGITS.indexOf(ch);
        if (a >= 0) {
            out += String(a);
            continue;
        }
        const f = $e6e4c456c1782c16$var$FA_DIGITS.indexOf(ch);
        if (f >= 0) {
            out += String(f);
            continue;
        }
        out += ch;
    }
    return out;
}
/**
 * الرقم بصيغة واتساب الدولية (بلا `+`)، أو `''` إن تعذّر.
 * @param {string|null|undefined} raw
 * @returns {string}
 */ function $e6e4c456c1782c16$var$waNumber(raw) {
    let d = $e6e4c456c1782c16$var$toLatinDigits(raw).replace(/\D/g, '');
    if (!d) return '';
    if (d.startsWith('00')) d = d.slice(2);
    if (d.startsWith('966')) // `9660 5…` يقع عند لصق «+966» أمام رقمٍ محلّي كامل — الصفر يُسقَط.
    d = '966' + d.slice(3).replace(/^0+/, '');
    else if (d.startsWith('0')) d = '966' + d.replace(/^0+/, '');
    else if (/^5\d{8}$/.test(d)) d = '966' + d; // رقمٌ محلّي بلا صفر ولا مفتاح
    if (/^9665\d{8}$/.test(d)) return d;
    // مفتاح دولةٍ أخرى — يُمرَّر كما هو (وليس 966 مشوّهاً).
    if (!d.startsWith('966') && /^\d{10,15}$/.test(d)) return d;
    return '';
}
/** رابط `wa.me` جاهز، أو `''` إن كان الرقم غير صالح. */ function $e6e4c456c1782c16$var$waLink(raw) {
    const n = $e6e4c456c1782c16$var$waNumber(raw);
    return n ? 'https://wa.me/' + n : '';
}
module.exports = {
    waLink: $e6e4c456c1782c16$var$waLink,
    waNumber: $e6e4c456c1782c16$var$waNumber,
    toLatinDigits: $e6e4c456c1782c16$var$toLatinDigits
};

});



parcelRegister("eGYci", function(module, exports) {

$parcel$export(module.exports, "DEALS_PAGE_SIZE", function () { return $18328c0a3f6fc90f$export$7e2c07726b24b840; });
$parcel$export(module.exports, "dealRepository", function () { return $18328c0a3f6fc90f$export$48252297d2f1d0ba; });

var $hUL2G = parcelRequire("hUL2G");

var $4aj47 = parcelRequire("4aj47");

var $3rEkS = parcelRequire("3rEkS");
/**
 * v13.22 — ترطيب التقييمات لمجموعة عروض (صفحة واحدة).
 * كان هذا المنطق محشوراً داخل getAll ويعمل على **كل** العروض؛ استُخرج ليعمل
 * على الصفحة المطلوبة فقط، فيبقى الطلب صغيراً مهما كبر الكتالوج.
 */ const $18328c0a3f6fc90f$var$hydrateRatings = async (deals)=>{
    if (deals.length === 0) return deals;
    const ids = deals.map((d)=>d.id);
    const { data: ratingRows } = await (0, $hUL2G.supabase).from('ratings').select('*').in('deal_id', ids).is('deleted_at', null).order('created_at', {
        ascending: false
    })// v13.29 — سقف. منتج رائج بعشرات آلاف التقييمات كان سيُنزّلها كلها مع
    // الصفحة. المتوسط والعدد يأتيان من `rating_avg`/`rating_count` المثبّتين
    // على الصف، وهذه القائمة للعرض فقط — فالسقف لا يُفقد رقماً.
    .limit($18328c0a3f6fc90f$var$RATINGS_HYDRATE_CAP);
    const byDeal = {};
    for (const r of ratingRows || [])(byDeal[r.deal_id] ||= []).push({
        id: r.id,
        userId: r.user_id,
        userName: r.user_name,
        score: Number(r.score) || 0,
        comment: r.comment ?? '',
        // بتوقيت الجهاز — toISOString (UTC) يرجع اليوم للوراء قبل ٣ فجراً
        date: r.created_at ? (()=>{
            const d = new Date(r.created_at);
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        })() : '',
        reply: r.reply ?? undefined,
        repliedBy: r.replied_by ?? undefined,
        repliedAt: r.replied_at ?? undefined,
        likedBy: Array.isArray(r.liked_by) ? r.liked_by : [],
        likeCount: Number(r.like_count) || 0
    });
    for (const d of deals)d.ratings = byDeal[d.id] || [];
    return deals;
};
const $18328c0a3f6fc90f$export$7e2c07726b24b840 = 30;
/** سقف صفوف التقييمات المجلوبة مع صفحة عروض (العرض فقط — الإحصاء مثبَّت). */ const $18328c0a3f6fc90f$var$RATINGS_HYDRATE_CAP = 300;
const $18328c0a3f6fc90f$var$EMPTY_BROWSE = {
    deals: [],
    total: 0,
    totalCapped: false,
    hasMore: false,
    cursor: null
};
const $18328c0a3f6fc90f$export$d1b7f2c6fa4476a2 = [
    'id',
    'store_id',
    'shop_name',
    'item_name',
    'category',
    'gender',
    'size',
    'original_price',
    'discounted_price',
    'discount_percentage',
    'images',
    'description',
    'location_id',
    'custom_location_name',
    'google_maps_link',
    'map_lat',
    'map_lng',
    'reliability_score',
    'expires_in_minutes',
    'quantity',
    'is_unlimited',
    'initial_quantity',
    'on_hand',
    'sold_out',
    'prep_time',
    'status',
    'created_at',
    'expiry_hijri',
    'expiry_gregorian',
    'updated_at',
    'city',
    'region',
    'expiry_type',
    'expiry_date',
    'views',
    'clicks',
    'starts_at',
    'coming_soon_notified_at',
    'subscription_frozen',
    'source',
    'max_per_booking',
    'max_bookings_per_buyer',
    'rebook_cooldown_minutes',
    'season_id',
    'options',
    'variants',
    'pos_sku',
    'locations',
    'loc_qty_mode',
    'auth_real_count',
    'auth_fake_count',
    'rating_avg',
    'rating_count'
].join(',');

const $18328c0a3f6fc90f$export$48252297d2f1d0ba = {
    /**
     * v13.26 — «حولي» على مستوى **الفرع** ومن الخادم.
     *
     * كانت الصفحة توسّع فروع العروض وتحسب المسافات في المتصفح على النافذة
     * المُحمّلة — أي أن «أقرب العروض إليك» كانت أقرب ما بين آخر ٣٠ عرضاً.
     * الآن القاعدة تقصّ الجوار بمرشّح صندوقي على فهرس الإحداثيات ثم تحسب
     * المسافة الدقيقة للناجين فقط، وترتّب بالأقرب مع ترقيم keyset.
     */ browseNearby: async (p)=>{
        const empty = {
            deals: [],
            total: 0,
            totalCapped: false,
            hasMore: false,
            cursor: null
        };
        if (typeof p.lat !== 'number' || typeof p.lng !== 'number') return empty;
        try {
            const { data: data, error: error } = await (0, $3rEkS.withTimeout)((0, $hUL2G.supabase).rpc('browse_nearby', {
                p_lat: p.lat,
                p_lng: p.lng,
                p_radius_km: p.radiusKm ?? 0,
                p_query: p.query?.trim() || null,
                p_category: p.category && p.category !== 'all' ? p.category : null,
                p_region: p.region || null,
                p_city: p.city || null,
                p_location_id: p.locationId || null,
                p_loc_type: p.locType || null,
                p_open_now: !!p.openNow,
                p_blocked: p.blocked && p.blocked.length ? p.blocked : null,
                p_limit: Math.max(1, Math.min(60, p.limit ?? $18328c0a3f6fc90f$export$7e2c07726b24b840)),
                p_cursor_dist: p.cursor ? p.cursor.dist : null,
                p_cursor_key: p.cursor ? p.cursor.key : null
            }), 20000);
            if (error) throw error;
            const rows = Array.isArray(data?.rows) ? data.rows : [];
            const deals = rows.map((r)=>Object.assign($18328c0a3f6fc90f$export$48252297d2f1d0ba.mapRowToDeal(r), {
                    distance: Number(r.distance) || 0,
                    lat: Number(r.lat) || 0,
                    lng: Number(r.lng) || 0,
                    _key: String(r._key),
                    _bId: r._bId ?? undefined,
                    _bLocId: r._bLocId ?? undefined,
                    _bName: r._bName ?? undefined,
                    _bRegion: r._bRegion ?? undefined,
                    _bCity: r._bCity ?? undefined
                }));
            return {
                deals: deals,
                total: Number(data?.total) || 0,
                totalCapped: !!data?.total_capped,
                hasMore: !!data?.has_more,
                cursor: data?.has_more && data?.next_key != null && data?.next_dist != null ? {
                    dist: Number(data.next_dist),
                    key: String(data.next_key)
                } : null
            };
        } catch (e) {
            console.error("\u274C browse_nearby failed:", e);
            return empty;
        }
    },
    /**
     * v13.24 — صفحة تصفّح/بحث كاملة من الخادم: نداء واحد يعيد العروض + العدد
     * الكلي + مؤشّر الصفحة التالية.
     *
     * لماذا نداء واحد: كل جولة شبكة إضافية تُضاف مباشرة لزمن ظهور الصفحة على
     * جوال المستخدم. العدّادات (التقييم/الأصالة) صارت مثبّتة على صف العرض
     * بـtriggers، فلا حاجة لجلب صفوف التقييمات ولا لنداء عدّ الأصالة.
     */ browse: async (p = {})=>{
        try {
            const { data: data, error: error } = await (0, $3rEkS.withTimeout)((0, $hUL2G.supabase).rpc('browse_deals', {
                p_query: p.query?.trim() || null,
                p_category: p.category && p.category !== 'all' ? p.category : null,
                p_gender: p.gender && p.gender !== 'all' ? p.gender : null,
                p_region: p.region || null,
                p_city: p.city || null,
                p_mall: p.mall || null,
                p_store_id: p.storeId || null,
                p_season_id: p.seasonId || null,
                p_sort: p.sort || 'new',
                p_mode: p.mode || 'live',
                p_open_now: !!p.openNow,
                p_verified: !!p.verified,
                p_cursor_key: p.cursor ? p.cursor.key : null,
                p_cursor_id: p.cursor ? p.cursor.id : null,
                p_limit: Math.max(1, Math.min(60, p.limit ?? $18328c0a3f6fc90f$export$7e2c07726b24b840)),
                p_blocked: p.blocked && p.blocked.length ? p.blocked : null,
                p_exclude_ids: p.excludeIds && p.excludeIds.length ? p.excludeIds : null
            }), 20000);
            if (error) throw error;
            const rows = Array.isArray(data?.rows) ? data.rows : [];
            const nextKey = data?.next_key;
            const nextId = data?.next_id;
            return {
                deals: rows.map($18328c0a3f6fc90f$export$48252297d2f1d0ba.mapRowToDeal),
                total: Number(data?.total) || 0,
                totalCapped: !!data?.total_capped,
                hasMore: !!data?.has_more,
                cursor: data?.has_more && nextId != null && nextKey != null ? {
                    key: Number(nextKey),
                    id: String(nextId)
                } : null
            };
        } catch (e) {
            console.error("\u274C browse_deals failed:", e);
            return $18328c0a3f6fc90f$var$EMPTY_BROWSE;
        }
    },
    /**
     * v13.22 — صفحة من واجهة العروض بترقيم **keyset** (أسلوب التطبيقات الكبرى).
     *
     * لماذا keyset لا OFFSET: مع OFFSET تُجبَر القاعدة على عدّ وتخطّي كل الصفوف
     * السابقة، فتتباطأ الصفحة كلما تعمّق المستخدم (الصفحة ١٠٠ أبطأ ١٠٠ مرة من
     * الأولى). أما keyset فيسأل «أعطني ما بعد هذا العنصر» فيقفز الفهرس مباشرة —
     * زمن ثابت مهما بلغ عمق التمرير أو حجم الكتالوج.
     *
     * الترتيب `created_at DESC, id DESC` يطابق الفهرس `idx_deals_feed_keyset`
     * تماماً، و`id` فاصلٌ حاسم يمنع تكرار أو تخطّي عرض عند تساوي الطابع الزمني.
     */ getFeedPage: async (opts)=>{
        const limit = Math.max(1, opts?.limit ?? $18328c0a3f6fc90f$export$7e2c07726b24b840);
        try {
            let q = (0, $hUL2G.supabase).from('deals').select($18328c0a3f6fc90f$export$d1b7f2c6fa4476a2).neq('status', 'deleted');
            const c = opts?.cursor;
            if (c) // (created_at < c) OR (created_at = c AND id < c.id)
            q = q.or(`created_at.lt.${c.createdAt},and(created_at.eq.${c.createdAt},id.lt.${JSON.stringify(c.id)})`);
            const { data: data, error: error } = await q.order('created_at', {
                ascending: false
            }).order('id', {
                ascending: false
            }).limit(limit + 1); // +1 لمعرفة وجود المزيد بلا عدّ إضافي
            if (error) throw error;
            const rows = data || [];
            const hasMore = rows.length > limit;
            const page = rows.slice(0, limit).map($18328c0a3f6fc90f$export$48252297d2f1d0ba.mapRowToDeal);
            await $18328c0a3f6fc90f$var$hydrateRatings(page);
            const last = page[page.length - 1];
            return {
                deals: page,
                nextCursor: hasMore && last ? {
                    createdAt: Number(last.createdAt) || 0,
                    id: last.id
                } : null,
                hasMore: hasMore
            };
        } catch (e) {
            console.error("\u274C Deal feed page fetch failed:", e);
            return {
                deals: [],
                nextCursor: null,
                hasMore: false
            };
        }
    },
    /**
     * بحث سريع يعيد أفضل المطابقات فقط (شريط بحث الرئيسية).
     *
     * v13.24 — صار غلافاً رفيعاً حول `browse` بدل استعلام `ilike` مستقل:
     * مسار بحث **واحد** في كل المنصة، فلا يمكن أن تختلف نتيجة الرئيسية عن
     * نتيجة صفحة العروض. الترتيب `best` = الأفضل مطابقةً لا الأحدث.
     */ searchDeals: async (opts)=>{
        const q = (opts.query || '').trim();
        const cat = opts.category && opts.category !== 'all' ? opts.category : null;
        if (!q && !cat) return [];
        const { deals: deals } = await $18328c0a3f6fc90f$export$48252297d2f1d0ba.browse({
            query: q || null,
            category: cat,
            sort: q ? 'best' : 'new',
            limit: opts.limit ?? 60
        });
        return deals;
    },
    /**
     * v13.22 — كل عروض متجر واحد (لوحة التاجر + صفحة المتجر).
     * كانت هاتان الصفحتان تُرشّحان المصفوفة العامة، فمع الترقيم كانتا سترى ما
     * حُمّل في النافذة فقط. الاستعلام الموجّه يضمن اكتمالها دائماً — وهو أسرع
     * أصلاً (فهرس `idx_deals_store_created`).
     */ getByStore: async (storeId)=>{
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('deals').select($18328c0a3f6fc90f$export$d1b7f2c6fa4476a2).eq('store_id', storeId).neq('status', 'deleted').order('created_at', {
                ascending: false
            });
            if (error) throw error;
            const list = (data || []).map($18328c0a3f6fc90f$export$48252297d2f1d0ba.mapRowToDeal);
            await $18328c0a3f6fc90f$var$hydrateRatings(list);
            return list;
        } catch (e) {
            console.error("\u274C Store deals fetch failed:", e);
            return [];
        }
    },
    getAll: async ()=>{
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('deals').select($18328c0a3f6fc90f$export$d1b7f2c6fa4476a2).neq('status', 'deleted').order('created_at', {
                ascending: false
            });
            if (error) throw error;
            if (data) {
                const mappedData = data.map($18328c0a3f6fc90f$export$48252297d2f1d0ba.mapRowToDeal);
                // Hydrate ratings from the dedicated table in one round trip.
                // Empty deal list → skip the second query entirely.
                if (mappedData.length > 0) {
                    const ids = mappedData.map((d)=>d.id);
                    const { data: ratingRows } = await (0, $hUL2G.supabase).from('ratings').select('*').in('deal_id', ids).is('deleted_at', null).order('created_at', {
                        ascending: false
                    });
                    if (Array.isArray(ratingRows) && ratingRows.length > 0) {
                        const byDeal = {};
                        for (const r of ratingRows)(byDeal[r.deal_id] ||= []).push({
                            id: r.id,
                            userId: r.user_id,
                            userName: r.user_name,
                            score: Number(r.score) || 0,
                            comment: r.comment ?? '',
                            // بتوقيت الجهاز — toISOString (UTC) يرجع اليوم للوراء قبل ٣ فجراً بتوقيت السعودية
                            date: r.created_at ? (()=>{
                                const d = new Date(r.created_at);
                                return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                            })() : '',
                            reply: r.reply ?? undefined,
                            repliedBy: r.replied_by ?? undefined,
                            repliedAt: r.replied_at ?? undefined,
                            likedBy: Array.isArray(r.liked_by) ? r.liked_by : [],
                            likeCount: Number(r.like_count) || 0
                        });
                        for (const d of mappedData)d.ratings = byDeal[d.id] || [];
                    }
                    // Hydrate real/fake authenticity vote counts (+ caller's own
                    // vote) in one round trip via the DEFINER RPC. Best-effort:
                    // a failure just leaves the badge hidden. v11.97
                    try {
                        const { authenticityRepository: authenticityRepository } = await (parcelRequire("gTQhM"));
                        const counts = await authenticityRepository.counts(ids);
                        for (const d of mappedData){
                            const c = counts[d.id];
                            if (c) {
                                d.authReal = c.realCount;
                                d.authFake = c.fakeCount;
                                d.myAuthVote = c.myVote;
                            }
                        }
                    } catch (e) {
                        (0, $4aj47.logger).log('authenticity counts skipped:', e?.message);
                    }
                }
                (0, $4aj47.logger).log("\uD83D\uDCE1 Fetched deals from remote:", mappedData.length);
                return mappedData;
            }
            return [];
        } catch (e) {
            console.error("\u274C Remote deals fetch failed:", e);
            return [];
        }
    },
    getById: async (id)=>{
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('deals').select($18328c0a3f6fc90f$export$d1b7f2c6fa4476a2).eq('id', id).maybeSingle();
            if (error) throw error;
            return data ? $18328c0a3f6fc90f$export$48252297d2f1d0ba.mapRowToDeal(data) : undefined;
        } catch (e) {
            console.error("\u274C Remote deal fetch by id failed:", e);
            return undefined;
        }
    },
    /**
     * v14.63 — جلب عروضٍ بمعرّفاتها. صفحةُ «المفضلة» تحتاجها لأن `deals` في
     * السياق **نافذةٌ مرقّمة** (keyset): مفضلةٌ قديمة خارج النافذة لا تظهر
     * أبداً لو اكتفينا بترشيح المصفوفة — وهو نفس الفخّ الموثّق في
     * صفحات المتجر والروابط المباشرة. القطع على ١٠٠ لأن `.in()` تذهب في سطر
     * العنوان وله حدّ طول.
     */ getByIds: async (ids)=>{
        if (!ids.length) return [];
        const CHUNK = 100;
        const out = [];
        try {
            for(let i = 0; i < ids.length; i += CHUNK){
                const { data: data, error: error } = await (0, $hUL2G.supabase).from('deals').select($18328c0a3f6fc90f$export$d1b7f2c6fa4476a2).in('id', ids.slice(i, i + CHUNK)).neq('status', 'deleted'); // الحذف عندنا «ناعم» — لولا هذا لظهر المحذوف في المفضلة
                if (error) throw error;
                out.push(...(data || []).map($18328c0a3f6fc90f$export$48252297d2f1d0ba.mapRowToDeal));
            }
            return out;
        } catch (e) {
            console.error("\u274C Deals fetch by ids failed:", e);
            return out; // ما وصل يُعرض — لا شاشة فارغة بسبب قطعةٍ واحدة
        }
    },
    save: async (deal)=>{
        // Optimistic local state update should be handled by the caller (AppContext)
        // Persistence is now purely remote.
        // 2. Sync to Remote
        const dbDeal = {
            id: deal.id,
            store_id: deal.storeId,
            shop_name: deal.shopName,
            item_name: deal.itemName,
            category: deal.category,
            gender: deal.gender || 'all',
            size: deal.size || null,
            original_price: deal.originalPrice,
            discounted_price: deal.discountedPrice,
            discount_percentage: deal.discountPercentage,
            images: deal.images || [],
            description: deal.description || '',
            location_id: deal.locationId || null,
            google_maps_link: deal.googleMapsLink || null,
            map_lat: deal.mapLocation?.lat ?? null,
            map_lng: deal.mapLocation?.lng ?? null,
            // Denormalized region/city so the filter chain works for
            // deals whose location_id is a `custom_<ts>` (not in LOCATIONS).
            region: deal.region || null,
            city: deal.city || null,
            reliability_score: deal.reliabilityScore ?? 100,
            expires_in_minutes: deal.expiresInMinutes ?? 525600,
            expiry_type: deal.expiryType || null,
            expiry_date: deal.expiryDate || null,
            quantity: deal.quantity === 'unlimited' ? null : deal.quantity,
            is_unlimited: deal.quantity === 'unlimited',
            initial_quantity: deal.initialQuantity === 'unlimited' ? null : deal.initialQuantity ?? (deal.quantity === 'unlimited' ? null : deal.quantity),
            status: deal.status,
            created_at: deal.createdAt || Date.now(),
            // v11.20 — scheduled launch (Coming Soon). null = launches immediately.
            starts_at: typeof deal.startsAt === 'number' ? deal.startsAt : null,
            // v12.28 — merchant booking limits (0/undefined = unlimited → NULL)
            max_per_booking: deal.maxPerBooking || null,
            max_bookings_per_buyer: deal.maxBookingsPerBuyer || null,
            rebook_cooldown_minutes: deal.rebookCooldownMinutes || null,
            // v12.48 — وسم الموسم (null = عرض عادي). نافذة الوسم يحرسها tr_deal_season.
            season_id: deal.seasonId || null,
            // v12.53 — اختيارات المنتج (أقسام/خيارات/كميات) — null = بلا اختيارات
            options: deal.options && deal.options.length ? deal.options : null,
            // v12.61 — نسخ المنتج بأسعار مختلفة (تجريبي) — null = بلا نسخ
            variants: deal.variants && deal.variants.length ? deal.variants : null,
            // v12.88 — رمز الكاشير (SKU) للمنتج الأساسي (رموز الأنواع/الإضافات داخل JSONB)
            pos_sku: deal.posSku && deal.posSku.trim() ? deal.posSku.trim() : null,
            // v12.91 — العرض الواحد في عدة مواقع (null = موقع واحد كالمعتاد)
            locations: deal.locations && deal.locations.length > 1 ? deal.locations : null,
            loc_qty_mode: deal.locations && deal.locations.length > 1 ? deal.locQtyMode || 'per_location' : null
        };
        // Internal 25s ceiling per attempt. The deal triggers
        // (handle_deal_smart_notifications + tr_enforce_location_cap +
        // tr_guard_deal_publish) plus AP-NE1 RTT can take a few seconds
        // on healthy 4G, but anything past 25s means the request is hung
        // (commonly: Supabase JS auth-refresh inTabLock on backgrounded
        // iOS Safari). Surfacing fast lets the caller try again instead
        // of holding the spinner against an outer 40s wall.
        let { error: error } = await (0, $3rEkS.withTimeout)((0, $hUL2G.supabase).from('deals').upsert(dbDeal), 25000);
        // Tolerate the case where the deals table is on an older schema that
        // hasn't yet picked up the expiry_type / expiry_date columns
        // (migration v8.16). Drop the new fields and retry once so the user
        // can still publish — the values will start sticking the moment the
        // migration runs, without forcing a hard release coupling.
        if (error && /expiry_(type|date)/i.test(error.message || '')) {
            const { expiry_type: expiry_type, expiry_date: expiry_date, ...legacyDeal } = dbDeal;
            const retry = await (0, $3rEkS.withTimeout)((0, $hUL2G.supabase).from('deals').upsert(legacyDeal), 25000);
            error = retry.error;
        }
        // Same tolerance if the region/city columns don't exist yet.
        if (error && /column "(region|city)"/i.test(error.message || '')) {
            const { region: region, city: city, ...noGeo } = dbDeal;
            const retry = await (0, $3rEkS.withTimeout)((0, $hUL2G.supabase).from('deals').upsert(noGeo), 25000);
            error = retry.error;
        }
        // v11.20 — same forward-compat trick for starts_at (Coming Soon).
        // If the migration hasn't yet landed in the target DB, drop the field
        // and retry so the merchant can still publish (without scheduling).
        if (error && /starts_at/i.test(error.message || '')) {
            const { starts_at: starts_at, ...noStart } = dbDeal;
            const retry = await (0, $3rEkS.withTimeout)((0, $hUL2G.supabase).from('deals').upsert(noStart), 25000);
            error = retry.error;
        }
        if (error) {
            console.error("\u274C Remote deal upsert failed:", error.message);
            throw error;
        }
        (0, $4aj47.logger).log("\u2705 Deal saved to remote:", deal.id);
    },
    /**
     * Partial update for stock-only changes (e.g. a buyer booking decrements
     * quantity by N). Crucially this does NOT touch the `status` column, which
     * means the `tr_guard_deal_publish` trigger (BEFORE UPDATE OF status) does
     * NOT fire. Fixes the bug where buyers got SUBSCRIPTION_REQUIRED if the
     * merchant's subscription happened to be expired at booking time —
     * already-published deals must remain bookable.
     */ /**
     * v15.02 — إعلانُ «المخزون الكامل» لعرضٍ واحد. `newQuantity` هو ما عند
     * التاجر فعلاً، **لا** المتاح: القاعدة تطرح المحجوز وتشتقّ المتاح.
     *
     * 🪤 وكانت هذه الدالّة تكتب `quantity` مباشرةً على الجدول. وبعد v15.03
     *    صار ذلك الكتابةَ المباشرة تُفسَّر إعلاناً — فتُرسل رقماً مطلقاً من
     *    قراءةٍ قديمة، والنتيجة مخزونٌ خاطئ بلا أيّ خطأ ظاهر. والمسار الصحيح
     *    نداءُ `merchant_set_stock` الذي يفحص الملكية ويقفل الصفّ ويشتقّ.
     *    (و«بلا حدّ» تبقى كتابةً مباشرة: لا مخزونَ يُشتقّ لعرضٍ بلا سقف.)
     */ updateQuantity: async (dealId, newQuantity)=>{
        if (newQuantity === 'unlimited') {
            const { error: error } = await (0, $hUL2G.supabase).from('deals').update({
                quantity: null,
                is_unlimited: true
            }).eq('id', dealId);
            if (error) {
                console.error("\u274C unlimited toggle failed:", error.message);
                throw error;
            }
            (0, $4aj47.logger).log("\u2705 Deal set unlimited:", dealId);
            return;
        }
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('merchant_set_stock', {
            p_deal_id: dealId,
            p_on_hand: newQuantity,
            p_variants: null,
            p_locations: null
        });
        if (error) {
            console.error("\u274C merchant_set_stock failed:", error.message);
            throw error;
        }
        // 🪤 كتابةٌ ترفضها القاعدة تعود `error=null` — فلا يُقال «حُفظ» إلا بدليل.
        if (!data?.ok) {
            const code = data?.error || 'STOCK_WRITE_REFUSED';
            console.error("\u274C merchant_set_stock refused:", code);
            throw new Error(code);
        }
        (0, $4aj47.logger).log("\u2705 Stock declared:", dealId, "\u2192", newQuantity, "\xb7 \u0645\u062A\u0627\u062D:", data.available);
    },
    /**
     * Save an entire deals array (bulk update).
     */ saveDeals: async (deals)=>{
        try {
            const dbDeals = deals.map((deal)=>({
                    id: deal.id,
                    store_id: deal.storeId,
                    shop_name: deal.shopName,
                    item_name: deal.itemName,
                    category: deal.category,
                    gender: deal.gender,
                    size: deal.size,
                    original_price: deal.originalPrice,
                    discounted_price: deal.discountedPrice,
                    discount_percentage: deal.discountPercentage,
                    images: deal.images,
                    description: deal.description,
                    location_id: deal.locationId || null,
                    google_maps_link: deal.googleMapsLink || null,
                    map_lat: deal.mapLocation?.lat || null,
                    map_lng: deal.mapLocation?.lng || null,
                    region: deal.region || null,
                    city: deal.city || null,
                    reliability_score: deal.reliabilityScore || 100,
                    expires_in_minutes: deal.expiresInMinutes || 525600,
                    quantity: deal.quantity === 'unlimited' ? null : deal.quantity,
                    is_unlimited: deal.quantity === 'unlimited',
                    initial_quantity: deal.initialQuantity === 'unlimited' ? null : deal.initialQuantity ?? (deal.quantity === 'unlimited' ? null : deal.quantity),
                    status: deal.status,
                    created_at: deal.createdAt || Date.now(),
                    starts_at: typeof deal.startsAt === 'number' ? deal.startsAt : null,
                    max_per_booking: deal.maxPerBooking || null,
                    max_bookings_per_buyer: deal.maxBookingsPerBuyer || null,
                    rebook_cooldown_minutes: deal.rebookCooldownMinutes || null
                }));
            const { error: error } = await (0, $hUL2G.supabase).from('deals').upsert(dbDeals);
            if (error) throw error;
            (0, $4aj47.logger).log("\u2705 Deals bulk-saved to remote");
        } catch (e) {
            console.error('Remote bulk sync failed:', e);
        }
    },
    remove: async (id)=>{
        // Soft-delete first: set status to 'deleted' so FK constraints (bookings)
        // don't block the operation. The client filters out 'deleted' deals on fetch.
        // If soft-delete succeeds, also attempt hard delete for cleanup.
        try {
            const { error: softError } = await (0, $hUL2G.supabase).from('deals').update({
                status: 'deleted'
            }).eq('id', id);
            if (softError) throw softError;
            (0, $4aj47.logger).log("\u2705 Deal soft-deleted from remote");
            // Best-effort hard delete — may fail if bookings still reference it
            const { error: hardError } = await (0, $hUL2G.supabase).from('deals').delete().eq('id', id);
            if (hardError) // Expected when bookings exist — soft delete is sufficient
            (0, $4aj47.logger).log("\u2139\uFE0F Hard delete skipped (FK constraint), soft delete active");
            else (0, $4aj47.logger).log("\u2705 Deal hard-deleted from remote");
        } catch (e) {
            console.error('Remote delete failed:', e);
            throw e; // Let caller handle the error
        }
    },
    clearAll: async ()=>{
    // Remote clear not allowed for safety
    },
    mapRowToDeal: (d)=>{
        const deal = {
            id: d.id,
            storeId: d.store_id,
            shopName: d.shop_name,
            itemName: d.item_name,
            category: d.category,
            gender: d.gender || 'all',
            size: d.size || undefined,
            originalPrice: Number(d.original_price) || 0,
            discountedPrice: Number(d.discounted_price) || 0,
            discountPercentage: Number(d.discount_percentage) || 0,
            images: Array.isArray(d.images) ? d.images : [],
            description: d.description || '',
            locationId: d.location_id || '',
            reliabilityScore: Number(d.reliability_score) || 100,
            expiresInMinutes: Number(d.expires_in_minutes) || 525600,
            quantity: d.is_unlimited ? 'unlimited' : d.quantity ?? 0,
            // v15.02 — المخزون الكامل بجانب المتاح. يُقرأ ولا يُكتب: القاعدة
            // تشتقّه ممّا يكتبه التاجر في `quantity` (المشغّل tr_b0_stock_declare).
            onHand: d.is_unlimited ? null : d.on_hand ?? null,
            soldOut: d.sold_out === true,
            initialQuantity: d.is_unlimited ? 'unlimited' : d.initial_quantity ?? d.quantity ?? 0,
            ratings: [],
            authReal: 0,
            authFake: 0,
            myAuthVote: null,
            prepTime: d.prep_time || undefined,
            status: d.status === 'expired' ? 'expired' : d.status === 'paused' ? 'paused' : d.status === 'deleted' ? 'deleted' : 'active',
            createdAt: isNaN(Number(d.created_at)) ? new Date(d.created_at).getTime() : Number(d.created_at)
        };
        // Only add location fields if they exist in the payload to avoid overwriting with undefined during partial realtime updates
        if ('google_maps_link' in d) deal.googleMapsLink = d.google_maps_link || undefined;
        if ('map_lat' in d && 'map_lng' in d) deal.mapLocation = {
            lat: Number(d.map_lat),
            lng: Number(d.map_lng)
        };
        if ('region' in d) deal.region = d.region || undefined;
        if ('city' in d) deal.city = d.city || undefined;
        if ('expiry_type' in d && d.expiry_type) deal.expiryType = d.expiry_type;
        if ('expiry_date' in d && d.expiry_date) deal.expiryDate = d.expiry_date;
        // v12.28 — merchant booking limits (NULL → undefined = unlimited)
        if ('max_per_booking' in d) deal.maxPerBooking = d.max_per_booking || undefined;
        if ('max_bookings_per_buyer' in d) deal.maxBookingsPerBuyer = d.max_bookings_per_buyer || undefined;
        if ('rebook_cooldown_minutes' in d) deal.rebookCooldownMinutes = d.rebook_cooldown_minutes || undefined;
        // v12.48 — وسم حملة الموسم
        if ('season_id' in d) deal.seasonId = d.season_id || undefined;
        // v12.53 — اختيارات المنتج
        if ('options' in d) deal.options = Array.isArray(d.options) ? d.options : undefined;
        // v12.61 — نسخ المنتج (تجريبي)
        if ('variants' in d) deal.variants = Array.isArray(d.variants) ? d.variants : undefined;
        // v12.88 — رمز الكاشير للمنتج الأساسي
        if ('pos_sku' in d) deal.posSku = d.pos_sku || undefined;
        // v12.91 — مواقع العرض المتعددة
        if ('locations' in d) deal.locations = Array.isArray(d.locations) ? d.locations : undefined;
        if ('loc_qty_mode' in d) deal.locQtyMode = d.loc_qty_mode || undefined;
        // v11.20 — scheduled launch (Coming Soon). Stored as BIGINT epoch ms.
        if ('starts_at' in d && d.starts_at != null) deal.startsAt = isNaN(Number(d.starts_at)) ? new Date(d.starts_at).getTime() : Number(d.starts_at);
        // Analytics counters (migration v13). Optional — older rows may be null.
        if ('views' in d && d.views != null) deal.views = Number(d.views) || 0;
        if ('clicks' in d && d.clicks != null) deal.clicks = Number(d.clicks) || 0;
        // v13.24 — عدّادات مثبّتة على الصف بـtriggers في القاعدة. وجودها يُغني
        // الصفحة عن جولتَي شبكة (صفوف التقييمات + نداء عدّ الأصالة).
        if ('auth_real_count' in d && d.auth_real_count != null) deal.authReal = Number(d.auth_real_count) || 0;
        if ('auth_fake_count' in d && d.auth_fake_count != null) deal.authFake = Number(d.auth_fake_count) || 0;
        if ('rating_avg' in d && d.rating_avg != null) deal.ratingAvg = Number(d.rating_avg) || 0;
        if ('rating_count' in d && d.rating_count != null) deal.ratingCount = Number(d.rating_count) || 0;
        return deal;
    }
};

});
parcelRegister("hUL2G", function(module, exports) {

$parcel$export(module.exports, "supabaseConfig", function () { return $25e6b85587bef04e$export$da678c20ae59ed21; });
$parcel$export(module.exports, "supabase", function () { return $25e6b85587bef04e$export$a0b632a28672d3c0; });

var $hcJhr = parcelRequire("hcJhr");

var $4aj47 = parcelRequire("4aj47");
const $25e6b85587bef04e$var$supabaseUrl = "https://api.takisa.net";
const $25e6b85587bef04e$var$supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzg1OTQ3NjIwLCJleHAiOjE5NDM2Mjc2MjB9.o4D4BvvZvLyjV0jQJrcp8y2TMS8a6SOWpmMMK_95ia0";
if (!$25e6b85587bef04e$var$supabaseUrl || !$25e6b85587bef04e$var$supabaseAnonKey) throw new Error("[TAKI] Missing Supabase environment variables. Set SUPABASE_URL and SUPABASE_ANON_KEY in your .env before starting the app.");
const $25e6b85587bef04e$export$da678c20ae59ed21 = {
    url: $25e6b85587bef04e$var$supabaseUrl,
    key: $25e6b85587bef04e$var$supabaseAnonKey
};
// Custom auth lock: serialise token-refresh attempts within this tab so a
// fresh request can never "steal" the lock from a still-running one. The
// default Web Locks adapter throws "another request stole it" when the
// browser revokes a stale lock; that warning was bubbling up to users via
// the deal-save error toast. A simple in-tab promise queue avoids it
// entirely without weakening security (cross-tab coordination still works
// through localStorage events).
let $25e6b85587bef04e$var$authQueue = Promise.resolve();
const $25e6b85587bef04e$var$inTabLock = async (_name, _acquireTimeout, fn)=>{
    const run = $25e6b85587bef04e$var$authQueue.then(()=>fn());
    $25e6b85587bef04e$var$authQueue = run.catch(()=>undefined);
    return run;
};
// v13.58 — الجلسة تُحفظ بمفتاح ثابت ('sb-taki-auth') لا يتغيّر بتغيّر الخادم،
// فعند نقل قاعدة البيانات إلى خادم آخر تبقى الجلسة القديمة في المتصفح ويرفضها
// الخادم الجديد لأنها موقّعة بمفتاح مختلف. النتيجة: التطبيق يظنّ المستخدم داخلاً
// بينما كل طلب يفشل بصمت، فتظهر الحجوزات والطلبات والمنتجات فارغة — بلاغ ناصر.
// نتحقّق هنا من أن مُصدِر التوكن (iss) هو هذا الخادم، وإلا نمسح الجلسة فوراً
// ليُطلب تسجيل الدخول بوضوح بدل صفحات فارغة.
const $25e6b85587bef04e$var$AUTH_STORAGE_KEY = 'sb-taki-auth';
// v13.87 — الفحص كان يقارن مُصدِر التوكن بعنوان الخادم **نصّاً**، فأي تغيير
// في الاسم — لا في الخادم — يُسقط كل الجلسات. ولمّا صار للخادم نفسه اسمان
// (`api.takisa.net` الجديد و`…sslip.io` القديم) ظهر الخطر بوضوح:
//   • التطبيق على الاسم الجديد + توكن مُصدَره الاسم القديم ⇒ يُمسح
//   • يسجّل المستخدم دخولاً، فيُصدِر الخادم توكناً بالاسم القديم مجدداً ⇒ يُمسح
//   ⇒ **حلقة تسجيل دخول لا تنتهي** لكل المستخدمين.
// والتوكن في هذه الحالة **صحيح تماماً**: نفس الخادم ونفس مفتاح التوقيع، ولا
// يرفضه إلا فحصنا نحن. فالسؤال الصحيح ليس «هل النصّ متطابق؟» بل «هل هذا
// المُصدِر خادمٌ نثق به؟».
const $25e6b85587bef04e$var$TRUSTED_ISSUER_HOSTS = [
    (()=>{
        try {
            return new URL($25e6b85587bef04e$var$supabaseUrl).host;
        } catch  {
            return '';
        }
    })(),
    'api.takisa.net',
    // 🪤 ويبقى الاسمُ القديم **هنا وحده** (v15.32): هذه قائمةُ **قَبولِ
    //    مُصدِري توكن** لا قائمةُ سماحٍ شبكيّ — إسقاطُها يُخرج جلسةَ من
    //    بقي توكنُه من قبل ١٩ أكتوبر، ولا يمنحها شيئاً (التوكن يبقى موقَّعاً
    //    بسرّنا، ومن يملك العنوانَ القديم لا يملك السرّ). وأُسقط من سياسة
    //    الأمان والخدمة العاملة لأن هناك **منحٌ** لا قَبول.
    '141-147-142-147.sslip.io'
].filter(Boolean);
const $25e6b85587bef04e$var$dropForeignSession = ()=>{
    try {
        if (typeof window === 'undefined' || !window.localStorage) return;
        const raw = window.localStorage.getItem($25e6b85587bef04e$var$AUTH_STORAGE_KEY);
        if (!raw) return;
        const token = JSON.parse(raw)?.access_token;
        if (typeof token !== 'string' || token.split('.').length !== 3) return;
        const claims = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        const issuer = String(claims?.iss || '');
        if (!issuer) return;
        // مُصدِر غير قابل للتحليل كعنوان (مثل 'supabase') يبقى مقبولاً كما كان
        // قبل هذا التغيير — لا نوسّع الرفض إلى حالات لم تكن مرفوضة.
        let host = '';
        try {
            host = new URL(issuer).host;
        } catch  {
            return;
        }
        if (!$25e6b85587bef04e$var$TRUSTED_ISSUER_HOSTS.includes(host)) {
            window.localStorage.removeItem($25e6b85587bef04e$var$AUTH_STORAGE_KEY);
            (0, $4aj47.logger).log("\uD83D\uDD04 \u062C\u0644\u0633\u0629 \u0645\u0646 \u062E\u0627\u062F\u0645 \u063A\u064A\u0631 \u0645\u0648\u062B\u0648\u0642 \u2014 \u0623\u064F\u0632\u064A\u0644\u062A\u060C \u064A\u0644\u0632\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0646 \u062C\u062F\u064A\u062F");
        }
    } catch  {}
};
$25e6b85587bef04e$var$dropForeignSession();
// شبكة أمان ثانية: لو رفض الخادم التوكن أثناء الاستخدام (منتهٍ أو غير صالح)،
// امسح الجلسة وأعد التحميل مرة واحدة فقط بدل إظهار صفحات فارغة بلا تفسير.
let $25e6b85587bef04e$var$recovering = false;
const $25e6b85587bef04e$var$fetchWithAuthRecovery = async (input, init)=>{
    const res = await fetch(input, init);
    if (res.status === 401 && !$25e6b85587bef04e$var$recovering && typeof window !== 'undefined' && window.localStorage?.getItem($25e6b85587bef04e$var$AUTH_STORAGE_KEY)) try {
        const body = await res.clone().text();
        if (/JWS|JWT|invalid.*token|expired/i.test(body)) {
            $25e6b85587bef04e$var$recovering = true;
            window.localStorage.removeItem($25e6b85587bef04e$var$AUTH_STORAGE_KEY);
            (0, $4aj47.logger).log("\uD83D\uDD04 \u0627\u0644\u062A\u0648\u0643\u0646 \u0645\u0631\u0641\u0648\u0636 \u0645\u0646 \u0627\u0644\u062E\u0627\u062F\u0645 \u2014 \u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644");
            window.location.reload();
        }
    } catch  {}
    return res;
};
const $25e6b85587bef04e$export$a0b632a28672d3c0 = (0, $hcJhr.createClient)($25e6b85587bef04e$var$supabaseUrl, $25e6b85587bef04e$var$supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: $25e6b85587bef04e$var$AUTH_STORAGE_KEY,
        lock: $25e6b85587bef04e$var$inTabLock
    },
    global: {
        fetch: $25e6b85587bef04e$var$fetchWithAuthRecovery
    },
    realtime: {
        params: {
            eventsPerSecond: 10
        }
    }
});
(0, $4aj47.logger).log("\uD83D\uDD17 Database Layer Initialized: Connected to Supabase");

});
parcelRegister("hcJhr", function(module, exports) {

$parcel$export(module.exports, "createClient", function () { return $0b606d376b05073b$export$5d730b7aed1a3eb0; });

var $hkzgb = parcelRequire("hkzgb");

var $exYGy = parcelRequire("exYGy");
parcelRequire("gbNQh");
var $kPw4N = parcelRequire("kPw4N");

var $98dH0 = parcelRequire("98dH0");
parcelRequire("aElLJ");
var $4KbMQ = parcelRequire("4KbMQ");
//#region src/lib/version.ts
const $0b606d376b05073b$var$version = "2.105.1";
//#endregion
//#region src/lib/constants.ts
let $0b606d376b05073b$var$JS_ENV = "";
if (typeof Deno !== "undefined") $0b606d376b05073b$var$JS_ENV = "deno";
else if (typeof document !== "undefined") $0b606d376b05073b$var$JS_ENV = "web";
else if (typeof navigator !== "undefined" && navigator.product === "ReactNative") $0b606d376b05073b$var$JS_ENV = "react-native";
else $0b606d376b05073b$var$JS_ENV = "node";
const $0b606d376b05073b$var$DEFAULT_HEADERS = {
    "X-Client-Info": `supabase-js-${$0b606d376b05073b$var$JS_ENV}/${$0b606d376b05073b$var$version}`
};
const $0b606d376b05073b$var$DEFAULT_GLOBAL_OPTIONS = {
    headers: $0b606d376b05073b$var$DEFAULT_HEADERS
};
const $0b606d376b05073b$var$DEFAULT_DB_OPTIONS = {
    schema: "public"
};
const $0b606d376b05073b$var$DEFAULT_AUTH_OPTIONS = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit"
};
const $0b606d376b05073b$var$DEFAULT_REALTIME_OPTIONS = {};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $0b606d376b05073b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0b606d376b05073b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $0b606d376b05073b$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $0b606d376b05073b$var$toPrimitive(t, r) {
    if ("object" != $0b606d376b05073b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0b606d376b05073b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $0b606d376b05073b$var$toPropertyKey(t) {
    var i = $0b606d376b05073b$var$toPrimitive(t, "string");
    return "symbol" == $0b606d376b05073b$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $0b606d376b05073b$var$_defineProperty(e, r, t) {
    return (r = $0b606d376b05073b$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $0b606d376b05073b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0b606d376b05073b$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0b606d376b05073b$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $0b606d376b05073b$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0b606d376b05073b$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/fetch.ts
const $0b606d376b05073b$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $0b606d376b05073b$var$resolveHeadersConstructor = ()=>{
    return Headers;
};
const $0b606d376b05073b$var$fetchWithAuth = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch$1 = $0b606d376b05073b$var$resolveFetch(customFetch);
    const HeadersConstructor = $0b606d376b05073b$var$resolveHeadersConstructor();
    return async (input, init)=>{
        var _await$getAccessToken;
        const accessToken = (_await$getAccessToken = await getAccessToken()) !== null && _await$getAccessToken !== void 0 ? _await$getAccessToken : supabaseKey;
        let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
        if (!headers.has("apikey")) headers.set("apikey", supabaseKey);
        if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${accessToken}`);
        return fetch$1(input, $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, init), {}, {
            headers: headers
        }));
    };
};
//#endregion
//#region src/lib/helpers.ts
function $0b606d376b05073b$var$ensureTrailingSlash(url) {
    return url.endsWith("/") ? url : url + "/";
}
function $0b606d376b05073b$var$applySettingDefaults(options, defaults) {
    var _DEFAULT_GLOBAL_OPTIO, _globalOptions$header;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS$1, auth: DEFAULT_AUTH_OPTIONS$1, realtime: DEFAULT_REALTIME_OPTIONS$1, global: DEFAULT_GLOBAL_OPTIONS$1 } = defaults;
    const result = {
        db: $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, DEFAULT_DB_OPTIONS$1), dbOptions),
        auth: $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, DEFAULT_AUTH_OPTIONS$1), authOptions),
        realtime: $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, DEFAULT_REALTIME_OPTIONS$1), realtimeOptions),
        storage: {},
        global: $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, DEFAULT_GLOBAL_OPTIONS$1), globalOptions), {}, {
            headers: $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, (_DEFAULT_GLOBAL_OPTIO = DEFAULT_GLOBAL_OPTIONS$1 === null || DEFAULT_GLOBAL_OPTIONS$1 === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS$1.headers) !== null && _DEFAULT_GLOBAL_OPTIO !== void 0 ? _DEFAULT_GLOBAL_OPTIO : {}), (_globalOptions$header = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _globalOptions$header !== void 0 ? _globalOptions$header : {})
        }),
        accessToken: async ()=>""
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else delete result.accessToken;
    return result;
}
/**
* Validates a Supabase client URL
*
* @param {string} supabaseUrl - The Supabase client URL string.
* @returns {URL} - The validated base URL.
* @throws {Error}
*/ function $0b606d376b05073b$var$validateSupabaseUrl(supabaseUrl) {
    const trimmedUrl = supabaseUrl === null || supabaseUrl === void 0 ? void 0 : supabaseUrl.trim();
    if (!trimmedUrl) throw new Error("supabaseUrl is required.");
    if (!trimmedUrl.match(/^https?:\/\//i)) throw new Error("Invalid supabaseUrl: Must be a valid HTTP or HTTPS URL.");
    try {
        return new URL($0b606d376b05073b$var$ensureTrailingSlash(trimmedUrl));
    } catch (_unused) {
        throw Error("Invalid supabaseUrl: Provided URL is malformed.");
    }
}
//#endregion
//#region src/lib/SupabaseAuthClient.ts
var $0b606d376b05073b$var$SupabaseAuthClient = class extends (0, $4KbMQ.default) {
    constructor(options){
        super(options);
    }
};
//#endregion
//#region src/SupabaseClient.ts
/**
* Supabase Client.
*
* An isomorphic Javascript client for interacting with Postgres.
*/ var $0b606d376b05073b$export$1bfe63e045eb2ffa = class {
    /**
	* Create a new client for use in the browser.
	*
	* @category Initializing
	*
	* @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
	* @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
	* @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
	* @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
	* @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
	* @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
	* @param options.realtime Options passed along to realtime-js constructor.
	* @param options.storage Options passed along to the storage-js constructor.
	* @param options.global.fetch A custom fetch implementation.
	* @param options.global.headers Any additional headers to send with each network request.
	*
	* @example Creating a client
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Create a single supabase client for interacting with your database
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* ```
	*
	* @example With a custom domain
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Use a custom domain as the supabase URL
	* const supabase = createClient('https://my-custom-domain.com', 'your-publishable-key')
	* ```
	*
	* @example With additional parameters
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const options = {
	*   db: {
	*     schema: 'public',
	*   },
	*   auth: {
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: true
	*   },
	*   global: {
	*     headers: { 'x-my-custom-header': 'my-app-name' },
	*   },
	* }
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", options)
	* ```
	*
	* @exampleDescription With custom schemas
	* By default the API server points to the `public` schema. You can enable other database schemas within the Dashboard.
	* Go to [Settings > API > Exposed schemas](/dashboard/project/_/settings/api) and add the schema which you want to expose to the API.
	*
	* Note: each client connection can only access a single schema, so the code above can access the `other_schema` schema but cannot access the `public` schema.
	*
	* @example With custom schemas
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
	*   // Provide a custom schema. Defaults to "public".
	*   db: { schema: 'other_schema' }
	* })
	* ```
	*
	* @exampleDescription Custom fetch implementation
	* `supabase-js` uses the [`cross-fetch`](https://www.npmjs.com/package/cross-fetch) library to make HTTP requests,
	* but an alternative `fetch` implementation can be provided as an option.
	* This is most useful in environments where `cross-fetch` is not compatible (for instance Cloudflare Workers).
	*
	* @example Custom fetch implementation
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
	*   global: { fetch: fetch.bind(globalThis) }
	* })
	* ```
	*
	* @exampleDescription React Native options with AsyncStorage
	* For React Native we recommend using `AsyncStorage` as the storage implementation for Supabase Auth.
	*
	* @example React Native options with AsyncStorage
	* ```js
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from "@react-native-async-storage/async-storage";
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", {
	*   auth: {
	*     storage: AsyncStorage,
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @exampleDescription React Native options with Expo SecureStore
	* If you wish to encrypt the user's session information, you can use `aes-js` and store the encryption key in Expo SecureStore.
	* The `aes-js` library, a reputable JavaScript-only implementation of the AES encryption algorithm in CTR mode.
	* A new 256-bit encryption key is generated using the `react-native-get-random-values` library.
	* This key is stored inside Expo's SecureStore, while the value is encrypted and placed inside AsyncStorage.
	*
	* Please make sure that:
	* - You keep the `expo-secure-store`, `aes-js` and `react-native-get-random-values` libraries up-to-date.
	* - Choose the correct [`SecureStoreOptions`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestoreoptions) for your app's needs.
	*   E.g. [`SecureStore.WHEN_UNLOCKED`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestorewhen_unlocked) regulates when the data can be accessed.
	* - Carefully consider optimizations or other modifications to the above example, as those can lead to introducing subtle security vulnerabilities.
	*
	* @example React Native options with Expo SecureStore
	* ```ts
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from '@react-native-async-storage/async-storage';
	* import * as SecureStore from 'expo-secure-store';
	* import * as aesjs from 'aes-js';
	* import 'react-native-get-random-values';
	*
	* // As Expo's SecureStore does not support values larger than 2048
	* // bytes, an AES-256 key is generated and stored in SecureStore, while
	* // it is used to encrypt/decrypt values stored in AsyncStorage.
	* class LargeSecureStore {
	*   private async _encrypt(key: string, value: string) {
	*     const encryptionKey = crypto.getRandomValues(new Uint8Array(256 / 8));
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(encryptionKey, new aesjs.Counter(1));
	*     const encryptedBytes = cipher.encrypt(aesjs.utils.utf8.toBytes(value));
	*
	*     await SecureStore.setItemAsync(key, aesjs.utils.hex.fromBytes(encryptionKey));
	*
	*     return aesjs.utils.hex.fromBytes(encryptedBytes);
	*   }
	*
	*   private async _decrypt(key: string, value: string) {
	*     const encryptionKeyHex = await SecureStore.getItemAsync(key);
	*     if (!encryptionKeyHex) {
	*       return encryptionKeyHex;
	*     }
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(aesjs.utils.hex.toBytes(encryptionKeyHex), new aesjs.Counter(1));
	*     const decryptedBytes = cipher.decrypt(aesjs.utils.hex.toBytes(value));
	*
	*     return aesjs.utils.utf8.fromBytes(decryptedBytes);
	*   }
	*
	*   async getItem(key: string) {
	*     const encrypted = await AsyncStorage.getItem(key);
	*     if (!encrypted) { return encrypted; }
	*
	*     return await this._decrypt(key, encrypted);
	*   }
	*
	*   async removeItem(key: string) {
	*     await AsyncStorage.removeItem(key);
	*     await SecureStore.deleteItemAsync(key);
	*   }
	*
	*   async setItem(key: string, value: string) {
	*     const encrypted = await this._encrypt(key, value);
	*
	*     await AsyncStorage.setItem(key, encrypted);
	*   }
	* }
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", {
	*   auth: {
	*     storage: new LargeSecureStore(),
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @example With a database query
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	*
	* const { data } = await supabase.from('profiles').select('*')
	* ```
	*/ constructor(supabaseUrl, supabaseKey, options){
        var _settings$auth$storag, _settings$global$head;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        const baseUrl = $0b606d376b05073b$var$validateSupabaseUrl(supabaseUrl);
        if (!supabaseKey) throw new Error("supabaseKey is required.");
        this.realtimeUrl = new URL("realtime/v1", baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace("http", "ws");
        this.authUrl = new URL("auth/v1", baseUrl);
        this.storageUrl = new URL("storage/v1", baseUrl);
        this.functionsUrl = new URL("functions/v1", baseUrl);
        const defaultStorageKey = `sb-${baseUrl.hostname.split(".")[0]}-auth-token`;
        const DEFAULTS = {
            db: $0b606d376b05073b$var$DEFAULT_DB_OPTIONS,
            realtime: $0b606d376b05073b$var$DEFAULT_REALTIME_OPTIONS,
            auth: $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, $0b606d376b05073b$var$DEFAULT_AUTH_OPTIONS), {}, {
                storageKey: defaultStorageKey
            }),
            global: $0b606d376b05073b$var$DEFAULT_GLOBAL_OPTIONS
        };
        const settings = $0b606d376b05073b$var$applySettingDefaults(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_settings$auth$storag = settings.auth.storageKey) !== null && _settings$auth$storag !== void 0 ? _settings$auth$storag : "";
        this.headers = (_settings$global$head = settings.global.headers) !== null && _settings$global$head !== void 0 ? _settings$global$head : {};
        if (!settings.accessToken) {
            var _settings$auth;
            this.auth = this._initSupabaseAuthClient((_settings$auth = settings.auth) !== null && _settings$auth !== void 0 ? _settings$auth : {}, this.headers, settings.global.fetch);
        } else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = $0b606d376b05073b$var$fetchWithAuth(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient($0b606d376b05073b$var$_objectSpread2({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this),
            fetch: this.fetch
        }, settings.realtime));
        if (this.accessToken) Promise.resolve(this.accessToken()).then((token)=>this.realtime.setAuth(token)).catch((e)=>console.warn("Failed to set initial Realtime auth token:", e));
        this.rest = new (0, $exYGy.PostgrestClient)(new URL("rest/v1", baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch,
            timeout: settings.db.timeout,
            urlLengthLimit: settings.db.urlLengthLimit
        });
        this.storage = new (0, $98dH0.StorageClient)(this.storageUrl.href, this.headers, this.fetch, options === null || options === void 0 ? void 0 : options.storage);
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
	* Supabase Functions allows you to deploy and invoke edge functions.
	*/ get functions() {
        return new (0, $hkzgb.FunctionsClient)(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*/ from(relation) {
        return this.rest.from(relation);
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*/ schema(schema) {
        return this.rest.schema(schema);
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*/ rpc(fn, args = {}, options = {
        head: false,
        get: false,
        count: void 0
    }) {
        return this.rest.rpc(fn, args, options);
    }
    /**
	* Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
	*
	* @param {string} name - The name of the Realtime channel.
	* @param {Object} opts - The options to pass to the Realtime channel.
	*
	*/ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
	* Returns all Realtime channels.
	*
	* @category Initializing
	*
	* @example Get all channels
	* ```js
	* const channels = supabase.getChannels()
	* ```
	*/ getChannels() {
        return this.realtime.getChannels();
    }
    /**
	* Unsubscribes and removes Realtime channel from Realtime client.
	*
	* @param {RealtimeChannel} channel - The name of the Realtime channel.
	*
	*
	* @category Initializing
	*
	* @remarks
	* - Removing a channel is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
	*
	* @example Removes a channel
	* ```js
	* supabase.removeChannel(myChannel)
	* ```
	*/ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
	* Unsubscribes and removes all Realtime channels from Realtime client.
	*
	* @category Initializing
	*
	* @remarks
	* - Removing channels is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
	*
	* @example Remove all channels
	* ```js
	* supabase.removeAllChannels()
	* ```
	*/ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    async _getAccessToken() {
        var _this = this;
        var _data$session$access_, _data$session;
        if (_this.accessToken) return await _this.accessToken();
        const { data: data } = await _this.auth.getSession();
        return (_data$session$access_ = (_data$session = data.session) === null || _data$session === void 0 ? void 0 : _data$session.access_token) !== null && _data$session$access_ !== void 0 ? _data$session$access_ : _this.supabaseKey;
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, userStorage: userStorage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug, throwOnError: throwOnError, experimental: experimental }, headers, fetch$1) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new $0b606d376b05073b$var$SupabaseAuthClient({
            url: this.authUrl.href,
            headers: $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            userStorage: userStorage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            throwOnError: throwOnError,
            experimental: experimental,
            fetch: fetch$1,
            hasCustomAuthorizationHeader: Object.keys(this.headers).some((key)=>key.toLowerCase() === "authorization")
        });
    }
    _initRealtimeClient(options) {
        return new (0, $kPw4N.default)(this.realtimeUrl.href, $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, options), {}, {
            params: $0b606d376b05073b$var$_objectSpread2($0b606d376b05073b$var$_objectSpread2({}, {
                apikey: this.supabaseKey
            }), options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        return this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, "CLIENT", session === null || session === void 0 ? void 0 : session.access_token);
        });
    }
    _handleTokenChanged(event, source, token) {
        if ((event === "TOKEN_REFRESHED" || event === "SIGNED_IN") && this.changedAccessToken !== token) {
            this.changedAccessToken = token;
            this.realtime.setAuth(token);
        } else if (event === "SIGNED_OUT") {
            this.realtime.setAuth();
            if (source == "STORAGE") this.auth.signOut();
            this.changedAccessToken = void 0;
        }
    }
};
//#endregion
//#region src/index.ts
/**
* Creates a new Supabase Client.
*
* @example Creating a Supabase client
* ```ts
* import { createClient } from '@supabase/supabase-js'
*
* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
* const { data, error } = await supabase.from('profiles').select('*')
* ```
*/ const $0b606d376b05073b$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new $0b606d376b05073b$export$1bfe63e045eb2ffa(supabaseUrl, supabaseKey, options);
};
function $0b606d376b05073b$var$shouldShowDeprecationWarning() {
    if (typeof window !== "undefined") return false;
    const _process = globalThis["process"];
    if (!_process) return false;
    const processVersion = _process["version"];
    if (processVersion === void 0 || processVersion === null) return false;
    const versionMatch = processVersion.match(/^v(\d+)\./);
    if (!versionMatch) return false;
    return parseInt(versionMatch[1], 10) <= 18;
}
if ($0b606d376b05073b$var$shouldShowDeprecationWarning()) console.warn("\u26A0\uFE0F  Node.js 18 and below are deprecated and will no longer be supported in future versions of @supabase/supabase-js. Please upgrade to Node.js 20 or later. For more information, visit: https://github.com/orgs/supabase/discussions/37217");

});
parcelRegister("hkzgb", function(module, exports) {

$parcel$export(module.exports, "FunctionsClient", function () { return $c9dfa7d8c5dd2f7c$export$1d0b400bf8a0fa55; });

var $jMaHP = parcelRequire("jMaHP");

var $k7Z6u = parcelRequire("k7Z6u");

var $cNATS = parcelRequire("cNATS");
class $c9dfa7d8c5dd2f7c$export$1d0b400bf8a0fa55 {
    /**
     * Creates a new Functions client bound to an Edge Functions URL.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const { data, error } = await supabase.functions.invoke('hello-world')
     * ```
     *
     * @category Functions
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { FunctionsClient, FunctionRegion } from '@supabase/functions-js'
     *
     * const functions = new FunctionsClient('https://xyzcompany.supabase.co/functions/v1', {
     *   headers: { apikey: 'your-publishable-key' },
     *   region: FunctionRegion.UsEast1,
     * })
     * ```
     */ constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $cNATS.FunctionRegion).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $k7Z6u.resolveFetch)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     *
     * @category Functions
     *
     * @example Setting the authorization header
     * ```ts
     * functions.setAuth(session.access_token)
     * ```
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     * @example
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     *
     * @category Functions
     *
     * @remarks
     * - Requires an Authorization header.
     * - Invoke params generally match the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API) spec.
     * - When you pass in a body to your function, we automatically attach the Content-Type header for `Blob`, `ArrayBuffer`, `File`, `FormData` and `String`. If it doesn't match any of these types we assume the payload is `json`, serialize it and attach the `Content-Type` header as `application/json`. You can override this behavior by passing in a `Content-Type` header of your own.
     * - Responses are automatically parsed as `json`, `blob` and `form-data` depending on the `Content-Type` header sent by your function. Responses are parsed as `text` by default.
     *
     * @example Basic invocation
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   body: { foo: 'bar' }
     * })
     * ```
     *
     * @exampleDescription Error handling
     * A `FunctionsHttpError` error is returned if your function throws an error, `FunctionsRelayError` if the Supabase Relay has an error processing your function and `FunctionsFetchError` if there is a network error in calling your function.
     *
     * @example Error handling
     * ```js
     * import { FunctionsHttpError, FunctionsRelayError, FunctionsFetchError } from "@supabase/supabase-js";
     *
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' }
     * })
     *
     * if (error instanceof FunctionsHttpError) {
     *   const errorMessage = await error.context.json()
     *   console.log('Function returned an error', errorMessage)
     * } else if (error instanceof FunctionsRelayError) {
     *   console.log('Relay error:', error.message)
     * } else if (error instanceof FunctionsFetchError) {
     *   console.log('Fetch error:', error.message)
     * }
     * ```
     *
     * @exampleDescription Passing custom headers
     * You can pass custom headers to your function. Note: supabase-js automatically passes the `Authorization` header with the signed in user's JWT.
     *
     * @example Passing custom headers
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' }
     * })
     * ```
     *
     * @exampleDescription Calling with DELETE HTTP verb
     * You can also set the HTTP verb to `DELETE` when calling your Edge Function.
     *
     * @example Calling with DELETE HTTP verb
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' },
     *   method: 'DELETE'
     * })
     * ```
     *
     * @exampleDescription Invoking a Function in the UsEast1 region
     * Here are the available regions:
     * - `FunctionRegion.Any`
     * - `FunctionRegion.ApNortheast1`
     * - `FunctionRegion.ApNortheast2`
     * - `FunctionRegion.ApSouth1`
     * - `FunctionRegion.ApSoutheast1`
     * - `FunctionRegion.ApSoutheast2`
     * - `FunctionRegion.CaCentral1`
     * - `FunctionRegion.EuCentral1`
     * - `FunctionRegion.EuWest1`
     * - `FunctionRegion.EuWest2`
     * - `FunctionRegion.EuWest3`
     * - `FunctionRegion.SaEast1`
     * - `FunctionRegion.UsEast1`
     * - `FunctionRegion.UsWest1`
     * - `FunctionRegion.UsWest2`
     *
     * @example Invoking a Function in the UsEast1 region
     * ```js
     * import { createClient, FunctionRegion } from '@supabase/supabase-js'
     *
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   body: { foo: 'bar' },
     *   region: FunctionRegion.UsEast1
     * })
     * ```
     *
     * @exampleDescription Calling with GET HTTP verb
     * You can also set the HTTP verb to `GET` when calling your Edge Function.
     *
     * @example Calling with GET HTTP verb
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   method: 'GET'
     * })
     * ```
     *
     * @example Example 7
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     */ invoke(functionName_1) {
        return (0, $jMaHP.__awaiter)(this, arguments, void 0, function*(functionName, options = {}) {
            var _a;
            let timeoutId;
            let timeoutController;
            try {
                const { headers: headers, method: method, body: functionArgs, signal: signal, timeout: timeout } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                // Add region as query parameter using URL API
                const url = new URL(`${this.url}/${functionName}`);
                if (region && region !== 'any') {
                    _headers['x-region'] = region;
                    url.searchParams.set('forceFunctionRegion', region);
                }
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                } else if (functionArgs && typeof functionArgs !== 'string' && !(typeof Blob !== 'undefined' && functionArgs instanceof Blob) && !(functionArgs instanceof ArrayBuffer) && !(typeof FormData !== 'undefined' && functionArgs instanceof FormData)) body = JSON.stringify(functionArgs);
                else body = functionArgs;
                // Handle timeout by creating an AbortController
                let effectiveSignal = signal;
                if (timeout) {
                    timeoutController = new AbortController();
                    timeoutId = setTimeout(()=>timeoutController.abort(), timeout);
                    // If user provided their own signal, we need to respect both
                    if (signal) {
                        effectiveSignal = timeoutController.signal;
                        // If the user's signal is aborted, abort our timeout controller too
                        signal.addEventListener('abort', ()=>timeoutController.abort());
                    } else effectiveSignal = timeoutController.signal;
                }
                const response = yield this.fetch(url.toString(), {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body,
                    signal: effectiveSignal
                }).catch((fetchError)=>{
                    throw new (0, $cNATS.FunctionsFetchError)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $cNATS.FunctionsRelayError)(response);
                if (!response.ok) throw new (0, $cNATS.FunctionsHttpError)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream' || responseType === 'application/pdf') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null,
                    response: response
                };
            } catch (error) {
                return {
                    data: null,
                    error: error,
                    response: error instanceof (0, $cNATS.FunctionsHttpError) || error instanceof (0, $cNATS.FunctionsRelayError) ? error.context : undefined
                };
            } finally{
                // Clear the timeout if it was set
                if (timeoutId) clearTimeout(timeoutId);
            }
        });
    }
}

});
parcelRegister("jMaHP", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $e65acdff47129de2$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $e65acdff47129de2$export$1050f835b63b671e; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e65acdff47129de2$var$extendStatics = function(d, b) {
    $e65acdff47129de2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e65acdff47129de2$var$extendStatics(d, b);
};
function $e65acdff47129de2$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e65acdff47129de2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e65acdff47129de2$export$18ce0697a983be9b = function() {
    $e65acdff47129de2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e65acdff47129de2$export$18ce0697a983be9b.apply(this, arguments);
};
function $e65acdff47129de2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e65acdff47129de2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e65acdff47129de2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e65acdff47129de2$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e65acdff47129de2$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e65acdff47129de2$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e65acdff47129de2$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e65acdff47129de2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e65acdff47129de2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e65acdff47129de2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e65acdff47129de2$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e65acdff47129de2$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e65acdff47129de2$export$45d3717a4c69092e(o, m, p);
}
function $e65acdff47129de2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e65acdff47129de2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e65acdff47129de2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e65acdff47129de2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e65acdff47129de2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e65acdff47129de2$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e65acdff47129de2$export$10c90e4f7922046c(v) {
    return this instanceof $e65acdff47129de2$export$10c90e4f7922046c ? (this.v = v, this) : new $e65acdff47129de2$export$10c90e4f7922046c(v);
}
function $e65acdff47129de2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e65acdff47129de2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e65acdff47129de2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e65acdff47129de2$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e65acdff47129de2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e65acdff47129de2$export$19a8beecd37a4c45 === "function" ? $e65acdff47129de2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e65acdff47129de2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e65acdff47129de2$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e65acdff47129de2$var$ownKeys = function(o) {
    $e65acdff47129de2$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e65acdff47129de2$var$ownKeys(o);
};
function $e65acdff47129de2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e65acdff47129de2$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e65acdff47129de2$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e65acdff47129de2$var$__setModuleDefault(result, mod);
    return result;
}
function $e65acdff47129de2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e65acdff47129de2$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e65acdff47129de2$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e65acdff47129de2$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e65acdff47129de2$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e65acdff47129de2$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e65acdff47129de2$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e65acdff47129de2$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e65acdff47129de2$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e65acdff47129de2$export$2e2bcd8739ae039 = {
    __extends: $e65acdff47129de2$export$a8ba968b8961cb8a,
    __assign: $e65acdff47129de2$export$18ce0697a983be9b,
    __rest: $e65acdff47129de2$export$3c9a16f847548506,
    __decorate: $e65acdff47129de2$export$29e00dfd3077644b,
    __param: $e65acdff47129de2$export$d5ad3fd78186038f,
    __esDecorate: $e65acdff47129de2$export$3a84e1ae4e97e9b0,
    __runInitializers: $e65acdff47129de2$export$d831c04e792af3d,
    __propKey: $e65acdff47129de2$export$6a2a36740a146cb8,
    __setFunctionName: $e65acdff47129de2$export$d1a06452d3489bc7,
    __metadata: $e65acdff47129de2$export$f1db080c865becb9,
    __awaiter: $e65acdff47129de2$export$1050f835b63b671e,
    __generator: $e65acdff47129de2$export$67ebef60e6f28a6,
    __createBinding: $e65acdff47129de2$export$45d3717a4c69092e,
    __exportStar: $e65acdff47129de2$export$f33643c0debef087,
    __values: $e65acdff47129de2$export$19a8beecd37a4c45,
    __read: $e65acdff47129de2$export$8d051b38c9118094,
    __spread: $e65acdff47129de2$export$afc72e2116322959,
    __spreadArrays: $e65acdff47129de2$export$6388937ca91ccae8,
    __spreadArray: $e65acdff47129de2$export$1216008129fb82ed,
    __await: $e65acdff47129de2$export$10c90e4f7922046c,
    __asyncGenerator: $e65acdff47129de2$export$e427f37a30a4de9b,
    __asyncDelegator: $e65acdff47129de2$export$bbd80228419bb833,
    __asyncValues: $e65acdff47129de2$export$e3b29a3d6162315f,
    __makeTemplateObject: $e65acdff47129de2$export$4fb47efe1390b86f,
    __importStar: $e65acdff47129de2$export$c21735bcef00d192,
    __importDefault: $e65acdff47129de2$export$da59b14a69baef04,
    __classPrivateFieldGet: $e65acdff47129de2$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e65acdff47129de2$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e65acdff47129de2$export$81fdc39f203e4e04,
    __addDisposableResource: $e65acdff47129de2$export$88ac25d8e944e405,
    __disposeResources: $e65acdff47129de2$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e65acdff47129de2$export$889dfb5d17574b0b
};

});

parcelRegister("k7Z6u", function(module, exports) {

$parcel$export(module.exports, "resolveFetch", function () { return $ea73dc010f93099e$export$98d92b1aa79f8cc7; });
const $ea73dc010f93099e$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};

});

parcelRegister("cNATS", function(module, exports) {

$parcel$export(module.exports, "FunctionsFetchError", function () { return $02679778b612a115$export$14f2b6540d498ce; });
$parcel$export(module.exports, "FunctionsRelayError", function () { return $02679778b612a115$export$d08a45df86040161; });
$parcel$export(module.exports, "FunctionsHttpError", function () { return $02679778b612a115$export$761f8c0e0fa4624f; });
$parcel$export(module.exports, "FunctionRegion", function () { return $02679778b612a115$export$9b19f1a5abf91e06; });
/**
 * Base error for Supabase Edge Function invocations.
 *
 * @example
 * ```ts
 * import { FunctionsError } from '@supabase/functions-js'
 *
 * throw new FunctionsError('Unexpected error invoking function', 'FunctionsError', {
 *   requestId: 'abc123',
 * })
 * ```
 */ class $02679778b612a115$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            context: this.context
        };
    }
}
class $02679778b612a115$export$14f2b6540d498ce extends $02679778b612a115$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $02679778b612a115$export$d08a45df86040161 extends $02679778b612a115$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $02679778b612a115$export$761f8c0e0fa4624f extends $02679778b612a115$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $02679778b612a115$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($02679778b612a115$export$9b19f1a5abf91e06 || ($02679778b612a115$export$9b19f1a5abf91e06 = {}));

});


parcelRegister("exYGy", function(module, exports) {

$parcel$export(module.exports, "PostgrestClient", function () { return $00ff55c36b74d88e$export$796f32e2ee984aaa; });
//#region src/types/common/common.ts
/**
* Default number of retry attempts.
*/ const $00ff55c36b74d88e$var$DEFAULT_MAX_RETRIES = 3;
/**
* Default exponential backoff delay function.
* Delays: 1s, 2s, 4s, 8s, ... (max 30s)
*
* @param attemptIndex - Zero-based index of the retry attempt
* @returns Delay in milliseconds before the next retry
*/ const $00ff55c36b74d88e$var$getRetryDelay = (attemptIndex)=>Math.min(1e3 * 2 ** attemptIndex, 3e4);
/**
* Status codes that are safe to retry.
* 520 = Cloudflare timeout/connection errors (transient)
* 503 = PostgREST schema cache not yet loaded (transient, signals retry via Retry-After header)
*/ const $00ff55c36b74d88e$var$RETRYABLE_STATUS_CODES = [
    520,
    503
];
/**
* HTTP methods that are safe to retry (idempotent operations).
*/ const $00ff55c36b74d88e$var$RETRYABLE_METHODS = [
    "GET",
    "HEAD",
    "OPTIONS"
];
//#endregion
//#region src/PostgrestError.ts
/**
* Error format
*
* {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
*/ var $00ff55c36b74d88e$export$445b7e3a323f992f = class extends Error {
    /**
	* @example
	* ```ts
	* import PostgrestError from '@supabase/postgrest-js'
	*
	* throw new PostgrestError({
	*   message: 'Row level security prevented the request',
	*   details: 'RLS denied the insert',
	*   hint: 'Check your policies',
	*   code: 'PGRST301',
	* })
	* ```
	*/ constructor(context){
        super(context.message);
        this.name = "PostgrestError";
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            details: this.details,
            hint: this.hint,
            code: this.code
        };
    }
};
//#endregion
//#region src/PostgrestBuilder.ts
/**
* Sleep for a given number of milliseconds.
* If an AbortSignal is provided, the sleep resolves early when the signal is aborted.
*/ function $00ff55c36b74d88e$var$sleep(ms, signal) {
    return new Promise((resolve)=>{
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            resolve();
            return;
        }
        const id = setTimeout(()=>{
            signal === null || signal === void 0 || signal.removeEventListener("abort", onAbort);
            resolve();
        }, ms);
        function onAbort() {
            clearTimeout(id);
            resolve();
        }
        signal === null || signal === void 0 || signal.addEventListener("abort", onAbort);
    });
}
/**
* Check if a request should be retried based on method and status code.
*/ function $00ff55c36b74d88e$var$shouldRetry(method, status, attemptCount, retryEnabled) {
    if (!retryEnabled || attemptCount >= $00ff55c36b74d88e$var$DEFAULT_MAX_RETRIES) return false;
    if (!$00ff55c36b74d88e$var$RETRYABLE_METHODS.includes(method)) return false;
    if (!$00ff55c36b74d88e$var$RETRYABLE_STATUS_CODES.includes(status)) return false;
    return true;
}
var $00ff55c36b74d88e$export$3106e21688a06353 = class {
    /**
	* Creates a builder configured for a specific PostgREST request.
	*
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('users').select('*')
	* ```
	*
	* @category Database
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const builder = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: new Headers({ apikey: 'your-publishable-key' }) }
	* )
	* ```
	*/ constructor(builder){
        var _builder$shouldThrowO, _builder$isMaybeSingl, _builder$shouldStripN, _builder$urlLengthLim, _builder$retry;
        this.shouldThrowOnError = false;
        this.retryEnabled = true;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = new Headers(builder.headers);
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = (_builder$shouldThrowO = builder.shouldThrowOnError) !== null && _builder$shouldThrowO !== void 0 ? _builder$shouldThrowO : false;
        this.signal = builder.signal;
        this.isMaybeSingle = (_builder$isMaybeSingl = builder.isMaybeSingle) !== null && _builder$isMaybeSingl !== void 0 ? _builder$isMaybeSingl : false;
        this.shouldStripNulls = (_builder$shouldStripN = builder.shouldStripNulls) !== null && _builder$shouldStripN !== void 0 ? _builder$shouldStripN : false;
        this.urlLengthLimit = (_builder$urlLengthLim = builder.urlLengthLimit) !== null && _builder$urlLengthLim !== void 0 ? _builder$urlLengthLim : 8e3;
        this.retryEnabled = (_builder$retry = builder.retry) !== null && _builder$retry !== void 0 ? _builder$retry : true;
        if (builder.fetch) this.fetch = builder.fetch;
        else this.fetch = fetch;
    }
    /**
	* If there's an error with the query, throwOnError will reject the promise by
	* throwing the error instead of returning it as part of a successful response.
	*
	* {@link https://github.com/supabase/supabase-js/issues/92}
	*
	* @category Database
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Strip null values from the response data. Properties with `null` values
	* will be omitted from the returned JSON objects.
	*
	* Requires PostgREST 11.2.0+.
	*
	* {@link https://docs.postgrest.org/en/stable/references/api/resource_representation.html#stripped-nulls}
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .stripNulls()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text, bio text);
	*
	* insert into
	*   characters (id, name, bio)
	* values
	*   (1, 'Luke', null),
	*   (2, 'Leia', 'Princess of Alderaan');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia",
	*       "bio": "Princess of Alderaan"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ stripNulls() {
        if (this.headers.get("Accept") === "text/csv") throw new Error("stripNulls() cannot be used with csv()");
        this.shouldStripNulls = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	*
	* @category Database
	*/ setHeader(name, value) {
        this.headers = new Headers(this.headers);
        this.headers.set(name, value);
        return this;
    }
    /**
	* @category Database
	*
	* Configure retry behavior for this request.
	*
	* By default, retries are enabled for idempotent requests (GET, HEAD, OPTIONS)
	* that fail with network errors or specific HTTP status codes (503, 520).
	* Retries use exponential backoff (1s, 2s, 4s) with a maximum of 3 attempts.
	*
	* @param enabled - Whether to enable retries for this request
	*
	* @example
	* ```ts
	* // Disable retries for a specific query
	* const { data, error } = await supabase
	*   .from('users')
	*   .select()
	*   .retry(false)
	* ```
	*/ retry(enabled) {
        this.retryEnabled = enabled;
        return this;
    }
    then(onfulfilled, onrejected) {
        var _this = this;
        if (this.schema === void 0) ;
        else if ([
            "GET",
            "HEAD"
        ].includes(this.method)) this.headers.set("Accept-Profile", this.schema);
        else this.headers.set("Content-Profile", this.schema);
        if (this.method !== "GET" && this.method !== "HEAD") this.headers.set("Content-Type", "application/json");
        if (this.shouldStripNulls) {
            const currentAccept = this.headers.get("Accept");
            if (currentAccept === "application/vnd.pgrst.object+json") this.headers.set("Accept", "application/vnd.pgrst.object+json;nulls=stripped");
            else if (!currentAccept || currentAccept === "application/json") this.headers.set("Accept", "application/vnd.pgrst.array+json;nulls=stripped");
        }
        const _fetch = this.fetch;
        const executeWithRetry = async ()=>{
            let attemptCount = 0;
            while(true){
                const requestHeaders = new Headers(_this.headers);
                if (attemptCount > 0) requestHeaders.set("X-Retry-Count", String(attemptCount));
                let res$1;
                try {
                    res$1 = await _fetch(_this.url.toString(), {
                        method: _this.method,
                        headers: requestHeaders,
                        body: JSON.stringify(_this.body, (_, value)=>typeof value === "bigint" ? value.toString() : value),
                        signal: _this.signal
                    });
                } catch (fetchError) {
                    if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR") throw fetchError;
                    if (!$00ff55c36b74d88e$var$RETRYABLE_METHODS.includes(_this.method)) throw fetchError;
                    if (_this.retryEnabled && attemptCount < $00ff55c36b74d88e$var$DEFAULT_MAX_RETRIES) {
                        const delay = $00ff55c36b74d88e$var$getRetryDelay(attemptCount);
                        attemptCount++;
                        await $00ff55c36b74d88e$var$sleep(delay, _this.signal);
                        continue;
                    }
                    throw fetchError;
                }
                if ($00ff55c36b74d88e$var$shouldRetry(_this.method, res$1.status, attemptCount, _this.retryEnabled)) {
                    var _res$headers$get, _res$headers;
                    const retryAfterHeader = (_res$headers$get = (_res$headers = res$1.headers) === null || _res$headers === void 0 ? void 0 : _res$headers.get("Retry-After")) !== null && _res$headers$get !== void 0 ? _res$headers$get : null;
                    const delay = retryAfterHeader !== null ? Math.max(0, parseInt(retryAfterHeader, 10) || 0) * 1e3 : $00ff55c36b74d88e$var$getRetryDelay(attemptCount);
                    await res$1.text();
                    attemptCount++;
                    await $00ff55c36b74d88e$var$sleep(delay, _this.signal);
                    continue;
                }
                return await _this.processResponse(res$1);
            }
        };
        let res = executeWithRetry();
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _fetchError$name2;
            let errorDetails = "";
            let hint = "";
            let code = "";
            const cause = fetchError === null || fetchError === void 0 ? void 0 : fetchError.cause;
            if (cause) {
                var _cause$message, _cause$code, _fetchError$name, _cause$name;
                const causeMessage = (_cause$message = cause === null || cause === void 0 ? void 0 : cause.message) !== null && _cause$message !== void 0 ? _cause$message : "";
                const causeCode = (_cause$code = cause === null || cause === void 0 ? void 0 : cause.code) !== null && _cause$code !== void 0 ? _cause$code : "";
                errorDetails = `${(_fetchError$name = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name !== void 0 ? _fetchError$name : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`;
                errorDetails += `\n\nCaused by: ${(_cause$name = cause === null || cause === void 0 ? void 0 : cause.name) !== null && _cause$name !== void 0 ? _cause$name : "Error"}: ${causeMessage}`;
                if (causeCode) errorDetails += ` (${causeCode})`;
                if (cause === null || cause === void 0 ? void 0 : cause.stack) errorDetails += `\n${cause.stack}`;
            } else {
                var _fetchError$stack;
                errorDetails = (_fetchError$stack = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _fetchError$stack !== void 0 ? _fetchError$stack : "";
            }
            const urlLength = this.url.toString().length;
            if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR") {
                code = "";
                hint = "Request was aborted (timeout or manual cancellation)";
                if (urlLength > this.urlLengthLimit) hint += `. Note: Your request URL is ${urlLength} characters, which may exceed server limits. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [many IDs])), consider using an RPC function to pass values server-side.`;
            } else if ((cause === null || cause === void 0 ? void 0 : cause.name) === "HeadersOverflowError" || (cause === null || cause === void 0 ? void 0 : cause.code) === "UND_ERR_HEADERS_OVERFLOW") {
                code = "";
                hint = "HTTP headers exceeded server limits (typically 16KB)";
                if (urlLength > this.urlLengthLimit) hint += `. Your request URL is ${urlLength} characters. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [200+ IDs])), consider using an RPC function instead.`;
            }
            return {
                success: false,
                error: {
                    message: `${(_fetchError$name2 = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name2 !== void 0 ? _fetchError$name2 : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: errorDetails,
                    hint: hint,
                    code: code
                },
                data: null,
                count: null,
                status: 0,
                statusText: ""
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
	* Process a fetch response and return the standardized postgrest response.
	*/ async processResponse(res) {
        var _this2 = this;
        let error = null;
        let data = null;
        let count = null;
        let status = res.status;
        let statusText = res.statusText;
        if (res.ok) {
            var _this$headers$get2, _res$headers$get2;
            if (_this2.method !== "HEAD") {
                var _this$headers$get;
                const body = await res.text();
                if (body === "") ;
                else if (_this2.headers.get("Accept") === "text/csv") data = body;
                else if (_this2.headers.get("Accept") && ((_this$headers$get = _this2.headers.get("Accept")) === null || _this$headers$get === void 0 ? void 0 : _this$headers$get.includes("application/vnd.pgrst.plan+text"))) data = body;
                else data = JSON.parse(body);
            }
            const countHeader = (_this$headers$get2 = _this2.headers.get("Prefer")) === null || _this$headers$get2 === void 0 ? void 0 : _this$headers$get2.match(/count=(exact|planned|estimated)/);
            const contentRange = (_res$headers$get2 = res.headers.get("content-range")) === null || _res$headers$get2 === void 0 ? void 0 : _res$headers$get2.split("/");
            if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
            if (_this2.isMaybeSingle && Array.isArray(data)) {
                if (data.length > 1) {
                    error = {
                        code: "PGRST116",
                        details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                        hint: null,
                        message: "JSON object requested, multiple (or no) rows returned"
                    };
                    data = null;
                    count = null;
                    status = 406;
                    statusText = "Not Acceptable";
                } else if (data.length === 1) data = data[0];
                else data = null;
            }
        } else {
            const body = await res.text();
            try {
                error = JSON.parse(body);
                if (Array.isArray(error) && res.status === 404) {
                    data = [];
                    error = null;
                    status = 200;
                    statusText = "OK";
                }
            } catch (_unused) {
                if (res.status === 404 && body === "") {
                    status = 204;
                    statusText = "No Content";
                } else error = {
                    message: body
                };
            }
            if (error && _this2.shouldThrowOnError) throw new $00ff55c36b74d88e$export$445b7e3a323f992f(error);
        }
        return {
            success: error === null,
            error: error,
            data: data,
            count: count,
            status: status,
            statusText: statusText
        };
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	*/ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
	* Override the type of the returned `data` field in the response.
	*
	* @typeParam NewResult - The new type to cast the response data to
	* @typeParam Options - Optional type configuration (defaults to { merge: true })
	* @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
	* @example
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	* @returns A PostgrestBuilder instance with the new type
	*
	* @category Database
	*
	* @example Complete Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<MyType>, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of successful response
	* ```ts
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Complete Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<MyType, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of object response
	* ```ts
	* let x: typeof data // MyType | null
	* ```
	*
	* @example Partial Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<{ status: "A" | "B" }>>()
	* ```
	*
	* @exampleResponse Partial Override type of successful response
	* ```ts
	* let x: typeof data // Array<CountryRowProperties & { status: "A" | "B" }>
	* ```
	*
	* @example Partial Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<{ status: "A" | "B" }>()
	* ```
	*
	* @exampleResponse Partial Override type of object response
	* ```ts
	* let x: typeof data // CountryRowProperties & { status: "A" | "B" } | null
	* ```
	*
	* @example Example 5
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	*/ overrideTypes() {
        return this;
    }
};
//#endregion
//#region src/PostgrestTransformBuilder.ts
var $00ff55c36b74d88e$export$7b4361bb87e3030c = class extends $00ff55c36b74d88e$export$3106e21688a06353 {
    /**
	* Perform a SELECT on the query result.
	*
	* By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
	* return modified rows. By calling this method, modified rows are returned in
	* `data`.
	*
	* @param columns - The columns to retrieve, separated by commas
	*
	* @category Database
	*
	* @example With `upsert()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .upsert({ id: 1, name: 'Han Solo' })
	*   .select()
	* ```
	*
	* @exampleSql With `upsert()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Han');
	* ```
	*
	* @exampleResponse With `upsert()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Han Solo"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*/ select(columns) {
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        this.headers.append("Prefer", "return=representation");
        return this;
    }
    /**
	* Order the query result by `column`.
	*
	* You can call this method multiple times to order by multiple columns.
	*
	* You can order referenced tables, but it only affects the ordering of the
	* parent table if you use `!inner` in the query.
	*
	* @param column - The column to order by
	* @param options - Named parameters
	* @param options.ascending - If `true`, the result will be in ascending order
	* @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
	* `null`s appear last.
	* @param options.referencedTable - Set this to order a referenced table by
	* its columns
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('id, name')
	*   .order('id', { ascending: false })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On a referenced table
	* Ordering with `referencedTable` doesn't affect the ordering of the
	* parent table.
	*
	* @example On a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('orchestral_sections')
	*     .select(`
	*       name,
	*       instruments (
	*         name
	*       )
	*     `)
	*     .order('name', { referencedTable: 'instruments', ascending: false })
	*
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         },
	*         {
	*           "name": "harp"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": []
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Order parent table by a referenced table
	* Ordering with `referenced_table(col)` affects the ordering of the
	* parent table.
	*
	* @example Order parent table by a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('instruments')
	*     .select(`
	*       name,
	*       section:orchestral_sections (
	*         name
	*       )
	*     `)
	*     .order('section(name)', { ascending: true })
	*
	* ```
	*
	* @exampleSql Order parent table by a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Order parent table by a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "violin",
	*       "orchestral_sections": {"name": "strings"}
	*     },
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : "order";
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ""}${column}.${ascending ? "asc" : "desc"}${nullsFirst === void 0 ? "" : nullsFirst ? ".nullsfirst" : ".nullslast"}`);
        return this;
    }
    /**
	* Limit the query result by `count`.
	*
	* @param count - The maximum number of rows to return
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	*   .limit(1, { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
	* Limit the query result by starting at an offset `from` and ending at the offset `to`.
	* Only records within this range are returned.
	* This respects the query order and if there is no order clause the range could behave unexpectedly.
	* The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
	* and fourth rows of the query.
	*
	* @param from - The starting index from which to limit the result
	* @param to - The last index to which to limit the result
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .range(0, 1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     },
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === "undefined" ? "offset" : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
	* Set the AbortSignal for the fetch request.
	*
	* @param signal - The AbortSignal to use for the fetch request
	*
	* @category Database
	*
	* @remarks
	* You can use this to set a timeout for the request.
	*
	* @exampleDescription Aborting requests in-flight
	* You can use an [`AbortController`](https://developer.mozilla.org/en-US/docs/Web/API/AbortController) to abort requests.
	* Note that `status` and `statusText` don't mean anything for aborted requests as the request wasn't fulfilled.
	*
	* @example Aborting requests in-flight
	* ```ts
	* const ac = new AbortController()
	*
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(ac.signal)
	*
	* // Abort the request after 100 ms
	* setTimeout(() => ac.abort(), 100)
	* ```
	*
	* @exampleResponse Aborting requests in-flight
	* ```json
	*   {
	*     "error": {
	*       "message": "AbortError: The user aborted a request.",
	*       "details": "",
	*       "hint": "The request was aborted locally via the provided AbortSignal.",
	*       "code": ""
	*     },
	*     "status": 0,
	*     "statusText": ""
	*   }
	*
	* ```
	*
	* @example Set a timeout
	* ```ts
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(AbortSignal.timeout(1000 /* ms *\/))
	* ```
	*
	* @exampleResponse Set a timeout
	* ```json
	*   {
	*     "error": {
	*       "message": "FetchError: The user aborted a request.",
	*       "details": "",
	*       "hint": "",
	*       "code": ""
	*     },
	*     "status": 400,
	*     "statusText": "Bad Request"
	*   }
	*
	* ```
	*/ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be one row (e.g. using `.limit(1)`), otherwise this
	* returns an error.
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	*   .single()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": {
	*     "name": "Luke"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ single() {
        this.headers.set("Accept", "application/vnd.pgrst.object+json");
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
	* this returns an error.
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Katniss')
	*   .maybeSingle()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ maybeSingle() {
        this.isMaybeSingle = true;
        return this;
    }
    /**
	* Return `data` as a string in CSV format.
	*
	* @category Database
	*
	* @exampleDescription Return data as CSV
	* By default, the data is returned in JSON format, but can also be returned as Comma Separated Values.
	*
	* @example Return data as CSV
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .csv()
	* ```
	*
	* @exampleSql Return data as CSV
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Return data as CSV
	* ```json
	* {
	*   "data": "id,name\n1,Luke\n2,Leia\n3,Han",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ csv() {
        this.headers.set("Accept", "text/csv");
        return this;
    }
    /**
	* Return `data` as an object in [GeoJSON](https://geojson.org) format.
	*
	* @category Database
	*/ geojson() {
        this.headers.set("Accept", "application/geo+json");
        return this;
    }
    /**
	* Return `data` as the EXPLAIN plan for the query.
	*
	* You need to enable the
	* [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
	* setting before using this method.
	*
	* @param options - Named parameters
	*
	* @param options.analyze - If `true`, the query will be executed and the
	* actual run time will be returned
	*
	* @param options.verbose - If `true`, the query identifier will be returned
	* and `data` will include the output columns of the query
	*
	* @param options.settings - If `true`, include information on configuration
	* parameters that affect query planning
	*
	* @param options.buffers - If `true`, include information on buffer usage
	*
	* @param options.wal - If `true`, include information on WAL record generation
	*
	* @param options.format - The format of the output, can be `"text"` (default)
	* or `"json"`
	*
	* @category Database
	*
	* @exampleDescription Get the execution plan
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain()
	* ```
	*
	* @exampleSql Get the execution plan
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40)
	*         ->  Seq Scan on characters  (cost=0.00..22.00 rows=1200 width=40)
	* ```
	*
	* @exampleDescription Get the execution plan with analyze and verbose
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan with analyze and verbose
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain({analyze:true,verbose:true})
	* ```
	*
	* @exampleSql Get the execution plan with analyze and verbose
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan with analyze and verbose
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112) (actual time=0.041..0.041 rows=1 loops=1)
	*   Output: NULL::bigint, count(ROW(characters.id, characters.name)), COALESCE(json_agg(ROW(characters.id, characters.name)), '[]'::json), NULLIF(current_setting('response.headers'::text, true), ''::text), NULLIF(current_setting('response.status'::text, true), ''::text)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40) (actual time=0.005..0.006 rows=3 loops=1)
	*         Output: characters.id, characters.name
	*         ->  Seq Scan on public.characters  (cost=0.00..22.00 rows=1200 width=40) (actual time=0.004..0.005 rows=3 loops=1)
	*               Output: characters.id, characters.name
	* Query Identifier: -4730654291623321173
	* Planning Time: 0.407 ms
	* Execution Time: 0.119 ms
	* ```
	*/ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = "text" } = {}) {
        var _this$headers$get;
        const options = [
            analyze ? "analyze" : null,
            verbose ? "verbose" : null,
            settings ? "settings" : null,
            buffers ? "buffers" : null,
            wal ? "wal" : null
        ].filter(Boolean).join("|");
        const forMediatype = (_this$headers$get = this.headers.get("Accept")) !== null && _this$headers$get !== void 0 ? _this$headers$get : "application/json";
        this.headers.set("Accept", `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`);
        if (format === "json") return this;
        else return this;
    }
    /**
	* Rollback the query.
	*
	* `data` will still be returned, but the query is not committed.
	*
	* @category Database
	*/ rollback() {
        this.headers.append("Prefer", "tx=rollback");
        return this;
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	*
	* @remarks
	* - Deprecated: use overrideTypes method instead
	*
	* @example Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .returns<Array<MyType>>()
	* ```
	*
	* @exampleResponse Override type of successful response
	* ```js
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .returns<MyType>()
	* ```
	*
	* @exampleResponse Override type of object response
	* ```js
	* let x: typeof data // MyType | null
	* ```
	*/ returns() {
        return this;
    }
    /**
	* Set the maximum number of rows that can be affected by the query.
	* Only available in PostgREST v13+ and only works with PATCH and DELETE methods.
	*
	* @param value - The maximum number of rows that can be affected
	*
	* @category Database
	*/ maxAffected(value) {
        this.headers.append("Prefer", "handling=strict");
        this.headers.append("Prefer", `max-affected=${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestFilterBuilder.ts
const $00ff55c36b74d88e$var$PostgrestReservedCharsRegexp = /* @__PURE__ */ new RegExp("[,()]");
var $00ff55c36b74d88e$export$3158317c13bdc93a = class extends $00ff55c36b74d88e$export$7b4361bb87e3030c {
    /**
	* Match only rows where `column` is equal to `value`.
	*
	* To check if the value of `column` is NULL, you should use `.is()` instead.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is not equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .neq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is greater than `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* When using [reserved words](https://www.postgresql.org/docs/current/sql-keywords-appendix.html) for column names you need
	* to add double quotes e.g. `.gt('"order"', 2)`
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .gt('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is greater than or equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .gte('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is less than `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .lt('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is less than or equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .lte('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` matches `pattern` case-sensitively.
	*
	* @param column - The column to filter on
	* @param pattern - The pattern to match with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .like('name', '%Lu%')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches all of `patterns` case-sensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches any of `patterns` case-sensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches `pattern` case-insensitively.
	*
	* @param column - The column to filter on
	* @param pattern - The pattern to match with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .ilike('name', '%lu%')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches all of `patterns` case-insensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches any of `patterns` case-insensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches the PostgreSQL regex `pattern`
	* case-sensitively (using the `~` operator).
	*
	* @param column - The column to filter on
	* @param pattern - The PostgreSQL regular expression pattern to match with
	*/ regexMatch(column, pattern) {
        this.url.searchParams.append(column, `match.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches the PostgreSQL regex `pattern`
	* case-insensitively (using the `~*` operator).
	*
	* @param column - The column to filter on
	* @param pattern - The PostgreSQL regular expression pattern to match with
	*/ regexIMatch(column, pattern) {
        this.url.searchParams.append(column, `imatch.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` IS `value`.
	*
	* For non-boolean columns, this is only relevant for checking if the value of
	* `column` is NULL by setting `value` to `null`.
	*
	* For boolean columns, you can also set `value` to `true` or `false` and it
	* will behave the same way as `.eq()`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @exampleDescription Checking for nullness, true or false
	* Using the `eq()` filter doesn't work when filtering for `null`.
	*
	* Instead, you need to use `is()`.
	*
	* @example Checking for nullness, true or false
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .is('name', null)
	* ```
	*
	* @exampleSql Checking for nullness, true or false
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse Checking for nullness, true or false
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "null"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` IS DISTINCT FROM `value`.
	*
	* Unlike `.neq()`, this treats `NULL` as a comparable value. Two `NULL` values
	* are considered equal (not distinct), and comparing `NULL` with any non-NULL
	* value returns true (distinct).
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*/ isDistinct(column, value) {
        this.url.searchParams.append(column, `isdistinct.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .in('name', ['Leia', 'Han'])
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $00ff55c36b74d88e$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
	* Match only rows where `column` is NOT included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*/ notIn(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $00ff55c36b74d88e$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `not.in.(${cleanedValues})`);
        return this;
    }
    /**
	* Only relevant for jsonb, array, and range columns. Match only rows where
	* `column` contains every element appearing in `value`.
	*
	* @param column - The jsonb, array, or range column to filter on
	* @param value - The jsonb, array, or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('issues')
	*   .select()
	*   .contains('tags', ['is:open', 'priority:low'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   issues (
	*     id int8 primary key,
	*     title text,
	*     tags text[]
	*   );
	*
	* insert into
	*   issues (id, title, tags)
	* values
	*   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
	*   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "title": "Cache invalidation is not working"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .contains('during', '[2000-01-01 13:00, 2000-01-01 13:30)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On `jsonb` columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select('name')
	*   .contains('address', { postcode: 90210 })
	* ```
	*
	* @exampleSql On `jsonb` columns
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
	*   (2, 'Jane', '{}');
	* ```
	*
	* @exampleResponse On `jsonb` columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Michael"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ contains(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cs.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
	* Only relevant for jsonb, array, and range columns. Match only rows where
	* every element appearing in `column` is contained by `value`.
	*
	* @param column - The jsonb, array, or range column to filter on
	* @param value - The jsonb, array, or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('classes')
	*   .select('name')
	*   .containedBy('days', ['monday', 'tuesday', 'wednesday', 'friday'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   classes (
	*     id int8 primary key,
	*     name text,
	*     days text[]
	*   );
	*
	* insert into
	*   classes (id, name, days)
	* values
	*   (1, 'Chemistry', array['monday', 'friday']),
	*   (2, 'History', array['monday', 'wednesday', 'thursday']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Chemistry"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .containedBy('during', '[2000-01-01 00:00, 2000-01-01 23:59)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On `jsonb` columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select('name')
	*   .containedBy('address', {})
	* ```
	*
	* @exampleSql On `jsonb` columns
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
	*   (2, 'Jane', '{}');
	* ```
	*
	* @exampleResponse On `jsonb` columns
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Jane"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ containedBy(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cd.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is greater than any element in `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeGt('during', '[2000-01-02 08:00, 2000-01-02 09:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 2,
	*         "room_name": "Topaz",
	*         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is either contained in `range` or greater than any element in
	* `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeGte('during', '[2000-01-02 08:30, 2000-01-02 09:30)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 2,
	*         "room_name": "Topaz",
	*         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is less than any element in `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeLt('during', '[2000-01-01 15:00, 2000-01-01 16:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is either contained in `range` or less than any element in
	* `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeLte('during', '[2000-01-01 14:00, 2000-01-01 16:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "room_name": "Emerald",
	*         "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where `column` is
	* mutually exclusive to `range` and there can be no element between the two
	* ranges.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeAdjacent('during', '[2000-01-01 12:00, 2000-01-01 13:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
	* Only relevant for array and range columns. Match only rows where
	* `column` and `value` have an element in common.
	*
	* @param column - The array or range column to filter on
	* @param value - The array or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('issues')
	*   .select('title')
	*   .overlaps('tags', ['is:closed', 'severity:high'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   issues (
	*     id int8 primary key,
	*     title text,
	*     tags text[]
	*   );
	*
	* insert into
	*   issues (id, title, tags)
	* values
	*   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
	*   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "title": "Cache invalidation is not working"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .overlaps('during', '[2000-01-01 12:45, 2000-01-01 13:15)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ overlaps(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `ov.${value}`);
        else this.url.searchParams.append(column, `ov.{${value.join(",")}}`);
        return this;
    }
    /**
	* Only relevant for text and tsvector columns. Match only rows where
	* `column` matches the query string in `query`.
	*
	* @param column - The text or tsvector column to filter on
	* @param query - The query text to match with
	* @param options - Named parameters
	* @param options.config - The text search configuration to use
	* @param options.type - Change how the `query` text is interpreted
	*
	* @category Database
	*
	* @remarks
	* - For more information, see [Postgres full text search](/docs/guides/database/full-text-search).
	*
	* @example Text search
	* ```ts
	* const result = await supabase
	*   .from("texts")
	*   .select("content")
	*   .textSearch("content", `'eggs' & 'ham'`, {
	*     config: "english",
	*   });
	* ```
	*
	* @exampleSql Text search
	* ```sql
	* create table texts (
	*   id      bigint
	*           primary key
	*           generated always as identity,
	*   content text
	* );
	*
	* insert into texts (content) values
	*     ('Four score and seven years ago'),
	*     ('The road goes ever on and on'),
	*     ('Green eggs and ham')
	* ;
	* ```
	*
	* @exampleResponse Text search
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "Green eggs and ham"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Basic normalization
	* Uses PostgreSQL's `plainto_tsquery` function.
	*
	* @example Basic normalization
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat' & 'cat'`, {
	*     type: 'plain',
	*     config: 'english'
	*   })
	* ```
	*
	* @exampleDescription Full normalization
	* Uses PostgreSQL's `phraseto_tsquery` function.
	*
	* @example Full normalization
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat' & 'cat'`, {
	*     type: 'phrase',
	*     config: 'english'
	*   })
	* ```
	*
	* @exampleDescription Websearch
	* Uses PostgreSQL's `websearch_to_tsquery` function.
	* This function will never raise syntax errors, which makes it possible to use raw user-supplied input for search, and can be used
	* with advanced operators.
	*
	* - `unquoted text`: text not inside quote marks will be converted to terms separated by & operators, as if processed by plainto_tsquery.
	* - `"quoted text"`: text inside quote marks will be converted to terms separated by `<->` operators, as if processed by phraseto_tsquery.
	* - `OR`: the word “or” will be converted to the | operator.
	* - `-`: a dash will be converted to the ! operator.
	*
	* @example Websearch
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat or cat'`, {
	*     type: 'websearch',
	*     config: 'english'
	*   })
	* ```
	*/ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = "";
        if (type === "plain") typePart = "pl";
        else if (type === "phrase") typePart = "ph";
        else if (type === "websearch") typePart = "w";
        const configPart = config === void 0 ? "" : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
	* Match only rows where each column in `query` keys is equal to its
	* associated value. Shorthand for multiple `.eq()`s.
	*
	* @param query - The object to filter with, with column names as keys mapped
	* to their filter values
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .match({ id: 2, name: 'Leia' })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ match(query) {
        Object.entries(query).filter(([_, value])=>value !== void 0).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
	* Match only rows which doesn't satisfy the filter.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to be negated to filter with, following
	* PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	*
	* @remarks
	* not() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .not('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .not('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .not('name', 'is', null)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "name": "null"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
	* Match only rows which satisfy at least one of the filters.
	*
	* Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure it's properly sanitized.
	*
	* It's currently not possible to do an `.or()` filter across multiple tables.
	*
	* @param filters - The filters to use, following PostgREST syntax
	* @param options - Named parameters
	* @param options.referencedTable - Set this to filter on referenced tables
	* instead of the parent table
	* @param options.foreignTable - Deprecated, use `referencedTable` instead
	*
	* @category Database
	*
	* @remarks
	* or() expects you to use the raw PostgREST syntax for the filter names and values.
	*
	* ```ts
	* .or('id.in.(5,6,7), arraycol.cs.{"a","b"}')  // Use `()` for `in` filter, `{}` for array values and `cs` for `contains()`.
	* .or('id.in.(5,6,7), arraycol.cd.{"a","b"}')  // Use `cd` for `containedBy()`
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.eq.2,name.eq.Han')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     },
	*     {
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` with `and`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.gt.3,and(id.eq.1,name.eq.Luke)')
	* ```
	*
	* @exampleSql Use `or` with `and`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Use `or` with `and`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` on referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .or('section_id.eq.1,name.eq.guzheng', { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql Use `or` on referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Use `or` on referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : "or";
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
	* Match only rows which satisfy the filter. This is an escape hatch - you
	* should use the specific filter methods wherever possible.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to filter with, following PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	*
	* @remarks
	* filter() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .filter('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .filter('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .filter('name', 'in', '("Han","Yoda")')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .filter('instruments.name', 'eq', 'flute')
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*    instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestQueryBuilder.ts
var $00ff55c36b74d88e$export$a81993b50ca081ad = class {
    /**
	* Creates a query builder scoped to a Postgres table or view.
	*
	* @category Database
	*
	* @param url - The URL for the query
	* @param options - Named parameters
	* @param options.headers - Custom headers
	* @param options.schema - Postgres schema to use
	* @param options.fetch - Custom fetch implementation
	* @param options.urlLengthLimit - Maximum URL length before warning
	* @param options.retry - Enable automatic retries for transient errors (default: true)
	*
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('users').select('*')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const query = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: { apikey: 'your-publishable-key' }, retry: true }
	* )
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, urlLengthLimit: urlLengthLimit = 8e3, retry: retry }){
        this.url = url;
        this.headers = new Headers(headers);
        this.schema = schema;
        this.fetch = fetch$1;
        this.urlLengthLimit = urlLengthLimit;
        this.retry = retry;
    }
    /**
	* Clone URL and headers to prevent shared state between operations.
	*/ cloneRequestState() {
        return {
            url: new URL(this.url.toString()),
            headers: new Headers(this.headers)
        };
    }
    /**
	* Perform a SELECT query on the table or view.
	*
	* @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
	*
	* @param options - Named parameters
	*
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	*
	* @param options.count - Count algorithm to use to count rows in the table or view.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @remarks
	* When using `count` with `.range()` or `.limit()`, the returned `count` is the total number of rows
	* that match your filters, not the number of rows in the current page. Use this to build pagination UI.
	
	* - By default, Supabase projects return a maximum of 1,000 rows. This setting can be changed in your project's [API settings](/dashboard/project/_/settings/api). It's recommended that you keep it low to limit the payload size of accidental or malicious requests. You can use `range()` queries to paginate through your data.
	* - `select()` can be combined with [Filters](/docs/reference/javascript/using-filters)
	* - `select()` can be combined with [Modifiers](/docs/reference/javascript/using-modifiers)
	* - `apikey` is a reserved keyword if you're using the [Supabase Platform](/docs/guides/platform) and [should be avoided as a column name](https://github.com/supabase/supabase/issues/5465). *
	* @category Database
	*
	* @example Getting your data
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	* ```
	*
	* @exampleSql Getting your data
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Harry'),
	*   (2, 'Frodo'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Getting your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Harry"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Frodo"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Selecting specific columns
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	* ```
	*
	* @exampleSql Selecting specific columns
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Frodo'),
	*   (2, 'Harry'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Selecting specific columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Frodo"
	*     },
	*     {
	*       "name": "Harry"
	*     },
	*     {
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables
	* If your database has foreign key relationships, you can query related tables too.
	*
	* @example Query referenced tables
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables with spaces in their names
	* If your table name contains spaces, you must use double quotes in the `select` statement to reference the table.
	*
	* @example Query referenced tables with spaces in their names
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral sections')
	*   .select(`
	*     name,
	*     "musical instruments" (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables with spaces in their names
	* ```sql
	* create table
	*   "orchestral sections" (id int8 primary key, name text);
	* create table
	*   "musical instruments" (
	*     id int8 primary key,
	*     section_id int8 not null references "orchestral sections",
	*     name text
	*   );
	*
	* insert into
	*   "orchestral sections" (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   "musical instruments" (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables with spaces in their names
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "musical instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "musical instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables through a join table
	* If you're in a situation where your tables are **NOT** directly
	* related, but instead are joined by a _join table_, you can still use
	* the `select()` method to query the related data. The join table needs
	* to have the foreign keys as part of its composite primary key.
	*
	* @example Query referenced tables through a join table
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     name,
	*     teams (
	*       name
	*     )
	*   `)
	*   
	* ```
	*
	* @exampleSql Query referenced tables through a join table
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*     -- both foreign keys must be part of a composite primary key
	*     primary key (user_id, team_id)
	*   );
	*
	* insert into
	*   users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* ```
	*
	* @exampleResponse Query referenced tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Kiran",
	*         "teams": [
	*           {
	*             "name": "Green"
	*           },
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       },
	*       {
	*         "name": "Evan",
	*         "teams": [
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Query the same referenced table multiple times
	* If you need to query the same referenced table twice, use the name of the
	* joined column to identify which join to use. You can also give each
	* column an alias.
	*
	* @example Query the same referenced table multiple times
	* ```ts
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:sender_id(name),
	*     to:receiver_id(name)
	*   `)
	*
	* // To infer types, use the name of the table (in this case `users`) and
	* // the name of the foreign key constraint.
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:users!messages_sender_id_fkey(name),
	*     to:users!messages_receiver_id_fkey(name)
	*   `)
	* ```
	*
	* @exampleSql Query the same referenced table multiple times
	* ```sql
	*  create table
	*  users (id int8 primary key, name text);
	*
	*  create table
	*    messages (
	*      sender_id int8 not null references users,
	*      receiver_id int8 not null references users,
	*      content text
	*    );
	*
	*  insert into
	*    users (id, name)
	*  values
	*    (1, 'Kiran'),
	*    (2, 'Evan');
	*
	*  insert into
	*    messages (sender_id, receiver_id, content)
	*  values
	*    (1, 2, '👋');
	*  ```
	* ```
	*
	* @exampleResponse Query the same referenced table multiple times
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "👋",
	*       "from": {
	*         "name": "Kiran"
	*       },
	*       "to": {
	*         "name": "Evan"
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query nested foreign tables through a join table
	* You can use the result of a joined table to gather data in
	* another foreign table. With multiple references to the same foreign
	* table you must specify the column on which to conduct the join.
	*
	* @example Query nested foreign tables through a join table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('games')
	*     .select(`
	*       game_id:id,
	*       away_team:teams!games_away_team_fkey (
	*         users (
	*           id,
	*           name
	*         )
	*       )
	*     `)
	*   
	* ```
	*
	* @exampleSql Query nested foreign tables through a join table
	* ```sql
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*
	*     primary key (user_id, team_id)
	*   );
	* create table
	*   games (
	*     id int8 primary key,
	*     home_team int8 not null references teams,
	*     away_team int8 not null references teams,
	*     name text
	*   );
	*
	* insert into users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* insert into
	*   games (id, home_team, away_team, name)
	* values
	*   (1, 1, 2, 'Green vs Blue'),
	*   (2, 2, 1, 'Blue vs Green');
	* ```
	*
	* @exampleResponse Query nested foreign tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "game_id": 1,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             },
	*             {
	*               "id": 2,
	*               "name": "Evan"
	*             }
	*           ]
	*         }
	*       },
	*       {
	*         "game_id": 2,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             }
	*           ]
	*         }
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Filtering through referenced tables
	* If the filter on a referenced table's column is not satisfied, the referenced
	* table returns `[]` or `null` but the parent table is not filtered out.
	* If you want to filter out the parent table rows, use the `!inner` hint
	*
	* @example Filtering through referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections(*)')
	*   .eq('orchestral_sections.name', 'percussion')
	* ```
	*
	* @exampleSql Filtering through referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Filtering through referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": null
	*     },
	*     {
	*       "name": "violin",
	*       "orchestral_sections": null
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with count
	* You can get the number of rows in a related table by using the
	* **count** property.
	*
	* @example Querying referenced table with count
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`*, instruments(count)`)
	* ```
	*
	* @exampleSql Querying referenced table with count
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table characters (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('strings') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('violin', (select id from section)),
	* ('viola', (select id from section)),
	* ('cello', (select id from section)),
	* ('double bass', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with count
	* ```json
	* [
	*   {
	*     "id": "693694e7-d993-4360-a6d7-6294e325d9b6",
	*     "name": "strings",
	*     "instruments": [
	*       {
	*         "count": 4
	*       }
	*     ]
	*   }
	* ]
	* ```
	*
	* @exampleDescription Querying with count option
	* You can get the number of rows by using the
	* [count](/docs/reference/javascript/select#parameters) option.
	*
	* @example Querying with count option
	* ```ts
	* const { count, error } = await supabase
	*   .from('characters')
	*   .select('*', { count: 'exact', head: true })
	* ```
	*
	* @exampleSql Querying with count option
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Querying with count option
	* ```json
	* {
	*   "count": 3,
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying JSON data
	* You can select and filter data inside of
	* [JSON](/docs/guides/database/json) columns. Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* querying JSON data.
	*
	* @example Querying JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     id, name,
	*     address->city
	*   `)
	* ```
	*
	* @exampleSql Querying JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Frodo', '{"city":"Hobbiton"}');
	* ```
	*
	* @exampleResponse Querying JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Frodo",
	*       "city": "Hobbiton"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with inner join
	* If you don't want to return the referenced table contents, you can leave the parenthesis empty.
	* Like `.select('name, orchestral_sections!inner()')`.
	*
	* @example Querying referenced table with inner join
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections!inner(name)')
	*   .eq('orchestral_sections.name', 'woodwinds')
	*   .limit(1)
	* ```
	*
	* @exampleSql Querying referenced table with inner join
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table instruments (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('woodwinds') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('flute', (select id from section)),
	* ('clarinet', (select id from section)),
	* ('bassoon', (select id from section)),
	* ('piccolo', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with inner join
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Switching schemas per query
	* In addition to setting the schema during initialization, you can also switch schemas on a per-query basis.
	* Make sure you've set up your [database privileges and API settings](/docs/guides/api/using-custom-schemas).
	*
	* @example Switching schemas per query
	* ```ts
	* const { data, error } = await supabase
	*   .schema('myschema')
	*   .from('mytable')
	*   .select()
	* ```
	*
	* @exampleSql Switching schemas per query
	* ```sql
	* create schema myschema;
	*
	* create table myschema.mytable (
	*   id uuid primary key default gen_random_uuid(),
	*   data text
	* );
	*
	* insert into myschema.mytable (data) values ('mydata');
	* ```
	*
	* @exampleResponse Switching schemas per query
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": "4162e008-27b0-4c0f-82dc-ccaeee9a624d",
	*       "data": "mydata"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ select(columns, options) {
        const { head: head = false, count: count } = options !== null && options !== void 0 ? options : {};
        const method = head ? "HEAD" : "GET";
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        const { url: url, headers: headers } = this.cloneRequestState();
        url.searchParams.set("select", cleanedColumns);
        if (count) headers.append("Prefer", `count=${count}`);
        return new $00ff55c36b74d88e$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an INSERT into the table or view.
	*
	* By default, inserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to insert. Pass an object to insert a single row
	* or an array to insert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count inserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. Only applies for bulk
	* inserts.
	*
	* @category Database
	*
	* @example Create a record
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	* ```
	*
	* @exampleSql Create a record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record
	* ```json
	* {
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @example Create a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	*   .select()
	* ```
	*
	* @exampleSql Create a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @exampleDescription Bulk create
	* A bulk create operation is handled in a single transaction.
	* If any of the inserts fail, none of the rows are inserted.
	*
	* @example Bulk create
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert([
	*     { id: 1, name: 'Mordor' },
	*     { id: 1, name: 'The Shire' },
	*   ])
	* ```
	*
	* @exampleSql Bulk create
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Bulk create
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (id)=(1) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"countries_pkey\""
	*   },
	*   "status": 409,
	*   "statusText": "Conflict"
	* }
	* ```
	*/ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", `missing=default`);
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $00ff55c36b74d88e$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an UPSERT on the table or view. Depending on the column(s) passed
	* to `onConflict`, `.upsert()` allows you to perform the equivalent of
	* `.insert()` if a row with the corresponding `onConflict` columns doesn't
	* exist, or if it does exist, perform an alternative action depending on
	* `ignoreDuplicates`.
	*
	* By default, upserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to upsert with. Pass an object to upsert a
	* single row or an array to upsert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
	* duplicate rows are determined. Two rows are duplicates if all the
	* `onConflict` columns are equal.
	*
	* @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
	* `false`, duplicate rows are merged with existing rows.
	*
	* @param options.count - Count algorithm to use to count upserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. This only applies when
	* inserting new rows, not when merging with existing rows under
	* `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
	*
	* @example Upsert a single row using a unique key
	* ```ts
	* // Upserting a single row, overwriting based on the 'username' unique column
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ username: 'supabot' }, { onConflict: 'username' })
	*
	* // Example response:
	* // {
	* //   data: [
	* //     { id: 4, message: 'bar', username: 'supabot' }
	* //   ],
	* //   error: null
	* // }
	* ```
	*
	* @example Upsert with conflict resolution and exact row counting
	* ```ts
	* // Upserting and returning exact count
	* const { data, error, count } = await supabase
	*   .from('users')
	*   .upsert(
	*     {
	*       id: 3,
	*       message: 'foo',
	*       username: 'supabot'
	*     },
	*     {
	*       onConflict: 'username',
	*       count: 'exact'
	*     }
	*   )
	*
	* // Example response:
	* // {
	* //   data: [
	* //     {
	* //       id: 42,
	* //       handle: "saoirse",
	* //       display_name: "Saoirse"
	* //     }
	* //   ],
	* //   count: 1,
	* //   error: null
	* // }
	* ```
	*
	* @category Database
	*
	* @remarks
	* - Primary keys must be included in `values` to use upsert.
	*
	* @example Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert({ id: 1, name: 'piano' })
	*   .select()
	* ```
	*
	* @exampleSql Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @example Bulk Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert([
	*     { id: 1, name: 'piano' },
	*     { id: 2, name: 'harp' },
	*   ])
	*   .select()
	* ```
	*
	* @exampleSql Bulk Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Bulk Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     },
	*     {
	*       "id": 2,
	*       "name": "harp"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @exampleDescription Upserting into tables with constraints
	* In the following query, `upsert()` implicitly uses the `id`
	* (primary key) column to determine conflicts. If there is no existing
	* row with the same `id`, `upsert()` inserts a new row, which
	* will fail in this case as there is already a row with `handle` `"saoirse"`.
	* Using the `onConflict` option, you can instruct `upsert()` to use
	* another column with a unique constraint to determine conflicts.
	*
	* @example Upserting into tables with constraints
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ id: 42, handle: 'saoirse', display_name: 'Saoirse' })
	*   .select()
	* ```
	*
	* @exampleSql Upserting into tables with constraints
	* ```sql
	* create table
	*   users (
	*     id int8 generated by default as identity primary key,
	*     handle text not null unique,
	*     display_name text
	*   );
	*
	* insert into
	*   users (id, handle, display_name)
	* values
	*   (1, 'saoirse', null);
	* ```
	*
	* @exampleResponse Upserting into tables with constraints
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (handle)=(saoirse) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"users_handle_key\""
	*   },
	*   "status": 409,
	*   "statusText": "Conflict"
	* }
	* ```
	*/ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch2;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        headers.append("Prefer", `resolution=${ignoreDuplicates ? "ignore" : "merge"}-duplicates`);
        if (onConflict !== void 0) url.searchParams.set("on_conflict", onConflict);
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", "missing=default");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $00ff55c36b74d88e$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch2 = this.fetch) !== null && _this$fetch2 !== void 0 ? _this$fetch2 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an UPDATE on the table or view.
	*
	* By default, updated rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param values - The values to update with
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count updated rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `update()` should always be combined with [Filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to update.
	*
	* @example Updating your data
	* ```ts
	* const { error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Updating your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Updating your data
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*
	* @example Update a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Update a record and return it
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Update a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Updating JSON data
	* Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* working with JSON data. Currently, it is only possible to update the entire JSON document.
	*
	* @example Updating JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .update({
	*     address: {
	*       street: 'Melrose Place',
	*       postcode: 90210
	*     }
	*   })
	*   .eq('address->postcode', 90210)
	*   .select()
	* ```
	*
	* @exampleSql Updating JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210 }');
	* ```
	*
	* @exampleResponse Updating JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Michael",
	*       "address": {
	*         "street": "Melrose Place",
	*         "postcode": 90210
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ update(values, { count: count } = {}) {
        var _this$fetch3;
        const method = "PATCH";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $00ff55c36b74d88e$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch3 = this.fetch) !== null && _this$fetch3 !== void 0 ? _this$fetch3 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform a DELETE on the table or view.
	*
	* By default, deleted rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count deleted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `delete()` should always be combined with [filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to delete.
	* - If you use `delete()` with filters and you have
	*   [RLS](/docs/learn/auth-deep-dive/auth-row-level-security) enabled, only
	*   rows visible through `SELECT` policies are deleted. Note that by default
	*   no rows are visible, so you need at least one `SELECT`/`ALL` policy that
	*   makes the rows visible.
	* - When using `delete().in()`, specify an array of values to target multiple rows with a single query. This is particularly useful for batch deleting entries that share common criteria, such as deleting users by their IDs. Ensure that the array you provide accurately represents all records you intend to delete to avoid unintended data removal.
	*
	* @example Delete a single record
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Delete a single record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a single record
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*
	* @example Delete a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Delete a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Delete multiple records
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .in('id', [1, 2, 3])
	* ```
	*
	* @exampleSql Delete multiple records
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'), (2, 'The Shire'), (3, 'Mordor');
	* ```
	*
	* @exampleResponse Delete multiple records
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*/ delete({ count: count } = {}) {
        var _this$fetch4;
        const method = "DELETE";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $00ff55c36b74d88e$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: (_this$fetch4 = this.fetch) !== null && _this$fetch4 !== void 0 ? _this$fetch4 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $00ff55c36b74d88e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $00ff55c36b74d88e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $00ff55c36b74d88e$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $00ff55c36b74d88e$var$toPrimitive(t, r) {
    if ("object" != $00ff55c36b74d88e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $00ff55c36b74d88e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $00ff55c36b74d88e$var$toPropertyKey(t) {
    var i = $00ff55c36b74d88e$var$toPrimitive(t, "string");
    return "symbol" == $00ff55c36b74d88e$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $00ff55c36b74d88e$var$_defineProperty(e, r, t) {
    return (r = $00ff55c36b74d88e$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $00ff55c36b74d88e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $00ff55c36b74d88e$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $00ff55c36b74d88e$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $00ff55c36b74d88e$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $00ff55c36b74d88e$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/PostgrestClient.ts
/**
* PostgREST client.
*
* @typeParam Database - Types for the schema from the [type
* generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
*
* @typeParam SchemaName - Postgres schema to switch to. Must be a string
* literal, the same one passed to the constructor. If the schema is not
* `"public"`, this must be supplied manually.
*/ var $00ff55c36b74d88e$export$796f32e2ee984aaa = class PostgrestClient {
    /**
	* Creates a PostgREST client.
	*
	* @param url - URL of the PostgREST endpoint
	* @param options - Named parameters
	* @param options.headers - Custom headers
	* @param options.schema - Postgres schema to switch to
	* @param options.fetch - Custom fetch
	* @param options.timeout - Optional timeout in milliseconds for all requests. When set, requests will automatically abort after this duration to prevent indefinite hangs.
	* @param options.urlLengthLimit - Maximum URL length in characters before warnings/errors are triggered. Defaults to 8000.
	* @param options.retry - Enable or disable automatic retries for transient errors.
	*   When enabled, idempotent requests (GET, HEAD, OPTIONS) that fail with network
	*   errors or HTTP 503/520 responses will be automatically retried up to 3 times
	*   with exponential backoff (1s, 2s, 4s). Defaults to `true`.
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('profiles').select('*')
	* ```
	*
	* @category Database
	*
	* @remarks
	* - A `timeout` option (in milliseconds) can be set to automatically abort requests that take too long.
	* - A `urlLengthLimit` option (default: 8000) can be set to control when URL length warnings are included in error messages for aborted requests.
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'your-publishable-key' },
	*   schema: 'public',
	*   timeout: 30000, // 30 second timeout
	* })
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, timeout: timeout, urlLengthLimit: urlLengthLimit = 8e3, retry: retry } = {}){
        this.url = url;
        this.headers = new Headers(headers);
        this.schemaName = schema;
        this.urlLengthLimit = urlLengthLimit;
        const originalFetch = fetch$1 !== null && fetch$1 !== void 0 ? fetch$1 : globalThis.fetch;
        if (timeout !== void 0 && timeout > 0) this.fetch = (input, init)=>{
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), timeout);
            const existingSignal = init === null || init === void 0 ? void 0 : init.signal;
            if (existingSignal) {
                if (existingSignal.aborted) {
                    clearTimeout(timeoutId);
                    return originalFetch(input, init);
                }
                const abortHandler = ()=>{
                    clearTimeout(timeoutId);
                    controller.abort();
                };
                existingSignal.addEventListener("abort", abortHandler, {
                    once: true
                });
                return originalFetch(input, $00ff55c36b74d88e$var$_objectSpread2($00ff55c36b74d88e$var$_objectSpread2({}, init), {}, {
                    signal: controller.signal
                })).finally(()=>{
                    clearTimeout(timeoutId);
                    existingSignal.removeEventListener("abort", abortHandler);
                });
            }
            return originalFetch(input, $00ff55c36b74d88e$var$_objectSpread2($00ff55c36b74d88e$var$_objectSpread2({}, init), {}, {
                signal: controller.signal
            })).finally(()=>clearTimeout(timeoutId));
        };
        else this.fetch = originalFetch;
        this.retry = retry;
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*
	* @category Database
	*/ from(relation) {
        if (!relation || typeof relation !== "string" || relation.trim() === "") throw new Error("Invalid relation name: relation must be a non-empty string.");
        return new $00ff55c36b74d88e$export$a81993b50ca081ad(new URL(`${this.url}/${relation}`), {
            headers: new Headers(this.headers),
            schema: this.schemaName,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*
	* @category Database
	*/ schema(schema) {
        return new PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @example
	* ```ts
	* // For cross-schema functions where type inference fails, use overrideTypes:
	* const { data } = await supabase
	*   .schema('schema_b')
	*   .rpc('function_a', {})
	*   .overrideTypes<{ id: string; user_id: string }[]>()
	* ```
	*
	* @category Database
	*
	* @example Call a Postgres function without arguments
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world')
	* ```
	*
	* @exampleSql Call a Postgres function without arguments
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function without arguments
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a Postgres function with arguments
	* ```ts
	* const { data, error } = await supabase.rpc('echo', { say: '👋' })
	* ```
	*
	* @exampleSql Call a Postgres function with arguments
	* ```sql
	* create function echo(say text) returns text as $$
	*   select say;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with arguments
	* ```json
	*   {
	*     "data": "👋",
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*
	* @exampleDescription Bulk processing
	* You can process large payloads by passing in an array as an argument.
	*
	* @example Bulk processing
	* ```ts
	* const { data, error } = await supabase.rpc('add_one_each', { arr: [1, 2, 3] })
	* ```
	*
	* @exampleSql Bulk processing
	* ```sql
	* create function add_one_each(arr int[]) returns int[] as $$
	*   select array_agg(n + 1) from unnest(arr) as n;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Bulk processing
	* ```json
	* {
	*   "data": [
	*     2,
	*     3,
	*     4
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Call a Postgres function with filters
	* Postgres functions that return tables can also be combined with [Filters](/docs/reference/javascript/using-filters) and [Modifiers](/docs/reference/javascript/using-modifiers).
	*
	* @example Call a Postgres function with filters
	* ```ts
	* const { data, error } = await supabase
	*   .rpc('list_stored_countries')
	*   .eq('id', 1)
	*   .single()
	* ```
	*
	* @exampleSql Call a Postgres function with filters
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'),
	*   (2, 'The Shire');
	*
	* create function list_stored_countries() returns setof countries as $$
	*   select * from countries;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with filters
	* ```json
	* {
	*   "data": {
	*     "id": 1,
	*     "name": "Rohan"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a read-only Postgres function
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world', undefined, { get: true })
	* ```
	*
	* @exampleSql Call a read-only Postgres function
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a read-only Postgres function
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        var _this$fetch;
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        const _isObject = (v)=>v !== null && typeof v === "object" && (!Array.isArray(v) || v.some(_isObject));
        const _hasObjectArg = head && Object.values(args).some(_isObject);
        if (_hasObjectArg) {
            method = "POST";
            body = args;
        } else if (head || get) {
            method = head ? "HEAD" : "GET";
            Object.entries(args).filter(([_, value])=>value !== void 0).map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(",")}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = "POST";
            body = args;
        }
        const headers = new Headers(this.headers);
        if (_hasObjectArg) headers.set("Prefer", count ? `count=${count},return=minimal` : "return=minimal");
        else if (count) headers.set("Prefer", `count=${count}`);
        return new $00ff55c36b74d88e$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
};
//#endregion
//#region src/index.ts
var $00ff55c36b74d88e$export$2e2bcd8739ae039 = {
    PostgrestClient: $00ff55c36b74d88e$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $00ff55c36b74d88e$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $00ff55c36b74d88e$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $00ff55c36b74d88e$export$7b4361bb87e3030c,
    PostgrestBuilder: $00ff55c36b74d88e$export$3106e21688a06353,
    PostgrestError: $00ff55c36b74d88e$export$445b7e3a323f992f
};

});

parcelRegister("gbNQh", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", function () { return (parcelRequire("kPw4N")).default; });

var $kPw4N = parcelRequire("kPw4N");

var $f3MjB = parcelRequire("f3MjB");

var $lbk1h = parcelRequire("lbk1h");

var $3tQAl = parcelRequire("3tQAl");

});
parcelRegister("kPw4N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2a173c71efcae28$export$2e2bcd8739ae039; });

var $3tQAl = parcelRequire("3tQAl");

var $buFEH = parcelRequire("buFEH");

var $dXYJX = parcelRequire("dXYJX");

var $iNtee = parcelRequire("iNtee");

var $f3MjB = parcelRequire("f3MjB");

var $8atwF = parcelRequire("8atwF");
// Connection-related constants
const $f2a173c71efcae28$var$CONNECTION_TIMEOUTS = {
    HEARTBEAT_INTERVAL: 25000,
    RECONNECT_DELAY: 10,
    HEARTBEAT_TIMEOUT_FALLBACK: 100
};
const $f2a173c71efcae28$var$RECONNECT_INTERVALS = [
    1000,
    2000,
    5000,
    10000
];
const $f2a173c71efcae28$var$DEFAULT_RECONNECT_FALLBACK = 10000;
const $f2a173c71efcae28$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;
class $f2a173c71efcae28$export$2e2bcd8739ae039 {
    get endPoint() {
        return this.socketAdapter.endPoint;
    }
    get timeout() {
        return this.socketAdapter.timeout;
    }
    get transport() {
        return this.socketAdapter.transport;
    }
    get heartbeatCallback() {
        return this.socketAdapter.heartbeatCallback;
    }
    get heartbeatIntervalMs() {
        return this.socketAdapter.heartbeatIntervalMs;
    }
    get heartbeatTimer() {
        if (this.worker) return this._workerHeartbeatTimer;
        return this.socketAdapter.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        if (this.worker) return this._pendingWorkerHeartbeatRef;
        return this.socketAdapter.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socketAdapter.reconnectTimer;
    }
    get vsn() {
        return this.socketAdapter.vsn;
    }
    get encode() {
        return this.socketAdapter.encode;
    }
    get decode() {
        return this.socketAdapter.decode;
    }
    get reconnectAfterMs() {
        return this.socketAdapter.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socketAdapter.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socketAdapter.stateChangeCallbacks;
    }
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers Deprecated: headers cannot be set on websocket connections and this option will be removed in the future.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.heartbeatCallback The optional function to handle heartbeat status and latency.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.logLevel Sets the log level for Realtime
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     * @param options.vsn The protocol version to use when connecting. Supported versions are "1.0.0" and "2.0.0". Defaults to "2.0.0".
     *
     * @category Realtime
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const channel = supabase.channel('room1')
     * channel
     *   .on('broadcast', { event: 'cursor-pos' }, (payload) => console.log(payload))
     *   .subscribe()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'your-publishable-key' },
     * })
     * client.connect()
     * ```
     */ constructor(endPoint, options){
        var _a;
        this.channels = new Array();
        this.accessTokenValue = null;
        this.accessToken = null;
        this.apiKey = null;
        this.httpEndpoint = '';
        /** @deprecated headers cannot be set on websocket connections */ this.headers = {};
        this.params = {};
        this.ref = 0;
        this.serializer = new (0, $dXYJX.default)();
        this._manuallySetToken = false;
        this._authPromise = null;
        this._workerHeartbeatTimer = undefined;
        this._pendingWorkerHeartbeatRef = null;
        this._pendingDisconnectTimer = null;
        this._disconnectOnEmptyChannelsAfterMs = 0;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            if (customFetch) return (...args)=>customFetch(...args);
            return (...args)=>fetch(...args);
        };
        // Validate required parameters
        if (!((_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey)) throw new Error('API key is required to connect to Realtime');
        this.apiKey = options.params.apikey;
        const socketAdapterOptions = this._initializeOptions(options);
        this.socketAdapter = new (0, $8atwF.default)(endPoint, socketAdapterOptions);
        this.httpEndpoint = (0, $iNtee.httpEndpointURL)(endPoint);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
    }
    /**
     * Connects the socket, unless already connected.
     *
     * @category Realtime
     */ connect() {
        // Skip if already connecting, disconnecting, or connected
        if (this.isConnecting() || this.isDisconnecting() || this.isConnected()) return;
        // Trigger auth if needed and not already in progress
        // This ensures auth is called for standalone RealtimeClient usage
        // while avoiding race conditions with SupabaseClient's immediate setAuth call
        if (this.accessToken && !this._authPromise) this._setAuthSafely('connect');
        this._setupConnectionHandlers();
        try {
            this.socketAdapter.connect();
        } catch (error) {
            const errorMessage = error.message;
            // Provide helpful error message based on environment
            if (errorMessage.includes('Node.js')) throw new Error(`${errorMessage}\n\n` + 'To use Realtime in Node.js, you need to provide a WebSocket implementation:\n\n' + 'Option 1: Use Node.js 22+ which has native WebSocket support\n' + 'Option 2: Install and provide the "ws" package:\n\n' + '  npm install ws\n\n' + '  import ws from "ws"\n' + '  const client = new RealtimeClient(url, {\n' + '    ...options,\n' + '    transport: ws\n' + '  })');
            throw new Error(`WebSocket not available: ${errorMessage}`);
        }
        this._handleNodeJsRaceCondition();
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     *
     * @category Realtime
     */ endpointURL() {
        return this.socketAdapter.endPointURL();
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     *
     * @category Realtime
     */ async disconnect(code, reason) {
        this._cancelPendingDisconnect();
        if (this.isDisconnecting()) return 'ok';
        return await this.socketAdapter.disconnect(()=>{
            clearInterval(this._workerHeartbeatTimer);
            this._terminateWorker();
        }, code, reason);
    }
    /**
     * Returns all created channels
     *
     * @category Realtime
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes, removes and tears down a single channel
     * @param channel A RealtimeChannel instance
     *
     * @category Realtime
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (status === 'ok') channel.teardown();
        return status;
    }
    /**
     * Unsubscribes, removes and tears down all channels
     *
     * @category Realtime
     */ async removeAllChannels() {
        const promises = this.channels.map(async (channel)=>{
            const result = await channel.unsubscribe();
            channel.teardown();
            return result;
        });
        const result = await Promise.all(promises);
        await this.disconnect();
        return result;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden in Client constructor.
     *
     * @category Realtime
     */ log(kind, msg, data) {
        this.socketAdapter.log(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     *
     * @category Realtime
     */ connectionState() {
        return this.socketAdapter.connectionState() || (0, $buFEH.CONNECTION_STATE).closed;
    }
    /**
     * Returns `true` is the connection is open.
     *
     * @category Realtime
     */ isConnected() {
        return this.socketAdapter.isConnected();
    }
    /**
     * Returns `true` if the connection is currently connecting.
     *
     * @category Realtime
     */ isConnecting() {
        return this.socketAdapter.isConnecting();
    }
    /**
     * Returns `true` if the connection is currently disconnecting.
     *
     * @category Realtime
     */ isDisconnecting() {
        return this.socketAdapter.isDisconnecting();
    }
    /**
     * Creates (or reuses) a {@link RealtimeChannel} for the provided topic.
     *
     * Topics are automatically prefixed with `realtime:` to match the Realtime service.
     * If a channel with the same topic already exists it will be returned instead of creating
     * a duplicate connection.
     *
     * @category Realtime
     */ channel(topic, params = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c)=>c.topic === realtimeTopic);
        if (!exists) {
            const chan = new (0, $f3MjB.default)(`realtime:${topic}`, params, this);
            this._cancelPendingDisconnect();
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     *
     * @category Realtime
     */ push(data) {
        this.socketAdapter.push(data);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * When a token is explicitly provided, it will be preserved across channel operations
     * (including removeChannel and resubscribe). The `accessToken` callback will not be
     * invoked until `setAuth()` is called without arguments.
     *
     * @param token A JWT string to override the token set on the client.
     *
     * @example Setting the authorization header
     * // Use a manual token (preserved across resubscribes, ignores accessToken callback)
     * client.realtime.setAuth('my-custom-jwt')
     *
     * // Switch back to using the accessToken callback
     * client.realtime.setAuth()
     *
     * @category Realtime
     */ async setAuth(token = null) {
        this._authPromise = this._performAuth(token);
        try {
            await this._authPromise;
        } finally{
            this._authPromise = null;
        }
    }
    /**
     * Returns true if the current access token was explicitly set via setAuth(token),
     * false if it was obtained via the accessToken callback.
     * @internal
     */ _isManualToken() {
        return this._manuallySetToken;
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     *
     * @category Realtime
     */ async sendHeartbeat() {
        this.socketAdapter.sendHeartbeat();
    }
    /**
     * Sets a callback that receives lifecycle events for internal heartbeat messages.
     * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
     *
     * @category Realtime
     */ onHeartbeat(callback) {
        this.socketAdapter.heartbeatCallback = this._wrapHeartbeatCallback(callback);
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        return this.socketAdapter.makeRef();
    }
    /**
     * Removes a channel from RealtimeClient
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c.topic !== channel.topic);
        if (this.channels.length === 0) {
            this.log('transport', 'no channels remaining, scheduling disconnect');
            this._schedulePendingDisconnect();
        }
    }
    /** @internal */ _schedulePendingDisconnect() {
        this._cancelPendingDisconnect();
        if (this._disconnectOnEmptyChannelsAfterMs === 0) {
            this.log('transport', 'disconnecting immediately - no channels');
            this.disconnect();
            return;
        }
        this._pendingDisconnectTimer = setTimeout(()=>{
            this._pendingDisconnectTimer = null;
            if (this.channels.length === 0) {
                this.log('transport', 'deferred disconnect fired - no channels, disconnecting');
                this.disconnect();
            }
        }, this._disconnectOnEmptyChannelsAfterMs);
        this.log('transport', `deferred disconnect scheduled in ${this._disconnectOnEmptyChannelsAfterMs}ms`);
    }
    /** @internal */ _cancelPendingDisconnect() {
        if (this._pendingDisconnectTimer !== null) {
            this.log('transport', 'pending disconnect cancelled - channel activity detected');
            clearTimeout(this._pendingDisconnectTimer);
            this._pendingDisconnectTimer = null;
        }
    }
    /**
     * Perform the actual auth operation
     * @internal
     */ async _performAuth(token = null) {
        let tokenToSend;
        let isManualToken = false;
        if (token) {
            tokenToSend = token;
            // Track if this is a manually-provided token
            isManualToken = true;
        } else if (this.accessToken) // Call the accessToken callback to get fresh token
        try {
            tokenToSend = await this.accessToken();
        } catch (e) {
            this.log('error', 'Error fetching access token from callback', e);
            // Fall back to cached value if callback fails
            tokenToSend = this.accessTokenValue;
        }
        else tokenToSend = this.accessTokenValue;
        // Track whether this token was manually set or fetched via callback
        if (isManualToken) this._manuallySetToken = true;
        else if (this.accessToken) // If we used the callback, clear the manual flag
        this._manuallySetToken = false;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                const payload = {
                    access_token: tokenToSend,
                    version: (0, $buFEH.DEFAULT_VERSION)
                };
                tokenToSend && channel.updateJoinPayload(payload);
                if (channel.joinedOnce && channel.channelAdapter.isJoined()) channel.channelAdapter.push((0, $buFEH.CHANNEL_EVENTS).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Wait for any in-flight auth operations to complete
     * @internal
     */ async _waitForAuthIfNeeded() {
        if (this._authPromise) await this._authPromise;
    }
    /**
     * Safely call setAuth with standardized error handling
     * @internal
     */ _setAuthSafely(context = 'general') {
        // Only refresh auth if using callback-based tokens
        if (!this._isManualToken()) this.setAuth().catch((e)=>{
            this.log('error', `Error setting auth in ${context}`, e);
        });
    }
    /** @internal */ _setupConnectionHandlers() {
        this.socketAdapter.onOpen(()=>{
            const authPromise = this._authPromise || (this.accessToken && !this.accessTokenValue ? this.setAuth() : Promise.resolve());
            authPromise.catch((e)=>{
                this.log('error', 'error waiting for auth on connect', e);
            });
            if (this.worker && !this.workerRef) this._startWorkerHeartbeat();
        });
        this.socketAdapter.onClose(()=>{
            if (this.worker && this.workerRef) this._terminateWorker();
        });
        this.socketAdapter.onMessage((message)=>{
            if (message.ref && message.ref === this._pendingWorkerHeartbeatRef) this._pendingWorkerHeartbeatRef = null;
        });
    }
    /** @internal */ _handleNodeJsRaceCondition() {
        if (this.socketAdapter.isConnected()) // hack: ensure onConnOpen is called
        this.socketAdapter.getSocket().onConnOpen();
    }
    /** @internal */ _wrapHeartbeatCallback(heartbeatCallback) {
        return (status, latency)=>{
            if (status == 'sent') this._setAuthSafely();
            if (heartbeatCallback) heartbeatCallback(status, latency);
        };
    }
    /** @internal */ _startWorkerHeartbeat() {
        if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
        else this.log('worker', `starting default worker`);
        const objectUrl = this._workerObjectUrl(this.workerUrl);
        this.workerRef = new Worker(objectUrl);
        this.workerRef.onerror = (error)=>{
            this.log('worker', 'worker error', error.message);
            this._terminateWorker();
            this.disconnect();
        };
        this.workerRef.onmessage = (event)=>{
            if (event.data.event === 'keepAlive') this.sendHeartbeat();
        };
        this.workerRef.postMessage({
            event: 'start',
            interval: this.heartbeatIntervalMs
        });
    }
    /**
     * Terminate the Web Worker and clear the reference
     * @internal
     */ _terminateWorker() {
        if (this.workerRef) {
            this.log('worker', 'terminating worker');
            this.workerRef.terminate();
            this.workerRef = undefined;
        }
    }
    /** @internal */ _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $f2a173c71efcae28$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
    /**
     * Initialize socket options with defaults
     * @internal
     */ _initializeOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this.worker = (_a = options === null || options === void 0 ? void 0 : options.worker) !== null && _a !== void 0 ? _a : false;
        this.accessToken = (_b = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _b !== void 0 ? _b : null;
        const result = {};
        result.timeout = (_c = options === null || options === void 0 ? void 0 : options.timeout) !== null && _c !== void 0 ? _c : (0, $buFEH.DEFAULT_TIMEOUT);
        result.heartbeatIntervalMs = (_d = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _d !== void 0 ? _d : $f2a173c71efcae28$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        this._disconnectOnEmptyChannelsAfterMs = (_e = options === null || options === void 0 ? void 0 : options.disconnectOnEmptyChannelsAfterMs) !== null && _e !== void 0 ? _e : 2 * ((_f = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _f !== void 0 ? _f : $f2a173c71efcae28$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL);
        // @ts-ignore - mismatch between phoenix and supabase
        result.transport = (_g = options === null || options === void 0 ? void 0 : options.transport) !== null && _g !== void 0 ? _g : (0, $3tQAl.default).getWebSocketConstructor();
        result.params = options === null || options === void 0 ? void 0 : options.params;
        result.logger = options === null || options === void 0 ? void 0 : options.logger;
        result.heartbeatCallback = this._wrapHeartbeatCallback(options === null || options === void 0 ? void 0 : options.heartbeatCallback);
        result.reconnectAfterMs = (_h = options === null || options === void 0 ? void 0 : options.reconnectAfterMs) !== null && _h !== void 0 ? _h : (tries)=>{
            return $f2a173c71efcae28$var$RECONNECT_INTERVALS[tries - 1] || $f2a173c71efcae28$var$DEFAULT_RECONNECT_FALLBACK;
        };
        let defaultEncode;
        let defaultDecode;
        const vsn = (_j = options === null || options === void 0 ? void 0 : options.vsn) !== null && _j !== void 0 ? _j : (0, $buFEH.DEFAULT_VSN);
        switch(vsn){
            case 0, $buFEH.VSN_1_0_0:
                defaultEncode = (payload, callback)=>{
                    return callback(JSON.stringify(payload));
                };
                defaultDecode = (payload, callback)=>{
                    return callback(JSON.parse(payload));
                };
                break;
            case 0, $buFEH.VSN_2_0_0:
                defaultEncode = this.serializer.encode.bind(this.serializer);
                defaultDecode = this.serializer.decode.bind(this.serializer);
                break;
            default:
                throw new Error(`Unsupported serializer version: ${result.vsn}`);
        }
        result.vsn = vsn;
        result.encode = (_k = options === null || options === void 0 ? void 0 : options.encode) !== null && _k !== void 0 ? _k : defaultEncode;
        result.decode = (_l = options === null || options === void 0 ? void 0 : options.decode) !== null && _l !== void 0 ? _l : defaultDecode;
        result.beforeReconnect = this._reconnectAuth.bind(this);
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            result.params = Object.assign(Object.assign({}, result.params), {
                log_level: this.logLevel
            });
        }
        // Handle worker setup
        if (this.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
            result.autoSendHeartbeat = !this.worker;
        }
        return result;
    }
    /** @internal */ async _reconnectAuth() {
        await this._waitForAuthIfNeeded();
        if (!this.isConnected()) this.connect();
    }
}

});
parcelRegister("3tQAl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $288cded6a86478ac$export$2e2bcd8739ae039; });
/**
 * Utilities for creating WebSocket instances across runtimes.
 */ class $288cded6a86478ac$export$67be75336dea7fb5 {
    /**
     * Static-only utility – prevent instantiation.
     */ constructor(){}
    static detectEnvironment() {
        var _a;
        if (typeof WebSocket !== 'undefined') return {
            type: 'native',
            constructor: WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocket !== 'undefined') return {
            type: 'native',
            constructor: globalThis.WebSocket
        };
        if (typeof $parcel$global !== 'undefined' && typeof $parcel$global.WebSocket !== 'undefined') return {
            type: 'native',
            constructor: $parcel$global.WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocketPair !== 'undefined' && typeof globalThis.WebSocket === 'undefined') return {
            type: 'cloudflare',
            error: 'Cloudflare Workers detected. WebSocket clients are not supported in Cloudflare Workers.',
            workaround: 'Use Cloudflare Workers WebSocket API for server-side WebSocket handling, or deploy to a different runtime.'
        };
        if (typeof globalThis !== 'undefined' && globalThis.EdgeRuntime || typeof navigator !== 'undefined' && ((_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('Vercel-Edge'))) return {
            type: 'unsupported',
            error: 'Edge runtime detected (Vercel Edge/Netlify Edge). WebSockets are not supported in edge functions.',
            workaround: 'Use serverless functions or a different deployment target for WebSocket functionality.'
        };
        // Use dynamic property access to avoid Next.js Edge Runtime static analysis warnings
        const _process = globalThis['process'];
        if (_process) {
            const processVersions = _process['versions'];
            if (processVersions && processVersions['node']) {
                // Remove 'v' prefix if present and parse the major version
                const versionString = processVersions['node'];
                const nodeVersion = parseInt(versionString.replace(/^v/, '').split('.')[0]);
                // Node.js 22+ should have native WebSocket
                if (nodeVersion >= 22) {
                    // Check if native WebSocket is available (should be in Node.js 22+)
                    if (typeof globalThis.WebSocket !== 'undefined') return {
                        type: 'native',
                        constructor: globalThis.WebSocket
                    };
                    // If not available, user needs to provide it
                    return {
                        type: 'unsupported',
                        error: `Node.js ${nodeVersion} detected but native WebSocket not found.`,
                        workaround: 'Provide a WebSocket implementation via the transport option.'
                    };
                }
                // Node.js < 22 doesn't have native WebSocket
                return {
                    type: 'unsupported',
                    error: `Node.js ${nodeVersion} detected without native WebSocket support.`,
                    workaround: 'For Node.js < 22, install "ws" package and provide it via the transport option:\nimport ws from "ws"\nnew RealtimeClient(url, { transport: ws })'
                };
            }
        }
        return {
            type: 'unsupported',
            error: 'Unknown JavaScript runtime without WebSocket support.',
            workaround: "Ensure you're running in a supported environment (browser, Node.js, Deno) or provide a custom WebSocket implementation."
        };
    }
    /**
     * Returns the best available WebSocket constructor for the current runtime.
     *
     * @category Realtime
     *
     * @example Example with error handling
     * ```ts
     * try {
     *   const WS = WebSocketFactory.getWebSocketConstructor()
     *   const socket = new WS('wss://example.com/socket')
     * } catch (error) {
     *   console.error('WebSocket not available in this environment.', error)
     * }
     * ```
     */ static getWebSocketConstructor() {
        const env = this.detectEnvironment();
        if (env.constructor) return env.constructor;
        let errorMessage = env.error || 'WebSocket not supported in this environment.';
        if (env.workaround) errorMessage += `\n\nSuggested solution: ${env.workaround}`;
        throw new Error(errorMessage);
    }
    /**
     * Detects whether the runtime can establish WebSocket connections.
     *
     * @category Realtime
     *
     * @example Example in a Node.js script
     * ```ts
     * if (!WebSocketFactory.isWebSocketSupported()) {
     *   console.error('WebSockets are required for this script.')
     *   process.exitCode = 1
     * }
     * ```
     */ static isWebSocketSupported() {
        try {
            const env = this.detectEnvironment();
            return env.type === 'native' || env.type === 'ws';
        } catch (_a) {
            return false;
        }
    }
}
var $288cded6a86478ac$export$2e2bcd8739ae039 = $288cded6a86478ac$export$67be75336dea7fb5;

});

parcelRegister("buFEH", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VERSION", function () { return $85e2cef53c2d1a6f$export$363ebe89e6e7aeef; });
$parcel$export(module.exports, "VSN_1_0_0", function () { return $85e2cef53c2d1a6f$export$b8f6d7e635d6c56b; });
$parcel$export(module.exports, "VSN_2_0_0", function () { return $85e2cef53c2d1a6f$export$3f251ec2d5d5cd3a; });
$parcel$export(module.exports, "DEFAULT_VSN", function () { return $85e2cef53c2d1a6f$export$90c89f9664aa9117; });
$parcel$export(module.exports, "DEFAULT_TIMEOUT", function () { return $85e2cef53c2d1a6f$export$7bd623b29ec8e1eb; });
$parcel$export(module.exports, "MAX_PUSH_BUFFER_SIZE", function () { return $85e2cef53c2d1a6f$export$f227fe8351a81f4a; });
$parcel$export(module.exports, "CHANNEL_STATES", function () { return $85e2cef53c2d1a6f$export$b83816118db74fe7; });
$parcel$export(module.exports, "CHANNEL_EVENTS", function () { return $85e2cef53c2d1a6f$export$8db7548e65d6ea55; });
$parcel$export(module.exports, "CONNECTION_STATE", function () { return $85e2cef53c2d1a6f$export$deda39003d27273; });

var $cONz1 = parcelRequire("cONz1");
const $85e2cef53c2d1a6f$export$363ebe89e6e7aeef = `realtime-js/${(0, $cONz1.version)}`;
const $85e2cef53c2d1a6f$export$b8f6d7e635d6c56b = '1.0.0';
const $85e2cef53c2d1a6f$export$3f251ec2d5d5cd3a = '2.0.0';
const $85e2cef53c2d1a6f$export$90c89f9664aa9117 = $85e2cef53c2d1a6f$export$3f251ec2d5d5cd3a;
const $85e2cef53c2d1a6f$export$a4ad2735b021c132 = (0, $cONz1.version);
const $85e2cef53c2d1a6f$export$7bd623b29ec8e1eb = 10000;
const $85e2cef53c2d1a6f$export$5e80cf62e56a877b = 1000;
const $85e2cef53c2d1a6f$export$f227fe8351a81f4a = 100;
const $85e2cef53c2d1a6f$export$a6d0320a1563d49e = {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
const $85e2cef53c2d1a6f$export$b83816118db74fe7 = {
    closed: 'closed',
    errored: 'errored',
    joined: 'joined',
    joining: 'joining',
    leaving: 'leaving'
};
const $85e2cef53c2d1a6f$export$8db7548e65d6ea55 = {
    close: 'phx_close',
    error: 'phx_error',
    join: 'phx_join',
    reply: 'phx_reply',
    leave: 'phx_leave',
    access_token: 'access_token'
};
const $85e2cef53c2d1a6f$export$b2688bfb999f5751 = {
    websocket: 'websocket'
};
const $85e2cef53c2d1a6f$export$deda39003d27273 = {
    connecting: 'connecting',
    open: 'open',
    closing: 'closing',
    closed: 'closed'
};

});
parcelRegister("cONz1", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $955099e1e4e9d0cb$export$83d89fbfd8236492; });
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $955099e1e4e9d0cb$export$83d89fbfd8236492 = '2.105.1';

});


parcelRegister("dXYJX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2afe6c7f3cd94b1$export$2e2bcd8739ae039; });
class $a2afe6c7f3cd94b1$export$2e2bcd8739ae039 {
    constructor(allowedMetadataKeys){
        this.HEADER_LENGTH = 1;
        this.USER_BROADCAST_PUSH_META_LENGTH = 6;
        this.KINDS = {
            userBroadcastPush: 3,
            userBroadcast: 4
        };
        this.BINARY_ENCODING = 0;
        this.JSON_ENCODING = 1;
        this.BROADCAST_EVENT = 'broadcast';
        this.allowedMetadataKeys = [];
        this.allowedMetadataKeys = allowedMetadataKeys !== null && allowedMetadataKeys !== void 0 ? allowedMetadataKeys : [];
    }
    encode(msg, callback) {
        if (msg.event === this.BROADCAST_EVENT && !(msg.payload instanceof ArrayBuffer) && typeof msg.payload.event === 'string') return callback(this._binaryEncodeUserBroadcastPush(msg));
        let payload = [
            msg.join_ref,
            msg.ref,
            msg.topic,
            msg.event,
            msg.payload
        ];
        return callback(JSON.stringify(payload));
    }
    _binaryEncodeUserBroadcastPush(message) {
        var _a;
        if (this._isArrayBuffer((_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload)) return this._encodeBinaryUserBroadcastPush(message);
        else return this._encodeJsonUserBroadcastPush(message);
    }
    _encodeBinaryUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : new ArrayBuffer(0);
        return this._encodeUserBroadcastPush(message, this.BINARY_ENCODING, userPayload);
    }
    _encodeJsonUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : {};
        const encoder = new TextEncoder();
        const encodedUserPayload = encoder.encode(JSON.stringify(userPayload)).buffer;
        return this._encodeUserBroadcastPush(message, this.JSON_ENCODING, encodedUserPayload);
    }
    _encodeUserBroadcastPush(message, encodingType, encodedPayload) {
        var _a, _b;
        const topic = message.topic;
        const ref = (_a = message.ref) !== null && _a !== void 0 ? _a : '';
        const joinRef = (_b = message.join_ref) !== null && _b !== void 0 ? _b : '';
        const userEvent = message.payload.event;
        // Filter metadata based on allowed keys
        const rest = this.allowedMetadataKeys ? this._pick(message.payload, this.allowedMetadataKeys) : {};
        const metadata = Object.keys(rest).length === 0 ? '' : JSON.stringify(rest);
        // Validate lengths don't exceed uint8 max value (255)
        if (joinRef.length > 255) throw new Error(`joinRef length ${joinRef.length} exceeds maximum of 255`);
        if (ref.length > 255) throw new Error(`ref length ${ref.length} exceeds maximum of 255`);
        if (topic.length > 255) throw new Error(`topic length ${topic.length} exceeds maximum of 255`);
        if (userEvent.length > 255) throw new Error(`userEvent length ${userEvent.length} exceeds maximum of 255`);
        if (metadata.length > 255) throw new Error(`metadata length ${metadata.length} exceeds maximum of 255`);
        const metaLength = this.USER_BROADCAST_PUSH_META_LENGTH + joinRef.length + ref.length + topic.length + userEvent.length + metadata.length;
        const header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.userBroadcastPush); // kind
        view.setUint8(offset++, joinRef.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, userEvent.length);
        view.setUint8(offset++, metadata.length);
        view.setUint8(offset++, encodingType);
        Array.from(joinRef, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(userEvent, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(metadata, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + encodedPayload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(encodedPayload), header.byteLength);
        return combined.buffer;
    }
    decode(rawPayload, callback) {
        if (this._isArrayBuffer(rawPayload)) {
            let result = this._binaryDecode(rawPayload);
            return callback(result);
        }
        if (typeof rawPayload === 'string') {
            const jsonPayload = JSON.parse(rawPayload);
            const [join_ref, ref, topic, event, payload] = jsonPayload;
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const kind = view.getUint8(0);
        const decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.userBroadcast:
                return this._decodeUserBroadcast(buffer, view, decoder);
        }
    }
    _decodeUserBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const userEventSize = view.getUint8(2);
        const metadataSize = view.getUint8(3);
        const payloadEncoding = view.getUint8(4);
        let offset = this.HEADER_LENGTH + 4;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const userEvent = decoder.decode(buffer.slice(offset, offset + userEventSize));
        offset = offset + userEventSize;
        const metadata = decoder.decode(buffer.slice(offset, offset + metadataSize));
        offset = offset + metadataSize;
        const payload = buffer.slice(offset, buffer.byteLength);
        const parsedPayload = payloadEncoding === this.JSON_ENCODING ? JSON.parse(decoder.decode(payload)) : payload;
        const data = {
            type: this.BROADCAST_EVENT,
            event: userEvent,
            payload: parsedPayload
        };
        // Metadata is optional and always JSON encoded
        if (metadataSize > 0) data['meta'] = JSON.parse(metadata);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: this.BROADCAST_EVENT,
            payload: data
        };
    }
    _isArrayBuffer(buffer) {
        var _a;
        return buffer instanceof ArrayBuffer || ((_a = buffer === null || buffer === void 0 ? void 0 : buffer.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'ArrayBuffer';
    }
    _pick(obj, keys) {
        if (!obj || typeof obj !== 'object') return {};
        return Object.fromEntries(Object.entries(obj).filter(([key])=>keys.includes(key)));
    }
}

});

parcelRegister("iNtee", function(module, exports) {

$parcel$export(module.exports, "convertChangeData", function () { return $daf379c2ab5ca666$export$20ce708a1f594c5e; });
$parcel$export(module.exports, "httpEndpointURL", function () { return $daf379c2ab5ca666$export$976fda7151b30cae; });
/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $daf379c2ab5ca666$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($daf379c2ab5ca666$export$4d213a7d364021dc || ($daf379c2ab5ca666$export$4d213a7d364021dc = {}));
const $daf379c2ab5ca666$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    if (!record) return {};
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $daf379c2ab5ca666$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $daf379c2ab5ca666$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $daf379c2ab5ca666$export$3df02a362b86a91(colType, value);
    return $daf379c2ab5ca666$var$noop(value);
};
const $daf379c2ab5ca666$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $daf379c2ab5ca666$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $daf379c2ab5ca666$export$4d213a7d364021dc.bool:
            return $daf379c2ab5ca666$export$3c2e6d1b7583eee6(value);
        case $daf379c2ab5ca666$export$4d213a7d364021dc.float4:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.float8:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.int2:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.int4:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.int8:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.numeric:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.oid:
            return $daf379c2ab5ca666$export$a0a81dc3380ce7d3(value);
        case $daf379c2ab5ca666$export$4d213a7d364021dc.json:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.jsonb:
            return $daf379c2ab5ca666$export$d5b7a8bf56ee1fe2(value);
        case $daf379c2ab5ca666$export$4d213a7d364021dc.timestamp:
            return $daf379c2ab5ca666$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $daf379c2ab5ca666$export$4d213a7d364021dc.abstime:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.date:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.daterange:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.int4range:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.int8range:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.money:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.reltime:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.text:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.time:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.timestamptz:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.timetz:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.tsrange:
        case $daf379c2ab5ca666$export$4d213a7d364021dc.tstzrange:
            return $daf379c2ab5ca666$var$noop(value);
        default:
            // Return the value for remaining types
            return $daf379c2ab5ca666$var$noop(value);
    }
};
const $daf379c2ab5ca666$var$noop = (value)=>{
    return value;
};
const $daf379c2ab5ca666$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $daf379c2ab5ca666$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $daf379c2ab5ca666$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
    return value;
};
const $daf379c2ab5ca666$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$daf379c2ab5ca666$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $daf379c2ab5ca666$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $daf379c2ab5ca666$export$976fda7151b30cae = (socketUrl)=>{
    const wsUrl = new URL(socketUrl);
    wsUrl.protocol = wsUrl.protocol.replace(/^ws/i, 'http');
    wsUrl.pathname = wsUrl.pathname.replace(/\/+$/, '') // remove all trailing slashes
    .replace(/\/socket\/websocket$/i, '') // remove the socket/websocket path
    .replace(/\/socket$/i, '') // remove the socket path
    .replace(/\/websocket$/i, ''); // remove the websocket path
    if (wsUrl.pathname === '' || wsUrl.pathname === '/') wsUrl.pathname = '/api/broadcast';
    else wsUrl.pathname = wsUrl.pathname + '/api/broadcast';
    return wsUrl.href;
};

});

parcelRegister("f3MjB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af6c9d352098ac47$export$2e2bcd8739ae039; });

var $buFEH = parcelRequire("buFEH");

var $lbk1h = parcelRequire("lbk1h");

var $iNtee = parcelRequire("iNtee");

var $kqSVM = parcelRequire("kqSVM");

var $2m4hX = parcelRequire("2m4hX");
var $af6c9d352098ac47$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($af6c9d352098ac47$export$bc171c571098b6c4 || ($af6c9d352098ac47$export$bc171c571098b6c4 = {}));
var $af6c9d352098ac47$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($af6c9d352098ac47$export$9e3fe8e487ef792e || ($af6c9d352098ac47$export$9e3fe8e487ef792e = {}));
var $af6c9d352098ac47$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($af6c9d352098ac47$export$a6885b926af646a2 || ($af6c9d352098ac47$export$a6885b926af646a2 = {}));
const $af6c9d352098ac47$export$154db638d9c0559e = (0, $buFEH.CHANNEL_STATES);
class $af6c9d352098ac47$export$2e2bcd8739ae039 {
    get state() {
        return this.channelAdapter.state;
    }
    set state(state) {
        this.channelAdapter.state = state;
    }
    get joinedOnce() {
        return this.channelAdapter.joinedOnce;
    }
    get timeout() {
        return this.socket.timeout;
    }
    get joinPush() {
        return this.channelAdapter.joinPush;
    }
    get rejoinTimer() {
        return this.channelAdapter.rejoinTimer;
    }
    /**
     * Creates a channel that can broadcast messages, sync presence, and listen to Postgres changes.
     *
     * The topic determines which realtime stream you are subscribing to. Config options let you
     * enable acknowledgement for broadcasts, presence tracking, or private channels.
     *
     * @category Realtime
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const channel = supabase.channel('room1')
     * channel
     *   .on('broadcast', { event: 'cursor-pos' }, (payload) => console.log(payload))
     *   .subscribe()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'your-publishable-key' },
     * })
     * const channel = new RealtimeChannel('realtime:public:messages', { config: {} }, client)
     * ```
     */ constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        var _a, _b;
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, params.config);
        this.channelAdapter = new (0, $2m4hX.default)(this.socket.socketAdapter, topic, this.params);
        this.presence = new (0, $lbk1h.default)(this);
        this._onClose(()=>{
            this.socket._remove(this);
        });
        this._updateFilterTransform();
        this.broadcastEndpointURL = (0, $iNtee.httpEndpointURL)(this.socket.socketAdapter.endPointURL());
        this.private = this.params.config.private || false;
        if (!this.private && ((_b = (_a = this.params.config) === null || _a === void 0 ? void 0 : _a.broadcast) === null || _b === void 0 ? void 0 : _b.replay)) throw new Error(`tried to use replay on public channel '${this.topic}'. It must be a private channel.`);
    }
    /**
     * Subscribe registers your client with the server
     * @category Realtime
     */ subscribe(callback, timeout = this.timeout) {
        var _a, _b, _c;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.channelAdapter.isClosed()) {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            const postgres_changes = (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [];
            const presence_enabled = !!this.bindings[$af6c9d352098ac47$export$9e3fe8e487ef792e.PRESENCE] && this.bindings[$af6c9d352098ac47$export$9e3fe8e487ef792e.PRESENCE].length > 0 || ((_c = this.params.config.presence) === null || _c === void 0 ? void 0 : _c.enabled) === true;
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: Object.assign(Object.assign({}, presence), {
                    enabled: presence_enabled
                }),
                postgres_changes: postgres_changes,
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this._onError((reason)=>{
                callback === null || callback === void 0 || callback($af6c9d352098ac47$export$a6885b926af646a2.CHANNEL_ERROR, (0, $kqSVM.normalizeChannelError)(reason));
            });
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($af6c9d352098ac47$export$a6885b926af646a2.CLOSED));
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this._updateFilterMessage();
            this.channelAdapter.subscribe(timeout).receive('ok', async ({ postgres_changes: postgres_changes })=>{
                // Only refresh auth if using callback-based tokens
                if (!this.socket._isManualToken()) this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($af6c9d352098ac47$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
                this._updatePostgresBindings(postgres_changes, callback);
            }).receive('error', (error)=>{
                this.state = (0, $buFEH.CHANNEL_STATES).errored;
                const message = Object.values(error).join(', ') || 'error';
                callback === null || callback === void 0 || callback($af6c9d352098ac47$export$a6885b926af646a2.CHANNEL_ERROR, new Error(message, {
                    cause: error
                }));
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($af6c9d352098ac47$export$a6885b926af646a2.TIMED_OUT);
            });
        }
        return this;
    }
    _updatePostgresBindings(postgres_changes, callback) {
        var _a;
        const clientPostgresBindings = this.bindings.postgres_changes;
        const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
        const newPostgresBindings = [];
        for(let i = 0; i < bindingsLen; i++){
            const clientPostgresBinding = clientPostgresBindings[i];
            const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
            const serverPostgresFilter = postgres_changes && postgres_changes[i];
            if (serverPostgresFilter && serverPostgresFilter.event === event && $af6c9d352098ac47$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.schema, schema) && $af6c9d352098ac47$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.table, table) && $af6c9d352098ac47$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.filter, filter)) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                id: serverPostgresFilter.id
            }));
            else {
                this.unsubscribe();
                this.state = (0, $buFEH.CHANNEL_STATES).errored;
                callback === null || callback === void 0 || callback($af6c9d352098ac47$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                return;
            }
        }
        this.bindings.postgres_changes = newPostgresBindings;
        if (this.state != (0, $buFEH.CHANNEL_STATES).errored && callback) callback($af6c9d352098ac47$export$a6885b926af646a2.SUBSCRIBED);
    }
    /**
     * Returns the current presence state for this channel.
     *
     * The shape is a map keyed by presence key (for example a user id) where each entry contains the
     * tracked metadata for that user.
     *
     * @category Realtime
     */ presenceState() {
        return this.presence.state;
    }
    /**
     * Sends the supplied payload to the presence tracker so other subscribers can see that this
     * client is online. Use `untrack` to stop broadcasting presence for the same key.
     *
     * @category Realtime
     */ async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    /**
     * Removes the current presence state for this client.
     *
     * @category Realtime
     */ async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    /**
     * Listen to realtime events on this channel.
     * @category Realtime
     *
     * @remarks
     * - By default, Broadcast and Presence are enabled for all projects.
     * - By default, listening to database changes is disabled for new projects due to database performance and security concerns. You can turn it on by managing Realtime's [replication](/docs/guides/api#realtime-api-overview).
     * - You can receive the "previous" data for updates and deletes by setting the table's `REPLICA IDENTITY` to `FULL` (e.g., `ALTER TABLE your_table REPLICA IDENTITY FULL;`).
     * - Row level security is not applied to delete statements. When RLS is enabled and replica identity is set to full, only the primary key is sent to clients.
     *
     * @example Listen to broadcast messages
     * ```js
     * const channel = supabase.channel("room1")
     *
     * channel.on("broadcast", { event: "cursor-pos" }, (payload) => {
     *   console.log("Cursor position received!", payload);
     * }).subscribe((status) => {
     *   if (status === "SUBSCRIBED") {
     *     channel.send({
     *       type: "broadcast",
     *       event: "cursor-pos",
     *       payload: { x: Math.random(), y: Math.random() },
     *     });
     *   }
     * });
     * ```
     *
     * @example Listen to presence sync
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'sync' }, () => {
     *     console.log('Synced presence state: ', channel.presenceState())
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *     }
     *   })
     * ```
     *
     * @example Listen to presence join
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'join' }, ({ newPresences }) => {
     *     console.log('Newly joined presences: ', newPresences)
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *     }
     *   })
     * ```
     *
     * @example Listen to presence leave
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'leave' }, ({ leftPresences }) => {
     *     console.log('Newly left presences: ', leftPresences)
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *       await channel.untrack()
     *     }
     *   })
     * ```
     *
     * @example Listen to all database changes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: '*', schema: '*' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @example Listen to a specific table
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: '*', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @example Listen to inserts
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to updates
     * By default, Supabase will send only the updated record. If you want to receive the previous values as well you can
     * enable full replication for the table you are listening to:
     *
     * ```sql
     * alter table "your_table" replica identity full;
     * ```
     *
     * @example Listen to updates
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to deletes
     * By default, Supabase does not send deleted records. If you want to receive the deleted record you can
     * enable full replication for the table you are listening to:
     *
     * ```sql
     * alter table "your_table" replica identity full;
     * ```
     *
     * @example Listen to deletes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to multiple events
     * You can chain listeners if you want to listen to multiple events for each table.
     *
     * @example Listen to multiple events
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, handleRecordInserted)
     *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, handleRecordDeleted)
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to row level changes
     * You can listen to individual rows using the format `{table}:{col}=eq.{val}` - where `{col}` is the column name, and `{val}` is the value which you want to match.
     *
     * @example Listen to row level changes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries', filter: 'id=eq.200' }, handleRecordUpdated)
     *   .subscribe()
     * ```
     */ on(type, filter, callback) {
        const stateCheck = this.channelAdapter.isJoined() || this.channelAdapter.isJoining();
        const typeCheck = type === $af6c9d352098ac47$export$9e3fe8e487ef792e.PRESENCE || type === $af6c9d352098ac47$export$9e3fe8e487ef792e.POSTGRES_CHANGES;
        if (stateCheck && typeCheck) {
            this.socket.log('channel', `cannot add \`${type}\` callbacks for ${this.topic} after \`subscribe()\`.`);
            throw new Error(`cannot add \`${type}\` callbacks for ${this.topic} after \`subscribe()\`.`);
        }
        return this._on(type, filter, callback);
    }
    /**
     * Sends a broadcast message explicitly via REST API.
     *
     * This method always uses the REST API endpoint regardless of WebSocket connection state.
     * Useful when you want to guarantee REST delivery or when gradually migrating from implicit REST fallback.
     *
     * @param event The name of the broadcast event
     * @param payload Payload to be sent (required)
     * @param opts Options including timeout
     * @returns Promise resolving to object with success status, and error details if failed
     *
     * @category Realtime
     */ async httpSend(event, payload, opts = {}) {
        var _a;
        if (payload === undefined || payload === null) return Promise.reject(new Error('Payload is required for httpSend()'));
        const headers = {
            apikey: this.socket.apiKey ? this.socket.apiKey : '',
            'Content-Type': 'application/json'
        };
        if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                messages: [
                    {
                        topic: this.subTopic,
                        event: event,
                        payload: payload,
                        private: this.private
                    }
                ]
            })
        };
        const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
        if (response.status === 202) return {
            success: true
        };
        let errorMessage = response.statusText;
        try {
            const errorBody = await response.json();
            errorMessage = errorBody.error || errorBody.message || errorMessage;
        } catch (_b) {}
        return Promise.reject(new Error(errorMessage));
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     *
     * @category Realtime
     *
     * @remarks
     * - When using REST you don't need to subscribe to the channel
     * - REST calls are only available from 2.37.0 onwards
     *
     * @example Send a message via websocket
     * ```js
     * const channel = supabase.channel('room1')
     *
     * channel.subscribe((status) => {
     *   if (status === 'SUBSCRIBED') {
     *     channel.send({
     *       type: 'broadcast',
     *       event: 'cursor-pos',
     *       payload: { x: Math.random(), y: Math.random() },
     *     })
     *   }
     * })
     * ```
     *
     * @exampleResponse Send a message via websocket
     * ```js
     * ok | timed out | error
     * ```
     *
     * @example Send a message via REST
     * ```js
     * supabase
     *   .channel('room1')
     *   .httpSend('cursor-pos', { x: Math.random(), y: Math.random() })
     * ```
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this.channelAdapter.canPush() && args.type === 'broadcast') {
            console.warn("Realtime send() is automatically falling back to REST API. This behavior will be deprecated in the future. Please use httpSend() explicitly for REST delivery.");
            const { event: event, payload: endpoint_payload } = args;
            const headers = {
                apikey: this.socket.apiKey ? this.socket.apiKey : '',
                'Content-Type': 'application/json'
            };
            if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this.channelAdapter.push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    /**
     * Updates the payload that will be sent the next time the channel joins (reconnects).
     * Useful for rotating access tokens or updating config without re-creating the channel.
     *
     * @category Realtime
     */ updateJoinPayload(payload) {
        this.channelAdapter.updateJoinPayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     *
     * @category Realtime
     */ async unsubscribe(timeout = this.timeout) {
        return new Promise((resolve)=>{
            this.channelAdapter.unsubscribe(timeout).receive('ok', ()=>resolve('ok')).receive('timeout', ()=>resolve('timed out')).receive('error', ()=>resolve('error'));
        });
    }
    /**
     * Destroys and stops related timers.
     *
     * @category Realtime
     */ teardown() {
        this.channelAdapter.teardown();
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const ref = this.channelAdapter.on(type, callback);
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback,
            ref: ref
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        this._updateFilterMessage();
        return this;
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this.channelAdapter.onClose(callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this.channelAdapter.onError(callback);
    }
    /** @internal */ _updateFilterMessage() {
        this.channelAdapter.updateFilterBindings((binding, payload, ref)=>{
            var _a, _b, _c, _d, _e, _f, _g;
            const typeLower = binding.event.toLocaleLowerCase();
            if (this._notThisChannelEvent(typeLower, ref)) return false;
            const bind = (_a = this.bindings[typeLower]) === null || _a === void 0 ? void 0 : _a.find((bind)=>bind.ref === binding.ref);
            if (!bind) return true;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event;
                    return bindId && ((_c = payload.ids) === null || _c === void 0 ? void 0 : _c.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_d = payload.data) === null || _d === void 0 ? void 0 : _d.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_f = (_e = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _e === void 0 ? void 0 : _e.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_g = payload === null || payload === void 0 ? void 0 : payload.event) === null || _g === void 0 ? void 0 : _g.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        });
    }
    /** @internal */ _notThisChannelEvent(event, ref) {
        const { close: close, error: error, leave: leave, join: join } = (0, $buFEH.CHANNEL_EVENTS);
        const events = [
            close,
            error,
            leave,
            join
        ];
        return ref && events.includes(event) && ref !== this.joinPush.ref;
    }
    /** @internal */ _updateFilterTransform() {
        this.channelAdapter.updatePayloadTransform((event, payload, ref)=>{
            if (typeof payload === 'object' && 'ids' in payload) {
                const postgresChanges = payload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                return Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            return payload;
        });
    }
    copyBindings(other) {
        if (this.joinedOnce) throw new Error('cannot copy bindings into joined channel');
        for(const kind in other.bindings)for (const binding of other.bindings[kind])this._on(binding.type, binding.filter, binding.callback);
    }
    /**
     * Compares two optional filter values for equality.
     * Treats undefined, null, and empty string as equivalent empty values.
     * @internal
     */ static isFilterValueEqual(serverValue, clientValue) {
        const normalizedServer = serverValue !== null && serverValue !== void 0 ? serverValue : undefined;
        const normalizedClient = clientValue !== null && clientValue !== void 0 ? clientValue : undefined;
        return normalizedServer === normalizedClient;
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $iNtee.convertChangeData(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $iNtee.convertChangeData(payload.columns, payload.old_record);
        return records;
    }
}

});
parcelRegister("lbk1h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6ba27875477301d$export$2e2bcd8739ae039; });
/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ 
var $9nVWt = parcelRequire("9nVWt");
var $f6ba27875477301d$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($f6ba27875477301d$export$f1ce049df2794fb4 || ($f6ba27875477301d$export$f1ce049df2794fb4 = {}));
class $f6ba27875477301d$export$2e2bcd8739ae039 {
    get state() {
        return this.presenceAdapter.state;
    }
    /**
     * Creates a Presence helper that keeps the local presence state in sync with the server.
     *
     * @param channel - The realtime channel to bind to.
     * @param opts - Optional custom event names, e.g. `{ events: { state: 'state', diff: 'diff' } }`.
     *
     * @category Realtime
     *
     * @example Example for a presence channel
     * ```ts
     * const presence = new RealtimePresence(channel)
     *
     * channel.on('presence', ({ event, key }) => {
     *   console.log(`Presence ${event} on ${key}`)
     * })
     * ```
     */ constructor(channel, opts){
        this.channel = channel;
        this.presenceAdapter = new (0, $9nVWt.default)(this.channel.channelAdapter, opts);
    }
}

});
parcelRegister("9nVWt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d53352063c6895d$export$2e2bcd8739ae039; });

var $aVPy4 = parcelRequire("aVPy4");
class $6d53352063c6895d$export$2e2bcd8739ae039 {
    constructor(channel, opts){
        const phoenixOptions = $6d53352063c6895d$var$phoenixPresenceOptions(opts);
        this.presence = new (0, $aVPy4.Presence)(channel.getChannel(), phoenixOptions);
        this.presence.onJoin((key, currentPresence, newPresence)=>{
            const onJoinPayload = $6d53352063c6895d$export$2e2bcd8739ae039.onJoinPayload(key, currentPresence, newPresence);
            channel.getChannel().trigger('presence', onJoinPayload);
        });
        this.presence.onLeave((key, currentPresence, leftPresence)=>{
            const onLeavePayload = $6d53352063c6895d$export$2e2bcd8739ae039.onLeavePayload(key, currentPresence, leftPresence);
            channel.getChannel().trigger('presence', onLeavePayload);
        });
        this.presence.onSync(()=>{
            channel.getChannel().trigger('presence', {
                event: 'sync'
            });
        });
    }
    get state() {
        return $6d53352063c6895d$export$2e2bcd8739ae039.transformState(this.presence.state);
    }
    /**
     * @private
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example Transform state
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     */ static transformState(state) {
        state = $6d53352063c6895d$var$cloneState(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            newState[key] = $6d53352063c6895d$var$transformState(presences);
            return newState;
        }, {});
    }
    static onJoinPayload(key, currentPresence, newPresence) {
        const currentPresences = $6d53352063c6895d$var$parseCurrentPresences(currentPresence);
        const newPresences = $6d53352063c6895d$var$transformState(newPresence);
        return {
            event: 'join',
            key: key,
            currentPresences: currentPresences,
            newPresences: newPresences
        };
    }
    static onLeavePayload(key, currentPresence, leftPresence) {
        const currentPresences = $6d53352063c6895d$var$parseCurrentPresences(currentPresence);
        const leftPresences = $6d53352063c6895d$var$transformState(leftPresence);
        return {
            event: 'leave',
            key: key,
            currentPresences: currentPresences,
            leftPresences: leftPresences
        };
    }
}
function $6d53352063c6895d$var$transformState(presences) {
    return presences.metas.map((presence)=>{
        presence['presence_ref'] = presence['phx_ref'];
        delete presence['phx_ref'];
        delete presence['phx_ref_prev'];
        return presence;
    });
}
function $6d53352063c6895d$var$cloneState(state) {
    return JSON.parse(JSON.stringify(state));
}
function $6d53352063c6895d$var$phoenixPresenceOptions(opts) {
    return (opts === null || opts === void 0 ? void 0 : opts.events) && {
        events: opts.events
    };
}
function $6d53352063c6895d$var$parseCurrentPresences(currentPresences) {
    return (currentPresences === null || currentPresences === void 0 ? void 0 : currentPresences.metas) ? $6d53352063c6895d$var$transformState(currentPresences) : [];
}

});
parcelRegister("aVPy4", function(module, exports) {

$parcel$export(module.exports, "Presence", function () { return $b48ed95b74083d0b$export$99c2b779aa4e8b8b; });
$parcel$export(module.exports, "Socket", function () { return $b48ed95b74083d0b$export$4798917dbf149b79; });
// js/phoenix/utils.js
var $b48ed95b74083d0b$var$closure = (value)=>{
    if (typeof value === "function") return /** @type {() => T} */ value;
    else {
        let closure2 = function() {
            return value;
        };
        return closure2;
    }
};
// js/phoenix/constants.js
var $b48ed95b74083d0b$var$globalSelf = typeof self !== "undefined" ? self : null;
var $b48ed95b74083d0b$var$phxWindow = typeof window !== "undefined" ? window : null;
var $b48ed95b74083d0b$var$global = $b48ed95b74083d0b$var$globalSelf || $b48ed95b74083d0b$var$phxWindow || globalThis;
var $b48ed95b74083d0b$var$DEFAULT_VSN = "2.0.0";
var $b48ed95b74083d0b$var$DEFAULT_TIMEOUT = 1e4;
var $b48ed95b74083d0b$var$WS_CLOSE_NORMAL = 1e3;
var $b48ed95b74083d0b$var$SOCKET_STATES = /** @type {const} */ {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
var $b48ed95b74083d0b$var$CHANNEL_STATES = /** @type {const} */ {
    closed: "closed",
    errored: "errored",
    joined: "joined",
    joining: "joining",
    leaving: "leaving"
};
var $b48ed95b74083d0b$var$CHANNEL_EVENTS = /** @type {const} */ {
    close: "phx_close",
    error: "phx_error",
    join: "phx_join",
    reply: "phx_reply",
    leave: "phx_leave"
};
var $b48ed95b74083d0b$var$TRANSPORTS = /** @type {const} */ {
    longpoll: "longpoll",
    websocket: "websocket"
};
var $b48ed95b74083d0b$var$XHR_STATES = /** @type {const} */ {
    complete: 4
};
var $b48ed95b74083d0b$var$AUTH_TOKEN_PREFIX = "base64url.bearer.phx.";
// js/phoenix/push.js
var $b48ed95b74083d0b$export$fb87db22c6b0e2ba = class {
    /**
   * Initializes the Push
   * @param {Channel} channel - The Channel
   * @param {ChannelEvent} event - The event, for example `"phx_join"`
   * @param {() => Record<string, unknown>} payload - The payload, for example `{user_id: 123}`
   * @param {number} timeout - The push timeout in milliseconds
   */ constructor(channel, event, payload, timeout){
        this.channel = channel;
        this.event = event;
        this.payload = payload || function() {
            return {};
        };
        this.receivedResp = null;
        this.timeout = timeout;
        this.timeoutTimer = null;
        this.recHooks = [];
        this.sent = false;
        this.ref = void 0;
    }
    /**
   *
   * @param {number} timeout
   */ resend(timeout) {
        this.timeout = timeout;
        this.reset();
        this.send();
    }
    /**
   *
   */ send() {
        if (this.hasReceived("timeout")) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload(),
            ref: this.ref,
            join_ref: this.channel.joinRef()
        });
    }
    /**
   *
   * @param {string} status
   * @param {(response: any) => void} callback
   */ receive(status, callback) {
        if (this.hasReceived(status)) callback(this.receivedResp.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    reset() {
        this.cancelRefEvent();
        this.ref = null;
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
    }
    destroy() {
        this.cancelRefEvent();
        this.cancelTimeout();
    }
    /**
   * @private
   */ matchReceive({ status: status, response: response, _ref: _ref }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    /**
   * @private
   */ cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel.off(this.refEvent);
    }
    cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
    }
    startTimeout() {
        if (this.timeoutTimer) this.cancelTimeout();
        this.ref = this.channel.socket.makeRef();
        this.refEvent = this.channel.replyEventName(this.ref);
        this.channel.on(this.refEvent, (payload)=>{
            this.cancelRefEvent();
            this.cancelTimeout();
            this.receivedResp = payload;
            this.matchReceive(payload);
        });
        this.timeoutTimer = setTimeout(()=>{
            this.trigger("timeout", {});
        }, this.timeout);
    }
    /**
   * @private
   */ hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
    trigger(status, response) {
        this.channel.trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
};
// js/phoenix/timer.js
var $b48ed95b74083d0b$export$c57e9b2d8b9e4de = class {
    /**
  * @param {() => void} callback
  * @param {(tries: number) => number} timerCalc
  */ constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = void 0;
        this.tries = 0;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    /**
   * Cancels any previous scheduleTimeout and schedules callback
   */ scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
};
// js/phoenix/channel.js
var $b48ed95b74083d0b$export$cfdacaa37f9b4dd7 = class {
    /**
   * @param {string} topic
   * @param {Params | (() => Params)} params
   * @param {Socket} socket
   */ constructor(topic, params, socket){
        this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.closed;
        this.topic = topic;
        this.params = $b48ed95b74083d0b$var$closure(params || {});
        this.socket = socket;
        this.bindings = [];
        this.bindingRef = 0;
        this.timeout = this.socket.timeout;
        this.joinedOnce = false;
        this.joinPush = new $b48ed95b74083d0b$export$fb87db22c6b0e2ba(this, $b48ed95b74083d0b$var$CHANNEL_EVENTS.join, this.params, this.timeout);
        this.pushBuffer = [];
        this.stateChangeRefs = [];
        this.rejoinTimer = new $b48ed95b74083d0b$export$c57e9b2d8b9e4de(()=>{
            if (this.socket.isConnected()) this.rejoin();
        }, this.socket.rejoinAfterMs);
        this.stateChangeRefs.push(this.socket.onError(()=>this.rejoinTimer.reset()));
        this.stateChangeRefs.push(this.socket.onOpen(()=>{
            this.rejoinTimer.reset();
            if (this.isErrored()) this.rejoin();
        }));
        this.joinPush.receive("ok", ()=>{
            this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this.joinPush.receive("error", (reason)=>{
            this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.errored;
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.onClose(()=>{
            this.rejoinTimer.reset();
            if (this.socket.hasLogger()) this.socket.log("channel", `close ${this.topic}`);
            this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.closed;
            this.socket.remove(this);
        });
        this.onError((reason)=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.isJoining()) this.joinPush.reset();
            this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.errored;
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive("timeout", ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout);
            let leavePush = new $b48ed95b74083d0b$export$fb87db22c6b0e2ba(this, $b48ed95b74083d0b$var$CHANNEL_EVENTS.leave, $b48ed95b74083d0b$var$closure({}), this.timeout);
            leavePush.send();
            this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.errored;
            this.joinPush.reset();
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.on($b48ed95b74083d0b$var$CHANNEL_EVENTS.reply, (payload, ref)=>{
            this.trigger(this.replyEventName(ref), payload);
        });
    }
    /**
   * Join the channel
   * @param {number} timeout
   * @returns {Push}
   */ join(timeout = this.timeout) {
        if (this.joinedOnce) throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
        else {
            this.timeout = timeout;
            this.joinedOnce = true;
            this.rejoin();
            return this.joinPush;
        }
    }
    /**
   * Teardown the channel.
   *
   * Destroys and stops related timers.
   */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.pushBuffer = [];
        this.rejoinTimer.reset();
        this.joinPush.destroy();
        this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.closed;
        this.bindings = [];
    }
    /**
   * Hook into channel close
   * @param {ChannelBindingCallback} callback
   */ onClose(callback) {
        this.on($b48ed95b74083d0b$var$CHANNEL_EVENTS.close, callback);
    }
    /**
   * Hook into channel errors
   * @param {ChannelOnErrorCallback} callback
   * @return {number}
   */ onError(callback) {
        return this.on($b48ed95b74083d0b$var$CHANNEL_EVENTS.error, (reason)=>callback(reason));
    }
    /**
   * Subscribes on channel events
   *
   * Subscription returns a ref counter, which can be used later to
   * unsubscribe the exact event listener
   *
   * @example
   * const ref1 = channel.on("event", do_stuff)
   * const ref2 = channel.on("event", do_other_stuff)
   * channel.off("event", ref1)
   * // Since unsubscription, do_stuff won't fire,
   * // while do_other_stuff will keep firing on the "event"
   *
   * @param {string} event
   * @param {ChannelBindingCallback} callback
   * @returns {number} ref
   */ on(event, callback) {
        let ref = this.bindingRef++;
        this.bindings.push({
            event: event,
            ref: ref,
            callback: callback
        });
        return ref;
    }
    /**
   * Unsubscribes off of channel events
   *
   * Use the ref returned from a channel.on() to unsubscribe one
   * handler, or pass nothing for the ref to unsubscribe all
   * handlers for the given event.
   *
   * @example
   * // Unsubscribe the do_stuff handler
   * const ref1 = channel.on("event", do_stuff)
   * channel.off("event", ref1)
   *
   * // Unsubscribe all handlers from event
   * channel.off("event")
   *
   * @param {string} event
   * @param {number} [ref]
   */ off(event, ref) {
        this.bindings = this.bindings.filter((bind)=>{
            return !(bind.event === event && (typeof ref === "undefined" || ref === bind.ref));
        });
    }
    /**
   * @private
   */ canPush() {
        return this.socket.isConnected() && this.isJoined();
    }
    /**
   * Sends a message `event` to phoenix with the payload `payload`.
   * Phoenix receives this in the `handle_in(event, payload, socket)`
   * function. if phoenix replies or it times out (default 10000ms),
   * then optionally the reply can be received.
   *
   * @example
   * channel.push("event")
   *   .receive("ok", payload => console.log("phoenix replied:", payload))
   *   .receive("error", err => console.log("phoenix errored", err))
   *   .receive("timeout", () => console.log("timed out pushing"))
   * @param {string} event
   * @param {Object} payload
   * @param {number} [timeout]
   * @returns {Push}
   */ push(event, payload, timeout = this.timeout) {
        payload = payload || {};
        if (!this.joinedOnce) throw new Error(`tried to push '${event}' to '${this.topic}' before joining. Use channel.join() before pushing events`);
        let pushEvent = new $b48ed95b74083d0b$export$fb87db22c6b0e2ba(this, event, function() {
            return payload;
        }, timeout);
        if (this.canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /** Leaves the channel
   *
   * Unsubscribes from server events, and
   * instructs channel to terminate on server
   *
   * Triggers onClose() hooks
   *
   * To receive leave acknowledgements, use the `receive`
   * hook to bind to the server ack, ie:
   *
   * @example
   * channel.leave().receive("ok", () => alert("left!") )
   *
   * @param {number} timeout
   * @returns {Push}
   */ leave(timeout = this.timeout) {
        this.rejoinTimer.reset();
        this.joinPush.cancelTimeout();
        this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.leaving;
        let onClose = ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `leave ${this.topic}`);
            this.trigger($b48ed95b74083d0b$var$CHANNEL_EVENTS.close, "leave");
        };
        let leavePush = new $b48ed95b74083d0b$export$fb87db22c6b0e2ba(this, $b48ed95b74083d0b$var$CHANNEL_EVENTS.leave, $b48ed95b74083d0b$var$closure({}), timeout);
        leavePush.receive("ok", ()=>onClose()).receive("timeout", ()=>onClose());
        leavePush.send();
        if (!this.canPush()) leavePush.trigger("ok", {});
        return leavePush;
    }
    /**
   * Overridable message hook
   *
   * Receives all events for specialized message handling
   * before dispatching to the channel callbacks.
   *
   * Must return the payload, modified or unmodified
   * @type{ChannelOnMessage}
   */ onMessage(_event, payload, _ref) {
        return payload;
    }
    /**
   * Overridable filter hook
   *
   * If this function returns `true`, `binding`'s callback will be called.
   *
   * @type{ChannelFilterBindings}
   */ filterBindings(_binding, _payload, _ref) {
        return true;
    }
    isMember(topic, event, payload, joinRef) {
        if (this.topic !== topic) return false;
        if (joinRef && joinRef !== this.joinRef()) {
            if (this.socket.hasLogger()) this.socket.log("channel", "dropping outdated message", {
                topic: topic,
                event: event,
                payload: payload,
                joinRef: joinRef
            });
            return false;
        } else return true;
    }
    joinRef() {
        return this.joinPush.ref;
    }
    /**
   * @private
   */ rejoin(timeout = this.timeout) {
        if (this.isLeaving()) return;
        this.socket.leaveOpenTopic(this.topic);
        this.state = $b48ed95b74083d0b$var$CHANNEL_STATES.joining;
        this.joinPush.resend(timeout);
    }
    /**
   * @param {string} event
   * @param {unknown} [payload]
   * @param {?string} [ref]
   * @param {?string} [joinRef]
   */ trigger(event, payload, ref, joinRef) {
        let handledPayload = this.onMessage(event, payload, ref, joinRef);
        if (payload && !handledPayload) throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");
        let eventBindings = this.bindings.filter((bind)=>bind.event === event && this.filterBindings(bind, payload, ref));
        for(let i = 0; i < eventBindings.length; i++){
            let bind = eventBindings[i];
            bind.callback(handledPayload, ref, joinRef || this.joinRef());
        }
    }
    /**
  * @param {string} ref
  */ replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    isClosed() {
        return this.state === $b48ed95b74083d0b$var$CHANNEL_STATES.closed;
    }
    isErrored() {
        return this.state === $b48ed95b74083d0b$var$CHANNEL_STATES.errored;
    }
    isJoined() {
        return this.state === $b48ed95b74083d0b$var$CHANNEL_STATES.joined;
    }
    isJoining() {
        return this.state === $b48ed95b74083d0b$var$CHANNEL_STATES.joining;
    }
    isLeaving() {
        return this.state === $b48ed95b74083d0b$var$CHANNEL_STATES.leaving;
    }
};
// js/phoenix/ajax.js
var $b48ed95b74083d0b$var$Ajax = class {
    static request(method, endPoint, headers, body, timeout, ontimeout, callback) {
        if ($b48ed95b74083d0b$var$global.XDomainRequest) {
            let req = new $b48ed95b74083d0b$var$global.XDomainRequest();
            return this.xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback);
        } else if ($b48ed95b74083d0b$var$global.XMLHttpRequest) {
            let req = new $b48ed95b74083d0b$var$global.XMLHttpRequest();
            return this.xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback);
        } else if ($b48ed95b74083d0b$var$global.fetch && $b48ed95b74083d0b$var$global.AbortController) return this.fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback);
        else throw new Error("No suitable XMLHttpRequest implementation found");
    }
    static fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback) {
        let options = {
            method: method,
            headers: headers,
            body: body
        };
        let controller = null;
        if (timeout) {
            controller = new AbortController();
            const _timeoutId = setTimeout(()=>controller.abort(), timeout);
            options.signal = controller.signal;
        }
        $b48ed95b74083d0b$var$global.fetch(endPoint, options).then((response)=>response.text()).then((data)=>this.parseJSON(data)).then((data)=>callback && callback(data)).catch((err)=>{
            if (err.name === "AbortError" && ontimeout) ontimeout();
            else callback && callback(null);
        });
        return controller;
    }
    static xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback) {
        req.timeout = timeout;
        req.open(method, endPoint);
        req.onload = ()=>{
            let response = this.parseJSON(req.responseText);
            callback && callback(response);
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.onprogress = ()=>{};
        req.send(body);
        return req;
    }
    static xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback) {
        req.open(method, endPoint, true);
        req.timeout = timeout;
        for (let [key, value] of Object.entries(headers))req.setRequestHeader(key, value);
        req.onerror = ()=>callback && callback(null);
        req.onreadystatechange = ()=>{
            if (req.readyState === $b48ed95b74083d0b$var$XHR_STATES.complete && callback) {
                let response = this.parseJSON(req.responseText);
                callback(response);
            }
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.send(body);
        return req;
    }
    static parseJSON(resp) {
        if (!resp || resp === "") return null;
        try {
            return JSON.parse(resp);
        } catch  {
            console && console.log("failed to parse JSON response", resp);
            return null;
        }
    }
    static serialize(obj, parentKey) {
        let queryStr = [];
        for(var key in obj){
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            let paramKey = parentKey ? `${parentKey}[${key}]` : key;
            let paramVal = obj[key];
            if (typeof paramVal === "object") queryStr.push(this.serialize(paramVal, paramKey));
            else queryStr.push(encodeURIComponent(paramKey) + "=" + encodeURIComponent(paramVal));
        }
        return queryStr.join("&");
    }
    static appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        let prefix = url.match(/\?/) ? "&" : "?";
        return `${url}${prefix}${this.serialize(params)}`;
    }
};
// js/phoenix/longpoll.js
var $b48ed95b74083d0b$var$arrayBufferToBase64 = (buffer)=>{
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for(let i = 0; i < len; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
};
var $b48ed95b74083d0b$export$57a2cdf8ead4f893 = class {
    constructor(endPoint, protocols){
        if (protocols && protocols.length === 2 && protocols[1].startsWith($b48ed95b74083d0b$var$AUTH_TOKEN_PREFIX)) this.authToken = atob(protocols[1].slice($b48ed95b74083d0b$var$AUTH_TOKEN_PREFIX.length));
        this.endPoint = null;
        this.token = null;
        this.skipHeartbeat = true;
        this.reqs = /* @__PURE__ */ new Set();
        this.awaitingBatchAck = false;
        this.currentBatch = null;
        this.currentBatchTimer = null;
        this.batchBuffer = [];
        this.onopen = function() {};
        this.onerror = function() {};
        this.onmessage = function() {};
        this.onclose = function() {};
        this.pollEndpoint = this.normalizeEndpoint(endPoint);
        this.readyState = $b48ed95b74083d0b$var$SOCKET_STATES.connecting;
        setTimeout(()=>this.poll(), 0);
    }
    normalizeEndpoint(endPoint) {
        return endPoint.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + $b48ed95b74083d0b$var$TRANSPORTS.websocket), "$1/" + $b48ed95b74083d0b$var$TRANSPORTS.longpoll);
    }
    endpointURL() {
        return $b48ed95b74083d0b$var$Ajax.appendParams(this.pollEndpoint, {
            token: this.token
        });
    }
    closeAndRetry(code, reason, wasClean) {
        this.close(code, reason, wasClean);
        this.readyState = $b48ed95b74083d0b$var$SOCKET_STATES.connecting;
    }
    ontimeout() {
        this.onerror("timeout");
        this.closeAndRetry(1005, "timeout", false);
    }
    isActive() {
        return this.readyState === $b48ed95b74083d0b$var$SOCKET_STATES.open || this.readyState === $b48ed95b74083d0b$var$SOCKET_STATES.connecting;
    }
    poll() {
        const headers = {
            "Accept": "application/json"
        };
        if (this.authToken) headers["X-Phoenix-AuthToken"] = this.authToken;
        this.ajax("GET", headers, null, ()=>this.ontimeout(), (resp)=>{
            if (resp) {
                var { status: status, token: token, messages: messages } = resp;
                if (status === 410 && this.token !== null) {
                    this.onerror(410);
                    this.closeAndRetry(3410, "session_gone", false);
                    return;
                }
                this.token = token;
            } else status = 0;
            switch(status){
                case 200:
                    messages.forEach((msg)=>{
                        setTimeout(()=>this.onmessage({
                                data: msg
                            }), 0);
                    });
                    this.poll();
                    break;
                case 204:
                    this.poll();
                    break;
                case 410:
                    this.readyState = $b48ed95b74083d0b$var$SOCKET_STATES.open;
                    this.onopen({});
                    this.poll();
                    break;
                case 403:
                    this.onerror(403);
                    this.close(1008, "forbidden", false);
                    break;
                case 0:
                case 500:
                    this.onerror(500);
                    this.closeAndRetry(1011, "internal server error", 500);
                    break;
                default:
                    throw new Error(`unhandled poll status ${status}`);
            }
        });
    }
    // we collect all pushes within the current event loop by
    // setTimeout 0, which optimizes back-to-back procedural
    // pushes against an empty buffer
    send(body) {
        if (typeof body !== "string") body = $b48ed95b74083d0b$var$arrayBufferToBase64(body);
        if (this.currentBatch) this.currentBatch.push(body);
        else if (this.awaitingBatchAck) this.batchBuffer.push(body);
        else {
            this.currentBatch = [
                body
            ];
            this.currentBatchTimer = setTimeout(()=>{
                this.batchSend(this.currentBatch);
                this.currentBatch = null;
            }, 0);
        }
    }
    batchSend(messages) {
        this.awaitingBatchAck = true;
        this.ajax("POST", {
            "Content-Type": "application/x-ndjson"
        }, messages.join("\n"), ()=>this.onerror("timeout"), (resp)=>{
            this.awaitingBatchAck = false;
            if (!resp || resp.status !== 200) {
                this.onerror(resp && resp.status);
                this.closeAndRetry(1011, "internal server error", false);
            } else if (this.batchBuffer.length > 0) {
                this.batchSend(this.batchBuffer);
                this.batchBuffer = [];
            }
        });
    }
    close(code, reason, wasClean) {
        for (let req of this.reqs)req.abort();
        this.readyState = $b48ed95b74083d0b$var$SOCKET_STATES.closed;
        let opts = Object.assign({
            code: 1e3,
            reason: void 0,
            wasClean: true
        }, {
            code: code,
            reason: reason,
            wasClean: wasClean
        });
        this.batchBuffer = [];
        clearTimeout(this.currentBatchTimer);
        this.currentBatchTimer = null;
        if (typeof CloseEvent !== "undefined") this.onclose(new CloseEvent("close", opts));
        else this.onclose(opts);
    }
    ajax(method, headers, body, onCallerTimeout, callback) {
        let req;
        let ontimeout = ()=>{
            this.reqs.delete(req);
            onCallerTimeout();
        };
        req = $b48ed95b74083d0b$var$Ajax.request(method, this.endpointURL(), headers, body, this.timeout, ontimeout, (resp)=>{
            this.reqs.delete(req);
            if (this.isActive()) callback(resp);
        });
        this.reqs.add(req);
    }
};
// js/phoenix/presence.js
var $b48ed95b74083d0b$export$99c2b779aa4e8b8b = class _Presence {
    /**
   * Initializes the Presence
   * @param {Channel} channel - The Channel
   * @param {PresenceOptions} [opts] - The options, for example `{events: {state: "state", diff: "diff"}}`
   */ constructor(channel, opts = {}){
        let events = opts.events || /** @type {PresenceEvents} */ {
            state: "presence_state",
            diff: "presence_diff"
        };
        this.state = {};
        this.pendingDiffs = [];
        this.channel = channel;
        this.joinRef = null;
        this.caller = {
            onJoin: function() {},
            onLeave: function() {},
            onSync: function() {}
        };
        this.channel.on(events.state, (newState)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel.joinRef();
            this.state = _Presence.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel.on(events.diff, (diff)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
    }
    /**
   * @param {PresenceOnJoin} callback
   */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /**
   * @param {PresenceOnLeave} callback
   */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /**
   * @param {PresenceOnSync} callback
   */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {((key: string, obj: PresenceState) => T)} [by]
   *
   * @returns {T[]}
   */ list(by) {
        return _Presence.list(this.state, by);
    }
    inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel.joinRef();
    }
    // lower-level public static API
    /**
   * Used to sync the list of presences on the server
   * with the client's state. An optional `onJoin` and `onLeave` callback can
   * be provided to react to changes in the client's local presences across
   * disconnects and reconnects with the server.
   *
   * @param {Record<string, PresenceState>} currentState
   * @param {Record<string, PresenceState>} newState
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncState(currentState, newState, onJoin, onLeave) {
        let state = this.clone(currentState);
        let joins = {};
        let leaves = {};
        this.map(state, (key, presence)=>{
            if (!newState[key]) leaves[key] = presence;
        });
        this.map(newState, (key, newPresence)=>{
            let currentPresence = state[key];
            if (currentPresence) {
                let newRefs = newPresence.metas.map((m)=>m.phx_ref);
                let curRefs = currentPresence.metas.map((m)=>m.phx_ref);
                let joinedMetas = newPresence.metas.filter((m)=>curRefs.indexOf(m.phx_ref) < 0);
                let leftMetas = currentPresence.metas.filter((m)=>newRefs.indexOf(m.phx_ref) < 0);
                if (joinedMetas.length > 0) {
                    joins[key] = newPresence;
                    joins[key].metas = joinedMetas;
                }
                if (leftMetas.length > 0) {
                    leaves[key] = this.clone(currentPresence);
                    leaves[key].metas = leftMetas;
                }
            } else joins[key] = newPresence;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
   *
   * Used to sync a diff of presence join and leave
   * events from the server, as they happen. Like `syncState`, `syncDiff`
   * accepts optional `onJoin` and `onLeave` callbacks to react to a user
   * joining or leaving from a device.
   *
   * @param {Record<string, PresenceState>} state
   * @param {PresenceDiff} diff
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncDiff(state, diff, onJoin, onLeave) {
        let { joins: joins, leaves: leaves } = this.clone(diff);
        if (!onJoin) onJoin = function() {};
        if (!onLeave) onLeave = function() {};
        this.map(joins, (key, newPresence)=>{
            let currentPresence = state[key];
            state[key] = this.clone(newPresence);
            if (currentPresence) {
                let joinedRefs = state[key].metas.map((m)=>m.phx_ref);
                let curMetas = currentPresence.metas.filter((m)=>joinedRefs.indexOf(m.phx_ref) < 0);
                state[key].metas.unshift(...curMetas);
            }
            onJoin(key, currentPresence, newPresence);
        });
        this.map(leaves, (key, leftPresence)=>{
            let currentPresence = state[key];
            if (!currentPresence) return;
            let refsToRemove = leftPresence.metas.map((m)=>m.phx_ref);
            currentPresence.metas = currentPresence.metas.filter((p)=>{
                return refsToRemove.indexOf(p.phx_ref) < 0;
            });
            onLeave(key, currentPresence, leftPresence);
            if (currentPresence.metas.length === 0) delete state[key];
        });
        return state;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {Record<string, PresenceState>} presences
   * @param {((key: string, obj: PresenceState) => T)} [chooser]
   *
   * @returns {T[]}
   */ static list(presences, chooser) {
        if (!chooser) chooser = function(key, pres) {
            return pres;
        };
        return this.map(presences, (key, presence)=>{
            return chooser(key, presence);
        });
    }
    // private
    /**
  * @template T
  * @param {Record<string, PresenceState>} obj
  * @param {(key: string, obj: PresenceState) => T} func
  */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
  * @template T
  * @param {T} obj
  * @returns {T}
  */ static clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
};
// js/phoenix/serializer.js
var $b48ed95b74083d0b$export$ef852775387a0be7 = {
    HEADER_LENGTH: 1,
    META_LENGTH: 4,
    KINDS: {
        push: 0,
        reply: 1,
        broadcast: 2
    },
    /**
  * @template T
  * @param {Message<Record<string, any>>} msg
  * @param {(msg: ArrayBuffer | string) => T} callback
  * @returns {T}
  */ encode (msg, callback) {
        if (msg.payload.constructor === ArrayBuffer) return callback(this.binaryEncode(msg));
        else {
            let payload = [
                msg.join_ref,
                msg.ref,
                msg.topic,
                msg.event,
                msg.payload
            ];
            return callback(JSON.stringify(payload));
        }
    },
    /**
  * @template T
  * @param {ArrayBuffer | string} rawPayload
  * @param {(msg: Message<unknown>) => T} callback
  * @returns {T}
  */ decode (rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this.binaryDecode(rawPayload));
        else {
            let [join_ref, ref, topic, event, payload] = JSON.parse(rawPayload);
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
    },
    /** @private */ binaryEncode (message) {
        let { join_ref: join_ref, ref: ref, event: event, topic: topic, payload: payload } = message;
        let metaLength = this.META_LENGTH + join_ref.length + ref.length + topic.length + event.length;
        let header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.push);
        view.setUint8(offset++, join_ref.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, event.length);
        Array.from(join_ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(event, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + payload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(payload), header.byteLength);
        return combined.buffer;
    },
    /**
  * @private
  */ binaryDecode (buffer) {
        let view = new DataView(buffer);
        let kind = view.getUint8(0);
        let decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.push:
                return this.decodePush(buffer, view, decoder);
            case this.KINDS.reply:
                return this.decodeReply(buffer, view, decoder);
            case this.KINDS.broadcast:
                return this.decodeBroadcast(buffer, view, decoder);
        }
    },
    /** @private */ decodePush (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let topicSize = view.getUint8(2);
        let eventSize = view.getUint8(3);
        let offset = this.HEADER_LENGTH + this.META_LENGTH - 1;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: joinRef,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    },
    /** @private */ decodeReply (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let refSize = view.getUint8(2);
        let topicSize = view.getUint8(3);
        let eventSize = view.getUint8(4);
        let offset = this.HEADER_LENGTH + this.META_LENGTH;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let ref = decoder.decode(buffer.slice(offset, offset + refSize));
        offset = offset + refSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        let payload = {
            status: event,
            response: data
        };
        return {
            join_ref: joinRef,
            ref: ref,
            topic: topic,
            event: $b48ed95b74083d0b$var$CHANNEL_EVENTS.reply,
            payload: payload
        };
    },
    /** @private */ decodeBroadcast (buffer, view, decoder) {
        let topicSize = view.getUint8(1);
        let eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
};
// js/phoenix/socket.js
var $b48ed95b74083d0b$export$4798917dbf149b79 = class {
    /** Initializes the Socket *
   *
   * For IE8 support use an ES5-shim (https://github.com/es-shims/es5-shim)
   *
   * @constructor
   * @param {string} endPoint - The string WebSocket endpoint, ie, `"ws://example.com/socket"`,
   *                                               `"wss://example.com"`
   *                                               `"/socket"` (inherited host & protocol)
   * @param {SocketOptions} [opts] - Optional configuration
   */ constructor(endPoint, opts = {}){
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.channels = [];
        this.sendBuffer = [];
        this.ref = 0;
        this.fallbackRef = null;
        this.timeout = opts.timeout || $b48ed95b74083d0b$var$DEFAULT_TIMEOUT;
        this.transport = opts.transport || $b48ed95b74083d0b$var$global.WebSocket || $b48ed95b74083d0b$export$57a2cdf8ead4f893;
        this.conn = void 0;
        this.primaryPassedHealthCheck = false;
        this.longPollFallbackMs = opts.longPollFallbackMs;
        this.fallbackTimer = null;
        this.sessionStore = opts.sessionStorage || $b48ed95b74083d0b$var$global && $b48ed95b74083d0b$var$global.sessionStorage;
        this.establishedConnections = 0;
        this.defaultEncoder = $b48ed95b74083d0b$export$ef852775387a0be7.encode.bind($b48ed95b74083d0b$export$ef852775387a0be7);
        this.defaultDecoder = $b48ed95b74083d0b$export$ef852775387a0be7.decode.bind($b48ed95b74083d0b$export$ef852775387a0be7);
        this.closeWasClean = true;
        this.disconnecting = false;
        this.binaryType = opts.binaryType || "arraybuffer";
        this.connectClock = 1;
        this.pageHidden = false;
        this.encode = void 0;
        this.decode = void 0;
        if (this.transport !== $b48ed95b74083d0b$export$57a2cdf8ead4f893) {
            this.encode = opts.encode || this.defaultEncoder;
            this.decode = opts.decode || this.defaultDecoder;
        } else {
            this.encode = this.defaultEncoder;
            this.decode = this.defaultDecoder;
        }
        let awaitingConnectionOnPageShow = null;
        if ($b48ed95b74083d0b$var$phxWindow && $b48ed95b74083d0b$var$phxWindow.addEventListener) {
            $b48ed95b74083d0b$var$phxWindow.addEventListener("pagehide", (_e)=>{
                if (this.conn) {
                    this.disconnect();
                    awaitingConnectionOnPageShow = this.connectClock;
                }
            });
            $b48ed95b74083d0b$var$phxWindow.addEventListener("pageshow", (_e)=>{
                if (awaitingConnectionOnPageShow === this.connectClock) {
                    awaitingConnectionOnPageShow = null;
                    this.connect();
                }
            });
            $b48ed95b74083d0b$var$phxWindow.addEventListener("visibilitychange", ()=>{
                if (document.visibilityState === "hidden") this.pageHidden = true;
                else {
                    this.pageHidden = false;
                    if (!this.isConnected() && !this.closeWasClean) this.teardown(()=>this.connect());
                }
            });
        }
        this.heartbeatIntervalMs = opts.heartbeatIntervalMs || 3e4;
        this.autoSendHeartbeat = opts.autoSendHeartbeat ?? true;
        this.heartbeatCallback = opts.heartbeatCallback ?? (()=>{});
        this.rejoinAfterMs = (tries)=>{
            if (opts.rejoinAfterMs) return opts.rejoinAfterMs(tries);
            else return [
                1e3,
                2e3,
                5e3
            ][tries - 1] || 1e4;
        };
        this.reconnectAfterMs = (tries)=>{
            if (opts.reconnectAfterMs) return opts.reconnectAfterMs(tries);
            else return [
                10,
                50,
                100,
                150,
                200,
                250,
                500,
                1e3,
                2e3
            ][tries - 1] || 5e3;
        };
        this.logger = opts.logger || null;
        if (!this.logger && opts.debug) this.logger = (kind, msg, data)=>{
            console.log(`${kind}: ${msg}`, data);
        };
        this.longpollerTimeout = opts.longpollerTimeout || 2e4;
        this.params = $b48ed95b74083d0b$var$closure(opts.params || {});
        this.endPoint = `${endPoint}/${$b48ed95b74083d0b$var$TRANSPORTS.websocket}`;
        this.vsn = opts.vsn || $b48ed95b74083d0b$var$DEFAULT_VSN;
        this.heartbeatTimeoutTimer = null;
        this.heartbeatTimer = null;
        this.heartbeatSentAt = null;
        this.pendingHeartbeatRef = null;
        this.reconnectTimer = new $b48ed95b74083d0b$export$c57e9b2d8b9e4de(()=>{
            if (this.pageHidden) {
                this.log("Not reconnecting as page is hidden!");
                this.teardown();
                return;
            }
            this.teardown(async ()=>{
                if (opts.beforeReconnect) await opts.beforeReconnect();
                this.connect();
            });
        }, this.reconnectAfterMs);
        this.authToken = opts.authToken;
    }
    /**
   * Returns the LongPoll transport reference
   */ getLongPollTransport() {
        return $b48ed95b74083d0b$export$57a2cdf8ead4f893;
    }
    /**
   * Disconnects and replaces the active transport
   *
   * @param {SocketTransport} newTransport - The new transport class to instantiate
   *
   */ replaceTransport(newTransport) {
        this.connectClock++;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        if (this.conn) {
            this.conn.close();
            this.conn = null;
        }
        this.transport = newTransport;
    }
    /**
   * Returns the socket protocol
   *
   * @returns {"wss" | "ws"}
   */ protocol() {
        return location.protocol.match(/^https/) ? "wss" : "ws";
    }
    /**
   * The fully qualified socket url
   *
   * @returns {string}
   */ endPointURL() {
        let uri = $b48ed95b74083d0b$var$Ajax.appendParams($b48ed95b74083d0b$var$Ajax.appendParams(this.endPoint, this.params()), {
            vsn: this.vsn
        });
        if (uri.charAt(0) !== "/") return uri;
        if (uri.charAt(1) === "/") return `${this.protocol()}:${uri}`;
        return `${this.protocol()}://${location.host}${uri}`;
    }
    /**
   * Disconnects the socket
   *
   * See https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes for valid status codes.
   *
   * @param {() => void} [callback] - Optional callback which is called after socket is disconnected.
   * @param {number} [code] - A status code for disconnection (Optional).
   * @param {string} [reason] - A textual description of the reason to disconnect. (Optional)
   */ disconnect(callback, code, reason) {
        this.connectClock++;
        this.disconnecting = true;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        this.teardown(()=>{
            this.disconnecting = false;
            callback && callback();
        }, code, reason);
    }
    /**
   * @param {Params} [params] - [DEPRECATED] The params to send when connecting, for example `{user_id: userToken}`
   *
   * Passing params to connect is deprecated; pass them in the Socket constructor instead:
   * `new Socket("/socket", {params: {user_id: userToken}})`.
   */ connect(params) {
        if (params) {
            console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor");
            this.params = $b48ed95b74083d0b$var$closure(params);
        }
        if (this.conn && !this.disconnecting) return;
        if (this.longPollFallbackMs && this.transport !== $b48ed95b74083d0b$export$57a2cdf8ead4f893) this.connectWithFallback($b48ed95b74083d0b$export$57a2cdf8ead4f893, this.longPollFallbackMs);
        else this.transportConnect();
    }
    /**
   * Logs the message. Override `this.logger` for specialized logging. noops by default
   * @param {string} kind
   * @param {string} msg
   * @param {Object} data
   */ log(kind, msg, data) {
        this.logger && this.logger(kind, msg, data);
    }
    /**
   * Returns true if a logger has been set on this socket.
   */ hasLogger() {
        return this.logger !== null;
    }
    /**
   * Registers callbacks for connection open events
   *
   * @example socket.onOpen(function(){ console.info("the socket was opened") })
   *
   * @param {SocketOnOpen} callback
   */ onOpen(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.open.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection close events
   * @param {SocketOnClose} callback
   * @returns {string}
   */ onClose(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.close.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection error events
   *
   * @example socket.onError(function(error){ alert("An error occurred") })
   *
   * @param {SocketOnError} callback
   * @returns {string}
   */ onError(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.error.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection message events
   * @param {SocketOnMessage} callback
   * @returns {string}
   */ onMessage(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.message.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Sets a callback that receives lifecycle events for internal heartbeat messages.
   * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
   * @param {HeartbeatCallback} callback
   */ onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
   * Pings the server and invokes the callback with the RTT in milliseconds
   * @param {(timeDelta: number) => void} callback
   *
   * Returns true if the ping was pushed or false if unable to be pushed.
   */ ping(callback) {
        if (!this.isConnected()) return false;
        let ref = this.makeRef();
        let startTime = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: ref
        });
        let onMsgRef = this.onMessage((msg)=>{
            if (msg.ref === ref) {
                this.off([
                    onMsgRef
                ]);
                callback(Date.now() - startTime);
            }
        });
        return true;
    }
    /**
   * @private
   *
   * @param {Function}
   */ transportName(transport) {
        switch(transport){
            case $b48ed95b74083d0b$export$57a2cdf8ead4f893:
                return "LongPoll";
            default:
                return transport.name;
        }
    }
    /**
   * @private
   */ transportConnect() {
        this.connectClock++;
        this.closeWasClean = false;
        let protocols = void 0;
        if (this.authToken) protocols = [
            "phoenix",
            `${$b48ed95b74083d0b$var$AUTH_TOKEN_PREFIX}${btoa(this.authToken).replace(/=/g, "")}`
        ];
        this.conn = new this.transport(this.endPointURL(), protocols);
        this.conn.binaryType = this.binaryType;
        this.conn.timeout = this.longpollerTimeout;
        this.conn.onopen = ()=>this.onConnOpen();
        this.conn.onerror = (error)=>this.onConnError(error);
        this.conn.onmessage = (event)=>this.onConnMessage(event);
        this.conn.onclose = (event)=>this.onConnClose(event);
    }
    getSession(key) {
        return this.sessionStore && this.sessionStore.getItem(key);
    }
    storeSession(key, val) {
        this.sessionStore && this.sessionStore.setItem(key, val);
    }
    connectWithFallback(fallbackTransport, fallbackThreshold = 2500) {
        clearTimeout(this.fallbackTimer);
        let established = false;
        let primaryTransport = true;
        let openRef, errorRef;
        let fallbackTransportName = this.transportName(fallbackTransport);
        let fallback = (reason)=>{
            this.log("transport", `falling back to ${fallbackTransportName}...`, reason);
            this.off([
                openRef,
                errorRef
            ]);
            primaryTransport = false;
            this.replaceTransport(fallbackTransport);
            this.transportConnect();
        };
        if (this.getSession(`phx:fallback:${fallbackTransportName}`)) return fallback("memorized");
        this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
        errorRef = this.onError((reason)=>{
            this.log("transport", "error", reason);
            if (primaryTransport && !established) {
                clearTimeout(this.fallbackTimer);
                fallback(reason);
            }
        });
        if (this.fallbackRef) this.off([
            this.fallbackRef
        ]);
        this.fallbackRef = this.onOpen(()=>{
            established = true;
            if (!primaryTransport) {
                let fallbackTransportName2 = this.transportName(fallbackTransport);
                if (!this.primaryPassedHealthCheck) this.storeSession(`phx:fallback:${fallbackTransportName2}`, "true");
                return this.log("transport", `established ${fallbackTransportName2} fallback`);
            }
            clearTimeout(this.fallbackTimer);
            this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
            this.ping((rtt)=>{
                this.log("transport", "connected to primary after", rtt);
                this.primaryPassedHealthCheck = true;
                clearTimeout(this.fallbackTimer);
            });
        });
        this.transportConnect();
    }
    clearHeartbeats() {
        clearTimeout(this.heartbeatTimer);
        clearTimeout(this.heartbeatTimeoutTimer);
    }
    onConnOpen() {
        if (this.hasLogger()) this.log("transport", `connected to ${this.endPointURL()}`);
        this.closeWasClean = false;
        this.disconnecting = false;
        this.establishedConnections++;
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (this.autoSendHeartbeat) this.resetHeartbeat();
        this.triggerStateCallbacks("open");
    }
    /**
   * @private
   */ heartbeatTimeout() {
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.heartbeatSentAt = null;
            if (this.hasLogger()) this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
            try {
                this.heartbeatCallback("timeout");
            } catch (e) {
                this.log("error", "error in heartbeat callback", e);
            }
            this.triggerChanError(new Error("heartbeat timeout"));
            this.closeWasClean = false;
            this.teardown(()=>this.reconnectTimer.scheduleTimeout(), $b48ed95b74083d0b$var$WS_CLOSE_NORMAL, "heartbeat timeout");
        }
    }
    resetHeartbeat() {
        if (this.conn && this.conn.skipHeartbeat) return;
        this.pendingHeartbeatRef = null;
        this.clearHeartbeats();
        this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    teardown(callback, code, reason) {
        if (!this.conn) return callback && callback();
        const connToClose = this.conn;
        this.waitForBufferDone(connToClose, ()=>{
            if (code) connToClose.close(code, reason || "");
            else connToClose.close();
            this.waitForSocketClosed(connToClose, ()=>{
                if (this.conn === connToClose) {
                    this.conn.onopen = function() {};
                    this.conn.onerror = function() {};
                    this.conn.onmessage = function() {};
                    this.conn.onclose = function() {};
                    this.conn = null;
                }
                callback && callback();
            });
        });
    }
    waitForBufferDone(conn, callback, tries = 1) {
        if (tries === 5 || !conn.bufferedAmount) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForBufferDone(conn, callback, tries + 1);
        }, 150 * tries);
    }
    waitForSocketClosed(conn, callback, tries = 1) {
        if (tries === 5 || conn.readyState === $b48ed95b74083d0b$var$SOCKET_STATES.closed) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForSocketClosed(conn, callback, tries + 1);
        }, 150 * tries);
    }
    /**
  * @param {CloseEvent} event
  */ onConnClose(event) {
        if (this.conn) this.conn.onclose = ()=>{};
        if (this.hasLogger()) this.log("transport", "close", event);
        this.triggerChanError(event);
        this.clearHeartbeats();
        if (!this.closeWasClean) this.reconnectTimer.scheduleTimeout();
        this.triggerStateCallbacks("close", event);
    }
    /**
   * @private
   * @param {Event} error
   */ onConnError(error) {
        if (this.hasLogger()) this.log("transport", "error", error);
        let transportBefore = this.transport;
        let establishedBefore = this.establishedConnections;
        this.triggerStateCallbacks("error", error, transportBefore, establishedBefore);
        if (transportBefore === this.transport || establishedBefore > 0) this.triggerChanError(error);
    }
    /**
   * @private
   * @param {unknown} [reason] underlying close/error event forwarded to channel error listeners
   */ triggerChanError(reason) {
        this.channels.forEach((channel)=>{
            if (!(channel.isErrored() || channel.isLeaving() || channel.isClosed())) channel.trigger($b48ed95b74083d0b$var$CHANNEL_EVENTS.error, reason);
        });
    }
    /**
   * @returns {string}
   */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case $b48ed95b74083d0b$var$SOCKET_STATES.connecting:
                return "connecting";
            case $b48ed95b74083d0b$var$SOCKET_STATES.open:
                return "open";
            case $b48ed95b74083d0b$var$SOCKET_STATES.closing:
                return "closing";
            default:
                return "closed";
        }
    }
    /**
   * @returns {boolean}
   */ isConnected() {
        return this.connectionState() === "open";
    }
    /**
   *
   * @param {Channel} channel
   */ remove(channel) {
        this.off(channel.stateChangeRefs);
        this.channels = this.channels.filter((c)=>c !== channel);
    }
    /**
   * Removes `onOpen`, `onClose`, `onError,` and `onMessage` registrations.
   *
   * @param {string[]} refs - list of refs returned by calls to
   *                 `onOpen`, `onClose`, `onError,` and `onMessage`
   */ off(refs) {
        for(let key in this.stateChangeCallbacks)this.stateChangeCallbacks[key] = this.stateChangeCallbacks[key].filter(([ref])=>{
            return refs.indexOf(ref) === -1;
        });
    }
    /**
   * Initiates a new channel for the given topic
   *
   * @param {string} topic
   * @param {Params | (() => Params)} [chanParams]- Parameters for the channel
   * @returns {Channel}
   */ channel(topic, chanParams = {}) {
        let chan = new $b48ed95b74083d0b$export$cfdacaa37f9b4dd7(topic, chanParams, this);
        this.channels.push(chan);
        return chan;
    }
    /**
   * @param {Message<Record<string, any>>} data
   */ push(data) {
        if (this.hasLogger()) {
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = data;
            this.log("push", `${topic} ${event} (${join_ref}, ${ref})`, payload);
        }
        if (this.isConnected()) this.encode(data, (result)=>this.conn.send(result));
        else this.sendBuffer.push(()=>this.encode(data, (result)=>this.conn.send(result)));
    }
    /**
   * Return the next message ref, accounting for overflows
   * @returns {string}
   */ makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    sendHeartbeat() {
        if (!this.isConnected()) {
            try {
                this.heartbeatCallback("disconnected");
            } catch (e) {
                this.log("error", "error in heartbeat callback", e);
            }
            return;
        }
        if (this.pendingHeartbeatRef) {
            this.heartbeatTimeout();
            return;
        }
        this.pendingHeartbeatRef = this.makeRef();
        this.heartbeatSentAt = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        try {
            this.heartbeatCallback("sent");
        } catch (e) {
            this.log("error", "error in heartbeat callback", e);
        }
        this.heartbeatTimeoutTimer = setTimeout(()=>this.heartbeatTimeout(), this.heartbeatIntervalMs);
    }
    flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
  * @param {MessageEvent<any>} rawMessage
  */ onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) {
                const latency = this.heartbeatSentAt ? Date.now() - this.heartbeatSentAt : void 0;
                this.clearHeartbeats();
                try {
                    this.heartbeatCallback(payload.status === "ok" ? "ok" : "error", latency);
                } catch (e) {
                    this.log("error", "error in heartbeat callback", e);
                }
                this.pendingHeartbeatRef = null;
                this.heartbeatSentAt = null;
                if (this.autoSendHeartbeat) this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
            }
            if (this.hasLogger()) this.log("receive", `${payload.status || ""} ${topic} ${event} ${ref && "(" + ref + ")" || ""}`.trim(), payload);
            for(let i = 0; i < this.channels.length; i++){
                const channel = this.channels[i];
                if (!channel.isMember(topic, event, payload, join_ref)) continue;
                channel.trigger(event, payload, ref, join_ref);
            }
            this.triggerStateCallbacks("message", msg);
        });
    }
    /**
   * @private
   * @template {keyof SocketStateChangeCallbacks} K
   * @param {K} event
   * @param {...Parameters<SocketStateChangeCallbacks[K][number][1]>} args
   * @returns {void}
   */ triggerStateCallbacks(event, ...args) {
        try {
            this.stateChangeCallbacks[event].forEach(([_, callback])=>{
                try {
                    callback(...args);
                } catch (e) {
                    this.log("error", `error in ${event} callback`, e);
                }
            });
        } catch (e) {
            this.log("error", `error triggering ${event} callbacks`, e);
        }
    }
    leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c.isJoined() || c.isJoining()));
        if (dupChannel) {
            if (this.hasLogger()) this.log("transport", `leaving duplicate topic "${topic}"`);
            dupChannel.leave();
        }
    }
};

});



parcelRegister("kqSVM", function(module, exports) {

$parcel$export(module.exports, "normalizeChannelError", function () { return $ee00d8817106f914$export$3c9468938c65e4dc; });
/**
 * Normalize the various shapes a channel error reason can take into a real `Error`.
 *
 * Transport-level channel errors arrive as a `CloseEvent`, a transport `Event`, an `Error`,
 * a string, or `undefined` depending on which path in the underlying socket fired. Server-reply
 * errors arrive as a payload object. This helper produces a consistent `Error` for every case
 * and preserves the original via `cause` so callers can still inspect the raw event.
 */ function $ee00d8817106f914$export$3c9468938c65e4dc(reason) {
    if (reason instanceof Error) return reason;
    if (typeof reason === 'string') return new Error(reason);
    if (reason && typeof reason === 'object') {
        const obj = reason;
        if (typeof obj.code === 'number') {
            const detail = typeof obj.reason === 'string' && obj.reason ? ` (${obj.reason})` : '';
            return new Error(`socket closed: ${obj.code}${detail}`, {
                cause: reason
            });
        }
        return new Error('channel error: transport failure', {
            cause: reason
        });
    }
    return new Error('channel error: connection lost');
}

});

parcelRegister("2m4hX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b70f677b4155881$export$2e2bcd8739ae039; });

var $buFEH = parcelRequire("buFEH");
class $1b70f677b4155881$export$2e2bcd8739ae039 {
    constructor(socket, topic, params){
        const phoenixParams = $1b70f677b4155881$var$phoenixChannelParams(params);
        this.channel = socket.getSocket().channel(topic, phoenixParams);
        this.socket = socket;
    }
    get state() {
        return this.channel.state;
    }
    set state(state) {
        this.channel.state = state;
    }
    get joinedOnce() {
        return this.channel.joinedOnce;
    }
    get joinPush() {
        return this.channel.joinPush;
    }
    get rejoinTimer() {
        return this.channel.rejoinTimer;
    }
    on(event, callback) {
        return this.channel.on(event, callback);
    }
    off(event, refNumber) {
        this.channel.off(event, refNumber);
    }
    subscribe(timeout) {
        return this.channel.join(timeout);
    }
    unsubscribe(timeout) {
        return this.channel.leave(timeout);
    }
    teardown() {
        this.channel.teardown();
    }
    onClose(callback) {
        this.channel.onClose(callback);
    }
    onError(callback) {
        return this.channel.onError(callback);
    }
    push(event, payload, timeout) {
        let push;
        try {
            push = this.channel.push(event, payload, timeout);
        } catch (error) {
            throw new Error(`tried to push '${event}' to '${this.channel.topic}' before joining. Use channel.subscribe() before pushing events`);
        }
        if (this.channel.pushBuffer.length > (0, $buFEH.MAX_PUSH_BUFFER_SIZE)) {
            const removedPush = this.channel.pushBuffer.shift();
            removedPush.cancelTimeout();
            this.socket.log('channel', `discarded push due to buffer overflow: ${removedPush.event}`, removedPush.payload());
        }
        return push;
    }
    updateJoinPayload(payload) {
        const oldPayload = this.channel.joinPush.payload();
        this.channel.joinPush.payload = ()=>Object.assign(Object.assign({}, oldPayload), payload);
    }
    canPush() {
        return this.socket.isConnected() && this.state === (0, $buFEH.CHANNEL_STATES).joined;
    }
    isJoined() {
        return this.state === (0, $buFEH.CHANNEL_STATES).joined;
    }
    isJoining() {
        return this.state === (0, $buFEH.CHANNEL_STATES).joining;
    }
    isClosed() {
        return this.state === (0, $buFEH.CHANNEL_STATES).closed;
    }
    isLeaving() {
        return this.state === (0, $buFEH.CHANNEL_STATES).leaving;
    }
    updateFilterBindings(filterBindings) {
        this.channel.filterBindings = filterBindings;
    }
    updatePayloadTransform(callback) {
        this.channel.onMessage = callback;
    }
    /**
     * @internal
     */ getChannel() {
        return this.channel;
    }
}
function $1b70f677b4155881$var$phoenixChannelParams(options) {
    return {
        config: Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, options.config)
    };
}

});


parcelRegister("8atwF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f262923d128fcf6$export$2e2bcd8739ae039; });

var $aVPy4 = parcelRequire("aVPy4");

var $buFEH = parcelRequire("buFEH");
class $5f262923d128fcf6$export$2e2bcd8739ae039 {
    constructor(endPoint, options){
        this.socket = new (0, $aVPy4.Socket)(endPoint, options);
    }
    get timeout() {
        return this.socket.timeout;
    }
    get endPoint() {
        return this.socket.endPoint;
    }
    get transport() {
        return this.socket.transport;
    }
    get heartbeatIntervalMs() {
        return this.socket.heartbeatIntervalMs;
    }
    get heartbeatCallback() {
        return this.socket.heartbeatCallback;
    }
    set heartbeatCallback(callback) {
        this.socket.heartbeatCallback = callback;
    }
    get heartbeatTimer() {
        return this.socket.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        return this.socket.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socket.reconnectTimer;
    }
    get vsn() {
        return this.socket.vsn;
    }
    get encode() {
        return this.socket.encode;
    }
    get decode() {
        return this.socket.decode;
    }
    get reconnectAfterMs() {
        return this.socket.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socket.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socket.stateChangeCallbacks;
    }
    connect() {
        this.socket.connect();
    }
    disconnect(callback, code, reason, timeout = 10000) {
        return new Promise((resolve)=>{
            setTimeout(()=>resolve('timeout'), timeout);
            this.socket.disconnect(()=>{
                callback();
                resolve('ok');
            }, code, reason);
        });
    }
    push(data) {
        this.socket.push(data);
    }
    log(kind, msg, data) {
        this.socket.log(kind, msg, data);
    }
    makeRef() {
        return this.socket.makeRef();
    }
    onOpen(callback) {
        this.socket.onOpen(callback);
    }
    onClose(callback) {
        this.socket.onClose(callback);
    }
    onError(callback) {
        this.socket.onError(callback);
    }
    onMessage(callback) {
        this.socket.onMessage(callback);
    }
    isConnected() {
        return this.socket.isConnected();
    }
    isConnecting() {
        return this.socket.connectionState() == (0, $buFEH.CONNECTION_STATE).connecting;
    }
    isDisconnecting() {
        return this.socket.connectionState() == (0, $buFEH.CONNECTION_STATE).closing;
    }
    connectionState() {
        // @ts-ignore - requires better typing and exposing type in phoenix
        return this.socket.connectionState();
    }
    endPointURL() {
        return this.socket.endPointURL();
    }
    sendHeartbeat() {
        this.socket.sendHeartbeat();
    }
    /**
     * @internal
     */ getSocket() {
        return this.socket;
    }
}

});



parcelRegister("98dH0", function(module, exports) {

$parcel$export(module.exports, "StorageClient", function () { return $dee9dbd1e78259f2$export$6c85f5032e75eff9; });

var $1XUCD = parcelRequire("1XUCD");

var $bzpjl = parcelRequire("bzpjl");
var $dee9dbd1e78259f2$require$Buffer = $bzpjl.Buffer;
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $dee9dbd1e78259f2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dee9dbd1e78259f2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $dee9dbd1e78259f2$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $dee9dbd1e78259f2$var$toPrimitive(t, r) {
    if ("object" != $dee9dbd1e78259f2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dee9dbd1e78259f2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $dee9dbd1e78259f2$var$toPropertyKey(t) {
    var i = $dee9dbd1e78259f2$var$toPrimitive(t, "string");
    return "symbol" == $dee9dbd1e78259f2$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $dee9dbd1e78259f2$var$_defineProperty(e, r, t) {
    return (r = $dee9dbd1e78259f2$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $dee9dbd1e78259f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dee9dbd1e78259f2$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dee9dbd1e78259f2$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $dee9dbd1e78259f2$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dee9dbd1e78259f2$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/common/errors.ts
/**
* Base error class for all Storage errors
* Supports both 'storage' and 'vectors' namespaces
*/ var $dee9dbd1e78259f2$export$697502632950e9d3 = class extends Error {
    constructor(message, namespace = "storage", status, statusCode){
        super(message);
        this.__isStorageError = true;
        this.namespace = namespace;
        this.name = namespace === "vectors" ? "StorageVectorsError" : "StorageError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            statusCode: this.statusCode
        };
    }
};
/**
* Type guard to check if an error is a StorageError
* @param error - The error to check
* @returns True if the error is a StorageError
*/ function $dee9dbd1e78259f2$export$5a322e77e5eb0561(error) {
    return typeof error === "object" && error !== null && "__isStorageError" in error;
}
/**
* API error returned from Storage service
* Includes HTTP status code and service-specific error code
*/ var $dee9dbd1e78259f2$export$ca9ecfd959b3871c = class extends $dee9dbd1e78259f2$export$697502632950e9d3 {
    constructor(message, status, statusCode, namespace = "storage"){
        super(message, namespace, status, statusCode);
        this.name = namespace === "vectors" ? "StorageVectorsApiError" : "StorageApiError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return $dee9dbd1e78259f2$var$_objectSpread2({}, super.toJSON());
    }
};
/**
* Unknown error that doesn't match expected error patterns
* Wraps the original error for debugging
*/ var $dee9dbd1e78259f2$export$29127ca2e1a271d = class extends $dee9dbd1e78259f2$export$697502632950e9d3 {
    constructor(message, originalError, namespace = "storage"){
        super(message, namespace);
        this.name = namespace === "vectors" ? "StorageVectorsUnknownError" : "StorageUnknownError";
        this.originalError = originalError;
    }
};
/**
* @deprecated Use StorageError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $dee9dbd1e78259f2$export$92ae90d5da46e8c0 = class extends $dee9dbd1e78259f2$export$697502632950e9d3 {
    constructor(message){
        super(message, "vectors");
    }
};
/**
* Type guard to check if an error is a StorageVectorsError
* @param error - The error to check
* @returns True if the error is a StorageVectorsError
*/ function $dee9dbd1e78259f2$export$95bc534aa9e6b2f1(error) {
    return $dee9dbd1e78259f2$export$5a322e77e5eb0561(error) && error["namespace"] === "vectors";
}
/**
* @deprecated Use StorageApiError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $dee9dbd1e78259f2$export$22e4871ee01e8e3f = class extends $dee9dbd1e78259f2$export$ca9ecfd959b3871c {
    constructor(message, status, statusCode){
        super(message, status, statusCode, "vectors");
    }
};
/**
* @deprecated Use StorageUnknownError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $dee9dbd1e78259f2$export$26d7e1f64f113285 = class extends $dee9dbd1e78259f2$export$29127ca2e1a271d {
    constructor(message, originalError){
        super(message, originalError, "vectors");
    }
};
/**
* Error codes specific to S3 Vectors API
* Maps AWS service errors to application-friendly error codes
*/ let $dee9dbd1e78259f2$export$2f60cecd2e35a5da = /* @__PURE__ */ function(StorageVectorsErrorCode$1) {
    /** Internal server fault (HTTP 500) */ StorageVectorsErrorCode$1["InternalError"] = "InternalError";
    /** Resource already exists / conflict (HTTP 409) */ StorageVectorsErrorCode$1["S3VectorConflictException"] = "S3VectorConflictException";
    /** Resource not found (HTTP 404) */ StorageVectorsErrorCode$1["S3VectorNotFoundException"] = "S3VectorNotFoundException";
    /** Delete bucket while not empty (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorBucketNotEmpty"] = "S3VectorBucketNotEmpty";
    /** Exceeds bucket quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxBucketsExceeded"] = "S3VectorMaxBucketsExceeded";
    /** Exceeds index quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxIndexesExceeded"] = "S3VectorMaxIndexesExceeded";
    return StorageVectorsErrorCode$1;
}({});
//#endregion
//#region src/lib/common/headers.ts
/**
* Sets a header with case-insensitive deduplication.
* Removes any existing headers whose name matches (case-insensitive),
* then sets the value under the lowercase key. Does not mutate the input object.
*
* @param headers - Existing headers object
* @param name - Header name to set (stored as lowercase)
* @param value - Header value
* @returns New headers object with the header set
*/ function $dee9dbd1e78259f2$var$setHeader(headers, name, value) {
    const result = $dee9dbd1e78259f2$var$_objectSpread2({}, headers);
    const nameLower = name.toLowerCase();
    for (const key of Object.keys(result))if (key.toLowerCase() === nameLower) delete result[key];
    result[nameLower] = value;
    return result;
}
/**
* Normalizes all header keys to lowercase with case-insensitive deduplication.
* When duplicate keys exist (differing only in case), the last value wins.
* Does not mutate the input object.
*
* @param headers - Headers object to normalize
* @returns New headers object with all keys lowercased
*/ function $dee9dbd1e78259f2$var$normalizeHeaders(headers) {
    const result = {};
    for (const [key, value] of Object.entries(headers))result[key.toLowerCase()] = value;
    return result;
}
//#endregion
//#region src/lib/common/helpers.ts
/**
* Resolves the fetch implementation to use
* Uses custom fetch if provided, otherwise uses native fetch
*
* @param customFetch - Optional custom fetch implementation
* @returns Resolved fetch function
*/ const $dee9dbd1e78259f2$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
/**
* Determine if input is a plain object
* An object is plain if it's created by either {}, new Object(), or Object.create(null)
*
* @param value - Value to check
* @returns True if value is a plain object
* @source https://github.com/sindresorhus/is-plain-obj
*/ const $dee9dbd1e78259f2$var$isPlainObject = (value)=>{
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};
/**
* Recursively converts object keys from snake_case to camelCase
* Used for normalizing API responses
*
* @param item - Object to convert
* @returns Converted object with camelCase keys
*/ const $dee9dbd1e78259f2$var$recursiveToCamel = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$dee9dbd1e78259f2$var$recursiveToCamel(el));
    else if (typeof item === "function" || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ""));
        result[newKey] = $dee9dbd1e78259f2$var$recursiveToCamel(value);
    });
    return result;
};
/**
* Validates if a given bucket name is valid according to Supabase Storage API rules
* Mirrors backend validation from: storage/src/storage/limits.ts:isValidBucketName()
*
* Rules:
* - Length: 1-100 characters
* - Allowed characters: alphanumeric (a-z, A-Z, 0-9), underscore (_), and safe special characters
* - Safe special characters: ! - . * ' ( ) space & $ @ = ; : + , ?
* - Forbidden: path separators (/, \), path traversal (..), leading/trailing whitespace
*
* AWS S3 Reference: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
*
* @param bucketName - The bucket name to validate
* @returns true if valid, false otherwise
*/ const $dee9dbd1e78259f2$var$isValidBucketName = (bucketName)=>{
    if (!bucketName || typeof bucketName !== "string") return false;
    if (bucketName.length === 0 || bucketName.length > 100) return false;
    if (bucketName.trim() !== bucketName) return false;
    if (bucketName.includes("/") || bucketName.includes("\\")) return false;
    return /^[\w!.\*'() &$@=;:+,?-]+$/.test(bucketName);
};
//#endregion
//#region src/lib/common/fetch.ts
/**
* Extracts error message from various error response formats
* @param err - Error object from API
* @returns Human-readable error message
*/ const $dee9dbd1e78259f2$var$_getErrorMessage = (err)=>{
    var _err$error;
    return err.msg || err.message || err.error_description || (typeof err.error === "string" ? err.error : (_err$error = err.error) === null || _err$error === void 0 ? void 0 : _err$error.message) || JSON.stringify(err);
};
/**
* Handles fetch errors and converts them to Storage error types
* @param error - The error caught from fetch
* @param reject - Promise rejection function
* @param options - Fetch options that may affect error handling
* @param namespace - Error namespace ('storage' or 'vectors')
*/ const $dee9dbd1e78259f2$var$handleError = async (error, reject, options, namespace)=>{
    if (error !== null && typeof error === "object" && typeof error.json === "function") {
        const responseError = error;
        let status = parseInt(responseError.status, 10);
        if (!Number.isFinite(status)) status = 500;
        responseError.json().then((err)=>{
            const statusCode = (err === null || err === void 0 ? void 0 : err.statusCode) || (err === null || err === void 0 ? void 0 : err.code) || status + "";
            reject(new $dee9dbd1e78259f2$export$ca9ecfd959b3871c($dee9dbd1e78259f2$var$_getErrorMessage(err), status, statusCode, namespace));
        }).catch(()=>{
            const statusCode = status + "";
            reject(new $dee9dbd1e78259f2$export$ca9ecfd959b3871c(responseError.statusText || `HTTP ${status} error`, status, statusCode, namespace));
        });
    } else reject(new $dee9dbd1e78259f2$export$29127ca2e1a271d($dee9dbd1e78259f2$var$_getErrorMessage(error), error, namespace));
};
/**
* Builds request parameters for fetch calls
* @param method - HTTP method
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters like AbortSignal
* @param body - Request body (will be JSON stringified if plain object)
* @returns Complete fetch request parameters
*/ const $dee9dbd1e78259f2$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET" || method === "HEAD" || !body) return $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, params), parameters);
    if ($dee9dbd1e78259f2$var$isPlainObject(body)) {
        var _contentType;
        const headers = (options === null || options === void 0 ? void 0 : options.headers) || {};
        let contentType;
        for (const [key, value] of Object.entries(headers))if (key.toLowerCase() === "content-type") contentType = value;
        params.headers = $dee9dbd1e78259f2$var$setHeader(headers, "Content-Type", (_contentType = contentType) !== null && _contentType !== void 0 ? _contentType : "application/json");
        params.body = JSON.stringify(body);
    } else params.body = body;
    if (options === null || options === void 0 ? void 0 : options.duplex) params.duplex = options.duplex;
    return $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, params), parameters);
};
/**
* Internal request handler that wraps fetch with error handling
* @param fetcher - Fetch function to use
* @param method - HTTP method
* @param url - Request URL
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters
* @param body - Request body
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Promise with parsed response or error
*/ async function $dee9dbd1e78259f2$var$_handleRequest(fetcher, method, url, options, parameters, body, namespace) {
    return new Promise((resolve, reject)=>{
        fetcher(url, $dee9dbd1e78259f2$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
            if (!result.ok) throw result;
            if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
            if (namespace === "vectors") {
                const contentType = result.headers.get("content-type");
                if (result.headers.get("content-length") === "0" || result.status === 204) return {};
                if (!contentType || !contentType.includes("application/json")) return {};
            }
            return result.json();
        }).then((data)=>resolve(data)).catch((error)=>$dee9dbd1e78259f2$var$handleError(error, reject, options, namespace));
    });
}
/**
* Creates a fetch API with the specified namespace
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Object with HTTP method functions
*/ function $dee9dbd1e78259f2$var$createFetchApi(namespace = "storage") {
    return {
        get: async (fetcher, url, options, parameters)=>{
            return $dee9dbd1e78259f2$var$_handleRequest(fetcher, "GET", url, options, parameters, void 0, namespace);
        },
        post: async (fetcher, url, body, options, parameters)=>{
            return $dee9dbd1e78259f2$var$_handleRequest(fetcher, "POST", url, options, parameters, body, namespace);
        },
        put: async (fetcher, url, body, options, parameters)=>{
            return $dee9dbd1e78259f2$var$_handleRequest(fetcher, "PUT", url, options, parameters, body, namespace);
        },
        head: async (fetcher, url, options, parameters)=>{
            return $dee9dbd1e78259f2$var$_handleRequest(fetcher, "HEAD", url, $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, options), {}, {
                noResolveJson: true
            }), parameters, void 0, namespace);
        },
        remove: async (fetcher, url, body, options, parameters)=>{
            return $dee9dbd1e78259f2$var$_handleRequest(fetcher, "DELETE", url, options, parameters, body, namespace);
        }
    };
}
const $dee9dbd1e78259f2$var$defaultApi = $dee9dbd1e78259f2$var$createFetchApi("storage");
const { get: $dee9dbd1e78259f2$var$get, post: $dee9dbd1e78259f2$var$post, put: $dee9dbd1e78259f2$var$put, head: $dee9dbd1e78259f2$var$head, remove: $dee9dbd1e78259f2$var$remove } = $dee9dbd1e78259f2$var$defaultApi;
const $dee9dbd1e78259f2$var$vectorsApi = $dee9dbd1e78259f2$var$createFetchApi("vectors");
//#endregion
//#region src/lib/common/BaseApiClient.ts
/**
* @ignore
* Base API client class for all Storage API classes
* Provides common infrastructure for error handling and configuration
*
* @typeParam TError - The error type (StorageError or subclass)
*/ var $dee9dbd1e78259f2$var$BaseApiClient = class {
    /**
	* Creates a new BaseApiClient instance
	* @param url - Base URL for API requests
	* @param headers - Default headers for API requests
	* @param fetch - Optional custom fetch implementation
	* @param namespace - Error namespace ('storage' or 'vectors')
	*/ constructor(url, headers = {}, fetch$1, namespace = "storage"){
        this.shouldThrowOnError = false;
        this.url = url;
        this.headers = $dee9dbd1e78259f2$var$normalizeHeaders(headers);
        this.fetch = $dee9dbd1e78259f2$var$resolveFetch(fetch$1);
        this.namespace = namespace;
    }
    /**
	* Enable throwing errors instead of returning them.
	* When enabled, errors are thrown instead of returned in { data, error } format.
	*
	* @returns this - For method chaining
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	* Creates a shallow copy of headers to avoid mutating shared state.
	*
	* @param name - Header name
	* @param value - Header value
	* @returns this - For method chaining
	*/ setHeader(name, value) {
        this.headers = $dee9dbd1e78259f2$var$setHeader(this.headers, name, value);
        return this;
    }
    /**
	* Handles API operation with standardized error handling
	* Eliminates repetitive try-catch blocks across all API methods
	*
	* This wrapper:
	* 1. Executes the operation
	* 2. Returns { data, error: null } on success
	* 3. Returns { data: null, error } on failure (if shouldThrowOnError is false)
	* 4. Throws error on failure (if shouldThrowOnError is true)
	*
	* @typeParam T - The expected data type from the operation
	* @param operation - Async function that performs the API call
	* @returns Promise with { data, error } tuple
	*
	* @example Handling an operation
	* ```typescript
	* async listBuckets() {
	*   return this.handleOperation(async () => {
	*     return await get(this.fetch, `${this.url}/bucket`, {
	*       headers: this.headers,
	*     })
	*   })
	* }
	* ```
	*/ async handleOperation(operation) {
        var _this = this;
        try {
            return {
                data: await operation(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($dee9dbd1e78259f2$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StreamDownloadBuilder.ts
var $dee9dbd1e78259f2$var$StreamDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
    }
    then(onfulfilled, onrejected) {
        return this.execute().then(onfulfilled, onrejected);
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: (await _this.downloadFn()).body,
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($dee9dbd1e78259f2$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/BlobDownloadBuilder.ts
let $dee9dbd1e78259f2$var$_Symbol$toStringTag;
$dee9dbd1e78259f2$var$_Symbol$toStringTag = Symbol.toStringTag;
var $dee9dbd1e78259f2$var$BlobDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
        this[$dee9dbd1e78259f2$var$_Symbol$toStringTag] = "BlobDownloadBuilder";
        this.promise = null;
    }
    asStream() {
        return new $dee9dbd1e78259f2$var$StreamDownloadBuilder(this.downloadFn, this.shouldThrowOnError);
    }
    then(onfulfilled, onrejected) {
        return this.getPromise().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.getPromise().catch(onrejected);
    }
    finally(onfinally) {
        return this.getPromise().finally(onfinally);
    }
    getPromise() {
        if (!this.promise) this.promise = this.execute();
        return this.promise;
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: await (await _this.downloadFn()).blob(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($dee9dbd1e78259f2$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StorageFileApi.ts
const $dee9dbd1e78259f2$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: "name",
        order: "asc"
    }
};
const $dee9dbd1e78259f2$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: "3600",
    contentType: "text/plain;charset=UTF-8",
    upsert: false
};
var $dee9dbd1e78259f2$var$StorageFileApi = class extends $dee9dbd1e78259f2$var$BaseApiClient {
    constructor(url, headers = {}, bucketId, fetch$1){
        super(url, headers, fetch$1, "storage");
        this.bucketId = bucketId;
    }
    /**
	* Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
	*
	* @param method HTTP method.
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	*/ async uploadOrUpdate(method, path, fileBody, fileOptions) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            let body;
            const options = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, $dee9dbd1e78259f2$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, _this.headers), method === "POST" && {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                if (metadata) body.append("metadata", _this.encodeMetadata(metadata));
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
                if (metadata && !body.has("metadata")) body.append("metadata", _this.encodeMetadata(metadata));
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (metadata) headers["x-metadata"] = _this.toBase64(_this.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) for (const [key, value] of Object.entries(fileOptions.headers))headers = $dee9dbd1e78259f2$var$setHeader(headers, key, value);
            const cleanPath = _this._removeEmptyFolders(path);
            const _path = _this._getFinalPath(cleanPath);
            const data = await (method == "PUT" ? $dee9dbd1e78259f2$var$put : $dee9dbd1e78259f2$var$post)(_this.fetch, `${_this.url}/object/${_path}`, body, $dee9dbd1e78259f2$var$_objectSpread2({
                headers: headers
            }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                duplex: options.duplex
            } : {}));
            return {
                path: cleanPath,
                id: data.Id,
                fullPath: data.Key
            };
        });
    }
    /**
	* Uploads a file to an existing bucket.
	*
	* @category File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, upsert, and metadata.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Upload file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600',
	*     upsert: false
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Upload file using `ArrayBuffer` from base64 file data
	* ```js
	* import { decode } from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: only `insert` when you are uploading new files and `select`, `insert` and `update` when you are upserting files
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	* - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Upload file using `ArrayBuffer` from base64 file data instead, see example below.
	*/ async upload(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("POST", path, fileBody, fileOptions);
    }
    /**
	* Upload a file with a token generated from `createSignedUploadUrl`.
	*
	* @category File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param token The token generated from `createSignedUploadUrl`
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions HTTP headers (cacheControl, contentType, etc.).
	* **Note:** The `upsert` option has no effect here. To enable upsert behavior,
	* pass `{ upsert: true }` when calling `createSignedUploadUrl()` instead.
	* @returns Promise with response containing file path and fullPath or error
	*
	* @example Upload to a signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .uploadToSignedUrl('folder/cat.jpg', 'token-from-createSignedUploadUrl', file)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "folder/cat.jpg",
	*     "fullPath": "avatars/folder/cat.jpg"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async uploadToSignedUrl(path, token, fileBody, fileOptions) {
        var _this3 = this;
        const cleanPath = _this3._removeEmptyFolders(path);
        const _path = _this3._getFinalPath(cleanPath);
        const url = new URL(_this3.url + `/object/upload/sign/${_path}`);
        url.searchParams.set("token", token);
        return _this3.handleOperation(async ()=>{
            let body;
            const options = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, $dee9dbd1e78259f2$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, _this3.headers), {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                if (metadata) body.append("metadata", _this3.encodeMetadata(metadata));
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
                if (metadata && !body.has("metadata")) body.append("metadata", _this3.encodeMetadata(metadata));
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (metadata) headers["x-metadata"] = _this3.toBase64(_this3.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) for (const [key, value] of Object.entries(fileOptions.headers))headers = $dee9dbd1e78259f2$var$setHeader(headers, key, value);
            return {
                path: cleanPath,
                fullPath: (await $dee9dbd1e78259f2$var$put(_this3.fetch, url.toString(), body, $dee9dbd1e78259f2$var$_objectSpread2({
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}))).Key
            };
        });
    }
    /**
	* Creates a signed upload URL.
	* Signed upload URLs can be used to upload files to the bucket without further authentication.
	* They are valid for 2 hours.
	*
	* @category File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param options.upsert If set to true, allows the file to be overwritten if it already exists.
	* @returns Promise with response containing signed upload URL, token, and path or error
	*
	* @example Create Signed Upload URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUploadUrl('folder/cat.jpg')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/upload/sign/avatars/folder/cat.jpg?token=<TOKEN>",
	*     "path": "folder/cat.jpg",
	*     "token": "<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `insert`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUploadUrl(path, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            let _path = _this4._getFinalPath(path);
            const headers = $dee9dbd1e78259f2$var$_objectSpread2({}, _this4.headers);
            if (options === null || options === void 0 ? void 0 : options.upsert) headers["x-upsert"] = "true";
            const data = await $dee9dbd1e78259f2$var$post(_this4.fetch, `${_this4.url}/object/upload/sign/${_path}`, {}, {
                headers: headers
            });
            const url = new URL(_this4.url + data.url);
            const token = url.searchParams.get("token");
            if (!token) throw new $dee9dbd1e78259f2$export$697502632950e9d3("No token returned by API");
            return {
                signedUrl: url.toString(),
                path: path,
                token: token
            };
        });
    }
    /**
	* Replaces an existing file at the specified path with a new one.
	*
	* @category File Buckets
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, and metadata.
	* **Note:** The `upsert` option has no effect here. `update()` always replaces the
	* file at the given path, so the `x-upsert` header is not sent. To control upsert
	* behavior, use `upload()` instead.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Update file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600'
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Update file using `ArrayBuffer` from base64 file data
	* ```js
	* import {decode} from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `update` and `select`
	* - `update()` always replaces the file at the given path regardless of the `upsert` option.
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	* - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Update file using `ArrayBuffer` from base64 file data instead, see example below.
	*/ async update(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("PUT", path, fileBody, fileOptions);
    }
    /**
	* Moves an existing file to a new path in the same bucket.
	*
	* @category File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
	* @param options The destination options.
	* @returns Promise with response containing success message or error
	*
	* @example Move file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .move('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully moved"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `update` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async move(fromPath, toPath, options) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$post(_this6.fetch, `${_this6.url}/object/move`, {
                bucketId: _this6.bucketId,
                sourceKey: fromPath,
                destinationKey: toPath,
                destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
            }, {
                headers: _this6.headers
            });
        });
    }
    /**
	* Copies an existing file to a new path in the same bucket.
	*
	* @category File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
	* @param options The destination options.
	* @returns Promise with response containing copied file path or error
	*
	* @example Copy file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .copy('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "avatars/private/avatar2.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `insert` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async copy(fromPath, toPath, options) {
        var _this7 = this;
        return _this7.handleOperation(async ()=>{
            return {
                path: (await $dee9dbd1e78259f2$var$post(_this7.fetch, `${_this7.url}/object/copy`, {
                    bucketId: _this7.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: _this7.headers
                })).Key
            };
        });
    }
    /**
	* Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @returns Promise with response containing signed URL or error
	*
	* @example Create Signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Create a signed URL for an asset with transformations
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Create a signed URL which triggers the download of the asset
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     download: true,
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUrl(path, expiresIn, options) {
        var _this8 = this;
        return _this8.handleOperation(async ()=>{
            let _path = _this8._getFinalPath(path);
            const hasTransform = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0;
            let data = await $dee9dbd1e78259f2$var$post(_this8.fetch, `${_this8.url}/object/sign/${_path}`, $dee9dbd1e78259f2$var$_objectSpread2({
                expiresIn: expiresIn
            }, hasTransform ? {
                transform: options.transform
            } : {}), {
                headers: _this8.headers
            });
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
            if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
            const queryString = query.toString();
            return {
                signedUrl: encodeURI(`${_this8.url}${data.signedURL}${queryString ? `&${queryString}` : ""}`)
            };
        });
    }
    /**
	* Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category File Buckets
	* @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
	* @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @returns Promise with response containing array of objects with signedUrl, path, and error or error
	*
	* @example Create Signed URLs
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrls(['folder/avatar1.png', 'folder/avatar2.png'], 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "error": null,
	*       "path": "folder/avatar1.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar1.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*     },
	*     {
	*       "error": null,
	*       "path": "folder/avatar2.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar2.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar2.png?token=<TOKEN>"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUrls(paths, expiresIn, options) {
        var _this9 = this;
        return _this9.handleOperation(async ()=>{
            const data = await $dee9dbd1e78259f2$var$post(_this9.fetch, `${_this9.url}/object/sign/${_this9.bucketId}`, {
                expiresIn: expiresIn,
                paths: paths
            }, {
                headers: _this9.headers
            });
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
            if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
            const queryString = query.toString();
            return data.map((datum)=>$dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, datum), {}, {
                    signedUrl: datum.signedURL ? encodeURI(`${_this9.url}${datum.signedURL}${queryString ? `&${queryString}` : ""}`) : null
                }));
        });
    }
    /**
	* Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
	*
	* @category File Buckets
	* @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
	* @param options.transform Transform the asset before serving it to the client.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @param parameters Additional fetch parameters like signal for cancellation. Supports standard fetch options including cache control.
	* @returns BlobDownloadBuilder instance for downloading the file
	*
	* @example Download file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": <BLOB>,
	*   "error": null
	* }
	* ```
	*
	* @example Download file with transformations
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*       quality: 80
	*     }
	*   })
	* ```
	*
	* @example Download with cache control (useful in Edge Functions)
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { cache: 'no-store' })
	* ```
	*
	* @example Download with abort signal
	* ```js
	* const controller = new AbortController()
	* setTimeout(() => controller.abort(), 5000)
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { signal: controller.signal })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ download(path, options, parameters) {
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0 ? "render/image/authenticated" : "object";
        const query = new URLSearchParams();
        if (options === null || options === void 0 ? void 0 : options.transform) this.applyTransformOptsToQuery(query, options.transform);
        if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
        const queryString = query.toString();
        const _path = this._getFinalPath(path);
        const downloadFn = ()=>$dee9dbd1e78259f2$var$get(this.fetch, `${this.url}/${renderPath}/${_path}${queryString ? `?${queryString}` : ""}`, {
                headers: this.headers,
                noResolveJson: true
            }, parameters);
        return new $dee9dbd1e78259f2$var$BlobDownloadBuilder(downloadFn, this.shouldThrowOnError);
    }
    /**
	* Retrieves the details of an existing file.
	*
	* Returns detailed file metadata including size, content type, and timestamps.
	* Note: The API returns `last_modified` field, not `updated_at`.
	*
	* @category File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing file metadata or error
	*
	* @example Get file info
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .info('folder/avatar1.png')
	*
	* if (data) {
	*   console.log('Last modified:', data.lastModified)
	*   console.log('Size:', data.size)
	* }
	* ```
	*/ async info(path) {
        var _this10 = this;
        const _path = _this10._getFinalPath(path);
        return _this10.handleOperation(async ()=>{
            return $dee9dbd1e78259f2$var$recursiveToCamel(await $dee9dbd1e78259f2$var$get(_this10.fetch, `${_this10.url}/object/info/${_path}`, {
                headers: _this10.headers
            }));
        });
    }
    /**
	* Checks the existence of a file.
	*
	* @category File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing boolean indicating file existence or error
	*
	* @example Check file existence
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .exists('folder/avatar1.png')
	* ```
	*/ async exists(path) {
        var _this11 = this;
        const _path = _this11._getFinalPath(path);
        try {
            await $dee9dbd1e78259f2$var$head(_this11.fetch, `${_this11.url}/object/${_path}`, {
                headers: _this11.headers
            });
            return {
                data: true,
                error: null
            };
        } catch (error) {
            if (_this11.shouldThrowOnError) throw error;
            if ($dee9dbd1e78259f2$export$5a322e77e5eb0561(error)) {
                var _error$originalError;
                const status = error instanceof $dee9dbd1e78259f2$export$ca9ecfd959b3871c ? error.status : error instanceof $dee9dbd1e78259f2$export$29127ca2e1a271d ? (_error$originalError = error.originalError) === null || _error$originalError === void 0 ? void 0 : _error$originalError.status : void 0;
                if (status !== void 0 && [
                    400,
                    404
                ].includes(status)) return {
                    data: false,
                    error: error
                };
            }
            throw error;
        }
    }
    /**
	* A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
	* This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
	*
	* @category File Buckets
	* @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
	* @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @returns Object with public URL
	*
	* @example Returns the URL for an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "publicUrl": "https://example.supabase.co/storage/v1/object/public/public-bucket/folder/avatar1.png"
	*   }
	* }
	* ```
	*
	* @example Returns the URL for an asset in a public bucket with transformations
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Returns the URL which triggers the download of an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     download: true,
	*   })
	* ```
	*
	* @remarks
	* - The bucket needs to be set to public, either via [updateBucket()](/docs/reference/javascript/storage-updatebucket) or by going to Storage on [supabase.com/dashboard](https://supabase.com/dashboard), clicking the overflow menu on a bucket and choosing "Make public"
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const query = new URLSearchParams();
        if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
        if (options === null || options === void 0 ? void 0 : options.transform) this.applyTransformOptsToQuery(query, options.transform);
        if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
        const queryString = query.toString();
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0 ? "render/image" : "object";
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}`) + (queryString ? `?${queryString}` : "")
            }
        };
    }
    /**
	* Deletes files within the same bucket
	*
	* Returns an array of FileObject entries for the deleted files. Note that deprecated
	* fields like `bucket_id` may or may not be present in the response - do not rely on them.
	*
	* @category File Buckets
	* @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
	* @returns Promise with response containing array of deleted file objects or error
	*
	* @example Delete file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .remove(['folder/avatar1.png'])
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `delete` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async remove(paths) {
        var _this12 = this;
        return _this12.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$remove(_this12.fetch, `${_this12.url}/object/${_this12.bucketId}`, {
                prefixes: paths
            }, {
                headers: _this12.headers
            });
        });
    }
    /**
	* Get file metadata
	* @param id the file id to retrieve metadata
	*/ /**
	* Update file metadata
	* @param id the file id to update metadata
	* @param meta the new file metadata
	*/ /**
	* Lists all the files and folders within a path of the bucket.
	*
	* **Important:** For folder entries, fields like `id`, `updated_at`, `created_at`,
	* `last_accessed_at`, and `metadata` will be `null`. Only files have these fields populated.
	* Additionally, deprecated fields like `bucket_id`, `owner`, and `buckets` are NOT returned
	* by this method.
	*
	* @category File Buckets
	* @param path The folder path.
	* @param options Search options including limit (defaults to 100), offset, sortBy, and search
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing array of files/folders or error
	*
	* @example List files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*   })
	*
	* // Handle files vs folders
	* data?.forEach(item => {
	*   if (item.id !== null) {
	*     // It's a file
	*     console.log('File:', item.name, 'Size:', item.metadata?.size)
	*   } else {
	*     // It's a folder
	*     console.log('Folder:', item.name)
	*   }
	* })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "avatar1.png",
	*       "id": "e668cf7f-821b-4a2f-9dce-7dfa5dd1cfd2",
	*       "updated_at": "2024-05-22T23:06:05.580Z",
	*       "created_at": "2024-05-22T23:04:34.443Z",
	*       "last_accessed_at": "2024-05-22T23:04:34.443Z",
	*       "metadata": {
	*         "eTag": "\"c5e8c553235d9af30ef4f6e280790b92\"",
	*         "size": 32175,
	*         "mimetype": "image/png",
	*         "cacheControl": "max-age=3600",
	*         "lastModified": "2024-05-22T23:06:05.574Z",
	*         "contentLength": 32175,
	*         "httpStatusCode": 200
	*       }
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @example Search files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*     search: 'jon'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async list(path, options, parameters) {
        var _this13 = this;
        return _this13.handleOperation(async ()=>{
            const body = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, $dee9dbd1e78259f2$var$DEFAULT_SEARCH_OPTIONS), options), {}, {
                prefix: path || ""
            });
            return await $dee9dbd1e78259f2$var$post(_this13.fetch, `${_this13.url}/object/list/${_this13.bucketId}`, body, {
                headers: _this13.headers
            }, parameters);
        });
    }
    /**
	* Lists all the files and folders within a bucket using the V2 API with pagination support.
	*
	* **Important:** Folder entries in the `folders` array only contain `name` and optionally `key` —
	* they have no `id`, timestamps, or `metadata` fields. Full file metadata is only available
	* on entries in the `objects` array.
	*
	* @experimental this method signature might change in the future
	*
	* @category File Buckets
	* @param options Search options including prefix, cursor for pagination, limit, with_delimiter
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing folders/objects arrays with pagination info or error
	*
	* @example List files with pagination
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .listV2({
	*     prefix: 'folder/',
	*     limit: 100,
	*   })
	*
	* // Handle pagination
	* if (data?.hasNext) {
	*   const nextPage = await supabase
	*     .storage
	*     .from('avatars')
	*     .listV2({
	*       prefix: 'folder/',
	*       cursor: data.nextCursor,
	*     })
	* }
	*
	* // Handle files vs folders
	* data?.objects.forEach(file => {
	*   if (file.id !== null) {
	*     console.log('File:', file.name, 'Size:', file.metadata?.size)
	*   }
	* })
	* data?.folders.forEach(folder => {
	*   console.log('Folder:', folder.name)
	* })
	* ```
	*/ async listV2(options, parameters) {
        var _this14 = this;
        return _this14.handleOperation(async ()=>{
            const body = $dee9dbd1e78259f2$var$_objectSpread2({}, options);
            return await $dee9dbd1e78259f2$var$post(_this14.fetch, `${_this14.url}/object/list-v2/${_this14.bucketId}`, body, {
                headers: _this14.headers
            }, parameters);
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $dee9dbd1e78259f2$require$Buffer !== "undefined") return $dee9dbd1e78259f2$require$Buffer.from(data).toString("base64");
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path.replace(/^\/+/, "")}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
    }
    /** Modifies the `query`, appending values the from `transform` */ applyTransformOptsToQuery(query, transform) {
        if (transform.width) query.set("width", transform.width.toString());
        if (transform.height) query.set("height", transform.height.toString());
        if (transform.resize) query.set("resize", transform.resize);
        if (transform.format) query.set("format", transform.format);
        if (transform.quality) query.set("quality", transform.quality.toString());
        return query;
    }
};
//#endregion
//#region src/lib/version.ts
const $dee9dbd1e78259f2$var$version = "2.105.1";
//#endregion
//#region src/lib/constants.ts
const $dee9dbd1e78259f2$var$DEFAULT_HEADERS = {
    "X-Client-Info": `storage-js/${$dee9dbd1e78259f2$var$version}`
};
//#endregion
//#region src/packages/StorageBucketApi.ts
var $dee9dbd1e78259f2$var$StorageBucketApi = class extends $dee9dbd1e78259f2$var$BaseApiClient {
    constructor(url, headers = {}, fetch$1, opts){
        const baseUrl = new URL(url);
        if (opts === null || opts === void 0 ? void 0 : opts.useNewHostname) {
            if (/supabase\.(co|in|red)$/.test(baseUrl.hostname) && !baseUrl.hostname.includes("storage.supabase.")) baseUrl.hostname = baseUrl.hostname.replace("supabase.", "storage.supabase.");
        }
        const finalUrl = baseUrl.href.replace(/\/$/, "");
        const finalHeaders = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, $dee9dbd1e78259f2$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* Retrieves the details of all Storage buckets within an existing project.
	*
	* @category File Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('id', 'name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of buckets or error
	*
	* @example List buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets()
	* ```
	*
	* @example List buckets with options
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc',
	*     search: 'prod'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async listBuckets(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            const queryString = _this.listBucketOptionsToQueryString(options);
            return await $dee9dbd1e78259f2$var$get(_this.fetch, `${_this.url}/bucket${queryString}`, {
                headers: _this.headers
            });
        });
    }
    /**
	* Retrieves the details of an existing Storage bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to retrieve.
	* @returns Promise with response containing bucket details or error
	*
	* @example Get bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .getBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "id": "avatars",
	*     "name": "avatars",
	*     "owner": "",
	*     "public": false,
	*     "file_size_limit": 1024,
	*     "allowed_mime_types": [
	*       "image/png"
	*     ],
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async getBucket(id) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$get(_this2.fetch, `${_this2.url}/bucket/${id}`, {
                headers: _this2.headers
            });
        });
    }
    /**
	* Creates a new Storage bucket
	*
	* @category File Buckets
	* @param id A unique identifier for the bucket you are creating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @param options.type (private-beta) specifies the bucket type. see `BucketType` for more details.
	*   - default bucket type is `STANDARD`
	* @returns Promise with response containing newly created bucket name or error
	*
	* @example Create bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .createBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "avatars"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `insert`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createBucket(id, options = {
        public: false
    }) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$post(_this3.fetch, `${_this3.url}/bucket`, {
                id: id,
                name: id,
                type: options.type,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this3.headers
            });
        });
    }
    /**
	* Updates a Storage bucket
	*
	* @category File Buckets
	* @param id A unique identifier for the bucket you are updating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @returns Promise with response containing success message or error
	*
	* @example Update bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .updateBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully updated"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `update`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async updateBucket(id, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$put(_this4.fetch, `${_this4.url}/bucket/${id}`, {
                id: id,
                name: id,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this4.headers
            });
        });
    }
    /**
	* Removes all objects inside a single bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to empty.
	* @returns Promise with success message or error
	*
	* @example Empty bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .emptyBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully emptied"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: `select` and `delete`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async emptyBucket(id) {
        var _this5 = this;
        return _this5.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$post(_this5.fetch, `${_this5.url}/bucket/${id}/empty`, {}, {
                headers: _this5.headers
            });
        });
    }
    /**
	* Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
	* You must first `empty()` the bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to delete.
	* @returns Promise with success message or error
	*
	* @example Delete bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .deleteBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `delete`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async deleteBucket(id) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$remove(_this6.fetch, `${_this6.url}/bucket/${id}`, {}, {
                headers: _this6.headers
            });
        });
    }
    listBucketOptionsToQueryString(options) {
        const params = {};
        if (options) {
            if ("limit" in options) params.limit = String(options.limit);
            if ("offset" in options) params.offset = String(options.offset);
            if (options.search) params.search = options.search;
            if (options.sortColumn) params.sortColumn = options.sortColumn;
            if (options.sortOrder) params.sortOrder = options.sortOrder;
        }
        return Object.keys(params).length > 0 ? "?" + new URLSearchParams(params).toString() : "";
    }
};
//#endregion
//#region src/packages/StorageAnalyticsClient.ts
/**
* Client class for managing Analytics Buckets using Iceberg tables
* Provides methods for creating, listing, and deleting analytics buckets
*/ var $dee9dbd1e78259f2$export$6be1752cbca4e2bf = class extends $dee9dbd1e78259f2$var$BaseApiClient {
    /**
	* @alpha
	*
	* Creates a new StorageAnalyticsClient instance
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param url - The base URL for the storage API
	* @param headers - HTTP headers to include in requests
	* @param fetch - Optional custom fetch implementation
	*
	* @example Using supabase-js (recommended)
	* ```typescript
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.storage.analytics.listBuckets()
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```typescript
	* import { StorageAnalyticsClient } from '@supabase/storage-js'
	*
	* const client = new StorageAnalyticsClient(url, headers)
	* ```
	*/ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, $dee9dbd1e78259f2$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* @alpha
	*
	* Creates a new analytics bucket using Iceberg tables
	* Analytics buckets are optimized for analytical queries and data processing
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param name A unique name for the bucket you are creating
	* @returns Promise with response containing newly created analytics bucket or error
	*
	* @example Create analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "analytics-data",
	*     "type": "ANALYTICS",
	*     "format": "iceberg",
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Creates a new analytics bucket using Iceberg tables
	* - Analytics buckets are optimized for analytical queries and data processing
	*/ async createBucket(name) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$post(_this.fetch, `${_this.url}/bucket`, {
                name: name
            }, {
                headers: _this.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Retrieves the details of all Analytics Storage buckets within an existing project
	* Only returns buckets of type 'ANALYTICS'
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of analytics buckets or error
	*
	* @example List analytics buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc'
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "analytics-data",
	*       "type": "ANALYTICS",
	*       "format": "iceberg",
	*       "created_at": "2024-05-22T22:26:05.100Z",
	*       "updated_at": "2024-05-22T22:26:05.100Z"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Retrieves the details of all Analytics Storage buckets within an existing project
	* - Only returns buckets of type 'ANALYTICS'
	*/ async listBuckets(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            const queryParams = new URLSearchParams();
            if ((options === null || options === void 0 ? void 0 : options.limit) !== void 0) queryParams.set("limit", options.limit.toString());
            if ((options === null || options === void 0 ? void 0 : options.offset) !== void 0) queryParams.set("offset", options.offset.toString());
            if (options === null || options === void 0 ? void 0 : options.sortColumn) queryParams.set("sortColumn", options.sortColumn);
            if (options === null || options === void 0 ? void 0 : options.sortOrder) queryParams.set("sortOrder", options.sortOrder);
            if (options === null || options === void 0 ? void 0 : options.search) queryParams.set("search", options.search);
            const queryString = queryParams.toString();
            const url = queryString ? `${_this2.url}/bucket?${queryString}` : `${_this2.url}/bucket`;
            return await $dee9dbd1e78259f2$var$get(_this2.fetch, url, {
                headers: _this2.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Deletes an existing analytics bucket
	* A bucket can't be deleted with existing objects inside it
	* You must first empty the bucket before deletion
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param bucketName The unique identifier of the bucket you would like to delete
	* @returns Promise with response containing success message or error
	*
	* @example Delete analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .deleteBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Deletes an analytics bucket
	*/ async deleteBucket(bucketName) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$remove(_this3.fetch, `${_this3.url}/bucket/${bucketName}`, {}, {
                headers: _this3.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Get an Iceberg REST Catalog client configured for a specific analytics bucket
	* Use this to perform advanced table and namespace operations within the bucket
	* The returned client provides full access to the Apache Iceberg REST Catalog API
	* with the Supabase `{ data, error }` pattern for consistent error handling on all operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param bucketName - The name of the analytics bucket (warehouse) to connect to
	* @returns The wrapped Iceberg catalog client
	* @throws {StorageError} If the bucket name is invalid
	*
	* @example Get catalog and create table
	* ```js
	* // First, create an analytics bucket
	* const { data: bucket, error: bucketError } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	*
	* // Get the Iceberg catalog for that bucket
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Create a namespace
	* const { error: nsError } = await catalog.createNamespace({ namespace: ['default'] })
	*
	* // Create a table with schema
	* const { data: tableMetadata, error: tableError } = await catalog.createTable(
	*   { namespace: ['default'] },
	*   {
	*     name: 'events',
	*     schema: {
	*       type: 'struct',
	*       fields: [
	*         { id: 1, name: 'id', type: 'long', required: true },
	*         { id: 2, name: 'timestamp', type: 'timestamp', required: true },
	*         { id: 3, name: 'user_id', type: 'string', required: false }
	*       ],
	*       'schema-id': 0,
	*       'identifier-field-ids': [1]
	*     },
	*     'partition-spec': {
	*       'spec-id': 0,
	*       fields: []
	*     },
	*     'write-order': {
	*       'order-id': 0,
	*       fields: []
	*     },
	*     properties: {
	*       'write.format.default': 'parquet'
	*     }
	*   }
	* )
	* ```
	*
	* @example List tables in namespace
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all tables in the default namespace
	* const { data: tables, error: listError } = await catalog.listTables({ namespace: ['default'] })
	* if (listError) {
	*   if (listError.isNotFound()) {
	*     console.log('Namespace not found')
	*   }
	*   return
	* }
	* console.log(tables) // [{ namespace: ['default'], name: 'events' }]
	* ```
	*
	* @example Working with namespaces
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all namespaces
	* const { data: namespaces } = await catalog.listNamespaces()
	*
	* // Create namespace with properties
	* await catalog.createNamespace(
	*   { namespace: ['production'] },
	*   { properties: { owner: 'data-team', env: 'prod' } }
	* )
	* ```
	*
	* @example Cleanup operations
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Drop table with purge option (removes all data)
	* const { error: dropError } = await catalog.dropTable(
	*   { namespace: ['default'], name: 'events' },
	*   { purge: true }
	* )
	*
	* if (dropError?.isNotFound()) {
	*   console.log('Table does not exist')
	* }
	*
	* // Drop namespace (must be empty)
	* await catalog.dropNamespace({ namespace: ['default'] })
	* ```
	*
	* @remarks
	* This method provides a bridge between Supabase's bucket management and the standard
	* Apache Iceberg REST Catalog API. The bucket name maps to the Iceberg warehouse parameter.
	* All authentication and configuration is handled automatically using your Supabase credentials.
	*
	* **Error Handling**: Invalid bucket names throw immediately. All catalog
	* operations return `{ data, error }` where errors are `IcebergError` instances from iceberg-js.
	* Use helper methods like `error.isNotFound()` or check `error.status` for specific error handling.
	* Use `.throwOnError()` on the analytics client if you prefer exceptions for catalog operations.
	*
	* **Cleanup Operations**: When using `dropTable`, the `purge: true` option permanently
	* deletes all table data. Without it, the table is marked as deleted but data remains.
	*
	* **Library Dependency**: The returned catalog wraps `IcebergRestCatalog` from iceberg-js.
	* For complete API documentation and advanced usage, refer to the
	* [iceberg-js documentation](https://supabase.github.io/iceberg-js/).
	*/ from(bucketName) {
        var _this4 = this;
        if (!$dee9dbd1e78259f2$var$isValidBucketName(bucketName)) throw new $dee9dbd1e78259f2$export$697502632950e9d3("Invalid bucket name: File, folder, and bucket names must follow AWS object key naming guidelines and should avoid the use of any other characters.");
        const catalog = new (0, $1XUCD.IcebergRestCatalog)({
            baseUrl: this.url,
            catalogName: bucketName,
            auth: {
                type: "custom",
                getHeaders: async ()=>_this4.headers
            },
            fetch: this.fetch
        });
        const shouldThrowOnError = this.shouldThrowOnError;
        return new Proxy(catalog, {
            get (target, prop) {
                const value = target[prop];
                if (typeof value !== "function") return value;
                return async (...args)=>{
                    try {
                        return {
                            data: await value.apply(target, args),
                            error: null
                        };
                    } catch (error) {
                        if (shouldThrowOnError) throw error;
                        return {
                            data: null,
                            error: error
                        };
                    }
                };
            }
        });
    }
};
//#endregion
//#region src/packages/VectorIndexApi.ts
/**
* @hidden
* Base implementation for vector index operations.
* Use {@link VectorBucketScope} via `supabase.storage.vectors.from('bucket')` instead.
*/ var $dee9dbd1e78259f2$export$50097ff1e36420b1 = class extends $dee9dbd1e78259f2$var$BaseApiClient {
    /** Creates a new VectorIndexApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, $dee9dbd1e78259f2$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector index within a bucket */ async createIndex(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateIndex`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector index */ async getIndex(vectorBucketName, indexName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector indexes within a bucket with optional filtering and pagination */ async listIndexes(options) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListIndexes`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector index and all its data */ async deleteIndex(vectorBucketName, indexName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorDataApi.ts
/**
* @hidden
* Base implementation for vector data operations.
* Use {@link VectorIndexScope} via `supabase.storage.vectors.from('bucket').index('idx')` instead.
*/ var $dee9dbd1e78259f2$export$5f2a4b6b8397c039 = class extends $dee9dbd1e78259f2$var$BaseApiClient {
    /** Creates a new VectorDataApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, $dee9dbd1e78259f2$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Inserts or updates vectors in batch (1-500 per request) */ async putVectors(options) {
        var _this = this;
        if (options.vectors.length < 1 || options.vectors.length > 500) throw new Error("Vector batch size must be between 1 and 500 items");
        return _this.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this.fetch, `${_this.url}/PutVectors`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves vectors by their keys in batch */ async getVectors(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectors`, options, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vectors in an index with pagination */ async listVectors(options) {
        var _this3 = this;
        if (options.segmentCount !== void 0) {
            if (options.segmentCount < 1 || options.segmentCount > 16) throw new Error("segmentCount must be between 1 and 16");
            if (options.segmentIndex !== void 0) {
                if (options.segmentIndex < 0 || options.segmentIndex >= options.segmentCount) throw new Error(`segmentIndex must be between 0 and ${options.segmentCount - 1}`);
            }
        }
        return _this3.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectors`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Queries for similar vectors using approximate nearest neighbor search */ async queryVectors(options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this4.fetch, `${_this4.url}/QueryVectors`, options, {
                headers: _this4.headers
            });
        });
    }
    /** Deletes vectors by their keys in batch (1-500 per request) */ async deleteVectors(options) {
        var _this5 = this;
        if (options.keys.length < 1 || options.keys.length > 500) throw new Error("Keys batch size must be between 1 and 500 items");
        return _this5.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this5.fetch, `${_this5.url}/DeleteVectors`, options, {
                headers: _this5.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorBucketApi.ts
/**
* @hidden
* Base implementation for vector bucket operations.
* Use {@link StorageVectorsClient} via `supabase.storage.vectors` instead.
*/ var $dee9dbd1e78259f2$export$e8b640c07a633e69 = class extends $dee9dbd1e78259f2$var$BaseApiClient {
    /** Creates a new VectorBucketApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, $dee9dbd1e78259f2$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector bucket */ async createBucket(vectorBucketName) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector bucket */ async getBucket(vectorBucketName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector buckets with optional filtering and pagination */ async listBuckets(options = {}) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectorBuckets`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector bucket (must be empty first) */ async deleteBucket(vectorBucketName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $dee9dbd1e78259f2$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/StorageVectorsClient.ts
/**
*
* @alpha
*
* Main client for interacting with S3 Vectors API
* Provides access to bucket, index, and vector data operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*
* **Usage Patterns:**
*
* ```typescript
* const { data, error } = await supabase
*  .storage
*  .vectors
*  .createBucket('embeddings-prod')
*
* // Access index operations via buckets
* const bucket = supabase.storage.vectors.from('embeddings-prod')
* await bucket.createIndex({
*   indexName: 'documents',
*   dataType: 'float32',
*   dimension: 1536,
*   distanceMetric: 'cosine'
* })
*
* // Access vector operations via index
* const index = bucket.index('documents')
* await index.putVectors({
*   vectors: [
*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
*   ]
* })
*
* // Query similar vectors
* const { data } = await index.queryVectors({
*   queryVector: { float32: [...] },
*   topK: 5,
*   returnDistance: true
* })
* ```
*/ var $dee9dbd1e78259f2$export$f8cb34cab8a13f87 = class extends $dee9dbd1e78259f2$export$e8b640c07a633e69 {
    /**
	* @alpha
	*
	* Creates a StorageVectorsClient that can manage buckets, indexes, and vectors.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param url - Base URL of the Storage Vectors REST API.
	* @param options.headers - Optional headers (for example `Authorization`) applied to every request.
	* @param options.fetch - Optional custom `fetch` implementation for non-browser runtimes.
	*
	* @example Using supabase-js (recommended)
	* ```typescript
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```typescript
	* import { StorageVectorsClient } from '@supabase/storage-js'
	*
	* const client = new StorageVectorsClient(url, options)
	* ```
	*/ constructor(url, options = {}){
        super(url, options.headers || {}, options.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific vector bucket
	* Returns a scoped client for index and vector operations within the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Bucket-scoped client with index and vector operations
	*
	* @example Accessing a vector bucket
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ from(vectorBucketName) {
        return new $dee9dbd1e78259f2$export$5a6e64e51df41f53(this.url, this.headers, vectorBucketName, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector bucket
	* Vector buckets are containers for vector indexes and their data
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Unique name for the vector bucket
	* @returns Promise with empty response on success or error
	*
	* @example Creating a vector bucket
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .createBucket('embeddings-prod')
	* ```
	*/ async createBucket(vectorBucketName) {
        var _superprop_getCreateBucket = ()=>super.createBucket, _this = this;
        return _superprop_getCreateBucket().call(_this, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific vector bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Promise with bucket metadata or error
	*
	* @example Get bucket metadata
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .getBucket('embeddings-prod')
	*
	* console.log('Bucket created:', data?.vectorBucket.creationTime)
	* ```
	*/ async getBucket(vectorBucketName) {
        var _superprop_getGetBucket = ()=>super.getBucket, _this2 = this;
        return _superprop_getGetBucket().call(_this2, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Lists all vector buckets with optional filtering and pagination
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Optional filters (prefix, maxResults, nextToken)
	* @returns Promise with list of buckets or error
	*
	* @example List vector buckets
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .listBuckets({ prefix: 'embeddings-' })
	*
	* data?.vectorBuckets.forEach(bucket => {
	*   console.log(bucket.vectorBucketName)
	* })
	* ```
	*/ async listBuckets(options = {}) {
        var _superprop_getListBuckets = ()=>super.listBuckets, _this3 = this;
        return _superprop_getListBuckets().call(_this3, options);
    }
    /**
	*
	* @alpha
	*
	* Deletes a vector bucket (bucket must be empty)
	* All indexes must be deleted before deleting the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket to delete
	* @returns Promise with empty response on success or error
	*
	* @example Delete a vector bucket
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .deleteBucket('embeddings-old')
	* ```
	*/ async deleteBucket(vectorBucketName) {
        var _superprop_getDeleteBucket = ()=>super.deleteBucket, _this4 = this;
        return _superprop_getDeleteBucket().call(_this4, vectorBucketName);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector bucket
* Provides index management and access to vector operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $dee9dbd1e78259f2$export$5a6e64e51df41f53 = class extends $dee9dbd1e78259f2$export$50097ff1e36420b1 {
    /**
	* @alpha
	*
	* Creates a helper that automatically scopes all index operations to the provided bucket.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @example Creating a vector bucket scope
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ constructor(url, headers, vectorBucketName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Index configuration (vectorBucketName is automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Creating a vector index
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.createIndex({
	*   indexName: 'documents-openai',
	*   dataType: 'float32',
	*   dimension: 1536,
	*   distanceMetric: 'cosine',
	*   metadataConfiguration: {
	*     nonFilterableMetadataKeys: ['raw_text']
	*   }
	* })
	* ```
	*/ async createIndex(options) {
        var _superprop_getCreateIndex = ()=>super.createIndex, _this5 = this;
        return _superprop_getCreateIndex().call(_this5, $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this5.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists indexes in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Listing options (vectorBucketName is automatically set)
	* @returns Promise with response containing indexes array and pagination token or error
	*
	* @example List indexes
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.listIndexes({ prefix: 'documents-' })
	* ```
	*/ async listIndexes(options = {}) {
        var _superprop_getListIndexes = ()=>super.listIndexes, _this6 = this;
        return _superprop_getListIndexes().call(_this6, $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this6.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index to retrieve
	* @returns Promise with index metadata or error
	*
	* @example Get index metadata
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.getIndex('documents-openai')
	* console.log('Dimension:', data?.index.dimension)
	* ```
	*/ async getIndex(indexName) {
        var _superprop_getGetIndex = ()=>super.getIndex, _this7 = this;
        return _superprop_getGetIndex().call(_this7, _this7.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Deletes an index from this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index to delete
	* @returns Promise with empty response on success or error
	*
	* @example Delete an index
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.deleteIndex('old-index')
	* ```
	*/ async deleteIndex(indexName) {
        var _superprop_getDeleteIndex = ()=>super.deleteIndex, _this8 = this;
        return _superprop_getDeleteIndex().call(_this8, _this8.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific index within this bucket
	* Returns a scoped client for vector data operations
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index
	* @returns Index-scoped client with vector data operations
	*
	* @example Accessing an index
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	*
	* // Insert vectors
	* await index.putVectors({
	*   vectors: [
	*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
	*   ]
	* })
	*
	* // Query similar vectors
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [...] },
	*   topK: 5
	* })
	* ```
	*/ index(indexName) {
        return new $dee9dbd1e78259f2$export$bb92e54e27a7dace(this.url, this.headers, this.vectorBucketName, indexName, this.fetch);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector index
* Provides vector data operations (put, get, list, query, delete)
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $dee9dbd1e78259f2$export$bb92e54e27a7dace = class extends $dee9dbd1e78259f2$export$5f2a4b6b8397c039 {
    /**
	*
	* @alpha
	*
	* Creates a helper that automatically scopes all vector operations to the provided bucket/index names.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @example Creating a vector index scope
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* ```
	*/ constructor(url, headers, vectorBucketName, indexName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
        this.indexName = indexName;
    }
    /**
	*
	* @alpha
	*
	* Inserts or updates vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Vector insertion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Insert vectors into an index
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.putVectors({
	*   vectors: [
	*     {
	*       key: 'doc-1',
	*       data: { float32: [0.1, 0.2, ...] },
	*       metadata: { title: 'Introduction', page: 1 }
	*     }
	*   ]
	* })
	* ```
	*/ async putVectors(options) {
        var _superprop_getPutVectors = ()=>super.putVectors, _this9 = this;
        return _superprop_getPutVectors().call(_this9, $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this9.vectorBucketName,
            indexName: _this9.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Vector retrieval options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array or error
	*
	* @example Get vectors by keys
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.getVectors({
	*   keys: ['doc-1', 'doc-2'],
	*   returnMetadata: true
	* })
	* ```
	*/ async getVectors(options) {
        var _superprop_getGetVectors = ()=>super.getVectors, _this10 = this;
        return _superprop_getGetVectors().call(_this10, $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this10.vectorBucketName,
            indexName: _this10.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists vectors in this index with pagination
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Listing options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array and pagination token or error
	*
	* @example List vectors with pagination
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.listVectors({
	*   maxResults: 500,
	*   returnMetadata: true
	* })
	* ```
	*/ async listVectors(options = {}) {
        var _superprop_getListVectors = ()=>super.listVectors, _this11 = this;
        return _superprop_getListVectors().call(_this11, $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this11.vectorBucketName,
            indexName: _this11.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Queries for similar vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Query options (bucket and index names automatically set)
	* @returns Promise with response containing matches array of similar vectors ordered by distance or error
	*
	* @example Query similar vectors
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [0.1, 0.2, ...] },
	*   topK: 5,
	*   filter: { category: 'technical' },
	*   returnDistance: true,
	*   returnMetadata: true
	* })
	* ```
	*/ async queryVectors(options) {
        var _superprop_getQueryVectors = ()=>super.queryVectors, _this12 = this;
        return _superprop_getQueryVectors().call(_this12, $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this12.vectorBucketName,
            indexName: _this12.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Deletes vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Deletion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Delete vectors by keys
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.deleteVectors({
	*   keys: ['doc-1', 'doc-2', 'doc-3']
	* })
	* ```
	*/ async deleteVectors(options) {
        var _superprop_getDeleteVectors = ()=>super.deleteVectors, _this13 = this;
        return _superprop_getDeleteVectors().call(_this13, $dee9dbd1e78259f2$var$_objectSpread2($dee9dbd1e78259f2$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this13.vectorBucketName,
            indexName: _this13.indexName
        }));
    }
};
//#endregion
//#region src/StorageClient.ts
var $dee9dbd1e78259f2$export$6c85f5032e75eff9 = class extends $dee9dbd1e78259f2$var$StorageBucketApi {
    /**
	* Creates a client for Storage buckets, files, analytics, and vectors.
	*
	* @category File Buckets
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const avatars = supabase.storage.from('avatars')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { StorageClient } from '@supabase/storage-js'
	*
	* const storage = new StorageClient('https://xyzcompany.supabase.co/storage/v1', {
	*   apikey: 'your-publishable-key',
	* })
	* const avatars = storage.from('avatars')
	* ```
	*/ constructor(url, headers = {}, fetch$1, opts){
        super(url, headers, fetch$1, opts);
    }
    /**
	* Perform file operation in a bucket.
	*
	* @category File Buckets
	* @param id The bucket id to operate on.
	*
	* @example Accessing a bucket
	* ```typescript
	* const avatars = supabase.storage.from('avatars')
	* ```
	*/ from(id) {
        return new $dee9dbd1e78259f2$var$StorageFileApi(this.url, this.headers, id, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access vector storage operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @returns A StorageVectorsClient instance configured with the current storage settings.
	*/ get vectors() {
        return new $dee9dbd1e78259f2$export$f8cb34cab8a13f87(this.url + "/vector", {
            headers: this.headers,
            fetch: this.fetch
        });
    }
    /**
	*
	* @alpha
	*
	* Access analytics storage operations using Iceberg tables.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @returns A StorageAnalyticsClient instance configured with the current storage settings.
	*/ get analytics() {
        return new $dee9dbd1e78259f2$export$6be1752cbca4e2bf(this.url + "/iceberg", this.headers, this.fetch);
    }
};

});
parcelRegister("1XUCD", function(module, exports) {

$parcel$export(module.exports, "IcebergRestCatalog", function () { return $e0721f3632d9d190$export$1ccb0cb30480e317; });
// src/errors/IcebergError.ts
var $e0721f3632d9d190$export$5625de1fddd06f76 = class extends Error {
    constructor(message, opts){
        super(message);
        this.name = "IcebergError";
        this.status = opts.status;
        this.icebergType = opts.icebergType;
        this.icebergCode = opts.icebergCode;
        this.details = opts.details;
        this.isCommitStateUnknown = opts.icebergType === "CommitStateUnknownException" || [
            500,
            502,
            504
        ].includes(opts.status) && opts.icebergType?.includes("CommitState") === true;
    }
    /**
   * Returns true if the error is a 404 Not Found error.
   */ isNotFound() {
        return this.status === 404;
    }
    /**
   * Returns true if the error is a 409 Conflict error.
   */ isConflict() {
        return this.status === 409;
    }
    /**
   * Returns true if the error is a 419 Authentication Timeout error.
   */ isAuthenticationTimeout() {
        return this.status === 419;
    }
};
// src/utils/url.ts
function $e0721f3632d9d190$var$buildUrl(baseUrl, path, query) {
    const url = new URL(path, baseUrl);
    if (query) {
        for (const [key, value] of Object.entries(query))if (value !== void 0) url.searchParams.set(key, value);
    }
    return url.toString();
}
// src/http/createFetchClient.ts
async function $e0721f3632d9d190$var$buildAuthHeaders(auth) {
    if (!auth || auth.type === "none") return {};
    if (auth.type === "bearer") return {
        Authorization: `Bearer ${auth.token}`
    };
    if (auth.type === "header") return {
        [auth.name]: auth.value
    };
    if (auth.type === "custom") return await auth.getHeaders();
    return {};
}
function $e0721f3632d9d190$var$createFetchClient(options) {
    const fetchFn = options.fetchImpl ?? globalThis.fetch;
    return {
        async request ({ method: method, path: path, query: query, body: body, headers: headers }) {
            const url = $e0721f3632d9d190$var$buildUrl(options.baseUrl, path, query);
            const authHeaders = await $e0721f3632d9d190$var$buildAuthHeaders(options.auth);
            const res = await fetchFn(url, {
                method: method,
                headers: {
                    ...body ? {
                        "Content-Type": "application/json"
                    } : {},
                    ...authHeaders,
                    ...headers
                },
                body: body ? JSON.stringify(body) : void 0
            });
            const text = await res.text();
            const isJson = (res.headers.get("content-type") || "").includes("application/json");
            const data = isJson && text ? JSON.parse(text) : text;
            if (!res.ok) {
                const errBody = isJson ? data : void 0;
                const errorDetail = errBody?.error;
                throw new $e0721f3632d9d190$export$5625de1fddd06f76(errorDetail?.message ?? `Request failed with status ${res.status}`, {
                    status: res.status,
                    icebergType: errorDetail?.type,
                    icebergCode: errorDetail?.code,
                    details: errBody
                });
            }
            return {
                status: res.status,
                headers: res.headers,
                data: data
            };
        }
    };
}
// src/catalog/namespaces.ts
function $e0721f3632d9d190$var$namespaceToPath(namespace) {
    return namespace.join("");
}
var $e0721f3632d9d190$var$NamespaceOperations = class {
    constructor(client, prefix = ""){
        this.client = client;
        this.prefix = prefix;
    }
    async listNamespaces(parent) {
        const query = parent ? {
            parent: $e0721f3632d9d190$var$namespaceToPath(parent.namespace)
        } : void 0;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces`,
            query: query
        });
        return response.data.namespaces.map((ns)=>({
                namespace: ns
            }));
    }
    async createNamespace(id, metadata) {
        const request = {
            namespace: id.namespace,
            properties: metadata?.properties
        };
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces`,
            body: request
        });
        return response.data;
    }
    async dropNamespace(id) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath(id.namespace)}`
        });
    }
    async loadNamespaceMetadata(id) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath(id.namespace)}`
        });
        return {
            properties: response.data.properties
        };
    }
    async namespaceExists(id) {
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath(id.namespace)}`
            });
            return true;
        } catch (error) {
            if (error instanceof $e0721f3632d9d190$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createNamespaceIfNotExists(id, metadata) {
        try {
            return await this.createNamespace(id, metadata);
        } catch (error) {
            if (error instanceof $e0721f3632d9d190$export$5625de1fddd06f76 && error.status === 409) return;
            throw error;
        }
    }
};
// src/catalog/tables.ts
function $e0721f3632d9d190$var$namespaceToPath2(namespace) {
    return namespace.join("");
}
var $e0721f3632d9d190$var$TableOperations = class {
    constructor(client, prefix = "", accessDelegation){
        this.client = client;
        this.prefix = prefix;
        this.accessDelegation = accessDelegation;
    }
    async listTables(namespace) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath2(namespace.namespace)}/tables`
        });
        return response.data.identifiers;
    }
    async createTable(namespace, request) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath2(namespace.namespace)}/tables`,
            body: request,
            headers: headers
        });
        return response.data.metadata;
    }
    async updateTable(id, request) {
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            body: request
        });
        return {
            "metadata-location": response.data["metadata-location"],
            metadata: response.data.metadata
        };
    }
    async dropTable(id, options) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            query: {
                purgeRequested: String(options?.purge ?? false)
            }
        });
    }
    async loadTable(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            headers: headers
        });
        return response.data.metadata;
    }
    async tableExists(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$e0721f3632d9d190$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
                headers: headers
            });
            return true;
        } catch (error) {
            if (error instanceof $e0721f3632d9d190$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createTableIfNotExists(namespace, request) {
        try {
            return await this.createTable(namespace, request);
        } catch (error) {
            if (error instanceof $e0721f3632d9d190$export$5625de1fddd06f76 && error.status === 409) return await this.loadTable({
                namespace: namespace.namespace,
                name: request.name
            });
            throw error;
        }
    }
};
// src/catalog/IcebergRestCatalog.ts
var $e0721f3632d9d190$export$1ccb0cb30480e317 = class {
    /**
   * Creates a new Iceberg REST Catalog client.
   *
   * @param options - Configuration options for the catalog client
   */ constructor(options){
        let prefix = "v1";
        if (options.catalogName) prefix += `/${options.catalogName}`;
        const baseUrl = options.baseUrl.endsWith("/") ? options.baseUrl : `${options.baseUrl}/`;
        this.client = $e0721f3632d9d190$var$createFetchClient({
            baseUrl: baseUrl,
            auth: options.auth,
            fetchImpl: options.fetch
        });
        this.accessDelegation = options.accessDelegation?.join(",");
        this.namespaceOps = new $e0721f3632d9d190$var$NamespaceOperations(this.client, prefix);
        this.tableOps = new $e0721f3632d9d190$var$TableOperations(this.client, prefix, this.accessDelegation);
    }
    /**
   * Lists all namespaces in the catalog.
   *
   * @param parent - Optional parent namespace to list children under
   * @returns Array of namespace identifiers
   *
   * @example
   * ```typescript
   * // List all top-level namespaces
   * const namespaces = await catalog.listNamespaces();
   *
   * // List namespaces under a parent
   * const children = await catalog.listNamespaces({ namespace: ['analytics'] });
   * ```
   */ async listNamespaces(parent) {
        return this.namespaceOps.listNamespaces(parent);
    }
    /**
   * Creates a new namespace in the catalog.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespace(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * console.log(response.namespace); // ['analytics']
   * console.log(response.properties); // { owner: 'data-team', ... }
   * ```
   */ async createNamespace(id, metadata) {
        return this.namespaceOps.createNamespace(id, metadata);
    }
    /**
   * Drops a namespace from the catalog.
   *
   * The namespace must be empty (contain no tables) before it can be dropped.
   *
   * @param id - Namespace identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropNamespace({ namespace: ['analytics'] });
   * ```
   */ async dropNamespace(id) {
        await this.namespaceOps.dropNamespace(id);
    }
    /**
   * Loads metadata for a namespace.
   *
   * @param id - Namespace identifier to load
   * @returns Namespace metadata including properties
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadNamespaceMetadata({ namespace: ['analytics'] });
   * console.log(metadata.properties);
   * ```
   */ async loadNamespaceMetadata(id) {
        return this.namespaceOps.loadNamespaceMetadata(id);
    }
    /**
   * Lists all tables in a namespace.
   *
   * @param namespace - Namespace identifier to list tables from
   * @returns Array of table identifiers
   *
   * @example
   * ```typescript
   * const tables = await catalog.listTables({ namespace: ['analytics'] });
   * console.log(tables); // [{ namespace: ['analytics'], name: 'events' }, ...]
   * ```
   */ async listTables(namespace) {
        return this.tableOps.listTables(namespace);
    }
    /**
   * Creates a new table in the catalog.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTable(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     },
   *     'partition-spec': {
   *       'spec-id': 0,
   *       fields: [
   *         { source_id: 2, field_id: 1000, name: 'ts_day', transform: 'day' }
   *       ]
   *     }
   *   }
   * );
   * ```
   */ async createTable(namespace, request) {
        return this.tableOps.createTable(namespace, request);
    }
    /**
   * Updates an existing table's metadata.
   *
   * Can update the schema, partition spec, or properties of a table.
   *
   * @param id - Table identifier to update
   * @param request - Update request with fields to modify
   * @returns Response containing the metadata location and updated table metadata
   *
   * @example
   * ```typescript
   * const response = await catalog.updateTable(
   *   { namespace: ['analytics'], name: 'events' },
   *   {
   *     properties: { 'read.split.target-size': '134217728' }
   *   }
   * );
   * console.log(response['metadata-location']); // s3://...
   * console.log(response.metadata); // TableMetadata object
   * ```
   */ async updateTable(id, request) {
        return this.tableOps.updateTable(id, request);
    }
    /**
   * Drops a table from the catalog.
   *
   * @param id - Table identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropTable({ namespace: ['analytics'], name: 'events' });
   * ```
   */ async dropTable(id, options) {
        await this.tableOps.dropTable(id, options);
    }
    /**
   * Loads metadata for a table.
   *
   * @param id - Table identifier to load
   * @returns Table metadata including schema, partition spec, location, etc.
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadTable({ namespace: ['analytics'], name: 'events' });
   * console.log(metadata.schema);
   * console.log(metadata.location);
   * ```
   */ async loadTable(id) {
        return this.tableOps.loadTable(id);
    }
    /**
   * Checks if a namespace exists in the catalog.
   *
   * @param id - Namespace identifier to check
   * @returns True if the namespace exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.namespaceExists({ namespace: ['analytics'] });
   * console.log(exists); // true or false
   * ```
   */ async namespaceExists(id) {
        return this.namespaceOps.namespaceExists(id);
    }
    /**
   * Checks if a table exists in the catalog.
   *
   * @param id - Table identifier to check
   * @returns True if the table exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.tableExists({ namespace: ['analytics'], name: 'events' });
   * console.log(exists); // true or false
   * ```
   */ async tableExists(id) {
        return this.tableOps.tableExists(id);
    }
    /**
   * Creates a namespace if it does not exist.
   *
   * If the namespace already exists, returns void. If created, returns the response.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties, or void if it already exists
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespaceIfNotExists(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * if (response) {
   *   console.log('Created:', response.namespace);
   * } else {
   *   console.log('Already exists');
   * }
   * ```
   */ async createNamespaceIfNotExists(id, metadata) {
        return this.namespaceOps.createNamespaceIfNotExists(id, metadata);
    }
    /**
   * Creates a table if it does not exist.
   *
   * If the table already exists, returns its metadata instead.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created or existing table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTableIfNotExists(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     }
   *   }
   * );
   * ```
   */ async createTableIfNotExists(namespace, request) {
        return this.tableOps.createTableIfNotExists(namespace, request);
    }
};
// src/catalog/types.ts
var $e0721f3632d9d190$var$DECIMAL_REGEX = /^decimal\s*\(\s*(\d+)\s*,\s*(\d+)\s*\)$/;
var $e0721f3632d9d190$var$FIXED_REGEX = /^fixed\s*\[\s*(\d+)\s*\]$/;
function $e0721f3632d9d190$export$31eb975fa3e9c1f6(type) {
    const match = type.match($e0721f3632d9d190$var$DECIMAL_REGEX);
    if (!match) return null;
    return {
        precision: parseInt(match[1], 10),
        scale: parseInt(match[2], 10)
    };
}
function $e0721f3632d9d190$export$43d56cf6240a0c0e(type) {
    const match = type.match($e0721f3632d9d190$var$FIXED_REGEX);
    if (!match) return null;
    return {
        length: parseInt(match[1], 10)
    };
}
function $e0721f3632d9d190$export$ec8cf417183662a1(type) {
    return $e0721f3632d9d190$var$DECIMAL_REGEX.test(type);
}
function $e0721f3632d9d190$export$9fafc1fb79bd852e(type) {
    return $e0721f3632d9d190$var$FIXED_REGEX.test(type);
}
function $e0721f3632d9d190$export$84255940fed2ec86(a, b) {
    const decimalA = $e0721f3632d9d190$export$31eb975fa3e9c1f6(a);
    const decimalB = $e0721f3632d9d190$export$31eb975fa3e9c1f6(b);
    if (decimalA && decimalB) return decimalA.precision === decimalB.precision && decimalA.scale === decimalB.scale;
    const fixedA = $e0721f3632d9d190$export$43d56cf6240a0c0e(a);
    const fixedB = $e0721f3632d9d190$export$43d56cf6240a0c0e(b);
    if (fixedA && fixedB) return fixedA.length === fixedB.length;
    return a === b;
}
function $e0721f3632d9d190$export$d26e6db8c278e564(metadata) {
    return metadata.schemas.find((s)=>s["schema-id"] === metadata["current-schema-id"]);
}
 //# sourceMappingURL=index.mjs.map

});

parcelRegister("bzpjl", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $86c698db19bf89cd$export$a143d493d941bafc; }, function (v) { return $86c698db19bf89cd$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $86c698db19bf89cd$export$f99ded8fe4b79145; }, function (v) { return $86c698db19bf89cd$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $86c698db19bf89cd$export$a143d493d941bafc;
var $86c698db19bf89cd$export$e4cf37d7f6fb9e0a;
var $86c698db19bf89cd$export$f99ded8fe4b79145;
var $86c698db19bf89cd$export$599f31c3813fae4d;
'use strict';

var $76zL8 = parcelRequire("76zL8");

var $8yrCN = parcelRequire("8yrCN");
const $86c698db19bf89cd$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$86c698db19bf89cd$export$a143d493d941bafc = $86c698db19bf89cd$var$Buffer;
$86c698db19bf89cd$export$e4cf37d7f6fb9e0a = $86c698db19bf89cd$var$SlowBuffer;
$86c698db19bf89cd$export$f99ded8fe4b79145 = 50;
const $86c698db19bf89cd$var$K_MAX_LENGTH = 0x7fffffff;
$86c698db19bf89cd$export$599f31c3813fae4d = $86c698db19bf89cd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $86c698db19bf89cd$var$Buffer.TYPED_ARRAY_SUPPORT = $86c698db19bf89cd$var$typedArraySupport();
if (!$86c698db19bf89cd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $86c698db19bf89cd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($86c698db19bf89cd$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$86c698db19bf89cd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($86c698db19bf89cd$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$86c698db19bf89cd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $86c698db19bf89cd$var$createBuffer(length) {
    if (length > $86c698db19bf89cd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $86c698db19bf89cd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $86c698db19bf89cd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $86c698db19bf89cd$var$allocUnsafe(arg);
    }
    return $86c698db19bf89cd$var$from(arg, encodingOrOffset, length);
}
$86c698db19bf89cd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $86c698db19bf89cd$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $86c698db19bf89cd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $86c698db19bf89cd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($86c698db19bf89cd$var$isInstance(value, ArrayBuffer) || value && $86c698db19bf89cd$var$isInstance(value.buffer, ArrayBuffer)) return $86c698db19bf89cd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($86c698db19bf89cd$var$isInstance(value, SharedArrayBuffer) || value && $86c698db19bf89cd$var$isInstance(value.buffer, SharedArrayBuffer))) return $86c698db19bf89cd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $86c698db19bf89cd$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $86c698db19bf89cd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $86c698db19bf89cd$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $86c698db19bf89cd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $86c698db19bf89cd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($86c698db19bf89cd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($86c698db19bf89cd$var$Buffer, Uint8Array);
function $86c698db19bf89cd$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $86c698db19bf89cd$var$alloc(size, fill, encoding) {
    $86c698db19bf89cd$var$assertSize(size);
    if (size <= 0) return $86c698db19bf89cd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $86c698db19bf89cd$var$createBuffer(size).fill(fill, encoding) : $86c698db19bf89cd$var$createBuffer(size).fill(fill);
    return $86c698db19bf89cd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $86c698db19bf89cd$var$Buffer.alloc = function(size, fill, encoding) {
    return $86c698db19bf89cd$var$alloc(size, fill, encoding);
};
function $86c698db19bf89cd$var$allocUnsafe(size) {
    $86c698db19bf89cd$var$assertSize(size);
    return $86c698db19bf89cd$var$createBuffer(size < 0 ? 0 : $86c698db19bf89cd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $86c698db19bf89cd$var$Buffer.allocUnsafe = function(size) {
    return $86c698db19bf89cd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $86c698db19bf89cd$var$Buffer.allocUnsafeSlow = function(size) {
    return $86c698db19bf89cd$var$allocUnsafe(size);
};
function $86c698db19bf89cd$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$86c698db19bf89cd$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $86c698db19bf89cd$var$byteLength(string, encoding) | 0;
    let buf = $86c698db19bf89cd$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $86c698db19bf89cd$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $86c698db19bf89cd$var$checked(array.length) | 0;
    const buf = $86c698db19bf89cd$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $86c698db19bf89cd$var$fromArrayView(arrayView) {
    if ($86c698db19bf89cd$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $86c698db19bf89cd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $86c698db19bf89cd$var$fromArrayLike(arrayView);
}
function $86c698db19bf89cd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $86c698db19bf89cd$var$Buffer.prototype);
    return buf;
}
function $86c698db19bf89cd$var$fromObject(obj) {
    if ($86c698db19bf89cd$var$Buffer.isBuffer(obj)) {
        const len = $86c698db19bf89cd$var$checked(obj.length) | 0;
        const buf = $86c698db19bf89cd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $86c698db19bf89cd$var$numberIsNaN(obj.length)) return $86c698db19bf89cd$var$createBuffer(0);
        return $86c698db19bf89cd$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $86c698db19bf89cd$var$fromArrayLike(obj.data);
}
function $86c698db19bf89cd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $86c698db19bf89cd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $86c698db19bf89cd$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $86c698db19bf89cd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $86c698db19bf89cd$var$Buffer.alloc(+length);
}
$86c698db19bf89cd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $86c698db19bf89cd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$86c698db19bf89cd$var$Buffer.compare = function compare(a, b) {
    if ($86c698db19bf89cd$var$isInstance(a, Uint8Array)) a = $86c698db19bf89cd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($86c698db19bf89cd$var$isInstance(b, Uint8Array)) b = $86c698db19bf89cd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$86c698db19bf89cd$var$Buffer.isBuffer(a) || !$86c698db19bf89cd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$86c698db19bf89cd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$86c698db19bf89cd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $86c698db19bf89cd$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $86c698db19bf89cd$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($86c698db19bf89cd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$86c698db19bf89cd$var$Buffer.isBuffer(buf)) buf = $86c698db19bf89cd$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$86c698db19bf89cd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $86c698db19bf89cd$var$byteLength(string, encoding) {
    if ($86c698db19bf89cd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $86c698db19bf89cd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $86c698db19bf89cd$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $86c698db19bf89cd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $86c698db19bf89cd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$86c698db19bf89cd$var$Buffer.byteLength = $86c698db19bf89cd$var$byteLength;
function $86c698db19bf89cd$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $86c698db19bf89cd$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $86c698db19bf89cd$var$utf8Slice(this, start, end);
        case 'ascii':
            return $86c698db19bf89cd$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $86c698db19bf89cd$var$latin1Slice(this, start, end);
        case 'base64':
            return $86c698db19bf89cd$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $86c698db19bf89cd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$86c698db19bf89cd$var$Buffer.prototype._isBuffer = true;
function $86c698db19bf89cd$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$86c698db19bf89cd$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$86c698db19bf89cd$var$swap(this, i, i + 1);
    return this;
};
$86c698db19bf89cd$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $86c698db19bf89cd$var$swap(this, i, i + 3);
        $86c698db19bf89cd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$86c698db19bf89cd$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $86c698db19bf89cd$var$swap(this, i, i + 7);
        $86c698db19bf89cd$var$swap(this, i + 1, i + 6);
        $86c698db19bf89cd$var$swap(this, i + 2, i + 5);
        $86c698db19bf89cd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$86c698db19bf89cd$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $86c698db19bf89cd$var$utf8Slice(this, 0, length);
    return $86c698db19bf89cd$var$slowToString.apply(this, arguments);
};
$86c698db19bf89cd$var$Buffer.prototype.toLocaleString = $86c698db19bf89cd$var$Buffer.prototype.toString;
$86c698db19bf89cd$var$Buffer.prototype.equals = function equals(b) {
    if (!$86c698db19bf89cd$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $86c698db19bf89cd$var$Buffer.compare(this, b) === 0;
};
$86c698db19bf89cd$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $86c698db19bf89cd$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($86c698db19bf89cd$var$customInspectSymbol) $86c698db19bf89cd$var$Buffer.prototype[$86c698db19bf89cd$var$customInspectSymbol] = $86c698db19bf89cd$var$Buffer.prototype.inspect;
$86c698db19bf89cd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($86c698db19bf89cd$var$isInstance(target, Uint8Array)) target = $86c698db19bf89cd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$86c698db19bf89cd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $86c698db19bf89cd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($86c698db19bf89cd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $86c698db19bf89cd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($86c698db19bf89cd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $86c698db19bf89cd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $86c698db19bf89cd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $86c698db19bf89cd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$86c698db19bf89cd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$86c698db19bf89cd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $86c698db19bf89cd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$86c698db19bf89cd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $86c698db19bf89cd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $86c698db19bf89cd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($86c698db19bf89cd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $86c698db19bf89cd$var$utf8Write(buf, string, offset, length) {
    return $86c698db19bf89cd$var$blitBuffer($86c698db19bf89cd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $86c698db19bf89cd$var$asciiWrite(buf, string, offset, length) {
    return $86c698db19bf89cd$var$blitBuffer($86c698db19bf89cd$var$asciiToBytes(string), buf, offset, length);
}
function $86c698db19bf89cd$var$base64Write(buf, string, offset, length) {
    return $86c698db19bf89cd$var$blitBuffer($86c698db19bf89cd$var$base64ToBytes(string), buf, offset, length);
}
function $86c698db19bf89cd$var$ucs2Write(buf, string, offset, length) {
    return $86c698db19bf89cd$var$blitBuffer($86c698db19bf89cd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$86c698db19bf89cd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $86c698db19bf89cd$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $86c698db19bf89cd$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $86c698db19bf89cd$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $86c698db19bf89cd$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $86c698db19bf89cd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$86c698db19bf89cd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $86c698db19bf89cd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $76zL8.fromByteArray(buf);
    else return $76zL8.fromByteArray(buf.slice(start, end));
}
function $86c698db19bf89cd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $86c698db19bf89cd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $86c698db19bf89cd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $86c698db19bf89cd$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $86c698db19bf89cd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $86c698db19bf89cd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $86c698db19bf89cd$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $86c698db19bf89cd$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $86c698db19bf89cd$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $86c698db19bf89cd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $86c698db19bf89cd$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$86c698db19bf89cd$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $86c698db19bf89cd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $86c698db19bf89cd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$86c698db19bf89cd$var$Buffer.prototype.readUintLE = $86c698db19bf89cd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$86c698db19bf89cd$var$Buffer.prototype.readUintBE = $86c698db19bf89cd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$86c698db19bf89cd$var$Buffer.prototype.readUint8 = $86c698db19bf89cd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$86c698db19bf89cd$var$Buffer.prototype.readUint16LE = $86c698db19bf89cd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$86c698db19bf89cd$var$Buffer.prototype.readUint16BE = $86c698db19bf89cd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$86c698db19bf89cd$var$Buffer.prototype.readUint32LE = $86c698db19bf89cd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$86c698db19bf89cd$var$Buffer.prototype.readUint32BE = $86c698db19bf89cd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$86c698db19bf89cd$var$Buffer.prototype.readBigUInt64LE = $86c698db19bf89cd$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $86c698db19bf89cd$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $86c698db19bf89cd$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$86c698db19bf89cd$var$Buffer.prototype.readBigUInt64BE = $86c698db19bf89cd$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $86c698db19bf89cd$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $86c698db19bf89cd$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$86c698db19bf89cd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$86c698db19bf89cd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$86c698db19bf89cd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$86c698db19bf89cd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$86c698db19bf89cd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$86c698db19bf89cd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$86c698db19bf89cd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$86c698db19bf89cd$var$Buffer.prototype.readBigInt64LE = $86c698db19bf89cd$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $86c698db19bf89cd$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $86c698db19bf89cd$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$86c698db19bf89cd$var$Buffer.prototype.readBigInt64BE = $86c698db19bf89cd$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $86c698db19bf89cd$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $86c698db19bf89cd$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$86c698db19bf89cd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 4, this.length);
    return $8yrCN.read(this, offset, true, 23, 4);
};
$86c698db19bf89cd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 4, this.length);
    return $8yrCN.read(this, offset, false, 23, 4);
};
$86c698db19bf89cd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 8, this.length);
    return $8yrCN.read(this, offset, true, 52, 8);
};
$86c698db19bf89cd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkOffset(offset, 8, this.length);
    return $8yrCN.read(this, offset, false, 52, 8);
};
function $86c698db19bf89cd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$86c698db19bf89cd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$86c698db19bf89cd$var$Buffer.prototype.writeUintLE = $86c698db19bf89cd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $86c698db19bf89cd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$86c698db19bf89cd$var$Buffer.prototype.writeUintBE = $86c698db19bf89cd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $86c698db19bf89cd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$86c698db19bf89cd$var$Buffer.prototype.writeUint8 = $86c698db19bf89cd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$86c698db19bf89cd$var$Buffer.prototype.writeUint16LE = $86c698db19bf89cd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$86c698db19bf89cd$var$Buffer.prototype.writeUint16BE = $86c698db19bf89cd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$86c698db19bf89cd$var$Buffer.prototype.writeUint32LE = $86c698db19bf89cd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$86c698db19bf89cd$var$Buffer.prototype.writeUint32BE = $86c698db19bf89cd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $86c698db19bf89cd$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $86c698db19bf89cd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $86c698db19bf89cd$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $86c698db19bf89cd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$86c698db19bf89cd$var$Buffer.prototype.writeBigUInt64LE = $86c698db19bf89cd$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $86c698db19bf89cd$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$86c698db19bf89cd$var$Buffer.prototype.writeBigUInt64BE = $86c698db19bf89cd$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $86c698db19bf89cd$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$86c698db19bf89cd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $86c698db19bf89cd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$86c698db19bf89cd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $86c698db19bf89cd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$86c698db19bf89cd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$86c698db19bf89cd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$86c698db19bf89cd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$86c698db19bf89cd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$86c698db19bf89cd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$86c698db19bf89cd$var$Buffer.prototype.writeBigInt64LE = $86c698db19bf89cd$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $86c698db19bf89cd$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$86c698db19bf89cd$var$Buffer.prototype.writeBigInt64BE = $86c698db19bf89cd$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $86c698db19bf89cd$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $86c698db19bf89cd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $86c698db19bf89cd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8yrCN.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$86c698db19bf89cd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $86c698db19bf89cd$var$writeFloat(this, value, offset, true, noAssert);
};
$86c698db19bf89cd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $86c698db19bf89cd$var$writeFloat(this, value, offset, false, noAssert);
};
function $86c698db19bf89cd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $86c698db19bf89cd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8yrCN.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$86c698db19bf89cd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $86c698db19bf89cd$var$writeDouble(this, value, offset, true, noAssert);
};
$86c698db19bf89cd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $86c698db19bf89cd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$86c698db19bf89cd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$86c698db19bf89cd$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$86c698db19bf89cd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$86c698db19bf89cd$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $86c698db19bf89cd$var$Buffer.isBuffer(val) ? val : $86c698db19bf89cd$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $86c698db19bf89cd$var$errors = {};
function $86c698db19bf89cd$var$E(sym, getMessage, Base) {
    $86c698db19bf89cd$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$86c698db19bf89cd$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$86c698db19bf89cd$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$86c698db19bf89cd$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $86c698db19bf89cd$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $86c698db19bf89cd$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $86c698db19bf89cd$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $86c698db19bf89cd$var$checkBounds(buf, offset, byteLength) {
    $86c698db19bf89cd$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $86c698db19bf89cd$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $86c698db19bf89cd$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $86c698db19bf89cd$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $86c698db19bf89cd$var$checkBounds(buf, offset, byteLength);
}
function $86c698db19bf89cd$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $86c698db19bf89cd$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $86c698db19bf89cd$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $86c698db19bf89cd$var$validateNumber(value, type);
        throw new $86c698db19bf89cd$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $86c698db19bf89cd$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $86c698db19bf89cd$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $86c698db19bf89cd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $86c698db19bf89cd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($86c698db19bf89cd$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $86c698db19bf89cd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $86c698db19bf89cd$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $86c698db19bf89cd$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $86c698db19bf89cd$var$base64ToBytes(str) {
    return $76zL8.toByteArray($86c698db19bf89cd$var$base64clean(str));
}
function $86c698db19bf89cd$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $86c698db19bf89cd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $86c698db19bf89cd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $86c698db19bf89cd$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $86c698db19bf89cd$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $86c698db19bf89cd$var$BufferBigIntNotDefined : fn;
}
function $86c698db19bf89cd$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("76zL8", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $52c4d4fb1c2e7486$export$d622b2ad8d90c771; }, function (v) { return $52c4d4fb1c2e7486$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $52c4d4fb1c2e7486$export$6100ba28696e12de; }, function (v) { return $52c4d4fb1c2e7486$export$6100ba28696e12de = v; });
var $52c4d4fb1c2e7486$export$a48f0734ac7c2329;
var $52c4d4fb1c2e7486$export$d622b2ad8d90c771;
var $52c4d4fb1c2e7486$export$6100ba28696e12de;
'use strict';
$52c4d4fb1c2e7486$export$a48f0734ac7c2329 = $52c4d4fb1c2e7486$var$byteLength;
$52c4d4fb1c2e7486$export$d622b2ad8d90c771 = $52c4d4fb1c2e7486$var$toByteArray;
$52c4d4fb1c2e7486$export$6100ba28696e12de = $52c4d4fb1c2e7486$var$fromByteArray;
var $52c4d4fb1c2e7486$var$lookup = [];
var $52c4d4fb1c2e7486$var$revLookup = [];
var $52c4d4fb1c2e7486$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $52c4d4fb1c2e7486$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $52c4d4fb1c2e7486$var$i = 0, $52c4d4fb1c2e7486$var$len = $52c4d4fb1c2e7486$var$code.length; $52c4d4fb1c2e7486$var$i < $52c4d4fb1c2e7486$var$len; ++$52c4d4fb1c2e7486$var$i){
    $52c4d4fb1c2e7486$var$lookup[$52c4d4fb1c2e7486$var$i] = $52c4d4fb1c2e7486$var$code[$52c4d4fb1c2e7486$var$i];
    $52c4d4fb1c2e7486$var$revLookup[$52c4d4fb1c2e7486$var$code.charCodeAt($52c4d4fb1c2e7486$var$i)] = $52c4d4fb1c2e7486$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$52c4d4fb1c2e7486$var$revLookup['-'.charCodeAt(0)] = 62;
$52c4d4fb1c2e7486$var$revLookup['_'.charCodeAt(0)] = 63;
function $52c4d4fb1c2e7486$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $52c4d4fb1c2e7486$var$byteLength(b64) {
    var lens = $52c4d4fb1c2e7486$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $52c4d4fb1c2e7486$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $52c4d4fb1c2e7486$var$toByteArray(b64) {
    var tmp;
    var lens = $52c4d4fb1c2e7486$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $52c4d4fb1c2e7486$var$Arr($52c4d4fb1c2e7486$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i)] << 18 | $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i)] << 2 | $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i)] << 10 | $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $52c4d4fb1c2e7486$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $52c4d4fb1c2e7486$var$tripletToBase64(num) {
    return $52c4d4fb1c2e7486$var$lookup[num >> 18 & 0x3F] + $52c4d4fb1c2e7486$var$lookup[num >> 12 & 0x3F] + $52c4d4fb1c2e7486$var$lookup[num >> 6 & 0x3F] + $52c4d4fb1c2e7486$var$lookup[num & 0x3F];
}
function $52c4d4fb1c2e7486$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($52c4d4fb1c2e7486$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $52c4d4fb1c2e7486$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($52c4d4fb1c2e7486$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($52c4d4fb1c2e7486$var$lookup[tmp >> 2] + $52c4d4fb1c2e7486$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($52c4d4fb1c2e7486$var$lookup[tmp >> 10] + $52c4d4fb1c2e7486$var$lookup[tmp >> 4 & 0x3F] + $52c4d4fb1c2e7486$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("8yrCN", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $63a6ed6310e5a187$export$aafa59e2e03f2942; }, function (v) { return $63a6ed6310e5a187$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $63a6ed6310e5a187$export$68d8715fc104d294; }, function (v) { return $63a6ed6310e5a187$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $63a6ed6310e5a187$export$aafa59e2e03f2942;
var $63a6ed6310e5a187$export$68d8715fc104d294;
$63a6ed6310e5a187$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$63a6ed6310e5a187$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("aElLJ", function(module, exports) {

$parcel$export(module.exports, "AuthClient", function () { return (parcelRequire("4KbMQ")).default; });

var $8KUaF = parcelRequire("8KUaF");

var $2GaB5 = parcelRequire("2GaB5");

var $4KktP = parcelRequire("4KktP");

var $4KbMQ = parcelRequire("4KbMQ");
parcelRequire("1XcDG");
parcelRequire("eiAXc");

var $0qGFG = parcelRequire("0qGFG");

});
parcelRegister("8KUaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65fe31015dc7fd12$export$2e2bcd8739ae039; });

var $jMaHP = parcelRequire("jMaHP");

var $1iZkC = parcelRequire("1iZkC");

var $hQAY4 = parcelRequire("hQAY4");

var $1XcDG = parcelRequire("1XcDG");

var $eiAXc = parcelRequire("eiAXc");
class $65fe31015dc7fd12$export$2e2bcd8739ae039 {
    /**
     * Creates an admin API client that can be used to manage users and OAuth clients.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-secret-key')
     * const { data, error } = await supabase.auth.admin.listUsers()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { GoTrueAdminApi } from '@supabase/auth-js'
     *
     * const admin = new GoTrueAdminApi({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { Authorization: `Bearer ${process.env.SUPABASE_SECRET_KEY}` },
     * })
     * ```
     */ constructor({ url: url = '', headers: headers = {}, fetch: fetch, experimental: experimental }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $hQAY4.resolveFetch)(fetch);
        this.experimental = experimental !== null && experimental !== void 0 ? experimental : {};
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
        this.oauth = {
            listClients: this._listOAuthClients.bind(this),
            createClient: this._createOAuthClient.bind(this),
            getClient: this._getOAuthClient.bind(this),
            updateClient: this._updateOAuthClient.bind(this),
            deleteClient: this._deleteOAuthClient.bind(this),
            regenerateClientSecret: this._regenerateOAuthClientSecret.bind(this)
        };
        this.customProviders = {
            listProviders: this._listCustomProviders.bind(this),
            createProvider: this._createCustomProvider.bind(this),
            getProvider: this._getCustomProvider.bind(this),
            updateProvider: this._updateCustomProvider.bind(this),
            deleteProvider: this._deleteCustomProvider.bind(this)
        };
        this.passkey = {
            listPasskeys: this._adminListPasskeys.bind(this),
            deletePasskey: this._adminDeletePasskey.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     *
     * @category Auth
     */ async signOut(jwt, scope = (0, $1XcDG.SIGN_OUT_SCOPES)[0]) {
        if ((0, $1XcDG.SIGN_OUT_SCOPES).indexOf(scope) < 0) throw new Error(`@supabase/auth-js: Parameter scope must be one of ${(0, $1XcDG.SIGN_OUT_SCOPES).join(', ')}`);
        try {
            await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     *
     * @category Auth
     *
     * @remarks
     * - Sends an invite link to the user's email address.
     * - The `inviteUserByEmail()` method is typically used by administrators to invite users to join the application.
     * - Note that PKCE is not supported when using `inviteUserByEmail`. This is because the browser initiating the invite is often different from the browser accepting the invite which makes it difficult to provide the security guarantees required of the PKCE flow.
     *
     * @example Invite a user
     * ```js
     * const { data, error } = await supabase.auth.admin.inviteUserByEmail('email@example.com')
     * ```
     *
     * @exampleResponse Invite a user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "invited_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $1iZkC._userResponse)
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     *
     * @category Auth
     *
     * @remarks
     * - The following types can be passed into `generateLink()`: `signup`, `magiclink`, `invite`, `recovery`, `email_change_current`, `email_change_new`, `phone_change`.
     * - `generateLink()` only generates the email link for `email_change_email` if the **Secure email change** is enabled in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
     * - `generateLink()` handles the creation of the user for `signup`, `invite` and `magiclink`.
     *
     * @example Generate a signup link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'signup',
     *   email: 'email@example.com',
     *   password: 'secret'
     * })
     * ```
     *
     * @exampleResponse Generate a signup link
     * ```json
     * {
     *   "data": {
     *     "properties": {
     *       "action_link": "<LINK_TO_SEND_TO_USER>",
     *       "email_otp": "999999",
     *       "hashed_token": "<HASHED_TOKEN",
     *       "redirect_to": "<REDIRECT_URL>",
     *       "verification_type": "signup"
     *     },
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "email@example.com",
     *       "phone": "",
     *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "email@example.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Generate an invite link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'invite',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate a magic link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'magiclink',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate a recovery link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'recovery',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate links to change current email address
     * ```js
     * // generate an email change link to be sent to the current email address
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'email_change_current',
     *   email: 'current.email@example.com',
     *   newEmail: 'new.email@example.com'
     * })
     *
     * // generate an email change link to be sent to the new email address
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'email_change_new',
     *   email: 'current.email@example.com',
     *   newEmail: 'new.email@example.com'
     * })
     * ```
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = (0, $jMaHP.__rest)(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $1iZkC._generateLinkResponse),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     *
     * @remarks
     * - To confirm the user's email address or phone number, set `email_confirm` or `phone_confirm` to true. Both arguments default to false.
     * - `createUser()` will not send a confirmation email to the user. You can use [`inviteUserByEmail()`](/docs/reference/javascript/auth-admin-inviteuserbyemail) if you want to send them an email invite instead.
     * - If you are sure that the created user's email or phone number is legitimate and verified, you can set the `email_confirm` or `phone_confirm` param to `true`.
     *
     * @example With custom user metadata
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   email: 'user@email.com',
     *   password: 'password',
     *   user_metadata: { name: 'Yoda' }
     * })
     * ```
     *
     * @exampleResponse With custom user metadata
     * ```json
     * {
     *   data: {
     *     user: {
     *       id: '1',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {},
     *       user_metadata: {},
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "1",
     *           "user_id": "1",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "phone_verified": false,
     *             "sub": "1"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false,
     *     }
     *   }
     *   error: null
     * }
     * ```
     *
     * @example Auto-confirm the user's email
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   email: 'user@email.com',
     *   email_confirm: true
     * })
     * ```
     *
     * @example Auto-confirm the user's phone number
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   phone: '1234567890',
     *   phone_confirm: true
     * })
     * ```
     */ async createUser(attributes) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $1iZkC._userResponse)
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     *
     * @category Auth
     *
     * @remarks
     * - Defaults to return 50 users per page.
     *
     * @example Get a page of users
     * ```js
     * const { data: { users }, error } = await supabase.auth.admin.listUsers()
     * ```
     *
     * @example Paginated list of users
     * ```js
     * const { data: { users }, error } = await supabase.auth.admin.listUsers({
     *   page: 1,
     *   perPage: 1000
     * })
     * ```
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $1iZkC._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     *
     * @remarks
     * - Fetches the user object from the database based on the user's id.
     * - The `getUserById()` method requires the user's id which maps to the `auth.users.id` column.
     *
     * @example Fetch the user object using the access_token jwt
     * ```js
     * const { data, error } = await supabase.auth.admin.getUserById(1)
     * ```
     *
     * @exampleResponse Fetch the user object using the access_token jwt
     * ```json
     * {
     *   data: {
     *     user: {
     *       id: '1',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {},
     *       user_metadata: {},
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "1",
     *           "user_id": "1",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "phone_verified": false,
     *             "sub": "1"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false,
     *     }
     *   }
     *   error: null
     * }
     * ```
     */ async getUserById(uid) {
        (0, $hQAY4.validateUUID)(uid);
        try {
            return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $1iZkC._userResponse)
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data. Changes are applied directly without confirmation flows.
     *
     * @param uid The user's unique identifier
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @remarks
     * **Important:** This is a server-side operation and does **not** trigger client-side
     * `onAuthStateChange` listeners. The admin API has no connection to client state.
     *
     * To sync changes to the client after calling this method:
     * 1. On the client, call `supabase.auth.refreshSession()` to fetch the updated user data
     * 2. This will trigger the `TOKEN_REFRESHED` event and notify all listeners
     *
     * @example
     * ```typescript
     * // Server-side (Edge Function)
     * const { data, error } = await supabase.auth.admin.updateUserById(
     *   userId,
     *   { user_metadata: { preferences: { theme: 'dark' } } }
     * )
     *
     * // Client-side (to sync the changes)
     * const { data, error } = await supabase.auth.refreshSession()
     * // onAuthStateChange listeners will now be notified with updated user
     * ```
     *
     * @see {@link GoTrueClient.refreshSession} for syncing admin changes to the client
     * @see {@link GoTrueClient.updateUser} for client-side user updates (triggers listeners automatically)
     *
     * @category Auth
     *
     * @example Updates a user's email
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '11111111-1111-1111-1111-111111111111',
     *   { email: 'new@email.com' }
     * )
     * ```
     *
     * @exampleResponse Updates a user's email
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "new@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "recovery_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Updates a user's password
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { password: 'new_password' }
     * )
     * ```
     *
     * @example Updates a user's metadata
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { user_metadata: { hello: 'world' } }
     * )
     * ```
     *
     * @example Updates a user's app_metadata
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { app_metadata: { plan: 'trial' } }
     * )
     * ```
     *
     * @example Confirms a user's email address
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { email_confirm: true }
     * )
     * ```
     *
     * @example Confirms a user's phone number
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { phone_confirm: true }
     * )
     * ```
     *
     * @example Ban a user for 100 years
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { ban_duration: '876000h' }
     * )
     * ```
     */ async updateUserById(uid, attributes) {
        (0, $hQAY4.validateUUID)(uid);
        try {
            return await (0, $1iZkC._request)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $1iZkC._userResponse)
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     *
     * @remarks
     * - The `deleteUser()` method requires the user's ID, which maps to the `auth.users.id` column.
     *
     * @example Removes a user
     * ```js
     * const { data, error } = await supabase.auth.admin.deleteUser(
     *   '715ed5db-f090-4b8c-a067-640ecee36aa0'
     * )
     * ```
     *
     * @exampleResponse Removes a user
     * ```json
     * {
     *   "data": {
     *     "user": {}
     *   },
     *   "error": null
     * }
     * ```
     */ async deleteUser(id, shouldSoftDelete = false) {
        (0, $hQAY4.validateUUID)(id);
        try {
            return await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $1iZkC._userResponse)
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        (0, $hQAY4.validateUUID)(params.userId);
        try {
            const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        (0, $hQAY4.validateUUID)(params.userId);
        (0, $hQAY4.validateUUID)(params.id);
        try {
            const data = await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all OAuth clients with optional pagination.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listOAuthClients(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $1iZkC._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const clients = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, clients), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    clients: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createOAuthClient(params) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getOAuthClient(clientId) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateOAuthClient(clientId, params) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'PUT', `${this.url}/admin/oauth/clients/${clientId}`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteOAuthClient(clientId) {
        try {
            await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Regenerates the secret for an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _regenerateOAuthClientSecret(clientId) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients/${clientId}/regenerate_secret`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all custom providers with optional type filter.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listCustomProviders(params) {
        try {
            const query = {};
            if (params === null || params === void 0 ? void 0 : params.type) query.type = params.type;
            return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers`, {
                headers: this.headers,
                query: query,
                xform: (data)=>{
                    var _a;
                    return {
                        data: {
                            providers: (_a = data === null || data === void 0 ? void 0 : data.providers) !== null && _a !== void 0 ? _a : []
                        },
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: {
                    providers: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new custom OIDC/OAuth provider.
     *
     * For OIDC providers, the server fetches and validates the OpenID Connect discovery document
     * from the issuer's well-known endpoint (or the provided `discovery_url`) at creation time.
     * This may return a validation error (`error_code: "validation_failed"`) if the discovery
     * document is unreachable, not valid JSON, missing required fields, or if the issuer
     * in the document does not match the expected issuer.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createCustomProvider(params) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/admin/custom-providers`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific custom provider by identifier.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getCustomProvider(identifier) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing custom provider.
     *
     * When `issuer` or `discovery_url` is changed on an OIDC provider, the server re-fetches and
     * validates the discovery document before persisting. This may return a validation error
     * (`error_code: "validation_failed"`) if the discovery document is unreachable, invalid, or
     * the issuer does not match.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateCustomProvider(identifier, params) {
        try {
            return await (0, $1iZkC._request)(this.fetch, 'PUT', `${this.url}/admin/custom-providers/${identifier}`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes a custom provider.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteCustomProvider(identifier) {
        try {
            await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all passkeys for a user.
     *
     * This function should only be called on a server. Never expose your secret key in the browser.
     *
     * Requires `auth.experimental.passkey: true`.
     */ async _adminListPasskeys(params) {
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        (0, $hQAY4.validateUUID)(params.userId);
        try {
            return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/passkeys`, {
                headers: this.headers,
                xform: (data)=>({
                        data: data,
                        error: null
                    })
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes a user's passkey.
     *
     * This function should only be called on a server. Never expose your secret key in the browser.
     *
     * Requires `auth.experimental.passkey: true`.
     */ async _adminDeletePasskey(params) {
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        (0, $hQAY4.validateUUID)(params.userId);
        (0, $hQAY4.validateUUID)(params.passkeyId);
        try {
            await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/passkeys/${params.passkeyId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}

});
parcelRegister("1iZkC", function(module, exports) {

$parcel$export(module.exports, "_request", function () { return $0f370c083c817d8a$export$8969b3850ca2cdfd; });
$parcel$export(module.exports, "_sessionResponse", function () { return $0f370c083c817d8a$export$273fe4673a018c2e; });
$parcel$export(module.exports, "_sessionResponsePassword", function () { return $0f370c083c817d8a$export$db83aade1c2922c7; });
$parcel$export(module.exports, "_userResponse", function () { return $0f370c083c817d8a$export$e20f488897843593; });
$parcel$export(module.exports, "_ssoResponse", function () { return $0f370c083c817d8a$export$b04785c46dcd8f8b; });
$parcel$export(module.exports, "_generateLinkResponse", function () { return $0f370c083c817d8a$export$f5eaa950605b2146; });
$parcel$export(module.exports, "_noResolveJsonResponse", function () { return $0f370c083c817d8a$export$7aed01df6e045e31; });

var $jMaHP = parcelRequire("jMaHP");

var $5MFcL = parcelRequire("5MFcL");

var $hQAY4 = parcelRequire("hQAY4");

var $eiAXc = parcelRequire("eiAXc");
const $0f370c083c817d8a$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
// 502, 503, 504: Standard server/gateway errors
// 520-524, 530: Cloudflare-specific error codes (web server down, connection timed out, etc.)
// These are infrastructure errors and should not cause session invalidation.
const $0f370c083c817d8a$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504,
    520,
    521,
    522,
    523,
    524,
    530
];
async function $0f370c083c817d8a$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $hQAY4.looksLikeFetchResponse)(error)) throw new (0, $eiAXc.AuthRetryableFetchError)($0f370c083c817d8a$var$_getErrorMessage(error), 0);
    if ($0f370c083c817d8a$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $eiAXc.AuthRetryableFetchError)($0f370c083c817d8a$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $eiAXc.AuthUnknownError)($0f370c083c817d8a$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $hQAY4.parseResponseAPIVersion)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $5MFcL.API_VERSIONS)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $eiAXc.AuthWeakPasswordError)($0f370c083c817d8a$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $eiAXc.AuthWeakPasswordError)($0f370c083c817d8a$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $eiAXc.AuthSessionMissingError)();
    throw new (0, $eiAXc.AuthApiError)($0f370c083c817d8a$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $0f370c083c817d8a$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $0f370c083c817d8a$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $5MFcL.API_VERSION_HEADER_NAME]) headers[0, $5MFcL.API_VERSION_HEADER_NAME] = (0, $5MFcL.API_VERSIONS)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $0f370c083c817d8a$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $0f370c083c817d8a$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $0f370c083c817d8a$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $eiAXc.AuthRetryableFetchError)($0f370c083c817d8a$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $0f370c083c817d8a$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $0f370c083c817d8a$export$d3da1ecaf1206c58(e);
    }
}
function $0f370c083c817d8a$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($0f370c083c817d8a$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $hQAY4.expiresAt)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $0f370c083c817d8a$export$db83aade1c2922c7(data) {
    const response = $0f370c083c817d8a$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $0f370c083c817d8a$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $0f370c083c817d8a$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $0f370c083c817d8a$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = (0, $jMaHP.__rest)(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $0f370c083c817d8a$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $0f370c083c817d8a$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}

});
parcelRegister("5MFcL", function(module, exports) {

$parcel$export(module.exports, "AUTO_REFRESH_TICK_DURATION_MS", function () { return $436165e0a74fabc7$export$a4558fee79d6c8ae; });
$parcel$export(module.exports, "AUTO_REFRESH_TICK_THRESHOLD", function () { return $436165e0a74fabc7$export$f20a97df8f5fe223; });
$parcel$export(module.exports, "EXPIRY_MARGIN_MS", function () { return $436165e0a74fabc7$export$a36ad0026e55ac00; });
$parcel$export(module.exports, "GOTRUE_URL", function () { return $436165e0a74fabc7$export$7fedf552187f0c3d; });
$parcel$export(module.exports, "STORAGE_KEY", function () { return $436165e0a74fabc7$export$86880b4b2e1a2384; });
$parcel$export(module.exports, "DEFAULT_HEADERS", function () { return $436165e0a74fabc7$export$88a84136db6a4b64; });
$parcel$export(module.exports, "API_VERSION_HEADER_NAME", function () { return $436165e0a74fabc7$export$e4f5507f88977535; });
$parcel$export(module.exports, "API_VERSIONS", function () { return $436165e0a74fabc7$export$1f9a66038489bdeb; });
$parcel$export(module.exports, "BASE64URL_REGEX", function () { return $436165e0a74fabc7$export$7a68c9e70b9d3911; });
$parcel$export(module.exports, "JWKS_TTL", function () { return $436165e0a74fabc7$export$5bd768495200f133; });

var $cKd9S = parcelRequire("cKd9S");
const $436165e0a74fabc7$export$a4558fee79d6c8ae = 30000;
const $436165e0a74fabc7$export$f20a97df8f5fe223 = 3;
const $436165e0a74fabc7$export$a36ad0026e55ac00 = $436165e0a74fabc7$export$f20a97df8f5fe223 * $436165e0a74fabc7$export$a4558fee79d6c8ae;
const $436165e0a74fabc7$export$7fedf552187f0c3d = 'http://localhost:9999';
const $436165e0a74fabc7$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $436165e0a74fabc7$export$2f9161bad044dacb = '';
const $436165e0a74fabc7$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $cKd9S.version)}`
};
const $436165e0a74fabc7$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $436165e0a74fabc7$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $436165e0a74fabc7$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $436165e0a74fabc7$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $436165e0a74fabc7$export$5bd768495200f133 = 600000; // 10 minutes

});
parcelRegister("cKd9S", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $9473fcdea9450fb0$export$83d89fbfd8236492; });
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $9473fcdea9450fb0$export$83d89fbfd8236492 = '2.105.1';

});


parcelRegister("hQAY4", function(module, exports) {

$parcel$export(module.exports, "expiresAt", function () { return $035a62f7e41e5c9c$export$e02d0a488392f690; });
$parcel$export(module.exports, "generateCallbackId", function () { return $035a62f7e41e5c9c$export$16db4ce6a8dfc285; });
$parcel$export(module.exports, "isBrowser", function () { return $035a62f7e41e5c9c$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "supportsLocalStorage", function () { return $035a62f7e41e5c9c$export$9ec034ee80211814; });
$parcel$export(module.exports, "parseParametersFromURL", function () { return $035a62f7e41e5c9c$export$7a29392fb778224c; });
$parcel$export(module.exports, "resolveFetch", function () { return $035a62f7e41e5c9c$export$98d92b1aa79f8cc7; });
$parcel$export(module.exports, "looksLikeFetchResponse", function () { return $035a62f7e41e5c9c$export$e8ad6599be1036a7; });
$parcel$export(module.exports, "setItemAsync", function () { return $035a62f7e41e5c9c$export$e82c36d29078a87f; });
$parcel$export(module.exports, "getItemAsync", function () { return $035a62f7e41e5c9c$export$ba6fcb7c333d32c0; });
$parcel$export(module.exports, "removeItemAsync", function () { return $035a62f7e41e5c9c$export$d35c645d585317ec; });
$parcel$export(module.exports, "Deferred", function () { return $035a62f7e41e5c9c$export$85f6557964517f1a; });
$parcel$export(module.exports, "decodeJWT", function () { return $035a62f7e41e5c9c$export$9a62e6c0a30e00bc; });
$parcel$export(module.exports, "sleep", function () { return $035a62f7e41e5c9c$export$e772c8ff12451969; });
$parcel$export(module.exports, "retryable", function () { return $035a62f7e41e5c9c$export$9e1b8e833f44ff21; });
$parcel$export(module.exports, "getCodeChallengeAndMethod", function () { return $035a62f7e41e5c9c$export$81b177cadfcf873c; });
$parcel$export(module.exports, "parseResponseAPIVersion", function () { return $035a62f7e41e5c9c$export$5f69ecf1c14d56fd; });
$parcel$export(module.exports, "validateExp", function () { return $035a62f7e41e5c9c$export$a5850868adeb9253; });
$parcel$export(module.exports, "getAlgorithm", function () { return $035a62f7e41e5c9c$export$fa59f625ab60cb91; });
$parcel$export(module.exports, "validateUUID", function () { return $035a62f7e41e5c9c$export$a4c72ae47296db0c; });
$parcel$export(module.exports, "assertPasskeyExperimentalEnabled", function () { return $035a62f7e41e5c9c$export$1b3246f2022dfc02; });
$parcel$export(module.exports, "userNotAvailableProxy", function () { return $035a62f7e41e5c9c$export$52c7f0d8a78626b; });
$parcel$export(module.exports, "insecureUserWarningProxy", function () { return $035a62f7e41e5c9c$export$28f3a5de6111309a; });
$parcel$export(module.exports, "deepClone", function () { return $035a62f7e41e5c9c$export$b7d58db314e0ac27; });

var $5MFcL = parcelRequire("5MFcL");

var $eiAXc = parcelRequire("eiAXc");

var $iqwv8 = parcelRequire("iqwv8");
function $035a62f7e41e5c9c$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $035a62f7e41e5c9c$export$16db4ce6a8dfc285() {
    return Symbol('auth-callback');
}
const $035a62f7e41e5c9c$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $035a62f7e41e5c9c$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $035a62f7e41e5c9c$export$9ec034ee80211814 = ()=>{
    if (!$035a62f7e41e5c9c$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($035a62f7e41e5c9c$var$localStorageWriteTests.tested) return $035a62f7e41e5c9c$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $035a62f7e41e5c9c$var$localStorageWriteTests.tested = true;
        $035a62f7e41e5c9c$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $035a62f7e41e5c9c$var$localStorageWriteTests.tested = true;
        $035a62f7e41e5c9c$var$localStorageWriteTests.writable = false;
    }
    return $035a62f7e41e5c9c$var$localStorageWriteTests.writable;
};
function $035a62f7e41e5c9c$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
const $035a62f7e41e5c9c$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $035a62f7e41e5c9c$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $035a62f7e41e5c9c$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $035a62f7e41e5c9c$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $035a62f7e41e5c9c$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $035a62f7e41e5c9c$export$85f6557964517f1a {
    constructor(){
        this.promise = new $035a62f7e41e5c9c$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$035a62f7e41e5c9c$export$85f6557964517f1a.promiseConstructor = Promise;
function $035a62f7e41e5c9c$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $eiAXc.AuthInvalidJwtError)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $5MFcL.BASE64URL_REGEX).test(parts[i])) throw new (0, $eiAXc.AuthInvalidJwtError)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $iqwv8.stringFromBase64URL)(parts[0])),
        payload: JSON.parse((0, $iqwv8.stringFromBase64URL)(parts[1])),
        signature: (0, $iqwv8.base64UrlToUint8Array)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $035a62f7e41e5c9c$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $035a62f7e41e5c9c$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $035a62f7e41e5c9c$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $035a62f7e41e5c9c$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $035a62f7e41e5c9c$var$dec2hex).join('');
}
async function $035a62f7e41e5c9c$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $035a62f7e41e5c9c$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $035a62f7e41e5c9c$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $035a62f7e41e5c9c$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $035a62f7e41e5c9c$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/recovery';
    await $035a62f7e41e5c9c$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $035a62f7e41e5c9c$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $035a62f7e41e5c9c$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $035a62f7e41e5c9c$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $5MFcL.API_VERSION_HEADER_NAME));
    if (!apiVersion) return null;
    if (!apiVersion.match($035a62f7e41e5c9c$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}
function $035a62f7e41e5c9c$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $035a62f7e41e5c9c$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}
const $035a62f7e41e5c9c$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function $035a62f7e41e5c9c$export$a4c72ae47296db0c(str) {
    if (!$035a62f7e41e5c9c$var$UUID_REGEX.test(str)) throw new Error('@supabase/auth-js: Expected parameter to be UUID but is not');
}
function $035a62f7e41e5c9c$export$1b3246f2022dfc02(experimental) {
    if (!experimental.passkey) throw new Error('@supabase/auth-js: the passkey API is experimental and disabled by default. Enable it by passing `auth: { experimental: { passkey: true } }` to createClient (or to the GoTrueClient constructor).');
}
function $035a62f7e41e5c9c$export$52c7f0d8a78626b() {
    const proxyTarget = {};
    return new Proxy(proxyTarget, {
        get: (target, prop)=>{
            if (prop === '__isUserNotAvailableProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms.
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)') // Node.js util.inspect
                return undefined;
            }
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${prop}" property of the session object is not supported. Please use getUser() instead.`);
        },
        set: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        },
        deleteProperty: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        }
    });
}
function $035a62f7e41e5c9c$export$28f3a5de6111309a(user, suppressWarningRef) {
    return new Proxy(user, {
        get: (target, prop, receiver)=>{
            // Allow internal checks without warning
            if (prop === '__isInsecureUserWarningProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)' || sProp === 'Symbol(nodejs.util.inspect.custom)') // Return the actual value for these symbols to allow proper inspection
                return Reflect.get(target, prop, receiver);
            }
            // Emit warning on first property access
            if (!suppressWarningRef.value && typeof prop === 'string') {
                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                suppressWarningRef.value = true;
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}
function $035a62f7e41e5c9c$export$b7d58db314e0ac27(obj) {
    return JSON.parse(JSON.stringify(obj));
}

});
parcelRegister("eiAXc", function(module, exports) {

$parcel$export(module.exports, "AuthError", function () { return $a68f69624e58d481$export$145273558d58e0ac; });
$parcel$export(module.exports, "isAuthError", function () { return $a68f69624e58d481$export$cde1786a482f9a1c; });
$parcel$export(module.exports, "AuthApiError", function () { return $a68f69624e58d481$export$45fde0b55b14f37b; });
$parcel$export(module.exports, "isAuthApiError", function () { return $a68f69624e58d481$export$4fe744aeb810d543; });
$parcel$export(module.exports, "AuthUnknownError", function () { return $a68f69624e58d481$export$f7559805d4a50078; });
$parcel$export(module.exports, "AuthSessionMissingError", function () { return $a68f69624e58d481$export$403b3fc0d3ad5f0c; });
$parcel$export(module.exports, "isAuthSessionMissingError", function () { return $a68f69624e58d481$export$3e849aa4db565c1d; });
$parcel$export(module.exports, "AuthInvalidTokenResponseError", function () { return $a68f69624e58d481$export$7e277b620449c1b4; });
$parcel$export(module.exports, "AuthInvalidCredentialsError", function () { return $a68f69624e58d481$export$9ef583f0381b4cc; });
$parcel$export(module.exports, "AuthImplicitGrantRedirectError", function () { return $a68f69624e58d481$export$bf5df8e043856ef5; });
$parcel$export(module.exports, "isAuthImplicitGrantRedirectError", function () { return $a68f69624e58d481$export$45edea3999507afd; });
$parcel$export(module.exports, "AuthPKCEGrantCodeExchangeError", function () { return $a68f69624e58d481$export$39583657eb2a7027; });
$parcel$export(module.exports, "AuthPKCECodeVerifierMissingError", function () { return $a68f69624e58d481$export$11e8e15400b7b336; });
$parcel$export(module.exports, "AuthRetryableFetchError", function () { return $a68f69624e58d481$export$2423b763f68be1b4; });
$parcel$export(module.exports, "isAuthRetryableFetchError", function () { return $a68f69624e58d481$export$a77af358da5fb874; });
$parcel$export(module.exports, "AuthWeakPasswordError", function () { return $a68f69624e58d481$export$b034076aa04913a6; });
$parcel$export(module.exports, "AuthInvalidJwtError", function () { return $a68f69624e58d481$export$d04cb18528f2043e; });
/**
 * Base error thrown by Supabase Auth helpers.
 *
 * @example
 * ```ts
 * import { AuthError } from '@supabase/auth-js'
 *
 * throw new AuthError('Unexpected auth error', 500, 'unexpected')
 * ```
 */ class $a68f69624e58d481$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            code: this.code
        };
    }
}
function $a68f69624e58d481$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $a68f69624e58d481$export$45fde0b55b14f37b extends $a68f69624e58d481$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $a68f69624e58d481$export$4fe744aeb810d543(error) {
    return $a68f69624e58d481$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $a68f69624e58d481$export$f7559805d4a50078 extends $a68f69624e58d481$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $a68f69624e58d481$export$823c745ae0673c5e extends $a68f69624e58d481$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $a68f69624e58d481$export$403b3fc0d3ad5f0c extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $a68f69624e58d481$export$3e849aa4db565c1d(error) {
    return $a68f69624e58d481$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $a68f69624e58d481$export$7e277b620449c1b4 extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $a68f69624e58d481$export$9ef583f0381b4cc extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $a68f69624e58d481$export$bf5df8e043856ef5 extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            details: this.details
        });
    }
}
function $a68f69624e58d481$export$45edea3999507afd(error) {
    return $a68f69624e58d481$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $a68f69624e58d481$export$39583657eb2a7027 extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            details: this.details
        });
    }
}
class $a68f69624e58d481$export$11e8e15400b7b336 extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(){
        super("PKCE code verifier not found in storage. This can happen if the auth flow was initiated in a different browser or device, or if the storage was cleared. For SSR frameworks (Next.js, SvelteKit, etc.), use @supabase/ssr on both the server and client to store the code verifier in cookies.", 'AuthPKCECodeVerifierMissingError', 400, 'pkce_code_verifier_not_found');
    }
}
function $a68f69624e58d481$export$398e1f2bb2c7a92(error) {
    return $a68f69624e58d481$export$cde1786a482f9a1c(error) && error.name === 'AuthPKCECodeVerifierMissingError';
}
class $a68f69624e58d481$export$2423b763f68be1b4 extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $a68f69624e58d481$export$a77af358da5fb874(error) {
    return $a68f69624e58d481$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $a68f69624e58d481$export$b034076aa04913a6 extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            reasons: this.reasons
        });
    }
}
function $a68f69624e58d481$export$dac36143fd8a46ef(error) {
    return $a68f69624e58d481$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $a68f69624e58d481$export$d04cb18528f2043e extends $a68f69624e58d481$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}

});

parcelRegister("iqwv8", function(module, exports) {

$parcel$export(module.exports, "stringFromBase64URL", function () { return $d6a3ddbbd1fba15d$export$bd5d476f823ea024; });
$parcel$export(module.exports, "base64UrlToUint8Array", function () { return $d6a3ddbbd1fba15d$export$9cae2cd6076b8fb6; });
$parcel$export(module.exports, "stringToUint8Array", function () { return $d6a3ddbbd1fba15d$export$a098e7b533f96db3; });
$parcel$export(module.exports, "bytesToBase64URL", function () { return $d6a3ddbbd1fba15d$export$3f156efe462a835e; });
/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $d6a3ddbbd1fba15d$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $d6a3ddbbd1fba15d$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $d6a3ddbbd1fba15d$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $d6a3ddbbd1fba15d$var$IGNORE_BASE64URL.length; i += 1)charMap[$d6a3ddbbd1fba15d$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $d6a3ddbbd1fba15d$var$TO_BASE64URL.length; i += 1)charMap[$d6a3ddbbd1fba15d$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $d6a3ddbbd1fba15d$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($d6a3ddbbd1fba15d$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($d6a3ddbbd1fba15d$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $d6a3ddbbd1fba15d$export$403e86c86002a137(charCode, state, emit) {
    const bits = $d6a3ddbbd1fba15d$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $d6a3ddbbd1fba15d$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $d6a3ddbbd1fba15d$export$caccae6095ceb6da(str, (byte)=>{
        $d6a3ddbbd1fba15d$export$744f452403189a3e(byte, state, emitter);
    });
    $d6a3ddbbd1fba15d$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $d6a3ddbbd1fba15d$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $d6a3ddbbd1fba15d$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$d6a3ddbbd1fba15d$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $d6a3ddbbd1fba15d$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $d6a3ddbbd1fba15d$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $d6a3ddbbd1fba15d$export$d203cd9136753332(codepoint, emit);
    }
}
function $d6a3ddbbd1fba15d$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $d6a3ddbbd1fba15d$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$d6a3ddbbd1fba15d$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $d6a3ddbbd1fba15d$export$a098e7b533f96db3(str) {
    const result = [];
    $d6a3ddbbd1fba15d$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}
function $d6a3ddbbd1fba15d$export$3f156efe462a835e(bytes) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onChar = (char)=>{
        result.push(char);
    };
    bytes.forEach((byte)=>$d6a3ddbbd1fba15d$export$744f452403189a3e(byte, state, onChar));
    // always call with `null` after processing all bytes
    $d6a3ddbbd1fba15d$export$744f452403189a3e(null, state, onChar);
    return result.join('');
}

});



parcelRegister("1XcDG", function(module, exports) {

$parcel$export(module.exports, "SIGN_OUT_SCOPES", function () { return $16c51af67c6f3a95$export$9a0f1d0c97ce73ca; });
const $16c51af67c6f3a95$var$WeakPasswordReasons = [
    'length',
    'characters',
    'pwned'
];
const $16c51af67c6f3a95$var$AMRMethods = [
    'password',
    'otp',
    'oauth',
    'totp',
    'mfa/totp',
    'mfa/phone',
    'mfa/webauthn',
    'anonymous',
    'sso/saml',
    'magiclink',
    'web3',
    'oauth_provider/authorization_code'
];
const $16c51af67c6f3a95$var$FactorTypes = [
    'totp',
    'phone',
    'webauthn'
];
const $16c51af67c6f3a95$var$FactorVerificationStatuses = [
    'verified',
    'unverified'
];
const $16c51af67c6f3a95$var$MFATOTPChannels = [
    'sms',
    'whatsapp'
];
const $16c51af67c6f3a95$export$9a0f1d0c97ce73ca = [
    'global',
    'local',
    'others'
];

});


parcelRegister("2GaB5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f37b95ef684de65$export$2e2bcd8739ae039; });

var $8KUaF = parcelRequire("8KUaF");

var $5MFcL = parcelRequire("5MFcL");

var $eiAXc = parcelRequire("eiAXc");

var $1iZkC = parcelRequire("1iZkC");

var $hQAY4 = parcelRequire("hQAY4");

var $f5pdv = parcelRequire("f5pdv");

var $0qGFG = parcelRequire("0qGFG");

var $byU9f = parcelRequire("byU9f");

var $cKd9S = parcelRequire("cKd9S");

var $iqwv8 = parcelRequire("iqwv8");

var $1aLKn = parcelRequire("1aLKn");

var $bJWBJ = parcelRequire("bJWBJ");
(0, $byU9f.polyfillGlobalThis)(); // Make "globalThis" available
const $1f37b95ef684de65$var$DEFAULT_OPTIONS = {
    url: (0, $5MFcL.GOTRUE_URL),
    storageKey: (0, $5MFcL.STORAGE_KEY),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $5MFcL.DEFAULT_HEADERS),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false,
    throwOnError: false,
    lockAcquireTimeout: 5000,
    skipAutoInitialize: false,
    experimental: {}
};
async function $1f37b95ef684de65$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
/**
 * Caches JWKS values for all clients created in the same environment. This is
 * especially useful for shared-memory execution environments such as Vercel's
 * Fluid Compute, AWS Lambda or Supabase's Edge Functions. Regardless of how
 * many clients are created, if they share the same storage key they will use
 * the same JWKS cache, significantly speeding up getClaims() with asymmetric
 * JWTs.
 */ const $1f37b95ef684de65$var$GLOBAL_JWKS = {};
class $1f37b95ef684de65$var$GoTrueClient {
    /**
     * The JWKS used for verifying asymmetric JWTs
     */ get jwks() {
        var _a, _b;
        return (_b = (_a = $1f37b95ef684de65$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.jwks) !== null && _b !== void 0 ? _b : {
            keys: []
        };
    }
    set jwks(value) {
        $1f37b95ef684de65$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $1f37b95ef684de65$var$GLOBAL_JWKS[this.storageKey]), {
            jwks: value
        });
    }
    get jwks_cached_at() {
        var _a, _b;
        return (_b = (_a = $1f37b95ef684de65$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.cachedAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER;
    }
    set jwks_cached_at(value) {
        $1f37b95ef684de65$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $1f37b95ef684de65$var$GLOBAL_JWKS[this.storageKey]), {
            cachedAt: value
        });
    }
    /**
     * Create a new client for use in the browser.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const { data, error } = await supabase.auth.getUser()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { GoTrueClient } from '@supabase/auth-js'
     *
     * const auth = new GoTrueClient({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { apikey: 'your-publishable-key' },
     *   storageKey: 'supabase-auth',
     * })
     * ```
     */ constructor(options){
        var _a, _b, _c, _d;
        /**
         * @experimental
         */ this.userStorage = null;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.autoRefreshTickTimeout = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the auth state is known and it's safe to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        const settings = Object.assign(Object.assign({}, $1f37b95ef684de65$var$DEFAULT_OPTIONS), options);
        this.storageKey = settings.storageKey;
        this.instanceID = (_a = $1f37b95ef684de65$var$GoTrueClient.nextInstanceID[this.storageKey]) !== null && _a !== void 0 ? _a : 0;
        $1f37b95ef684de65$var$GoTrueClient.nextInstanceID[this.storageKey] = this.instanceID + 1;
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        if (this.instanceID > 0 && (0, $hQAY4.isBrowser)()) {
            const message = `${this._logPrefix()} Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.`;
            console.warn(message);
            if (this.logDebugMessages) console.trace(message);
        }
        this.persistSession = settings.persistSession;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.experimental = (_b = settings.experimental) !== null && _b !== void 0 ? _b : {};
        this.admin = new (0, $8KUaF.default)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch,
            experimental: this.experimental
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $hQAY4.resolveFetch)(settings.fetch);
        this.lock = settings.lock || $1f37b95ef684de65$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        this.throwOnError = settings.throwOnError;
        this.lockAcquireTimeout = settings.lockAcquireTimeout;
        if (settings.lock) this.lock = settings.lock;
        else if (this.persistSession && (0, $hQAY4.isBrowser)() && ((_c = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _c === void 0 ? void 0 : _c.locks)) this.lock = (0, $0qGFG.navigatorLock);
        else this.lock = $1f37b95ef684de65$var$lockNoOp;
        if (!this.jwks) {
            this.jwks = {
                keys: []
            };
            this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        }
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this),
            webauthn: new (0, $bJWBJ.WebAuthnApi)(this)
        };
        this.oauth = {
            getAuthorizationDetails: this._getAuthorizationDetails.bind(this),
            approveAuthorization: this._approveAuthorization.bind(this),
            denyAuthorization: this._denyAuthorization.bind(this),
            listGrants: this._listOAuthGrants.bind(this),
            revokeGrant: this._revokeOAuthGrant.bind(this)
        };
        this.passkey = {
            startRegistration: this._startPasskeyRegistration.bind(this),
            verifyRegistration: this._verifyPasskeyRegistration.bind(this),
            startAuthentication: this._startPasskeyAuthentication.bind(this),
            verifyAuthentication: this._verifyPasskeyAuthentication.bind(this),
            list: this._listPasskeys.bind(this),
            update: this._updatePasskey.bind(this),
            delete: this._deletePasskey.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $hQAY4.supportsLocalStorage)()) this.storage = globalThis.localStorage;
            else {
                this.memoryStorage = {};
                this.storage = (0, $f5pdv.memoryLocalStorageAdapter)(this.memoryStorage);
            }
            if (settings.userStorage) this.userStorage = settings.userStorage;
        } else {
            this.memoryStorage = {};
            this.storage = (0, $f5pdv.memoryLocalStorageAdapter)(this.memoryStorage);
        }
        if ((0, $hQAY4.isBrowser)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_d = this.broadcastChannel) === null || _d === void 0 || _d.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                try {
                    await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
                } catch (error) {
                    this._debug('#broadcastChannel', 'error', error);
                }
            });
        }
        // Only auto-initialize if not explicitly disabled. Skipped in SSR contexts
        // where initialization timing must be controlled. All public methods have
        // lazy initialization, so the client remains fully functional.
        if (!settings.skipAutoInitialize) this.initialize().catch((error)=>{
            this._debug('#initialize()', 'error', error);
        });
    }
    /**
     * Returns whether error throwing mode is enabled for this client.
     */ isThrowOnErrorEnabled() {
        return this.throwOnError;
    }
    /**
     * Centralizes return handling with optional error throwing. When `throwOnError` is enabled
     * and the provided result contains a non-nullish error, the error is thrown instead of
     * being returned. This ensures consistent behavior across all public API methods.
     */ _returnResult(result) {
        if (this.throwOnError && result && result.error) throw result.error;
        return result;
    }
    _logPrefix() {
        return 'GoTrueClient@' + `${this.storageKey}:${this.instanceID} (${0, $cKd9S.version}) ${new Date().toISOString()}`;
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(this._logPrefix(), ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     *
     * @category Auth
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            let params = {};
            let callbackUrlType = 'none';
            if ((0, $hQAY4.isBrowser)()) {
                params = (0, $hQAY4.parseParametersFromURL)(window.location.href);
                if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
                else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            }
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $hQAY4.isBrowser)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $eiAXc.isAuthImplicitGrantRedirectError)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // Don't remove existing session on URL login failure.
                    // A failed attempt (e.g. reused magic link) shouldn't invalidate a valid session.
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                error: error
            });
            return this._returnResult({
                error: new (0, $eiAXc.AuthUnknownError)('Unexpected error during initialization', error)
            });
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     *
     * @category Auth
     *
     * @remarks
     * - Returns an anonymous user
     * - It is recommended to set up captcha for anonymous sign-ins to prevent abuse. You can pass in the captcha token in the `options` param.
     *
     * @example Create an anonymous user
     * ```js
     * const { data, error } = await supabase.auth.signInAnonymously({
     *   options: {
     *     captchaToken
     *   }
     * });
     * ```
     *
     * @exampleResponse Create an anonymous user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {},
     *       "user_metadata": {},
     *       "identities": [],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": true
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {},
     *         "user_metadata": {},
     *         "identities": [],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": true
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Create an anonymous user with custom user metadata
     * ```js
     * const { data, error } = await supabase.auth.signInAnonymously({
     *   options: {
     *     data
     *   }
     * })
     * ```
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $1iZkC._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error || !data) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     *
     * @category Auth
     *
     * @remarks
     * - By default, the user needs to verify their email address before logging in. To turn this off, disable **Confirm email** in [your project](/dashboard/project/_/auth/providers).
     * - **Confirm email** determines if users need to confirm their email address after signing up.
     *   - If **Confirm email** is enabled, a `user` is returned but `session` is null.
     *   - If **Confirm email** is disabled, both a `user` and a `session` are returned.
     * - When the user confirms their email address, they are redirected to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) by default. You can modify your `SITE_URL` or add additional redirect URLs in [your project](/dashboard/project/_/auth/url-configuration).
     * - If signUp() is called for an existing confirmed user:
     *   - When both **Confirm email** and **Confirm phone** (even when phone provider is disabled) are enabled in [your project](/dashboard/project/_/auth/providers), an obfuscated/fake user object is returned.
     *   - When either **Confirm email** or **Confirm phone** (even when phone provider is disabled) is disabled, the error message, `User already registered` is returned.
     * - To fetch the currently logged-in user, refer to [`getUser()`](/docs/reference/javascript/auth-getuser).
     *
     * @example Sign up with an email and password
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign up with an email and password
     * ```json
     * // Some fields may be null if "confirm email" is enabled.
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign up with a phone number and password (SMS)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'sms'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign up with a phone number and password (whatsapp)
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign up with a phone number and password (whatsapp)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'whatsapp'
     *   }
     * })
     * ```
     *
     * @example Sign up with additional user metadata
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       data: {
     *         first_name: 'John',
     *         age: 27,
     *       }
     *     }
     *   }
     * )
     * ```
     *
     * @exampleDescription Sign up with a redirect URL
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign up with a redirect URL
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       emailRedirectTo: 'https://example.com/welcome'
     *     }
     *   }
     * )
     * ```
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $hQAY4.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                res = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $1iZkC._sessionResponse)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $1iZkC._sessionResponse)
                });
            } else throw new (0, $eiAXc.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) {
                await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     *
     * @category Auth
     *
     * @remarks
     * - Requires either an email and password or a phone number and password.
     *
     * @example Sign in with email and password
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign in with email and password
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign in with phone and password
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   phone: '+13334445555',
     *   password: 'some-password',
     * })
     * ```
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $1iZkC._sessionResponsePassword)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $1iZkC._sessionResponsePassword)
                });
            } else throw new (0, $eiAXc.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $eiAXc.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     *
     * @category Auth
     *
     * @remarks
     * - This method is used for signing in using [Social Login (OAuth) providers](/docs/guides/auth#configure-third-party-providers).
     * - It works by redirecting your application to the provider's authorization screen, before bringing back the user to your app.
     *
     * @example Sign in using a third-party provider
     * ```js
     * const { data, error } = await supabase.auth.signInWithOAuth({
     *   provider: 'github'
     * })
     * ```
     *
     * @exampleResponse Sign in using a third-party provider
     * ```json
     * {
     *   data: {
     *     provider: 'github',
     *     url: <PROVIDER_URL_TO_REDIRECT_TO>
     *   },
     *   error: null
     * }
     * ```
     *
     * @exampleDescription Sign in using a third-party provider with redirect
     * - When the OAuth provider successfully authenticates the user, they are redirected to the URL specified in the `redirectTo` parameter. This parameter defaults to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls). It does not redirect the user immediately after invoking this method.
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign in using a third-party provider with redirect
     * ```js
     * const { data, error } = await supabase.auth.signInWithOAuth({
     *   provider: 'github',
     *   options: {
     *     redirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign in with scopes and access provider tokens
     * If you need additional access from an OAuth provider, in order to access provider specific APIs in the name of the user, you can do this by passing in the scopes the user should authorize for your application. Note that the `scopes` option takes in **a space-separated list** of scopes.
     *
     * Because OAuth sign-in often includes redirects, you should register an `onAuthStateChange` callback immediately after you create the Supabase client. This callback will listen for the presence of `provider_token` and `provider_refresh_token` properties on the `session` object and store them in local storage. The client library will emit these values **only once** immediately after the user signs in. You can then access them by looking them up in local storage, or send them to your backend servers for further processing.
     *
     * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
     *
     * @example Sign in with scopes and access provider tokens
     * ```js
     * // Register this immediately after calling createClient!
     * // Because signInWithOAuth causes a redirect, you need to fetch the
     * // provider tokens from the callback.
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (session && session.provider_token) {
     *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
     *   }
     *
     *   if (session && session.provider_refresh_token) {
     *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
     *   }
     *
     *   if (event === 'SIGNED_OUT') {
     *     window.localStorage.removeItem('oauth_provider_token')
     *     window.localStorage.removeItem('oauth_provider_refresh_token')
     *   }
     * })
     *
     * // Call this on your Sign in with GitHub button to initiate OAuth
     * // with GitHub with the requested elevated scopes.
     * await supabase.auth.signInWithOAuth({
     *   provider: 'github',
     *   options: {
     *     scopes: 'repo gist notifications'
     *   }
     * })
     * ```
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     *
     * @category Auth
     *
     * @remarks
     * - Used when `flowType` is set to `pkce` in client options.
     *
     * @example Exchange Auth Code
     * ```js
     * supabase.auth.exchangeCodeForSession('34e770dd-9ff9-416c-87fa-43b31d7ef225')
     * ```
     *
     * @exampleResponse Exchange Auth Code
     * ```json
     * {
     *   "data": {
     *     session: {
     *       access_token: '<ACCESS_TOKEN>',
     *       token_type: 'bearer',
     *       expires_in: 3600,
     *       expires_at: 1700000000,
     *       refresh_token: '<REFRESH_TOKEN>',
     *       user: {
     *         id: '11111111-1111-1111-1111-111111111111',
     *         aud: 'authenticated',
     *         role: 'authenticated',
     *         email: 'example@email.com'
     *         email_confirmed_at: '2024-01-01T00:00:00Z',
     *         phone: '',
     *         confirmation_sent_at: '2024-01-01T00:00:00Z',
     *         confirmed_at: '2024-01-01T00:00:00Z',
     *         last_sign_in_at: '2024-01-01T00:00:00Z',
     *         app_metadata: {
     *           "provider": "email",
     *           "providers": [
     *             "email",
     *             "<OTHER_PROVIDER>"
     *           ]
     *         },
     *         user_metadata: {
     *           email: 'email@email.com',
     *           email_verified: true,
     *           full_name: 'User Name',
     *           iss: '<ISS>',
     *           name: 'User Name',
     *           phone_verified: false,
     *           provider_id: '<PROVIDER_ID>',
     *           sub: '<SUB>'
     *         },
     *         identities: [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "email@example.com"
     *           },
     *           {
     *             "identity_id": "33333333-3333-3333-3333-333333333333",
     *             "id": "<ID>",
     *             "user_id": "<USER_ID>",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": true,
     *               "full_name": "User Name",
     *               "iss": "<ISS>",
     *               "name": "User Name",
     *               "phone_verified": false,
     *               "provider_id": "<PROVIDER_ID>",
     *               "sub": "<SUB>"
     *             },
     *             "provider": "<PROVIDER>",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         created_at: '2024-01-01T00:00:00Z',
     *         updated_at: '2024-01-01T00:00:00Z',
     *         is_anonymous: false
     *       },
     *       provider_token: '<PROVIDER_TOKEN>',
     *       provider_refresh_token: '<PROVIDER_REFRESH_TOKEN>'
     *     },
     *     user: {
     *       id: '11111111-1111-1111-1111-111111111111',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {
     *         provider: 'email',
     *         providers: [
     *           "email",
     *           "<OTHER_PROVIDER>"
     *         ]
     *       },
     *       user_metadata: {
     *         email: 'email@email.com',
     *         email_verified: true,
     *         full_name: 'User Name',
     *         iss: '<ISS>',
     *         name: 'User Name',
     *         phone_verified: false,
     *         provider_id: '<PROVIDER_ID>',
     *         sub: '<SUB>'
     *       },
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *         {
     *           "identity_id": "33333333-3333-3333-3333-333333333333",
     *           "id": "<ID>",
     *           "user_id": "<USER_ID>",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "full_name": "User Name",
     *             "iss": "<ISS>",
     *             "name": "User Name",
     *             "phone_verified": false,
     *             "provider_id": "<PROVIDER_ID>",
     *             "sub": "<SUB>"
     *           },
     *           "provider": "<PROVIDER>",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false
     *     },
     *     redirectType: null
     *   },
     *   "error": null
     * }
     * ```
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    /**
     * Signs in a user by verifying a message signed by the user's private key.
     * Supports Ethereum (via Sign-In-With-Ethereum) & Solana (Sign-In-With-Solana) standards,
     * both of which derive from the EIP-4361 standard
     * With slight variation on Solana's side.
     * @reference https://eips.ethereum.org/EIPS/eip-4361
     *
     * @category Auth
     *
     * @remarks
     * - Uses a Web3 (Ethereum, Solana) wallet to sign a user in.
     * - Read up on the [potential for abuse](/docs/guides/auth/auth-web3#potential-for-abuse) before using it.
     *
     * @example Sign in with Solana or Ethereum (Window API)
     * ```js
     *   // uses window.ethereum for the wallet
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'ethereum',
     *     statement: 'I accept the Terms of Service at https://example.com/tos'
     *   })
     *
     *   // uses window.solana for the wallet
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'solana',
     *     statement: 'I accept the Terms of Service at https://example.com/tos'
     *   })
     * ```
     *
     * @example Sign in with Ethereum (Message and Signature)
     * ```js
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'ethereum',
     *     message: '<sign in with ethereum message>',
     *     signature: '<hex of the ethereum signature over the message>',
     *   })
     * ```
     *
     * @example Sign in with Solana (Brave)
     * ```js
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'solana',
     *     statement: 'I accept the Terms of Service at https://example.com/tos',
     *     wallet: window.braveSolana
     *   })
     * ```
     *
     * @example Sign in with Solana (Wallet Adapter)
     * ```jsx
     *   function SignInButton() {
     *   const wallet = useWallet()
     *
     *   return (
     *     <>
     *       {wallet.connected ? (
     *         <button
     *           onClick={() => {
     *             supabase.auth.signInWithWeb3({
     *               chain: 'solana',
     *               statement: 'I accept the Terms of Service at https://example.com/tos',
     *               wallet,
     *             })
     *           }}
     *         >
     *           Sign in with Solana
     *         </button>
     *       ) : (
     *         <WalletMultiButton />
     *       )}
     *     </>
     *   )
     * }
     *
     * function App() {
     *   const endpoint = clusterApiUrl('devnet')
     *   const wallets = useMemo(() => [], [])
     *
     *   return (
     *     <ConnectionProvider endpoint={endpoint}>
     *       <WalletProvider wallets={wallets}>
     *         <WalletModalProvider>
     *           <SignInButton />
     *         </WalletModalProvider>
     *       </WalletProvider>
     *     </ConnectionProvider>
     *   )
     * }
     * ```
     */ async signInWithWeb3(credentials) {
        const { chain: chain } = credentials;
        switch(chain){
            case 'ethereum':
                return await this.signInWithEthereum(credentials);
            case 'solana':
                return await this.signInWithSolana(credentials);
            default:
                throw new Error(`@supabase/auth-js: Unsupported chain "${chain}"`);
        }
    }
    async signInWithEthereum(credentials) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        // TODO: flatten type
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $hQAY4.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('ethereum' in windowAny && typeof windowAny.ethereum === 'object' && 'request' in windowAny.ethereum && typeof windowAny.ethereum.request === 'function') resolvedWallet = windowAny.ethereum;
                else throw new Error(`@supabase/auth-js: No compatible Ethereum wallet interface on the window object (window.ethereum) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'ethereum', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            const accounts = await resolvedWallet.request({
                method: 'eth_requestAccounts'
            }).then((accs)=>accs).catch(()=>{
                throw new Error(`@supabase/auth-js: Wallet method eth_requestAccounts is missing or invalid`);
            });
            if (!accounts || accounts.length === 0) throw new Error(`@supabase/auth-js: No accounts available. Please ensure the wallet is connected.`);
            const address = (0, $1aLKn.getAddress)(accounts[0]);
            let chainId = (_b = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _b === void 0 ? void 0 : _b.chainId;
            if (!chainId) {
                const chainIdHex = await resolvedWallet.request({
                    method: 'eth_chainId'
                });
                chainId = (0, $1aLKn.fromHex)(chainIdHex);
            }
            const siweMessage = {
                domain: url.host,
                address: address,
                statement: statement,
                uri: url.href,
                version: '1',
                chainId: chainId,
                nonce: (_c = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _c === void 0 ? void 0 : _c.nonce,
                issuedAt: (_e = (_d = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _d === void 0 ? void 0 : _d.issuedAt) !== null && _e !== void 0 ? _e : new Date(),
                expirationTime: (_f = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _f === void 0 ? void 0 : _f.expirationTime,
                notBefore: (_g = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _g === void 0 ? void 0 : _g.notBefore,
                requestId: (_h = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _h === void 0 ? void 0 : _h.requestId,
                resources: (_j = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _j === void 0 ? void 0 : _j.resources
            };
            message = (0, $1aLKn.createSiweMessage)(siweMessage);
            // Sign message
            signature = await resolvedWallet.request({
                method: 'personal_sign',
                params: [
                    (0, $1aLKn.toHex)(message),
                    address
                ]
            });
        }
        try {
            const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'ethereum',
                    message: message,
                    signature: signature
                }, ((_k = credentials.options) === null || _k === void 0 ? void 0 : _k.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken
                    }
                } : null),
                xform: (0, $1iZkC._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $eiAXc.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async signInWithSolana(credentials) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $hQAY4.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('solana' in windowAny && typeof windowAny.solana === 'object' && ('signIn' in windowAny.solana && typeof windowAny.solana.signIn === 'function' || 'signMessage' in windowAny.solana && typeof windowAny.solana.signMessage === 'function')) resolvedWallet = windowAny.solana;
                else throw new Error(`@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            if ('signIn' in resolvedWallet && resolvedWallet.signIn) {
                const output = await resolvedWallet.signIn(Object.assign(Object.assign(Object.assign({
                    issuedAt: new Date().toISOString()
                }, options === null || options === void 0 ? void 0 : options.signInWithSolana), {
                    // non-overridable properties
                    version: '1',
                    domain: url.host,
                    uri: url.href
                }), statement ? {
                    statement: statement
                } : null));
                let outputToProcess;
                if (Array.isArray(output) && output[0] && typeof output[0] === 'object') outputToProcess = output[0];
                else if (output && typeof output === 'object' && 'signedMessage' in output && 'signature' in output) outputToProcess = output;
                else throw new Error('@supabase/auth-js: Wallet method signIn() returned unrecognized value');
                if ('signedMessage' in outputToProcess && 'signature' in outputToProcess && (typeof outputToProcess.signedMessage === 'string' || outputToProcess.signedMessage instanceof Uint8Array) && outputToProcess.signature instanceof Uint8Array) {
                    message = typeof outputToProcess.signedMessage === 'string' ? outputToProcess.signedMessage : new TextDecoder().decode(outputToProcess.signedMessage);
                    signature = outputToProcess.signature;
                } else throw new Error('@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields');
            } else {
                if (!('signMessage' in resolvedWallet) || typeof resolvedWallet.signMessage !== 'function' || !('publicKey' in resolvedWallet) || typeof resolvedWallet !== 'object' || !resolvedWallet.publicKey || !('toBase58' in resolvedWallet.publicKey) || typeof resolvedWallet.publicKey.toBase58 !== 'function') throw new Error('@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API');
                message = [
                    `${url.host} wants you to sign in with your Solana account:`,
                    resolvedWallet.publicKey.toBase58(),
                    ...statement ? [
                        '',
                        statement,
                        ''
                    ] : [
                        ''
                    ],
                    'Version: 1',
                    `URI: ${url.href}`,
                    `Issued At: ${(_c = (_b = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _b === void 0 ? void 0 : _b.issuedAt) !== null && _c !== void 0 ? _c : new Date().toISOString()}`,
                    ...((_d = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _d === void 0 ? void 0 : _d.notBefore) ? [
                        `Not Before: ${options.signInWithSolana.notBefore}`
                    ] : [],
                    ...((_e = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _e === void 0 ? void 0 : _e.expirationTime) ? [
                        `Expiration Time: ${options.signInWithSolana.expirationTime}`
                    ] : [],
                    ...((_f = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _f === void 0 ? void 0 : _f.chainId) ? [
                        `Chain ID: ${options.signInWithSolana.chainId}`
                    ] : [],
                    ...((_g = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _g === void 0 ? void 0 : _g.nonce) ? [
                        `Nonce: ${options.signInWithSolana.nonce}`
                    ] : [],
                    ...((_h = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _h === void 0 ? void 0 : _h.requestId) ? [
                        `Request ID: ${options.signInWithSolana.requestId}`
                    ] : [],
                    ...((_k = (_j = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _j === void 0 ? void 0 : _j.resources) === null || _k === void 0 ? void 0 : _k.length) ? [
                        'Resources',
                        ...options.signInWithSolana.resources.map((resource)=>`- ${resource}`)
                    ] : []
                ].join('\n');
                const maybeSignature = await resolvedWallet.signMessage(new TextEncoder().encode(message), 'utf8');
                if (!maybeSignature || !(maybeSignature instanceof Uint8Array)) throw new Error('@supabase/auth-js: Wallet signMessage() API returned an recognized value');
                signature = maybeSignature;
            }
        }
        try {
            const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'solana',
                    message: message,
                    signature: (0, $iqwv8.bytesToBase64URL)(signature)
                }, ((_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken
                    }
                } : null),
                xform: (0, $1iZkC._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $eiAXc.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $hQAY4.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            if (!codeVerifier && this.flowType === 'pkce') throw new (0, $eiAXc.AuthPKCECodeVerifierMissingError)();
            const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $1iZkC._sessionResponse)
            });
            await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $eiAXc.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        redirectType: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers(redirectType === 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            });
        } catch (error) {
            await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     *
     * @category Auth
     *
     * @remarks
     * - Use an ID token to sign in.
     * - Especially useful when implementing sign in using native platform dialogs in mobile or desktop apps using Sign in with Apple or Sign in with Google on iOS and Android.
     * - You can also use Google's [One Tap](https://developers.google.com/identity/gsi/web/guides/display-google-one-tap) and [Automatic sign-in](https://developers.google.com/identity/gsi/web/guides/automatic-sign-in-sign-out) via this API.
     *
     * @example Sign In using ID Token
     * ```js
     * const { data, error } = await supabase.auth.signInWithIdToken({
     *   provider: 'google',
     *   token: 'your-id-token'
     * })
     * ```
     *
     * @exampleResponse Sign In using ID Token
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         ...
     *       },
     *       "user_metadata": {
     *         ...
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "provider": "google",
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           ...
     *         },
     *         "user_metadata": {
     *           ...
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "provider": "google",
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $1iZkC._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $eiAXc.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: data,
                error: error
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     *
     * @category Auth
     *
     * @remarks
     * - Requires either an email or phone number.
     * - This method is used for passwordless sign-ins where a OTP is sent to the user's email or phone number.
     * - If the user doesn't exist, `signInWithOtp()` will signup the user instead. To restrict this behavior, you can set `shouldCreateUser` in `SignInWithPasswordlessCredentials.options` to `false`.
     * - If you're using an email, you can configure whether you want the user to receive a magiclink or a OTP.
     * - If you're using phone, you can configure whether you want the user to receive a OTP.
     * - The magic link's destination URL is determined by the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls).
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     * - Magic links and OTPs share the same implementation. To send users a one-time code instead of a magic link, [modify the magic link email template](/dashboard/project/_/auth/templates) to include `{{ .Token }}` instead of `{{ .ConfirmationURL }}`.
     * - See our [Twilio Phone Auth Guide](/docs/guides/auth/phone-login?showSMSProvider=Twilio) for details about configuring WhatsApp sign in.
     *
     * @exampleDescription Sign in with email
     * The user will be sent an email which contains either a magiclink or a OTP or both. By default, a given user can only request a OTP once every 60 seconds.
     *
     * @example Sign in with email
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   email: 'example@email.com',
     *   options: {
     *     emailRedirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleResponse Sign in with email
     * ```json
     * {
     *   "data": {
     *     "user": null,
     *     "session": null
     *   },
     *   "error": null
     * }
     * ```
     *
     * @exampleDescription Sign in with SMS OTP
     * The user will be sent a SMS which contains a OTP. By default, a given user can only request a OTP once every 60 seconds.
     *
     * @example Sign in with SMS OTP
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   phone: '+13334445555',
     * })
     * ```
     *
     * @exampleDescription Sign in with WhatsApp OTP
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign in with WhatsApp OTP
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   phone: '+13334445555',
     *   options: {
     *     channel:'whatsapp',
     *   }
     * })
     * ```
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $hQAY4.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $eiAXc.AuthInvalidCredentialsError)('You must provide either an email or phone number.');
        } catch (error) {
            await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     *
     * @category Auth
     *
     * @remarks
     * - The `verifyOtp` method takes in different verification types.
     * - If a phone number is used, the type can either be:
     *   1. `sms` – Used when verifying a one-time password (OTP) sent via SMS during sign-up or sign-in.
     *   2. `phone_change` – Used when verifying an OTP sent to a new phone number during a phone number update process.
     * - If an email address is used, the type can be one of the following (note: `signup` and `magiclink` types are deprecated):
     *   1. `email` – Used when verifying an OTP sent to the user's email during sign-up or sign-in.
     *   2. `recovery` – Used when verifying an OTP sent for account recovery, typically after a password reset request.
     *   3. `invite` – Used when verifying an OTP sent as part of an invitation to join a project or organization.
     *   4. `email_change` – Used when verifying an OTP sent to a new email address during an email update process.
     * - The verification type used should be determined based on the corresponding auth method called before `verifyOtp` to sign up / sign-in a user.
     * - The `TokenHash` is contained in the [email templates](/docs/guides/auth/auth-email-templates) and can be used to sign in.  You may wish to use the hash for the PKCE flow for Server Side Auth. Read [the Password-based Auth guide](/docs/guides/auth/passwords) for more details.
     *
     * @example Verify Signup One-Time Password (OTP)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ email, token, type: 'email'})
     * ```
     *
     * @exampleResponse Verify Signup One-Time Password (OTP)
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "recovery_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "recovery_sent_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Verify SMS One-Time Password (OTP)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ phone, token, type: 'sms'})
     * ```
     *
     * @example Verify Email Auth (Token Hash)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ token_hash: tokenHash, type: 'email'})
     * ```
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $1iZkC._sessionResponse)
            });
            if (error) throw error;
            if (!data) {
                const tokenVerificationError = new Error('An error occurred on token verification.');
                throw tokenVerificationError;
            }
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     *
     * @category Auth
     *
     * @remarks
     * - Before you can call this method you need to [establish a connection](/docs/guides/auth/sso/auth-sso-saml#managing-saml-20-connections) to an identity provider. Use the [CLI commands](/docs/reference/cli/supabase-sso) to do this.
     * - If you've associated an email domain to the identity provider, you can use the `domain` property to start a sign-in flow.
     * - In case you need to use a different way to start the authentication flow with an identity provider, you can use the `providerId` property. For example:
     *     - Mapping specific user email addresses with an identity provider.
     *     - Using different hints to identity the identity provider to be used by the user, like a company-specific page, IP address or other tracking information.
     *
     * @example Sign in with email domain
     * ```js
     *   // You can extract the user's email domain and use it to trigger the
     *   // authentication flow with the correct identity provider.
     *
     *   const { data, error } = await supabase.auth.signInWithSSO({
     *     domain: 'company.com'
     *   })
     *
     *   if (data?.url) {
     *     // redirect the user to the identity provider's authentication flow
     *     window.location.href = data.url
     *   }
     * ```
     *
     * @example Sign in with provider UUID
     * ```js
     *   // Useful when you need to map a user's sign in request according
     *   // to different rules that can't use email domains.
     *
     *   const { data, error } = await supabase.auth.signInWithSSO({
     *     providerId: '21648a9d-8d5a-4555-a9d1-d6375dc14e92'
     *   })
     *
     *   if (data?.url) {
     *     // redirect the user to the identity provider's authentication flow
     *     window.location.href = data.url
     *   }
     * ```
     */ async signInWithSSO(params) {
        var _a, _b, _c, _d, _e;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $hQAY4.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const result = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $1iZkC._ssoResponse)
            });
            // Automatically redirect in browser unless skipBrowserRedirect is true
            if (((_d = result.data) === null || _d === void 0 ? void 0 : _d.url) && (0, $hQAY4.isBrowser)() && !((_e = params.options) === null || _e === void 0 ? void 0 : _e.skipBrowserRedirect)) window.location.assign(result.data.url);
            return this._returnResult(result);
        } catch (error) {
            await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     *
     * @category Auth
     *
     * @remarks
     * - This method is used together with `updateUser()` when a user's password needs to be updated.
     * - If you require your user to reauthenticate before updating their password, you need to enable the **Secure password change** option in your [project's email provider settings](/dashboard/project/_/auth/providers).
     * - A user is only require to reauthenticate before updating their password if **Secure password change** is enabled and the user **hasn't recently signed in**. A user is deemed recently signed in if the session was created in the last 24 hours.
     * - This method will send a nonce to the user's email. If the user doesn't have a confirmed email address, the method will send the nonce to the user's confirmed phone number instead.
     * - After receiving the OTP, include it as the `nonce` in your `updateUser()` call to finalize the password change.
     *
     * @exampleDescription Send reauthentication nonce
     * Sends a reauthentication nonce to the user's email or phone number.
     *
     * @example Send reauthentication nonce
     * ```js
     * const { error } = await supabase.auth.reauthenticate()
     * ```
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $eiAXc.AuthSessionMissingError)();
                const { error: error } = await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     *
     * @category Auth
     *
     * @remarks
     * - Resends a signup confirmation, email change or phone change email to the user.
     * - Passwordless sign-ins can be resent by calling the `signInWithOtp()` method again.
     * - Password recovery emails can be resent by calling the `resetPasswordForEmail()` method again.
     * - This method will only resend an email or phone OTP to the user if there was an initial signup, email change or phone change request being made(note: For existing users signing in with OTP, you should use `signInWithOtp()` again to resend the OTP).
     * - You can specify a redirect url when you resend an email link using the `emailRedirectTo` option.
     *
     * @exampleDescription Resend an email signup confirmation
     * Resends the email signup confirmation to the user
     *
     * @example Resend an email signup confirmation
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'signup',
     *   email: 'email@example.com',
     *   options: {
     *     emailRedirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleDescription Resend a phone signup confirmation
     * Resends the phone signup confirmation email to the user
     *
     * @example Resend a phone signup confirmation
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'sms',
     *   phone: '1234567890'
     * })
     * ```
     *
     * @exampleDescription Resend email change email
     * Resends the email change email to the user
     *
     * @example Resend email change email
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'email_change',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @exampleDescription Resend phone change OTP
     * Resends the phone change OTP to the user
     *
     * @example Resend phone change OTP
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'phone_change',
     *   phone: '1234567890'
     * })
     * ```
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $eiAXc.AuthInvalidCredentialsError)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     *
     * @category Auth
     *
     * @remarks
     * - Since the introduction of [asymmetric JWT signing keys](/docs/guides/auth/signing-keys), this method is considered low-level and we encourage you to use `getClaims()` or `getUser()` instead.
     * - Retrieves the current [user session](/docs/guides/auth/sessions) from the storage medium (local storage, cookies).
     * - The session contains an access token (signed JWT), a refresh token and the user object.
     * - If the session's access token is expired or is about to expire, this method will use the refresh token to refresh the session.
     * - When using in a browser, or you've called `startAutoRefresh()` in your environment (React Native, etc.) this function always returns a valid access token without refreshing the session itself, as this is done in the background. This function returns very fast.
     * - **IMPORTANT SECURITY NOTICE:** If using an insecure storage medium, such as cookies or request headers, the user object returned by this function **must not be trusted**. Always verify the JWT using `getClaims()` or your own JWT verification library to securely establish the user's identity and access. You can also use `getUser()` to fetch the user object directly from the Auth server for this purpose.
     * - When using in a browser, this function is synchronized across all tabs using the [LockManager](https://developer.mozilla.org/en-US/docs/Web/API/LockManager) API. In other environments make sure you've defined a proper `lock` property, if necessary, to make sure there are no race conditions while the session is being refreshed.
     *
     * @example Get the session data
     * ```js
     * const { data, error } = await supabase.auth.getSession()
     * ```
     *
     * @exampleResponse Get the session data
     * ```json
     * {
     *   "data": {
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $hQAY4.getItemAsync)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $5MFcL.EXPIRY_MARGIN_MS) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.userStorage) {
                    const maybeUser = await (0, $hQAY4.getItemAsync)(this.userStorage, this.storageKey + '-user');
                    if (maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) currentSession.user = maybeUser.user;
                    else currentSession.user = (0, $hQAY4.userNotAvailableProxy)();
                }
                // Wrap the user object with a warning proxy on the server
                // This warns when properties of the user are accessed, not when session.user itself is accessed
                if (this.storage.isServer && currentSession.user && !currentSession.user.__isUserNotAvailableProxy) {
                    const suppressWarningRef = {
                        value: this.suppressGetSessionWarning
                    };
                    currentSession.user = (0, $hQAY4.insecureUserWarningProxy)(currentSession.user, suppressWarningRef);
                    // Update the client-level suppression flag when the proxy suppresses the warning
                    if (suppressWarningRef.value) this.suppressGetSessionWarning = true;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return this._returnResult({
                data: {
                    session: null
                },
                error: error
            });
            return this._returnResult({
                data: {
                    session: session
                },
                error: null
            });
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     *
     * @category Auth
     *
     * @remarks
     * - This method fetches the user object from the database instead of local session.
     * - This method is useful for checking if the user is authorized because it validates the user's access token JWT on the server.
     * - Should always be used when checking for user authorization on the server. On the client, you can instead use `getSession().session.user` for faster results. `getSession` is insecure on the server.
     *
     * @example Get the logged in user with the current existing session
     * ```js
     * const { data: { user } } = await supabase.auth.getUser()
     * ```
     *
     * @exampleResponse Get the logged in user with the current existing session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Get the logged in user with a custom access token jwt
     * ```js
     * const { data: { user } } = await supabase.auth.getUser(jwt)
     * ```
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._getUser();
        });
        if (result.data.user) this.suppressGetSessionWarning = true;
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $1iZkC._userResponse)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                };
                return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $1iZkC._userResponse)
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) {
                if ((0, $eiAXc.isAuthSessionMissingError)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return this._returnResult({
                    data: {
                        user: null
                    },
                    error: error
                });
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     *
     * @category Auth
     *
     * @remarks
     * - In order to use the `updateUser()` method, the user needs to be signed in first.
     * - By default, email updates sends a confirmation link to both the user's current and new email.
     * To only send a confirmation link to the user's new email, disable **Secure email change** in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
     *
     * @exampleDescription Update the email for an authenticated user
     * Sends a "Confirm Email Change" email to the new address. If **Secure Email Change** is enabled (default), confirmation is also required from the **old email** before the change is applied. To skip dual confirmation and apply the change after only the new email is verified, disable **Secure Email Change** in the [Email Auth Provider settings](/dashboard/project/_/auth/providers?provider=Email).
     *
     * @example Update the email for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   email: 'new@email.com'
     * })
     * ```
     *
     * @exampleResponse Update the email for an authenticated user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "new_email": "new@email.com",
     *       "email_change_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @exampleDescription Update the phone number for an authenticated user
     * Sends a one-time password (OTP) to the new phone number.
     *
     * @example Update the phone number for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   phone: '123456789'
     * })
     * ```
     *
     * @example Update the password for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: 'new password'
     * })
     * ```
     *
     * @exampleDescription Update the user's metadata
     * Updates the user's custom metadata.
     *
     * **Note**: The `data` field maps to the `auth.users.raw_user_meta_data` column in your Supabase database. When calling `getUser()`, the data will be available as `user.user_metadata`.
     *
     * @example Update the user's metadata
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   data: { hello: 'world' }
     * })
     * ```
     *
     * @exampleDescription Update the user's password with a nonce
     * If **Secure password change** is enabled in your [project's email provider settings](/dashboard/project/_/auth/providers), updating the user's password would require a nonce if the user **hasn't recently signed in**. The nonce is sent to the user's email or phone number. A user is deemed recently signed in if the session was created in the last 24 hours.
     *
     * @example Update the user's password with a nonce
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: 'new password',
     *   nonce: '123456'
     * })
     * ```
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $eiAXc.AuthSessionMissingError)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $hQAY4.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $1iZkC._request)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $1iZkC._userResponse)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return this._returnResult({
                    data: {
                        user: session.user
                    },
                    error: null
                });
            });
        } catch (error) {
            await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     *
     * @category Auth
     *
     * @remarks
     * - This method sets the session using an `access_token` and `refresh_token`.
     * - If successful, a `SIGNED_IN` event is emitted.
     *
     * @exampleDescription Set the session
     * Sets the session data from an access_token and refresh_token, then returns an auth response or error.
     *
     * @example Set the session
     * ```js
     *   const { data, error } = await supabase.auth.setSession({
     *     access_token,
     *     refresh_token
     *   })
     * ```
     *
     * @exampleResponse Set the session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "11111111-1111-1111-1111-111111111111",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "2024-01-01T00:00:00Z",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       },
     *       "token_type": "bearer",
     *       "expires_in": 3500,
     *       "expires_at": 1700000000
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $eiAXc.AuthSessionMissingError)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $hQAY4.decodeJWT)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { data: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     *
     * @category Auth
     *
     * @remarks
     * - This method will refresh and return a new session whether the current one is expired or not.
     *
     * @example Refresh session using the current session
     * ```js
     * const { data, error } = await supabase.auth.refreshSession()
     * const { session, user } = data
     * ```
     *
     * @exampleResponse Refresh session using the current session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Refresh session using a refresh token
     * ```js
     * const { data, error } = await supabase.auth.refreshSession({ refresh_token })
     * const { session, user } = data
     * ```
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $eiAXc.AuthSessionMissingError)();
                const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!session) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                });
                return this._returnResult({
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        var _a;
        try {
            if (!(0, $hQAY4.isBrowser)()) throw new (0, $eiAXc.AuthImplicitGrantRedirectError)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $eiAXc.AuthImplicitGrantRedirectError)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $eiAXc.AuthPKCEGrantCodeExchangeError)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $eiAXc.AuthImplicitGrantRedirectError)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $eiAXc.AuthPKCEGrantCodeExchangeError)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: (_a = data.redirectType) !== null && _a !== void 0 ? _a : null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $eiAXc.AuthImplicitGrantRedirectError)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $5MFcL.AUTO_REFRESH_TICK_DURATION_MS)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return this._returnResult({
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     *
     * If `detectSessionInUrl` is a function, it will be called with the URL and params to determine
     * if the URL should be processed as a Supabase auth callback. This allows users to exclude
     * URLs from other OAuth providers (e.g., Facebook Login) that also return access_token in the fragment.
     */ _isImplicitGrantCallback(params) {
        if (typeof this.detectSessionInUrl === 'function') return this.detectSessionInUrl(new URL(window.location.href), params);
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $hQAY4.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     *
     * **Warning:** the default `scope` is `'global'`. This signs the user out of
     * **every device they are currently signed in on**, not just the current
     * tab/session. If you only want to sign the user out of the current session
     * (the behavior most other auth libraries default to), pass
     * `{ scope: 'local' }` explicitly.
     *
     * @category Auth
     *
     * @remarks
     * - In order to use the `signOut()` method, the user needs to be signed in first.
     * - By default, `signOut()` uses the **global** scope, which signs out the user
     *   on every device they are signed in on (not just the current one). Pass
     *   `{ scope: 'local' }` to only sign out the current session. This is
     *   usually what apps want on a "Sign out" button, especially when users
     *   sign in from multiple devices and do not expect signing out of one to
     *   terminate the others.
     * - Since Supabase Auth uses JWTs for authentication, the access token JWT will be valid until it's expired. When the user signs out, Supabase revokes the refresh token and deletes the JWT from the client-side. This does not revoke the JWT and it will still be valid until it expires.
     *
     * @example Sign out of every device (global – default)
     * ```js
     * const { error } = await supabase.auth.signOut()
     * ```
     *
     * @example Sign out only the current session (recommended for most apps)
     * ```js
     * const { error } = await supabase.auth.signOut({ scope: 'local' })
     * ```
     *
     * @example Sign out of all other sessions, keep the current one
     * ```js
     * const { error } = await supabase.auth.signOut({ scope: 'others' })
     * ```
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError && !(0, $eiAXc.isAuthSessionMissingError)(sessionError)) return this._returnResult({
                error: sessionError
            });
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $eiAXc.isAuthApiError)(error) && (error.status === 404 || error.status === 401 || error.status === 403) || (0, $eiAXc.isAuthSessionMissingError)(error))) return this._returnResult({
                        error: error
                    });
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return this._returnResult({
                error: null
            });
        });
    }
    /**  *
     * @category Auth
     *
     * @remarks
     * - Subscribes to important events occurring on the user's session.
     * - Use on the frontend/client. It is less useful on the server.
     * - Events are emitted across tabs to keep your application's UI up-to-date. Some events can fire very frequently, based on the number of tabs open. Use a quick and efficient callback function, and defer or debounce as many operations as you can to be performed outside of the callback.
     * - **Important:** A callback can be an `async` function and it runs synchronously during the processing of the changes causing the event. You can easily create a dead-lock by using `await` on a call to another method of the Supabase library.
     *   - Avoid using `async` functions as callbacks.
     *   - Limit the number of `await` calls in `async` callbacks.
     *   - Do not use other Supabase functions in the callback function. If you must, dispatch the functions once the callback has finished executing. Use this as a quick way to achieve this:
     *     ```js
     *     supabase.auth.onAuthStateChange((event, session) => {
     *       setTimeout(async () => {
     *         // await on other Supabase function here
     *         // this runs right after the callback has finished
     *       }, 0)
     *     })
     *     ```
     * - Emitted events:
     *   - `INITIAL_SESSION`
     *     - Emitted right after the Supabase client is constructed and the initial session from storage is loaded.
     *   - `SIGNED_IN`
     *     - Emitted each time a user session is confirmed or re-established, including on user sign in and when refocusing a tab.
     *     - Avoid making assumptions as to when this event is fired, this may occur even when the user is already signed in. Instead, check the user object attached to the event to see if a new user has signed in and update your application's UI.
     *     - This event can fire very frequently depending on the number of tabs open in your application.
     *   - `SIGNED_OUT`
     *     - Emitted when the user signs out. This can be after:
     *       - A call to `supabase.auth.signOut()`.
     *       - After the user's session has expired for any reason:
     *         - User has signed out on another device.
     *         - The session has reached its timebox limit or inactivity timeout.
     *         - User has signed in on another device with single session per user enabled.
     *         - Check the [User Sessions](/docs/guides/auth/sessions) docs for more information.
     *     - Use this to clean up any local storage your application has associated with the user.
     *   - `TOKEN_REFRESHED`
     *     - Emitted each time a new access and refresh token are fetched for the signed in user.
     *     - It's best practice and highly recommended to extract the access token (JWT) and store it in memory for further use in your application.
     *       - Avoid frequent calls to `supabase.auth.getSession()` for the same purpose.
     *     - There is a background process that keeps track of when the session should be refreshed so you will always receive valid tokens by listening to this event.
     *     - The frequency of this event is related to the JWT expiry limit configured on your project.
     *   - `USER_UPDATED`
     *     - Emitted each time the `supabase.auth.updateUser()` method finishes successfully. Listen to it to update your application's UI based on new profile information.
     *   - `PASSWORD_RECOVERY`
     *     - Emitted instead of the `SIGNED_IN` event when the user lands on a page that includes a password recovery link in the URL.
     *     - Use it to show a UI to the user where they can [reset their password](/docs/guides/auth/passwords#resetting-a-users-password-forgot-password).
     *
     * @example Listen to auth changes
     * ```js
     * const { data } = supabase.auth.onAuthStateChange((event, session) => {
     *   console.log(event, session)
     *
     *   if (event === 'INITIAL_SESSION') {
     *     // handle initial session
     *   } else if (event === 'SIGNED_IN') {
     *     // handle sign in event
     *   } else if (event === 'SIGNED_OUT') {
     *     // handle sign out event
     *   } else if (event === 'PASSWORD_RECOVERY') {
     *     // handle password recovery event
     *   } else if (event === 'TOKEN_REFRESHED') {
     *     // handle token refreshed event
     *   } else if (event === 'USER_UPDATED') {
     *     // handle user updated event
     *   }
     * })
     *
     * // call unsubscribe to remove the callback
     * data.subscription.unsubscribe()
     * ```
     *
     * @exampleDescription Listen to sign out
     * Make sure you clear out any local data, such as local and session storage, after the client library has detected the user's sign out.
     *
     * @example Listen to sign out
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'SIGNED_OUT') {
     *     console.log('SIGNED_OUT', session)
     *
     *     // clear local and session storage
     *     [
     *       window.localStorage,
     *       window.sessionStorage,
     *     ].forEach((storage) => {
     *       Object.entries(storage)
     *         .forEach(([key]) => {
     *           storage.removeItem(key)
     *         })
     *     })
     *   }
     * })
     * ```
     *
     * @exampleDescription Store OAuth provider tokens on sign in
     * When using [OAuth (Social Login)](/docs/guides/auth/social-login) you sometimes wish to get access to the provider's access token and refresh token, in order to call provider APIs in the name of the user.
     *
     * For example, if you are using [Sign in with Google](/docs/guides/auth/social-login/auth-google) you may want to use the provider token to call Google APIs on behalf of the user. Supabase Auth does not keep track of the provider access and refresh token, but does return them for you once, immediately after sign in. You can use the `onAuthStateChange` method to listen for the presence of the provider tokens and store them in local storage. You can further send them to your server's APIs for use on the backend.
     *
     * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
     *
     * @example Store OAuth provider tokens on sign in
     * ```js
     * // Register this immediately after calling createClient!
     * // Because signInWithOAuth causes a redirect, you need to fetch the
     * // provider tokens from the callback.
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (session && session.provider_token) {
     *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
     *   }
     *
     *   if (session && session.provider_refresh_token) {
     *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
     *   }
     *
     *   if (event === 'SIGNED_OUT') {
     *     window.localStorage.removeItem('oauth_provider_token')
     *     window.localStorage.removeItem('oauth_provider_refresh_token')
     *   }
     * })
     * ```
     *
     * @exampleDescription Use React Context for the User's session
     * Instead of relying on `supabase.auth.getSession()` within your React components, you can use a [React Context](https://react.dev/reference/react/createContext) to store the latest session information from the `onAuthStateChange` callback and access it that way.
     *
     * @example Use React Context for the User's session
     * ```js
     * const SessionContext = React.createContext(null)
     *
     * function main() {
     *   const [session, setSession] = React.useState(null)
     *
     *   React.useEffect(() => {
     *     const {data: { subscription }} = supabase.auth.onAuthStateChange(
     *       (event, session) => {
     *         if (event === 'SIGNED_OUT') {
     *           setSession(null)
     *         } else if (session) {
     *           setSession(session)
     *         }
     *       })
     *
     *     return () => {
     *       subscription.unsubscribe()
     *     }
     *   }, [])
     *
     *   return (
     *     <SessionContext.Provider value={session}>
     *       <App />
     *     </SessionContext.Provider>
     *   )
     * }
     * ```
     *
     * @example Listen to password recovery events
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'PASSWORD_RECOVERY') {
     *     console.log('PASSWORD_RECOVERY', session)
     *     // show screen to update user's password
     *     showPasswordResetScreen(true)
     *   }
     * })
     * ```
     *
     * @example Listen to sign in
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'SIGNED_IN') console.log('SIGNED_IN', session)
     * })
     * ```
     *
     * @example Listen to token refresh
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'TOKEN_REFRESHED') console.log('TOKEN_REFRESHED', session)
     * })
     * ```
     *
     * @example Listen to user updates
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'USER_UPDATED') console.log('USER_UPDATED', session)
     * })
     * ```
     */ onAuthStateChange(callback) {
        const id = (0, $hQAY4.generateCallbackId)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                if ((0, $eiAXc.isAuthSessionMissingError)(err)) console.warn(err);
                else console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     *
     * @category Auth
     *
     * @remarks
     * - The password reset flow consist of 2 broad steps: (i) Allow the user to login via the password reset link; (ii) Update the user's password.
     * - The `resetPasswordForEmail()` only sends a password reset link to the user's email.
     * To update the user's password, see [`updateUser()`](/docs/reference/javascript/auth-updateuser).
     * - A `PASSWORD_RECOVERY` event will be emitted when the password recovery link is clicked.
     * You can use [`onAuthStateChange()`](/docs/reference/javascript/auth-onauthstatechange) to listen and invoke a callback function on these events.
     * - When the user clicks the reset link in the email they are redirected back to your application.
     * You can configure the URL that the user is redirected to with the `redirectTo` parameter.
     * See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     * - After the user has been redirected successfully, prompt them for a new password and call `updateUser()`:
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: new_password
     * })
     * ```
     *
     * @example Reset password
     * ```js
     * const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
     *   redirectTo: 'https://example.com/update-password',
     * })
     * ```
     *
     * @exampleResponse Reset password
     * ```json
     * {
     *   data: {}
     *   error: null
     * }
     * ```
     *
     * @example Reset password (React)
     * ```js
     * /**
     *  * Step 1: Send the user an email to get a password reset token.
     *  * This email contains a link which sends the user back to your application.
     *  *\/
     * const { data, error } = await supabase.auth
     *   .resetPasswordForEmail('user@email.com')
     *
     * /**
     *  * Step 2: Once the user is redirected back to your application,
     *  * ask the user to reset their password.
     *  *\/
     *  useEffect(() => {
     *    supabase.auth.onAuthStateChange(async (event, session) => {
     *      if (event == "PASSWORD_RECOVERY") {
     *        const newPassword = prompt("What would you like your new password to be?");
     *        const { data, error } = await supabase.auth
     *          .updateUser({ password: newPassword })
     *
     *        if (data) alert("Password updated successfully!")
     *        if (error) alert("There was an error updating your password.")
     *      }
     *    })
     *  }, [])
     * ```
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $hQAY4.getCodeChallengeAndMethod)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     *
     * @category Auth
     *
     * @remarks
     * - The user needs to be signed in to call `getUserIdentities()`.
     *
     * @example Returns a list of identities linked to the user
     * ```js
     * const { data, error } = await supabase.auth.getUserIdentities()
     * ```
     *
     * @exampleResponse Returns a list of identities linked to the user
     * ```json
     * {
     *   "data": {
     *     "identities": [
     *       {
     *         "identity_id": "22222222-2222-2222-2222-222222222222",
     *         "id": "2024-01-01T00:00:00Z",
     *         "user_id": "2024-01-01T00:00:00Z",
     *         "identity_data": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "provider": "email",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "email": "example@email.com"
     *       }
     *     ]
     *   },
     *   "error": null
     * }
     * ```
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return this._returnResult({
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**  *
     * @category Auth
     *
     * @remarks
     * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
     * - The user needs to be signed in to call `linkIdentity()`.
     * - If the candidate identity is already linked to the existing user or another user, `linkIdentity()` will fail.
     * - If `linkIdentity` is run in the browser, the user is automatically redirected to the returned URL. On the server, you should handle the redirect.
     *
     * @example Link an identity to a user
     * ```js
     * const { data, error } = await supabase.auth.linkIdentity({
     *   provider: 'github'
     * })
     * ```
     *
     * @exampleResponse Link an identity to a user
     * ```json
     * {
     *   data: {
     *     provider: 'github',
     *     url: <PROVIDER_URL_TO_REDIRECT_TO>
     *   },
     *   error: null
     * }
     * ```
     */ async linkIdentity(credentials) {
        if ('token' in credentials) return this.linkIdentityIdToken(credentials);
        return this.linkIdentityOAuth(credentials);
    }
    async linkIdentityOAuth(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $1iZkC._request)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $hQAY4.isBrowser)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            });
            throw error;
        }
    }
    async linkIdentityIdToken(credentials) {
        return await this._useSession(async (result)=>{
            var _a;
            try {
                const { error: sessionError, data: { session: session } } = result;
                if (sessionError) throw sessionError;
                const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
                const res = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                    headers: this.headers,
                    jwt: (_a = session === null || session === void 0 ? void 0 : session.access_token) !== null && _a !== void 0 ? _a : undefined,
                    body: {
                        provider: provider,
                        id_token: token,
                        access_token: access_token,
                        nonce: nonce,
                        link_identity: true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $1iZkC._sessionResponse)
                });
                const { data: data, error: error } = res;
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                else if (!data || !data.session || !data.user) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: new (0, $eiAXc.AuthInvalidTokenResponseError)()
                });
                if (data.session) {
                    await this._saveSession(data.session);
                    await this._notifyAllSubscribers('USER_UPDATED', data.session);
                }
                return this._returnResult({
                    data: data,
                    error: error
                });
            } catch (error) {
                await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     *
     * @category Auth
     *
     * @remarks
     * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
     * - The user needs to be signed in to call `unlinkIdentity()`.
     * - The user must have at least 2 identities in order to unlink an identity.
     * - The identity to be unlinked must belong to the user.
     *
     * @example Unlink an identity
     * ```js
     * // retrieve all identities linked to a user
     * const identities = await supabase.auth.getUserIdentities()
     *
     * // find the google identity
     * const googleIdentity = identities.find(
     *   identity => identity.provider === 'google'
     * )
     *
     * // unlink the google identity
     * const { error } = await supabase.auth.unlinkIdentity(googleIdentity)
     * ```
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $hQAY4.retryable)(async (attempt)=>{
                if (attempt > 0) await (0, $hQAY4.sleep)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $1iZkC._sessionResponse)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $eiAXc.isAuthRetryableFetchError)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $5MFcL.AUTO_REFRESH_TICK_DURATION_MS);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $hQAY4.isBrowser)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a, _b;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $hQAY4.getItemAsync)(this.storage, this.storageKey);
            if (currentSession && this.userStorage) {
                let maybeUser = await (0, $hQAY4.getItemAsync)(this.userStorage, this.storageKey + '-user');
                if (!this.storage.isServer && Object.is(this.storage, this.userStorage) && !maybeUser) {
                    // storage and userStorage are the same storage medium, for example
                    // window.localStorage if userStorage does not have the user from
                    // storage stored, store it first thereby migrating the user object
                    // from storage -> userStorage
                    maybeUser = {
                        user: currentSession.user
                    };
                    await (0, $hQAY4.setItemAsync)(this.userStorage, this.storageKey + '-user', maybeUser);
                }
                currentSession.user = (_a = maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) !== null && _a !== void 0 ? _a : (0, $hQAY4.userNotAvailableProxy)();
            } else if (currentSession && !currentSession.user) // user storage is not set, let's check if it was previously enabled so
            // we bring back the storage as it should be
            {
                if (!currentSession.user) {
                    // test if userStorage was previously enabled and the storage medium was the same, to move the user back under the same key
                    const separateUser = await (0, $hQAY4.getItemAsync)(this.storage, this.storageKey + '-user');
                    if (separateUser && (separateUser === null || separateUser === void 0 ? void 0 : separateUser.user)) {
                        currentSession.user = separateUser.user;
                        await (0, $hQAY4.removeItemAsync)(this.storage, this.storageKey + '-user');
                        await (0, $hQAY4.setItemAsync)(this.storage, this.storageKey, currentSession);
                    } else currentSession.user = (0, $hQAY4.userNotAvailableProxy)();
                }
            }
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_b = currentSession.expires_at) !== null && _b !== void 0 ? _b : Infinity) * 1000 - Date.now() < (0, $5MFcL.EXPIRY_MARGIN_MS);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $5MFcL.EXPIRY_MARGIN_MS)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $eiAXc.isAuthRetryableFetchError)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else if (currentSession.user && currentSession.user.__isUserNotAvailableProxy === true) // If we have a proxy user, try to get the real user data
            try {
                const { data: data, error: userError } = await this._getUser(currentSession.access_token);
                if (!userError && (data === null || data === void 0 ? void 0 : data.user)) {
                    currentSession.user = data.user;
                    await this._saveSession(currentSession);
                    await this._notifyAllSubscribers('SIGNED_IN', currentSession);
                } else this._debug(debugName, 'could not get user data, skipping SIGNED_IN notification');
            } catch (getUserError) {
                console.error('Error getting user data:', getUserError);
                this._debug(debugName, 'error getting user data, skipping SIGNED_IN notification', getUserError);
            }
            else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $eiAXc.AuthSessionMissingError)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $hQAY4.Deferred)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $eiAXc.AuthSessionMissingError)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                data: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $eiAXc.isAuthError)(error)) {
                const result = {
                    data: null,
                    error: error
                };
                if (!(0, $eiAXc.isAuthRetryableFetchError)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $hQAY4.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        // Create a shallow copy to work with, to avoid mutating the original session object if it's used elsewhere
        const sessionToProcess = Object.assign({}, session);
        const userIsProxy = sessionToProcess.user && sessionToProcess.user.__isUserNotAvailableProxy === true;
        if (this.userStorage) {
            if (!userIsProxy && sessionToProcess.user) // If it's a real user object, save it to userStorage.
            await (0, $hQAY4.setItemAsync)(this.userStorage, this.storageKey + '-user', {
                user: sessionToProcess.user
            });
            else userIsProxy;
            // Prepare the main session data for primary storage: remove the user property before cloning
            // This is important because the original session.user might be the proxy
            const mainSessionData = Object.assign({}, sessionToProcess);
            delete mainSessionData.user; // Remove user (real or proxy) before cloning for main storage
            const clonedMainSessionData = (0, $hQAY4.deepClone)(mainSessionData);
            await (0, $hQAY4.setItemAsync)(this.storage, this.storageKey, clonedMainSessionData);
        } else {
            // No userStorage is configured.
            // In this case, session.user should ideally not be a proxy.
            // If it were, structuredClone would fail. This implies an issue elsewhere if user is a proxy here
            const clonedSession = (0, $hQAY4.deepClone)(sessionToProcess); // sessionToProcess still has its original user property
            await (0, $hQAY4.setItemAsync)(this.storage, this.storageKey, clonedSession);
        }
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        this.suppressGetSessionWarning = false;
        await (0, $hQAY4.removeItemAsync)(this.storage, this.storageKey);
        await (0, $hQAY4.removeItemAsync)(this.storage, this.storageKey + '-code-verifier');
        await (0, $hQAY4.removeItemAsync)(this.storage, this.storageKey + '-user');
        if (this.userStorage) await (0, $hQAY4.removeItemAsync)(this.userStorage, this.storageKey + '-user');
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $hQAY4.isBrowser)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $5MFcL.AUTO_REFRESH_TICK_DURATION_MS));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        const timeout = setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
        this.autoRefreshTickTimeout = timeout;
        if (timeout && typeof timeout === 'object' && typeof timeout.unref === 'function') timeout.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(timeout);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
        const timeout = this.autoRefreshTickTimeout;
        this.autoRefreshTickTimeout = null;
        if (timeout) clearTimeout(timeout);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     *
     * @category Auth
     *
     * @remarks
     * - Only useful in non-browser environments such as React Native or Electron.
     * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
     * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
     * - To give this hint to the application, you should be calling this method when the app is in focus and calling `supabase.auth.stopAutoRefresh()` when it's out of focus.
     *
     * @example Start and stop auto refresh in React Native
     * ```js
     * import { AppState } from 'react-native'
     *
     * // make sure you register this only once!
     * AppState.addEventListener('change', (state) => {
     *   if (state === 'active') {
     *     supabase.auth.startAutoRefresh()
     *   } else {
     *     supabase.auth.stopAutoRefresh()
     *   }
     * })
     * ```
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     *
     * @category Auth
     *
     * @remarks
     * - Only useful in non-browser environments such as React Native or Electron.
     * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
     * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
     * - When your application goes in the background or out of focus, call this method to stop the proactive refreshing of the session.
     *
     * @example Start and stop auto refresh in React Native
     * ```js
     * import { AppState } from 'react-native'
     *
     * // make sure you register this only once!
     * AppState.addEventListener('change', (state) => {
     *   if (state === 'active') {
     *     supabase.auth.startAutoRefresh()
     *   } else {
     *     supabase.auth.stopAutoRefresh()
     *   }
     * })
     * ```
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $5MFcL.AUTO_REFRESH_TICK_DURATION_MS));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $5MFcL.AUTO_REFRESH_TICK_DURATION_MS)}ms, refresh threshold is ${(0, $5MFcL.AUTO_REFRESH_TICK_THRESHOLD)} ticks`);
                            if (expiresInTicks <= (0, $5MFcL.AUTO_REFRESH_TICK_THRESHOLD)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $0qGFG.LockAcquireTimeoutError)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $hQAY4.isBrowser)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>{
                try {
                    await this._onVisibilityChanged(false);
                } catch (error) {
                    this._debug('#visibilityChangedCallback', 'error', error);
                }
            };
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $hQAY4.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                return await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : params.factorType === 'totp' ? {
                    issuer: params.issuer
                } : {});
                const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                if (params.factorType === 'totp' && data.type === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _verify(params) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const body = Object.assign({
                        challenge_id: params.challengeId
                    }, 'webauthn' in params ? {
                        webauthn: Object.assign(Object.assign({}, params.webauthn), {
                            credential_response: params.webauthn.type === 'create' ? (0, $bJWBJ.serializeCredentialCreationResponse)(params.webauthn.credential_response) : (0, $bJWBJ.serializeCredentialRequestResponse)(params.webauthn.credential_response)
                        })
                    } : {
                        code: params.code
                    });
                    const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: body,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return this._returnResult({
                        data: null,
                        error: error
                    });
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return this._returnResult({
                        data: data,
                        error: error
                    });
                });
            } catch (error) {
                if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    async _challenge(params) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const response = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: params,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (response.error) return response;
                    const { data: data } = response;
                    if (data.type !== 'webauthn') return {
                        data: data,
                        error: null
                    };
                    switch(data.webauthn.type){
                        case 'create':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $bJWBJ.deserializeCredentialCreationOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                        case 'request':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $bJWBJ.deserializeCredentialRequestOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                    }
                });
            } catch (error) {
                if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return this._returnResult({
            data: null,
            error: challengeError
        });
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        var _a;
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const data = {
            all: [],
            phone: [],
            totp: [],
            webauthn: []
        };
        // loop over the factors ONCE
        for (const factor of (_a = user === null || user === void 0 ? void 0 : user.factors) !== null && _a !== void 0 ? _a : []){
            data.all.push(factor);
            if (factor.status === 'verified') data[factor.factor_type].push(factor);
        }
        return {
            data: data,
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel(jwt) {
        var _a, _b, _c, _d;
        if (jwt) try {
            const { payload: payload } = (0, $hQAY4.decodeJWT)(jwt);
            let currentLevel = null;
            if (payload.aal) currentLevel = payload.aal;
            let nextLevel = currentLevel;
            const { data: { user: user }, error: userError } = await this.getUser(jwt);
            if (userError) return this._returnResult({
                data: null,
                error: userError
            });
            const verifiedFactors = (_b = (_a = user === null || user === void 0 ? void 0 : user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
            if (verifiedFactors.length > 0) nextLevel = 'aal2';
            const currentAuthenticationMethods = payload.amr || [];
            return {
                data: {
                    currentLevel: currentLevel,
                    nextLevel: nextLevel,
                    currentAuthenticationMethods: currentAuthenticationMethods
                },
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
        const { data: { session: session }, error: sessionError } = await this.getSession();
        if (sessionError) return this._returnResult({
            data: null,
            error: sessionError
        });
        if (!session) return {
            data: {
                currentLevel: null,
                nextLevel: null,
                currentAuthenticationMethods: []
            },
            error: null
        };
        const { payload: payload } = (0, $hQAY4.decodeJWT)(session.access_token);
        let currentLevel = null;
        if (payload.aal) currentLevel = payload.aal;
        let nextLevel = currentLevel;
        const verifiedFactors = (_d = (_c = session.user.factors) === null || _c === void 0 ? void 0 : _c.filter((factor)=>factor.status === 'verified')) !== null && _d !== void 0 ? _d : [];
        if (verifiedFactors.length > 0) nextLevel = 'aal2';
        const currentAuthenticationMethods = payload.amr || [];
        return {
            data: {
                currentLevel: currentLevel,
                nextLevel: nextLevel,
                currentAuthenticationMethods: currentAuthenticationMethods
            },
            error: null
        };
    }
    /**
     * Retrieves details about an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * Returns authorization details including client info, scopes, and user information.
     * If the response includes only a redirect_url field, it means consent was already given - the caller
     * should handle the redirect manually if needed.
     */ async _getAuthorizationDetails(authorizationId) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/oauth/authorizations/${authorizationId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Approves an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _approveAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                const response = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'approve'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $hQAY4.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Denies an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _denyAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                const response = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'deny'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $hQAY4.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Lists all OAuth grants that the authenticated user has authorized.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _listOAuthGrants() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                return await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Revokes a user's OAuth grant for a specific client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _revokeOAuthGrant(options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    query: {
                        client_id: options.clientId
                    },
                    noResolveJson: true
                });
                return {
                    data: {},
                    error: null
                };
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        const now = Date.now();
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $5MFcL.JWKS_TTL) > now) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) return null;
        this.jwks = data;
        this.jwks_cached_at = now;
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) return null;
        return jwk;
    }
    /**
     * Extracts the JWT claims present in the access token by first verifying the
     * JWT against the server's JSON Web Key Set endpoint
     * `/.well-known/jwks.json` which is often cached, resulting in significantly
     * faster responses. Prefer this method over {@link #getUser} which always
     * sends a request to the Auth server for each JWT.
     *
     * If the project is not using an asymmetric JWT signing key (like ECC or
     * RSA) it always sends a request to the Auth server (similar to {@link
     * #getUser}) to verify the JWT.
     *
     * @param jwt An optional specific JWT you wish to verify, not the one you
     *            can obtain from {@link #getSession}.
     * @param options Various additional options that allow you to customize the
     *                behavior of this method.
     *
     * @category Auth
     *
     * @remarks
     * - Parses the user's [access token](/docs/guides/auth/sessions#access-token-jwt-claims) as a [JSON Web Token (JWT)](/docs/guides/auth/jwts) and returns its components if valid and not expired.
     * - If your project is using asymmetric JWT signing keys, then the verification is done locally usually without a network request using the [WebCrypto API](https://developer.mozilla.org/en-US/docs/Web/API/Web_Crypto_API).
     * - A network request is sent to your project's JWT signing key discovery endpoint `https://project-id.supabase.co/auth/v1/.well-known/jwks.json`, which is cached locally. If your environment is ephemeral, such as a Lambda function that is destroyed after every request, a network request will be sent for each new invocation. Supabase provides a network-edge cache providing fast responses for these situations.
     * - If the user's access token is about to expire when calling this function, the user's session will first be refreshed before validating the JWT.
     * - If your project is using a symmetric secret to sign the JWT, it always sends a request similar to `getUser()` to validate the JWT at the server before returning the decoded token. This is also used if the WebCrypto API is not available in the environment. Make sure you polyfill it in such situations.
     * - The returned claims can be customized per project using the [Custom Access Token Hook](/docs/guides/auth/auth-hooks/custom-access-token-hook).
     *
     * @example Get JWT claims, header and signature
     * ```js
     * const { data, error } = await supabase.auth.getClaims()
     * ```
     *
     * @exampleResponse Get JWT claims, header and signature
     * ```json
     * {
     *   "data": {
     *     "claims": {
     *       "aal": "aal1",
     *       "amr": [{
     *         "method": "email",
     *         "timestamp": 1715766000
     *       }],
     *       "app_metadata": {},
     *       "aud": "authenticated",
     *       "email": "example@email.com",
     *       "exp": 1715769600,
     *       "iat": 1715766000,
     *       "is_anonymous": false,
     *       "iss": "https://project-id.supabase.co/auth/v1",
     *       "phone": "+13334445555",
     *       "role": "authenticated",
     *       "session_id": "11111111-1111-1111-1111-111111111111",
     *       "sub": "11111111-1111-1111-1111-111111111111",
     *       "user_metadata": {}
     *     },
     *     "header": {
     *       "alg": "RS256",
     *       "typ": "JWT",
     *       "kid": "11111111-1111-1111-1111-111111111111"
     *     },
     *     "signature": [/** Uint8Array *\/],
     *   },
     *   "error": null
     * }
     * ```
     */ async getClaims(jwt, options = {}) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return this._returnResult({
                    data: null,
                    error: error
                });
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $hQAY4.decodeJWT)(token);
            if (!(options === null || options === void 0 ? void 0 : options.allowExpired)) // Reject expired JWTs should only happen if jwt argument was passed
            (0, $hQAY4.validateExp)(payload.exp);
            const signingKey = !header.alg || header.alg.startsWith('HS') || !header.kid || !('crypto' in globalThis && 'subtle' in globalThis.crypto) ? null : await this.fetchJwk(header.kid, (options === null || options === void 0 ? void 0 : options.keys) ? {
                keys: options.keys
            } : options === null || options === void 0 ? void 0 : options.jwks);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!signingKey) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $hQAY4.getAlgorithm)(header.alg);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $iqwv8.stringToUint8Array)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $eiAXc.AuthInvalidJwtError)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    // --- Passkey Methods ---
    /**
     * Sign in with a passkey. Handles the full WebAuthn ceremony:
     * 1. Fetches authentication challenge from server
     * 2. Prompts user via navigator.credentials.get()
     * 3. Verifies credential with server and creates session
     *
     * Requires `auth.experimental.passkey: true`.
     */ async signInWithPasskey(credentials) {
        var _a, _b, _c;
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            if (!(0, $bJWBJ.browserSupportsWebAuthn)()) return this._returnResult({
                data: null,
                error: new (0, $eiAXc.AuthUnknownError)('Browser does not support WebAuthn', null)
            });
            // 1. Get challenge options from server
            const { data: options, error: optionsError } = await this._startPasskeyAuthentication({
                options: {
                    captchaToken: (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.captchaToken
                }
            });
            if (optionsError || !options) return this._returnResult({
                data: null,
                error: optionsError
            });
            // 2. Deserialize and prompt user via browser WebAuthn API
            const publicKeyOptions = (0, $bJWBJ.deserializeCredentialRequestOptions)(options.options);
            const signal = (_c = (_b = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _b === void 0 ? void 0 : _b.signal) !== null && _c !== void 0 ? _c : (0, $bJWBJ.webAuthnAbortService).createNewAbortSignal();
            const { data: credential, error: credentialError } = await (0, $bJWBJ.getCredential)({
                publicKey: publicKeyOptions,
                signal: signal
            });
            if (credentialError || !credential) return this._returnResult({
                data: null,
                error: credentialError !== null && credentialError !== void 0 ? credentialError : new (0, $eiAXc.AuthUnknownError)('WebAuthn ceremony failed', null)
            });
            // 3. Serialize and verify with server
            const serialized = (0, $bJWBJ.serializeCredentialRequestResponse)(credential);
            return this._verifyPasskeyAuthentication({
                challengeId: options.challenge_id,
                credential: serialized
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Register a passkey for the current authenticated user. Handles the full WebAuthn ceremony:
     * 1. Fetches registration challenge from server
     * 2. Prompts user via navigator.credentials.create()
     * 3. Verifies credential with server
     *
     * Requires an active session. Requires `auth.experimental.passkey: true`.
     */ async registerPasskey(credentials) {
        var _a, _b;
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            if (!(0, $bJWBJ.browserSupportsWebAuthn)()) return this._returnResult({
                data: null,
                error: new (0, $eiAXc.AuthUnknownError)('Browser does not support WebAuthn', null)
            });
            // 1. Get challenge options from server
            const { data: options, error: optionsError } = await this._startPasskeyRegistration();
            if (optionsError || !options) return this._returnResult({
                data: null,
                error: optionsError
            });
            // 2. Deserialize and prompt user via browser WebAuthn API
            const publicKeyOptions = (0, $bJWBJ.deserializeCredentialCreationOptions)(options.options);
            const signal = (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.signal) !== null && _b !== void 0 ? _b : (0, $bJWBJ.webAuthnAbortService).createNewAbortSignal();
            const { data: credential, error: credentialError } = await (0, $bJWBJ.createCredential)({
                publicKey: publicKeyOptions,
                signal: signal
            });
            if (credentialError || !credential) return this._returnResult({
                data: null,
                error: credentialError !== null && credentialError !== void 0 ? credentialError : new (0, $eiAXc.AuthUnknownError)('WebAuthn ceremony failed', null)
            });
            // 3. Serialize and verify with server
            const serialized = (0, $bJWBJ.serializeCredentialCreationResponse)(credential);
            return this._verifyPasskeyRegistration({
                challengeId: options.challenge_id,
                credential: serialized
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Start passkey registration for the current authenticated user.
     * Returns WebAuthn credential creation options to pass to navigator.credentials.create().
     */ async _startPasskeyRegistration() {
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/passkeys/registration/options`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {}
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Verify passkey registration with the credential response.
     * The credentialResponse should be the serialized output of navigator.credentials.create().
     */ async _verifyPasskeyRegistration(params) {
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/passkeys/registration/verify`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        challenge_id: params.challengeId,
                        credential: params.credential
                    }
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Start passkey authentication.
     * Returns WebAuthn credential request options to pass to navigator.credentials.get().
     */ async _startPasskeyAuthentication(params) {
        var _a;
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/passkeys/authentication/options`, {
                headers: this.headers,
                body: {
                    gotrue_meta_security: {
                        captcha_token: (_a = params === null || params === void 0 ? void 0 : params.options) === null || _a === void 0 ? void 0 : _a.captchaToken
                    }
                }
            });
            if (error) return this._returnResult({
                data: null,
                error: error
            });
            return this._returnResult({
                data: data,
                error: null
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Verify passkey authentication and create a session.
     * The credential should be the serialized output of navigator.credentials.get().
     */ async _verifyPasskeyAuthentication(params) {
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'POST', `${this.url}/passkeys/authentication/verify`, {
                headers: this.headers,
                body: {
                    challenge_id: params.challengeId,
                    credential: params.credential
                },
                xform: (0, $1iZkC._sessionResponse)
            });
            if (error) return this._returnResult({
                data: null,
                error: error
            });
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: data,
                error: null
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * List all passkeys for the current user.
     */ async _listPasskeys() {
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'GET', `${this.url}/passkeys`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Update a passkey.
     */ async _updatePasskey(params) {
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $1iZkC._request)(this.fetch, 'PATCH', `${this.url}/passkeys/${params.passkeyId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        friendly_name: params.friendlyName
                    }
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Delete a passkey.
     */ async _deletePasskey(params) {
        (0, $hQAY4.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $eiAXc.AuthSessionMissingError)()
                });
                const { error: error } = await (0, $1iZkC._request)(this.fetch, 'DELETE', `${this.url}/passkeys/${params.passkeyId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    noResolveJson: true
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: null,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
}
$1f37b95ef684de65$var$GoTrueClient.nextInstanceID = {};
var $1f37b95ef684de65$export$2e2bcd8739ae039 = $1f37b95ef684de65$var$GoTrueClient;

});
parcelRegister("f5pdv", function(module, exports) {

$parcel$export(module.exports, "memoryLocalStorageAdapter", function () { return $afbae22f136a9868$export$d791f66d7e5710cf; });
/**
 * Returns a localStorage-like object that stores the key-value pairs in
 * memory.
 */ function $afbae22f136a9868$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}

});

parcelRegister("0qGFG", function(module, exports) {

$parcel$export(module.exports, "LockAcquireTimeoutError", function () { return $0014b3bbc40a5d4b$export$23e9464cc010dff9; });
$parcel$export(module.exports, "navigatorLock", function () { return $0014b3bbc40a5d4b$export$f4ff21938fb7af3c; });

var $hQAY4 = parcelRequire("hQAY4");
const $0014b3bbc40a5d4b$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $hQAY4.supportsLocalStorage)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $0014b3bbc40a5d4b$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $0014b3bbc40a5d4b$export$4aa56776043a4631 extends $0014b3bbc40a5d4b$export$23e9464cc010dff9 {
}
class $0014b3bbc40a5d4b$export$4b982ee840d3d915 extends $0014b3bbc40a5d4b$export$23e9464cc010dff9 {
}
async function $0014b3bbc40a5d4b$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    let acquireTimeoutTimer;
    if (acquireTimeout > 0) acquireTimeoutTimer = setTimeout(()=>{
        abortController.abort();
        if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    await Promise.resolve();
    try {
        return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                // Lock acquired — cancel the acquire-timeout timer so it cannot fire
                // while fn() is running. Without this, a delayed timeout abort would
                // set signal.aborted = true even though we already hold the lock,
                // causing a subsequent steal to be misclassified as "our timeout
                // fired" and triggering a spurious steal-back cascade.
                clearTimeout(acquireTimeoutTimer);
                if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $0014b3bbc40a5d4b$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                clearTimeout(acquireTimeoutTimer);
                return await fn();
            }
        });
    } catch (e) {
        // Always clear the acquire timeout once the request settles, so it cannot
        // fire later and incorrectly abort/log after a rejection.
        if (acquireTimeout > 0) clearTimeout(acquireTimeoutTimer);
        if ((e === null || e === void 0 ? void 0 : e.name) === 'AbortError' && acquireTimeout > 0) {
            if (abortController.signal.aborted) {
                // OUR timeout fired — the lock is genuinely orphaned. Steal it.
                //
                // The lock acquisition was aborted because the timeout fired while the
                // request was still pending. This typically means another lock holder is
                // not releasing the lock, possibly due to React Strict Mode's
                // double-mount/unmount behavior or a component unmounting mid-operation,
                // leaving an orphaned lock.
                //
                // Recovery: use { steal: true } to forcefully acquire the lock. Per the
                // Web Locks API spec, this releases any currently held lock with the same
                // name and grants the request immediately, preempting any queued requests.
                // The previous holder's callback continues running to completion but no
                // longer holds the lock for exclusion purposes.
                //
                // See: https://github.com/supabase/supabase/issues/42505
                if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire timeout, recovering by stealing lock', name);
                console.warn(`@supabase/gotrue-js: Lock "${name}" was not released within ${acquireTimeout}ms. ` + 'This may indicate an orphaned lock from a component unmount (e.g., React Strict Mode). ' + 'Forcefully acquiring the lock to recover.');
                return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, {
                        mode: 'exclusive',
                        steal: true
                    }, async (lock)=>{
                        if (lock) {
                            if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: recovered (stolen)', name, lock.name);
                            try {
                                return await fn();
                            } finally{
                                if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released (stolen)', name, lock.name);
                            }
                        } else {
                            // This should not happen with steal: true, but handle gracefully.
                            console.warn('@supabase/gotrue-js: Navigator LockManager returned null lock even with steal: true');
                            return await fn();
                        }
                    }));
            } else {
                // We HELD the lock but another request stole it from us.
                // Per the Web Locks spec, our fn() callback is still running as an
                // orphaned background task — do NOT steal back. Stealing back would
                // cause a cascade (A steals B, B steals A, ...) and run fn() a second
                // time concurrently, corrupting auth state.
                // Convert to a typed error so callers (e.g. _autoRefreshTokenTick)
                // can handle/filter it without it leaking to Sentry as a raw AbortError.
                if ($0014b3bbc40a5d4b$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: lock was stolen by another request', name);
                throw new $0014b3bbc40a5d4b$export$4aa56776043a4631(`Lock "${name}" was released because another request stole it`);
            }
        }
        throw e;
    }
}
const $0014b3bbc40a5d4b$var$PROCESS_LOCKS = {};
async function $0014b3bbc40a5d4b$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $0014b3bbc40a5d4b$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    // Wrap previousOperation to handle errors without using .catch()
    // This avoids Firefox content script security errors
    const previousOperationHandled = (async ()=>{
        try {
            await previousOperation;
            return null;
        } catch (e) {
            // ignore error of previous operation that we're waiting to finish
            return null;
        }
    })();
    const currentOperation = (async ()=>{
        let timeoutId = null;
        try {
            // Wait for either previous operation or timeout
            const timeoutPromise = acquireTimeout >= 0 ? new Promise((_, reject)=>{
                timeoutId = setTimeout(()=>{
                    console.warn(`@supabase/gotrue-js: Lock "${name}" acquisition timed out after ${acquireTimeout}ms. ` + 'This may be caused by another operation holding the lock. ' + 'Consider increasing lockAcquireTimeout or checking for stuck operations.');
                    reject(new $0014b3bbc40a5d4b$export$4b982ee840d3d915(`Acquiring process lock with name "${name}" timed out`));
                }, acquireTimeout);
            }) : null;
            await Promise.race([
                previousOperationHandled,
                timeoutPromise
            ].filter((x)=>x));
            // If we reach here, previousOperationHandled won the race
            // Clear the timeout to prevent false warnings
            if (timeoutId !== null) clearTimeout(timeoutId);
        } catch (e) {
            // Clear the timeout on error path as well
            if (timeoutId !== null) clearTimeout(timeoutId);
            // Re-throw timeout errors, ignore others
            if (e && e.isAcquireTimeout) throw e;
        // Fall through to run fn() - previous operation finished with error
        }
        // Previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    })();
    $0014b3bbc40a5d4b$var$PROCESS_LOCKS[name] = (async ()=>{
        try {
            return await currentOperation;
        } catch (e) {
            if (e && e.isAcquireTimeout) {
                // if the current operation timed out, it doesn't mean that the previous
                // operation finished, so we need continue waiting for it to finish
                try {
                    await previousOperation;
                } catch (prevError) {
                // Ignore previous operation errors
                }
                return null;
            }
            throw e;
        }
    })();
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}

});

parcelRegister("byU9f", function(module, exports) {

$parcel$export(module.exports, "polyfillGlobalThis", function () { return $86ae6c8511625993$export$ad067ce270531206; });
/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $86ae6c8511625993$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}

});

parcelRegister("1aLKn", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $0dabc32ea2d6f5f8$export$88411125f012957a; });
$parcel$export(module.exports, "fromHex", function () { return $0dabc32ea2d6f5f8$export$1a8ceedbd5845648; });
$parcel$export(module.exports, "toHex", function () { return $0dabc32ea2d6f5f8$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "createSiweMessage", function () { return $0dabc32ea2d6f5f8$export$7ee2e5fde403d4c8; });
// types and functions copied over from viem so this library doesn't depend on it
function $0dabc32ea2d6f5f8$export$88411125f012957a(address) {
    if (!/^0x[a-fA-F0-9]{40}$/.test(address)) throw new Error(`@supabase/auth-js: Address "${address}" is invalid.`);
    return address.toLowerCase();
}
function $0dabc32ea2d6f5f8$export$1a8ceedbd5845648(hex) {
    return parseInt(hex, 16);
}
function $0dabc32ea2d6f5f8$export$7ea66e3774a60b67(value) {
    const bytes = new TextEncoder().encode(value);
    const hex = Array.from(bytes, (byte)=>byte.toString(16).padStart(2, '0')).join('');
    return '0x' + hex;
}
function $0dabc32ea2d6f5f8$export$7ee2e5fde403d4c8(parameters) {
    var _a;
    const { chainId: chainId, domain: domain, expirationTime: expirationTime, issuedAt: issuedAt = new Date(), nonce: nonce, notBefore: notBefore, requestId: requestId, resources: resources, scheme: scheme, uri: uri, version: version } = parameters;
    if (!Number.isInteger(chainId)) throw new Error(`@supabase/auth-js: Invalid SIWE message field "chainId". Chain ID must be a EIP-155 chain ID. Provided value: ${chainId}`);
    if (!domain) throw new Error(`@supabase/auth-js: Invalid SIWE message field "domain". Domain must be provided.`);
    if (nonce && nonce.length < 8) throw new Error(`@supabase/auth-js: Invalid SIWE message field "nonce". Nonce must be at least 8 characters. Provided value: ${nonce}`);
    if (!uri) throw new Error(`@supabase/auth-js: Invalid SIWE message field "uri". URI must be provided.`);
    if (version !== '1') throw new Error(`@supabase/auth-js: Invalid SIWE message field "version". Version must be '1'. Provided value: ${version}`);
    if ((_a = parameters.statement) === null || _a === void 0 ? void 0 : _a.includes('\n')) throw new Error(`@supabase/auth-js: Invalid SIWE message field "statement". Statement must not include '\\n'. Provided value: ${parameters.statement}`);
    // Construct message
    const address = $0dabc32ea2d6f5f8$export$88411125f012957a(parameters.address);
    const origin = scheme ? `${scheme}://${domain}` : domain;
    const statement = parameters.statement ? `${parameters.statement}\n` : '';
    const prefix = `${origin} wants you to sign in with your Ethereum account:\n${address}\n\n${statement}`;
    let suffix = `URI: ${uri}\nVersion: ${version}\nChain ID: ${chainId}${nonce ? `\nNonce: ${nonce}` : ''}\nIssued At: ${issuedAt.toISOString()}`;
    if (expirationTime) suffix += `\nExpiration Time: ${expirationTime.toISOString()}`;
    if (notBefore) suffix += `\nNot Before: ${notBefore.toISOString()}`;
    if (requestId) suffix += `\nRequest ID: ${requestId}`;
    if (resources) {
        let content = '\nResources:';
        for (const resource of resources){
            if (!resource || typeof resource !== 'string') throw new Error(`@supabase/auth-js: Invalid SIWE message field "resources". Every resource must be a valid string. Provided value: ${resource}`);
            content += `\n- ${resource}`;
        }
        suffix += content;
    }
    return `${prefix}\n${suffix}`;
}

});

parcelRegister("bJWBJ", function(module, exports) {

$parcel$export(module.exports, "webAuthnAbortService", function () { return $88c15be62351451a$export$4109de07ec7c8bef; });
$parcel$export(module.exports, "deserializeCredentialCreationOptions", function () { return $88c15be62351451a$export$d02e6c69c68605f0; });
$parcel$export(module.exports, "deserializeCredentialRequestOptions", function () { return $88c15be62351451a$export$943ff00a541d1017; });
$parcel$export(module.exports, "serializeCredentialCreationResponse", function () { return $88c15be62351451a$export$4b534f6222f6d585; });
$parcel$export(module.exports, "serializeCredentialRequestResponse", function () { return $88c15be62351451a$export$b3350da6d3acaa5a; });
$parcel$export(module.exports, "isValidDomain", function () { return $88c15be62351451a$export$59e759560deddc3c; });
$parcel$export(module.exports, "browserSupportsWebAuthn", function () { return $88c15be62351451a$export$21f8045e1be8a25d; });
$parcel$export(module.exports, "createCredential", function () { return $88c15be62351451a$export$e4658562cd85d5e4; });
$parcel$export(module.exports, "getCredential", function () { return $88c15be62351451a$export$298c59008c641b3e; });
$parcel$export(module.exports, "WebAuthnApi", function () { return $88c15be62351451a$export$23264e48ebb7dee0; });

var $jMaHP = parcelRequire("jMaHP");

var $iqwv8 = parcelRequire("iqwv8");

var $eiAXc = parcelRequire("eiAXc");

var $hQAY4 = parcelRequire("hQAY4");

var $aBFpC = parcelRequire("aBFpC");
class $88c15be62351451a$export$442ada5d34ca6e87 {
    /**
     * Create an abort signal for a new WebAuthn operation.
     * Automatically cancels any existing operation.
     *
     * @returns {AbortSignal} Signal to pass to navigator.credentials.create() or .get()
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal MDN - AbortSignal}
     */ createNewAbortSignal() {
        // Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
        if (this.controller) {
            const abortError = new Error('Cancelling existing WebAuthn API call for new one');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    /**
     * Manually cancel the current WebAuthn operation.
     * Useful for cleaning up when user cancels or navigates away.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort MDN - AbortController.abort}
     */ cancelCeremony() {
        if (this.controller) {
            const abortError = new Error('Manually cancelling existing WebAuthn API call');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const $88c15be62351451a$export$4109de07ec7c8bef = new $88c15be62351451a$export$442ada5d34ca6e87();
function $88c15be62351451a$export$d02e6c69c68605f0(options) {
    if (!options) throw new Error('Credential creation options are required');
    // Check if the native parseCreationOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseCreationOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseCreationOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseCreationOptionsFromJSON(/** we assert the options here as typescript still doesn't know about future webauthn types */ options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, user: userOpts, excludeCredentials: excludeCredentials } = options, restOptions = (0, $jMaHP.__rest)(options, [
        "challenge",
        "user",
        "excludeCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $iqwv8.base64UrlToUint8Array)(challengeStr).buffer;
    // Convert user.id from base64url to ArrayBuffer
    const user = Object.assign(Object.assign({}, userOpts), {
        id: (0, $iqwv8.base64UrlToUint8Array)(userOpts.id).buffer
    });
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge,
        user: user
    });
    // Only add excludeCredentials if it exists
    if (excludeCredentials && excludeCredentials.length > 0) {
        result.excludeCredentials = new Array(excludeCredentials.length);
        for(let i = 0; i < excludeCredentials.length; i++){
            const cred = excludeCredentials[i];
            result.excludeCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $iqwv8.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $88c15be62351451a$export$943ff00a541d1017(options) {
    if (!options) throw new Error('Credential request options are required');
    // Check if the native parseRequestOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseRequestOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseRequestOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseRequestOptionsFromJSON(options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, allowCredentials: allowCredentials } = options, restOptions = (0, $jMaHP.__rest)(options, [
        "challenge",
        "allowCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $iqwv8.base64UrlToUint8Array)(challengeStr).buffer;
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge
    });
    // Only add allowCredentials if it exists
    if (allowCredentials && allowCredentials.length > 0) {
        result.allowCredentials = new Array(allowCredentials.length);
        for(let i = 0; i < allowCredentials.length; i++){
            const cred = allowCredentials[i];
            result.allowCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $iqwv8.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $88c15be62351451a$export$4b534f6222f6d585(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    const credentialWithAttachment = credential;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            attestationObject: (0, $iqwv8.bytesToBase64URL)(new Uint8Array(credential.response.attestationObject)),
            clientDataJSON: (0, $iqwv8.bytesToBase64URL)(new Uint8Array(credential.response.clientDataJSON))
        },
        type: 'public-key',
        clientExtensionResults: credential.getClientExtensionResults(),
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $88c15be62351451a$export$b3350da6d3acaa5a(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    // Fallback to manual conversion for browsers that don't support toJSON
    // Access authenticatorAttachment via type assertion to handle TypeScript version differences
    // @simplewebauthn/types includes this property but base TypeScript 4.7.4 doesn't
    const credentialWithAttachment = credential;
    const clientExtensionResults = credential.getClientExtensionResults();
    const assertionResponse = credential.response;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            authenticatorData: (0, $iqwv8.bytesToBase64URL)(new Uint8Array(assertionResponse.authenticatorData)),
            clientDataJSON: (0, $iqwv8.bytesToBase64URL)(new Uint8Array(assertionResponse.clientDataJSON)),
            signature: (0, $iqwv8.bytesToBase64URL)(new Uint8Array(assertionResponse.signature)),
            userHandle: assertionResponse.userHandle ? (0, $iqwv8.bytesToBase64URL)(new Uint8Array(assertionResponse.userHandle)) : undefined
        },
        type: 'public-key',
        clientExtensionResults: clientExtensionResults,
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $88c15be62351451a$export$59e759560deddc3c(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}
function $88c15be62351451a$export$21f8045e1be8a25d() {
    var _a, _b;
    return !!((0, $hQAY4.isBrowser)() && 'PublicKeyCredential' in window && window.PublicKeyCredential && 'credentials' in navigator && typeof ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _a === void 0 ? void 0 : _a.create) === 'function' && typeof ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _b === void 0 ? void 0 : _b.get) === 'function');
}
async function $88c15be62351451a$export$e4658562cd85d5e4(options) {
    try {
        const response = await navigator.credentials.create(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $aBFpC.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $aBFpC.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $aBFpC.identifyRegistrationError)({
                error: err,
                options: options
            })
        };
    }
}
async function $88c15be62351451a$export$298c59008c641b3e(options) {
    try {
        const response = await navigator.credentials.get(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $aBFpC.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $aBFpC.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $aBFpC.identifyAuthenticationError)({
                error: err,
                options: options
            })
        };
    }
}
const $88c15be62351451a$export$315ccaead2259c48 = {
    hints: [
        'security-key'
    ],
    authenticatorSelection: {
        authenticatorAttachment: 'cross-platform',
        requireResidentKey: false,
        /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
        residentKey: 'discouraged'
    },
    attestation: 'direct'
};
const $88c15be62351451a$export$26eadd1e9f10eb21 = {
    /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
    hints: [
        'security-key'
    ],
    attestation: 'direct'
};
function $88c15be62351451a$var$deepMerge(...sources) {
    const isObject = (val)=>val !== null && typeof val === 'object' && !Array.isArray(val);
    const isArrayBufferLike = (val)=>val instanceof ArrayBuffer || ArrayBuffer.isView(val);
    const result = {};
    for (const source of sources){
        if (!source) continue;
        for(const key in source){
            const value = source[key];
            if (value === undefined) continue;
            if (Array.isArray(value)) // preserve array reference, including unions like AuthenticatorTransport[]
            result[key] = value;
            else if (isArrayBufferLike(value)) result[key] = value;
            else if (isObject(value)) {
                const existing = result[key];
                if (isObject(existing)) result[key] = $88c15be62351451a$var$deepMerge(existing, value);
                else result[key] = $88c15be62351451a$var$deepMerge(value);
            } else result[key] = value;
        }
    }
    return result;
}
function $88c15be62351451a$export$3be75f4dca600793(baseOptions, overrides) {
    return $88c15be62351451a$var$deepMerge($88c15be62351451a$export$315ccaead2259c48, baseOptions, overrides || {});
}
function $88c15be62351451a$export$dd12a9ca29190b76(baseOptions, overrides) {
    return $88c15be62351451a$var$deepMerge($88c15be62351451a$export$26eadd1e9f10eb21, baseOptions, overrides || {});
}
class $88c15be62351451a$export$23264e48ebb7dee0 {
    constructor(client){
        this.client = client;
        // Bind all methods so they can be destructured
        this.enroll = this._enroll.bind(this);
        this.challenge = this._challenge.bind(this);
        this.verify = this._verify.bind(this);
        this.authenticate = this._authenticate.bind(this);
        this.register = this._register.bind(this);
    }
    /**
     * Enroll a new WebAuthn factor.
     * Creates an unverified WebAuthn factor that must be verified with a credential.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Omit<MFAEnrollWebauthnParams, 'factorType'>} params - Enrollment parameters (friendlyName required)
     * @returns {Promise<AuthMFAEnrollWebauthnResponse>} Enrolled factor details or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registering a New Credential}
     */ async _enroll(params) {
        return this.client.mfa.enroll(Object.assign(Object.assign({}, params), {
            factorType: 'webauthn'
        }));
    }
    /**
     * Challenge for WebAuthn credential creation or authentication.
     * Combines server challenge with browser credential operations.
     * Handles both registration (create) and authentication (request) flows.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {MFAChallengeWebauthnParams & { friendlyName?: string; signal?: AbortSignal }} params - Challenge parameters including factorId
     * @param {Object} overrides - Allows you to override the parameters passed to navigator.credentials
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides.create - Override options for credential creation
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides.request - Override options for credential request
     * @returns {Promise<RequestResult>} Challenge response with credential or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-credential-creation W3C WebAuthn Spec - Credential Creation}
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying Assertion}
     */ async _challenge({ factorId: factorId, webauthn: webauthn, friendlyName: friendlyName, signal: signal }, overrides) {
        var _a;
        try {
            // Get challenge from server using the client's MFA methods
            const { data: challengeResponse, error: challengeError } = await this.client.mfa.challenge({
                factorId: factorId,
                webauthn: webauthn
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const abortSignal = signal !== null && signal !== void 0 ? signal : $88c15be62351451a$export$4109de07ec7c8bef.createNewAbortSignal();
            /** webauthn will fail if either of the name/displayname are blank */ if (challengeResponse.webauthn.type === 'create') {
                const { user: user } = challengeResponse.webauthn.credential_options.publicKey;
                if (!user.name) {
                    // Preserve original format: use friendlyName if provided, otherwise fetch fallback
                    // This maintains backward compatibility with the ${user.id}:${name} format
                    const nameToUse = friendlyName;
                    if (!nameToUse) {
                        // Only fetch user data if friendlyName is not provided (bug fix for null friendlyName)
                        const currentUser = await this.client.getUser();
                        const userData = currentUser.data.user;
                        const fallbackName = ((_a = userData === null || userData === void 0 ? void 0 : userData.user_metadata) === null || _a === void 0 ? void 0 : _a.name) || (userData === null || userData === void 0 ? void 0 : userData.email) || (userData === null || userData === void 0 ? void 0 : userData.id) || 'User';
                        user.name = `${user.id}:${fallbackName}`;
                    } else user.name = `${user.id}:${nameToUse}`;
                }
                if (!user.displayName) user.displayName = user.name;
            }
            switch(challengeResponse.webauthn.type){
                case 'create':
                    {
                        const options = $88c15be62351451a$export$3be75f4dca600793(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.create);
                        const { data: data, error: error } = await $88c15be62351451a$export$e4658562cd85d5e4({
                            publicKey: options,
                            signal: abortSignal
                        });
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
                case 'request':
                    {
                        const options = $88c15be62351451a$export$dd12a9ca29190b76(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.request);
                        const { data: data, error: error } = await $88c15be62351451a$export$298c59008c641b3e(Object.assign(Object.assign({}, challengeResponse.webauthn.credential_options), {
                            publicKey: options,
                            signal: abortSignal
                        }));
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
            }
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $eiAXc.AuthUnknownError)('Unexpected error in challenge', error)
            };
        }
    }
    /**
     * Verify a WebAuthn credential with the server.
     * Completes the WebAuthn ceremony by sending the credential to the server for verification.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Verification parameters
     * @param {string} params.challengeId - ID of the challenge being verified
     * @param {string} params.factorId - ID of the WebAuthn factor
     * @param {MFAVerifyWebauthnParams<T>['webauthn']} params.webauthn - WebAuthn credential response
     * @returns {Promise<AuthMFAVerifyResponse>} Verification result with session or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying an Authentication Assertion}
     * */ async _verify({ challengeId: challengeId, factorId: factorId, webauthn: webauthn }) {
        return this.client.mfa.verify({
            factorId: factorId,
            challengeId: challengeId,
            webauthn: webauthn
        });
    }
    /**
     * Complete WebAuthn authentication flow.
     * Performs challenge and verification in a single operation for existing credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Authentication parameters
     * @param {string} params.factorId - ID of the WebAuthn factor to authenticate with
     * @param {Object} params.webauthn - WebAuthn configuration
     * @param {string} params.webauthn.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.webauthn.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.webauthn.signal - Optional abort signal
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides - Override options for navigator.credentials.get
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Authentication result
     * @see {@link https://w3c.github.io/webauthn/#sctn-authentication W3C WebAuthn Spec - Authentication Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialRequestOptions MDN - PublicKeyCredentialRequestOptions}
     */ async _authenticate({ factorId: factorId, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $eiAXc.AuthError)('rpId is required for WebAuthn authentication')
        };
        try {
            if (!$88c15be62351451a$export$21f8045e1be8a25d()) return {
                data: null,
                error: new (0, $eiAXc.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Get challenge and credential
            const { data: challengeResponse, error: challengeError } = await this.challenge({
                factorId: factorId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                request: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const { webauthn: webauthn } = challengeResponse;
            // Verify credential
            return this._verify({
                factorId: factorId,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    type: webauthn.type,
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    credential_response: webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $eiAXc.AuthUnknownError)('Unexpected error in authenticate', error)
            };
        }
    }
    /**
     * Complete WebAuthn registration flow.
     * Performs enrollment, challenge, and verification in a single operation for new credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Registration parameters
     * @param {string} params.friendlyName - User-friendly name for the credential
     * @param {string} params.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.signal - Optional abort signal
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides - Override options for navigator.credentials.create
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Registration result
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registration Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialCreationOptions MDN - PublicKeyCredentialCreationOptions}
     */ async _register({ friendlyName: friendlyName, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $eiAXc.AuthError)('rpId is required for WebAuthn registration')
        };
        try {
            if (!$88c15be62351451a$export$21f8045e1be8a25d()) return {
                data: null,
                error: new (0, $eiAXc.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Enroll factor
            const { data: factor, error: enrollError } = await this._enroll({
                friendlyName: friendlyName
            });
            if (!factor) {
                await this.client.mfa.listFactors().then((factors)=>{
                    var _a;
                    return (_a = factors.data) === null || _a === void 0 ? void 0 : _a.all.find((v)=>v.factor_type === 'webauthn' && v.friendly_name === friendlyName && v.status !== 'unverified');
                }).then((factor)=>factor ? this.client.mfa.unenroll({
                        factorId: factor === null || factor === void 0 ? void 0 : factor.id
                    }) : void 0);
                return {
                    data: null,
                    error: enrollError
                };
            }
            // Get challenge and create credential
            const { data: challengeResponse, error: challengeError } = await this._challenge({
                factorId: factor.id,
                friendlyName: factor.friendly_name,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                create: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            return this._verify({
                factorId: factor.id,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    type: challengeResponse.webauthn.type,
                    credential_response: challengeResponse.webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $eiAXc.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $eiAXc.AuthUnknownError)('Unexpected error in register', error)
            };
        }
    }
}

});
parcelRegister("aBFpC", function(module, exports) {

$parcel$export(module.exports, "WebAuthnUnknownError", function () { return $7b8d7bb36f3e8ced$export$2799e3b911935b0d; });
$parcel$export(module.exports, "identifyRegistrationError", function () { return $7b8d7bb36f3e8ced$export$1c18a773f8a28a92; });
$parcel$export(module.exports, "identifyAuthenticationError", function () { return $7b8d7bb36f3e8ced$export$9b62fd498befe529; });
/* eslint-disable @typescript-eslint/ban-ts-comment */ 
var $bJWBJ = parcelRequire("bJWBJ");
class $7b8d7bb36f3e8ced$export$90f0c14a652de832 extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        var _a;
        // @ts-ignore: help Rollup understand that `cause` is okay to set
        super(message, {
            cause: cause
        });
        this.__isWebAuthnError = true;
        this.name = (_a = name !== null && name !== void 0 ? name : cause instanceof Error ? cause.name : undefined) !== null && _a !== void 0 ? _a : 'Unknown Error';
        this.code = code;
    }
}
class $7b8d7bb36f3e8ced$export$2799e3b911935b0d extends $7b8d7bb36f3e8ced$export$90f0c14a652de832 {
    constructor(message, originalError){
        super({
            code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
            cause: originalError,
            message: message
        });
        this.name = 'WebAuthnUnknownError';
        this.originalError = originalError;
    }
}
function $7b8d7bb36f3e8ced$export$8596540875e19045(error) {
    return typeof error === 'object' && error !== null && '__isWebAuthnError' in error;
}
function $7b8d7bb36f3e8ced$export$1c18a773f8a28a92({ error: error, options: options }) {
    var _a, _b, _c;
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: 'Registration ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'ConstraintError') {
        if (((_a = publicKey.authenticatorSelection) === null || _a === void 0 ? void 0 : _a.requireResidentKey) === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: 'Discoverable credentials were required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT',
            cause: error
        });
        else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === 'conditional' && ((_b = publicKey.authenticatorSelection) === null || _b === void 0 ? void 0 : _b.userVerification) === 'required') // https://w3c.github.io/webauthn/#sctn-createCredential (Step 22.4)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: 'User verification was required during automatic registration but it could not be performed',
            code: 'ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE',
            cause: error
        });
        else if (((_c = publicKey.authenticatorSelection) === null || _c === void 0 ? void 0 : _c.userVerification) === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: 'User verification was required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT',
            cause: error
        });
    } else if (error.name === 'InvalidStateError') // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
    return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
        message: 'The authenticator was previously registered',
        code: 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED',
        cause: error
    });
    else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'NotSupportedError') {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === 'public-key');
        if (validPubKeyCredParams.length === 0) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 10)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: 'ERROR_MALFORMED_PUBKEYCREDPARAMS',
            cause: error
        });
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: 'No available authenticator supported any of the specified pubKeyCredParams algorithms',
            code: 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG',
            cause: error
        });
    } else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $bJWBJ.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'TypeError') {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: 'User ID was not between 1 and 64 characters',
            code: 'ERROR_INVALID_USER_ID_LENGTH',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
    return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new credential',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}
function $7b8d7bb36f3e8ced$export$9b62fd498befe529({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: 'Authentication ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $bJWBJ.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
        return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
    return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new assertion signature',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $7b8d7bb36f3e8ced$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}

});



parcelRegister("4KktP", function(module, exports) {

var $8KUaF = parcelRequire("8KUaF");
const $374b583678be1f66$var$AuthAdminApi = (0, $8KUaF.default);
var $374b583678be1f66$export$2e2bcd8739ae039 = $374b583678be1f66$var$AuthAdminApi;

});

parcelRegister("4KbMQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $374499eb4f99bb7f$export$2e2bcd8739ae039; });

var $2GaB5 = parcelRequire("2GaB5");
const $374499eb4f99bb7f$var$AuthClient = (0, $2GaB5.default);
var $374499eb4f99bb7f$export$2e2bcd8739ae039 = $374499eb4f99bb7f$var$AuthClient;

});



parcelRegister("4aj47", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $d2947aab58e16b9a$export$af88d00dbe7f521; });
// DEV-gated logger.
// `info` and `log` print only in development; `warn` and `error` always print so
// production observability stays intact.
// Parcel inlines `process.env.NODE_ENV` and dead-code-eliminates the DEV branch
// from production bundles.
const $d2947aab58e16b9a$var$isDev = false;
const $d2947aab58e16b9a$export$af88d00dbe7f521 = {
    info: (...args)=>{
        if ($d2947aab58e16b9a$var$isDev) console.info(...args);
    },
    log: (...args)=>{
        if ($d2947aab58e16b9a$var$isDev) console.log(...args);
    },
    warn: (...args)=>{
        console.warn(...args);
    },
    error: (...args)=>{
        console.error(...args);
    }
};

});


parcelRegister("gTQhM", function(module, exports) {
module.exports = $parcel$import("g9eTp").then(()=>parcelRequire('814BC'));

});


parcelRegister("i2uG6", function(module, exports) {

$parcel$export(module.exports, "mapUserRowToProfile", function () { return $36f0ffad69c48cc6$export$ba634ddffff70fff; });
$parcel$export(module.exports, "userRepository", function () { return $36f0ffad69c48cc6$export$d211ca6b6558f4d8; });

var $1BuUO = parcelRequire("1BuUO");

var $hUL2G = parcelRequire("hUL2G");

var $4aj47 = parcelRequire("4aj47");

var $3rEkS = parcelRequire("3rEkS");
const $36f0ffad69c48cc6$export$2401025398cf3699 = 1000;
const $36f0ffad69c48cc6$export$3836b98b2bc8c6ff = 'id,name,shop,avatar_url,bio,contact_phone,user_type,lat,lng,google_maps_link,working_hours,preferred_lang';
/**
 * هل يوجد العرض العام على الخادم؟ (null = لم نجرّب بعد). نتذكّر النتيجة فلا
 * نُطلق طلباً فاشلاً في كل تحديث قبل تطبيق ترحيل v13.71 على الخادم.
 */ let $36f0ffad69c48cc6$var$publicDirectoryAvailable = null;
const $36f0ffad69c48cc6$export$c5fca3d3276bc352 = "id,name,phone,email,user_type,shop,contact_phone,avatar_url,bio,savings,bookings_count,notif_keywords,smart_alerts,preferred_lang,followed_merchants,blocked_merchants,lat,lng,google_maps_link,working_hours";
const $36f0ffad69c48cc6$export$ba634ddffff70fff = (d)=>({
        id: d.id,
        name: d.name,
        phone: d.phone,
        email: d.email,
        userType: d.user_type,
        shop: d.shop,
        contactPhone: d.contact_phone,
        avatar_url: d.avatar_url,
        bio: d.bio,
        savings: d.savings,
        bookingsCount: d.bookings_count,
        notifKeywords: d.notif_keywords,
        smartAlerts: Array.isArray(d.smart_alerts) ? d.smart_alerts : [],
        preferredLang: d.preferred_lang || 'ar',
        followedMerchants: Array.isArray(d.followed_merchants) ? d.followed_merchants : [],
        blockedMerchants: Array.isArray(d.blocked_merchants) ? d.blocked_merchants : [],
        lat: d.lat,
        lng: d.lng,
        googleMapsLink: d.google_maps_link,
        workingHours: d.working_hours
    });
/**
 * طابورٌ لكل عرضٍ على حدة (v14.64).
 * 🪤 نقرتان سريعتان على زرّ الحفظ (إضافة ثم إزالة خلال جزء من الثانية) كانتا
 * تنطلقان معاً، فأيّهما يصل الخادم أخيراً يفوز — وقد تكون الأولى. النتيجة
 * حالةٌ في القاعدة تخالف ما يراه المشتري على الشاشة. الآن تُسلسَل عمليات
 * **نفس العرض** فلا تتسابقان، وتبقى عمليات العروض الأخرى متوازية.
 */ const $36f0ffad69c48cc6$var$favQueue = new Map();
const $36f0ffad69c48cc6$var$queueFavorite = (dealId, task)=>{
    const prev = $36f0ffad69c48cc6$var$favQueue.get(dealId) || Promise.resolve(true);
    const next = prev.catch(()=>false).then(task);
    $36f0ffad69c48cc6$var$favQueue.set(dealId, next);
    // تنظيفٌ حين يهدأ هذا العرض، فلا تنمو الخريطة بلا حدّ.
    next.finally(()=>{
        if ($36f0ffad69c48cc6$var$favQueue.get(dealId) === next) $36f0ffad69c48cc6$var$favQueue.delete(dealId);
    });
    return next;
};
const $36f0ffad69c48cc6$export$d211ca6b6558f4d8 = {
    getCurrentUser: async ()=>{
        const memory = (0, $1BuUO.authService).getUser();
        if (memory) return memory;
        try {
            const { data: { session: session } } = await (0, $hUL2G.supabase).auth.getSession();
            if (session?.user) {
                const profile = await $36f0ffad69c48cc6$export$d211ca6b6558f4d8.findById(session.user.id);
                if (profile) {
                    (0, $1BuUO.authService).setUser(profile);
                    return profile;
                }
                // Optimistic fallback: a valid session whose `users` row is
                // missing or blocked by RLS used to leave us treating the
                // visitor as a guest forever. Build the profile from the JWT
                // metadata so the UI unlocks immediately. The realtime
                // listener replaces this with the canonical row when it lands.
                const meta = session.user.user_metadata || {};
                const fallback = {
                    id: session.user.id,
                    name: meta.name || "\u0645\u0633\u062A\u062E\u062F\u0645",
                    phone: meta.phone || session.user.phone || '',
                    email: meta.email || session.user.email || '',
                    userType: meta.user_type || 'buyer',
                    shop: meta.shop || '',
                    contactPhone: meta.contact_phone || meta.phone || session.user.phone || '',
                    address: meta.address || '',
                    savings: 0,
                    bookingsCount: 0,
                    notifKeywords: [],
                    smartAlerts: [],
                    preferredLang: 'ar',
                    followedMerchants: [],
                    blockedMerchants: []
                };
                (0, $1BuUO.authService).setUser(fallback);
                return fallback;
            }
        } catch (e) {
            console.error('Failed to fetch session from remote', e);
        }
        return null;
    },
    saveProfile: async (profile)=>{
        (0, $1BuUO.authService).setUser(profile);
        try {
            // PARTIAL-AWARE upsert. The previous version wrote every field with
            // `profile.X || default`, which silently NULLed out columns the
            // caller didn't include in its partial. The reported "follow
            // disappeared after an update" came from this — a saveProfile
            // call after toggling a notif keyword carried no followedMerchants
            // on the cached `user`, so `|| []` wiped the DB array.
            //
            // Rule: only include a column when the corresponding profile field
            // is explicitly set (i.e. not `undefined`). `null` is preserved as
            // an intentional clear; missing means "leave it alone".
            const p = profile;
            const dbData = {
                id: profile.id
            };
            const set = (col, val, fallback)=>{
                if (val !== undefined) dbData[col] = val;
                else if (fallback !== undefined) dbData[col] = fallback;
            };
            set('name', p.name, "\u0645\u0633\u062A\u062E\u062F\u0645");
            set('phone', p.phone ?? null);
            set('email', p.email ?? null);
            // user_type only when present — never silently downgrade.
            if (p.userType !== undefined) dbData.user_type = p.userType;
            set('shop', p.shop ?? null);
            set('contact_phone', p.contactPhone ?? p.phone ?? null);
            set('address', p.address ?? null);
            // 🔴 v14.72c — `avatar_url` و`bio` **لا تُكتبان من هنا بعد اليوم**.
            // هذا الكاتب يمسّ `users` وحده، والبوتان يقرآن `store_profiles`
            // أيضاً — فكلّ كتابةٍ من هنا كانت تُعيد فتح الانفصال الذي أغلقته
            // v14.71 (نبذةٌ من الموقع لا يراها أحدٌ في البوت). الكاتب الوحيد
            // للعمودين صار `merchant_set_store_card` على القاعدة.
            // 🪤 وتُحذَفان من مجموعة الأعمدة **صراحةً** لا بالإهمال: إسقاطُ
            //    الحقل بصمت وهو مُمرَّر فخٌّ في نفسه، فالتعليق هنا هو العقد.
            if (p.avatar_url !== undefined || p.bio !== undefined) (0, $4aj47.logger).info("saveProfile: \u062A\u062C\u0627\u0648\u064F\u0632 avatar_url/bio \u2014 \u0643\u0627\u062A\u0628\u0647\u0645\u0627 merchant_set_store_card");
            if (p.savings !== undefined) dbData.savings = p.savings;
            if (p.bookingsCount !== undefined) dbData.bookings_count = p.bookingsCount;
            // Array fields — only write when the caller really intends to
            // replace them. This is the followed-merchants protection.
            if (Array.isArray(p.notifKeywords)) dbData.notif_keywords = p.notifKeywords;
            if (Array.isArray(p.smartAlerts)) dbData.smart_alerts = p.smartAlerts;
            if (Array.isArray(p.followedMerchants)) dbData.followed_merchants = p.followedMerchants;
            if (Array.isArray(p.blockedMerchants)) dbData.blocked_merchants = p.blockedMerchants;
            if (p.preferredLang !== undefined) dbData.preferred_lang = p.preferredLang;
            if (p.lat !== undefined) dbData.lat = p.lat;
            if (p.lng !== undefined) dbData.lng = p.lng;
            // v14.06 — عنوان التوصيل: يمرّ بنفس قاعدة الجزئية (undefined = لا تلمس،
            // null = محو مقصود). قيد القاعدة يرفض العنوان بلا إحداثيات رقمية.
            if (p.deliveryAddress !== undefined) dbData.delivery_address = p.deliveryAddress;
            if (p.googleMapsLink !== undefined) dbData.google_maps_link = p.googleMapsLink;
            if (p.workingHours !== undefined) dbData.working_hours = p.workingHours;
            // upsert needs the conflict column when the row already exists.
            // Internal 15s ceiling — if the Supabase JS SDK's auth-refresh
            // inTabLock is stuck (iOS Safari backgrounding hazard), the
            // upsert promise never settles. Without this, the outer
            // withTimeout in the caller has to wait its full 30s budget on
            // top of any other awaits, producing a "spinner forever" UX.
            const { error: error } = await (0, $3rEkS.withTimeout)((0, $hUL2G.supabase).from('users').upsert(dbData, {
                onConflict: 'id'
            }), 15000);
            if (!error) {
                (0, $4aj47.logger).log("\u2705 Profile saved to remote successfully:", profile.id);
                return;
            }
            (0, $4aj47.logger).error("\u274C Remote profile sync failed:", error.message, error.details, error.hint);
            throw error;
        } catch (error) {
            console.error("\u274C Remote profile sync exception:", error.message || error);
            throw error;
        }
    },
    /**
     * Fetch favorites from Supabase `favorites` table first,
     * falling back to user_metadata, then localStorage
     */ getFavorites: async ()=>{
        try {
            // getSession() reads the in-memory/localStorage session — no
            // network. getUser() round-trips to the GoTrue /user endpoint
            // every call; this runs on every cold load and every focus
            // re-sync, so that round-trip was pure latency.
            const { data: { session: session } } = await (0, $hUL2G.supabase).auth.getSession();
            const sUser = session?.user;
            if (sUser) {
                // Try the dedicated favorites table first (skip if table doesn't exist)
                try {
                    const { data: favRows, error: error } = await (0, $hUL2G.supabase).from('favorites').select('deal_id').eq('user_id', sUser.id);
                    // 🪤 v14.63 — كان الشرط `favRows.length > 0`: من أزال **آخر**
                    // مفضلة له يسقط إلى نسخة `user_metadata` القديمة فتعود
                    // مفضلاته المحذوفة عند أول تحديث. الجدول هو الحقيقة،
                    // والمصفوفة الفارغة **جوابٌ صحيح** لا غيابُ جواب.
                    if (!error && favRows) return favRows.map((r)=>r.deal_id);
                } catch (tableError) {
                    console.warn('Favorites table not available, skipping remote favorites fetch');
                }
                // Fallback to user_metadata
                if (sUser.user_metadata?.favorites) return sUser.user_metadata.favorites;
            }
        } catch (e) {
            console.error('Failed to fetch remote favorites', e);
        }
        return [];
    },
    /**
     * v14.63 — مفضلة حقيقية: **صفٌّ واحد لكل نقرة**.
     * ═══════════════════════════════════════════════════════════════════
     * كانت `setFavorites` تقرأ كل الصفوف ثم تفارق ثم تكتب ثم تنادي
     * `auth.updateUser` — أربع جولات شبكة لكل نقرة، و«آخر كاتبٍ يفوز» فنقرتان
     * سريعتان تضيّع إحداهما، ونداءُ `updateUser` يُطلق حدث `USER_UPDATED`
     * فيُعاد ترطيب الحساب كلّه. والأهمّ: كانت **صامتة** — لا تتحقّق من شيء،
     * وقاعدة المشروع أن كل كتابة تُثبَت بـ`.select()` وعدد صفوف، لأن ما ترفضه
     * RLS يعود بـ`error = null` وصفر صفوف.
     */ addFavorite: (dealId)=>$36f0ffad69c48cc6$var$queueFavorite(dealId, async ()=>{
            try {
                const { data: { session: session } } = await (0, $hUL2G.supabase).auth.getSession();
                const userId = session?.user?.id;
                if (!userId) return false;
                // 🪤 لا `upsert` هنا: PostgREST يترجمها إلى `ON CONFLICT DO UPDATE`،
                // و`public.favorites` **بلا سياسة UPDATE** — فإعادة حفظ صفٍّ قائم
                // كانت سترفضها RLS. الإدراج المباشر يكفي، و«مكرّر» (23505) معناه
                // أن المطلوب حاصلٌ أصلاً فهو نجاح لا فشل.
                const { data: data, error: error } = await (0, $hUL2G.supabase).from('favorites').insert({
                    user_id: userId,
                    deal_id: dealId
                }).select('deal_id');
                if (error) {
                    if (error.code === '23505') return true;
                    console.warn('addFavorite:', error.message);
                    return false;
                }
                return (data?.length ?? 0) > 0;
            } catch (e) {
                console.warn('addFavorite failed', e);
                return false;
            }
        }),
    removeFavorite: (dealId)=>$36f0ffad69c48cc6$var$queueFavorite(dealId, async ()=>{
            try {
                const { data: { session: session } } = await (0, $hUL2G.supabase).auth.getSession();
                const userId = session?.user?.id;
                if (!userId) return false;
                const { data: data, error: error } = await (0, $hUL2G.supabase).from('favorites').delete().eq('user_id', userId).eq('deal_id', dealId).select('deal_id');
                if (error) {
                    console.warn('removeFavorite:', error.message);
                    return false;
                }
                return (data?.length ?? 0) > 0;
            } catch (e) {
                console.warn('removeFavorite failed', e);
                return false;
            }
        }),
    /** دمج مفضلة الزائر في حسابه عند أول دخول — بلا أن يضيع ما حفظه قبل التسجيل. */ mergeFavorites: async (ids)=>{
        if (!ids.length) return;
        try {
            const { data: { session: session } } = await (0, $hUL2G.supabase).auth.getSession();
            const userId = session?.user?.id;
            if (!userId) return;
            // `ignoreDuplicates` ⇒ `ON CONFLICT DO NOTHING`: لا حاجة لسياسة UPDATE.
            // وصفٌّ يشير إلى عرضٍ حُذف يُسقط الدفعة كلها بمفتاحٍ أجنبي، فنُدرج
            // واحداً واحداً: ما ينجح يُحفظ، وما يفشل لا يُسقط الباقي.
            const rows = ids.map((deal_id)=>({
                    user_id: userId,
                    deal_id: deal_id
                }));
            const { error: error } = await (0, $hUL2G.supabase).from('favorites').upsert(rows, {
                onConflict: 'user_id,deal_id',
                ignoreDuplicates: true
            });
            if (error) for (const r of rows)await (0, $hUL2G.supabase).from('favorites').upsert(r, {
                onConflict: 'user_id,deal_id',
                ignoreDuplicates: true
            });
        } catch (e) {
            console.warn('mergeFavorites failed', e);
        }
    },
    /**
     * Count how many users follow a given store. Uses the array-contains
     * operator on users.followed_merchants. Falls back to 0 on error so the
     * UI never shows a fake number.
     */ getFollowerCount: async (storeId)=>{
        // v11.43: via SECURITY DEFINER RPC — the users RLS policy no longer lets
        // anon/buyers be counted directly (PII lockdown), so a table read would
        // under-count. The RPC counts buyers who follow this store safely.
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('store_follower_count', {
                p_store_id: storeId
            });
            if (error) throw error;
            return Number(data) || 0;
        } catch (e) {
            console.warn('Follower count fetch failed:', e);
            return 0;
        }
    },
    /**
     * Fetch followed merchants from the user row, falling back to localStorage.
     */ getFollowedMerchants: async ()=>{
        try {
            const { data: { session: session } } = await (0, $hUL2G.supabase).auth.getSession();
            if (session?.user) {
                const { data: data, error: error } = await (0, $hUL2G.supabase).from('users').select('followed_merchants').eq('id', session.user.id).maybeSingle();
                if (data && !error && Array.isArray(data.followed_merchants)) return data.followed_merchants;
            }
        } catch (e) {
            console.warn('Followed merchants remote fetch failed:', e);
        }
        return [];
    },
    findById: async (id)=>{
        // Try remote first
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('users').select('*').eq('id', id).maybeSingle();
            if (data && !error) return {
                id: data.id,
                name: data.name,
                phone: data.phone,
                email: data.email,
                userType: data.user_type,
                shop: data.shop,
                contactPhone: data.contact_phone,
                savings: data.savings,
                bookingsCount: data.bookings_count,
                notifKeywords: data.notif_keywords,
                smartAlerts: Array.isArray(data.smart_alerts) ? data.smart_alerts : [],
                preferredLang: data.preferred_lang || 'ar',
                followedMerchants: Array.isArray(data.followed_merchants) ? data.followed_merchants : [],
                blockedMerchants: Array.isArray(data.blocked_merchants) ? data.blocked_merchants : [],
                lat: data.lat,
                lng: data.lng,
                // v14.06 — عنوان التوصيل الدائم. `select('*')` يُرجعه أصلاً،
                // وكان يسقط في التحويل فيصل التطبيق «بلا عنوان» فيُخفي التوصيل.
                deliveryAddress: data.delivery_address && typeof data.delivery_address === 'object' ? data.delivery_address : null,
                googleMapsLink: data.google_maps_link,
                workingHours: data.working_hours,
                isSuperAdmin: data.is_super_admin === true,
                adminPermissions: Array.isArray(data.admin_permissions) ? data.admin_permissions : []
            };
        } catch (e) {
            console.error('Remote user lookup failed', e);
        }
        // Fallback to local
        const current = (0, $1BuUO.authService).getUser();
        return current?.id === id ? current : null;
    },
    searchStores: async (query)=>{
        if (!query || !query.trim()) return [];
        try {
            // SECURITY: Sanitize query to prevent PostgREST filter injection.
            // Escape %, _, and \ which are special in ILIKE patterns.
            const sanitized = query.trim().substring(0, 100) // Limit length
            .replace(/\\/g, '\\\\').replace(/%/g, '\\%').replace(/_/g, '\\_').replace(/['"(),.:]/g, ''); // Strip filter-breaking chars
            if (!sanitized) return [];
            // v13.71 — نفس مبدأ getAllSellers: الدليل العام أولاً (حقول عامة
            // فقط)، وارتداد للجدول قبل تطبيق الترحيل. و`neq('buyer')` بدل
            // `eq('seller')` حتى يظهر متجر ناصر المملوك لحساب أدمن في البحث.
            if ($36f0ffad69c48cc6$var$publicDirectoryAvailable !== false) {
                const viaView = await (0, $hUL2G.supabase).from('sellers_public').select($36f0ffad69c48cc6$export$3836b98b2bc8c6ff).or(`shop.ilike.%${sanitized}%,name.ilike.%${sanitized}%`).limit(10);
                $36f0ffad69c48cc6$var$publicDirectoryAvailable = !viaView.error;
                if (!viaView.error) return (viaView.data || []).map($36f0ffad69c48cc6$export$ba634ddffff70fff);
            }
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('users').select($36f0ffad69c48cc6$export$c5fca3d3276bc352).neq('user_type', 'buyer').or(`shop.ilike.%${sanitized}%,name.ilike.%${sanitized}%`).limit(10);
            if (data && !error) // v13.71 — كان هنا نسخة ثانية يدوية من محوّل الصفوف تنحرف عن
            // `mapUserRowToProfile` (كانت تُسقط `working_hours` مثلاً).
            return data.map($36f0ffad69c48cc6$export$ba634ddffff70fff);
        } catch (e) {
            console.error('Failed to search stores', e);
        }
        return [];
    },
    /**
     * v13.80 — دليل المتاجر صار **مسقوفاً**، والباقي يُجلب عند الحاجة.
     *
     * كان يُنزّل صفوف **كل تاجر في المنصّة** عند كل فتح للتطبيق وعند كل تحديث
     * كامل. بعشرات التجار هذا لا يُلاحَظ؛ بمئة ألف تاجر يصير كل فتح تنزيلاً
     * بعشرات الميغابايتات على كل جهاز — وهو أعنف سقف في المشروع قبل الملايين.
     *
     * الآن: صفحة أولى مسقوفة تكفي التصفّح العام، وأي متجر خارجها يُجلب
     * بمعرّفه لحظة ظهور عرضه أو فتح صفحته (`getSellersByIds`). النتيجة على
     * الشاشة واحدة، والحِمل صار بحجم ما يراه المستخدم لا بحجم المنصّة.
     */ getAllSellers: async (limit = $36f0ffad69c48cc6$export$2401025398cf3699)=>{
        try {
            // v13.71 — الدليل العام للمتاجر يُقرأ من `sellers_public` (حقول
            // عامة فقط)، وإن لم يوجد العرض بعد — أي قبل تطبيق ترحيل v13.71 على
            // الخادم — نرتدّ إلى الجدول كما كان. فالنشر آمن في الحالتين.
            if ($36f0ffad69c48cc6$var$publicDirectoryAvailable !== false) {
                const viaView = await (0, $hUL2G.supabase).from('sellers_public').select($36f0ffad69c48cc6$export$3836b98b2bc8c6ff).limit(limit);
                $36f0ffad69c48cc6$var$publicDirectoryAvailable = !viaView.error;
                if (!viaView.error) return (viaView.data || []).map($36f0ffad69c48cc6$export$ba634ddffff70fff);
            }
            // v13.71 — `neq('user_type','buyer')` لا `eq('seller')`: متجر ناصر
            // مملوك لحساب **أدمن**، وكل مرشِّح `user_type='seller'` في هذا
            // المستودع أخفاه تاريخياً (نفس درس قناة realtime في realtimeService).
            // النتيجة كانت: بطاقات متجره بلا شعار ولا ساعات عمل ولا رقم تواصل.
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('users').select($36f0ffad69c48cc6$export$c5fca3d3276bc352).neq('user_type', 'buyer').limit(limit);
            if (data && !error) return data.map($36f0ffad69c48cc6$export$ba634ddffff70fff);
        } catch (e) {
            console.error('Failed to fetch all sellers', e);
        }
        return [];
    },
    /**
     * v13.80 — ملفات متاجر بعينها (ما نقص عن الصفحة المسقوفة أعلاه).
     * تُجزَّأ الطلبات فلا يطول رابط الاستعلام مهما كثرت المعرّفات.
     */ getSellersByIds: async (ids)=>{
        const unique = Array.from(new Set((ids || []).filter(Boolean)));
        if (unique.length === 0) return [];
        const out = [];
        const CHUNK = 100;
        for(let i = 0; i < unique.length; i += CHUNK){
            const slice = unique.slice(i, i + CHUNK);
            try {
                if ($36f0ffad69c48cc6$var$publicDirectoryAvailable !== false) {
                    const viaView = await (0, $hUL2G.supabase).from('sellers_public').select($36f0ffad69c48cc6$export$3836b98b2bc8c6ff).in('id', slice);
                    $36f0ffad69c48cc6$var$publicDirectoryAvailable = !viaView.error;
                    if (!viaView.error) {
                        out.push(...(viaView.data || []).map($36f0ffad69c48cc6$export$ba634ddffff70fff));
                        continue;
                    }
                }
                const { data: data, error: error } = await (0, $hUL2G.supabase).from('users').select($36f0ffad69c48cc6$export$c5fca3d3276bc352).in('id', slice).neq('user_type', 'buyer');
                if (!error && data) out.push(...data.map($36f0ffad69c48cc6$export$ba634ddffff70fff));
            } catch (e) {
                console.warn('getSellersByIds chunk failed:', e);
            }
        }
        return out;
    }
};

});
parcelRegister("1BuUO", function(module, exports) {

$parcel$export(module.exports, "authService", function () { return $4643978bef7553cc$export$62819fe1bf99c5f7; });

var $hUL2G = parcelRequire("hUL2G");
const $4643978bef7553cc$export$62819fe1bf99c5f7 = {
    // Current memory-only profile for synchronous checks
    _profile: null,
    getUser: ()=>{
        return $4643978bef7553cc$export$62819fe1bf99c5f7._profile;
    },
    setUser: (profile)=>{
        $4643978bef7553cc$export$62819fe1bf99c5f7._profile = profile;
    },
    logout: async ()=>{
        // Clear local cache IMMEDIATELY
        $4643978bef7553cc$export$62819fe1bf99c5f7._profile = null;
        localStorage.removeItem('supabase.auth.token');
        Object.keys(localStorage).forEach((key)=>{
            if (key.startsWith('sb-') || key.includes('auth-token')) localStorage.removeItem(key);
        });
        try {
            await (0, $hUL2G.supabase).auth.signOut();
        } catch (e) {
            console.error('Signout Error', e);
        }
    },
    deleteAccount: async ()=>{
        try {
            // Call the RPC function to delete the user account in Supabase
            await (0, $hUL2G.supabase).rpc('delete_user_account');
            await (0, $hUL2G.supabase).auth.signOut();
        } catch (e) {
            console.error('Delete Account Error', e);
        }
        $4643978bef7553cc$export$62819fe1bf99c5f7._profile = null;
        localStorage.removeItem('supabase.auth.token');
    },
    isAuthenticated: ()=>{
        return $4643978bef7553cc$export$62819fe1bf99c5f7.getUser() !== null;
    },
    isAdmin: ()=>{
        const user = $4643978bef7553cc$export$62819fe1bf99c5f7.getUser();
        return !!user && user.userType === 'admin';
    },
    isSeller: ()=>{
        const user = $4643978bef7553cc$export$62819fe1bf99c5f7.getUser();
        return user?.userType === 'seller' || user?.userType === 'admin';
    },
    // ----------------------------------------------------
    //                 REAL SUPABASE AUTH
    // ----------------------------------------------------
    signUpWithPhone: async (profile, password)=>{
        if (!profile.phone) return {
            data: null,
            error: {
                message: 'Phone is required for phone signup'
            }
        };
        return await (0, $hUL2G.supabase).auth.signUp({
            phone: profile.phone,
            email: profile.email,
            password: password,
            options: {
                data: {
                    name: profile.name,
                    phone: profile.phone,
                    user_type: profile.userType,
                    shop: profile.shop,
                    contact_phone: profile.contactPhone || profile.phone,
                    address: profile.address || '',
                    savings: profile.savings || 0
                }
            }
        });
    },
    signUpWithEmail: async (email, password, userData, captchaToken)=>{
        return await (0, $hUL2G.supabase).auth.signUp({
            email: email,
            password: password,
            options: {
                // v13.52 — Cloudflare Turnstile. Passing a token while the auth
                // server still has CAPTCHA switched off is a no-op: GoTrue only
                // looks at this field once the feature is enabled. That is the
                // whole point of shipping the client half first — the day the
                // server switch flips, every page is already sending a token.
                ...captchaToken ? {
                    captchaToken: captchaToken
                } : {},
                // Pin the confirmation link's redirect target to the current
                // origin (https://www.takisa.net in production, or whatever
                // the user's browser shows). Without this, Supabase
                // falls back to its configured Site URL — which defaults to
                // localhost:3000 — and the email link sends the user to a
                // dead "ERR_CONNECTION_REFUSED" page on their phone. The
                // origin still has to be in the project's Redirect-URL
                // allowlist; we document that step in progress.md for v10.55.
                emailRedirectTo: window.location.origin,
                data: {
                    name: userData.name,
                    phone: userData.phone,
                    user_type: userData.user_type,
                    shop: userData.shop || null,
                    contact_phone: userData.contact_phone || userData.phone,
                    address: userData.address || '',
                    // v12.30 — referral attribution; handle_new_user resolves
                    // referred_by_code → the owning store's id server-side.
                    referral_source: userData.referral_source || null,
                    referral_source_detail: userData.referral_source_detail || null,
                    referred_by_code: userData.referred_by_code || null,
                    // v13.92 — لغة الواجهة وقت التسجيل. GoTrue يمرّر
                    // raw_user_meta_data للقالب باسم `.Data`، فهذا الحقل هو
                    // ما يجعل بريد التأكيد يصل عربياً لمن يسجّل بالعربية
                    // وإنجليزياً لمن يسجّل بالإنجليزية. غيابه = عربي.
                    lang: userData.lang === 'en' ? 'en' : 'ar'
                }
            }
        });
    },
    checkPhoneExists: async (phone)=>{
        // 🔴 v13.99 — كان يستعمل `find_email_by_phone`، وهي دالة **تسجيل دخول**
        // تستثني حسابات الإدارة عمداً منذ v12.39 (تدخل بالبريد لا بالجوال).
        // فكانت تُرجع فارغاً لرقم مسجَّل فعلاً ⇒ الموقع يقول «✅ الرقم متاح»
        // لرقم مأخوذ، ثم يفشل التسجيل عند القاعدة بخطأ غامض.
        //
        // السؤال هنا «هل الرقم مأخوذ؟» لا «بأي بريد يدخل صاحبه؟» — و
        // `account_exists` هي دالة هذا السؤال بالضبط، بلا أي استثناء.
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('account_exists', {
            p_email: null,
            p_phone: phone
        });
        // نرمي الخطأ عمداً: «تعذّر الفحص» ليست «متاح». الواجهة تُظهر تحذيراً
        // بدل علامة خضراء كاذبة.
        if (error) throw error;
        return !!(data && data.phone_taken);
    },
    checkEmailExists: async (email)=>{
        // v11.43: route through the SECURITY DEFINER `account_exists` RPC instead
        // of reading public.users directly. The users RLS policy no longer exposes
        // buyer rows to anon, so a direct table read would always miss buyers.
        // 🔴 v13.99 — كان `catch {} return false`: أي خطأ (حدّ محاولات، شبكة)
        // يُترجَم «البريد متاح» ويُظهر علامة خضراء كاذبة على بريد مأخوذ.
        // الفشل الآن يُرمى فتعرضه الواجهة تحذيراً — «لا أعرف» ليست «متاح».
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('account_exists', {
            p_email: email,
            p_phone: null
        });
        if (error) throw error;
        return !!(data && data.email_taken);
    },
    /**
     * Combined check: returns which fields are already taken
     * Used for real-time inline validation during registration.
     * v11.43: backed by the `account_exists` definer RPC (see checkEmailExists).
     */ checkFieldsAvailability: async (email, phone)=>{
        // v13.99 — لا ابتلاع صامت: «تعذّر الفحص» تُرمى ولا تُقدَّم كـ«متاح».
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('account_exists', {
            p_email: email ?? null,
            p_phone: phone ?? null
        });
        if (error) throw error;
        return {
            emailTaken: !!(data && data.email_taken),
            phoneTaken: !!(data && data.phone_taken)
        };
    },
    verifyOtp: async (phoneOrEmail, token, type)=>{
        if (type === 'sms') return await (0, $hUL2G.supabase).auth.verifyOtp({
            phone: phoneOrEmail,
            token: token,
            type: 'sms'
        });
        else return await (0, $hUL2G.supabase).auth.verifyOtp({
            email: phoneOrEmail,
            token: token,
            type: 'email'
        });
    },
    resendVerification: async (email, captchaToken)=>{
        // v13.98 — /resend من المسارات التي تحرسها كابتشا GoTrue (مع /signup
        // و/token و/recover). شاشة التحقّق تعرض ودجتها الخاص لهذا السبب.
        return await (0, $hUL2G.supabase).auth.resend({
            type: 'signup',
            email: email,
            ...captchaToken ? {
                options: {
                    captchaToken: captchaToken
                }
            } : {}
        });
    },
    signInWithPassword: async (identifier, password, type, captchaToken)=>{
        const opts = captchaToken ? {
            captchaToken: captchaToken
        } : undefined;
        if (type === 'phone') {
            // Normalize phone: digits only, strip 966/00966 country code
            let normalizedPhone = identifier.replace(/\D/g, '');
            if (normalizedPhone.startsWith('00966')) normalizedPhone = '0' + normalizedPhone.slice(5);
            else if (normalizedPhone.startsWith('966') && normalizedPhone.length > 10) normalizedPhone = '0' + normalizedPhone.slice(3);
            // النمط القديم: الحسابات المسجّلة بالجوال وحده بريدها <الجوال>@taki.app
            const dummyEmail = `${normalizedPhone}@taki.app`;
            // 🔴 v13.96 — كان هنا **سباق**: نداءا دخول متوازيان (البريد من الـRPC،
            // والبريد الوهمي القديم) وأوّلهما ينجح يفوز. صار السباق مستحيلاً بعد
            // تفعيل Turnstile: **الرمز يُستهلك مرة واحدة**، فالنداء الثاني يصل
            // بنفس الرمز فترفضه Cloudflare بـ`timeout-or-duplicate` — أي أن نصف
            // محاولات الدخول كانت ستفشل بخطأ «كابتشا» عشوائياً.
            //
            // البديل تسلسلي: نحسم البريد أولاً (الـRPC يغطّي كل صيغ الجوال
            // وبيانات الحساب)، ثم ننفق الرمز في نداء واحد فقط. تكلفتُه دورةُ
            // شبكة إضافية، وثمنُ السباق كان دخولاً متقطّعاً بلا سبب ظاهر.
            let targetEmail = null;
            try {
                const { data: rpcEmail } = await (0, $hUL2G.supabase).rpc('find_email_by_phone', {
                    input_phone: normalizedPhone
                });
                if (rpcEmail) targetEmail = String(rpcEmail);
            } catch  {}
            const result = await (0, $hUL2G.supabase).auth.signInWithPassword({
                email: targetEmail || dummyEmail,
                password: password,
                options: opts
            }).catch((err)=>({
                    error: {
                        message: err?.message || 'sign-in-failed'
                    }
                }));
            if (result?.data?.user) return result;
            const msg = String(result?.error?.message || '').toLowerCase();
            if (msg.includes('invalid login credentials')) // v13.97 — رسالة أوضح حين لا يُحلّ الرقم إلى بريد: بعض الحسابات
            // (كحسابات الإدارة) تدخل بالبريد وحده منذ v12.39، فالرقم الصحيح
            // يبدو «غير مسجّل». لا نُلمّح لنوع الحساب — نوجّه للبديل فقط.
            return {
                error: {
                    message: !targetEmail ? "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645. \u062C\u0631\u0651\u0628 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0645\u0631\u062A\u0628\u0637 \u0628\u0627\u0644\u062D\u0633\u0627\u0628\u060C \u0623\u0648 \u0633\u062C\u0651\u0644 \u062D\u0633\u0627\u0628\u0627\u064B \u062C\u062F\u064A\u062F\u0627\u064B." : "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0623\u0648 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649."
                }
            };
            return result;
        } else return await (0, $hUL2G.supabase).auth.signInWithPassword({
            email: identifier,
            password: password,
            options: opts
        });
    },
    // OAuth helpers — both use skipBrowserRedirect so the caller can catch
    // "provider is not enabled" / config errors and surface a friendly
    // Arabic message instead of letting Supabase navigate the user away
    // to a black JSON error page on supabase.co.
    signInWithApple: async ()=>{
        const result = await (0, $hUL2G.supabase).auth.signInWithOAuth({
            provider: 'apple',
            options: {
                redirectTo: window.location.origin,
                skipBrowserRedirect: true
            }
        });
        if (!result.error && result.data?.url) window.location.href = result.data.url;
        return result;
    },
    signInWithGoogle: async ()=>{
        const result = await (0, $hUL2G.supabase).auth.signInWithOAuth({
            provider: 'google',
            options: {
                redirectTo: window.location.origin,
                skipBrowserRedirect: true,
                queryParams: {
                    access_type: 'offline',
                    prompt: 'consent'
                }
            }
        });
        if (!result.error && result.data?.url) window.location.href = result.data.url;
        return result;
    },
    resetPassword: async (email, captchaToken)=>{
        // v13.96 — الكابتشا على الخادم تحرس /recover كما تحرس /signup و/token.
        return await (0, $hUL2G.supabase).auth.resetPasswordForEmail(email, {
            redirectTo: `${window.location.origin}/register`,
            ...captchaToken ? {
                captchaToken: captchaToken
            } : {}
        });
    },
    // Cancel an unverified signup. Calls the SQL function which removes the
    // auth.users row only if the email is still unconfirmed. Used by the
    // 10-minute verification timeout in the registration flow.
    //
    // v13.40 (security): the RPC used to take the email ALONE, from any
    // anonymous caller. That let anyone delete anyone else's pending signup
    // just by naming their address — and repeating it keeps that person from
    // ever completing registration. The RPC now also demands the account UUID
    // that signUp() handed back, which only the person who actually signed up
    // has. Callers must therefore pass `userId` through.
    cancelUnverifiedSignup: async (email, userId)=>{
        if (!userId) {
            console.error('cancelUnverifiedSignup: userId is required');
            return {
                error: {
                    message: 'userId is required'
                }
            };
        }
        try {
            return await (0, $hUL2G.supabase).rpc('cancel_unverified_signup', {
                target_email: email,
                target_id: userId
            });
        } catch (e) {
            console.error('Failed to cancel unverified signup:', e);
            return {
                error: e
            };
        }
    }
};

});


parcelRegister("lGggQ", function(module, exports) {

$parcel$export(module.exports, "notificationRepository", function () { return $c3feca12411c9f39$export$cb8f4724be6aca3b; });

var $hUL2G = parcelRequire("hUL2G");
const $c3feca12411c9f39$var$fromRow = (n)=>({
        id: n.id,
        userId: n.user_id,
        title: {
            ar: n.title_ar,
            en: n.title_en
        },
        body: {
            ar: n.body_ar,
            en: n.body_en
        },
        type: n.type,
        isRead: n.is_read,
        createdAt: new Date(n.created_at).getTime(),
        metadata: n.meta_data
    });
const $c3feca12411c9f39$export$cb8f4724be6aca3b = {
    /**
     * صفحة من الإشعارات بترقيم المفتاح (v14.26).
     *
     * 🪤 ما كان قبله: `fetchByUserId` تجلب ١٠٠ وتتوقّف، والشاشة تعرضها كلها بلا
     * زرّ «المزيد». قِيس على الإنتاج في ١٤ سبتمبر: حسابٌ لديه ٧٤٧ إشعاراً، أي
     * **٦٤٧ إشعاراً غير مرئية**، وعدّادُ الشريط السفلي يعدّ غير المقروء داخل
     * المئة وحدها فيكذب على صاحبه.
     *
     * المؤشّر مركّب `(created_at, id)` لا `created_at` وحده: إشعارات الحجز
     * الواحد تُكتب في نفس اللحظة من نفس المشغّل، فبلا فاصلٍ ثانٍ ثابت يتكرّر
     * صفٌّ ويُبتلع آخر عند حدّ الصفحة.
     */ browsePage: async (cursor, limit = 40, q)=>{
        const empty = {
            rows: [],
            hasMore: false,
            unreadTotal: 0,
            total: 0,
            matched: 0,
            cursor: null
        };
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('browse_notifications', {
                p_cursor_at: cursor?.at ?? null,
                p_cursor_id: cursor?.id ?? null,
                p_limit: limit,
                // v14.63 — البحث من الخادم: من له ٧٥٠ إشعاراً لا يبحث في آخر ٤٠.
                p_q: q && q.trim() ? q.trim() : null
            });
            if (error) {
                console.warn('browse_notifications:', error.message);
                return empty;
            }
            const d = data || {};
            if (!d.ok) return empty;
            const raw = Array.isArray(d.rows) ? d.rows : [];
            const last = raw[raw.length - 1];
            return {
                rows: raw.map($c3feca12411c9f39$var$fromRow),
                hasMore: !!d.has_more,
                unreadTotal: Number(d.unread_total) || 0,
                total: Number(d.total) || 0,
                matched: d.matched != null ? Number(d.matched) : Number(d.total) || 0,
                cursor: last ? {
                    at: last.created_at,
                    id: last.id
                } : null
            };
        } catch  {
            return empty;
        }
    },
    /**
     * حذف إشعار واحد (v14.63).
     * 🪤 حذفٌ ترفضه RLS يعود بـ`error = null` وصفر صفوف — فلا يكفي فحص الخطأ.
     * نطلب `.select('id')` ونعدّ الصفوف فعلاً، وإلا كان الزرّ صامتاً يكذب.
     */ remove: async (id)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('notifications').delete().eq('id', id).select('id');
        if (error) {
            console.warn('notif delete:', error.message);
            return false;
        }
        return (data?.length || 0) > 0;
    },
    /** حذف كل ما قُرئ. يُرجع العدد المحذوف فعلاً (لا المتوقَّع). */ removeAllRead: async (userId)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('notifications').delete().eq('user_id', userId).eq('is_read', true).select('id');
        if (error) {
            console.warn('notif bulk delete:', error.message);
            return 0;
        }
        return data?.length || 0;
    },
    fetchByUserId: async (userId)=>{
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('notifications').select('*').eq('user_id', userId).order('created_at', {
                ascending: false
            }).limit(100);
            if (error) throw error;
            return (data || []).map($c3feca12411c9f39$var$fromRow);
        } catch (error) {
            console.warn("\u274C Failed to fetch notifications:", error);
            return [];
        }
    },
    save: async (notif)=>{
        try {
            const dbData = {
                id: notif.id,
                user_id: notif.userId,
                title_ar: notif.title.ar,
                title_en: notif.title.en,
                body_ar: notif.body.ar,
                body_en: notif.body.en,
                type: notif.type,
                is_read: notif.isRead,
                meta_data: notif.metadata || {},
                created_at: new Date(notif.createdAt).toISOString()
            };
            const { error: error } = await (0, $hUL2G.supabase).from('notifications').upsert(dbData);
            if (error) throw error;
        } catch (error) {
            console.warn("\u274C Failed to save notification:", error);
        }
    },
    markAsRead: async (id)=>{
        try {
            const { error: error } = await (0, $hUL2G.supabase).from('notifications').update({
                is_read: true
            }).eq('id', id);
            if (error) throw error;
        } catch (error) {
            console.warn("\u274C Failed to mark notification as read:", error);
        }
    },
    // Mark every unread notification for a user as read in one round-trip — powers
    // the "قراءة الكل / Mark all read" button. RLS (notifs_update_own) restricts the
    // UPDATE to the caller's own rows, so user_id must be the signed-in user.
    markAllAsRead: async (userId)=>{
        try {
            const { error: error } = await (0, $hUL2G.supabase).from('notifications').update({
                is_read: true
            }).eq('user_id', userId).eq('is_read', false);
            if (error) throw error;
        } catch (error) {
            console.warn("\u274C Failed to mark all notifications as read:", error);
        }
    },
    deleteByUser: async (userId)=>{
        try {
            await (0, $hUL2G.supabase).from('notifications').delete().eq('user_id', userId);
        } catch (error) {
            console.warn("\u274C Failed to delete notifications:", error);
        }
    }
};

});

parcelRegister("7hk6Y", function(module, exports) {

$parcel$export(module.exports, "BOOKINGS_PAGE_SIZE", function () { return $e430dee9eb650eb7$export$56273d3653886102; });
$parcel$export(module.exports, "mapBookingRow", function () { return $e430dee9eb650eb7$export$b20131ff5da140b3; });
$parcel$export(module.exports, "bookingRepository", function () { return $e430dee9eb650eb7$export$28f38f789ef70bab; });
/**
 * Booking Repository — Data access layer for bookings.
 * All data operations are server-only via Supabase.
 */ 
var $hUL2G = parcelRequire("hUL2G");

var $eGYci = parcelRequire("eGYci");

var $4aj47 = parcelRequire("4aj47");
const $e430dee9eb650eb7$export$3d64226e8a52ea5 = 200;
const $e430dee9eb650eb7$export$56273d3653886102 = 20;
const $e430dee9eb650eb7$var$mapMessage = (m)=>({
        id: m.id,
        barcode: m.barcode,
        senderId: m.sender_id,
        senderRole: m.sender_role,
        body: m.body,
        createdAt: new Date(m.created_at).getTime(),
        readAt: m.read_at ? new Date(m.read_at).getTime() : null,
        attachmentPath: m.attachment_path ?? null
    });
// Status progression rank — higher = more advanced. When local and remote
// disagree on the same barcode (e.g. seller acknowledged offline, remote
// hasn't synced yet, or RLS briefly rejected the update), prefer the higher
// status so a confirmed receipt never reverts to "pending" on refresh.
const $e430dee9eb650eb7$var$STATUS_RANK = {
    pending: 0,
    acknowledged: 1,
    completed: 2,
    cancelled: 2
};
const $e430dee9eb650eb7$var$moreAdvanced = (a, b)=>$e430dee9eb650eb7$var$STATUS_RANK[a] >= $e430dee9eb650eb7$var$STATUS_RANK[b] ? a : b;
const $e430dee9eb650eb7$export$b20131ff5da140b3 = (b, deal)=>({
        barcode: b.barcode,
        backupCode: b.backup_code,
        deal: deal || {
            id: b.deal_id,
            storeId: b.store_id,
            itemName: "\u062A\u062E\u0641\u064A\u0636"
        },
        userId: b.user_id,
        userName: b.user_name || undefined,
        userPhone: b.user_phone || undefined,
        bookedQuantity: b.booked_quantity,
        prepTime: b.prep_time,
        notes: b.notes,
        merchantNote: b.merchant_note,
        status: b.status,
        bookedAt: b.booked_at,
        // v15.44 — لحظةُ ضغط التاجر «تأكيد استلام الطلب»: منها تبدأ مهلةُ الختم بلا كود.
        acknowledgedAt: b.acknowledged_at ? new Date(b.acknowledged_at).getTime() : undefined,
        completedAt: b.completed_at ? new Date(b.completed_at).getTime() : undefined,
        paidAt: b.paid_at ? new Date(b.paid_at).getTime() : undefined,
        paymentProvider: b.payment_provider || undefined,
        paidAmount: b.paid_amount != null ? Number(b.paid_amount) : undefined,
        paymentMethod: b.payment_method === 'cod' || b.payment_method === 'online' ? b.payment_method : undefined,
        cancelledBy: b.cancelled_by || undefined,
        fulfillment: b.fulfillment === 'delivery' ? 'delivery' : 'pickup',
        deliveryAddress: b.delivery_address && typeof b.delivery_address === 'object' ? b.delivery_address : null,
        deliveryFee: b.delivery_fee != null ? Number(b.delivery_fee) : undefined,
        totalAmount: b.total_amount != null ? Number(b.total_amount) : undefined,
        refund: b.refund ?? undefined,
        selectedOptions: Array.isArray(b.selected_options) ? b.selected_options : undefined,
        locationId: b.location_id || undefined,
        expiryTime: b.expiry_time
    });
const $e430dee9eb650eb7$export$28f38f789ef70bab = {
    /**
     * v13.28 — صفحة طلبات من الخادم بترقيم keyset.
     *
     * الترشيح (مشترٍ/تاجر، جارٍ/سابق) والبحث والعدّ كلها على القاعدة، والعرض
     * مُرفَق في نفس الصف — فلا جولة شبكة ثانية لجلب المنتجات. البحث يمرّ على
     * محرك التطبيع العربي نفسه، فـ«قهوه» تجد «قهوة».
     */ browse: async (p = {})=>{
        const empty = {
            bookings: [],
            total: 0,
            totalCapped: false,
            hasMore: false,
            cursor: null
        };
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('browse_bookings', {
                p_scope: p.scope || 'buyer',
                p_state: p.state || 'all',
                p_query: p.query?.trim() || null,
                p_cursor_ts: p.cursor ? p.cursor.ts : null,
                p_cursor_id: p.cursor ? p.cursor.id : null,
                p_limit: Math.max(1, Math.min(50, p.limit ?? $e430dee9eb650eb7$export$56273d3653886102))
            });
            if (error) throw error;
            const rows = Array.isArray(data?.rows) ? data.rows : [];
            return {
                bookings: rows.map((r)=>$e430dee9eb650eb7$export$b20131ff5da140b3(r, r.deal ? (0, $eGYci.dealRepository).mapRowToDeal(r.deal) : undefined)),
                total: Number(data?.total) || 0,
                totalCapped: !!data?.total_capped,
                hasMore: !!data?.has_more,
                cursor: data?.has_more && data?.next_ts && data?.next_id ? {
                    ts: String(data.next_ts),
                    id: String(data.next_id)
                } : null
            };
        } catch (e) {
            console.error("\u274C browse_bookings failed:", e);
            return empty;
        }
    },
    getAll: async ()=>{
        // Return empty array if not specific to a user, as we don't fetch all bookings anymore
        return [];
    },
    /**
     * نافذة الطلبات الأحدث للمستخدم (مشترياً أو تاجراً) — تُغذّي الحالة العامة.
     *
     * v13.28 — كانت بلا حد ولا ترتيب: التاجر الناجح بعشرات الآلاف من الطلبات
     * ينزّلها **كلها** عند كل فتح للتطبيق. الآن سقف ثابت بترتيب الأحدث، فحجم
     * التحميل لا يكبر مع نجاح التاجر أبداً. القوائم الكاملة تأتي من
     * `browse()` المُرقَّم، والإحصاءات من `seller_order_stats` على القاعدة —
     * فلا شيء يعتمد على هذه النافذة ليكون صحيحاً.
     */ getByUser: async (userId, knownDeals)=>{
        try {
            // Fetch bookings where user is buyer (user_id) OR seller (store_id),
            // so the same call hydrates both sides of the transaction.
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('bookings').select('*').or(`user_id.eq.${userId},store_id.eq.${userId}`).order('created_at', {
                ascending: false
            }).limit($e430dee9eb650eb7$export$3d64226e8a52ea5);
            if (data && !error) {
                // Resolve the deal object WITHOUT re-fetching the entire deals
                // (+ ratings) tables. Before v10.71 this called
                // dealRepository.getAll() — two extra heavy Tokyo round-trips
                // on the critical path every time bookings loaded. Now: reuse
                // the caller's already-loaded deals; if absent, fetch only the
                // handful of deal rows these bookings actually reference.
                let deals = Array.isArray(knownDeals) ? knownDeals : [];
                const haveIds = new Set(deals.map((d)=>d.id));
                const missingIds = Array.from(new Set(data.map((b)=>b.deal_id).filter((id)=>id && !haveIds.has(id))));
                if (missingIds.length > 0) {
                    const { data: dealRows } = await (0, $hUL2G.supabase).from('deals').select('*').in('id', missingIds);
                    if (Array.isArray(dealRows)) deals = deals.concat(dealRows.map((0, $eGYci.dealRepository).mapRowToDeal));
                }
                const remoteBookings = data.map((b)=>({
                        barcode: b.barcode,
                        backupCode: b.backup_code,
                        deal: deals.find((d)=>d.id === b.deal_id) || {
                            id: b.deal_id,
                            storeId: b.store_id,
                            itemName: "\u062A\u062E\u0641\u064A\u0636"
                        },
                        userId: b.user_id,
                        userName: b.user_name || undefined,
                        userPhone: b.user_phone || undefined,
                        bookedQuantity: b.booked_quantity,
                        prepTime: b.prep_time,
                        notes: b.notes,
                        merchantNote: b.merchant_note,
                        status: b.status,
                        bookedAt: b.booked_at,
                        acknowledgedAt: b.acknowledged_at ? new Date(b.acknowledged_at).getTime() : undefined,
                        completedAt: b.completed_at ? new Date(b.completed_at).getTime() : undefined,
                        paidAt: b.paid_at ? new Date(b.paid_at).getTime() : undefined,
                        paymentProvider: b.payment_provider || undefined,
                        paidAmount: b.paid_amount != null ? Number(b.paid_amount) : undefined,
                        // v13.11 — نية الدفع وقت الحجز (يخفي «ادفع الآن» عن حجوزات COD)
                        paymentMethod: b.payment_method === 'cod' || b.payment_method === 'online' ? b.payment_method : undefined,
                        // v13.13 — من ألغى الطلب (للفاتورة)
                        cancelledBy: b.cancelled_by || undefined,
                        // v14.06 — التوصيل: الطريقة والعنوان والرسوم (كلها من الخادم)
                        fulfillment: b.fulfillment === 'delivery' ? 'delivery' : 'pickup',
                        deliveryAddress: b.delivery_address && typeof b.delivery_address === 'object' ? b.delivery_address : null,
                        deliveryFee: b.delivery_fee != null ? Number(b.delivery_fee) : undefined,
                        totalAmount: b.total_amount != null ? Number(b.total_amount) : undefined,
                        // v12.88 — الاختيارات المهيكلة تُقرأ لبناء باركود الكاشير في الفاتورة
                        selectedOptions: Array.isArray(b.selected_options) ? b.selected_options : undefined,
                        // v12.91 — الفرع المختار
                        locationId: b.location_id || undefined,
                        expiryTime: b.expiry_time
                    }));
                return remoteBookings;
            }
        } catch (e) {
            console.warn('Remote booking fetch failed:', e);
        }
        return [];
    },
    getByStore: async (storeId)=>{
        const all = await $e430dee9eb650eb7$export$28f38f789ef70bab.getAll();
        return all.filter((b)=>b.deal?.storeId === storeId);
    },
    getByBarcode: async (barcode)=>{
        try {
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('bookings').select('*').or(`barcode.eq.${barcode},backup_code.eq.${barcode}`).single();
            if (data && !error) {
                const deal = await (0, $eGYci.dealRepository).getById(data.deal_id);
                return {
                    barcode: data.barcode,
                    backupCode: data.backup_code,
                    deal: deal || {
                        id: data.deal_id,
                        storeId: data.store_id,
                        itemName: "\u062A\u062E\u0641\u064A\u0636"
                    },
                    userId: data.user_id,
                    userName: data.user_name || undefined,
                    userPhone: data.user_phone || undefined,
                    bookedQuantity: data.booked_quantity,
                    prepTime: data.prep_time,
                    notes: data.notes,
                    merchantNote: data.merchant_note,
                    status: data.status,
                    bookedAt: data.booked_at,
                    acknowledgedAt: data.acknowledged_at ? new Date(data.acknowledged_at).getTime() : undefined,
                    completedAt: data.completed_at ? new Date(data.completed_at).getTime() : undefined,
                    paidAt: data.paid_at ? new Date(data.paid_at).getTime() : undefined,
                    paymentProvider: data.payment_provider || undefined,
                    paidAmount: data.paid_amount != null ? Number(data.paid_amount) : undefined,
                    paymentMethod: data.payment_method === 'cod' || data.payment_method === 'online' ? data.payment_method : undefined,
                    cancelledBy: data.cancelled_by || undefined,
                    fulfillment: data.fulfillment === 'delivery' ? 'delivery' : 'pickup',
                    deliveryAddress: data.delivery_address && typeof data.delivery_address === 'object' ? data.delivery_address : null,
                    deliveryFee: data.delivery_fee != null ? Number(data.delivery_fee) : undefined,
                    totalAmount: data.total_amount != null ? Number(data.total_amount) : undefined,
                    expiryTime: data.expiry_time
                };
            }
        } catch (e) {
            console.error('Remote fetch by barcode failed:', e);
        }
        return undefined;
    },
    save: async (booking)=>{
        // Sync to remote
        try {
            const bookingRecord = {
                barcode: booking.barcode,
                backup_code: booking.backupCode,
                deal_id: booking.deal?.id,
                user_id: booking.userId,
                // Denormalize the buyer's name + phone onto the booking row.
                // The seller's order list is a single bookings query and RLS
                // does not let a seller read the buyer's `users` row, so
                // without this the seller only ever saw the raw UUID. Captured
                // at booking time = correct even if the buyer renames later.
                user_name: booking.userName ?? null,
                user_phone: booking.userPhone ?? null,
                store_id: booking.deal?.storeId || booking.deal?.store_id,
                booked_quantity: booking.bookedQuantity,
                prep_time: booking.prepTime,
                notes: booking.notes,
                // v12.53 — الاختيارات المهيكلة: يقرؤها tr_booking_options لخصم
                // كميات الخيارات المسقوفة (النص القارئ للتاجر داخل notes أصلاً)
                selected_options: booking.selectedOptions && booking.selectedOptions.length ? booking.selectedOptions : null,
                location_id: booking.locationId || null,
                // v13.11 — نية الدفع وقت الحجز (cod/online) لإخفاء «ادفع الآن» عن COD
                payment_method: booking.paymentMethod || null,
                // v14.06 — التوصيل: نرسل الطريقة والعنوان فقط. الرسوم يحسبها
                // حارس القاعدة من نطاق التاجر ويكتبها بنفسه — أي رقم من العميل
                // يُتجاهل، فلا يستطيع مشترٍ تخفيض رسوم توصيله.
                fulfillment: booking.fulfillment === 'delivery' ? 'delivery' : 'pickup',
                delivery_address: booking.fulfillment === 'delivery' ? booking.deliveryAddress || null : null,
                status: booking.status,
                booked_at: booking.bookedAt,
                expiry_time: booking.expiryTime
            };
            const { error: error } = await (0, $hUL2G.supabase).from('bookings').upsert(bookingRecord);
            if (error) throw error;
            (0, $4aj47.logger).log("\u2705 Booking saved to remote");
        } catch (e) {
            // v13.14 — لا ابتلاع: الرفض (نفدت الكمية/حظر/حدود) يجب أن يصل
            // للمستدعي ليتراجع محلياً ويعرض السبب للمشتري. كان الابتلاع هنا
            // يجعل rollback الـv12.76 في bookDeal لا يعمل أبداً.
            console.error('Remote booking sync failed:', e);
            throw e;
        }
    },
    updateStatus: async (barcode, status, merchantNote)=>{
        // Atomic, awaited status transition via server-side RPC.
        // The RPC guards the precondition (status was pending/acknowledged),
        // checks auth, and raises a clear error if anything is off. This is
        // the v10.20 fix for the "completion silently reverts" bug — the
        // previous fire-and-forget `.update()` could fail without the
        // optimistic UI ever noticing.
        try {
            let rpcName;
            let args;
            if (status === 'completed') {
                rpcName = 'complete_booking';
                args = {
                    p_barcode: barcode
                };
            } else if (status === 'acknowledged') {
                rpcName = 'acknowledge_booking';
                args = {
                    p_barcode: barcode,
                    p_merchant_note: merchantNote ?? null
                };
            } else if (status === 'cancelled') {
                rpcName = 'cancel_booking';
                args = {
                    p_barcode: barcode
                };
            } else throw new Error(`Unsupported status transition: ${status}`);
            const { data: data, error: error } = await (0, $hUL2G.supabase).rpc(rpcName, args);
            if (error) throw error;
            if (!data) throw new Error('RPC returned no row');
            (0, $4aj47.logger).log("\u2705 Booking status updated via RPC:", barcode, "\u2192", status);
        } catch (e) {
            console.error('Remote status sync failed:', e);
            throw e;
        }
    },
    /**
     * v14.10 — «استلمت طلبي»: إغلاق المشتري لطلب توصيله بنفسه.
     *
     * لماذا دالة مستقلّة لا `updateStatus('completed')`؟ لأن `complete_booking`
     * تقبل المشتري والتاجر معاً بلا أي شرط آخر، فكان المشتري يستطيع إغلاق طلبٍ
     * لم يصله أصلاً. `buyer_confirm_receipt` تشترط أن يكون التاجر قد أعلن
     * انطلاق المندوب — وحالة المندوب لا يستطيع المشتري كتابتها إطلاقاً، فهي
     * الحصانة الحقيقية الوحيدة. وتُسجّل `completed_by='buyer'` كأثر للنزاعات.
     *
     * ترمي عند الرفض برسالة عربية جاهزة للعرض (P0001) — فلا زرّ صامت.
     */ buyerConfirmReceipt: async (barcode)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('buyer_confirm_receipt', {
            p_barcode: barcode
        });
        if (error) throw error;
        if (!data) throw new Error('RPC returned no row');
        (0, $4aj47.logger).log("\u2705 Buyer confirmed receipt:", barcode);
    },
    /**
     * v15.42 — اختصارُ التاجر: ختمُ الطلب **بلا كود**، للتاجر وحده وبعد
     * مهلة `self_close_minutes` (P0028 من القاعدة إن سبق وقتَه).
     * 🪤 ولا تُستعمل مكان `completeBooking`: مسارُ الكود هو الأصل، وهو فوريٌّ
     *    بلا مهلة — فعميلٌ واقفٌ عند الصندوق لا يُؤذَى بانتظار.
     */ merchantHandover: async (barcode)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('merchant_handover_booking', {
            p_barcode: barcode
        });
        if (error) throw error;
        if (!data) throw new Error('RPC returned no row');
        (0, $4aj47.logger).log("\u2705 Merchant handover (no code):", barcode);
    },
    remove: async (barcode)=>{
        // v13.71 — كان يبتلع كل شيء: لا يقرأ `error` العائد أصلاً، ولا يميّز
        // حذفاً رفضته RLS (يعود بصفر صفوف و`error=null`). أي نداء مستقبلي كان
        // سيحصل على «نجاح» وهمي. الآن يرمي، فيقرّر المُستدعي ماذا يعرض.
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('bookings').delete().eq('barcode', barcode).select('barcode');
        if (error) {
            console.error('Remote delete failed:', error);
            throw error;
        }
        if (!data || data.length === 0) throw new Error("BOOKING_DELETE_NOOP: \u0644\u0645 \u064A\u064F\u062D\u0630\u0641 \u0627\u0644\u062D\u062C\u0632 \u0645\u0646 \u0627\u0644\u0642\u0627\u0639\u062F\u0629 (\u0644\u0627 \u0635\u0644\u0627\u062D\u064A\u0629 \u0623\u0648 \u0628\u0627\u0631\u0643\u0648\u062F \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F).");
    },
    // ── Messages thread ──────────────────────────────────────────
    getMessages: async (barcode)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('booking_messages').select('*').eq('barcode', barcode).order('created_at', {
            ascending: true
        }).limit(200); // v13.29 — المحادثة محدودة بقاعدة العمل (٣+٣)؛ السقف حارس
        if (error) {
            console.warn('Fetch booking messages failed:', error.message);
            return [];
        }
        return (data || []).map($e430dee9eb650eb7$var$mapMessage);
    },
    sendMessage: async (barcode, body, attachmentPath)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('send_booking_message', {
            p_barcode: barcode,
            p_body: body,
            p_attachment_path: attachmentPath || null
        });
        if (error) throw error;
        if (!data) throw new Error('RPC returned no row');
        return $e430dee9eb650eb7$var$mapMessage(data);
    },
    markMessagesRead: async (barcode)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('mark_booking_messages_read', {
            p_barcode: barcode
        });
        if (error) {
            console.warn('Mark-read failed:', error.message);
            return 0;
        }
        return Number(data) || 0;
    },
    clearAll: async ()=>{
    // Remote clear not allowed
    }
};

});

parcelRegister("hVlFU", function(module, exports) {

$parcel$export(module.exports, "branchRepository", function () { return $8e49aaf645ef7491$export$4f923204491aa0c5; });

var $hUL2G = parcelRequire("hUL2G");
const $8e49aaf645ef7491$var$fromRow = (r)=>({
        id: r.id,
        merchantId: r.merchant_id,
        nameAr: r.name_ar,
        nameEn: r.name_en,
        regionId: r.region_id,
        cityId: r.city_id,
        locationId: r.location_id,
        address: r.address,
        mapLat: r.map_lat,
        mapLng: r.map_lng,
        googleMapsLink: r.google_maps_link,
        phone: r.phone,
        isPrimary: r.is_primary,
        isActive: r.is_active,
        showOnStorePage: r.show_on_store_page ?? false,
        createdAt: r.created_at,
        updatedAt: r.updated_at
    });
/**
 * صفّ القاعدة من كائن الفرع — **جزئيّ بالقصد** (v14.74).
 *
 * 🔴 ما كان قبله: كل حقلٍ يُكتب بـ`?? null` أو `?? false`، أي أن أي نداءٍ لا
 *    يذكر حقلاً **يمحوه**. وهو نفس العيب الذي كلّفنا `saveProfile` من قبل
 *    («اختفت المتابَعات بعد تعديل»). أثره هنا مباشر على ما شُحن اليوم:
 *      • `saveShopLocation` يبني كائناً بلا `address` — فكلّ ضغطة «حفظ الموقع»
 *        كانت ستمحو العنوان الذي كتبه التاجر للتوّ في الموقع الرئيسي.
 *      • ويبني بلا `isPrimary` في مسارٍ آخر — فيُصفَّر الموقع الرئيسي بلا أن
 *        يطلب أحد ذلك (وهو سببٌ مرشّح لـ«صفر رئيسي» في متجر تاكي).
 *
 * القاعدة الآن: عمودٌ يُكتب **فقط** إذا مُرِّر حقله صراحةً (`!== undefined`).
 * و`null` تبقى محواً مقصوداً. وللصفّ الجديد تكفي افتراضيّات القاعدة نفسها
 * (`is_active` = true · `is_primary` = false · `show_on_store_page` = false —
 * فُحصت على جدة)، فلا حاجة لكتابتها من هنا.
 */ const $8e49aaf645ef7491$var$toRow = (b)=>{
    const row = {
        ...b.id ? {
            id: b.id
        } : {},
        merchant_id: b.merchantId,
        name_ar: b.nameAr,
        updated_at: new Date().toISOString()
    };
    const put = (col, v)=>{
        if (v !== undefined) row[col] = v;
    };
    put('name_en', b.nameEn);
    put('region_id', b.regionId);
    put('city_id', b.cityId);
    put('location_id', b.locationId);
    put('address', b.address);
    put('map_lat', b.mapLat);
    put('map_lng', b.mapLng);
    put('google_maps_link', b.googleMapsLink);
    put('phone', b.phone);
    put('is_primary', b.isPrimary);
    put('is_active', b.isActive);
    put('show_on_store_page', b.showOnStorePage);
    return row;
};
const $8e49aaf645ef7491$export$4f923204491aa0c5 = {
    async listByMerchant (merchantId) {
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('store_branches').select('*').eq('merchant_id', merchantId).eq('is_active', true).order('created_at', {
            ascending: true
        });
        if (error) {
            console.error('branches list error', error);
            return [];
        }
        return (data || []).map($8e49aaf645ef7491$var$fromRow);
    },
    async upsert (branch) {
        const row = $8e49aaf645ef7491$var$toRow(branch);
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('store_branches').upsert(row, {
            onConflict: 'id'
        }).select().single();
        if (error) {
            console.error('branches upsert error', error);
            throw error;
        }
        return data ? $8e49aaf645ef7491$var$fromRow(data) : null;
    },
    /** v13.61 — إظهار/إخفاء فرع على صفحة المتجر. القاعدة هي التي تفرض حدّ
     *  الباقة؛ نُرجع رسالة عربية واضحة عند الرفض بدل خطأ تقني.
     *  v13.66 — نطلب الصفوف المتأثّرة (`select`) ونتحقّق أن الكتابة **وقعت**:
     *  سياسة RLS ترفض الكتابة بلا خطأ — تُرجع صفر صفوف و`error=null` — فكانت
     *  الواجهة تقول «تم» ولا شيء تغيّر في القاعدة. */ async setDisplayed (id, show) {
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('store_branches').update({
            show_on_store_page: show
        }).eq('id', id).select('id');
        if (!error) {
            if (!data || data.length === 0) return {
                ok: false,
                error: "\u0644\u0645 \u064A\u064F\u062D\u0641\u064E\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0641\u064A \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A (\u0644\u0627 \u0635\u0644\u0627\u062D\u064A\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0641\u0631\u0639). \u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0648\u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627\u064B."
            };
            return {
                ok: true
            };
        }
        const m = /BRANCH_DISPLAY_CAP:(\d+)/.exec(error.message || '');
        if (m) return {
            ok: false,
            cap: Number(m[1]),
            error: `\u{628}\u{627}\u{642}\u{62A}\u{643} \u{62A}\u{633}\u{645}\u{62D} \u{628}\u{639}\u{631}\u{636} ${m[1]} \u{645}\u{648}\u{642}\u{639} \u{639}\u{644}\u{649} \u{635}\u{641}\u{62D}\u{62A}\u{643}. \u{623}\u{62E}\u{641}\u{650} \u{645}\u{648}\u{642}\u{639}\u{627}\u{64B} \u{622}\u{62E}\u{631} \u{623}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{631}\u{642}\u{650}\u{651} \u{628}\u{627}\u{642}\u{62A}\u{643}.`
        };
        return {
            ok: false,
            error: error.message
        };
    },
    /**
     * الفروع الظاهرة للزوار على صفحة المتجر — **مسقوفة بحدّ الباقة الحيّ**.
     *
     * v13.67 — طبقة ثانية بأمر ناصر («تأكد أنها مربوطة بالباقة»). الطبقة الأولى
     * في القاعدة (مشغّلان: يمنع تجاوز الحدّ، ويُعيد المواءمة عند تغيّر الباقة).
     * لكن العرض كان يثق بعمود `show_on_store_page` وحده، فأي انحراف في الصفوف
     * — استعادة نسخة احتياطية، تعديل مباشر بـSQL، أو مسار اشتراك لا يُحدّث
     * الحدّ — كان يعني صفحةً تعرض أكثر مما تسمح به الباقة.
     *
     * الآن العدد **مسقوف عند القراءة**: مهما قالت الصفوف، لا يُعرض للزائر أكثر
     * من `store_profiles.max_branches`. الترتيب هو نفسه ترتيب دالة المواءمة في
     * القاعدة (الفرع الرئيسي ثم الأقدم) فلا تختلف النتيجتان أبداً.
     */ async listDisplayed (merchantId) {
        const [rowsRes, capRes] = await Promise.all([
            (0, $hUL2G.supabase).from('store_branches').select('*').eq('merchant_id', merchantId).eq('show_on_store_page', true).eq('is_active', true).order('is_primary', {
                ascending: false
            }).order('created_at', {
                ascending: true
            }),
            (0, $hUL2G.supabase).from('store_profiles').select('max_branches').eq('store_id', merchantId).maybeSingle()
        ]);
        if (rowsRes.error) return [];
        const rows = (rowsRes.data || []).map($8e49aaf645ef7491$var$fromRow);
        // بلا سقف معروف لا نخترع واحداً: الصفوف كما هي (القاعدة تحرسها أصلاً).
        const cap = Number(capRes.data?.max_branches);
        if (!Number.isFinite(cap) || cap <= 0) return rows;
        return rows.slice(0, cap);
    },
    /**
     * حذف فرع من القاعدة نهائياً.
     *
     * v13.66 — `.select()` إلزامي هنا: حذفٌ ترفضه سياسة RLS يعود بـ`error=null`
     * وصفر صفوف، فكانت الواجهة تُسقط الشريحة من الشاشة والصفّ باقٍ في القاعدة —
     * ويعود عند أول تحديث. الآن نتأكّد أن صفاً حُذف فعلاً وإلا نرمي خطأً
     * فيتراجع السياق ويرى التاجر رسالة صريحة. (بلاغ ناصر: «تأكد أن الإضافة
     * والحذف مربوطان بالداتابيس».)
     */ /**
     * v14.74 — تحرير بطاقة الموقع: الاسم والعنوان.
     *
     * لماذا هذان الحقلان تحديداً: قِيس على الإنتاج (٢١ سبتمبر ٢٠٢٦) أن **صفراً
     * من عشرة** مواقع يحمل عنواناً نصّياً — لأن العمود موجود وصفحة المتجر
     * تعرضه، ولم يكن في النظام **حقل إدخالٍ واحد** له. وأن متجراً له فرعان
     * نشطان اسمهما «الدمام» على بُعد ٤ كيلومترات — ولا سبيل للتاجر أن يميّزهما
     * لأن الاسم يُولَّد من اسم المدينة/المول ولا يُحرَّر.
     *
     * 🪤 `.select()` إلزامي: تحديثٌ ترفضه RLS يعود بـ`error=null` وصفر صفوف،
     *    فتقول الشاشة «حُفظ» ولا شيء في القاعدة (فخّ «الأزرار الصامتة»).
     * 🪤 ولا يمسّ هذا التحديث حارس السقف: `tr_enforce_branch_cap` يعمل على
     *    `UPDATE OF location_id, map_lat, map_lng, is_active` وحدها، فتحرير
     *    الاسم والعنوان لا يُرفض بسبب باقةٍ ممتلئة (فُحص على جدة).
     */ async setCard (id, patch) {
        const row = {};
        if (patch.nameAr !== undefined) {
            const n = String(patch.nameAr).trim().slice(0, 80);
            if (!n) return {
                ok: false,
                error: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0648\u0642\u0639 \u0644\u0627 \u064A\u0635\u062D\u0651 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0641\u0627\u0631\u063A\u0627\u064B."
            };
            row.name_ar = n;
        }
        if (patch.address !== undefined) row.address = String(patch.address ?? '').trim().slice(0, 200) || null;
        if (Object.keys(row).length === 0) return {
            ok: true
        };
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('store_branches').update(row).eq('id', id).select('id');
        if (error) {
            console.error('branches setCard error', error);
            // v14.74 — حارس القاعدة يمنع اسمين متطابقين بين المواقع النشطة.
            // رسالته تُترجَم هنا: نصّ خطأ PostgREST الخام لا يقول للتاجر ما يفعل.
            if (/BRANCH_NAME_DUP/i.test(error.message || '')) return {
                ok: false,
                error: "\u0644\u062F\u064A\u0643 \u0645\u0648\u0642\u0639\u064C \u0622\u062E\u0631 \u0628\u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u0645. \u0627\u062E\u062A\u0631 \u0627\u0633\u0645\u0627\u064B \u064A\u0645\u064A\u0651\u0632\u0647 (\u0648\u0627\u0643\u062A\u0628 \u0639\u0646\u0648\u0627\u0646\u0647) \u0644\u064A\u0641\u0631\u0651\u0642 \u0627\u0644\u0645\u0634\u062A\u0631\u064A \u0628\u064A\u0646\u0647\u0645\u0627."
            };
            return {
                ok: false,
                error: error.message
            };
        }
        if (!data || data.length === 0) return {
            ok: false,
            error: "\u0644\u0645 \u064A\u064F\u062D\u0641\u064E\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631 \u0641\u064A \u0627\u0644\u0642\u0627\u0639\u062F\u0629 (\u0644\u0627 \u0635\u0644\u0627\u062D\u064A\u0629 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0642\u0639). \u062D\u062F\u0651\u062B \u0627\u0644\u0635\u0641\u062D\u0629 \u0648\u062D\u0627\u0648\u0644 \u0645\u062C\u062F\u062F\u0627\u064B."
        };
        return {
            ok: true
        };
    },
    async remove (id) {
        const { data: data, error: error } = await (0, $hUL2G.supabase).from('store_branches').delete().eq('id', id).select('id');
        if (error) {
            console.error('branches delete error', error);
            throw error;
        }
        if (!data || data.length === 0) {
            const e = new Error("BRANCH_DELETE_NOOP: \u0627\u0644\u0635\u0641 \u0644\u0645 \u064A\u064F\u062D\u0630\u0641 \u0645\u0646 \u0627\u0644\u0642\u0627\u0639\u062F\u0629 (\u0644\u0627 \u0635\u0644\u0627\u062D\u064A\u0629 \u0623\u0648 \u0645\u064F\u0639\u0631\u0651\u0641 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F).");
            console.error(e.message, id);
            throw e;
        }
    }
};

});

parcelRegister("ke30W", function(module, exports) {

$parcel$export(module.exports, "sponsorRepository", function () { return $a1a16d88755aa222$export$3750e0b1ea1a2fc9; });
/**
 * Sponsor Repository (v11.23) — Official Sponsors (راعٍ رسمي).
 *
 * Read path: any client loads the active sponsors to render gold ads.
 * Write path: admin-only, routed through SECURITY DEFINER RPCs so RLS on
 * `sponsors` never has to self-reference.
 */ 
var $hUL2G = parcelRequire("hUL2G");

var $4aj47 = parcelRequire("4aj47");
const $a1a16d88755aa222$var$mapRow = (r)=>({
        storeId: r.store_id,
        isActive: r.is_active ?? true,
        targetCategory: r.target_category ?? null,
        targetCity: r.target_city ?? null,
        targetRegion: r.target_region ?? null,
        targetLat: r.target_lat ?? null,
        targetLng: r.target_lng ?? null,
        targetRadiusKm: r.target_radius_km ?? null,
        priority: r.priority ?? 0,
        labelType: r.label_type ?? 'ad',
        startsAt: r.starts_at ?? null,
        expiresAt: r.expires_at ?? null
    });
const $a1a16d88755aa222$export$3750e0b1ea1a2fc9 = {
    /**
     * Active, non-expired sponsors only. Used by every deal list to build the
     * gold-ad rotation. Cheap: one indexed scan, filtered to active rows.
     */ getActive: async ()=>{
        try {
            // NOTE: we deliberately do NOT use a PostgREST `.or(expires_at...)`
            // filter — an ISO timestamp contains ':' and '.' which break the
            // .or() mini-grammar and silently return nothing. Fetch active rows
            // and drop expired ones in JS (the active-sponsor set is tiny).
            const { data: data, error: error } = await (0, $hUL2G.supabase).from('sponsors').select('*').eq('is_active', true);
            if (error) throw error;
            const now = Date.now();
            return (data || []).filter((r)=>!r.expires_at || new Date(r.expires_at).getTime() > now).map($a1a16d88755aa222$var$mapRow);
        } catch (e) {
            console.warn('Failed to load sponsors:', e);
            return [];
        }
    },
    /** Admin: list every sponsor (active or not) with store name. */ listAll: async ()=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('admin_list_sponsors');
        if (error) {
            console.error('[sponsorRepository.listAll]', error);
            return [];
        }
        return (data || []).map((r)=>({
                ...$a1a16d88755aa222$var$mapRow(r),
                storeName: r.store_name,
                shop: r.shop,
                notes: r.notes ?? null
            }));
    },
    /** Admin: grant / update a sponsorship. */ set: async (p)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('admin_set_sponsor', {
            p_store_id: p.storeId,
            p_is_active: p.isActive ?? true,
            p_target_category: p.targetCategory ?? null,
            p_target_city: p.targetCity ?? null,
            p_target_region: p.targetRegion ?? null,
            p_target_lat: p.targetLat ?? null,
            p_target_lng: p.targetLng ?? null,
            p_target_radius_km: p.targetRadiusKm ?? null,
            p_priority: p.priority ?? 0,
            p_expires_at: p.expiresAt ?? null,
            p_notes: p.notes ?? null,
            p_label_type: p.labelType ?? 'ad',
            p_starts_at: p.startsAt ?? null
        });
        if (error) {
            console.error('[sponsorRepository.set]', error);
            return {
                success: false,
                error: error.message
            };
        }
        (0, $4aj47.logger).log("\u2705 Sponsor saved");
        return {
            success: !!data?.success
        };
    },
    /** Admin: revoke a sponsorship. */ remove: async (storeId)=>{
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('admin_remove_sponsor', {
            p_store_id: storeId
        });
        if (error) {
            console.error('[sponsorRepository.remove]', error);
            return {
                success: false,
                error: error.message
            };
        }
        return {
            success: !!data?.success
        };
    }
};

});

parcelRegister("k7Lgv", function(module, exports) {

$parcel$export(module.exports, "pushService", function () { return $de2e4176a2c46283$export$d2422b36bd687627; });
/**
 * pushService — اشتراك إشعارات الجوّال (Web Push) — v14.13
 * ═══════════════════════════════════════════════════════════════════════════
 * الإرسال يتم على الخادم: مشغّل `tr_notification_push` على جدول `notifications`
 * ينادي دالة `send-push` التي تُرسل لكل أجهزة صاحب الإشعار.
 *
 * 🪤 ما أُصلح هنا (v14.13):
 *   ١) **الإذن كان يُطلب لحظة فتح التطبيق** مقابل لا شيء يراه المستخدم — وهو
 *      أسوأ وقت لطلبه: أغلب الناس يرفضون، والرفض على الويب شبه نهائي (لا
 *      يُعاد السؤال). صار الطلب بزرٍّ صريح بعد أول حجز ناجح، حين يكون للإشعار
 *      معنى واضح: «طلبك جاهز» و«مندوبك انطلق».
 *   ٢) **تسجيل عامل الخدمة كان مربوطاً بطلب الإذن** — انتقل إلى `sw-cleanup`
 *      فصار يعمل دائماً بلا سؤال.
 *   ٣) **المفتاح العام كان يُنتظر من متغيّر بناء** لم يُضبط قط، فكانت الدالة
 *      تخرج صامتة. صار يُقرأ من `platform_settings.vapid_public_key` لحظياً —
 *      لا خطوة بناء ولا متغيّر بيئة على Vercel.
 */ 
var $hUL2G = parcelRequire("hUL2G");

var $4aj47 = parcelRequire("4aj47");
let $de2e4176a2c46283$var$_vapidCache = null;
/** المفتاح العام من القاعدة (عامٌّ بطبيعته — المتصفّح يحتاجه ليشترك). */ async function $de2e4176a2c46283$var$vapidKey() {
    if ($de2e4176a2c46283$var$_vapidCache !== null) return $de2e4176a2c46283$var$_vapidCache;
    try {
        const { data: data } = await (0, $hUL2G.supabase).from('platform_settings').select('value').eq('key', 'vapid_public_key').maybeSingle();
        $de2e4176a2c46283$var$_vapidCache = typeof data?.value === 'string' ? data.value : '';
    } catch  {
        $de2e4176a2c46283$var$_vapidCache = '';
    }
    return $de2e4176a2c46283$var$_vapidCache;
}
const $de2e4176a2c46283$var$urlBase64ToUint8Array = (b64)=>{
    const padding = '='.repeat((4 - b64.length % 4) % 4);
    const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = atob(base64);
    const out = new Uint8Array(raw.length);
    for(let i = 0; i < raw.length; i++)out[i] = raw.charCodeAt(i);
    return out;
};
const $de2e4176a2c46283$var$arrayBufferToBase64 = (buf)=>{
    if (!buf) return '';
    const bytes = new Uint8Array(buf);
    let s = '';
    for(let i = 0; i < bytes.length; i++)s += String.fromCharCode(bytes[i]);
    return btoa(s);
};
const $de2e4176a2c46283$var$isIOS = ()=>typeof navigator !== 'undefined' && (/iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
/** التطبيق مثبَّت على الشاشة الرئيسية؟ شرطٌ لا مفرّ منه لإشعارات آيفون. */ const $de2e4176a2c46283$var$isStandalone = ()=>{
    if (typeof window === 'undefined') return false;
    return window.navigator.standalone === true || window.matchMedia?.('(display-mode: standalone)').matches === true;
};
/** لا يُسجِّل عاملاً جديداً — التسجيل مسؤولية `sw-cleanup` وحدها. */ async function $de2e4176a2c46283$var$getRegistration() {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return null;
    try {
        return await navigator.serviceWorker.getRegistration('/') || await navigator.serviceWorker.ready.catch(()=>null);
    } catch  {
        return null;
    }
}
/** يكتب/يحدّث صفّ الاشتراك. يُرجع true عند النجاح. */ async function $de2e4176a2c46283$var$persist(sub, userId) {
    const json = sub.toJSON?.();
    const endpoint = json?.endpoint || sub.endpoint;
    const p256dh = json?.keys?.p256dh || $de2e4176a2c46283$var$arrayBufferToBase64(sub.getKey?.('p256dh') || null);
    const auth = json?.keys?.auth || $de2e4176a2c46283$var$arrayBufferToBase64(sub.getKey?.('auth') || null);
    if (!endpoint || !p256dh || !auth) return false;
    let uid = userId;
    if (!uid) try {
        uid = (await (0, $hUL2G.supabase).auth.getUser()).data?.user?.id;
    } catch  {}
    if (!uid) return false;
    // ⚠️ الكتابة تُرجع خطأً يجب فحصه — زرٌّ صامت يقول «تم» وهو لم يتم
    // هو بالضبط ما يجعل المستخدم ينتظر إشعاراً لن يصل.
    const { error: error } = await (0, $hUL2G.supabase).from('push_subscriptions').upsert({
        user_id: uid,
        endpoint: endpoint,
        p256dh: p256dh,
        auth: auth,
        user_agent: navigator.userAgent.slice(0, 240),
        last_used_at: new Date().toISOString()
    }, {
        onConflict: 'endpoint'
    });
    if (error) {
        (0, $4aj47.logger).warn('Push subscription upsert failed:', error.message);
        return false;
    }
    return true;
}
const $de2e4176a2c46283$export$d2422b36bd687627 = {
    /** ماذا نعرض للمستخدم على هذا الجهاز تحديداً؟ */ status: async ()=>{
        if (typeof window === 'undefined' || !('Notification' in window)) return $de2e4176a2c46283$var$isIOS() && !$de2e4176a2c46283$var$isStandalone() ? 'ios-needs-install' : 'unsupported';
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) return $de2e4176a2c46283$var$isIOS() && !$de2e4176a2c46283$var$isStandalone() ? 'ios-needs-install' : 'unsupported';
        // آيفون لا يوصّل إشعاراً إلا للتطبيق المثبَّت — قوله صراحةً أفضل من صمت.
        if ($de2e4176a2c46283$var$isIOS() && !$de2e4176a2c46283$var$isStandalone()) return 'ios-needs-install';
        if (Notification.permission === 'denied') return 'denied';
        if (Notification.permission !== 'granted') return 'off';
        try {
            const reg = await $de2e4176a2c46283$var$getRegistration();
            const sub = await reg?.pushManager.getSubscription();
            return sub ? 'on' : 'off';
        } catch  {
            return 'off';
        }
    },
    /**
     * يُنادى **من ضغطة زرّ صريحة فقط**: يطلب الإذن، ينشئ الاشتراك، يحفظه.
     * يُرجع الحالة النهائية كي يعرض المتّصل الرسالة الصحيحة.
     */ enable: async (userId)=>{
        const pre = await $de2e4176a2c46283$export$d2422b36bd687627.status();
        if (pre === 'unsupported' || pre === 'ios-needs-install' || pre === 'denied') return pre;
        let perm = Notification.permission;
        if (perm === 'default') try {
            perm = await Notification.requestPermission();
        } catch  {
            return 'off';
        }
        if (perm !== 'granted') return perm === 'denied' ? 'denied' : 'off';
        const key = await $de2e4176a2c46283$var$vapidKey();
        if (!key) {
            (0, $4aj47.logger).warn("VAPID public key missing \u2014 push disabled");
            return 'off';
        }
        const reg = await $de2e4176a2c46283$var$getRegistration();
        if (!reg) return 'off';
        let sub = await reg.pushManager.getSubscription();
        if (!sub) try {
            sub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: $de2e4176a2c46283$var$urlBase64ToUint8Array(key)
            });
        } catch (e) {
            (0, $4aj47.logger).warn('Push subscribe failed:', e?.message || e);
            return 'off';
        }
        if (!sub) return 'off';
        return await $de2e4176a2c46283$var$persist(sub, userId) ? 'on' : 'off';
    },
    /**
     * تحديث صامت لاشتراك قائم — لا يطلب إذناً ولا يعرض شيئاً.
     * يُنادى عند الإقلاع فقط حين يكون الإذن ممنوحاً أصلاً، كي يبقى الصفّ
     * حيّاً (`last_used_at`) ولا يكنسه تنظيف التسعين يوماً.
     */ refreshIfEnabled: async (userId)=>{
        try {
            if (typeof window === 'undefined' || !('Notification' in window)) return;
            if (Notification.permission !== 'granted') return;
            if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
            const reg = await $de2e4176a2c46283$var$getRegistration();
            const sub = await reg?.pushManager.getSubscription();
            if (sub) await $de2e4176a2c46283$var$persist(sub, userId);
        } catch  {}
    },
    /** إيقاف الإشعارات على هذا الجهاز (زرّ صريح، أو خروج من الحساب). */ disable: async ()=>{
        try {
            const reg = await $de2e4176a2c46283$var$getRegistration();
            const sub = await reg?.pushManager.getSubscription();
            if (!sub) return;
            const endpoint = sub.endpoint;
            await sub.unsubscribe().catch(()=>{});
            await (0, $hUL2G.supabase).from('push_subscriptions').delete().eq('endpoint', endpoint);
        } catch  {}
    },
    /** اسم قديم أبقيناه للتوافق مع مسار الخروج. */ unsubscribe: async ()=>{
        await $de2e4176a2c46283$export$d2422b36bd687627.disable();
    }
};

});

parcelRegister("eHxTy", function(module, exports) {

$parcel$export(module.exports, "realtimeService", function () { return $3a073295d69d1e88$export$9f1141082d16ec71; });
/**
 * Realtime Service — Central hub for ALL real-time synchronization in TAKI.
 * 
 * Handles:
 * - Supabase Realtime channel management with auto-reconnect
 * - Visibility-change re-sync (when user returns to tab/app)
 * - Online/offline detection with automatic data refresh
 * - Heartbeat monitoring to detect stale connections
 * - Focus-based re-hydration for all data types
 * 
 * This ensures ALL services (notifications, bookings, deals, favorites,
 * follows, store profiles, etc.) update in real-time without requiring
 * the user to refresh or re-open the app.
 */ 
var $hUL2G = parcelRequire("hUL2G");

var $4aj47 = parcelRequire("4aj47");
// ─── State ──────────────────────────────────────────────────────
let $3a073295d69d1e88$var$currentConfig = null;
let $3a073295d69d1e88$var$userChannel = null;
let $3a073295d69d1e88$var$globalChannel = null;
let $3a073295d69d1e88$var$favoritesChannel = null;
// v13.82 — قناة رسائل المحادثة. `messagesFilterSupported` تصير false إذا
// رفض الخادم الترشيح (خادم لم تُطبَّق عليه هجرة v13.82 بعد)، فنبني القناة
// بلا ترشيح **مباشرة** في كل اشتراك لاحق — لا نعيد المحاولة الفاشلة كل مرة.
let $3a073295d69d1e88$var$messagesChannel = null;
let $3a073295d69d1e88$var$messagesFilterSupported = true;
let $3a073295d69d1e88$var$heartbeatTimer = null;
let $3a073295d69d1e88$var$reconnectTimer = null;
let $3a073295d69d1e88$var$lastActivityAt = Date.now();
// Timestamp of the last time the page was genuinely hidden (backgrounded /
// locked / app-switched). iOS standalone PWAs fire a window `focus` event
// when the soft keyboard is dismissed — e.g. tapping "Send" after typing a
// chat message — even though the app never left the foreground. Treating
// that as a return-from-background kicked off onRefreshAll() (5 heavy
// queries + 5 big setState → a full re-render) right on top of the send,
// which froze the UI for ~6s before the message appeared. We only count a
// focus/visible as a real return when the page was actually hidden first.
let $3a073295d69d1e88$var$lastHiddenAt = 0;
let $3a073295d69d1e88$var$isConnected = false;
let $3a073295d69d1e88$var$reconnectAttempts = 0;
const $3a073295d69d1e88$var$MAX_RECONNECT_DELAY = 30000; // 30s max backoff
const $3a073295d69d1e88$var$HEARTBEAT_INTERVAL = 15000; // Check every 15s
const $3a073295d69d1e88$var$STALE_THRESHOLD = 60000; // Consider stale after 60s of no activity
// v13.83 — مهلة استقرار بعد بناء القنوات قبل الحكم عليها بالعطل (القناة تمرّ
// بحالة `joining` قبل `joined`، والحكم عليها قبل ذلك يُنتج حلقة هدم/بناء)،
// وحدّ أدنى بين عمليات إعادة البناء القسرية حتى لا نُرهق شبكة متعثّرة.
const $3a073295d69d1e88$var$SETUP_GRACE = 12000;
const $3a073295d69d1e88$var$RECONNECT_MIN_INTERVAL = 20000;
let $3a073295d69d1e88$var$lastSetupAt = 0;
let $3a073295d69d1e88$var$lastForcedReconnectAt = 0;
// Track last sync timestamps per data type
const $3a073295d69d1e88$var$lastSyncAt = {
    notifications: 0,
    bookings: 0,
    deals: 0,
    favorites: 0,
    storeProfiles: 0,
    user: 0
};
// ─── Refresh coalescing ─────────────────────────────────────────
// Multiple subsystems ask for a full re-sync near-simultaneously:
// `visibilitychange` AND `focus` both fire when a tab is re-entered;
// `online` / `pageshow` can pile on top. Without coalescing, returning
// to the app fired onRefreshAll (5 heavy queries) 2-3× back-to-back —
// a major contributor to "الموقع ثقيل". This collapses any burst into a
// single refresh and enforces a minimum gap between full refreshes.
// Explicit pull-to-refresh (forceRefresh) deliberately bypasses it.
let $3a073295d69d1e88$var$lastRefreshAt = 0;
let $3a073295d69d1e88$var$refreshDebounceTimer = null;
const $3a073295d69d1e88$var$REFRESH_MIN_INTERVAL = 6000; // ignore repeat refreshes within 6s
const $3a073295d69d1e88$var$REFRESH_DEBOUNCE = 600; // collapse a burst of triggers into one
function $3a073295d69d1e88$var$requestRefresh(reason) {
    if (!$3a073295d69d1e88$var$currentConfig) return;
    if ($3a073295d69d1e88$var$refreshDebounceTimer) return; // a refresh is already queued
    const since = Date.now() - $3a073295d69d1e88$var$lastRefreshAt;
    if (since < $3a073295d69d1e88$var$REFRESH_MIN_INTERVAL) {
        (0, $4aj47.logger).info(`\u{23ED}\u{FE0F} Refresh (${reason}) skipped \u{2014} ran ${Math.round(since / 1000)}s ago`);
        return;
    }
    $3a073295d69d1e88$var$refreshDebounceTimer = setTimeout(()=>{
        $3a073295d69d1e88$var$refreshDebounceTimer = null;
        if (!$3a073295d69d1e88$var$currentConfig) return;
        $3a073295d69d1e88$var$lastRefreshAt = Date.now();
        (0, $4aj47.logger).info(`\u{1F504} Coalesced refresh (${reason})`);
        $3a073295d69d1e88$var$currentConfig.onRefreshAll();
    }, $3a073295d69d1e88$var$REFRESH_DEBOUNCE);
}
// ─── Visibility & Online Handlers ───────────────────────────────
// True only if the page was genuinely hidden since we last treated the app
// as active. This is what tells a real background→foreground return apart
// from an in-app iOS keyboard-dismiss `focus` (page never hid → no heavy
// re-sync). Real background trips reliably fire visibilitychange→hidden
// and/or pagehide on every modern iOS, so genuine returns still re-sync.
function $3a073295d69d1e88$var$cameBackFromHidden() {
    return $3a073295d69d1e88$var$lastHiddenAt > $3a073295d69d1e88$var$lastActivityAt;
}
function $3a073295d69d1e88$var$handleVisibilityChange() {
    if (document.visibilityState === 'hidden') {
        $3a073295d69d1e88$var$lastHiddenAt = Date.now();
        return;
    }
    if (document.visibilityState === 'visible') {
        (0, $4aj47.logger).info("\uD83D\uDC41\uFE0F Tab became visible \u2014 triggering sync");
        const now = Date.now();
        const elapsed = now - $3a073295d69d1e88$var$lastActivityAt;
        // Re-sync on a genuine return to foreground. iOS Safari pauses the
        // realtime websocket as soon as the tab loses focus, so even a
        // 2-second dip behind another app means we missed packets. Gated
        // on cameBackFromHidden() so a spurious visible (no preceding
        // hide) can't trigger the heavy onRefreshAll storm.
        if ($3a073295d69d1e88$var$currentConfig && $3a073295d69d1e88$var$cameBackFromHidden() && elapsed > 1000) {
            (0, $4aj47.logger).info(`\u{23F0} Away for ${Math.round(elapsed / 1000)}s \u{2014} full re-sync`);
            $3a073295d69d1e88$var$requestRefresh('visibility');
        }
        $3a073295d69d1e88$var$verifyAndReconnect('visibility');
        $3a073295d69d1e88$var$lastActivityAt = now;
    }
}
// pagehide is the most reliable "the app is going to the background" signal
// on iOS standalone PWAs (visibilitychange is sometimes skipped there).
function $3a073295d69d1e88$var$handlePageHide() {
    $3a073295d69d1e88$var$lastHiddenAt = Date.now();
}
// iOS Safari restores the page from the back-forward cache (bfcache) on
// swipe-back / "rerun previous tab" — visibilitychange does NOT fire in
// that path. `pageshow` does, and the `persisted` flag distinguishes a
// bfcache restore (where the websocket is definitely dead) from a normal
// first load.
function $3a073295d69d1e88$var$handlePageShow(e) {
    if (e.persisted && $3a073295d69d1e88$var$currentConfig) {
        (0, $4aj47.logger).info("\u267B\uFE0F Restored from bfcache \u2014 full reconnect + re-sync");
        $3a073295d69d1e88$var$teardownChannels();
        $3a073295d69d1e88$var$setupChannels($3a073295d69d1e88$var$currentConfig);
        $3a073295d69d1e88$var$requestRefresh('bfcache');
        $3a073295d69d1e88$var$lastActivityAt = Date.now();
    }
}
function $3a073295d69d1e88$var$handleOnline() {
    (0, $4aj47.logger).info("\uD83C\uDF10 Network came online \u2014 reconnecting");
    if ($3a073295d69d1e88$var$currentConfig) // Small delay to let the network stabilize
    setTimeout(()=>{
        if (!$3a073295d69d1e88$var$currentConfig) return;
        $3a073295d69d1e88$var$teardownChannels();
        $3a073295d69d1e88$var$setupChannels($3a073295d69d1e88$var$currentConfig);
        $3a073295d69d1e88$var$requestRefresh('online');
    }, 1000);
}
function $3a073295d69d1e88$var$handleOffline() {
    (0, $4aj47.logger).info("\uD83D\uDCE1 Network went offline");
    $3a073295d69d1e88$var$isConnected = false;
}
// Handle page focus (works on mobile browsers better than visibilitychange).
// Only a focus that follows a genuine hide counts as a return — a bare
// focus with the page never hidden is the iOS keyboard-dismiss case (e.g.
// tapping "Send" after typing), which must NOT trigger onRefreshAll().
function $3a073295d69d1e88$var$handleFocus() {
    const now = Date.now();
    const elapsed = now - $3a073295d69d1e88$var$lastActivityAt;
    if ($3a073295d69d1e88$var$currentConfig && $3a073295d69d1e88$var$cameBackFromHidden() && elapsed > 1000) {
        (0, $4aj47.logger).info(`\u{1F504} Window focused after ${Math.round(elapsed / 1000)}s \u{2014} quick sync`);
        $3a073295d69d1e88$var$requestRefresh('focus');
        $3a073295d69d1e88$var$verifyAndReconnect('focus');
    }
    $3a073295d69d1e88$var$lastActivityAt = now;
}
// ─── Heartbeat ──────────────────────────────────────────────────
function $3a073295d69d1e88$var$startHeartbeat() {
    $3a073295d69d1e88$var$stopHeartbeat();
    $3a073295d69d1e88$var$heartbeatTimer = setInterval(()=>{
        if (document.visibilityState !== 'visible') return;
        // v13.83 — الفحص يجري في **كل** نبضة، لا بعد ٦٠ ثانية صمت فقط.
        // الفحص محلّي بالكامل (حالة الـsocket + حالة القنوات) بلا أي طلب
        // شبكة، فتكلفته صفر عملياً. وهذا ما يمسك الحالة التي أبلغ عنها ناصر:
        // المستخدم **داخل** التطبيق يتابع محادثة، فلا يقع أي حدث visibility
        // أو focus يوقظ المزامنة، والـsocket ميت بصمت منذ دقائق.
        $3a073295d69d1e88$var$verifyAndReconnect('heartbeat');
        // فحص ثانٍ ألطف: القنوات تبدو سليمة لكن لا يصل شيء منذ مدة طويلة —
        // نطلب إعادة جلب تحوّطية (مكبوحة بـrequestRefresh) لا إعادة بناء.
        if (Date.now() - $3a073295d69d1e88$var$lastActivityAt > $3a073295d69d1e88$var$STALE_THRESHOLD) {
            $3a073295d69d1e88$var$requestRefresh('heartbeat-stale');
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
        }
    }, $3a073295d69d1e88$var$HEARTBEAT_INTERVAL);
}
function $3a073295d69d1e88$var$stopHeartbeat() {
    if ($3a073295d69d1e88$var$heartbeatTimer) {
        clearInterval($3a073295d69d1e88$var$heartbeatTimer);
        $3a073295d69d1e88$var$heartbeatTimer = null;
    }
}
// ─── Channel Management ─────────────────────────────────────────
/** حالة قناة بالاسم، أو null إن لم تعد موجودة أصلاً. */ function $3a073295d69d1e88$var$channelState(topicPart) {
    const ch = (0, $hUL2G.supabase).getChannels().find((c)=>typeof c?.topic === 'string' && c.topic.includes(topicPart));
    return ch ? String(ch.state || '') : null;
}
/**
 * v13.83 — ما الذي يجعل الريل‑تايم «ميتاً وهو يبدو حيّاً»؟
 *
 * النسخة السابقة كانت تسأل سؤالاً واحداً: «هل كائن القناة موجود في القائمة؟»
 * وهذا السؤال **يُجاب بنعم دائماً**: في `realtime-js` تُنادى `_remove` من مكان
 * واحد فقط (إغلاق القناة بنفسها)، فالقناة التي ماتت بـ`CHANNEL_ERROR` أو
 * `TIMED_OUT` — حين يقتل iOS الـwebsocket، أو ينتقل الجهاز بين Wi‑Fi والبيانات،
 * أو تنتهي مهلة وسيط — **تبقى في `getChannels()` بحالة `errored`**. فكان الفحص
 * يمرّ كل ١٥ ثانية ولا يُعيد الاتصال أبداً، وتتوقّف الرسائل بلا أي إشارة.
 *
 * أُثبت بالتجربة على عميل realtime حقيقي موجَّه لمنفذ غير قابل للوصول:
 *     getChannels() → "realtime:rt-user-TEST=errored"
 *     الفحص القديم → «سليم ✅»   ·   الفحص الجديد → «معطّل ❌»
 *
 * الآن نسأل عن **الصحة لا الوجود**: الـsocket متصل فعلاً، وكل قناة متوقَّعة في
 * حالة `joined` (و`joining` مقبولة لأنها انضمام قيد التنفيذ).
 *
 * قنوات `rt-deal-*` مستثناة عمداً: مؤقّتة تُفتح وتُغلق مع صفحة العرض، فغيابها
 * ليس عطلاً.
 */ function $3a073295d69d1e88$var$findUnhealthyChannel() {
    if (!$3a073295d69d1e88$var$currentConfig) return null;
    // مستوى الـsocket نفسه — أرخص وأصدق فحص، وبلا أي طلب شبكة.
    try {
        if (!(0, $hUL2G.supabase).realtime.isConnected()) return 'socket:disconnected';
    } catch  {
    /* واجهة غير متاحة — نكمل بفحص القنوات وحدها */ }
    const hasUser = !!$3a073295d69d1e88$var$currentConfig.userId;
    const expected = [
        [
            'rt-global',
            true
        ],
        [
            'rt-user-',
            hasUser
        ],
        // قناة المحادثة المستقلة (v13.82). `rt-msgs` تطابق النسختين:
        // المُرشَّحة `rt-msgs-<id>` والمرتدّة `rt-msgs-fb-<id>`.
        [
            'rt-msgs',
            hasUser
        ],
        [
            'rt-favorites-',
            hasUser
        ]
    ];
    for (const [topic, required] of expected){
        if (!required) continue;
        const st = $3a073295d69d1e88$var$channelState(topic);
        if (st === null) return `${topic}:missing`;
        if (st !== 'joined' && st !== 'joining') return `${topic}:${st}`;
    }
    return null;
}
function $3a073295d69d1e88$var$verifyAndReconnect(reason = 'verify') {
    if (!$3a073295d69d1e88$var$currentConfig) return;
    // مهلة استقرار بعد كل بناء: القنوات تحتاج لحظات للانضمام، وفحصها قبل ذلك
    // يُنتج حلقة هدم/بناء لا تنتهي. وتغطّي كذلك ارتداد قناة المحادثة في v13.82
    // (تسقط بـCHANNEL_ERROR ثم يُعاد اشتراكها بلا ترشيح مباشرة بعد البناء).
    if (Date.now() - $3a073295d69d1e88$var$lastSetupAt < $3a073295d69d1e88$var$SETUP_GRACE) return;
    const problem = $3a073295d69d1e88$var$findUnhealthyChannel();
    if (!problem) {
        // سليمة — نصفّر عدّاد المحاولات فلا يرث اتصالٌ ناجح تأخيرَ ما قبله.
        $3a073295d69d1e88$var$isConnected = true;
        $3a073295d69d1e88$var$reconnectAttempts = 0;
        return;
    }
    if (Date.now() - $3a073295d69d1e88$var$lastForcedReconnectAt < $3a073295d69d1e88$var$RECONNECT_MIN_INTERVAL) return;
    $3a073295d69d1e88$var$lastForcedReconnectAt = Date.now();
    (0, $4aj47.logger).warn(`\u{1F504} Realtime unhealthy (${problem}) via ${reason} \u{2014} rebuilding channels`);
    $3a073295d69d1e88$var$isConnected = false;
    $3a073295d69d1e88$var$teardownChannels();
    $3a073295d69d1e88$var$setupChannels($3a073295d69d1e88$var$currentConfig);
    // ⚠️ جوهري: إعادة الاشتراك **لا تُعيد بثّ** الصفوف التي فاتت أثناء
    // الانقطاع — Supabase لا يحتفظ بها. فبلا إعادة جلب صريحة هنا تبقى رسالة
    // المحادثة مفقودة إلى الأبد رغم نجاح إعادة الاتصال. هذا السطر هو الفرق
    // بين «عاد الاتصال» و«عادت الرسالة».
    $3a073295d69d1e88$var$requestRefresh(`reconnect:${reason}`);
}
function $3a073295d69d1e88$var$teardownChannels() {
    // Remove only our managed channels
    const channels = (0, $hUL2G.supabase).getChannels();
    channels.filter((c)=>{
        const topic = typeof c?.topic === 'string' ? c.topic : '';
        return topic.includes('rt-user-') || topic.includes('rt-global') || topic.includes('rt-deal-') || topic.includes('rt-msgs') || topic.includes('rt-favorites-');
    }).forEach((c)=>(0, $hUL2G.supabase).removeChannel(c));
    $3a073295d69d1e88$var$userChannel = null;
    $3a073295d69d1e88$var$globalChannel = null;
    $3a073295d69d1e88$var$messagesChannel = null;
    $3a073295d69d1e88$var$favoritesChannel = null;
    $3a073295d69d1e88$var$isConnected = false;
}
function $3a073295d69d1e88$var$setupChannels(config) {
    const { userId: userId } = config;
    // v13.83 — ختم وقت البناء: فحص الصحة يمتنع عن الحكم قبل انقضاء مهلة
    // الاستقرار، وإلا هدم القنوات وهي لا تزال في حالة `joining`.
    $3a073295d69d1e88$var$lastSetupAt = Date.now();
    if (userId) {
        // ─── 1. User-specific channel (notifications + bookings) ────
        $3a073295d69d1e88$var$userChannel = (0, $hUL2G.supabase).channel(`rt-user-${userId}`);
        // Notifications: INSERT
        $3a073295d69d1e88$var$userChannel.on('postgres_changes', {
            event: 'INSERT',
            schema: 'public',
            table: 'notifications',
            filter: `user_id=eq.${userId}`
        }, (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            $3a073295d69d1e88$var$lastSyncAt.notifications = Date.now();
            config.onNotificationInsert(payload);
        });
        // Notifications: UPDATE (mark as read from another device)
        $3a073295d69d1e88$var$userChannel.on('postgres_changes', {
            event: 'UPDATE',
            schema: 'public',
            table: 'notifications',
            filter: `user_id=eq.${userId}`
        }, (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            config.onNotificationUpdate(payload);
        });
        // Notifications: DELETE
        $3a073295d69d1e88$var$userChannel.on('postgres_changes', {
            event: 'DELETE',
            schema: 'public',
            table: 'notifications'
        }, (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            config.onNotificationUpdate(payload);
        });
        // ─────────────────────────────────────────────────────────────
        // Bookings — v13.80: مُرشَّحة على الخادم بدل استقبال كل حجوزات المنصّة.
        //
        // كان الاشتراك بلا `filter`، أي أن خادم الريل‑تايم يُقيّم صلاحية **كل**
        // تغيير على `bookings` أمام **كل** متصل ثم يرمي ما لا يخصّه. هذا حسابياً
        // (عدد التغييرات × عدد المتصلين): مقبول بآلاف المستخدمين، ومستحيل
        // بملايينهم — كل حجز في المملكة كان يُقيَّم أمام كل جهاز مفتوح.
        //
        // الآن اشتراكان مُرشَّحان على القاعدة: صفوفي كمشترٍ، وصفوفي كتاجر. الحساب
        // صار بعدد التغييرات وحدها، وما يصل الجهاز يخصّه أصلاً.
        //
        // الحذف يبقى باشتراك ثالث بلا ترشيح **عمداً**: صفّ الحذف في WAL لا يحمل
        // إلا المفتاح الأساسي (`barcode`)، فأي ترشيح على `user_id`/`store_id` لن
        // يطابقه أبداً وتضيع أحداث الحذف. والحذف نادر (الإلغاء تغيير حالة لا حذف)
        // فحِمله لا يُذكر.
        // ─────────────────────────────────────────────────────────────
        const onBooking = (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            $3a073295d69d1e88$var$lastSyncAt.bookings = Date.now();
            config.onBookingChange(payload);
        };
        $3a073295d69d1e88$var$userChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'bookings',
            filter: `user_id=eq.${userId}`
        }, onBooking);
        $3a073295d69d1e88$var$userChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'bookings',
            filter: `store_id=eq.${userId}`
        }, onBooking);
        $3a073295d69d1e88$var$userChannel.on('postgres_changes', {
            event: 'DELETE',
            schema: 'public',
            table: 'bookings'
        }, onBooking);
        // ─────────────────────────────────────────────────────────────
        // Booking messages — v13.82: قناة مستقلة مُرشَّحة، مع ارتداد آمن.
        //
        // كانت آخر اشتراك بلا ترشيح: كل رسالة في المنصّة تُقيَّم أمام كل جهاز.
        // الترشيح صار ممكناً بعد عمود `recipient_id` (يُملأ بمشغّل في القاعدة،
        // فلا يُزوَّر من العميل):
        //     recipient_id = أنا  → الوارد
        //     sender_id    = أنا  → إيصالات القراءة على رسائلي أنا
        //
        // ولماذا قناة مستقلة؟ لأن الترشيح على عمود غير موجود يُسقط **القناة
        // كلها**. لو كان معها الحجوزات والإشعارات لسقطت هي الأخرى على خادم لم
        // تُطبَّق عليه الهجرة بعد. هنا تسقط وحدها، ويلتقطها الارتداد أدناه:
        // نعيد الاشتراك بلا ترشيح (سلوك ما قبل v13.82 بالضبط) فلا تتعطّل
        // المحادثة لحظة واحدة — مرة واحدة فقط، بلا حلقة إعادة محاولة.
        // ─────────────────────────────────────────────────────────────
        const onMessage = (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            config.onBookingMessage?.(payload);
        };
        const subscribeMessagesUnfiltered = ()=>{
            $3a073295d69d1e88$var$messagesChannel = (0, $hUL2G.supabase).channel(`rt-msgs-fb-${userId}`);
            $3a073295d69d1e88$var$messagesChannel.on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: 'booking_messages'
            }, onMessage);
            $3a073295d69d1e88$var$messagesChannel.subscribe();
        };
        if (!$3a073295d69d1e88$var$messagesFilterSupported) subscribeMessagesUnfiltered();
        else {
            $3a073295d69d1e88$var$messagesChannel = (0, $hUL2G.supabase).channel(`rt-msgs-${userId}`);
            $3a073295d69d1e88$var$messagesChannel.on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: 'booking_messages',
                filter: `recipient_id=eq.${userId}`
            }, onMessage);
            $3a073295d69d1e88$var$messagesChannel.on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: 'booking_messages',
                filter: `sender_id=eq.${userId}`
            }, onMessage);
            $3a073295d69d1e88$var$messagesChannel.subscribe((status)=>{
                if (status !== 'CHANNEL_ERROR' || !$3a073295d69d1e88$var$messagesFilterSupported) return;
                // الترشيح مرفوض على هذا الخادم — نسجّلها مرة واحدة ونرتدّ إلى سلوك
                // ما قبل v13.82 فلا تتعطّل المحادثة، وكل اشتراك لاحق يبدأ مرتدّاً.
                $3a073295d69d1e88$var$messagesFilterSupported = false;
                (0, $4aj47.logger).warn("\u21A9\uFE0F booking_messages filter rejected \u2014 falling back to unfiltered");
                try {
                    if ($3a073295d69d1e88$var$messagesChannel) (0, $hUL2G.supabase).removeChannel($3a073295d69d1e88$var$messagesChannel);
                } catch  {}
                subscribeMessagesUnfiltered();
            });
        }
        // User profile changes (for this user — settings, keywords, etc.)
        $3a073295d69d1e88$var$userChannel.on('postgres_changes', {
            event: 'UPDATE',
            schema: 'public',
            table: 'users',
            filter: `id=eq.${userId}`
        }, (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            $3a073295d69d1e88$var$lastSyncAt.user = Date.now();
            config.onUserChange(payload);
        });
        $3a073295d69d1e88$var$userChannel.subscribe((status)=>{
            if (status === 'SUBSCRIBED') {
                (0, $4aj47.logger).info("\u2705 Realtime user channel connected:", userId);
                $3a073295d69d1e88$var$isConnected = true;
                $3a073295d69d1e88$var$reconnectAttempts = 0;
            } else if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
                (0, $4aj47.logger).warn("\u274C Realtime user channel error:", status);
                $3a073295d69d1e88$var$isConnected = false;
                $3a073295d69d1e88$var$scheduleReconnect();
            } else if (status === 'CLOSED') $3a073295d69d1e88$var$isConnected = false;
        });
    }
    // ─── 2. Global channel (deals + store profiles) ────────────
    $3a073295d69d1e88$var$globalChannel = (0, $hUL2G.supabase).channel('rt-global');
    // ─────────────────────────────────────────────────────────────
    // Deals + Ratings — v13.81: من بثّ عام إلى ما يخصّ المستخدم فعلاً.
    //
    // كانا مشتركين على **كل** صفوف الجدولين بلا ترشيح. معناه أن كل نقص كمية
    // في أي عرض بأي مدينة (وهو يحدث مع كل حجز في المنصّة) كان يُقيَّم ويُبَثّ
    // إلى **كل جهاز مفتوح**. بعشرات العروض لا يُلاحَظ؛ بمليون عرض ومليون
    // متصل يصير أضخم بند في فاتورة الخادم — وأول ما ينهار.
    //
    // القاعدة الصحيحة: لا أحد يحتاج بثّاً حيّاً لمليون عرض، إنما لما يخصّه:
    //   • التاجر  → عروضه هو وتقييمات متجره (ترشيح على store_id).
    //   • المشتري → العرض المفتوح أمامه الآن (اشتراك موجّه — `watchDeal`).
    //   • البقية  → تحديث عند العودة للتطبيق/السحب للتحديث (قائم منذ v10.22).
    // ─────────────────────────────────────────────────────────────
    if (userId) {
        $3a073295d69d1e88$var$globalChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'deals',
            filter: `store_id=eq.${userId}`
        }, (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            $3a073295d69d1e88$var$lastSyncAt.deals = Date.now();
            config.onDealChange(payload);
        });
        $3a073295d69d1e88$var$globalChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'ratings',
            filter: `store_id=eq.${userId}`
        }, (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            config.onRatingChange?.(payload);
        });
    }
    // Store profiles (sellers)
    //
    // v13.21 — SCALE-CRITICAL: this used to subscribe to EVERY row of `users`
    // and discard non-sellers on the CLIENT. The server still had to evaluate
    // and fan out every buyer row change to every connected client — and the
    // live-location watcher writes users.lat/lng for every shopper as they
    // move. At a million shoppers that is a permanent firehose broadcast to a
    // million sockets (the single most expensive thing the app did).
    // The server-side filter below drops buyers at the source; the merchant's
    // own profile updates still arrive on the per-user channel above
    // (filter: id=eq.<me>), so nothing is lost.
    //
    // The filter is `neq.buyer`, NOT `eq.seller`: Nasser's own store is
    // ADMIN-owned, and every `user_type='seller'` filter in this codebase has
    // historically hidden it (see the admin-owner gate lessons). `neq.buyer`
    // keeps sellers AND admin-owned stores while still dropping the millions
    // of shopper rows that cause the fan-out.
    $3a073295d69d1e88$var$globalChannel.on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'users',
        filter: 'user_type=neq.buyer'
    }, (payload)=>{
        $3a073295d69d1e88$var$lastActivityAt = Date.now();
        $3a073295d69d1e88$var$lastSyncAt.storeProfiles = Date.now();
        config.onUserChange(payload);
    });
    $3a073295d69d1e88$var$globalChannel.subscribe((status)=>{
        if (status === 'SUBSCRIBED') (0, $4aj47.logger).info("\u2705 Realtime global channel connected");
        else if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
            (0, $4aj47.logger).warn("\u274C Realtime global channel error:", status);
            $3a073295d69d1e88$var$scheduleReconnect();
        }
    });
    if (userId) {
        // ─── 3. Favorites channel (for this user) ──────────────────
        $3a073295d69d1e88$var$favoritesChannel = (0, $hUL2G.supabase).channel(`rt-favorites-${userId}`);
        $3a073295d69d1e88$var$favoritesChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'favorites',
            filter: `user_id=eq.${userId}`
        }, (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            $3a073295d69d1e88$var$lastSyncAt.favorites = Date.now();
            config.onFavoriteChange(payload);
        });
        $3a073295d69d1e88$var$favoritesChannel.subscribe((status)=>{
            if (status === 'SUBSCRIBED') (0, $4aj47.logger).info("\u2705 Realtime favorites channel connected");
            else if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
                // v13.83 — كانت هذه القناة وحدها بلا أي معالجة خطأ: تسقط
                // فتبقى ساقطة إلى الأبد (المفضّلة تتوقف عن التحديث بصمت).
                (0, $4aj47.logger).warn("\u274C Realtime favorites channel error:", status);
                $3a073295d69d1e88$var$scheduleReconnect();
            }
        });
    }
}
function $3a073295d69d1e88$var$scheduleReconnect() {
    if ($3a073295d69d1e88$var$reconnectTimer) return;
    // Exponential backoff: 1s, 2s, 4s, 8s, ... up to MAX_RECONNECT_DELAY
    const delay = Math.min(1000 * Math.pow(2, $3a073295d69d1e88$var$reconnectAttempts), $3a073295d69d1e88$var$MAX_RECONNECT_DELAY);
    $3a073295d69d1e88$var$reconnectAttempts++;
    (0, $4aj47.logger).info(`\u{1F504} Scheduling reconnect in ${delay}ms (attempt ${$3a073295d69d1e88$var$reconnectAttempts})`);
    $3a073295d69d1e88$var$reconnectTimer = setTimeout(()=>{
        $3a073295d69d1e88$var$reconnectTimer = null;
        if ($3a073295d69d1e88$var$currentConfig && document.visibilityState === 'visible') {
            $3a073295d69d1e88$var$teardownChannels();
            $3a073295d69d1e88$var$setupChannels($3a073295d69d1e88$var$currentConfig);
            // v13.83 — نفس درس verifyAndReconnect: إعادة الاشتراك لا تُعيد
            // الصفوف الفائتة، فبلا إعادة الجلب هنا يبقى ما فات مفقوداً.
            $3a073295d69d1e88$var$requestRefresh('reconnect-backoff');
        }
    }, delay);
}
const $3a073295d69d1e88$export$9f1141082d16ec71 = {
    /**
     * Initialize the realtime service for a logged-in user.
     * Sets up all channels, listeners, and background monitors.
     */ connect (config) {
        (0, $4aj47.logger).info("\uD83D\uDE80 Realtime Service: Connecting for user", config.userId || 'guest');
        // Tear down any previous session
        this.disconnect();
        $3a073295d69d1e88$var$currentConfig = config;
        $3a073295d69d1e88$var$lastActivityAt = Date.now();
        $3a073295d69d1e88$var$reconnectAttempts = 0;
        // Setup channels
        $3a073295d69d1e88$var$setupChannels(config);
        // Start heartbeat monitoring
        $3a073295d69d1e88$var$startHeartbeat();
        // Register visibility and network listeners
        document.addEventListener('visibilitychange', $3a073295d69d1e88$var$handleVisibilityChange);
        window.addEventListener('online', $3a073295d69d1e88$var$handleOnline);
        window.addEventListener('offline', $3a073295d69d1e88$var$handleOffline);
        window.addEventListener('focus', $3a073295d69d1e88$var$handleFocus);
        window.addEventListener('pagehide', $3a073295d69d1e88$var$handlePageHide);
        window.addEventListener('pageshow', $3a073295d69d1e88$var$handlePageShow);
        // NOTE: no auto-refresh on connect. Cold load is owned by
        // AppContext.initData(); a login re-connect is hydrated by the
        // SIGNED_IN auth path; a genuine "was away → came back" reconnect
        // goes through the visibility/focus/online/pageshow handlers, which
        // all funnel into the coalesced requestRefresh(). The old
        // unconditional 500 ms onRefreshAll here fired a 5-query refetch
        // right on top of initData on every single page open.
        return ()=>this.disconnect();
    },
    /**
     * Disconnect all channels and remove all listeners.
     */ disconnect () {
        (0, $4aj47.logger).info("\uD83D\uDD0C Realtime Service: Disconnecting");
        $3a073295d69d1e88$var$currentConfig = null;
        $3a073295d69d1e88$var$stopHeartbeat();
        if ($3a073295d69d1e88$var$reconnectTimer) {
            clearTimeout($3a073295d69d1e88$var$reconnectTimer);
            $3a073295d69d1e88$var$reconnectTimer = null;
        }
        if ($3a073295d69d1e88$var$refreshDebounceTimer) {
            clearTimeout($3a073295d69d1e88$var$refreshDebounceTimer);
            $3a073295d69d1e88$var$refreshDebounceTimer = null;
        }
        // Reset so the first refresh after a genuine reconnect is honored.
        $3a073295d69d1e88$var$lastRefreshAt = 0;
        $3a073295d69d1e88$var$teardownChannels();
        document.removeEventListener('visibilitychange', $3a073295d69d1e88$var$handleVisibilityChange);
        window.removeEventListener('online', $3a073295d69d1e88$var$handleOnline);
        window.removeEventListener('offline', $3a073295d69d1e88$var$handleOffline);
        window.removeEventListener('focus', $3a073295d69d1e88$var$handleFocus);
        window.removeEventListener('pagehide', $3a073295d69d1e88$var$handlePageHide);
        window.removeEventListener('pageshow', $3a073295d69d1e88$var$handlePageShow);
    },
    /**
     * Force a full data refresh right now.
     */ async forceRefresh () {
        if ($3a073295d69d1e88$var$currentConfig) {
            (0, $4aj47.logger).info("\uD83D\uDD04 Realtime Service: Force refresh (explicit)");
            // Explicit user intent (pull-to-refresh) — bypass the coalescer
            // but still stamp the clock so an incidental focus/visibility
            // event a second later doesn't immediately refetch again.
            if ($3a073295d69d1e88$var$refreshDebounceTimer) {
                clearTimeout($3a073295d69d1e88$var$refreshDebounceTimer);
                $3a073295d69d1e88$var$refreshDebounceTimer = null;
            }
            $3a073295d69d1e88$var$lastRefreshAt = Date.now();
            await $3a073295d69d1e88$var$currentConfig.onRefreshAll();
        }
    },
    /**
     * Get connection status.
     */ getStatus () {
        return {
            isConnected: $3a073295d69d1e88$var$isConnected,
            lastActivityAt: $3a073295d69d1e88$var$lastActivityAt,
            reconnectAttempts: $3a073295d69d1e88$var$reconnectAttempts,
            lastSyncAt: {
                ...$3a073295d69d1e88$var$lastSyncAt
            }
        };
    },
    /**
     * Mark activity — call this from any handler that receives
     * realtime data to keep the heartbeat happy.
     */ markActivity () {
        $3a073295d69d1e88$var$lastActivityAt = Date.now();
    },
    /**
     * v13.81 — اشتراك موجّه على **عرض واحد**: يستعمله من يفتح صفحة العرض.
     *
     * بعد إلغاء البثّ العام للعروض، هذا هو ما يُبقي «٣ متبقية» تتناقص أمام
     * عين المشتري وهو ينظر إلى الصفحة — وهو الموضع الوحيد الذي تهمّ فيه
     * اللحظية للمشتري. قناة مستقلة لكل عرض مفتوح، تُغلق بمغادرته، فالتكلفة
     * على الخادم بعدد من يشاهدون هذا العرض الآن لا بعدد مستخدمي المنصّة.
     *
     * يُرجع دالة إلغاء الاشتراك (استعملها في `useEffect` cleanup).
     */ watchDeal (dealId, onChange) {
        if (!dealId) return ()=>{};
        const ch = (0, $hUL2G.supabase).channel(`rt-deal-${dealId}`);
        ch.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'deals',
            filter: `id=eq.${dealId}`
        }, (payload)=>{
            $3a073295d69d1e88$var$lastActivityAt = Date.now();
            $3a073295d69d1e88$var$lastSyncAt.deals = Date.now();
            onChange(payload);
        });
        ch.subscribe();
        return ()=>{
            try {
                (0, $hUL2G.supabase).removeChannel(ch);
            } catch  {}
        };
    }
};

});

parcelRegister("411pF", function(module, exports) {

$parcel$export(module.exports, "CONSENT_EVENT", function () { return $14a9691343c7c06d$export$a3b25a1440f49f51; });
$parcel$export(module.exports, "analyticsAllowed", function () { return $14a9691343c7c06d$export$6cb98a6520b3692f; });
$parcel$export(module.exports, "setAnalyticsAllowed", function () { return $14a9691343c7c06d$export$cbaef5de7a4d089e; });
$parcel$export(module.exports, "syncAnalyticsConsentFromAccount", function () { return $14a9691343c7c06d$export$76f213a1acf33ed5; });

var $hUL2G = parcelRequire("hUL2G");
/**
 * analyticsConsent — بوّابة واحدة يمرّ بها كل قياسٍ سلوكي (v14.82)
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 الثغرة، مقيسة لا مفترضة: سياسة الخصوصية تَعِد صراحةً بحقّ **سحب الموافقة**
 *    (القسم ٦)، وقسمُ الكوكيز يُحيل إلى «إعدادات متصفّحك لرفض هذه الملفّات».
 *    والقياسُ في تاكي **لا يمرّ بالكوكيز إطلاقاً**: أربعة مسارات تكتب مباشرةً
 *    إلى القاعدة عبر RPC —
 *      ١) `analyticsTracker`  → `record_analytics_events`  (سلوك داخل التطبيق)
 *      ٢) `searchTracker`     → أحداث البحث
 *      ٣) `track_app_open`    → فتح التطبيق ومصدره
 *      ٤) `siteVisit`         → الزيارة والمصدر وصفحة الهبوط
 *    فمن يتبع إرشادنا ويمنع الكوكيز **لا يُوقف شيئاً منها**. أي أن الوثيقة
 *    تَعِد بما لا يُنفَّذ — وهذا أسوأ من ألّا تَعِد.
 *
 * ما صار: مفتاحٌ واحد حقيقي. الحالة تُحفظ محلياً (فتعمل **للزائر** أيضاً، وهو
 * مُتتبَّعٌ فعلاً)، وتُزامَن مع `users.analytics_opt_out` لمن له حساب فتتبعه
 * بين أجهزته. والبوّابة تُفحص **قبل بناء أي حدث** لا قبل إرساله — فلا يُجمَّع
 * شيء في الذاكرة أصلاً.
 *
 * 🪤 والافتراضي «مفعّل» عمداً: القياس مجهولُ الهوية (لا اسم ولا بريد ولا عنوان
 *    إنترنت)، ونظام حماية البيانات السعودي يسمح به للمصلحة المشروعة —
 *    والوعد الذي يجب أن يُوفى هو **إمكان الإيقاف**، لا الإيقاف افتراضاً.
 * 🪤 وعند الإيقاف يُمحى معرّف الجلسة ومفاتيح إزالة التكرار من المتصفّح، وإلا
 *    بقي المعرّف نفسه في الجهاز فعاد القياس بنفس الهوية لحظة إعادة التفعيل.
 */ /** مفتاح واحد في `localStorage`. القيمة `'1'` تعني **موقوف**. */ const $14a9691343c7c06d$var$OPT_OUT_KEY = 'taki_analytics_off';
/** مفاتيح يخلّفها القياس في المتصفّح — تُمحى عند الإيقاف. */ const $14a9691343c7c06d$var$TRACE_KEYS = [
    'taki_an_sid',
    'taki_an_seen',
    'taki_visit_sent'
];
const $14a9691343c7c06d$export$a3b25a1440f49f51 = 'taki:analytics-consent';
let $14a9691343c7c06d$var$cached = null;
const $14a9691343c7c06d$export$6cb98a6520b3692f = ()=>{
    if ($14a9691343c7c06d$var$cached !== null) return $14a9691343c7c06d$var$cached;
    try {
        $14a9691343c7c06d$var$cached = localStorage.getItem($14a9691343c7c06d$var$OPT_OUT_KEY) !== '1';
    } catch  {
        $14a9691343c7c06d$var$cached = true; // متصفّحٌ يمنع التخزين — لا نُعطّل القياس بسبب ذلك
    }
    return $14a9691343c7c06d$var$cached;
};
/** يُنظّف ما خلّفه القياس في هذا المتصفّح. */ const $14a9691343c7c06d$var$clearTraces = ()=>{
    for (const k of $14a9691343c7c06d$var$TRACE_KEYS){
        try {
            localStorage.removeItem(k);
        } catch  {}
        try {
            sessionStorage.removeItem(k);
        } catch  {}
    }
};
const $14a9691343c7c06d$export$cbaef5de7a4d089e = async (allowed)=>{
    $14a9691343c7c06d$var$cached = allowed;
    try {
        if (allowed) localStorage.removeItem($14a9691343c7c06d$var$OPT_OUT_KEY);
        else localStorage.setItem($14a9691343c7c06d$var$OPT_OUT_KEY, '1');
    } catch  {}
    if (!allowed) $14a9691343c7c06d$var$clearTraces();
    try {
        window.dispatchEvent(new CustomEvent($14a9691343c7c06d$export$a3b25a1440f49f51, {
            detail: {
                allowed: allowed
            }
        }));
    } catch  {}
    // المزامنة مع الحساب: تُفشل بصمتٍ للزائر (لا جلسة) وهذا مقصود.
    try {
        const { data: sess } = await (0, $hUL2G.supabase).auth.getSession();
        if (!sess?.session?.user?.id) return true;
        const { error: error } = await (0, $hUL2G.supabase).rpc('set_analytics_opt_out', {
            p_off: !allowed
        });
        if (error) {
            console.warn("analyticsConsent: \u062A\u0639\u0630\u0651\u0631\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629 \u0645\u0639 \u0627\u0644\u062D\u0633\u0627\u0628:", error.message);
            return false;
        }
    } catch (e) {
        console.warn("analyticsConsent: \u062A\u0639\u0630\u0651\u0631\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629:", e);
        return false;
    }
    return true;
};
const $14a9691343c7c06d$export$76f213a1acf33ed5 = async ()=>{
    try {
        const { data: data, error: error } = await (0, $hUL2G.supabase).rpc('get_analytics_opt_out');
        if (error || data === null || data === undefined) return;
        const off = data === true;
        $14a9691343c7c06d$var$cached = !off;
        try {
            if (off) localStorage.setItem($14a9691343c7c06d$var$OPT_OUT_KEY, '1');
            else localStorage.removeItem($14a9691343c7c06d$var$OPT_OUT_KEY);
        } catch  {}
        if (off) $14a9691343c7c06d$var$clearTraces();
        try {
            window.dispatchEvent(new CustomEvent($14a9691343c7c06d$export$a3b25a1440f49f51, {
                detail: {
                    allowed: !off
                }
            }));
        } catch  {}
    } catch  {}
};
const $14a9691343c7c06d$export$f6dfd9cbf8c4f2e8 = ()=>{
    $14a9691343c7c06d$var$cached = null;
};

});

parcelRegister("bRDgQ", function(module, exports) {

$parcel$export(module.exports, "readSnapshot", function () { return $d8124bb9b4cd6dc4$export$117db55c9cf9e6aa; });
$parcel$export(module.exports, "writeSnapshot", function () { return $d8124bb9b4cd6dc4$export$7b4fc7c56ad9d1fc; });
$parcel$export(module.exports, "clearSnapshots", function () { return $d8124bb9b4cd6dc4$export$9d46d2a3b8aa6918; });
/**
 * Snapshot cache — stale-while-revalidate render cache.
 *
 * The Supabase project lives in ap-northeast-1 (Tokyo); users are in
 * Saudi Arabia. Every REST/Realtime round-trip is ~300-500 ms from a
 * KSA phone, and the cold-load path makes several of them, so a fresh
 * fetch can take 6-7 s before anything paints.
 *
 * This cache makes the FIRST paint instant: the last data the user saw
 * is persisted to localStorage and re-hydrated synchronously on the
 * next app open, BEFORE any network call. The live fetch still runs in
 * the background and overwrites state the moment it lands — the server
 * is always authoritative, the snapshot is never trusted as truth. It
 * only removes the blank-screen wait, exactly like SWR / TanStack Query
 * persistence.
 *
 * Safety:
 *  - schema-versioned: a shape change invalidates every old snapshot.
 *  - TTL bounded: a snapshot older than the TTL is ignored.
 *  - user-scoped keys: per-user lists are keyed by uid so account
 *    switching can never show the previous account's data.
 *  - fully wrapped in try/catch: private mode / quota / disabled
 *    storage degrades to "no cache", never throws.
 */ const $d8124bb9b4cd6dc4$var$PREFIX = 'taki_snap_';
const $d8124bb9b4cd6dc4$var$SCHEMA = 'v1';
// Default bound on how stale the very FIRST paint may be. The live fetch
// always revalidates on top of it.
const $d8124bb9b4cd6dc4$var$TTL_MS = 604800000; // 7 days
/**
 * v13.21 (طلب ناصر: «أريد كل شيء من الداتابيس ولا أريد بيانات عالقة»)
 *
 * صلاحية أقصر لما هو **حسّاس زمنياً**. العروض تحمل مخزوناً وسعراً ووقت
 * انتهاء تتغير بالثانية، فلقطة عمرها أيام قد تُظهر سعراً أو كمية لم تعد
 * صحيحة لو تأخّرت الشبكة. خمس دقائق تكفي تماماً لغرض «أول رسمة فورية»
 * (التحديث الدوري كل ٣٠ ثانية + البث اللحظي يغطّيان ما بعدها)، وما بعدها
 * نعرض المؤشّر ونقرأ من القاعدة بدل إظهار رقم قديم.
 */ const $d8124bb9b4cd6dc4$var$TTL_BY_KEY = [
    [
        /^deals$/,
        300000
    ],
    [
        /^bk_/,
        300000
    ],
    [
        /^sellers$/,
        3600000
    ]
];
const $d8124bb9b4cd6dc4$var$ttlFor = (key)=>{
    for (const [re, ms] of $d8124bb9b4cd6dc4$var$TTL_BY_KEY)if (re.test(key)) return ms;
    return $d8124bb9b4cd6dc4$var$TTL_MS;
};
function $d8124bb9b4cd6dc4$export$117db55c9cf9e6aa(key) {
    try {
        const raw = localStorage.getItem($d8124bb9b4cd6dc4$var$PREFIX + key);
        if (!raw) return null;
        const env = JSON.parse(raw);
        if (!env || env.s !== $d8124bb9b4cd6dc4$var$SCHEMA) return null;
        if (Date.now() - env.t > $d8124bb9b4cd6dc4$var$ttlFor(key)) return null;
        return env.d;
    } catch  {
        return null;
    }
}
function $d8124bb9b4cd6dc4$export$7b4fc7c56ad9d1fc(key, data) {
    try {
        const env = {
            s: $d8124bb9b4cd6dc4$var$SCHEMA,
            t: Date.now(),
            d: data
        };
        localStorage.setItem($d8124bb9b4cd6dc4$var$PREFIX + key, JSON.stringify(env));
    } catch  {
    // Quota exceeded / private mode / storage disabled — the cache is
    // best-effort; losing it only means the next open shows a spinner.
    }
}
function $d8124bb9b4cd6dc4$export$9d46d2a3b8aa6918(keyFragment) {
    try {
        const toRemove = [];
        for(let i = 0; i < localStorage.length; i++){
            const k = localStorage.key(i);
            if (!k || !k.startsWith($d8124bb9b4cd6dc4$var$PREFIX)) continue;
            if (!keyFragment || k.includes(keyFragment)) toRemove.push(k);
        }
        toRemove.forEach((k)=>localStorage.removeItem(k));
    } catch  {
    /* ignore */ }
}

});

parcelRegister("gL9Nf", function(module, exports) {

$parcel$export(module.exports, "guestFavorites", function () { return $0afbae0b924a0e4a$export$8ceb6132cefae865; });

var $8r4Fg = parcelRequire("8r4Fg");
/**
 * favoritesStore — مفضلة الزائر (غير المسجَّل) · v14.63
 * ═══════════════════════════════════════════════════════════════════════════
 * المفتاح `taki_favorites` كان مُعلناً في `config.ts` منذ إصدارات **ولم
 * يُستعمل ولا مرّة**. الزائر الذي يعجبه عرضٌ قبل أن يسجّل كان لا يملك أي طريقة
 * لحفظه، فيفقده إن أغلق الصفحة.
 *
 * كل قراءة وكتابة ملفوفة بـtry: المتصفّح في الوضع الخاص أو الممتلئ الحصّة
 * يرمي عند الكتابة، ولا يجوز أن يُسقط ذلك زرّاً في الواجهة.
 */ const $0afbae0b924a0e4a$var$KEY = (0, $8r4Fg.CONFIG).STORAGE_KEYS.FAVORITES;
const $0afbae0b924a0e4a$export$8ceb6132cefae865 = {
    read () {
        try {
            const raw = localStorage.getItem($0afbae0b924a0e4a$var$KEY);
            const parsed = raw ? JSON.parse(raw) : [];
            return Array.isArray(parsed) ? parsed.filter((x)=>typeof x === 'string') : [];
        } catch  {
            return [];
        }
    },
    write (ids) {
        try {
            localStorage.setItem($0afbae0b924a0e4a$var$KEY, JSON.stringify(ids));
        } catch  {}
    },
    clear () {
        try {
            localStorage.removeItem($0afbae0b924a0e4a$var$KEY);
        } catch  {}
    }
};
var $0afbae0b924a0e4a$export$2e2bcd8739ae039 = $0afbae0b924a0e4a$export$8ceb6132cefae865;

});
parcelRegister("8r4Fg", function(module, exports) {

$parcel$export(module.exports, "CONFIG", function () { return $53b296ff0816416c$export$1630b5343357e8b5; });
const $53b296ff0816416c$export$1630b5343357e8b5 = {
    BOOKING_DURATION_MS: 7200000,
    STORAGE_KEYS: {
        USER: 'taki_user_v2',
        USER_PROFILE: 'taki_user_profile',
        DEALS: 'taki_deals',
        BOOKINGS: 'taki_bookings',
        FAVORITES: 'taki_favorites',
        LANG: 'taki_lang',
        LOC: 'taki_loc',
        KEYWORDS: 'taki_keywords',
        NOTIFICATIONS: 'taki_notifs',
        STORE_PROFILES: 'taki_store_profiles',
        DARK_MODE: 'taki_dark',
        FOLLOWED_MERCHANTS: 'taki_followed',
        DATA_VERSION: 'taki_data_version',
        REGISTERED_ACCOUNTS: 'taki_registered_accounts',
        INITIALIZED: 'taki_initialized_v3',
        NOTIF_KEYWORDS: 'taki_notif_keywords',
        LAST_MARKETING_ALERTS: 'taki_last_marketing_alerts',
        LAST_SELLER_MAP_POS: 'taki_last_seller_map_pos'
    },
    APP_NAME: 'TAKI',
    VERSION: '5.0.0',
    // Bot Integration Config (for future Telegram & WhatsApp bot)
    BOT_CONFIG: {
        TELEGRAM: {
            WEBHOOK_URL: '',
            BOT_USERNAME: '@taki_deals_bot',
            COMMANDS: [
                '/start',
                '/explore',
                '/publish',
                '/bookings',
                '/profile',
                '/help'
            ]
        },
        WHATSAPP: {
            WEBHOOK_URL: '',
            PHONE_NUMBER: ''
        },
        DEFAULT_LANGUAGE: 'ar',
        NEARBY_RADIUS_KM: 10
    }
};

});


parcelRegister("cfBdF", function(module, exports) {

$parcel$export(module.exports, "publishErrorMessage", function () { return $69adb09d2bfe115a$export$6c3e76d9a9594336; });
/**
 * publishError — سببُ رفض النشر، بعبارةٍ يفهمها التاجر (v14.95)
 * ═══════════════════════════════════════════════════════════════════════════
 * حارسا `deals` الجديدان يرفعان استثناءً **بالعربي** من القاعدة، ولو وصل خاماً
 * إلى التاجر لصار «تعذّر حفظ العرض في قاعدة البيانات.» متبوعاً بنصٍّ لا يقول
 * له ماذا يفعل. فهذه الدالّة تحوّل الرمز/النصّ إلى عبارةٍ فيها **الخطوة
 * التالية**، وتُرجع `null` لأي شيءٍ لا تعرفه — فيبقى بديلُ المنادي كما هو.
 *
 * 🪤 لماذا تُطابَق الرموز **والنصّ** معاً: PostgREST يسلّم `code` و`message` في
 *    حقلين، و`dealRepository.save` ترمي الكائن كما هو، فالمنادي قد يمرّر
 *    `error.message` وحده. فمرِّر ما شئت — `msg` أو `` `${code} ${msg}` `` —
 *    والدالّة تلتقط الاثنين. (أرخصُ من فرض شكلٍ على كل منادٍ ثم نسيانه.)
 *
 * 🪤 والتطبيع ليس تجميلاً: نصّ القاعدة يحمل الشدّة («موثّق» · «يُحدَّد»)، وأي
 *    مطابقةٍ حرفيّةٍ تنكسر بحركةٍ واحدة تُضاف أو تُحذف في هجرةٍ لاحقة.
 */ /** يُسقط الحركات والتطويل، ويوحّد الهمزات — مطابقةٌ لا تنكسر بشدّة. */ const $69adb09d2bfe115a$var$norm = (s)=>s.replace(/[ً-ْٰـ]/g, '').replace(/[أإآ]/g, "\u0627").replace(/\s+/g, ' ').trim();
function $69adb09d2bfe115a$export$6c3e76d9a9594336(msg, isRTL) {
    const raw = String(msg || '');
    if (!raw) return null;
    const n = $69adb09d2bfe115a$var$norm(raw);
    // ── حدّ المواقع (قائم منذ v12.32) — نفسُ نصّ AppContext حرفاً بحرف ──────
    if (/LOCATION_LIMIT_EXCEEDED/i.test(raw)) return isRTL ? "\u26A0\uFE0F \u0648\u0635\u0644\u062A \u0644\u062D\u062F \u0627\u0644\u0645\u0648\u0627\u0642\u0639 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0641\u064A \u0628\u0627\u0642\u062A\u0643.\n\n\u0627\u062E\u062A\u0631 \u0645\u0648\u0642\u0639\u0627\u064B \u0645\u0646 \u0645\u0648\u0627\u0642\u0639\u0643 \u0627\u0644\u062D\u0627\u0644\u064A\u0629\u060C \u0623\u0648 \u0627\u062D\u0630\u0641 \u0643\u0644 \u0645\u0646\u062A\u062C\u0627\u062A \u0623\u062D\u062F \u0627\u0644\u0645\u0648\u0627\u0642\u0639 \u0627\u0644\u0634\u0627\u063A\u0631\u0629 \u0644\u062A\u0641\u0631\u064A\u063A \u062E\u0627\u0646\u0629 \u0642\u0628\u0644 \u0625\u0636\u0627\u0641\u0629 \u0645\u0648\u0642\u0639 \u062C\u062F\u064A\u062F. \u0644\u0644\u062A\u0631\u0642\u064A\u0629 \u0644\u0628\u0627\u0642\u0629 \u0623\u0643\u0628\u0631 \u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0625\u062F\u0627\u0631\u0629 \u062A\u0627\u0643\u064A." : "\u26A0\uFE0F You've reached your package's location limit.\n\nPick one of your existing locations, or free a vacant slot first. Contact TAKI admin to upgrade.";
    // ── P0022 — الحساب ليس حساب تاجر أصلاً ────────────────────────────────
    if (/\bP0022\b/.test(raw) || /ليس حساب تاجر/.test(n)) return isRTL ? "\u26A0\uFE0F \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0644\u064A\u0633 \u062D\u0633\u0627\u0628 \u062A\u0627\u062C\u0631\u060C \u0641\u0644\u0627 \u064A\u064F\u0646\u0634\u0631 \u0645\u0646\u0647 \u0639\u0631\u0636.\n\n\u0625\u0646 \u0643\u0646\u062A \u062A\u0627\u062C\u0631\u0627\u064B \u0641\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0625\u062F\u0627\u0631\u0629 \u062A\u0627\u0643\u064A \u0644\u062A\u062D\u0648\u064A\u0644 \u062D\u0633\u0627\u0628\u0643 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628 \u0645\u062A\u062C\u0631." : "\u26A0\uFE0F This is not a merchant account, so it cannot publish a deal.\n\nIf you are a merchant, contact TAKI support to switch your account to a store account.";
    // ── P0024 — متجرٌ غير موثّق (يُفحص قبل P0023: نصّه يذكر «التوثيق» أيضاً) ─
    if (/\bP0024\b/.test(raw) || /غير موثق/.test(n)) return isRTL ? "\uD83E\uDEAA \u0644\u0645 \u064A\u064F\u0646\u0634\u0631 \u0639\u0631\u0636\u0643: \u0645\u062A\u062C\u0631\u0643 \u063A\u064A\u0631 \u0645\u0648\u062B\u0651\u0642 \u0628\u0639\u062F.\n\n\u0627\u0641\u062A\u062D \xab\u062D\u0633\u0627\u0628\u064A \u2190 \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u0627\u062C\u0631 \u2190 \u062A\u0648\u062B\u064A\u0642 \u0627\u0644\u0645\u062A\u062C\u0631\xbb \u0648\u0623\u0631\u0633\u0644 \u0631\u0642\u0645 \u0633\u062C\u0644\u0643 \u0648\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062C\u064E\u0651\u0644. \u062A\u0635\u0644\u0643 \u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0625\u0634\u0639\u0627\u0631\u0627\u064B\u060C \u0648\u062A\u064F\u0646\u0634\u0631 \u0639\u0631\u0648\u0636\u0643 \u0628\u0636\u063A\u0637\u0629 \u0628\u0639\u062F\u0647\u0627.\n\n(\u0639\u0631\u0648\u0636\u0643 \u0627\u0644\u0645\u0646\u0634\u0648\u0631\u0629 \u0633\u0627\u0628\u0642\u0627\u064B \u062A\u0628\u0642\u0649 \u062A\u0639\u0645\u0644 \u0643\u0645\u0627 \u0647\u064A.)" : "\uD83E\uDEAA Your deal was not published: your store is not verified yet.\n\nOpen \u201CMy account \u2192 Merchant dashboard \u2192 Store verification\u201D and send your registration number and registered name. You will get the result as a notification, and can publish right after.\n\n(Deals already published keep working.)";
    // ── P0023 — رقم السجل لا يُكتب يدوياً ─────────────────────────────────
    if (/\bP0023\b/.test(raw) || /رقم السجل/.test(n)) return isRTL ? "\uD83E\uDEAA \u0631\u0642\u0645 \u0627\u0644\u0633\u062C\u0644 \u0644\u0627 \u064A\u064F\u0643\u062A\u0628 \u064A\u062F\u0648\u064A\u0627\u064B \u2014 \u064A\u064F\u0639\u062A\u0645\u062F \u0645\u0646 \u0637\u0644\u0628 \u0627\u0644\u062A\u0648\u062B\u064A\u0642 \u0648\u062D\u062F\u0647\u060C \u0644\u0623\u0646\u0647 \u064A\u064F\u0637\u0628\u0639 \u0639\u0644\u0649 \u0641\u0648\u0627\u062A\u064A\u0631 \u0639\u0645\u0644\u0627\u0626\u0643.\n\n\u0623\u0631\u0633\u0644\u0647 \u0645\u0646 \xab\u062D\u0633\u0627\u0628\u064A \u2190 \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u0627\u062C\u0631 \u2190 \u062A\u0648\u062B\u064A\u0642 \u0627\u0644\u0645\u062A\u062C\u0631\xbb." : "\uD83E\uDEAA The registration number cannot be typed in by hand \u2014 it is set only by an approved verification request, because it is printed on your customers\u2019 invoices.\n\nSend it from \u201CMy account \u2192 Merchant dashboard \u2192 Store verification\u201D.";
    return null;
}
var $69adb09d2bfe115a$export$2e2bcd8739ae039 = $69adb09d2bfe115a$export$6c3e76d9a9594336;

});

parcelRegister("jCjMw", function(module, exports) {
module.exports = $parcel$import("45fRo").then(()=>parcelRequire('4whDr'));

});

parcelRegister("6xdoN", function(module, exports) {

$parcel$export(module.exports, "isTelegramMiniApp", function () { return $4a2d361b2e543626$export$fb557fad1b5952f6; });
$parcel$export(module.exports, "initTelegramMiniApp", function () { return $4a2d361b2e543626$export$9f4eb873a302c1f6; });
$parcel$export(module.exports, "loginViaTelegram", function () { return $4a2d361b2e543626$export$d5dd82927cbd8f7f; });
$parcel$export(module.exports, "linkTelegramToCurrentUser", function () { return $4a2d361b2e543626$export$73073bed61064d08; });
$parcel$export(module.exports, "ensureTelegramLinked", function () { return $4a2d361b2e543626$export$42f047f99138bfed; });

var $hUL2G = parcelRequire("hUL2G");
function $4a2d361b2e543626$var$getWebApp() {
    try {
        return window?.Telegram?.WebApp || null;
    } catch  {
        return null;
    }
}
function $4a2d361b2e543626$export$fb557fad1b5952f6() {
    const wa = $4a2d361b2e543626$var$getWebApp();
    return !!(wa && typeof wa.initData === 'string' && wa.initData.length > 0);
}
let $4a2d361b2e543626$var$attempted = false;
async function $4a2d361b2e543626$export$9f4eb873a302c1f6() {
    const wa = $4a2d361b2e543626$var$getWebApp();
    if (!wa) return false;
    // Tell Telegram we're ready + use the full height sheet.
    try {
        wa.ready?.();
    } catch  {}
    try {
        wa.expand?.();
    } catch  {}
    const initData = wa.initData || '';
    if (!initData) return false;
    if ($4a2d361b2e543626$var$attempted) return true;
    $4a2d361b2e543626$var$attempted = true;
    // Already signed in on this device? Don't mint a new session.
    try {
        const { data: data } = await (0, $hUL2G.supabase).auth.getSession();
        if (data?.session) return true;
    } catch  {}
    try {
        const { data: data, error: error } = await (0, $hUL2G.supabase).functions.invoke('telegram-auth', {
            body: {
                initData: initData
            }
        });
        if (error || !data?.hashed_token) {
            console.warn('[telegram-auth] failed', error || data);
            return false;
        }
        const { error: vErr } = await (0, $hUL2G.supabase).auth.verifyOtp({
            type: 'magiclink',
            token_hash: data.hashed_token
        });
        if (vErr) {
            console.warn('[telegram verifyOtp] failed', vErr.message);
            return false;
        }
        return true;
    } catch (e) {
        console.warn('[telegram login] error', e?.message || e);
        return false;
    }
}
function $4a2d361b2e543626$export$66b5b52ce7e1c3da() {
    const wa = $4a2d361b2e543626$var$getWebApp();
    return wa && typeof wa.initData === 'string' ? wa.initData : '';
}
async function $4a2d361b2e543626$export$d5dd82927cbd8f7f() {
    const initData = $4a2d361b2e543626$export$66b5b52ce7e1c3da();
    if (!initData) return false;
    try {
        const { data: sess } = await (0, $hUL2G.supabase).auth.getSession();
        if (sess?.session) return true;
        const { data: data, error: error } = await (0, $hUL2G.supabase).functions.invoke('telegram-auth', {
            body: {
                initData: initData,
                allowCreate: true
            }
        });
        if (error || !data?.hashed_token) return false;
        const { error: vErr } = await (0, $hUL2G.supabase).auth.verifyOtp({
            type: 'magiclink',
            token_hash: data.hashed_token
        });
        return !vErr;
    } catch  {
        return false;
    }
}
async function $4a2d361b2e543626$export$73073bed61064d08() {
    const initData = $4a2d361b2e543626$export$66b5b52ce7e1c3da();
    if (!initData) return 'not_telegram';
    try {
        const { data: data, error: error } = await (0, $hUL2G.supabase).functions.invoke('telegram-auth', {
            body: {
                initData: initData,
                mode: 'link'
            }
        });
        if (error) return 'failed';
        if (data?.success) return 'linked';
        if (data?.code === 'not_authenticated') return 'not_authenticated';
        return 'failed';
    } catch  {
        return 'failed';
    }
}
async function $4a2d361b2e543626$export$42f047f99138bfed() {
    if (!$4a2d361b2e543626$export$fb557fad1b5952f6()) return 'not_telegram';
    const r = await $4a2d361b2e543626$export$73073bed61064d08();
    if (r === 'linked') return 'linked';
    if (r === 'not_authenticated') return 'not_authenticated';
    return 'failed';
}

});

parcelRegister("bZlZ8", function(module, exports) {
module.exports = $parcel$import("5JfwP").then(()=>parcelRequire('EIM4Y'));

});

parcelRegister("iw1Ih", function(module, exports) {

$parcel$export(module.exports, "trackVisit", function () { return $c0c49f192bf48885$export$2add79960af7847f; });
$parcel$export(module.exports, "markVisitBooked", function () { return $c0c49f192bf48885$export$2585910b0c12a5a5; });

var $hUL2G = parcelRequire("hUL2G");

var $411pF = parcelRequire("411pF");
/**
 * siteVisit — قياس الزائر ومصدره (v14.80).
 * ═══════════════════════════════════════════════════════════════════════════
 * ما كان ناقصاً: كل قياسات المنصّة مربوطةٌ بـ`store_id` — فزائرٌ يفتح الصفحة
 * الرئيسية ثم يخرج **غير مرئيّ تماماً**. ولا `document.referrer` ولا `utm_*`
 * في المستودع كلّه. فلا جواب لثلاثة أسئلة يحتاجها يوم الإطلاق:
 *   كم زائراً · من أي قناة · وأي صفحة أوقفتهم.
 *
 * ── ما لا يُرسَل من هنا عمداً ───────────────────────────────────────────────
 *  • لا كعكة ولا بصمة جهاز ولا معرّف دائم. المعرّف من `sessionStorage` يموت
 *    بإغلاق التبويب، وهو **نفس معرّف `analyticsTracker`** فلا معرّفان لشخصٍ واحد.
 *  • المُحيل يُرسَل كما هو **ويُقصّ على الخادم إلى اسم المضيف وحده** — القصّ في
 *    القاعدة لا هنا، فلا تُصلحه نسخةٌ وتنساه أخرى.
 *  • العنوان يُرسَل بمساره فقط؛ والاستعلام يُسقطه الخادم (فلا يُخزَّن باركود
 *    أو رمز دعوةٍ وقع في الرابط).
 *
 * 🪤 و**صامتٌ تماماً**: أي فشلٍ هنا يُبتلع. القياس لا يجوز أن يُعطّل تصفّحاً —
 *    وهو نفس مبدأ `analyticsTracker`.
 * 🪤 و`utm` تُلتقط **مرّة واحدة عند أول صفحة** وتُحفظ في الجلسة: الخادم يُسند
 *    لأوّل لمسة، ولو أرسلناها مع كل تنقّلٍ لضاعت عند أول رابطٍ داخلي.
 */ const $c0c49f192bf48885$var$SESSION_KEY = 'taki_an_sid'; // نفس مفتاح analyticsTracker — معرّفٌ واحد
const $c0c49f192bf48885$var$SENT_KEY = 'taki_visit_sent';
/** نفس اشتقاق analyticsTracker حرفياً حتى لا يفترق المعرّفان. */ const $c0c49f192bf48885$var$sessionId = ()=>{
    try {
        let s = sessionStorage.getItem($c0c49f192bf48885$var$SESSION_KEY);
        if (!s) {
            s = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
            sessionStorage.setItem($c0c49f192bf48885$var$SESSION_KEY, s);
        }
        return s;
    } catch  {
        return '';
    }
};
const $c0c49f192bf48885$var$device = ()=>{
    try {
        const w = window.innerWidth;
        const touch = navigator.maxTouchPoints > 0;
        if (touch && w < 768) return 'mobile';
        if (touch && w < 1180) return 'tablet';
        return 'desktop';
    } catch  {
        return 'desktop';
    }
};
const $c0c49f192bf48885$var$isStandalone = ()=>{
    try {
        return window.matchMedia?.('(display-mode: standalone)')?.matches === true || navigator.standalone === true;
    } catch  {
        return false;
    }
};
/** وسوم الحملة من العنوان — تُقرأ مرّة ثم تُحفظ للجلسة. */ const $c0c49f192bf48885$var$campaign = ()=>{
    const out = {};
    try {
        const q = new URLSearchParams(window.location.search);
        const map = {
            utm_source: 'source',
            utm_medium: 'medium',
            utm_campaign: 'campaign',
            ref: 'ref'
        };
        for (const [k, v] of Object.entries(map)){
            const val = q.get(k);
            if (val) out[v] = val.slice(0, 64);
        }
    } catch  {}
    return out;
};
let $c0c49f192bf48885$var$lastPath = '';
let $c0c49f192bf48885$var$inFlight = false;
const $c0c49f192bf48885$export$2add79960af7847f = (path)=>{
    if (!(0, $411pF.analyticsAllowed)()) return; // v14.82 — مفتاح «حسابي ← الخصوصية»
    const sid = $c0c49f192bf48885$var$sessionId();
    if (!sid) return;
    const p = (path || '/').split('?')[0].split('#')[0] || '/';
    if (p === $c0c49f192bf48885$var$lastPath || $c0c49f192bf48885$var$inFlight) return;
    $c0c49f192bf48885$var$lastPath = p;
    let first = false;
    try {
        first = sessionStorage.getItem($c0c49f192bf48885$var$SENT_KEY) !== '1';
        if (first) sessionStorage.setItem($c0c49f192bf48885$var$SENT_KEY, '1');
    } catch  {
        first = true;
    }
    $c0c49f192bf48885$var$inFlight = true;
    // 🪤 مُنشئ Supabase ليس Promise كاملاً (PromiseLike بلا `.catch`) —
    //    فالالتفاف بـ`Promise.resolve` هو ما يجعل الابتلاع الصامت ممكناً فعلاً.
    Promise.resolve((0, $hUL2G.supabase).rpc('track_site_visit', {
        p_session: sid,
        p_path: p,
        // المُحيل يُفيد في أول نداءٍ وحده — بعده يصير عنوان موقعنا نفسه.
        p_referrer: first ? document.referrer || null : null,
        p_utm: first ? $c0c49f192bf48885$var$campaign() : {},
        p_device: $c0c49f192bf48885$var$device(),
        p_pwa: $c0c49f192bf48885$var$isStandalone(),
        p_lang: document.documentElement.lang === 'en' ? 'en' : 'ar'
    })).catch(()=>{}).finally(()=>{
        $c0c49f192bf48885$var$inFlight = false;
    });
};
const $c0c49f192bf48885$export$2585910b0c12a5a5 = ()=>{
    if (!(0, $411pF.analyticsAllowed)()) return; // v14.82
    const sid = $c0c49f192bf48885$var$sessionId();
    if (!sid) return;
    Promise.resolve((0, $hUL2G.supabase).rpc('taki_mark_session_booked', {
        p_session: sid
    })).catch(()=>{});
};

});

parcelRegister("lJZYA", function(module, exports) {
module.exports = $parcel$import("gniSV").then(()=>parcelRequire('SpwET'));

});


parcelRegister("dVZDm", function(module, exports) {

$parcel$export(module.exports, "markPasswordRecovery", function () { return $af5e2ab55a68648a$export$e4663c3fe2473d22; });
$parcel$export(module.exports, "isPasswordRecovery", function () { return $af5e2ab55a68648a$export$625bce5863313aec; });
$parcel$export(module.exports, "clearPasswordRecovery", function () { return $af5e2ab55a68648a$export$b80ddc7479dc560f; });
/**
 * passwordRecovery.ts — مصدر واحد يقيني لحالة «نحن في مسار إعادة تعيين كلمة المرور»
 * ---------------------------------------------------------------------------
 * 🔴 المشكلة التي يحلّها (بلاغ ناصر: «الرابط من الإيميل دخّلني الموقع مباشرة»):
 *
 * رابط الاستعادة يعود إلى `/register#access_token=…&type=recovery`. وكان
 * كشفُ هذا الوضع يعتمد على حدث `PASSWORD_RECOVERY` من supabase-js — وهو حدث
 * **يقع مرّة واحدة عند تهيئة العميل**، أي غالباً **قبل** أن تُركَّب صفحة
 * التسجيل ويُسجَّل مستمعُها. فيُفوَّت الحدث، ولا يُفتح وضع التعيين، ويبقى
 * للمستخدم جلسةٌ صالحة ⇒ يسحبه `AuthRedirector` إلى الرئيسية بكلمته القديمة.
 *
 * ولم يكن ذلك التحويل الوحيد: `AuthRedirector` يحوّل أيضاً بمجرد رؤية
 * `access_token` في التجزئة — وتجزئةُ رابط الاستعادة تحتويه.
 *
 * ✅ الحلّ: **لا نعتمد على توقيت أي حدث**. نقرأ العنوان **لحظة تحميل هذه
 * الوحدة** (قبل أن يمسح supabase-js التجزئة عند `detectSessionInUrl`)، ونثبّت
 * النتيجة في `sessionStorage` فتبقى بعد مسح التجزئة وبعد أي إعادة تركيب أو
 * إعادة تحميل داخل نفس التبويب. وتُمحى **فقط** بعد حفظ كلمة المرور فعلاً أو
 * بمغادرة المستخدم الشاشة صراحةً.
 *
 * لماذا `sessionStorage` لا `localStorage`: الحالة تخصّ هذا التبويب وهذه
 * المحاولة. `localStorage` كان سيُبقي المستخدم عالقاً في وضع التعيين على كل
 * تبويب وفي كل زيارة لاحقة لو انقطع في المنتصف.
 */ const $af5e2ab55a68648a$var$KEY = 'taki_pw_recovery';
/** هل يحمل العنوان الحالي علامة مسار الاستعادة؟ */ const $af5e2ab55a68648a$var$urlSaysRecovery = ()=>{
    try {
        // GoTrue يعيد: /register#access_token=…&type=recovery&…
        // ونفحص `search` أيضاً تحسّباً لأي تهيئة تضع المعاملات في الاستعلام.
        const hay = `${window.location.hash || ''}&${window.location.search || ''}`;
        return /[?&#]type=recovery(?:&|$)/.test(hay);
    } catch  {
        return false;
    }
};
// ── يُنفَّذ مرّة عند أول استيراد، قبل أن تُمسح التجزئة ────────────────────────
try {
    if ($af5e2ab55a68648a$var$urlSaysRecovery()) sessionStorage.setItem($af5e2ab55a68648a$var$KEY, '1');
} catch  {}
const $af5e2ab55a68648a$export$e4663c3fe2473d22 = ()=>{
    try {
        sessionStorage.setItem($af5e2ab55a68648a$var$KEY, '1');
    } catch  {}
};
const $af5e2ab55a68648a$export$625bce5863313aec = ()=>{
    try {
        if (sessionStorage.getItem($af5e2ab55a68648a$var$KEY) === '1') return true;
    } catch  {}
    return $af5e2ab55a68648a$var$urlSaysRecovery();
};
const $af5e2ab55a68648a$export$b80ddc7479dc560f = ()=>{
    try {
        sessionStorage.removeItem($af5e2ab55a68648a$var$KEY);
    } catch  {}
};

});

parcelRegister("HIK1m", function(module, exports) {

$parcel$export(module.exports, "returnTo", function () { return $efdbbdb6051cc87e$export$a100abf02fd5bd2e; });
$parcel$export(module.exports, "goRegister", function () { return $efdbbdb6051cc87e$export$2ac5f0e23a5aa0f; });
/**
 * returnTo — أعِد الزائر إلى حيث كان (v14.28)
 * ═══════════════════════════════════════════════════════════════════════════
 * 🪤 ما كان قبله: زائرٌ يفتح رابط عرضٍ من واتساب، يضغط «احجز»، فيُدفع إلى
 * التسجيل. وبعد أن ينجح يجد نفسه على **الرئيسية** — والعرض الذي جاء من أجله
 * اختفى. عليه أن يبحث عنه من جديد، وكثيرون لا يفعلون.
 *
 * `sessionStorage` لا `localStorage` عمداً: الوجهة تخصّ هذه الجلسة وحدها.
 * وتبويبٌ فُتح أمس لا يخطف وجهة تبويب اليوم.
 */ const $efdbbdb6051cc87e$var$KEY = 'taki_return_to';
/** المسارات التي لا يجوز أن تكون وجهة عودة: لأنها تُعيدك إلى الحلقة نفسها. */ const $efdbbdb6051cc87e$var$BLOCKED = [
    '/register',
    '/complete-profile',
    '/login',
    '/auth'
];
const $efdbbdb6051cc87e$var$safe = (path)=>{
    if (!path || typeof path !== 'string') return null;
    // مسار داخلي فقط. `//host` و`https://host` كلاهما يخرج من الموقع، و`//`
    // خصوصاً يبدو داخلياً للعين وليس كذلك للمتصفّح.
    if (!path.startsWith('/') || path.startsWith('//')) return null;
    const base = path.split('?')[0].split('#')[0];
    if ($efdbbdb6051cc87e$var$BLOCKED.some((b)=>base === b || base.startsWith(b + '/'))) return null;
    if (path.length > 512) return null;
    return path;
};
const $efdbbdb6051cc87e$export$a100abf02fd5bd2e = {
    save (path) {
        const v = $efdbbdb6051cc87e$var$safe(path);
        try {
            if (v) sessionStorage.setItem($efdbbdb6051cc87e$var$KEY, v);
        } catch  {}
    },
    /** يقرأ ويمسح: وجهةٌ تُستهلك مرّة واحدة، فلا تُعيدك بعد شهر. */ take () {
        try {
            const v = $efdbbdb6051cc87e$var$safe(sessionStorage.getItem($efdbbdb6051cc87e$var$KEY));
            sessionStorage.removeItem($efdbbdb6051cc87e$var$KEY);
            return v;
        } catch  {
            return null;
        }
    },
    clear () {
        try {
            sessionStorage.removeItem($efdbbdb6051cc87e$var$KEY);
        } catch  {}
    }
};
function $efdbbdb6051cc87e$export$2ac5f0e23a5aa0f(history, from) {
    const here = from ?? (typeof window !== 'undefined' ? window.location.pathname + window.location.search : '');
    $efdbbdb6051cc87e$export$a100abf02fd5bd2e.save(here);
    history.push('/register');
}
var $efdbbdb6051cc87e$export$2e2bcd8739ae039 = $efdbbdb6051cc87e$export$a100abf02fd5bd2e;

});

parcelRegister("6rLjR", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", function () { return $4b19f85611302659$export$63baa8ccbe60bb07; });
$parcel$export(module.exports, "Router", function () { return $4b19f85611302659$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Redirect", function () { return $4b19f85611302659$export$2d8d895a0a0f636e; });
$parcel$export(module.exports, "matchPath", function () { return $4b19f85611302659$export$81336c211d5ff295; });
$parcel$export(module.exports, "Route", function () { return $4b19f85611302659$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Switch", function () { return $4b19f85611302659$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "useHistory", function () { return $4b19f85611302659$export$3420e1dc2c4a518c; });
$parcel$export(module.exports, "useLocation", function () { return $4b19f85611302659$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useParams", function () { return $4b19f85611302659$export$99eaa27ddbbb95ef; });

var $cyZba = parcelRequire("cyZba");

var $2eaC8 = parcelRequire("2eaC8");

var $kXlTW = parcelRequire("kXlTW");

var $hJqH2 = parcelRequire("hJqH2");


var $7Rvmm = parcelRequire("7Rvmm");

var $d0bMm = parcelRequire("d0bMm");

var $2JkOz = parcelRequire("2JkOz");
parcelRequire("iUwX0");

var $eKFfo = parcelRequire("eKFfo");

var $8ZdxO = parcelRequire("8ZdxO");
var $4b19f85611302659$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $4b19f85611302659$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $4b19f85611302659$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $4b19f85611302659$var$commonjsGlobal[key] = ($4b19f85611302659$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $4b19f85611302659$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $4b19f85611302659$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $4b19f85611302659$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $4b19f85611302659$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $4b19f85611302659$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $cyZba.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $4b19f85611302659$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($4b19f85611302659$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $4b19f85611302659$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($kXlTW))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $cyZba.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $4b19f85611302659$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $4b19f85611302659$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $4b19f85611302659$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($kXlTW))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $4b19f85611302659$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createContext || $4b19f85611302659$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $4b19f85611302659$var$createNamedContext = function createNamedContext(name) {
    var context = $4b19f85611302659$var$createContext();
    context.displayName = name;
    return context;
};
var $4b19f85611302659$export$c213558b66925821 = /*#__PURE__*/ $4b19f85611302659$var$createNamedContext("Router-History");
var $4b19f85611302659$export$63baa8ccbe60bb07 = /*#__PURE__*/ $4b19f85611302659$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $4b19f85611302659$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $cyZba.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $4b19f85611302659$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $cyZba.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $hJqH2.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
var $4b19f85611302659$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $cyZba.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $4b19f85611302659$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $7Rvmm.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $4b19f85611302659$var$messageType;
var $4b19f85611302659$var$cache = {};
var $4b19f85611302659$var$cacheLimit = 10000;
var $4b19f85611302659$var$cacheCount = 0;
function $4b19f85611302659$var$compilePath(path) {
    if ($4b19f85611302659$var$cache[path]) return $4b19f85611302659$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($2JkOz))).compile(path);
    if ($4b19f85611302659$var$cacheCount < $4b19f85611302659$var$cacheLimit) {
        $4b19f85611302659$var$cache[path] = generator;
        $4b19f85611302659$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $4b19f85611302659$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $4b19f85611302659$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $4b19f85611302659$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $7Rvmm.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $hJqH2.createLocation)(computedMatch ? typeof to === "string" ? $4b19f85611302659$export$82476f982757e71e(to, computedMatch.params) : (0, $d0bMm.default)({}, to, {
            pathname: $4b19f85611302659$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $hJqH2.createLocation)(prevProps.to);
                if (!(0, $hJqH2.locationsAreEqual)(prevLocation, (0, $d0bMm.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $4b19f85611302659$var$cache$1 = {};
var $4b19f85611302659$var$cacheLimit$1 = 10000;
var $4b19f85611302659$var$cacheCount$1 = 0;
function $4b19f85611302659$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $4b19f85611302659$var$cache$1[cacheKey] || ($4b19f85611302659$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($2JkOz)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($4b19f85611302659$var$cacheCount$1 < $4b19f85611302659$var$cacheLimit$1) {
        pathCache[path] = result;
        $4b19f85611302659$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $4b19f85611302659$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $4b19f85611302659$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $4b19f85611302659$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Children.count(children) === 0;
}
function $4b19f85611302659$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $4b19f85611302659$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $cyZba.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $7Rvmm.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $4b19f85611302659$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $d0bMm.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $4b19f85611302659$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
function $4b19f85611302659$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $4b19f85611302659$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $d0bMm.default)({}, location, {
        pathname: $4b19f85611302659$var$addLeadingSlash(basename) + location.pathname
    });
}
function $4b19f85611302659$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $4b19f85611302659$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $d0bMm.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $4b19f85611302659$var$createURL(location) {
    return typeof location === "string" ? location : (0, $hJqH2.createPath)(location);
}
function $4b19f85611302659$var$staticHandler(methodName) {
    return function() {
        (0, $7Rvmm.default)(false);
    };
}
function $4b19f85611302659$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $4b19f85611302659$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $cyZba.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $4b19f85611302659$var$noop;
        };
        _this.handleBlock = function() {
            return $4b19f85611302659$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $4b19f85611302659$var$addBasename(basename, (0, $hJqH2.createLocation)(location));
        context.url = $4b19f85611302659$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $eKFfo.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $4b19f85611302659$var$addLeadingSlash(basename + $4b19f85611302659$var$createURL(path));
            },
            action: "POP",
            location: $4b19f85611302659$var$stripBasename(basename, (0, $hJqH2.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $4b19f85611302659$var$staticHandler("go"),
            goBack: $4b19f85611302659$var$staticHandler("goBack"),
            goForward: $4b19f85611302659$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$55185c17a0fcbe46, (0, $d0bMm.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $4b19f85611302659$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $cyZba.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $7Rvmm.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $4b19f85611302659$export$81336c211d5ff295(location.pathname, (0, $d0bMm.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $4b19f85611302659$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $eKFfo.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($4b19f85611302659$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $7Rvmm.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement(Component, (0, $d0bMm.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8ZdxO)))(C, Component);
}
var $4b19f85611302659$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).useContext;
function $4b19f85611302659$export$3420e1dc2c4a518c() {
    return $4b19f85611302659$var$useContext($4b19f85611302659$export$c213558b66925821);
}
function $4b19f85611302659$export$45d76561a5302f2b() {
    return $4b19f85611302659$var$useContext($4b19f85611302659$export$63baa8ccbe60bb07).location;
}
function $4b19f85611302659$export$99eaa27ddbbb95ef() {
    var match = $4b19f85611302659$var$useContext($4b19f85611302659$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $4b19f85611302659$export$632be4bb944c1bc7(path) {
    var location = $4b19f85611302659$export$45d76561a5302f2b();
    var match = $4b19f85611302659$var$useContext($4b19f85611302659$export$63baa8ccbe60bb07).match;
    return path ? $4b19f85611302659$export$81336c211d5ff295(location.pathname, path) : match;
}
var $4b19f85611302659$var$global$1, $4b19f85611302659$var$key, $4b19f85611302659$var$buildNames, $4b19f85611302659$var$initialBuildName, $4b19f85611302659$var$secondaryBuildName;

});
parcelRegister("cyZba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92581def768cf50d$export$2e2bcd8739ae039; });

var $dhKNY = parcelRequire("dhKNY");
function $92581def768cf50d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $dhKNY.default)(t, o);
}

});
parcelRegister("dhKNY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ac12b64b5e16ac2$export$2e2bcd8739ae039; });
function $9ac12b64b5e16ac2$export$2e2bcd8739ae039(t, e) {
    return $9ac12b64b5e16ac2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9ac12b64b5e16ac2$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("kXlTW", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f41a4e7ba469cbce$var$ReactIs, $f41a4e7ba469cbce$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hgRbQ"))();

});
parcelRegister("hgRbQ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $8ZKlG = parcelRequire("8ZKlG");
function $c92d30bd72e46605$var$emptyFunction() {}
function $c92d30bd72e46605$var$emptyFunctionWithReset() {}
$c92d30bd72e46605$var$emptyFunctionWithReset.resetWarningCache = $c92d30bd72e46605$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8ZKlG) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $c92d30bd72e46605$var$emptyFunctionWithReset,
        resetWarningCache: $c92d30bd72e46605$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8ZKlG", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $68c7f9232aa6afa3$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $68c7f9232aa6afa3$var$ReactPropTypesSecret;

});



parcelRegister("hJqH2", function(module, exports) {

$parcel$export(module.exports, "createPath", function () { return $ce8b58571dae80f0$export$fe53371bee54353d; });
$parcel$export(module.exports, "createLocation", function () { return $ce8b58571dae80f0$export$90c043f1c57770b8; });
$parcel$export(module.exports, "locationsAreEqual", function () { return $ce8b58571dae80f0$export$c3e8bb440bd55b18; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $ce8b58571dae80f0$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $ce8b58571dae80f0$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $ce8b58571dae80f0$export$2b76ad033c6e6d08; });

var $d0bMm = parcelRequire("d0bMm");

var $g8bwc = parcelRequire("g8bwc");

var $i5NCZ = parcelRequire("i5NCZ");


var $7Rvmm = parcelRequire("7Rvmm");
function $ce8b58571dae80f0$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $ce8b58571dae80f0$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $ce8b58571dae80f0$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $ce8b58571dae80f0$var$stripBasename(path, prefix) {
    return $ce8b58571dae80f0$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $ce8b58571dae80f0$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $ce8b58571dae80f0$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $ce8b58571dae80f0$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $ce8b58571dae80f0$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $ce8b58571dae80f0$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $d0bMm.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $g8bwc.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $ce8b58571dae80f0$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $i5NCZ.default)(a.state, b.state);
}
function $ce8b58571dae80f0$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $ce8b58571dae80f0$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $ce8b58571dae80f0$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $ce8b58571dae80f0$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $ce8b58571dae80f0$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $ce8b58571dae80f0$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $ce8b58571dae80f0$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $ce8b58571dae80f0$var$PopStateEvent = 'popstate';
var $ce8b58571dae80f0$var$HashChangeEvent = 'hashchange';
function $ce8b58571dae80f0$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $ce8b58571dae80f0$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$ce8b58571dae80f0$var$canUseDOM && (0, $7Rvmm.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $ce8b58571dae80f0$var$supportsHistory();
    var needsHashChangeListener = !$ce8b58571dae80f0$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $ce8b58571dae80f0$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $ce8b58571dae80f0$var$stripTrailingSlash($ce8b58571dae80f0$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $ce8b58571dae80f0$var$stripBasename(path, basename);
        return $ce8b58571dae80f0$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $ce8b58571dae80f0$var$createTransitionManager();
    function setState(nextState) {
        (0, $d0bMm.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($ce8b58571dae80f0$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($ce8b58571dae80f0$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($ce8b58571dae80f0$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $ce8b58571dae80f0$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $ce8b58571dae80f0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $ce8b58571dae80f0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($ce8b58571dae80f0$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($ce8b58571dae80f0$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($ce8b58571dae80f0$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($ce8b58571dae80f0$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $ce8b58571dae80f0$var$HashChangeEvent$1 = 'hashchange';
var $ce8b58571dae80f0$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $ce8b58571dae80f0$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $ce8b58571dae80f0$var$stripLeadingSlash,
        decodePath: $ce8b58571dae80f0$var$addLeadingSlash
    },
    slash: {
        encodePath: $ce8b58571dae80f0$var$addLeadingSlash,
        decodePath: $ce8b58571dae80f0$var$addLeadingSlash
    }
};
function $ce8b58571dae80f0$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $ce8b58571dae80f0$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $ce8b58571dae80f0$var$pushHashPath(path) {
    window.location.hash = path;
}
function $ce8b58571dae80f0$var$replaceHashPath(path) {
    window.location.replace($ce8b58571dae80f0$var$stripHash(window.location.href) + '#' + path);
}
function $ce8b58571dae80f0$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$ce8b58571dae80f0$var$canUseDOM && (0, $7Rvmm.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $ce8b58571dae80f0$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $ce8b58571dae80f0$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $ce8b58571dae80f0$var$stripTrailingSlash($ce8b58571dae80f0$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $ce8b58571dae80f0$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($ce8b58571dae80f0$var$getHashPath());
        if (basename) path = $ce8b58571dae80f0$var$stripBasename(path, basename);
        return $ce8b58571dae80f0$export$90c043f1c57770b8(path);
    }
    var transitionManager = $ce8b58571dae80f0$var$createTransitionManager();
    function setState(nextState) {
        (0, $d0bMm.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $ce8b58571dae80f0$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $ce8b58571dae80f0$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $ce8b58571dae80f0$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($ce8b58571dae80f0$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($ce8b58571dae80f0$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $ce8b58571dae80f0$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $ce8b58571dae80f0$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $ce8b58571dae80f0$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $ce8b58571dae80f0$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $ce8b58571dae80f0$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $ce8b58571dae80f0$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $ce8b58571dae80f0$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $ce8b58571dae80f0$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $ce8b58571dae80f0$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($ce8b58571dae80f0$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $ce8b58571dae80f0$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $ce8b58571dae80f0$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $ce8b58571dae80f0$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $ce8b58571dae80f0$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($ce8b58571dae80f0$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($ce8b58571dae80f0$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($ce8b58571dae80f0$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $ce8b58571dae80f0$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $ce8b58571dae80f0$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $ce8b58571dae80f0$var$createTransitionManager();
    function setState(nextState) {
        (0, $d0bMm.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $ce8b58571dae80f0$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $ce8b58571dae80f0$export$90c043f1c57770b8(entry, undefined, createKey()) : $ce8b58571dae80f0$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $ce8b58571dae80f0$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $ce8b58571dae80f0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $ce8b58571dae80f0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $ce8b58571dae80f0$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("d0bMm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $977469827da2ab0c$export$2e2bcd8739ae039; });
function $977469827da2ab0c$export$2e2bcd8739ae039() {
    return $977469827da2ab0c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $977469827da2ab0c$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("g8bwc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbe653fc24919a88$export$2e2bcd8739ae039; });
function $bbe653fc24919a88$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $bbe653fc24919a88$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $bbe653fc24919a88$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $bbe653fc24919a88$var$isAbsolute(to);
    var isFromAbs = from && $bbe653fc24919a88$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $bbe653fc24919a88$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $bbe653fc24919a88$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $bbe653fc24919a88$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $bbe653fc24919a88$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$bbe653fc24919a88$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $bbe653fc24919a88$export$2e2bcd8739ae039 = $bbe653fc24919a88$var$resolvePathname;

});

parcelRegister("i5NCZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2bf30af6c2116d3$export$2e2bcd8739ae039; });
function $d2bf30af6c2116d3$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $d2bf30af6c2116d3$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $d2bf30af6c2116d3$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $d2bf30af6c2116d3$var$valueOf(a);
        var bValue = $d2bf30af6c2116d3$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $d2bf30af6c2116d3$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $d2bf30af6c2116d3$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $d2bf30af6c2116d3$export$2e2bcd8739ae039 = $d2bf30af6c2116d3$var$valueEqual;

});

parcelRegister("7Rvmm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b95cefeb25a6d42$export$2e2bcd8739ae039; });
var $5b95cefeb25a6d42$var$isProduction = true;
var $5b95cefeb25a6d42$var$prefix = 'Invariant failed';
function $5b95cefeb25a6d42$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($5b95cefeb25a6d42$var$isProduction) throw new Error($5b95cefeb25a6d42$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($5b95cefeb25a6d42$var$prefix, ": ").concat(provided) : $5b95cefeb25a6d42$var$prefix;
    throw new Error(value);
}

});


parcelRegister("2JkOz", function(module, exports) {

var $crwYz = parcelRequire("crwYz");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $1fcfee12afbea9be$var$pathToRegexp;
module.exports.parse = $1fcfee12afbea9be$var$parse;
module.exports.compile = $1fcfee12afbea9be$var$compile;
module.exports.tokensToFunction = $1fcfee12afbea9be$var$tokensToFunction;
module.exports.tokensToRegExp = $1fcfee12afbea9be$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $1fcfee12afbea9be$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $1fcfee12afbea9be$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $1fcfee12afbea9be$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $1fcfee12afbea9be$var$escapeGroup(pattern) : asterisk ? '.*' : $1fcfee12afbea9be$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $1fcfee12afbea9be$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $1fcfee12afbea9be$var$escapeString(delimiter) + ']+?';
    return $1fcfee12afbea9be$var$escapeString(prevText) + '|(?:(?!' + $1fcfee12afbea9be$var$escapeString(prevText) + ')[^' + $1fcfee12afbea9be$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $1fcfee12afbea9be$var$compile(str, options) {
    return $1fcfee12afbea9be$var$tokensToFunction($1fcfee12afbea9be$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $1fcfee12afbea9be$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $1fcfee12afbea9be$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $1fcfee12afbea9be$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $1fcfee12afbea9be$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $1fcfee12afbea9be$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($crwYz(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $1fcfee12afbea9be$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $1fcfee12afbea9be$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $1fcfee12afbea9be$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $1fcfee12afbea9be$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $1fcfee12afbea9be$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $1fcfee12afbea9be$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $1fcfee12afbea9be$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $1fcfee12afbea9be$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($1fcfee12afbea9be$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $1fcfee12afbea9be$var$flags(options));
    return $1fcfee12afbea9be$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $1fcfee12afbea9be$var$stringToRegexp(path, keys, options) {
    return $1fcfee12afbea9be$var$tokensToRegExp($1fcfee12afbea9be$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $1fcfee12afbea9be$var$tokensToRegExp(tokens, keys, options) {
    if (!$crwYz(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $1fcfee12afbea9be$var$escapeString(token);
        else {
            var prefix = $1fcfee12afbea9be$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $1fcfee12afbea9be$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $1fcfee12afbea9be$var$attachKeys(new RegExp('^' + route, $1fcfee12afbea9be$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $1fcfee12afbea9be$var$pathToRegexp(path, keys, options) {
    if (!$crwYz(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $1fcfee12afbea9be$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($crwYz(path)) return $1fcfee12afbea9be$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $1fcfee12afbea9be$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("crwYz", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});


parcelRegister("iUwX0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ey4pm"));

});
parcelRegister("ey4pm", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $a977a8ff85f6feb6$export$2b8d127b894957b9; }, function (v) { return $a977a8ff85f6feb6$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $a977a8ff85f6feb6$export$cea3a54a6425200c; }, function (v) { return $a977a8ff85f6feb6$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $a977a8ff85f6feb6$export$a7c73072b1a182ae; }, function (v) { return $a977a8ff85f6feb6$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $a977a8ff85f6feb6$export$9f27bc3417b4524d; }, function (v) { return $a977a8ff85f6feb6$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $a977a8ff85f6feb6$export$db77ccec0bb4ccac; }, function (v) { return $a977a8ff85f6feb6$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $a977a8ff85f6feb6$export$8392c0c9d3dcbd35; }, function (v) { return $a977a8ff85f6feb6$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a977a8ff85f6feb6$export$ffb0004e005737fa; }, function (v) { return $a977a8ff85f6feb6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $a977a8ff85f6feb6$export$b624eff549462981; }, function (v) { return $a977a8ff85f6feb6$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $a977a8ff85f6feb6$export$7897aa7841a5380c; }, function (v) { return $a977a8ff85f6feb6$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $a977a8ff85f6feb6$export$602eac185826482c; }, function (v) { return $a977a8ff85f6feb6$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $a977a8ff85f6feb6$export$e2c29f18771995cb; }, function (v) { return $a977a8ff85f6feb6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a977a8ff85f6feb6$export$5f8d39834fd61797; }, function (v) { return $a977a8ff85f6feb6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a977a8ff85f6feb6$export$74bf444e3cd11ea5; }, function (v) { return $a977a8ff85f6feb6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $a977a8ff85f6feb6$export$92387174baf9b227; }, function (v) { return $a977a8ff85f6feb6$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $a977a8ff85f6feb6$export$ec112efeb987d9c6; }, function (v) { return $a977a8ff85f6feb6$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $a977a8ff85f6feb6$export$b706b080d889d2c9; }, function (v) { return $a977a8ff85f6feb6$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $a977a8ff85f6feb6$export$5be5a87408f70ddc; }, function (v) { return $a977a8ff85f6feb6$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $a977a8ff85f6feb6$export$45a5e7f76e0caa8d; }, function (v) { return $a977a8ff85f6feb6$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $a977a8ff85f6feb6$export$455c2e768291efa6; }, function (v) { return $a977a8ff85f6feb6$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $a977a8ff85f6feb6$export$9522e17588c12572; }, function (v) { return $a977a8ff85f6feb6$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $a977a8ff85f6feb6$export$2110ac352bb060b9; }, function (v) { return $a977a8ff85f6feb6$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $a977a8ff85f6feb6$export$56885ab8b9c456ab; }, function (v) { return $a977a8ff85f6feb6$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $a977a8ff85f6feb6$export$d927fcb6adf8f9de; }, function (v) { return $a977a8ff85f6feb6$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $a977a8ff85f6feb6$export$b82d16f27459e05a; }, function (v) { return $a977a8ff85f6feb6$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $a977a8ff85f6feb6$export$522c17b4f5e123e8; }, function (v) { return $a977a8ff85f6feb6$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $a977a8ff85f6feb6$export$1aabd8a0274ecfd6; }, function (v) { return $a977a8ff85f6feb6$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $a977a8ff85f6feb6$export$9b621391a187a31a; }, function (v) { return $a977a8ff85f6feb6$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $a977a8ff85f6feb6$export$f5bbd400c2f4426f; }, function (v) { return $a977a8ff85f6feb6$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a977a8ff85f6feb6$export$2b8d127b894957b9;
var $a977a8ff85f6feb6$export$cea3a54a6425200c;
var $a977a8ff85f6feb6$export$a7c73072b1a182ae;
var $a977a8ff85f6feb6$export$9f27bc3417b4524d;
var $a977a8ff85f6feb6$export$db77ccec0bb4ccac;
var $a977a8ff85f6feb6$export$8392c0c9d3dcbd35;
var $a977a8ff85f6feb6$export$ffb0004e005737fa;
var $a977a8ff85f6feb6$export$b624eff549462981;
var $a977a8ff85f6feb6$export$7897aa7841a5380c;
var $a977a8ff85f6feb6$export$602eac185826482c;
var $a977a8ff85f6feb6$export$e2c29f18771995cb;
var $a977a8ff85f6feb6$export$5f8d39834fd61797;
var $a977a8ff85f6feb6$export$74bf444e3cd11ea5;
var $a977a8ff85f6feb6$export$92387174baf9b227;
var $a977a8ff85f6feb6$export$ec112efeb987d9c6;
var $a977a8ff85f6feb6$export$b706b080d889d2c9;
var $a977a8ff85f6feb6$export$5be5a87408f70ddc;
var $a977a8ff85f6feb6$export$45a5e7f76e0caa8d;
var $a977a8ff85f6feb6$export$455c2e768291efa6;
var $a977a8ff85f6feb6$export$9522e17588c12572;
var $a977a8ff85f6feb6$export$2110ac352bb060b9;
var $a977a8ff85f6feb6$export$56885ab8b9c456ab;
var $a977a8ff85f6feb6$export$d927fcb6adf8f9de;
var $a977a8ff85f6feb6$export$b82d16f27459e05a;
var $a977a8ff85f6feb6$export$522c17b4f5e123e8;
var $a977a8ff85f6feb6$export$1aabd8a0274ecfd6;
var $a977a8ff85f6feb6$export$9b621391a187a31a;
var $a977a8ff85f6feb6$export$f5bbd400c2f4426f;
'use strict';
var $a977a8ff85f6feb6$var$b = "function" === typeof Symbol && Symbol.for, $a977a8ff85f6feb6$var$c = $a977a8ff85f6feb6$var$b ? Symbol.for("react.element") : 60103, $a977a8ff85f6feb6$var$d = $a977a8ff85f6feb6$var$b ? Symbol.for("react.portal") : 60106, $a977a8ff85f6feb6$var$e = $a977a8ff85f6feb6$var$b ? Symbol.for("react.fragment") : 60107, $a977a8ff85f6feb6$var$f = $a977a8ff85f6feb6$var$b ? Symbol.for("react.strict_mode") : 60108, $a977a8ff85f6feb6$var$g = $a977a8ff85f6feb6$var$b ? Symbol.for("react.profiler") : 60114, $a977a8ff85f6feb6$var$h = $a977a8ff85f6feb6$var$b ? Symbol.for("react.provider") : 60109, $a977a8ff85f6feb6$var$k = $a977a8ff85f6feb6$var$b ? Symbol.for("react.context") : 60110, $a977a8ff85f6feb6$var$l = $a977a8ff85f6feb6$var$b ? Symbol.for("react.async_mode") : 60111, $a977a8ff85f6feb6$var$m = $a977a8ff85f6feb6$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a977a8ff85f6feb6$var$n = $a977a8ff85f6feb6$var$b ? Symbol.for("react.forward_ref") : 60112, $a977a8ff85f6feb6$var$p = $a977a8ff85f6feb6$var$b ? Symbol.for("react.suspense") : 60113, $a977a8ff85f6feb6$var$q = $a977a8ff85f6feb6$var$b ? Symbol.for("react.suspense_list") : 60120, $a977a8ff85f6feb6$var$r = $a977a8ff85f6feb6$var$b ? Symbol.for("react.memo") : 60115, $a977a8ff85f6feb6$var$t = $a977a8ff85f6feb6$var$b ? Symbol.for("react.lazy") : 60116, $a977a8ff85f6feb6$var$v = $a977a8ff85f6feb6$var$b ? Symbol.for("react.block") : 60121, $a977a8ff85f6feb6$var$w = $a977a8ff85f6feb6$var$b ? Symbol.for("react.fundamental") : 60117, $a977a8ff85f6feb6$var$x = $a977a8ff85f6feb6$var$b ? Symbol.for("react.responder") : 60118, $a977a8ff85f6feb6$var$y = $a977a8ff85f6feb6$var$b ? Symbol.for("react.scope") : 60119;
function $a977a8ff85f6feb6$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a977a8ff85f6feb6$var$c:
                switch(a = a.type, a){
                    case $a977a8ff85f6feb6$var$l:
                    case $a977a8ff85f6feb6$var$m:
                    case $a977a8ff85f6feb6$var$e:
                    case $a977a8ff85f6feb6$var$g:
                    case $a977a8ff85f6feb6$var$f:
                    case $a977a8ff85f6feb6$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a977a8ff85f6feb6$var$k:
                            case $a977a8ff85f6feb6$var$n:
                            case $a977a8ff85f6feb6$var$t:
                            case $a977a8ff85f6feb6$var$r:
                            case $a977a8ff85f6feb6$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a977a8ff85f6feb6$var$d:
                return u;
        }
    }
}
function $a977a8ff85f6feb6$var$A(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$m;
}
$a977a8ff85f6feb6$export$2b8d127b894957b9 = $a977a8ff85f6feb6$var$l;
$a977a8ff85f6feb6$export$cea3a54a6425200c = $a977a8ff85f6feb6$var$m;
$a977a8ff85f6feb6$export$a7c73072b1a182ae = $a977a8ff85f6feb6$var$k;
$a977a8ff85f6feb6$export$9f27bc3417b4524d = $a977a8ff85f6feb6$var$h;
$a977a8ff85f6feb6$export$db77ccec0bb4ccac = $a977a8ff85f6feb6$var$c;
$a977a8ff85f6feb6$export$8392c0c9d3dcbd35 = $a977a8ff85f6feb6$var$n;
$a977a8ff85f6feb6$export$ffb0004e005737fa = $a977a8ff85f6feb6$var$e;
$a977a8ff85f6feb6$export$b624eff549462981 = $a977a8ff85f6feb6$var$t;
$a977a8ff85f6feb6$export$7897aa7841a5380c = $a977a8ff85f6feb6$var$r;
$a977a8ff85f6feb6$export$602eac185826482c = $a977a8ff85f6feb6$var$d;
$a977a8ff85f6feb6$export$e2c29f18771995cb = $a977a8ff85f6feb6$var$g;
$a977a8ff85f6feb6$export$5f8d39834fd61797 = $a977a8ff85f6feb6$var$f;
$a977a8ff85f6feb6$export$74bf444e3cd11ea5 = $a977a8ff85f6feb6$var$p;
$a977a8ff85f6feb6$export$92387174baf9b227 = function(a) {
    return $a977a8ff85f6feb6$var$A(a) || $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$l;
};
$a977a8ff85f6feb6$export$ec112efeb987d9c6 = $a977a8ff85f6feb6$var$A;
$a977a8ff85f6feb6$export$b706b080d889d2c9 = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$k;
};
$a977a8ff85f6feb6$export$5be5a87408f70ddc = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$h;
};
$a977a8ff85f6feb6$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a977a8ff85f6feb6$var$c;
};
$a977a8ff85f6feb6$export$455c2e768291efa6 = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$n;
};
$a977a8ff85f6feb6$export$9522e17588c12572 = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$e;
};
$a977a8ff85f6feb6$export$2110ac352bb060b9 = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$t;
};
$a977a8ff85f6feb6$export$56885ab8b9c456ab = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$r;
};
$a977a8ff85f6feb6$export$d927fcb6adf8f9de = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$d;
};
$a977a8ff85f6feb6$export$b82d16f27459e05a = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$g;
};
$a977a8ff85f6feb6$export$522c17b4f5e123e8 = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$f;
};
$a977a8ff85f6feb6$export$1aabd8a0274ecfd6 = function(a) {
    return $a977a8ff85f6feb6$var$z(a) === $a977a8ff85f6feb6$var$p;
};
$a977a8ff85f6feb6$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a977a8ff85f6feb6$var$e || a === $a977a8ff85f6feb6$var$m || a === $a977a8ff85f6feb6$var$g || a === $a977a8ff85f6feb6$var$f || a === $a977a8ff85f6feb6$var$p || a === $a977a8ff85f6feb6$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a977a8ff85f6feb6$var$t || a.$$typeof === $a977a8ff85f6feb6$var$r || a.$$typeof === $a977a8ff85f6feb6$var$h || a.$$typeof === $a977a8ff85f6feb6$var$k || a.$$typeof === $a977a8ff85f6feb6$var$n || a.$$typeof === $a977a8ff85f6feb6$var$w || a.$$typeof === $a977a8ff85f6feb6$var$x || a.$$typeof === $a977a8ff85f6feb6$var$y || a.$$typeof === $a977a8ff85f6feb6$var$v);
};
$a977a8ff85f6feb6$export$f5bbd400c2f4426f = $a977a8ff85f6feb6$var$z;

});


parcelRegister("eKFfo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abd55b64afecb873$export$2e2bcd8739ae039; });
function $abd55b64afecb873$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("8ZdxO", function(module, exports) {
'use strict';

var $iUwX0 = parcelRequire("iUwX0");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $01b03bfb571a23c6$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $01b03bfb571a23c6$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $01b03bfb571a23c6$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $01b03bfb571a23c6$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $01b03bfb571a23c6$var$TYPE_STATICS = {};
$01b03bfb571a23c6$var$TYPE_STATICS[$iUwX0.ForwardRef] = $01b03bfb571a23c6$var$FORWARD_REF_STATICS;
$01b03bfb571a23c6$var$TYPE_STATICS[$iUwX0.Memo] = $01b03bfb571a23c6$var$MEMO_STATICS;
function $01b03bfb571a23c6$var$getStatics(component) {
    // React v16.11 and below
    if ($iUwX0.isMemo(component)) return $01b03bfb571a23c6$var$MEMO_STATICS;
     // React v16.12 and above
    return $01b03bfb571a23c6$var$TYPE_STATICS[component['$$typeof']] || $01b03bfb571a23c6$var$REACT_STATICS;
}
var $01b03bfb571a23c6$var$defineProperty = Object.defineProperty;
var $01b03bfb571a23c6$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $01b03bfb571a23c6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $01b03bfb571a23c6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $01b03bfb571a23c6$var$getPrototypeOf = Object.getPrototypeOf;
var $01b03bfb571a23c6$var$objectPrototype = Object.prototype;
function $01b03bfb571a23c6$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($01b03bfb571a23c6$var$objectPrototype) {
            var inheritedComponent = $01b03bfb571a23c6$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $01b03bfb571a23c6$var$objectPrototype) $01b03bfb571a23c6$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $01b03bfb571a23c6$var$getOwnPropertyNames(sourceComponent);
        if ($01b03bfb571a23c6$var$getOwnPropertySymbols) keys = keys.concat($01b03bfb571a23c6$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $01b03bfb571a23c6$var$getStatics(targetComponent);
        var sourceStatics = $01b03bfb571a23c6$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$01b03bfb571a23c6$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $01b03bfb571a23c6$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $01b03bfb571a23c6$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $01b03bfb571a23c6$var$hoistNonReactStatics;

});


parcelRegister("5JI7W", function(module, exports) {

$parcel$export(module.exports, "bumpNavDepth", function () { return $1e5ac1ededf01cc5$export$87a76b2afcba772c; });
$parcel$export(module.exports, "smartBack", function () { return $1e5ac1ededf01cc5$export$5c9f62f8965585a3; });
// v12.98 — تتبّع عمق التنقّل داخل التطبيق + «رجوع ذكي».
//
// المشكلة: أزرار «العودة» التي تستدعي history.push('/') تُنشئ إدخالاً جديداً في
// السجل (PUSH) فيقفز مدير التمرير للأعلى بدل استعادة موضع الصفحة السابقة. الرجوع
// الحقيقي (POP عبر goBack) هو ما يجعل المدير يستعيد الموضع بالضبط.
//
// لكن goBack() الأعمى قد يخرج من التطبيق كلياً إذا كان المستخدم دخل مباشرةً على
// صفحة عميقة (رابط خارجي/إشعار) بلا تاريخ داخلي. لذا نعدّ كم انتقالاً PUSH تمّ
// داخل جلسة التطبيق: إن كان > 0 فالرجوع آمن (يبقى داخل التطبيق ويستعيد الموضع)،
// وإلا نسقط إلى وجهة افتراضية (الرئيسية غالباً).
let $1e5ac1ededf01cc5$var$appNavDepth = 0;
const $1e5ac1ededf01cc5$export$87a76b2afcba772c = (action)=>{
    if (action === 'PUSH') $1e5ac1ededf01cc5$var$appNavDepth += 1;
    else if (action === 'POP') $1e5ac1ededf01cc5$var$appNavDepth = Math.max(0, $1e5ac1ededf01cc5$var$appNavDepth - 1);
// REPLACE لا يغيّر العمق (يستبدل الإدخال الحالي بلا إضافة/حذف).
};
const $1e5ac1ededf01cc5$export$726a263e9dec7784 = ()=>$1e5ac1ededf01cc5$var$appNavDepth > 0;
const $1e5ac1ededf01cc5$export$5c9f62f8965585a3 = (history, fallback = '/')=>{
    if ($1e5ac1ededf01cc5$var$appNavDepth > 0) history.goBack();
    else history.push(fallback);
};

});

parcelRegister("849SX", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1Y1CV"),
    $parcel$import("clcdZ"),
    $parcel$import("dAgal")
]).then(()=>parcelRequire('6gsR2'));

});

parcelRegister("8EfWo", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("kiFiY"))($parcel$resolve("5hGYw")),
    $parcel$import("eZdgN"),
    $parcel$import("bVnKH"),
    $parcel$import("75ZpN"),
    $parcel$import("7miI0"),
    $parcel$import("clcdZ"),
    $parcel$import("5WMzO")
]).then(()=>parcelRequire('5v1fT'));

});
parcelRegister("kiFiY", function(module, exports) {
"use strict";

var $2mQOm = parcelRequire("2mQOm");
module.exports = $2mQOm(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("2mQOm", function(module, exports) {
"use strict";
var $1b969a0bedc5335e$var$cachedBundles = {};
var $1b969a0bedc5335e$var$cachedPreloads = {};
var $1b969a0bedc5335e$var$cachedPrefetches = {};
function $1b969a0bedc5335e$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1b969a0bedc5335e$var$cachedPreloads;
        case 'prefetch':
            return $1b969a0bedc5335e$var$cachedPrefetches;
        default:
            return $1b969a0bedc5335e$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1b969a0bedc5335e$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("aeroq", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("clcdZ"),
    $parcel$import("g279z")
]).then(()=>parcelRequire('7iMgc'));

});

parcelRegister("go6YP", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("kiFiY"))($parcel$resolve("dSUGQ")),
    $parcel$import("bVnKH"),
    $parcel$import("5dHHe")
]).then(()=>parcelRequire('cX7QX'));

});

parcelRegister("b5vkl", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("5wh6l"),
    $parcel$import("izAlD")
]).then(()=>parcelRequire('lWLvZ'));

});

parcelRegister("1qXYJ", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1Y1CV"),
    $parcel$import("ek5bZ")
]).then(()=>parcelRequire('l9YJO'));

});

parcelRegister("86FRQ", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("kiFiY"))($parcel$resolve("7mdnq")),
    $parcel$import("bVnKH"),
    $parcel$import("gRgue"),
    $parcel$import("fMJDB")
]).then(()=>parcelRequire('ilRk1'));

});

parcelRegister("eN7Mv", function(module, exports) {
module.exports = $parcel$import("6z9Th").then(()=>parcelRequire('6leoV'));

});

parcelRegister("9dyTB", function(module, exports) {
module.exports = $parcel$import("5LJfL").then(()=>parcelRequire('anE4k'));

});

parcelRegister("irf4d", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("01Stw"),
    $parcel$import("gFFjV"),
    $parcel$import("js19t"),
    $parcel$import("9Gg76"),
    $parcel$import("eZdgN"),
    $parcel$import("75ZpN"),
    $parcel$import("dqPWK")
]).then(()=>parcelRequire('csMNu'));

});

parcelRegister("ksxAm", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("gFFjV"),
    $parcel$import("js19t"),
    $parcel$import("5wh6l"),
    $parcel$import("1Y1CV"),
    $parcel$import("7miI0"),
    $parcel$import("5VBLg")
]).then(()=>parcelRequire('imEkP'));

});

parcelRegister("5sRB7", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("clcdZ"),
    $parcel$import("ap1Hd")
]).then(()=>parcelRequire('aaqio'));

});

parcelRegister("fnOy6", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1Y1CV"),
    $parcel$import("3U6qo")
]).then(()=>parcelRequire('jtq5Z'));

});

parcelRegister("93yqV", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("gFFjV"),
    $parcel$import("4g8lU")
]).then(()=>parcelRequire('e3fPq'));

});

parcelRegister("cdaDq", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("9Gg76"),
    $parcel$import("eZdgN"),
    $parcel$import("al8mc")
]).then(()=>parcelRequire('oWUc1'));

});

parcelRegister("c5gwY", function(module, exports) {
module.exports = $parcel$import("jUiuX").then(()=>parcelRequire('ct4cV'));

});

parcelRegister("ealWH", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1Y1CV"),
    $parcel$import("h7Kk8")
]).then(()=>parcelRequire('lLpX3'));

});

parcelRegister("8HJ93", function(module, exports) {
module.exports = $parcel$import("57pdp").then(()=>parcelRequire('8JO1C'));

});

parcelRegister("2IoRt", function(module, exports) {
module.exports = $parcel$import("2qyiw").then(()=>parcelRequire('7T8CY'));

});

parcelRegister("ps57r", function(module, exports) {
module.exports = $parcel$import("7p6iP").then(()=>parcelRequire('3l8Gs'));

});

parcelRegister("67KMC", function(module, exports) {
module.exports = $parcel$import("cbmlH").then(()=>parcelRequire('dwmVK'));

});

parcelRegister("inbOg", function(module, exports) {
module.exports = $parcel$import("aSppd").then(()=>parcelRequire('ldbtZ'));

});

parcelRegister("5XbF3", function(module, exports) {
module.exports = $parcel$import("6y6Kj").then(()=>parcelRequire('gGYEK'));

});

parcelRegister("gazls", function(module, exports) {
module.exports = $parcel$import("9GDFm").then(()=>parcelRequire('bJ6a8'));

});

parcelRegister("7fgaP", function(module, exports) {
module.exports = $parcel$import("f4HKM").then(()=>parcelRequire('7m7y6'));

});

parcelRegister("3Htee", function(module, exports) {
module.exports = $parcel$import("bhWZt").then(()=>parcelRequire('8H6Fp'));

});

parcelRegister("6HJWm", function(module, exports) {
module.exports = $parcel$import("fbuQQ").then(()=>parcelRequire('jgJeT'));

});

parcelRegister("9rqDb", function(module, exports) {
module.exports = $parcel$import("4DAcT").then(()=>parcelRequire('eZ9AT'));

});

var $0fe664c20ab99227$exports = {};
$parcel$extendImportMap({
    "g9eTp": "authenticityRepository.d33010ca.js",
    "45fRo": "promoRepository.fe9c3a82.js",
    "5JfwP": "ratingRepository.9eec9182.js",
    "gniSV": "analyticsTracker.cd2daa74.js",
    "dAgal": "Home.31690146.js",
    "1WwlQ": "searchTracker.a23ff62a.js",
    "clcdZ": "Home.b83de9d8.js",
    "1Y1CV": "Home.27521bb6.js",
    "5WMzO": "Bookings.ce26898b.js",
    "7miI0": "ReportDialog.8384cad1.js",
    "75ZpN": "Bookings.d5758efd.js",
    "bVnKH": "Bookings.f4739092.js",
    "cDE3k": "marker-icon.3f7d3721.png",
    "gU3Mb": "marker-icon-2x.160d643f.png",
    "lSLqB": "marker-shadow.8f26ed1f.png",
    "eZdgN": "Bookings.b1a24be2.js",
    "5hGYw": "Bookings.e1dce3ee.css",
    "tC7BB": "layers.760a0456.png",
    "3vthU": "layers-2x.b7b89169.png",
    "8rbqY": "marker-icon.3f7d3721.png",
    "g279z": "BookingReceipt.ca26727d.js",
    "5dHHe": "Nearby.16c8aafb.js",
    "dSUGQ": "Nearby.3d3b52fc.css",
    "izAlD": "DealDetails.580d43eb.js",
    "gRgue": "BuyerAddressCard.0bb2ca4f.js",
    "7mdnq": "BuyerAddressCard.4799c318.css",
    "5wh6l": "DealDetails.6c8628ea.js",
    "ek5bZ": "DealsList.7f6681ff.js",
    "fMJDB": "Profile.5fc82c4c.js",
    "6z9Th": "Register.2ef0eee7.js",
    "5LJfL": "CompleteProfile.6f2ab192.js",
    "dqPWK": "SellerDashboard.6dc315ff.js",
    "jenRZ": "BarcodeScanner.ab47f44a.js",
    "h8uWr": "DualCalendarPicker.9d831103.js",
    "5oD7t": "ImageCropEditor.ce8b58af.js",
    "c7YtS": "CameraCapture.b1c535b1.js",
    "bwB89": "WorkingHoursEditor.7c7c7d65.js",
    "fLoR2": "ReferralCard.a2bb3f69.js",
    "2hJBw": "GatewayCard.2164a9ee.js",
    "e5onD": "DeliveryCard.b5efe2e7.js",
    "adsZy": "DeliveryCard.c39f59c6.css",
    "8I8LJ": "StockLinkCard.34170fc2.js",
    "5jfi1": "DeliveryTrackerCard.e8b827a3.js",
    "3vYEh": "SellerAnalytics.430b6b38.js",
    "48PTP": "StoreLocationPicker.29860e9f.js",
    "d7IOe": "StoreLocationPicker.e4f9bfb6.css",
    "9Gg76": "SellerDashboard.8b915307.js",
    "js19t": "SellerDashboard.2f97577e.js",
    "gFFjV": "SellerDashboard.32315cef.js",
    "01Stw": "storageService.70786294.js",
    "gY6gu": "moderationService.e5007878.js",
    "2uNiP": "dist.39f302a4.js",
    "5VBLg": "StoreDetails.452200ee.js",
    "bGia5": "StoreBranchesMap.7bff4ec7.js",
    "ewcJL": "StoreBranchesMap.04d38701.css",
    "ap1Hd": "Notifications.1fa1b075.js",
    "3U6qo": "SeasonalOffers.b87fbdbd.js",
    "4g8lU": "AdminDashboard.4639e8ac.js",
    "6VLnw": "AdminOverview.1aa1b920.js",
    "kdueH": "AdminBuyers.44410f21.js",
    "9buj7": "PromoteToAdminDialog.3ecf00a4.js",
    "kdR5h": "AdminSellers.3819587e.js",
    "9jJqd": "AdminAnalytics.841b0784.js",
    "38nGf": "AdminTools.ab66b0f7.js",
    "g91mo": "AdminTools.cb15fc42.js",
    "hH4W3": "AdminLocations.463e6c6a.js",
    "aL3pg": "AdminLocations.3cc56326.css",
    "kf00Z": "AdminContests.9c8b4cf7.js",
    "5z5y0": "AdminReports.90950520.js",
    "7lAWD": "AdminOperations.82f69097.js",
    "f0NxV": "AdminVerification.8b7b9bfb.js",
    "8Af1g": "AdminModeration.fd005629.js",
    "igzj1": "AdminLaunch.70cc7ce6.js",
    "kw1t7": "AdminTax.39d76d4f.js",
    "79Hlo": "AdminDelivery.a16c5a45.js",
    "eXWlC": "AdminInvoices.88d9857a.js",
    "iS2Kk": "AdminMessages.6dc9ef56.js",
    "kK6pf": "AdminMessaging.c4c00de5.js",
    "1RKvy": "AdminAdmins.60e36603.js",
    "NYhZF": "AdminAnalyst.803159f9.js",
    "o4EXv": "AdminAudience.25554e37.js",
    "al8mc": "Subscription.531a9020.js",
    "jUiuX": "Contests.f2f9709f.js",
    "h7Kk8": "Favorites.fc827fe9.js",
    "57pdp": "MyComplaints.5f0b4bcf.js",
    "2qyiw": "Terms.cfcbce5c.js",
    "7p6iP": "Privacy.7ab043bc.js",
    "cbmlH": "Refund.0564328b.js",
    "aSppd": "About.339d4745.js",
    "6y6Kj": "Contact.c04059ba.js",
    "9GDFm": "FAQ.c57a90f6.js",
    "f4HKM": "NotFound.6479e8b3.js",
    "bhWZt": "UpdateBanner.69220c9f.js",
    "fbuQQ": "InstallPrompt.ffa88a97.js",
    "4DAcT": "esm.13936255.js"
});


var $gCmhw = parcelRequire("gCmhw");
parcelRequire("2eaC8");

var $52EYl = parcelRequire("52EYl");

var $1wrgB = parcelRequire("1wrgB");
// ⚠️ أول استيراد عمداً: وحدةُ كشف مسار الاستعادة تقرأ تجزئة العنوان لحظة
// تحميلها، ويجب أن يسبق ذلك تهيئةَ عميل supabase الذي يمسح التجزئة.

var $gCmhw = parcelRequire("gCmhw");

var $dVZDm = parcelRequire("dVZDm");

var $HIK1m = parcelRequire("HIK1m");

var $2eaC8 = parcelRequire("2eaC8");

var $6rLjR = parcelRequire("6rLjR");

var $cyZba = parcelRequire("cyZba");

var $2eaC8 = parcelRequire("2eaC8");

var $hJqH2 = parcelRequire("hJqH2");



var $d0bMm = parcelRequire("d0bMm");

var $eKFfo = parcelRequire("eKFfo");

var $7Rvmm = parcelRequire("7Rvmm");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $e493fc9e94bf912b$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $cyZba.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $hJqH2.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement((0, $6rLjR.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $e493fc9e94bf912b$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $cyZba.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $hJqH2.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement((0, $6rLjR.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).Component);
var $e493fc9e94bf912b$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $e493fc9e94bf912b$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $hJqH2.createLocation)(to, null, null, currentLocation) : to;
};
var $e493fc9e94bf912b$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $e493fc9e94bf912b$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).forwardRef;
if (typeof $e493fc9e94bf912b$var$forwardRef === "undefined") $e493fc9e94bf912b$var$forwardRef = $e493fc9e94bf912b$var$forwardRefShim;
function $e493fc9e94bf912b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $e493fc9e94bf912b$var$LinkAnchor = $e493fc9e94bf912b$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $eKFfo.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $d0bMm.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$e493fc9e94bf912b$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($e493fc9e94bf912b$var$forwardRefShim !== $e493fc9e94bf912b$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $e493fc9e94bf912b$export$a6c7ac8248d6e38a = $e493fc9e94bf912b$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $e493fc9e94bf912b$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $eKFfo.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement((0, $6rLjR.__RouterContext).Consumer, null, function(context) {
        !context && (0, $7Rvmm.default)(false);
        var history = context.history;
        var location = $e493fc9e94bf912b$var$normalizeToLocation($e493fc9e94bf912b$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $d0bMm.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $e493fc9e94bf912b$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $hJqH2.createPath)(context.location) === (0, $hJqH2.createPath)($e493fc9e94bf912b$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($e493fc9e94bf912b$var$forwardRefShim !== $e493fc9e94bf912b$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement(component, props);
    });
});
var $e493fc9e94bf912b$var$toType, $e493fc9e94bf912b$var$refType;
var $e493fc9e94bf912b$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $e493fc9e94bf912b$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).forwardRef;
if (typeof $e493fc9e94bf912b$var$forwardRef$1 === "undefined") $e493fc9e94bf912b$var$forwardRef$1 = $e493fc9e94bf912b$var$forwardRefShim$1;
function $e493fc9e94bf912b$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $e493fc9e94bf912b$export$b0d92dbee9b5b60d = $e493fc9e94bf912b$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $eKFfo.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement((0, $6rLjR.__RouterContext).Consumer, null, function(context) {
        !context && (0, $7Rvmm.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $e493fc9e94bf912b$var$normalizeToLocation($e493fc9e94bf912b$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $6rLjR.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $e493fc9e94bf912b$var$joinClassnames(className, activeClassName);
            style = (0, $d0bMm.default)({}, style, activeStyle);
        }
        var props = (0, $d0bMm.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($e493fc9e94bf912b$var$forwardRefShim$1 !== $e493fc9e94bf912b$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).createElement($e493fc9e94bf912b$export$a6c7ac8248d6e38a, props);
    });
});
var $e493fc9e94bf912b$var$ariaCurrentType;


var $6rLjR = parcelRequire("6rLjR");

var $iw1Ih = parcelRequire("iw1Ih");

var $1wrgB = parcelRequire("1wrgB");

var $5JI7W = parcelRequire("5JI7W");

var $hUL2G = parcelRequire("hUL2G");

var $4aj47 = parcelRequire("4aj47");

var $gCmhw = parcelRequire("gCmhw");

var $2eaC8 = parcelRequire("2eaC8");

var $6rLjR = parcelRequire("6rLjR");

var $1wrgB = parcelRequire("1wrgB");
/**
 * Non-blocking top notification banner. Replaces the old blocking center
 * "موافق" modal that fired once per unread booking — a merchant taking
 * hundreds of orders could not work through a modal per order. This sits at
 * the top, auto-dismisses, and (crucially) never intercepts taps on the page
 * behind it: the outer layer is pointer-events:none, only the card itself is
 * tappable. Shown identically for buyer and seller.
 */ const $d7e015a0631a1e3c$var$AUTO_DISMISS_MS = 5000;
const $d7e015a0631a1e3c$var$InAppBanner = ()=>{
    const { inAppBanner: inAppBanner, dismissInAppBanner: dismissInAppBanner, language: language } = (0, $1wrgB.useApp)();
    const history = (0, $6rLjR.useHistory)();
    const isRTL = language === 'ar';
    (0, $2eaC8.useEffect)(()=>{
        if (!inAppBanner) return;
        const t = setTimeout(()=>dismissInAppBanner(), $d7e015a0631a1e3c$var$AUTO_DISMISS_MS);
        return ()=>clearTimeout(t);
    }, [
        inAppBanner,
        dismissInAppBanner
    ]);
    if (!inAppBanner) return null;
    const meta = inAppBanner.metadata || {};
    const barcode = meta.barcode;
    const dealId = meta.dealId;
    const audience = meta.audience;
    const followerId = meta.followerId;
    // Same destination rules as the Notifications list so a tap lands where
    // the booking + its chat thread live.
    const dest = audience === 'seller' && barcode ? `/seller?tab=orders&barcode=${barcode}` : audience === 'buyer' && barcode ? `/bookings?barcode=${barcode}` : barcode ? `/bookings?barcode=${barcode}` : dealId ? `/deal/${dealId}` : followerId ? '/profile' : '/notifications';
    const title = isRTL ? inAppBanner.title.ar : inAppBanner.title.en;
    const body = isRTL ? inAppBanner.body.ar : inAppBanner.body.en;
    return /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
        dir: isRTL ? 'rtl' : 'ltr',
        style: {
            position: 'fixed',
            top: 'calc(env(safe-area-inset-top, 0px) + 8px)',
            left: 0,
            right: 0,
            zIndex: 99998,
            display: 'flex',
            justifyContent: 'center',
            padding: '0 12px',
            pointerEvents: 'none'
        },
        children: /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
            role: "button",
            tabIndex: 0,
            onClick: ()=>{
                dismissInAppBanner();
                if (dest) history.push(dest);
            },
            onKeyDown: (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    dismissInAppBanner();
                    if (dest) history.push(dest);
                }
            },
            className: "animate-fade-in",
            style: {
                pointerEvents: 'auto',
                width: '100%',
                maxWidth: 460,
                background: 'rgba(15, 23, 42, 0.96)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                color: '#fff',
                borderRadius: 18,
                boxShadow: '0 12px 34px rgba(0,0,0,0.45)',
                border: '1px solid rgba(255,255,255,0.12)',
                padding: '12px 14px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                cursor: 'pointer'
            },
            children: [
                /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                    style: {
                        width: 38,
                        height: 38,
                        borderRadius: 11,
                        flexShrink: 0,
                        background: 'linear-gradient(135deg, #10b981, #059669)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.1rem'
                    },
                    children: "\uD83D\uDD14"
                }),
                /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                            style: {
                                fontSize: '0.86rem',
                                fontWeight: 900,
                                marginBottom: 2,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                            style: {
                                fontSize: '0.78rem',
                                fontWeight: 600,
                                opacity: 0.88,
                                lineHeight: 1.45,
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden'
                            },
                            children: body
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gCmhw.jsx)("button", {
                    type: "button",
                    "aria-label": isRTL ? "\u0625\u063A\u0644\u0627\u0642" : 'Dismiss',
                    onClick: (e)=>{
                        e.stopPropagation();
                        dismissInAppBanner();
                    },
                    style: {
                        background: 'rgba(255,255,255,0.12)',
                        border: 'none',
                        color: '#fff',
                        width: 26,
                        height: 26,
                        minWidth: 26,
                        borderRadius: 8,
                        cursor: 'pointer',
                        fontSize: '0.8rem',
                        fontWeight: 900,
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    children: "\u2715"
                })
            ]
        })
    });
};
var $d7e015a0631a1e3c$export$2e2bcd8739ae039 = $d7e015a0631a1e3c$var$InAppBanner;



var $gCmhw = parcelRequire("gCmhw");

var $2eaC8 = parcelRequire("2eaC8");

var $6rLjR = parcelRequire("6rLjR");

var $1wrgB = parcelRequire("1wrgB");

var $inbzl = parcelRequire("inbzl");
/**
 * v12.45 — «عمق الموسم»: طبقة ثابتة فوق الصفحة كلها تُمطر عناصر الموسم
 * (فوانيس رمضان تهبط، شموس الصيف تنزل من فوق لتحت، بالونات العيد تصعد…)
 * بأنيميشن CSS خالص — transform فقط، بلا أي مؤقّتات JS، وبتأخيرات سالبة
 * فتكون «السماء» ممتلئة من أول لحظة. pointer-events:none فلا تعيق أي ضغطة.
 * مخفية داخل لوحة المدير (/admin) حتى تبقى بيئة العمل صافية، وتختفي
 * تلقائياً لمن فعّل «تقليل الحركة» في نظامه.
 * v12.46-47 (طلب ناصر): «فرحة دخول» فقط — ٥ ثوانٍ من دخول عناصر جديدة عند
 * فتح التطبيق، وبعدها لا ينزل شيء جديد من الأعلى بينما تُكمل العناصر
 * النازلة رحلتها كاملة حتى خارج الشاشة (لا اختفاء مفاجئ في منتصف الهواء).
 * تعود الفرحة من جديد لحظة تفعيل/تبديل موسم من لوحة المدير (realtime).
 */ const $414ca410e466a94e$var$COUNT = 16;
const $414ca410e466a94e$var$SHOW_MS = 5000; // نافذة دخول عناصر جديدة من الأعلى
// مولّد شبه عشوائي حتمي (mulberry32) — نفس الموسم يعطي نفس التوزيع دائماً،
// فلا «تقفز» العناصر لمواضع جديدة مع كل re-render أو تنقّل بين الصفحات.
const $414ca410e466a94e$var$mulberry32 = (seed)=>()=>{
        seed |= 0;
        seed = seed + 0x6D2B79F5 | 0;
        let t = Math.imul(seed ^ seed >>> 15, 1 | seed);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
const $414ca410e466a94e$var$SeasonFX = ()=>{
    const { platformSettings: platformSettings } = (0, $1wrgB.useApp)();
    const location = (0, $6rLjR.useLocation)();
    const season = (0, $inbzl.getSeasonById)(platformSettings.seasonalTheme);
    // ⚠️ flakes يُعرَّف قبل الـeffect الذي يقرأه في deps — فخ TDZ المعروف (v10.61).
    const flakes = (0, $2eaC8.useMemo)(()=>{
        if (!season) return [];
        let seed = 0;
        for(let i = 0; i < season.id.length; i++)seed = seed * 31 + season.id.charCodeAt(i);
        const rnd = $414ca410e466a94e$var$mulberry32(seed);
        return Array.from({
            length: $414ca410e466a94e$var$COUNT
        }, (_, i)=>{
            const dur = 11 + rnd() * 11; // 11–22s سقوط بطيء مريح
            return {
                key: i,
                item: season.fx.items[i % season.fx.items.length],
                x: `${Math.round(rnd() * 96)}%`,
                size: `${Math.round(14 + rnd() * 18)}px`,
                dur: `${dur.toFixed(1)}s`,
                delay: `-${(rnd() * dur).toFixed(1)}s`,
                drift: `${Math.round((rnd() - 0.5) * 120)}px`,
                op: (0.3 + rnd() * 0.3).toFixed(2)
            };
        });
    }, [
        season?.id
    ]);
    // «فرحة الدخول» (v12.47): on = عناصر جديدة تدخل من الأعلى (animation
    // infinite). بعد ٥ ثوانٍ نمنح كل عنصر عدد دوراته الجارية فقط
    // (iteration-count محدود) فيُكمل نزوله الحالي حتى خارج الشاشة ثم يقف —
    // بلا اختفاء مفاجئ في منتصف الهواء — وبعد وصول آخر عنصر تُزال الطبقة
    // كلها (off). تغيير iteration-count لا يُعيد تشغيل الأنيميشن (بعكس
    // animation-name). تبديل الموسم من لوحة المدير يعيد الدورة من جديد.
    const containerRef = (0, $2eaC8.useRef)(null);
    const [phase, setPhase] = (0, $2eaC8.useState)('on');
    (0, $2eaC8.useEffect)(()=>{
        if (!season) return;
        setPhase('on');
        let t2;
        const t1 = setTimeout(()=>{
            let maxEndMs = 0;
            const root = containerRef.current;
            if (root) Array.from(root.children).forEach((el, i)=>{
                const f = flakes[i];
                if (!f) return;
                const dur = parseFloat(f.dur);
                const delayAbs = Math.abs(parseFloat(f.delay));
                // الدورة الجارية الآن = floor((الزمن المنقضي + |التأخير|) / المدة)؛
                // نسمح بإكمالها فقط ثم يقف العنصر (opacity الأساس 0 = غير مرئي).
                const iters = Math.floor(($414ca410e466a94e$var$SHOW_MS / 1000 + delayAbs) / dur) + 1;
                el.style.animationIterationCount = String(iters);
                const endMs = (iters * dur - delayAbs) * 1000;
                if (endMs > maxEndMs) maxEndMs = endMs;
            });
            // إزالة الطبقة نهائياً بعد أن يُنهي آخر عنصر رحلته (+ هامش بسيط).
            t2 = setTimeout(()=>setPhase('off'), Math.max(0, maxEndMs - $414ca410e466a94e$var$SHOW_MS) + 800);
        }, $414ca410e466a94e$var$SHOW_MS);
        return ()=>{
            clearTimeout(t1);
            if (t2) clearTimeout(t2);
        };
    }, [
        season?.id,
        flakes
    ]);
    // داخل لوحة المدير الكثافة البصرية عالية أصلاً — نُبقيها صافية.
    if (!season || phase === 'off' || location.pathname.startsWith('/admin')) return null;
    return /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
        ref: containerRef,
        className: `season-fx${season.fx.mode === 'rise' ? ' rise' : ''}`,
        "aria-hidden": true,
        children: flakes.map((f)=>/*#__PURE__*/ (0, $gCmhw.jsx)("span", {
                style: {
                    '--fx-x': f.x,
                    '--fx-size': f.size,
                    '--fx-dur': f.dur,
                    '--fx-delay': f.delay,
                    '--fx-drift': f.drift,
                    '--fx-op': f.op
                },
                children: f.item
            }, f.key))
    });
};
var $414ca410e466a94e$export$2e2bcd8739ae039 = $414ca410e466a94e$var$SeasonFX;



var $inbzl = parcelRequire("inbzl");

var $6xdoN = parcelRequire("6xdoN");
// True only inside Telegram AND when the user arrived via the bot's "ربط حسابي"
// link (index.tsx stamps sessionStorage on ?tglink=1). Used to send the user to
// the profile linking page right after they authenticate inside Telegram —
// other browsers keep their normal home/dashboard landing.
const $3b2255436c932565$var$tgLinkIntent = ()=>{
    try {
        return (0, $6xdoN.isTelegramMiniApp)() && sessionStorage.getItem('taki_tglink') === '1';
    } catch  {
        return false;
    }
};

// Code-split each route. Initial bundle no longer pays for pages the user
// hasn't visited (e.g. SellerDashboard's 1124 lines on a buyer's first paint).
const $3b2255436c932565$var$Home = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("849SX")));

const $3b2255436c932565$var$Bookings = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("8EfWo")));

const $3b2255436c932565$var$BookingReceipt = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("aeroq")));

const $3b2255436c932565$var$Nearby = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("go6YP")));

const $3b2255436c932565$var$DealDetails = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("b5vkl")));

const $3b2255436c932565$var$DealsList = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("1qXYJ")));

const $3b2255436c932565$var$Profile = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("86FRQ")));

const $3b2255436c932565$var$Register = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("eN7Mv")));

const $3b2255436c932565$var$CompleteProfile = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("9dyTB")));

const $3b2255436c932565$var$SellerDashboard = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("irf4d")));

const $3b2255436c932565$var$StoreDetails = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("ksxAm")));

const $3b2255436c932565$var$Notifications = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("5sRB7")));

const $3b2255436c932565$var$SeasonalOffers = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("fnOy6")));

const $3b2255436c932565$var$AdminDashboard = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("93yqV")));

const $3b2255436c932565$var$Subscription = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("cdaDq")));

const $3b2255436c932565$var$Contests = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("c5gwY")));

const $3b2255436c932565$var$Favorites = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("ealWH")));

const $3b2255436c932565$var$MyComplaints = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("8HJ93")));

const $3b2255436c932565$var$Terms = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("2IoRt")));

const $3b2255436c932565$var$Privacy = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("ps57r")));

const $3b2255436c932565$var$Refund = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("67KMC")));

const $3b2255436c932565$var$About = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("inbOg")));

const $3b2255436c932565$var$Contact = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("5XbF3")));

const $3b2255436c932565$var$FAQ = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("gazls")));

const $3b2255436c932565$var$NotFound = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("7fgaP")));
const $3b2255436c932565$var$RouteFallback = ()=>/*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            fontFamily: 'Tajawal, sans-serif',
            color: 'var(--text-secondary)'
        },
        children: [
            /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                style: {
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    border: '3px solid var(--border-color)',
                    borderTopColor: '#10b981',
                    animation: 'taki-spin 0.8s linear infinite'
                }
            }),
            /*#__PURE__*/ (0, $gCmhw.jsx)("style", {
                children: `@keyframes taki-spin{to{transform:rotate(360deg)}}`
            })
        ]
    });
const $3b2255436c932565$var$AuthRedirector = ()=>{
    const context = (0, $1wrgB.useApp)();
    const user = context.user;
    const isAuthReady = context.isAuthReady;
    const language = context.language;
    const customAlert = context.customAlert;
    const impersonating = context.impersonating;
    const history = (0, $6rLjR.useHistory)();
    const location = (0, $6rLjR.useLocation)();
    const isRTL = language === 'ar';
    // Helper: determine user type from context user OR directly from Supabase session metadata
    const getUserType = async ()=>{
        if (user && user.userType) return user.userType;
        // Fallback: read directly from Supabase session
        try {
            const { data: data } = await (0, $hUL2G.supabase).auth.getSession();
            const meta = data?.session?.user?.user_metadata;
            if (meta?.user_type) return meta.user_type;
        } catch  {}
        return 'buyer';
    };
    // Helper: figure out where to send the user post-auth. OAuth users
    // (Google/Apple) arrive with no phone/shop, so they must complete
    // their profile before reaching the role-specific dashboard.
    const getPostAuthDestination = async (uType)=>{
        // Inside Telegram's link flow → finish on the profile linking page.
        if ($3b2255436c932565$var$tgLinkIntent()) return '/profile?tglink=1';
        // Direct DB lookup is safer than trusting user_metadata mirrors.
        try {
            const { data: sess } = await (0, $hUL2G.supabase).auth.getSession();
            const uid = sess?.session?.user?.id;
            if (uid) {
                const { data: row } = await (0, $hUL2G.supabase).from('users').select('phone, shop, user_type').eq('id', uid).maybeSingle();
                const phoneMissing = !row?.phone || String(row.phone).length < 9;
                const effectiveType = row?.user_type || uType;
                const shopMissing = effectiveType === 'seller' && !row?.shop;
                if (phoneMissing || shopMissing) return '/complete-profile';
            }
        } catch  {}
        // v14.28 — الوجهة التي جاء منها الزائر أولى بالعودة من الرئيسية.
        // ترتيبها بعد `complete-profile` عمداً: من لا يملك هاتفاً لا يستطيع
        // الحجز أصلاً، فإعادته إلى العرض تُوقعه في رفضٍ لا يفهمه.
        const back = (0, $HIK1m.returnTo).take();
        if (back) return back;
        return uType === 'admin' ? '/admin' : uType === 'seller' ? '/seller' : '/';
    };
    (0, $2eaC8.useEffect)(()=>{
        let timer;
        if (location.hash) {
            (0, $4aj47.logger).info("\uD83D\uDD17 AuthRedirector: Hash detected:", location.hash.substring(0, 50) + '...');
            // 🔴 v14.03 — رابط الاستعادة تجزئته تحوي `access_token` أيضاً، فكان
            // هذا الشرط يبتلعه ويحوّل المستخدم للرئيسية بعد ثانية — قبل أن
            // يُطلب منه تعيين كلمة مرور. هذا هو سبب «الرابط دخّلني مباشرة».
            if ((0, $dVZDm.isPasswordRecovery)()) (0, $4aj47.logger).info("\uD83D\uDD11 \u0645\u0633\u0627\u0631 \u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u2014 \u0644\u0627 \u062A\u062D\u0648\u064A\u0644.");
            else if (location.hash.indexOf('access_token') !== -1 || location.hash.indexOf('type=signup') !== -1 || location.hash.indexOf('type=magiclink') !== -1) timer = setTimeout(async ()=>{
                const uType = await getUserType();
                const dest = await getPostAuthDestination(uType);
                (0, $4aj47.logger).info("\uD83D\uDD04 Redirecting based on hash auth to:", dest);
                // After magic-link / signup auth, buyers land on the
                // home feed. Admins/sellers go to their dashboards.
                // OAuth users with an incomplete profile are funneled
                // through /complete-profile first (see getPostAuthDestination).
                history.replace(dest);
            }, 1000);
            if (location.hash.indexOf('error_description') !== -1) {
                const params = new URLSearchParams(location.hash.replace('#', ''));
                const errorDesc = params.get('error_description') || '';
                const decodedError = decodeURIComponent(errorDesc.replace(/\+/g, ' '));
                customAlert(isRTL ? "\u26A0\uFE0F \u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0631\u0627\u0628\u0637: " + decodedError : "\u26A0\uFE0F Link Error: " + decodedError);
                history.replace('/register');
            }
        }
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('access_token') && !(0, $dVZDm.isPasswordRecovery)()) {
            (0, $4aj47.logger).info("\uD83D\uDD17 AuthRedirector: Query access_token detected");
            timer = setTimeout(async ()=>{
                const uType = await getUserType();
                const dest = await getPostAuthDestination(uType);
                (0, $4aj47.logger).info("\uD83D\uDD04 Redirecting based on query auth to:", dest);
                history.replace(dest);
            }, 1000);
        }
        return ()=>clearTimeout(timer);
    }, [
        location.hash,
        history,
        user,
        customAlert,
        isRTL
    ]);
    (0, $2eaC8.useEffect)(()=>{
        if (user) {
            // 🔴 v14.03 — **أول حارس على الإطلاق**: التحقّق من رمز الاستعادة
            // يُنشئ جلسةً، وكل تحويل بعده كان يسحب المستخدم من شاشة تعيين
            // كلمة المرور قبل أن يحفظها. وُضع في v14.02 بعد فحص «الملف ناقص»
            // فكان مستخدمٌ بلا جوال (حساب OAuth مثلاً) يُسحب إلى
            // /complete-profile رغم أنه في منتصف استعادة كلمته.
            //
            // القاعدة: ما دام المستخدم في مسار الاستعادة فلا يحرّكه أحد حتى
            // يحفظ كلمته أو يغادر الشاشة بنفسه.
            if ((0, $dVZDm.isPasswordRecovery)()) return;
            // While an admin is "browsing as" a target user, skip the
            // profile-completion + register/complete-profile redirects —
            // admin is just observing and must NOT be funneled into editing
            // the target's profile. The exit banner is the way back.
            if (impersonating) return;
            // Telegram link flow: once authenticated inside Telegram, finish
            // linking on the profile page. Other browsers keep their normal
            // landing (the intent flag is only set inside Telegram).
            if ($3b2255436c932565$var$tgLinkIntent()) {
                if (location.pathname !== '/profile') history.replace('/profile?tglink=1');
                return;
            }
            // Detect OAuth users whose profile is missing required fields.
            // Email/password signups never reach this branch with a missing
            // phone — the Register form blocks that. OAuth providers
            // (Google/Apple) hand us email+name but never the Saudi phone
            // or the buyer/seller choice, so funnel them through
            // /complete-profile before granting access to the rest of the
            // app. Once they fill it in, CompleteProfile redirects to the
            // correct landing page.
            const phoneMissing = !user.phone || String(user.phone).length < 9;
            const shopMissing = user.userType === 'seller' && !user.shop;
            const profileIncomplete = phoneMissing || shopMissing;
            if (profileIncomplete && location.pathname !== '/complete-profile') {
                history.replace('/complete-profile');
                return;
            }
            if (location.pathname === '/register' || !profileIncomplete && location.pathname === '/complete-profile') {
                const dest = user.userType === 'admin' ? '/admin' : user.userType === 'seller' ? '/seller' : '/';
                history.replace(dest);
            }
        } else if (isAuthReady) // Only kick to home AFTER auth has resolved. Without this guard,
        // a refresh on /admin or /seller bounces logged-in users to '/'
        // because user is briefly null while the Supabase session loads
        // (the white-screen bug the admin reported).
        {
            if (location.pathname === '/seller' || location.pathname === '/admin') {
                (0, $4aj47.logger).info("\uD83D\uDEAA AuthRedirector: Guest on protected route, redirecting to home");
                history.replace('/');
            }
        }
    }, [
        user,
        isAuthReady,
        location.pathname,
        location.search,
        history
    ]);
    return null;
};
// v12.48 — بوابة صفحة عروض الموسم: تفتح للعامة خلال النافذة العامة التي
// حددها المالك فقط (public_from → public_to)، وللتجار والأدمن معاينة مبكرة
// خلال نافذة إضافة العروض. خارج ذلك أي رابط قديم يعود للرئيسية بصمت.
const $3b2255436c932565$var$SeasonalGate = ()=>{
    const { platformSettings: platformSettings, platformSettingsReady: platformSettingsReady, user: user } = (0, $1wrgB.useApp)();
    // فتح /seasonal برابط مباشر يسبق وصول الإعدادات من الخادم — لا نحكم
    // بالطرد قبل أن نعرف نوافذ الحملة فعلاً (كان يعيد التوجيه خطأً).
    if (!platformSettingsReady) return /*#__PURE__*/ (0, $gCmhw.jsx)($3b2255436c932565$var$RouteFallback, {});
    const camp = platformSettings.seasonCampaign;
    const allowed = (0, $inbzl.campaignPublicLive)(camp) || (0, $inbzl.campaignSellerOpen)(camp) && (user?.userType === 'seller' || user?.userType === 'admin');
    if (!allowed) return /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Redirect), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $gCmhw.jsx)($3b2255436c932565$var$SeasonalOffers, {});
};

const $3b2255436c932565$var$UpdateBanner = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("3Htee")));

// v12.35 — mobile-browser «ثبّت التطبيق» recommendation (non-blocking).
const $3b2255436c932565$var$InstallPrompt = /*#__PURE__*/ (0, $2eaC8.lazy)(()=>(parcelRequire("6HJWm")));
// v12.98 — «استعادة موضع التمرير» بمستوى المواقع العالمية (بلاغ ناصر: زر الرجوع كان
// يرمي المتسوّق لأعلى الرئيسية بدل إعادته لمكانه). القاعدة الطبيعية للمتصفحات:
//   • فتح صفحة جديدة (PUSH بمسار مختلف)  → قفزة فورية للأعلى.
//   • رجوع/تقدّم (POP)                    → استعادة الموضع المحفوظ لتلك الصفحة بالضبط.
//   • تغيّر ?query/#hash بنفس المسار       → لا نلمس التمرير (الصفحة تدير تمريرها:
//     تبويبات ?tab= للتاجر، وتمرير تذكرة الإشعار ?barcode= داخل صفحة المنتج).
// نُعطّل استعادة المتصفح الأصلية (scrollRestoration='manual') لنتحكّم نحن بها.
const $3b2255436c932565$var$scrollPositions = new Map();
const $3b2255436c932565$var$jumpScroll = (y)=>{
    try {
        window.scrollTo(0, y);
        if (document.scrollingElement) document.scrollingElement.scrollTop = y;
        document.documentElement.scrollTop = y;
        document.body.scrollTop = y;
    } catch  {}
};
// استعادة موضع محفوظ عند الرجوع/التقدّم. الصفحة الهدف (route كسول + بيانات غير
// متزامنة) قد لا يكون ارتفاعها كافياً في أول إطار، فنعيد المحاولة بلطف بضعة أطر
// حتى نصل الموضع أو ينتهي الحدّ (بلا وميض: نُصر على نفس القيمة فقط لا غير).
let $3b2255436c932565$var$restoreToken = 0;
const $3b2255436c932565$var$restoreScroll = (y)=>{
    const token = ++$3b2255436c932565$var$restoreToken;
    if (!(y > 0)) {
        $3b2255436c932565$var$jumpScroll(0);
        return;
    }
    const startedAt = typeof performance !== 'undefined' ? performance.now() : Date.now();
    let userMoved = false;
    const onUser = ()=>{
        userMoved = true;
    };
    const opts = {
        passive: true
    };
    window.addEventListener('wheel', onUser, opts);
    window.addEventListener('touchmove', onUser, opts);
    window.addEventListener('keydown', onUser, opts);
    // v13.07 — نُوقف «scroll anchoring» **مؤقتاً أثناء الاستعادة فقط** حتى لا يزيح
    // المتصفح موضعنا كلما ارتفع محتوى فوق العرض؛ ونعيده بعدها فيبقى التصفّح العادي
    // (نموذج التاجر…) بلا قفزات.
    try {
        document.documentElement.style.overflowAnchor = 'none';
    } catch  {}
    const cleanup = ()=>{
        window.removeEventListener('wheel', onUser, opts);
        window.removeEventListener('touchmove', onUser, opts);
        window.removeEventListener('keydown', onUser, opts);
        try {
            document.documentElement.style.overflowAnchor = '';
        } catch  {}
    };
    // نُعيد تأكيد الموضع كل إطار حتى نبلغه فعلاً (الصفحة قد ترتفع تدريجياً بعد
    // الرجوع)، ونتوقّف فور الوصول أو عند تمرير المستخدم يدوياً أو بعد سقف ~2ث.
    // نعتمد setTimeout لا requestAnimationFrame: الأخير يتجمّد كلياً عندما يكون
    // التبويب مخفياً (visibility hidden) فلا تُنفَّذ الاستعادة أبداً. الاستعادة قفزة
    // فورية لا رسم متحرّك، فـ setTimeout كافٍ وسلس (ويعمل ظاهراً ومخفياً).
    //
    // مهم: لا نتوقّف عند أول «وصول». الرئيسية تُعاد بناؤها والصور تُحمّل تدريجياً،
    // و«scroll anchoring» في المتصفح يزيح التمرير كلما أُدرج محتوى فوق الموضع — فلو
    // توقفنا مبكراً يتراكم الانزياح بعدنا (كان يعطي +161px ثابتة). لذا نُعيد تأكيد
    // الموضع حتى يثبت فعلاً عدّة تكرارات متتالية (استقرار المحتوى)، أو ينتهي السقف.
    let stable = 0;
    const attempt = ()=>{
        if (token !== $3b2255436c932565$var$restoreToken || userMoved) {
            cleanup();
            return;
        }
        $3b2255436c932565$var$jumpScroll(y);
        const cur = window.scrollY || document.documentElement.scrollTop || 0;
        const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
        stable = Math.abs(cur - y) <= 2 ? stable + 1 : 0;
        if (stable >= 6 || now - startedAt > 3000) {
            cleanup();
            return;
        }
        setTimeout(attempt, 32);
    };
    attempt(); // محاولة أولى فورية (متزامنة داخل layout-effect)
};
/**
 * VisitTracker — يسجّل الزيارة ومصدرها (v14.80).
 *
 * مكوّنٌ مستقلّ لا حشوٌ في `ScrollManager`: مسؤوليّتان مختلفتان، وخلطهما يجعل
 * أي تعديلٍ على إحداهما يمسّ الأخرى. لا يُصيّر شيئاً، ويصمت عند أي فشل.
 */ const $3b2255436c932565$var$VisitTracker = ()=>{
    const location = (0, $6rLjR.useLocation)();
    (0, $2eaC8.useEffect)(()=>{
        (0, $iw1Ih.trackVisit)(location.pathname);
    }, [
        location.pathname
    ]);
    return null;
};
const $3b2255436c932565$var$ScrollManager = ()=>{
    const location = (0, $6rLjR.useLocation)();
    const history = (0, $6rLjR.useHistory)();
    const prevKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).useRef(location.key || 'root');
    const prevPathRef = (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).useRef(location.pathname);
    // مرة واحدة: أطفئ استعادة المتصفح الأصلية حتى لا تتضارب مع منطقنا.
    (0, $2eaC8.useEffect)(()=>{
        try {
            if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
        } catch  {}
    }, []);
    // احفظ موضع تمرير الصفحة **المغادِرة** لحظة بدء الانتقال (history.listen يعمل
    // متزامناً قبل أن يعيد React رسم الصفحة الجديدة وقبل أي تمرير برمجي منّا)، فلا
    // يتلوّث الموضع المحفوظ بقفزة jumpScroll(0) كما كان يحدث مع مستمع scroll مستمر.
    (0, $2eaC8.useEffect)(()=>{
        const unlisten = history.listen(()=>{
            $3b2255436c932565$var$scrollPositions.set(prevKeyRef.current, window.scrollY || document.documentElement.scrollTop || 0);
        });
        return unlisten;
    }, [
        history
    ]);
    // قرار التمرير عند كل انتقال (قبل الرسم عبر layout-effect لتفادي أي وميض).
    (0, (/*@__PURE__*/$parcel$interopDefault($2eaC8))).useLayoutEffect(()=>{
        const action = history.action; // 'PUSH' | 'POP' | 'REPLACE'
        const key = location.key || 'root';
        const samePath = prevPathRef.current === location.pathname;
        // عمق السجل داخل التطبيق (لأزرار «الرجوع الذكي») — يُحدَّث لكل انتقال حتى
        // تغيّر ?query (فهو إدخال سجل جديد أيضاً).
        (0, $5JI7W.bumpNavDepth)(action);
        if (!samePath) {
            if (action === 'POP') $3b2255436c932565$var$restoreScroll($3b2255436c932565$var$scrollPositions.get(key) ?? 0);
            else $3b2255436c932565$var$jumpScroll(0); // PUSH/REPLACE لمسار جديد → ابدأ من الأعلى فوراً
        }
        // (تغيّر ?query/#hash بنفس المسار → لا نلمس التمرير؛ الصفحة تديره)
        prevKeyRef.current = key;
        prevPathRef.current = location.pathname;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.key
    ]);
    return null;
};
const $3b2255436c932565$var$App = ()=>{
    return /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $e493fc9e94bf912b$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $gCmhw.jsx)($3b2255436c932565$var$ScrollManager, {}),
            /*#__PURE__*/ (0, $gCmhw.jsx)($3b2255436c932565$var$VisitTracker, {}),
            /*#__PURE__*/ (0, $gCmhw.jsx)($3b2255436c932565$var$AuthRedirector, {}),
            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $d7e015a0631a1e3c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $414ca410e466a94e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $2eaC8.Suspense), {
                fallback: null,
                children: [
                    /*#__PURE__*/ (0, $gCmhw.jsx)($3b2255436c932565$var$UpdateBanner, {}),
                    /*#__PURE__*/ (0, $gCmhw.jsx)($3b2255436c932565$var$InstallPrompt, {})
                ]
            }),
            /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                className: "app-container",
                children: /*#__PURE__*/ (0, $gCmhw.jsx)((0, $2eaC8.Suspense), {
                    fallback: /*#__PURE__*/ (0, $gCmhw.jsx)($3b2255436c932565$var$RouteFallback, {}),
                    children: /*#__PURE__*/ (0, $gCmhw.jsxs)((0, $6rLjR.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                exact: true,
                                path: "/",
                                component: $3b2255436c932565$var$Home
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/register",
                                component: $3b2255436c932565$var$Register
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/complete-profile",
                                component: $3b2255436c932565$var$CompleteProfile
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/seller",
                                component: $3b2255436c932565$var$SellerDashboard
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/admin",
                                component: $3b2255436c932565$var$AdminDashboard
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/subscription",
                                component: $3b2255436c932565$var$Subscription
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/contests",
                                component: $3b2255436c932565$var$Contests
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/favorites",
                                component: $3b2255436c932565$var$Favorites
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/complaints",
                                component: $3b2255436c932565$var$MyComplaints
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/store/:id",
                                component: $3b2255436c932565$var$StoreDetails
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/nearby",
                                component: $3b2255436c932565$var$Nearby
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/bookings",
                                component: $3b2255436c932565$var$Bookings
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/booking/:barcode",
                                component: $3b2255436c932565$var$BookingReceipt
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/deals",
                                component: $3b2255436c932565$var$DealsList
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/deal/:id",
                                component: $3b2255436c932565$var$DealDetails
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/profile",
                                component: $3b2255436c932565$var$Profile
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/notifications",
                                component: $3b2255436c932565$var$Notifications
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/seasonal",
                                component: $3b2255436c932565$var$SeasonalGate
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/terms",
                                component: $3b2255436c932565$var$Terms
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/privacy",
                                component: $3b2255436c932565$var$Privacy
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/refund",
                                component: $3b2255436c932565$var$Refund
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/about",
                                component: $3b2255436c932565$var$About
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/contact",
                                component: $3b2255436c932565$var$Contact
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/faq",
                                component: $3b2255436c932565$var$FAQ
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/dashboard",
                                children: /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Redirect), {
                                    to: "/seller"
                                })
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                path: "/index.html",
                                children: /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Redirect), {
                                    to: "/"
                                })
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)((0, $6rLjR.Route), {
                                component: $3b2255436c932565$var$NotFound
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $3b2255436c932565$export$2e2bcd8739ae039 = $3b2255436c932565$var$App;



var $gCmhw = parcelRequire("gCmhw");

var $2eaC8 = parcelRequire("2eaC8");
/**
 * Optional error monitoring (v11.44 · كسولٌ منذ v14.83).
 *
 * يبقى **صامتاً تماماً** حتى يُضبط `SENTRY_DSN` وقت البناء
 * (Vercel ▸ Project ▸ Settings ▸ Environment Variables ثم إعادة نشر).
 * والقياس لا يجوز أن يُعطّل التطبيق أو يُبطئه، فكل نداء محروس.
 *
 * ── لماذا صار كسولاً (v14.83) ──────────────────────────────────────────────
 * 🔴 كان `import * as Sentry from '@sentry/react'` **ساكناً**، و`index.tsx`
 *    يستورد هذا الملفّ عند الإقلاع — فتدخل الحزمة كاملةً (ومعها **Session
 *    Replay** وهي أثقل أجزائها) في **حزمة الدخول** التي يحمّلها كل زائر،
 *    قبل أن يرى حرفاً واحداً. قِيس: حزمة الدخول ٨١٣ كيلوبايت.
 *    والأسوأ: الاستيراد الساكن يدخل الحزمة **حتى حين لا يوجد DSN أصلاً** —
 *    أي ثِقلٌ كامل مقابل صفر فائدة.
 *
 * ما صار: `import('@sentry/react')` ديناميكيّ **بعد أوّل رسم وعند خمول
 * المتصفّح**، ولا يُنادى إطلاقاً بلا DSN.
 *
 * 🪤 **ولا يُفقد خطأ وقع قبل أن تجهز الحزمة**: الأخطاء تُكدَّس في طابورٍ صغير
 *    وتُفرَغ لحظة الجهوز. ولولا ذلك لكان أخطر وقتٍ في عمر الصفحة (أوّل ثانية،
 *    حيث تقع أخطاء الإقلاع) هو الوقت الوحيد غير المراقَب — وهو عكس الغرض.
 * 🪤 وسقف الطابور ٢٠: خطأٌ متكرّر في حلقةٍ لا يجوز أن يأكل الذاكرة.
 */ const $e2b04a55c4681dff$var$DSN = "https://2cc08d8e67af9b74527d9a4bf59621fc@o4511518394155008.ingest.us.sentry.io/4511519555452928".trim();
let $e2b04a55c4681dff$var$sentry = null;
let $e2b04a55c4681dff$var$enabled = false;
let $e2b04a55c4681dff$var$loading = null;
/** أخطاء وقعت قبل جهوز الحزمة — تُفرَغ عند الجهوز. */ const $e2b04a55c4681dff$var$pending = [];
const $e2b04a55c4681dff$var$PENDING_MAX = 20;
/** يُفرغ ما تكدّس قبل الجهوز. */ function $e2b04a55c4681dff$var$flushPending() {
    if (!$e2b04a55c4681dff$var$sentry || !$e2b04a55c4681dff$var$enabled) {
        $e2b04a55c4681dff$var$pending.length = 0;
        return;
    }
    for (const p of $e2b04a55c4681dff$var$pending.splice(0, $e2b04a55c4681dff$var$pending.length))try {
        $e2b04a55c4681dff$var$sentry.captureException(p.err, p.context ? {
            extra: p.context
        } : undefined);
    } catch  {}
}

/** يجلب الحزمة ويُهيّئها مرّةً واحدة. */ function $e2b04a55c4681dff$var$load() {
    if ($e2b04a55c4681dff$var$loading) return $e2b04a55c4681dff$var$loading;
    $e2b04a55c4681dff$var$loading = (parcelRequire("9rqDb")).then((mod)=>{
        mod.init({
            dsn: $e2b04a55c4681dff$var$DSN,
            environment: "production",
            tracesSampleRate: 0.1,
            // Scrub obvious PII from any captured request/headers before sending.
            sendDefaultPii: false,
            integrations: [
                // Session Replay — a privacy-safe "video" of what the user did
                // right before an error. maskAllText + blockAllMedia ensure names,
                // phones, prices and images are NEVER recorded — only the layout
                // and the actions (taps/navigation) are. (v11.52)
                mod.replayIntegration({
                    maskAllText: true,
                    blockAllMedia: true
                })
            ],
            // Capture 100% of sessions that hit an error (the ones worth watching)
            // + a light 10% sample of normal sessions for context.
            replaysOnErrorSampleRate: 1.0,
            replaysSessionSampleRate: 0.1
        });
        $e2b04a55c4681dff$var$sentry = mod;
        $e2b04a55c4681dff$var$enabled = true;
        $e2b04a55c4681dff$var$flushPending();
    }).catch(()=>{
        // شبكة أو حجبٌ — المراقبة تسقط وحدها ولا تُسقط شيئاً معها.
        $e2b04a55c4681dff$var$pending.length = 0;
    });
    return $e2b04a55c4681dff$var$loading;
}
function $e2b04a55c4681dff$export$f5ae3c4820871661() {
    if (!$e2b04a55c4681dff$var$DSN || $e2b04a55c4681dff$var$loading) return;
    const start = ()=>{
        $e2b04a55c4681dff$var$load();
    };
    try {
        const ric = window.requestIdleCallback;
        // 🪤 سفاري لا يعرف `requestIdleCallback` حتى اليوم — وهو متصفّح أكثر
        //    مستخدمينا. الارتداد إلى مؤقّت لازمٌ لا تجميل.
        if (typeof ric === 'function') ric(start, {
            timeout: 5000
        });
        else setTimeout(start, 2000);
    } catch  {
        setTimeout(start, 2000);
    }
}
function $e2b04a55c4681dff$export$3e205fbb5df021e0(err, context) {
    if (!$e2b04a55c4681dff$var$DSN) return; // المراقبة مطفأة أصلاً
    try {
        if ($e2b04a55c4681dff$var$sentry && $e2b04a55c4681dff$var$enabled) {
            $e2b04a55c4681dff$var$sentry.captureException(err, context ? {
                extra: context
            } : undefined);
            return;
        }
        // لم تجهز بعد: يُكدَّس ويُستعجل التحميل — فخطأ الإقلاع لا يضيع.
        if ($e2b04a55c4681dff$var$pending.length < $e2b04a55c4681dff$var$PENDING_MAX) $e2b04a55c4681dff$var$pending.push({
            err: err,
            context: context
        });
        $e2b04a55c4681dff$var$load();
    } catch  {
    /* ignore */ }
}
const $e2b04a55c4681dff$export$37a0bd2ebfba3816 = ()=>$e2b04a55c4681dff$var$enabled;


// A stale build trying to lazy-load a chunk that the new deploy renamed.
// «Importing a module script failed» + bare «Load failed» are iOS Safari's
// wording for the same failure — without them iPhones got the generic error
// screen instead of the silent auto-recovery (v12.36 fix, seen live by the
// owner right after the v12.35 deploy).
const $03220ac3f66f165c$var$isChunkError = (err)=>err?.name === 'ChunkLoadError' || /Loading chunk|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|^Load failed$/i.test(err?.message ?? '');
// Guard so a genuinely broken build can't reload-loop forever. If we already
// auto-recovered within this window and STILL hit a chunk error, we stop and
// show the manual button instead of thrashing.
const $03220ac3f66f165c$var$RECOVER_KEY = 'TAKI_CHUNK_AUTO_RECOVER_AT';
const $03220ac3f66f165c$var$RECOVER_COOLDOWN_MS = 25000;
class $03220ac3f66f165c$var$ErrorBoundary extends (0, $2eaC8.Component) {
    state = {
        hasError: false,
        error: null,
        componentStack: null,
        autoRecovering: false
    };
    static getDerivedStateFromError(error) {
        // For a chunk error we've almost certainly just deployed — recover
        // automatically instead of parking the user on a manual "reload" screen,
        // UNLESS we already tried very recently (loop protection).
        let recentlyRecovered = false;
        try {
            const last = Number(sessionStorage.getItem($03220ac3f66f165c$var$RECOVER_KEY) || '0');
            recentlyRecovered = Date.now() - last < $03220ac3f66f165c$var$RECOVER_COOLDOWN_MS;
        } catch  {}
        const autoRecovering = $03220ac3f66f165c$var$isChunkError(error) && !recentlyRecovered;
        return {
            hasError: true,
            error: error,
            componentStack: null,
            autoRecovering: autoRecovering
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        // Chunk errors are an expected side effect of shipping a new build while
        // someone has the app open — not a real bug. Don't page Sentry for them.
        if (!$03220ac3f66f165c$var$isChunkError(error)) (0, $e2b04a55c4681dff$export$3e205fbb5df021e0)(error, {
            componentStack: errorInfo.componentStack
        });
        this.setState({
            componentStack: errorInfo.componentStack ?? null
        });
        if (this.state.autoRecovering) {
            try {
                sessionStorage.setItem($03220ac3f66f165c$var$RECOVER_KEY, String(Date.now()));
            } catch  {}
            // Purge caches + swap the service worker, then reload to the fresh
            // build — the same thing the manual button did, just done for the user.
            this.handleHardRefresh();
        }
    }
    handleReset = ()=>{
        this.setState({
            hasError: false,
            error: null,
            componentStack: null,
            autoRecovering: false
        });
    };
    handleHardRefresh = async ()=>{
        // Clear caches + unregister SW so a stale chunk reference can't recur.
        try {
            if ('serviceWorker' in navigator) {
                const regs = await navigator.serviceWorker.getRegistrations();
                await Promise.all(regs.map((r)=>r.unregister()));
            }
            if ('caches' in window) {
                const keys = await caches.keys();
                await Promise.all(keys.map((k)=>caches.delete(k)));
            }
        } catch  {}
        window.location.reload();
    };
    render() {
        if (this.state.hasError) {
            const err = this.state.error;
            const isChunkLoadError = $03220ac3f66f165c$var$isChunkError(err);
            // Silent auto-recovery in progress — show a calm "updating" splash
            // instead of the technical reload screen. handleHardRefresh() is
            // already clearing caches + reloading in the background. v12.06
            // v14.63 — شاشة الخطأ كانت عربية بالكامل بلا وعيٍ باللغة، وهي **أسوأ
            // لحظة** لجدار نصٍّ لا يقرؤه المستخدم. ومكوّن الصنف لا يستطيع `useApp`،
            // لكنّ وسم `<html lang>` صار يتبع اللغة منذ هذا الإصدار — فهو المصدر.
            const isRTL = (()=>{
                try {
                    return (document.documentElement.lang || 'ar') !== 'en';
                } catch  {
                    return true;
                }
            })();
            const t = (ar, en)=>isRTL ? ar : en;
            if (this.state.autoRecovering) return /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                style: {
                    padding: 20,
                    background: 'var(--body-bg)',
                    color: 'var(--text-primary)',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    direction: isRTL ? 'rtl' : 'ltr'
                },
                children: [
                    /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                        style: {
                            width: 46,
                            height: 46,
                            border: '4px solid var(--border-color)',
                            borderTopColor: 'var(--primary)',
                            borderRadius: '50%',
                            animation: 'taki-eb-spin 0.9s linear infinite'
                        }
                    }),
                    /*#__PURE__*/ (0, $gCmhw.jsx)("style", {
                        children: `@keyframes taki-eb-spin{to{transform:rotate(360deg)}}`
                    }),
                    /*#__PURE__*/ (0, $gCmhw.jsx)("h1", {
                        style: {
                            fontSize: '1.25rem',
                            marginTop: 22,
                            fontWeight: 800
                        },
                        children: t("\u062C\u0627\u0631\u064A \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u2026", "Updating the app\u2026")
                    }),
                    /*#__PURE__*/ (0, $gCmhw.jsx)("p", {
                        style: {
                            fontSize: '0.9rem',
                            color: 'var(--text-secondary)',
                            marginTop: 8,
                            maxWidth: 360
                        },
                        children: t("\u0648\u0635\u0644\u062A \u0646\u0633\u062E\u0629 \u062C\u062F\u064A\u062F\u0629 \u2014 \u0646\u062D\u0645\u0651\u0644\u0647\u0627 \u0644\u0643 \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u062E\u0644\u0627\u0644 \u0644\u062D\u0638\u0627\u062A.", "A new version arrived \u2014 loading it for you now.")
                    })
                ]
            });
            return /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                style: {
                    padding: 20,
                    background: 'var(--body-bg)',
                    color: 'var(--text-primary)',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    direction: isRTL ? 'rtl' : 'ltr'
                },
                children: [
                    /*#__PURE__*/ (0, $gCmhw.jsx)("div", {
                        style: {
                            fontSize: '4rem',
                            marginBottom: 12
                        },
                        children: isChunkLoadError ? "\uD83D\uDD04" : "\u26A0\uFE0F"
                    }),
                    /*#__PURE__*/ (0, $gCmhw.jsx)("h1", {
                        style: {
                            fontSize: '1.5rem',
                            marginBottom: 10,
                            fontWeight: 800
                        },
                        children: isChunkLoadError ? t("\u062A\u062D\u062F\u064A\u062B \u0645\u062A\u0627\u062D \u2014 \u0623\u0639\u062F \u0627\u0644\u062A\u062D\u0645\u064A\u0644", "An update is available \u2014 reload") : t("\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639", 'Something went wrong')
                    }),
                    /*#__PURE__*/ (0, $gCmhw.jsx)("p", {
                        style: {
                            fontSize: '0.9rem',
                            color: 'var(--text-secondary)',
                            marginBottom: 20,
                            maxWidth: 480
                        },
                        children: isChunkLoadError ? t("\u0627\u0644\u0645\u0648\u0642\u0639 \u062A\u0645 \u062A\u062D\u062F\u064A\u062B\u0647 \u0623\u062B\u0646\u0627\u0621 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643. \u0627\u0636\u063A\u0637 \xab\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644\xbb \u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0639\u0645\u0644 \u0628\u0623\u062D\u062F\u062B \u0646\u0633\u062E\u0629.", "The site was updated while you were using it. Tap \u201CReload\u201D to continue on the latest version.") : t("\u0646\u0623\u0633\u0641 \u0639\u0644\u0649 \u0630\u0644\u0643. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u0646 \u062D\u064A\u062B \u062A\u0648\u0642\u0641\u062A \u0623\u0648 \u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0627\u0644\u0643\u0627\u0645\u0644.", 'Sorry about that. You can continue where you left off, or reload the page completely.')
                    }),
                    /*#__PURE__*/ (0, $gCmhw.jsxs)("details", {
                        style: {
                            background: 'var(--card-bg)',
                            padding: 14,
                            borderRadius: 12,
                            width: '100%',
                            maxWidth: 'min(600px, calc(100vw - 24px))',
                            textAlign: isRTL ? 'right' : 'left',
                            border: '1px solid var(--border-color)',
                            marginBottom: 16
                        },
                        children: [
                            /*#__PURE__*/ (0, $gCmhw.jsxs)("summary", {
                                style: {
                                    cursor: 'pointer',
                                    fontSize: '0.8rem',
                                    fontWeight: 700,
                                    color: 'var(--text-secondary)'
                                },
                                children: [
                                    "\uD83D\uDD0D ",
                                    t("\u062A\u0641\u0627\u0635\u064A\u0644 \u062A\u0642\u0646\u064A\u0629 (\u0644\u0644\u0646\u0633\u062E)", 'Technical details (to copy)')
                                ]
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsx)("pre", {
                                style: {
                                    marginTop: 10,
                                    fontSize: '0.75rem',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    color: 'var(--danger)'
                                },
                                children: err?.toString() ?? '(no error)'
                            }),
                            this.state.componentStack && /*#__PURE__*/ (0, $gCmhw.jsx)("pre", {
                                style: {
                                    marginTop: 8,
                                    fontSize: '0.75rem',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    color: 'var(--text-secondary)',
                                    maxHeight: 200,
                                    overflow: 'auto'
                                },
                                children: this.state.componentStack
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gCmhw.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            flexWrap: 'wrap',
                            justifyContent: 'center'
                        },
                        children: [
                            !isChunkLoadError && /*#__PURE__*/ (0, $gCmhw.jsxs)("button", {
                                onClick: this.handleReset,
                                style: {
                                    padding: '12px 24px',
                                    borderRadius: 12,
                                    border: '1.5px solid var(--border-color)',
                                    background: 'var(--card-bg)',
                                    color: 'var(--text-primary)',
                                    fontSize: '0.9rem',
                                    fontWeight: 700,
                                    cursor: 'pointer'
                                },
                                children: [
                                    "\u21A9\uFE0F ",
                                    t("\u0645\u062A\u0627\u0628\u0639\u0629", 'Continue')
                                ]
                            }),
                            /*#__PURE__*/ (0, $gCmhw.jsxs)("button", {
                                onClick: this.handleHardRefresh,
                                style: {
                                    padding: '12px 24px',
                                    borderRadius: 12,
                                    border: 'none',
                                    background: 'var(--primary)',
                                    color: 'white',
                                    fontSize: '0.9rem',
                                    fontWeight: 800,
                                    cursor: 'pointer'
                                },
                                children: [
                                    "\uD83D\uDD04 ",
                                    t("\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0643\u0627\u0645\u0644\u0629", 'Full reload')
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        return this.props.children;
    }
}
var $03220ac3f66f165c$export$2e2bcd8739ae039 = $03220ac3f66f165c$var$ErrorBoundary;




var $6xdoN = parcelRequire("6xdoN");
// Error monitoring — no-op until SENTRY_DSN is configured (see services/sentry.ts).
(0, $e2b04a55c4681dff$export$f5ae3c4820871661)();
// One-time initialization: clear old data on shape changes
const $4702659029c806ca$var$INIT_KEY = 'taki_initialized_v8';
if (!localStorage.getItem($4702659029c806ca$var$INIT_KEY)) {
    localStorage.clear();
    localStorage.setItem($4702659029c806ca$var$INIT_KEY, 'true');
}
const $4702659029c806ca$var$container = document.getElementById('root');
const $4702659029c806ca$var$root = (0, $52EYl.createRoot)($4702659029c806ca$var$container);
const $4702659029c806ca$var$renderApp = ()=>$4702659029c806ca$var$root.render(/*#__PURE__*/ (0, $gCmhw.jsx)((0, $03220ac3f66f165c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $gCmhw.jsx)((0, $1wrgB.AppProvider), {
            children: /*#__PURE__*/ (0, $gCmhw.jsx)((0, $3b2255436c932565$export$2e2bcd8739ae039), {})
        })
    }));
// Inside Telegram: auto-login first (with a safety timeout) so the app opens
// already signed in. EXCEPT on the explicit link entry (/profile?tglink=1) —
// there we must NOT auto-create a Telegram buyer session, otherwise an existing
// account (seller/admin) could never be the one that gets linked. On that path
// we render immediately and let the profile page link the chosen/existing
// account (or offer to create one). Everywhere else: render immediately.
const $4702659029c806ca$var$wantsTgLink = (()=>{
    try {
        return new URLSearchParams(window.location.search).get('tglink') === '1';
    } catch  {
        return false;
    }
})();
// Remember the link intent so that AFTER the user signs in (inside Telegram)
// the auth redirector sends them to /profile?tglink=1 to finish linking,
// instead of the normal home/dashboard landing.
if ($4702659029c806ca$var$wantsTgLink) try {
    sessionStorage.setItem('taki_tglink', '1');
} catch  {}
if ((0, $6xdoN.isTelegramMiniApp)() && !$4702659029c806ca$var$wantsTgLink) {
    const safety = new Promise((res)=>setTimeout(res, 4000));
    Promise.race([
        (0, $6xdoN.initTelegramMiniApp)(),
        safety
    ]).finally($4702659029c806ca$var$renderApp);
} else $4702659029c806ca$var$renderApp();


//# sourceMappingURL=path0.861bd689.js.map
